export function getCssText() {
  // const allCSS = [...document.styleSheets]
  //     .map(styleSheet => {
  //       try {
  //         return [...styleSheet.cssRules]
  //           .map(rule => rule.cssText)
  //           .join('');
  //       } catch (e) {
  //         console.log('Access to stylesheet %s is denied. Ignoring...', styleSheet.href);
  //       }
  //     })
  //     .filter(Boolean)
  //     .join('\n');
    return `
    th[data-v-6f537f1c],  td[data-v-6f537f1c] {
      padding: 2px;
      background-color: white;
    }
    td.today[data-v-6f537f1c] {
      font-weight: bold;
    }
    td.disabled[data-v-6f537f1c] {
      pointer-events: none;
      opacity: 0.6;
    }
     td.disabled[data-v-6f537f1c] {
      background-color: #eee;
      border-radius: 0;
    }
    .fa[data-v-6f537f1c] {
      display: inline-block;
      width: 100%;
      height: 100%;
      fill: #ccc;
    }
     .fa[data-v-6f537f1c] {
      background: transparent no-repeat center center;
      background-size: 100% 100%;
    }
     .prev[data-v-6f537f1c]:hover,  .next[data-v-6f537f1c]:hover {
      background-color: transparent !important;
    }
    .prev .fa[data-v-6f537f1c]:hover, .next .fa[data-v-6f537f1c]:hover {
      opacity: 0.6;
    }
    .chevron-left[data-v-6f537f1c] {
      width: 16px;
      height: 16px;
      display: block;
    }
     .chevron-left[data-v-6f537f1c] {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-2 -2 10 10'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
    }
    .chevron-right[data-v-6f537f1c] {
      width: 16px;
      height: 16px;
      display: block;
    }
     .chevron-right[data-v-6f537f1c] {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-2 -2 10 10'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
    }
    .yearselect[data-v-6f537f1c] {
      appearance: menulist;
    }
     .yearselect[data-v-6f537f1c] {
      border: none;
    }
    [dir=ltr] .yearselect[data-v-6f537f1c] {
      padding-right: 1px;
    }
    [dir=rtl] .yearselect[data-v-6f537f1c] {
      padding-left: 1px;
    }
     .monthselect[data-v-6f537f1c] {
      border: none;
    }
    .daterangepicker .ranges {
      width: 100%;
    } .daterangepicker .ranges {
      margin: 0;
    }[dir=ltr] .daterangepicker .ranges {
      text-align: left;
    }[dir=rtl] .daterangepicker .ranges {
      text-align: right;
    }
    .daterangepicker .ranges ul {
      list-style: none;
      width: 100%;
    }
     .daterangepicker .ranges ul {
      margin: 0 auto;
      padding: 0;
    }
    .daterangepicker .ranges li {
      font-size: 12px;
    }
     .daterangepicker .ranges li {
      padding: 8px 12px;
      cursor: pointer;
    }
    .daterangepicker .ranges li:hover {
      color: #000;
    }
     .daterangepicker .ranges li:hover {
      background-color: #eee;
    }
    .daterangepicker .ranges li.active {
      color: #fff;
    }
     .daterangepicker .ranges li.active {
      background-color: #08c;
    }
    .daterangepicker .monthselect, .daterangepicker .yearselect {
      font-size: 12px;
      height: auto;
      width: calc(50% - 1rem);
    }
     .daterangepicker .monthselect,  .daterangepicker .yearselect {
      padding: 1px;
      margin: 0;
      cursor: default;
    }
    [dir=ltr] .daterangepicker .monthselect {
      margin-right: 1rem;
    }
    [dir=rtl] .daterangepicker .monthselect {
      margin-left: 1rem;
    }
    .daterangepicker .calendar-time {
      line-height: 30px;
      position: relative;
      display: flex;
      justify-content: center;
    }
     .daterangepicker .calendar-time {
      text-align: center;
      margin: 4px auto 0 auto;
    }
    .daterangepicker .calendar-time select.disabled {
      color: #ccc;
    }
     .daterangepicker .calendar-time select.disabled {
      cursor: not-allowed;
    }
    .daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect {
      width: 50px;
      outline: 0;
      font-size: 12px;
    }
     .daterangepicker select.hourselect,  .daterangepicker select.minuteselect,  .daterangepicker select.secondselect,  .daterangepicker select.ampmselect {
      margin: 2px;
      background: #eee;
      border: 1px solid #eee;
      padding: 2px;
    }
    .daterangepicker .drp-buttons .btn {
      font-size: 12px;
      font-weight: bold;
    }
     .daterangepicker .drp-buttons .btn {
      padding: 4px 8px;
    }
    [dir=ltr] .daterangepicker .drp-buttons .btn {
      margin-left: 8px;
    }
    [dir=rtl] .daterangepicker .drp-buttons .btn {
      margin-right: 8px;
    }
    .daterangepicker .btn {
      display: inline-block;
      vertical-align: middle;
      user-select: none;
    }
     .daterangepicker .btn {
      text-align: center;
      background-color: transparent;
      border: 1px solid transparent;
    }
    .daterangepicker .btn-success, .daterangepicker .btn-primary {
      color: #fff;
    }
     .daterangepicker .btn-success,  .daterangepicker .btn-primary {
      background-color: #28a745;
    }
    .daterangepicker .btn-secondary {
      color: #fff;
    }
     .daterangepicker .btn-secondary {
      background-color: #6c757d;
    }
    .vue-daterange-picker *, .vue-daterange-picker ::after, .vue-daterange-picker ::before {
      box-sizing: border-box;
    }
    .drp-calendar .col .left {
      flex: 0 0 auto;
    }
    .daterangepicker.hide-calendars.show-ranges .ranges {
      width: 100%;
    }
    .daterangepicker.hide-calendars.show-ranges .ranges ul {
      width: 100%;
    }
    .daterangepicker .calendars-container {
      display: flex;
    }
    .daterangepicker[readonly] {
      pointer-events: none;
    }
    .daterangepicker {
      position: absolute;
      color: inherit;
      width: 278px;
      max-width: none;
      top: 100px;
      z-index: 3001;
      display: none;
      font-size: 15px;
      line-height: 1em;
    }
     .daterangepicker {
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #ddd;
      padding: 0;
      margin-top: 7px;
    }
    [dir=ltr] .daterangepicker {
      left: 20px;
    }
    [dir=rtl] .daterangepicker {
      right: 20px;
    }
    .daterangepicker:before, .daterangepicker:after {
      position: absolute;
      display: inline-block;
      content: "";
    }
     .daterangepicker:before,  .daterangepicker:after {
      border-bottom-color: rgba(0, 0, 0, 0.2);
    }
    .daterangepicker:before {
      top: -7px;
    }
     .daterangepicker:before {
      border-bottom: 7px solid #ccc;
    }
    [dir=ltr] .daterangepicker:before {
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
    }
    [dir=rtl] .daterangepicker:before {
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
    }
    .daterangepicker:after {
      top: -6px;
    }
     .daterangepicker:after {
      border-bottom: 6px solid #fff;
    }
    [dir=ltr] .daterangepicker:after {
      border-right: 6px solid transparent;
      border-left: 6px solid transparent;
    }
    [dir=rtl] .daterangepicker:after {
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }
    [dir=ltr] .daterangepicker.opensleft:before {
      right: 9px;
    }
    [dir=rtl] .daterangepicker.opensleft:before {
      left: 9px;
    }
    [dir=ltr] .daterangepicker.opensleft:after {
      right: 10px;
    }
    [dir=rtl] .daterangepicker.opensleft:after {
      left: 10px;
    }
    .daterangepicker.openscenter:before {
      width: 0;
    }
    [dir=ltr] .daterangepicker.openscenter:before {
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
    }
    [dir=rtl] .daterangepicker.openscenter:before {
      right: 0;
      left: 0;
      margin-right: auto;
      margin-left: auto;
    }
    .daterangepicker.openscenter:after {
      width: 0;
    }
    [dir=ltr] .daterangepicker.openscenter:after {
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
    }
    [dir=rtl] .daterangepicker.openscenter:after {
      right: 0;
      left: 0;
      margin-right: auto;
      margin-left: auto;
    }
    [dir=ltr] .daterangepicker.opensright:before {
      left: 9px;
    }
    [dir=rtl] .daterangepicker.opensright:before {
      right: 9px;
    }
    [dir=ltr] .daterangepicker.opensright:after {
      left: 10px;
    }
    [dir=rtl] .daterangepicker.opensright:after {
      right: 10px;
    }
     .daterangepicker.drop-up {
      margin-top: -7px;
    }
    .daterangepicker.drop-up:before {
      top: initial;
      bottom: -7px;
    }
     .daterangepicker.drop-up:before {
      border-bottom: initial;
      border-top: 7px solid #ccc;
    }
    .daterangepicker.drop-up:after {
      top: initial;
      bottom: -6px;
    }
     .daterangepicker.drop-up:after {
      border-bottom: initial;
      border-top: 6px solid #fff;
    }
    .daterangepicker.single .drp-selected {
      display: none;
    }
    .daterangepicker.show-calendar .drp-calendar {
      display: block;
    }
    .daterangepicker.show-calendar .drp-buttons {
      display: block;
    }
    .daterangepicker.auto-apply .drp-buttons {
      display: none;
    }
    .daterangepicker .drp-calendar {
      display: none;
      max-width: 270px;
      width: 270px;
    }
    [dir=ltr] .daterangepicker .drp-calendar.left {
      padding: 8px 0 8px 8px;
    }
    [dir=rtl] .daterangepicker .drp-calendar.left {
      padding: 8px 8px 8px 0;
    }
     .daterangepicker .drp-calendar.right {
      padding: 8px;
    }
     .daterangepicker .drp-calendar.single .calendar-table {
      border: none;
    }
    .daterangepicker .calendar-table .next span, .daterangepicker .calendar-table .prev span {
      color: #fff;
      display: inline-block;
    }
     .daterangepicker .calendar-table .next span,  .daterangepicker .calendar-table .prev span {
      border: solid black;
      border-radius: 0;
      padding: 3px;
    }
    [dir=ltr] .daterangepicker .calendar-table .next span, [dir=ltr] .daterangepicker .calendar-table .prev span {
      border-width: 0 2px 2px 0;
    }
    [dir=rtl] .daterangepicker .calendar-table .next span, [dir=rtl] .daterangepicker .calendar-table .prev span {
      border-width: 0 0 2px 2px;
    }
    [dir=ltr] .daterangepicker .calendar-table .next span {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    [dir=rtl] .daterangepicker .calendar-table .next span {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }
    [dir=ltr] .daterangepicker .calendar-table .prev span {
      transform: rotate(135deg);
      -webkit-transform: rotate(135deg);
    }
    [dir=rtl] .daterangepicker .calendar-table .prev span {
      transform: rotate(-135deg);
      -webkit-transform: rotate(-135deg);
    }
    .daterangepicker .calendar-table th, .daterangepicker .calendar-table td {
      white-space: nowrap;
      vertical-align: middle;
      min-width: 32px;
      width: 32px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
    }
     .daterangepicker .calendar-table th,  .daterangepicker .calendar-table td {
      text-align: center;
      border-radius: 4px;
      border: 1px solid transparent;
      cursor: pointer;
    }
     .daterangepicker .calendar-table {
      border: 1px solid #fff;
      border-radius: 4px;
      background-color: #fff;
    }
    .daterangepicker .calendar-table table {
      width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      display: table;
    }
     .daterangepicker .calendar-table table {
      margin: 0;
    }
    .daterangepicker td.available:hover, .daterangepicker th.available:hover {
      color: inherit;
    }
     .daterangepicker td.available:hover,  .daterangepicker th.available:hover {
      background-color: #eee;
      border-color: transparent;
    }
    .daterangepicker td.week, .daterangepicker th.week {
      font-size: 80%;
      color: #ccc;
    }
    .daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {
      color: #999;
    }
     .daterangepicker td.off,  .daterangepicker td.off.in-range,  .daterangepicker td.off.start-date,  .daterangepicker td.off.end-date {
      background-color: #fff;
      border-color: transparent;
    }
    .daterangepicker td.in-range {
      color: #000;
    }
     .daterangepicker td.in-range {
      background-color: #ebf4f8;
      border-color: transparent;
      border-radius: 0;
    }
    [dir=ltr] .daterangepicker td.start-date {
      border-radius: 4px 0 0 4px;
    }
    [dir=rtl] .daterangepicker td.start-date {
      border-radius: 0 4px 4px 0;
    }
    [dir=ltr] .daterangepicker td.end-date {
      border-radius: 0 4px 4px 0;
    }
    [dir=rtl] .daterangepicker td.end-date {
      border-radius: 4px 0 0 4px;
    }
     .daterangepicker td.start-date.end-date {
      border-radius: 4px;
    }
    .daterangepicker td.active, .daterangepicker td.active:hover {
      color: #fff;
    }
     .daterangepicker td.active,  .daterangepicker td.active:hover {
      background-color: #357ebd;
      border-color: transparent;
    }
    .daterangepicker th.month {
      width: auto;
    }
    .daterangepicker td.disabled, .daterangepicker option.disabled {
      color: #999;
      text-decoration: line-through;
    }
     .daterangepicker td.disabled,  .daterangepicker option.disabled {
      cursor: not-allowed;
    }
    .daterangepicker select.yearselect {
      width: 40%;
    }
    .daterangepicker .drp-buttons {
      display: none;
      line-height: 12px;
      vertical-align: middle;
    }
     .daterangepicker .drp-buttons {
      clear: both;
      padding: 8px;
      border-top: 1px solid #ddd;
    }
    [dir=ltr] .daterangepicker .drp-buttons {
      text-align: right;
    }
    [dir=rtl] .daterangepicker .drp-buttons {
      text-align: left;
    }
    .daterangepicker .drp-selected {
      display: inline-block;
      font-size: 12px;
    }
    [dir=ltr] .daterangepicker .drp-selected {
      padding-right: 8px;
    }
    [dir=rtl] .daterangepicker .drp-selected {
      padding-left: 8px;
    }
    [dir=ltr] .daterangepicker.show-ranges .drp-calendar.left {
      border-left: 1px solid #ddd;
    }
    [dir=rtl] .daterangepicker.show-ranges .drp-calendar.left {
      border-right: 1px solid #ddd;
    }
    .daterangepicker.show-calendar .ranges {
      width: auto;
    }
     .daterangepicker.show-calendar .ranges {
      margin-top: 8px;
    }
    
    /*  Larger Screen Styling */
    @media (min-width: 564px) {
    .daterangepicker {
        width: auto;
    }
    .daterangepicker .ranges ul {
        width: 140px;
    }
    .daterangepicker.single .ranges ul {
        width: 100%;
    }
     .daterangepicker.single .drp-calendar.left {
        clear: none;
    }
    [dir=ltr] .daterangepicker.ltr {
        direction: ltr;
        text-align: left;
    }
    [dir=rtl] .daterangepicker.ltr {
        direction: rtl;
        text-align: right;
    }
    [dir=ltr] .daterangepicker.ltr .drp-calendar.left {
        clear: left;
        margin-right: 0;
    }
    [dir=rtl] .daterangepicker.ltr .drp-calendar.left {
        clear: right;
        margin-left: 0;
    }
    [dir=ltr] .daterangepicker.ltr .drp-calendar.left .calendar-table {
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    [dir=rtl] .daterangepicker.ltr .drp-calendar.left .calendar-table {
        border-left: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    [dir=ltr] .daterangepicker.ltr .drp-calendar.right {
        margin-left: 0;
    }
    [dir=rtl] .daterangepicker.ltr .drp-calendar.right {
        margin-right: 0;
    }
    [dir=ltr] .daterangepicker.ltr .drp-calendar.right .calendar-table {
        border-left: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    [dir=rtl] .daterangepicker.ltr .drp-calendar.right .calendar-table {
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    [dir=ltr] .daterangepicker.ltr .drp-calendar.left .calendar-table {
        padding-right: 8px;
    }
    [dir=rtl] .daterangepicker.ltr .drp-calendar.left .calendar-table {
        padding-left: 8px;
    }
    [dir=ltr] .daterangepicker.rtl {
        direction: rtl;
        text-align: right;
    }
    [dir=rtl] .daterangepicker.rtl {
        direction: ltr;
        text-align: left;
    }
    [dir=ltr] .daterangepicker.rtl .drp-calendar.left {
        clear: right;
        margin-left: 0;
    }
    [dir=rtl] .daterangepicker.rtl .drp-calendar.left {
        clear: left;
        margin-right: 0;
    }
    [dir=ltr] .daterangepicker.rtl .drp-calendar.left .calendar-table {
        border-left: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    [dir=rtl] .daterangepicker.rtl .drp-calendar.left .calendar-table {
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    [dir=ltr] .daterangepicker.rtl .drp-calendar.right {
        margin-right: 0;
    }
    [dir=rtl] .daterangepicker.rtl .drp-calendar.right {
        margin-left: 0;
    }
    [dir=ltr] .daterangepicker.rtl .drp-calendar.right .calendar-table {
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    [dir=rtl] .daterangepicker.rtl .drp-calendar.right .calendar-table {
        border-left: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    [dir=ltr] .daterangepicker.rtl .drp-calendar.left .calendar-table {
        padding-left: 12px;
    }
    [dir=rtl] .daterangepicker.rtl .drp-calendar.left .calendar-table {
        padding-right: 12px;
    }
    [dir=ltr] .daterangepicker.rtl .ranges, [dir=ltr] .daterangepicker.rtl .drp-calendar {
        text-align: right;
    }
    [dir=rtl] .daterangepicker.rtl .ranges, [dir=rtl] .daterangepicker.rtl .drp-calendar {
        text-align: left;
    }
    }
    @media (min-width: 730px) {
     .daterangepicker .drp-calendar.left {
        clear: none !important;
    }
    }
    .calendars[data-v-9268e6a2] {
      display: flex;
      flex-wrap: wrap;
    }
    .reportrange-text[data-v-9268e6a2] {
      width: 100%;
      overflow: hidden;
    }
     .reportrange-text[data-v-9268e6a2] {
      background: #fff;
      padding: 5px 10px;
      border: 1px solid #ccc;
    }
    .daterangepicker[data-v-9268e6a2] {
      flex-direction: column;
      display: flex;
      width: auto;
      /*from 540 to 768*/
    }
    @media screen and (max-width: 768px) {
    [dir=ltr] .daterangepicker.show-ranges .drp-calendar.left[data-v-9268e6a2] {
        border-left: 0px;
    }
    [dir=rtl] .daterangepicker.show-ranges .drp-calendar.left[data-v-9268e6a2] {
        border-right: 0px;
    }
    .daterangepicker.show-ranges .ranges[data-v-9268e6a2] {
        width: 100%;
    }
     .daterangepicker.show-ranges .ranges[data-v-9268e6a2] {
        border-bottom: 1px solid #ddd;
    }
    .daterangepicker.show-ranges .ranges[data-v-9268e6a2]  ul {
        display: flex;
        flex-wrap: wrap;
        width: auto;
    }
    }
    @media screen and (max-width: 541px) {
    .daterangepicker .calendars-container[data-v-9268e6a2] {
        flex-wrap: wrap;
    }
    }
    @media screen and (min-width: 540px) {
    .daterangepicker[data-v-9268e6a2] {
        min-width: 486px;
    }
    .daterangepicker.show-weeknumbers[data-v-9268e6a2] {
        min-width: 486px;
    }
    }
    @media screen and (min-width: 768px) {
    .daterangepicker.show-ranges[data-v-9268e6a2] {
        min-width: 682px;
    }
    .daterangepicker.show-ranges.show-weeknumbers[data-v-9268e6a2] {
        min-width: 682px;
    }
    }
    @media screen and (max-width: 340px) {
    .daterangepicker.single[data-v-9268e6a2] {
        min-width: 250px;
    }
    .daterangepicker.single.show-weeknumbers[data-v-9268e6a2] {
        min-width: 250px;
    }
    }
    @media screen and (min-width: 339px) {
    .daterangepicker.single[data-v-9268e6a2] {
        min-width: auto;
    }
    .daterangepicker.single.show-ranges[data-v-9268e6a2] {
        min-width: 356px;
    }
    .daterangepicker.single.show-ranges.show-weeknumbers[data-v-9268e6a2] {
        min-width: 356px;
    }
    [dir=ltr] .daterangepicker.single.show-ranges .drp-calendar.left[data-v-9268e6a2] {
        border-left: 1px solid #ddd;
    }
    [dir=rtl] .daterangepicker.single.show-ranges .drp-calendar.left[data-v-9268e6a2] {
        border-right: 1px solid #ddd;
    }
    .daterangepicker.single.show-ranges .ranges[data-v-9268e6a2] {
        max-width: none;
        flex-basis: auto;
    }
     .daterangepicker.single.show-ranges .ranges[data-v-9268e6a2] {
        border-bottom: 0;
    }
    .daterangepicker.single.show-ranges .ranges[data-v-9268e6a2]  ul {
        display: block;
        width: 100%;
    }
    }
    .daterangepicker.show-calendar[data-v-9268e6a2] {
      display: block;
      top: auto;
    }
    .daterangepicker.opensleft[data-v-9268e6a2] {
      /*top: 35px;*/
    }
    [dir=ltr] .daterangepicker.opensleft[data-v-9268e6a2] {
      right: 10px;
      left: auto;
    }
    [dir=rtl] .daterangepicker.opensleft[data-v-9268e6a2] {
      left: 10px;
      right: auto;
    }
    .daterangepicker.openscenter[data-v-9268e6a2] {
      /*top: 35px;*/
    }
    [dir=ltr] .daterangepicker.openscenter[data-v-9268e6a2] {
      right: auto;
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .daterangepicker.openscenter[data-v-9268e6a2] {
      left: auto;
      right: 50%;
      transform: translate(50%, 0);
    }
    .daterangepicker.opensright[data-v-9268e6a2] {
      /*top: 35px;*/
    }
    [dir=ltr] .daterangepicker.opensright[data-v-9268e6a2] {
      left: 0;
      right: auto;
    }
    [dir=rtl] .daterangepicker.opensright[data-v-9268e6a2] {
      right: 0;
      left: auto;
    }
    
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active[data-v-9268e6a2] {
      transition: all 0.2s ease;
    }
    .slide-fade-leave-active[data-v-9268e6a2] {
      transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .slide-fade-enter[data-v-9268e6a2], .slide-fade-leave-to[data-v-9268e6a2] {
      opacity: 0;
    }
    [dir=ltr] .slide-fade-enter[data-v-9268e6a2], [dir=ltr] .slide-fade-leave-to[data-v-9268e6a2] {
      transform: translateX(10px);
    }
    [dir=rtl] .slide-fade-enter[data-v-9268e6a2], [dir=rtl] .slide-fade-leave-to[data-v-9268e6a2] {
      transform: translateX(-10px);
    }
    .vue-daterange-picker[data-v-9268e6a2] {
      position: relative;
      display: inline-block;
      min-width: 60px;
    }
    .vue-daterange-picker .show-ranges.hide-calendars[data-v-9268e6a2] {
      width: 150px;
      min-width: 150px;
    }
    .inline .daterangepicker[data-v-9268e6a2] {
      position: static;
    }
    .inline .daterangepicker[data-v-9268e6a2]:before, .inline .daterangepicker[data-v-9268e6a2]:after {
      display: none;
    }.vue-daterange-picker {
      width: 100%;
    }
    .vue-daterange-picker .reportrange-text {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
     .vue-daterange-picker .reportrange-text {
      padding: 0.438rem 1rem;
      border: 1px solid #D6D9E1;
    }
    .vue-daterange-picker .reportrange-text .date-mask {
      color: #424244;
      max-width: 115px;
    }
     .vue-daterange-picker .reportrange-text .date-mask {
      border: none;
    }
    .vue-daterange-picker .reportrange-text .date-mask:focus {
      outline: none;
    }
     .vue-daterange-picker .reportrange-text .input-mask span {
      padding: 0 5px;
    }
    
    .daterangepicker:before, .daterangepicker:after {
      display: none;
    }
    .daterangepicker .calendars .ranges {
      order: 2;
    }
    .daterangepicker .calendars .ranges ul li {
      font-size: 12px;
      line-height: 18px;
      color: #60625E;
    }
     .daterangepicker .calendars .ranges ul li {
      padding: 11px 20px;
    }
    .daterangepicker .calendars .ranges ul li.active {
      color: #114A9F;
    }
     .daterangepicker .calendars .ranges ul li.active {
      background: rgba(17, 74, 159, 0.12);
    }
    .daterangepicker .calendars .calendars-container {
      order: 1;
    }
     .daterangepicker .calendars .calendars-container .left {
      border: none;
    }
    [dir=ltr] .daterangepicker .calendars .calendars-container .left {
      margin-left: 0;
      padding: 8px 8px 8px 4px;
    }
    [dir=rtl] .daterangepicker .calendars .calendars-container .left {
      margin-right: 0;
      padding: 8px 4px 8px 8px;
    }
    [dir=ltr] .daterangepicker .calendars .calendars-container .left table thead tr th.prev {
      text-align: left;
      padding-left: 10px;
    }
    [dir=rtl] .daterangepicker .calendars .calendars-container .left table thead tr th.prev {
      text-align: right;
      padding-right: 10px;
    }
    [dir=ltr] .daterangepicker .calendars .calendars-container .right {
      border-right: 1px solid #efefef;
      margin-left: 0;
    }
    [dir=rtl] .daterangepicker .calendars .calendars-container .right {
      border-left: 1px solid #efefef;
      margin-right: 0;
    }
    .daterangepicker .calendars .calendars-container .right table thead tr th.prev {
      visibility: hidden;
    }
    .daterangepicker .calendars .calendars-container .calendar-table thead th {
      font-weight: 500;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.9);
    }
    .daterangepicker .calendars .calendars-container .calendar-table tbody tr th {
      font-size: 12px;
      font-weight: 400;
    }
    .daterangepicker .calendars .calendars-container .calendar-table tbody tr td {
      min-width: 36px;
      width: 36px;
      max-width: 36px;
      height: 36px;
      line-height: 36px;
      line-height: 34px;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td {
      padding: 1px;
      border: none;
    }
    .daterangepicker .calendars .calendars-container .calendar-table tbody tr td span {
      width: 36px;
      max-width: 36px;
      height: 36px;
      color: #424244;
      display: inline-block;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td span {
      background: none;
      border: 1px solid transparent;
      border-radius: 150px;
      cursor: pointer;
      margin: 0;
      text-align: center;
    }
    .daterangepicker .calendars .calendars-container .calendar-table tbody tr td span:hover {
      color: #424244;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td span:hover {
      background: #f6f6f6;
      cursor: pointer;
      border-color: #e6e6e6;
    }
    .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.off span {
      color: #dae1e7;
    }
    .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.today span {
      font-weight: normal;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.today span {
      border-color: #114A9F;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.in-range {
      background-color: transparent;
    }
    .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.in-range span {
      color: #114A9F;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.in-range span {
      background: rgba(17, 74, 159, 0.12);
      border: none;
      border-radius: 0;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.in-range span:hover {
      background: rgba(17, 74, 159, 0.12);
      border-color: rgba(17, 74, 159, 0.12);
    }
    .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.start-date > span {
      color: #fff;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.start-date > span {
      background: #114A9F;
      border-color: #114A9F;
    }
    [dir=ltr] .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.start-date > span {
      border-radius: 50px 0 0 50px;
    }
    [dir=rtl] .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.start-date > span {
      border-radius: 0 50px 50px 0;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.start-date > span:hover {
      background: #114A9F;
      border-color: #114A9F;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.start-date.in-range {
      background: #fff;
      box-shadow: none;
    }
    .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.end-date > span {
      color: #fff;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.end-date > span {
      background: #114A9F;
      border-color: #114A9F;
    }
    [dir=ltr] .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.end-date > span {
      border-radius: 0 50px 50px 0;
    }
    [dir=rtl] .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.end-date > span {
      border-radius: 50px 0 0 50px;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.end-date > span:hover {
      background: #114A9F;
      border-color: #114A9F;
    }
     .daterangepicker .calendars .calendars-container .calendar-table tbody tr td.end-date.in-range {
      background: #fff;
      box-shadow: none;
    }
    .daterangepicker .calendars .calendars-container .calendar-time {
      align-items: center;
    }
     .daterangepicker .calendars .calendars-container .calendar-time {
      margin-top: 8px;
    }
    .daterangepicker .calendars .calendars-container .calendar-time select {
      appearance: auto;
    }
     .daterangepicker .calendars .calendars-container .calendar-time select {
      border: 1px solid #D6D9E1;
      background-color: transparent;
      text-align: center;
    }
     .daterangepicker .calendars .calendars-container .calendar-time select:nth-child(2) {
      margin: 0 1rem;
    }
    .daterangepicker .calendars .calendars-container .calendar-time select.form-control {
      height: 2rem;
    }
    .daterangepicker .calendars .calendars-container .calendar-time select.ampmselect {
      display: block;
      height: 2rem;
      font-size: 12px;
      font-weight: 400;
      line-height: 1.45;
      color: #424244;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      width: 50px;
      outline: 0;
    }
     .daterangepicker .calendars .calendars-container .calendar-time select.ampmselect {
      border-radius: 0.357rem;
    }
    .daterangepicker .drp-buttons {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     .daterangepicker .drp-buttons {
      border-color: #efefef;
    }
    .daterangepicker .drp-buttons .cancelBtn {
      display: none;
    }
    .daterangepicker .drp-buttons .applyBtn {
      letter-spacing: 0.4px;
      font-size: 12px;
      color: #fff !important;
      font-weight: 500;
    }
     .daterangepicker .drp-buttons .applyBtn {
      border: 1px solid #114A9F !important;
      border-radius: 5px;
      padding: 9px 18px;
      background-color: #114A9F !important;
    }
    .daterangepicker .drp-buttons .applyBtn:disabled {
      color: #efefef !important;
    }
     .daterangepicker .drp-buttons .applyBtn:disabled {
      border-color: #efefef !important;
    }
     .daterangepicker.single .calendars .calendars-container .left {
      padding: 8px !important;
    }
    [dir=ltr] .daterangepicker.single .calendars .calendars-container .left .calendar-table {
      padding-right: 0 !important;
    }
    [dir=rtl] .daterangepicker.single .calendars .calendars-container .left .calendar-table {
      padding-left: 0 !important;
    }
    
     .daterangepicker td.today {
      background-color: rgba(17, 74, 159, 0.05) !important;
      border-radius: 50% !important;
    }
    
     .daterangepicker.single td.active,  .daterangepicker.single td.active:hover {
      background-color: #114A9F !important;
      border-radius: 50% !important;
      border-color: transparent;
    }
    
     .calendar-time select {
      background: none !important;
      padding: 0 !important;
    }
    .ps{overflow:hidden!important;overflow-anchor:none;-ms-overflow-style:none;touch-action:auto;-ms-touch-action:auto}.ps__rail-x{height:15px;bottom:0}.ps__rail-x,.ps__rail-y{display:none;opacity:0;transition:background-color .2s linear,opacity .2s linear;-webkit-transition:background-color .2s linear,opacity .2s linear;position:absolute}.ps__rail-y{width:15px;right:0}.ps--active-x>.ps__rail-x,.ps--active-y>.ps__rail-y{display:block;background-color:transparent}.ps--focus>.ps__rail-x,.ps--focus>.ps__rail-y,.ps--scrolling-x>.ps__rail-x,.ps--scrolling-y>.ps__rail-y,.ps:hover>.ps__rail-x,.ps:hover>.ps__rail-y{opacity:.6}.ps .ps__rail-x.ps--clicking,.ps .ps__rail-x:focus,.ps .ps__rail-x:hover,.ps .ps__rail-y.ps--clicking,.ps .ps__rail-y:focus,.ps .ps__rail-y:hover{background-color:#eee;opacity:.9}.ps__thumb-x{transition:background-color .2s linear,height .2s ease-in-out;-webkit-transition:background-color .2s linear,height .2s ease-in-out;height:6px;bottom:2px}.ps__thumb-x,.ps__thumb-y{background-color:#aaa;border-radius:6px;position:absolute}.ps__thumb-y{transition:background-color .2s linear,width .2s ease-in-out;-webkit-transition:background-color .2s linear,width .2s ease-in-out;width:6px;right:2px}.ps__rail-x.ps--clicking .ps__thumb-x,.ps__rail-x:focus>.ps__thumb-x,.ps__rail-x:hover>.ps__thumb-x{background-color:#999;height:11px}.ps__rail-y.ps--clicking .ps__thumb-y,.ps__rail-y:focus>.ps__thumb-y,.ps__rail-y:hover>.ps__thumb-y{background-color:#999;width:11px}@supports (-ms-overflow-style:none){.ps{overflow:auto!important}}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.ps{overflow:auto!important}}.ps-container{position:relative}
    .toastification-close-icon[data-v-7f5431ea],
    .toastification-title[data-v-7f5431ea] {
      line-height: 20px;
    }
    .toastification-title[data-v-7f5431ea] {
      color: inherit;
    }
    .btn-scroll-to-top[data-v-7f94a6f1] {
      position: fixed;
      bottom: 5%;
      z-index: 99;
      opacity: 0;
      transition: all 0.5s ease;
    }[dir=ltr] .btn-scroll-to-top[data-v-7f94a6f1] {
      right: 30px;
    }[dir=rtl] .btn-scroll-to-top[data-v-7f94a6f1] {
      left: 30px;
    }
    .btn-scroll-to-top.show[data-v-7f94a6f1] {
      opacity: 1;
    }
    .ez-toast {
      position: fixed;
      z-index: 99999;
      bottom: 24px;
      font-size: 14px;
    } .ez-toast {
      padding: 15px 20px;
      border-radius: 8px;
      box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
    }[dir=ltr] .ez-toast {
      right: 12px;
    }[dir=rtl] .ez-toast {
      left: 12px;
    }
     .ez-toast.error {
      background-color: #ff0000;
    }
     .ez-toast.success {
      background-color: #0da313;
    }
    .ez-toast i {
      color: #ffffff !important;
    }
    [dir=ltr] .ez-toast i {
      margin-right: 10px;
    }
    [dir=rtl] .ez-toast i {
      margin-left: 10px;
    }
    .ez-toast span {
      font-weight: bold;
      color: #ffffff;
      text-transform: uppercase;
    }
    svg.feather {
      outline: none;
    }
    .v-select {
      position: relative;
      font-family: inherit;
    }
    
    .v-select,
    .v-select * {
      box-sizing: border-box;
    }
    
    /* KeyFrames */
    @-webkit-keyframes vSelectSpinner-ltr {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    @-webkit-keyframes vSelectSpinner-rtl {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
    @keyframes vSelectSpinner-ltr {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    @keyframes vSelectSpinner-rtl {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
    /* Dropdown Default Transition */
    .vs__fade-enter-active,
    .vs__fade-leave-active {
      pointer-events: none;
      transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);
    }
    
    .vs__fade-enter,
    .vs__fade-leave-to {
      opacity: 0;
    }
    
    /** Component States */
    /*
     * Disabled
     *
     * When the component is disabled, all interaction
     * should be prevented. Here we modify the bg color,
     * and change the cursor displayed on the interactive
     * components.
     */
     .vs--disabled .vs__dropdown-toggle,  .vs--disabled .vs__clear,  .vs--disabled .vs__search,  .vs--disabled .vs__selected,  .vs--disabled .vs__open-indicator {
      cursor: not-allowed;
      background-color: #f8f8f8;
    }
    .v-select[dir=rtl] .vs__actions {
      padding: 0 3px 0 6px;
    }
    .v-select[dir=rtl] .vs__clear {
      margin-left: 6px;
      margin-right: 0;
    }
    .v-select[dir=rtl] .vs__deselect {
      margin-left: 0;
      margin-right: 2px;
    }
    .v-select[dir=rtl] .vs__dropdown-menu {
      text-align: right;
    }
    .vs__dropdown-toggle {
      appearance: none;
      display: flex;
      white-space: normal;
    }
     .vs__dropdown-toggle {
      padding: 0 0 4px 0;
      background: none;
      border: 1px solid #D6D9E1;
      border-radius: 0.357rem;
    }
    
    .vs__selected-options {
      display: flex;
      flex-basis: 100%;
      flex-grow: 1;
      flex-wrap: wrap;
      position: relative;
    }
    
     .vs__selected-options {
      padding: 0 2px;
    }
    
    .vs__actions {
      display: flex;
      align-items: center;
    }
    
    [dir=ltr] .vs__actions {
      padding: 4px 6px 0 3px;
    }
    
    [dir=rtl] .vs__actions {
      padding: 4px 3px 0 6px;
    }
    
    /* Dropdown Toggle States */
     .vs--searchable .vs__dropdown-toggle {
      cursor: text;
    }
    
     .vs--unsearchable .vs__dropdown-toggle {
      cursor: pointer;
    }
    
     .vs--open .vs__dropdown-toggle {
      border-bottom-color: transparent;
    }
    
    [dir=ltr] .vs--open .vs__dropdown-toggle {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    [dir=rtl] .vs--open .vs__dropdown-toggle {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    
    .vs__open-indicator {
      fill: rgba(60, 60, 60, 0.5);
      transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    }
    
     .vs__open-indicator {
      transform: scale(1);
      transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
    }
    
    [dir=ltr] .vs--open .vs__open-indicator {
      transform: rotate(180deg) scale(1);
    }
    
    [dir=rtl] .vs--open .vs__open-indicator {
      transform: rotate(-180deg) scale(1);
    }
    
    .vs--loading .vs__open-indicator {
      opacity: 0;
    }
    
    /* Clear Button */
    .vs__clear {
      fill: rgba(60, 60, 60, 0.5);
    }
     .vs__clear {
      padding: 0;
      border: 0;
      background-color: transparent;
      cursor: pointer;
    }
    [dir=ltr] .vs__clear {
      margin-right: 8px;
    }
    [dir=rtl] .vs__clear {
      margin-left: 8px;
    }
    
    /* Dropdown Menu */
    .vs__dropdown-menu {
      display: block;
      box-sizing: border-box;
      position: absolute;
      top: calc(100% - 1px);
      z-index: 1000;
      width: 100%;
      max-height: 350px;
      min-width: 160px;
      overflow-y: auto;
      list-style: none;
    }
     .vs__dropdown-menu {
      padding: 5px 0;
      margin: 0;
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
      border: 1px solid #D6D9E1;
      border-top-style: none;
      border-radius: 0 0 0.357rem 0.357rem;
      background: #fff;
    }
    [dir=ltr] .vs__dropdown-menu {
      left: 0;
      text-align: left;
    }
    [dir=rtl] .vs__dropdown-menu {
      right: 0;
      text-align: right;
    }
    
     .vs__no-options {
      text-align: center;
    }
    
    /* List Items */
    .vs__dropdown-option {
      line-height: 1.42857143;
      /* Normalize line height */
      display: block;
      color: #333;
      /* Overrides most CSS frameworks */
      white-space: nowrap;
    }
     .vs__dropdown-option {
      padding: 3px 20px;
      clear: both;
    }
     .vs__dropdown-option:hover {
      cursor: pointer;
    }
    
    .vs__dropdown-option--highlight {
      color: #114A9F !important;
    }
    
     .vs__dropdown-option--highlight {
      background: rgba(17, 74, 159, 0.12);
    }
    
    .vs__dropdown-option--disabled {
      color: rgba(60, 60, 60, 0.5);
    }
    
     .vs__dropdown-option--disabled {
      background: inherit;
    }
     .vs__dropdown-option--disabled:hover {
      cursor: inherit;
    }
    
    /* Selected Tags */
    .vs__selected {
      display: flex;
      align-items: center;
      color: #333;
      line-height: 1.8;
      z-index: 0;
    }
     .vs__selected {
      background-color: #114A9F;
      border: 0 solid rgba(60, 60, 60, 0.26);
      border-radius: 0.357rem;
      margin: 4px 2px 0px 2px;
      padding: 0 0.25em;
    }
    
    .vs__deselect {
      display: inline-flex;
      appearance: none;
      fill: rgba(60, 60, 60, 0.5);
    }
    
     .vs__deselect {
      padding: 0;
      border: 0;
      cursor: pointer;
      background: none;
      text-shadow: 0 1px 0 #fff;
    }
    
    [dir=ltr] .vs__deselect {
      margin-left: 4px;
    }
    
    [dir=rtl] .vs__deselect {
      margin-right: 4px;
    }
    
    /* States */
     .vs--single .vs__selected {
      background-color: transparent;
      border-color: transparent;
    }
    .vs--single.vs--open .vs__selected {
      position: absolute;
      opacity: 0.4;
    }
    .vs--single.vs--searching .vs__selected {
      display: none;
    }
    
    /* Search Input */
    /**
     * Super weird bug... If this declaration is grouped
     * below, the cancel button will still appear in chrome.
     * If it's up here on it's own, it'll hide it.
     */
    .vs__search::-webkit-search-cancel-button {
      display: none;
    }
    
    .vs__search::-webkit-search-decoration,
    .vs__search::-webkit-search-results-button,
    .vs__search::-webkit-search-results-decoration,
    .vs__search::-ms-clear {
      display: none;
    }
    
    .vs__search,
    .vs__search:focus {
      appearance: none;
      line-height: 1.8;
      font-size: 1em;
      outline: none;
      width: 0;
      max-width: 100%;
      flex-grow: 1;
      z-index: 1;
    }
    
     .vs__search,  .vs__search:focus {
      border: 1px solid transparent;
      margin: 4px 0 0 0;
      padding: 0 7px;
      background: none;
      box-shadow: none;
    }
    
    [dir=ltr] .vs__search, [dir=ltr] .vs__search:focus {
      border-left: none;
    }
    
    [dir=rtl] .vs__search, [dir=rtl] .vs__search:focus {
      border-right: none;
    }
    
    .vs__search::placeholder {
      color: #424244;
    }
    
    /**
        States
     */
    .vs--unsearchable .vs__search {
      opacity: 1;
    }
     .vs--unsearchable:not(.vs--disabled) .vs__search:hover {
      cursor: pointer;
    }
    
    .vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {
      opacity: 0.2;
    }
    
    /* Loading Spinner */
    .vs__spinner {
      align-self: center;
      opacity: 0;
      font-size: 5px;
      text-indent: -9999em;
      overflow: hidden;
      transition: opacity 0.1s;
    }
     .vs__spinner {
      border-top: 0.9em solid rgba(100, 100, 100, 0.1);
      border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);
      transform: translateZ(0);
    }
    [dir=ltr] .vs__spinner {
      border-right: 0.9em solid rgba(100, 100, 100, 0.1);
      border-left: 0.9em solid rgba(60, 60, 60, 0.45);
      animation:  vSelectSpinner-ltr 1.1s infinite linear;
    }
    [dir=rtl] .vs__spinner {
      border-left: 0.9em solid rgba(100, 100, 100, 0.1);
      border-right: 0.9em solid rgba(60, 60, 60, 0.45);
      animation:  vSelectSpinner-rtl 1.1s infinite linear;
    }
    
    .vs__spinner,
    .vs__spinner:after {
      width: 5em;
      height: 5em;
    }
    
     .vs__spinner,  .vs__spinner:after {
      border-radius: 50%;
    }
    
    /* Loading Spinner States */
    .vs--loading .vs__spinner {
      opacity: 1;
    }
    
    .vs__open-indicator {
      fill: none;
    }
    
     .vs__open-indicator {
      margin-top: 0.15rem;
    }
    
    .vs__dropdown-toggle {
      transition: all 0.25s ease-in-out;
    }
    
     .vs__dropdown-toggle {
      padding: 0.59px 0 2px 0;
    }
    [dir=ltr] .vs--single .vs__dropdown-toggle {
      padding-left: 6px;
    }
    [dir=rtl] .vs--single .vs__dropdown-toggle {
      padding-right: 6px;
    }
    
    .vs__dropdown-option--disabled {
      opacity: 0.5;
    }
     .vs__dropdown-option--disabled.vs__dropdown-option--selected {
      background: #114A9F !important;
    }
    
    .vs__dropdown-option {
      color: #424244;
    }
    
     .vs__dropdown-option,  .vs__no-options {
      padding: 7px 20px;
    }
    .vs__dropdown-option--selected {
      background-color: #114A9F;
      color: #fff;
      position: relative;
    }
    .vs__dropdown-option--selected::after {
      content: "";
      height: 1.1rem;
      width: 1.1rem;
      display: inline-block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 1.1rem;
    }
    [dir=rtl] .vs__dropdown-option--selected::after {
      left: 20px;
      right: unset;
    }
    .vs__dropdown-option--selected.vs__dropdown-option--highlight {
      color: #fff !important;
      background-color: #114A9F !important;
    }
    .vs__clear svg {
      color: #424244;
    }
    
    .vs__selected {
      color: #fff;
    }
    .v-select.vs--single .vs__selected {
      color: #424244;
      transition: transform 0.2s ease;
    }
     .v-select.vs--single .vs__selected {
      margin-top: 5px;
    }
    [dir=ltr] .v-select.vs--single .vs__selected input {
      padding-left: 0;
    }
    [dir=rtl] .v-select.vs--single .vs__selected input {
      padding-right: 0;
    }
    [dir=ltr] .vs--single.vs--open .vs__selected {
      transform: translateX(5px);
    }
    [dir=rtl] .vs--single.vs--open .vs__selected {
      transform: translateX(-5px);
    }
    .vs__selected .vs__deselect {
      color: inherit;
    }
    
    .v-select:not(.vs--single) .vs__selected {
      font-size: 0.9rem;
    }
    
     .v-select:not(.vs--single) .vs__selected {
      border-radius: 3px;
      padding: 0 0.6em;
    }
    
    [dir=ltr] .v-select:not(.vs--single) .vs__selected {
      margin: 5px 2px 2px 5px;
    }
    
    [dir=rtl] .v-select:not(.vs--single) .vs__selected {
      margin: 5px 5px 2px 2px;
    }
    .v-select:not(.vs--single) .vs__deselect svg {
      vertical-align: text-top;
    }
     .v-select:not(.vs--single) .vs__deselect svg {
      transform: scale(0.8);
    }
    
    .vs__dropdown-menu {
      top: calc(100% + 0.5rem);
    }
    
     .vs__dropdown-menu {
      border: none;
      border-radius: 6px;
      padding: 0;
    }
    
     .vs--open .vs__dropdown-toggle {
      border-color: #114A9F;
      border-bottom-color: #114A9F;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
    
    [dir=ltr] .vs--open .vs__dropdown-toggle {
      border-bottom-left-radius: 0.357rem;
      border-bottom-right-radius: 0.357rem;
    }
    
    [dir=rtl] .vs--open .vs__dropdown-toggle {
      border-bottom-right-radius: 0.357rem;
      border-bottom-left-radius: 0.357rem;
    }
    
    .select-size-lg .vs__selected {
      font-size: 1rem !important;
    }
     .select-size-lg.vs--single.vs--open .vs__selected {
      margin-top: 6px;
    }
    .select-size-lg .vs__dropdown-toggle,
    .select-size-lg .vs__selected {
      font-size: 1.25rem;
    }
     .select-size-lg .vs__dropdown-toggle {
      padding: 5px;
    }
     .select-size-lg .vs__dropdown-toggle input {
      margin-top: 0;
    }
    .select-size-lg .vs__deselect svg {
      vertical-align: middle !important;
    }
     .select-size-lg .vs__deselect svg {
      transform: scale(1) !important;
    }
    
     .select-size-sm .vs__dropdown-toggle {
      padding-bottom: 0;
      padding: 1px;
    }
     .select-size-sm.vs--single .vs__dropdown-toggle {
      padding: 2px;
    }
    .select-size-sm .vs__dropdown-toggle,
    .select-size-sm .vs__selected {
      font-size: 0.9rem;
    }
     .select-size-sm .vs__actions {
      padding-top: 2px;
      padding-bottom: 2px;
    }
    .select-size-sm .vs__deselect svg {
      vertical-align: middle !important;
    }
     .select-size-sm .vs__search {
      margin-top: 0;
    }
    .select-size-sm.v-select .vs__selected {
      font-size: 0.75rem;
    }
     .select-size-sm.v-select .vs__selected {
      padding: 0 0.3rem;
    }
     .select-size-sm.v-select:not(.vs--single) .vs__selected {
      margin: 4px 5px;
    }
     .select-size-sm.v-select.vs--single .vs__selected {
      margin-top: 1px;
    }
     .select-size-sm.vs--single.vs--open .vs__selected {
      margin-top: 4px;
    }
    
    .dark-layout .vs__dropdown-toggle {
      color: #b4b7bd;
    }
    
     .dark-layout .vs__dropdown-toggle {
      background: #283046;
      border-color: #404656;
    }
    .dark-layout .vs__selected-options input {
      color: #b4b7bd;
    }
    .dark-layout .vs__selected-options input::placeholder {
      color: #676d7d;
    }
    .dark-layout .vs__actions svg {
      fill: #404656;
    }
     .dark-layout .vs__dropdown-menu {
      background: #283046;
    }
    .dark-layout .vs__dropdown-menu li {
      color: #b4b7bd;
    }
    .dark-layout .v-select:not(.vs--single) .vs__selected {
      color: #114A9F;
    }
     .dark-layout .v-select:not(.vs--single) .vs__selected {
      background-color: rgba(17, 74, 159, 0.12);
    }
    .dark-layout .v-select.vs--single .vs__selected {
      color: #b4b7bd !important;
    }
    .dark-layout .vs--disabled .vs__dropdown-toggle,
    .dark-layout .vs--disabled .vs__clear,
    .dark-layout .vs--disabled .vs__search,
    .dark-layout .vs--disabled .vs__selected,
    .dark-layout .vs--disabled .vs__open-indicator {
      opacity: 0.5;
      color: inherit !important;
    }
     .dark-layout .vs--disabled .vs__dropdown-toggle,  .dark-layout .vs--disabled .vs__clear,  .dark-layout .vs--disabled .vs__search,  .dark-layout .vs--disabled .vs__selected,  .dark-layout .vs--disabled .vs__open-indicator {
      background-color: #283046;
    }
    
    .vs--disabled .vs__selected {
      color: inherit !important;
    }
    .vs--disabled .vs__selected button {
      display: none;
    }
    .Vue-Toastification__container {
      z-index: 9999;
      position: fixed;
      width: 400px;
      box-sizing: border-box;
      display: flex;
      min-height: 100%;
      color: #fff;
      flex-direction: column;
      pointer-events: none;
    } .Vue-Toastification__container {
      padding: 4px;
    }
    @media only screen and (min-width : 600px) {
      .Vue-Toastification__container.top-left, .Vue-Toastification__container.top-right, .Vue-Toastification__container.top-center {
        top: 1em;
      }
      .Vue-Toastification__container.bottom-left, .Vue-Toastification__container.bottom-right, .Vue-Toastification__container.bottom-center {
        bottom: 1em;
        flex-direction: column-reverse;
      }
      [dir=ltr] .Vue-Toastification__container.top-left, [dir=ltr] .Vue-Toastification__container.bottom-left {
        left: 1em;
      }
      [dir=rtl] .Vue-Toastification__container.top-left, [dir=rtl] .Vue-Toastification__container.bottom-left {
        right: 1em;
      }
      [dir=ltr] .Vue-Toastification__container.top-left .Vue-Toastification__toast, [dir=ltr] .Vue-Toastification__container.bottom-left .Vue-Toastification__toast {
        margin-right: auto;
      }
      [dir=rtl] .Vue-Toastification__container.top-left .Vue-Toastification__toast, [dir=rtl] .Vue-Toastification__container.bottom-left .Vue-Toastification__toast {
        margin-left: auto;
      }
      [dir=ltr] .Vue-Toastification__container.top-left .Vue-Toastification__toast--rtl, [dir=ltr] .Vue-Toastification__container.bottom-left .Vue-Toastification__toast--rtl {
        margin-right: unset;
        margin-left: auto;
      }
      [dir=rtl] .Vue-Toastification__container.top-left .Vue-Toastification__toast--rtl, [dir=rtl] .Vue-Toastification__container.bottom-left .Vue-Toastification__toast--rtl {
        margin-left: unset;
        margin-right: auto;
      }
      [dir=ltr] .Vue-Toastification__container.top-right, [dir=ltr] .Vue-Toastification__container.bottom-right {
        right: 1em;
      }
      [dir=rtl] .Vue-Toastification__container.top-right, [dir=rtl] .Vue-Toastification__container.bottom-right {
        left: 1em;
      }
      [dir=ltr] .Vue-Toastification__container.top-right .Vue-Toastification__toast, [dir=ltr] .Vue-Toastification__container.bottom-right .Vue-Toastification__toast {
        margin-left: auto;
      }
      [dir=rtl] .Vue-Toastification__container.top-right .Vue-Toastification__toast, [dir=rtl] .Vue-Toastification__container.bottom-right .Vue-Toastification__toast {
        margin-right: auto;
      }
      [dir=ltr] .Vue-Toastification__container.top-right .Vue-Toastification__toast--rtl, [dir=ltr] .Vue-Toastification__container.bottom-right .Vue-Toastification__toast--rtl {
        margin-left: unset;
        margin-right: auto;
      }
      [dir=rtl] .Vue-Toastification__container.top-right .Vue-Toastification__toast--rtl, [dir=rtl] .Vue-Toastification__container.bottom-right .Vue-Toastification__toast--rtl {
        margin-right: unset;
        margin-left: auto;
      }
      [dir=ltr] .Vue-Toastification__container.top-center, [dir=ltr] .Vue-Toastification__container.bottom-center {
        left: 50%;
        margin-left: -200px;
      }
      [dir=rtl] .Vue-Toastification__container.top-center, [dir=rtl] .Vue-Toastification__container.bottom-center {
        right: 50%;
        margin-right: -200px;
      }
      [dir=ltr] .Vue-Toastification__container.top-center .Vue-Toastification__toast, [dir=ltr] .Vue-Toastification__container.bottom-center .Vue-Toastification__toast {
        margin-left: auto;
        margin-right: auto;
      }
      [dir=rtl] .Vue-Toastification__container.top-center .Vue-Toastification__toast, [dir=rtl] .Vue-Toastification__container.bottom-center .Vue-Toastification__toast {
        margin-right: auto;
        margin-left: auto;
      }
    }
    @media only screen and (max-width : 600px) {
      .Vue-Toastification__container {
        width: 100vw;
      }
       .Vue-Toastification__container {
        padding: 0;
        margin: 0;
      }
      [dir=ltr] .Vue-Toastification__container {
        left: 0;
      }
      [dir=rtl] .Vue-Toastification__container {
        right: 0;
      }
      .Vue-Toastification__container .Vue-Toastification__toast {
        width: 100%;
      }
      .Vue-Toastification__container.top-left, .Vue-Toastification__container.top-right, .Vue-Toastification__container.top-center {
        top: 0;
      }
      .Vue-Toastification__container.bottom-left, .Vue-Toastification__container.bottom-right, .Vue-Toastification__container.bottom-center {
        bottom: 0;
        flex-direction: column-reverse;
      }
    }
    
    .Vue-Toastification__toast {
      display: inline-flex;
      position: relative;
      max-height: unset;
      min-height: unset;
      box-sizing: border-box;
      justify-content: space-between;
      font-family: inherit;
      max-width: 400px;
      min-width: 326px;
      pointer-events: auto;
      overflow: hidden;
    }
    
     .Vue-Toastification__toast {
      margin-bottom: 1rem;
      padding: 22px 24px;
      border-radius: 8px;
      box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
      transform: translateZ(0);
    }
    
    [dir=ltr] .Vue-Toastification__toast {
      direction: ltr;
    }
    
    [dir=rtl] .Vue-Toastification__toast {
      direction: rtl;
    }
    [dir=ltr] .Vue-Toastification__toast--rtl {
      direction: rtl;
    }
    [dir=rtl] .Vue-Toastification__toast--rtl {
      direction: ltr;
    }
    .Vue-Toastification__toast--default {
      color: #114A9F;
    }
     .Vue-Toastification__toast--default {
      background-color: #fff;
    }
    .Vue-Toastification__toast--info {
      color: #00CFE8;
    }
     .Vue-Toastification__toast--info {
      background-color: #fff;
    }
    .Vue-Toastification__toast--success {
      color: #17B75E;
    }
     .Vue-Toastification__toast--success {
      background-color: #fff;
    }
    .Vue-Toastification__toast--error {
      color: #EA5455;
    }
     .Vue-Toastification__toast--error {
      background-color: #fff;
    }
    .Vue-Toastification__toast--warning {
      color: #FDB913;
    }
     .Vue-Toastification__toast--warning {
      background-color: #fff;
    }
    @media only screen and (max-width : 600px) {
       .Vue-Toastification__toast {
        border-radius: 0px;
        margin-bottom: 0.5rem;
      }
    }
    .Vue-Toastification__toast-body {
      flex: 1;
      line-height: 24px;
      font-size: 16px;
      word-break: break-word;
      white-space: pre-wrap;
    }
    .Vue-Toastification__toast-component-body {
      flex: 1;
    }
    .Vue-Toastification__toast.disable-transition {
      transition: none !important;
    }
    [dir=ltr] .Vue-Toastification__toast.disable-transition {
      animation: none !important;
    }
    [dir=rtl] .Vue-Toastification__toast.disable-transition {
      animation: none !important;
    }
    
    .Vue-Toastification__close-button {
      font-weight: bold;
      font-size: 24px;
      line-height: 24px;
      outline: none;
      transition: 0.3s ease;
      align-items: center;
      color: #fff;
      opacity: 0.3;
      transition: visibility 0s, opacity 0.2s linear;
    }
    
     .Vue-Toastification__close-button {
      background: transparent;
      border: none;
      padding: 0;
      cursor: pointer;
    }
    
    [dir=ltr] .Vue-Toastification__close-button {
      padding-left: 10px;
    }
    
    [dir=rtl] .Vue-Toastification__close-button {
      padding-right: 10px;
    }
    .Vue-Toastification__close-button:hover, .Vue-Toastification__close-button:focus {
      opacity: 1;
    }
    .Vue-Toastification__toast:not(:hover) .Vue-Toastification__close-button.show-on-hover {
      opacity: 0;
    }
    [dir=ltr] .Vue-Toastification__toast--rtl .Vue-Toastification__close-button {
      padding-left: unset;
      padding-right: 10px;
    }
    [dir=rtl] .Vue-Toastification__toast--rtl .Vue-Toastification__close-button {
      padding-right: unset;
      padding-left: 10px;
    }
    
    @keyframes scale-x-frames {
      0% {
        transform: scaleX(1);
      }
      100% {
        transform: scaleX(0);
      }
    }
    .Vue-Toastification__progress-bar {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 5px;
      z-index: 10000;
    }
     .Vue-Toastification__progress-bar {
      background-color: rgba(255, 255, 255, 0.7);
    }
    [dir=ltr] .Vue-Toastification__progress-bar {
      left: 0;
      transform-origin: left;
      animation: scale-x-frames linear 1 forwards;
    }
    [dir=rtl] .Vue-Toastification__progress-bar {
      right: 0;
      transform-origin: right;
      animation: scale-x-frames linear 1 forwards;
    }
    [dir=ltr] .Vue-Toastification__toast--rtl .Vue-Toastification__progress-bar {
      right: 0;
      left: unset;
      transform-origin: right;
    }
    [dir=rtl] .Vue-Toastification__toast--rtl .Vue-Toastification__progress-bar {
      left: 0;
      right: unset;
      transform-origin: left;
    }
    
    .Vue-Toastification__icon {
      outline: none;
      transition: 0.3s ease;
      align-items: center;
      width: 20px;
      height: 100%;
    }
    
     .Vue-Toastification__icon {
      background: transparent;
      border: none;
      padding: 0;
    }
    
    [dir=ltr] .Vue-Toastification__icon {
      margin: auto 18px auto 0px;
    }
    
    [dir=rtl] .Vue-Toastification__icon {
      margin: auto 0px auto 18px;
    }
    [dir=ltr] .Vue-Toastification__toast--rtl .Vue-Toastification__icon {
      margin: auto 0px auto 18px;
    }
    [dir=rtl] .Vue-Toastification__toast--rtl .Vue-Toastification__icon {
      margin: auto 18px auto 0px;
    }
    
    /* ----------------------------------------------
     * Modified version from Animista
     * Animista is Licensed under FreeBSD License.
     * See http://animista.net/license for more info. 
     * w: http://animista.net, t: @cssanimista
     * ---------------------------------------------- */
    @keyframes fadeOutTop {
      0% {
        transform: translateY(0);
        opacity: 1;
      }
      100% {
        transform: translateY(-50px);
        opacity: 0;
      }
    }
    @keyframes fadeOutLeft-ltr {
      0% {
        transform: translateX(0);
        opacity: 1;
      }
      100% {
        transform: translateX(-50px);
        opacity: 0;
      }
    }
    @keyframes fadeOutLeft-rtl {
      0% {
        transform: translateX(0);
        opacity: 1;
      }
      100% {
        transform: translateX(50px);
        opacity: 0;
      }
    }
    @keyframes fadeOutBottom {
      0% {
        transform: translateY(0);
        opacity: 1;
      }
      100% {
        transform: translateY(50px);
        opacity: 0;
      }
    }
    @keyframes fadeOutRight-ltr {
      0% {
        transform: translateX(0);
        opacity: 1;
      }
      100% {
        transform: translateX(50px);
        opacity: 0;
      }
    }
    @keyframes fadeOutRight-rtl {
      0% {
        transform: translateX(0);
        opacity: 1;
      }
      100% {
        transform: translateX(-50px);
        opacity: 0;
      }
    }
    @keyframes fadeInLeft-ltr {
      0% {
        transform: translateX(-50px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }
    @keyframes fadeInLeft-rtl {
      0% {
        transform: translateX(50px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }
    @keyframes fadeInRight-ltr {
      0% {
        transform: translateX(50px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }
    @keyframes fadeInRight-rtl {
      0% {
        transform: translateX(-50px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }
    @keyframes fadeInTop {
      0% {
        transform: translateY(-50px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
    @keyframes fadeInBottom {
      0% {
        transform: translateY(50px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
    [dir=ltr] .Vue-Toastification__fade-enter-active.top-left, [dir=ltr] .Vue-Toastification__fade-enter-active.bottom-left {
      animation-name:  fadeInLeft-ltr ;
    }
    [dir=rtl] .Vue-Toastification__fade-enter-active.top-left, [dir=rtl] .Vue-Toastification__fade-enter-active.bottom-left {
      animation-name:  fadeInLeft-rtl ;
    }
    [dir=ltr] .Vue-Toastification__fade-enter-active.top-right, [dir=ltr] .Vue-Toastification__fade-enter-active.bottom-right {
      animation-name:  fadeInRight-ltr ;
    }
    [dir=rtl] .Vue-Toastification__fade-enter-active.top-right, [dir=rtl] .Vue-Toastification__fade-enter-active.bottom-right {
      animation-name:  fadeInRight-rtl ;
    }
    [dir=ltr] .Vue-Toastification__fade-enter-active.top-center {
      animation-name: fadeInTop;
    }
    [dir=rtl] .Vue-Toastification__fade-enter-active.top-center {
      animation-name: fadeInTop;
    }
    [dir=ltr] .Vue-Toastification__fade-enter-active.bottom-center {
      animation-name: fadeInBottom;
    }
    [dir=rtl] .Vue-Toastification__fade-enter-active.bottom-center {
      animation-name: fadeInBottom;
    }
    
    [dir=ltr] .Vue-Toastification__fade-leave-active.top-left, [dir=ltr] .Vue-Toastification__fade-leave-active.bottom-left {
      animation-name:  fadeOutLeft-ltr ;
    }
    
    [dir=rtl] .Vue-Toastification__fade-leave-active.top-left, [dir=rtl] .Vue-Toastification__fade-leave-active.bottom-left {
      animation-name:  fadeOutLeft-rtl ;
    }
    [dir=ltr] .Vue-Toastification__fade-leave-active.top-right, [dir=ltr] .Vue-Toastification__fade-leave-active.bottom-right {
      animation-name:  fadeOutRight-ltr ;
    }
    [dir=rtl] .Vue-Toastification__fade-leave-active.top-right, [dir=rtl] .Vue-Toastification__fade-leave-active.bottom-right {
      animation-name:  fadeOutRight-rtl ;
    }
    [dir=ltr] .Vue-Toastification__fade-leave-active.top-center {
      animation-name: fadeOutTop;
    }
    [dir=rtl] .Vue-Toastification__fade-leave-active.top-center {
      animation-name: fadeOutTop;
    }
    [dir=ltr] .Vue-Toastification__fade-leave-active.bottom-center {
      animation-name: fadeOutBottom;
    }
    [dir=rtl] .Vue-Toastification__fade-leave-active.bottom-center {
      animation-name: fadeOutBottom;
    }
    
     .Vue-Toastification__fade-move {
      transition-timing-function: ease-in-out;
      transition-property: all;
      transition-duration: 400ms;
    }
    
     .Vue-Toastification__toast {
      padding: 1rem;
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
      border-radius: 0.428rem;
    }
    
    @media only screen and (max-width: 600px) {
      .Vue-Toastification__container .Vue-Toastification__toast {
        width: 90%;
      }
    }
     .dark-layout .Vue-Toastification__toast {
      background-color: #283046;
    }
    
    .feather {
      /* use !important to prevent issues with browser extensions that change fonts */
      font-family: 'feather' !important;
      speak: none;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
    
      /* Better Font Rendering =========== */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    
    .icon-alert-octagon:before {
      content: '\e81b';
    }
    
    .icon-alert-circle:before {
      content: '\e81c';
    }
    
    .icon-activity:before {
      content: '\e81d';
    }
    
    .icon-alert-triangle:before {
      content: '\e81e';
    }
    
    .icon-align-center:before {
      content: '\e81f';
    }
    
    .icon-airplay:before {
      content: '\e820';
    }
    
    .icon-align-justify:before {
      content: '\e821';
    }
    
    .icon-align-left:before {
      content: '\e822';
    }
    
    .icon-align-right:before {
      content: '\e823';
    }
    
    .icon-arrow-down-left:before {
      content: '\e824';
    }
    
    .icon-arrow-down-right:before {
      content: '\e825';
    }
    
    .icon-anchor:before {
      content: '\e826';
    }
    
    .icon-aperture:before {
      content: '\e827';
    }
    
    .icon-arrow-left:before {
      content: '\e828';
    }
    
    .icon-arrow-right:before {
      content: '\e829';
    }
    
    .icon-arrow-down:before {
      content: '\e82a';
    }
    
    .icon-arrow-up-left:before {
      content: '\e82b';
    }
    
    .icon-arrow-up-right:before {
      content: '\e82c';
    }
    
    .icon-arrow-up:before {
      content: '\e82d';
    }
    
    .icon-award:before {
      content: '\e82e';
    }
    
    .icon-bar-chart:before {
      content: '\e82f';
    }
    
    .icon-at-sign:before {
      content: '\e830';
    }
    
    .icon-bar-chart-2:before {
      content: '\e831';
    }
    
    .icon-battery-charging:before {
      content: '\e832';
    }
    
    .icon-bell-off:before {
      content: '\e833';
    }
    
    .icon-battery:before {
      content: '\e834';
    }
    
    .icon-bluetooth:before {
      content: '\e835';
    }
    
    .icon-bell:before {
      content: '\e836';
    }
    
    .icon-book:before {
      content: '\e837';
    }
    
    .icon-briefcase:before {
      content: '\e838';
    }
    
    .icon-camera-off:before {
      content: '\e839';
    }
    
    .icon-calendar:before {
      content: '\e83a';
    }
    
    .icon-bookmark:before {
      content: '\e83b';
    }
    
    .icon-box:before {
      content: '\e83c';
    }
    
    .icon-camera:before {
      content: '\e83d';
    }
    
    .icon-check-circle:before {
      content: '\e83e';
    }
    
    .icon-check:before {
      content: '\e83f';
    }
    
    .icon-check-square:before {
      content: '\e840';
    }
    
    .icon-cast:before {
      content: '\e841';
    }
    
    .icon-chevron-down:before {
      content: '\e842';
    }
    
    .icon-chevron-left:before {
      content: '\e843';
    }
    
    .icon-chevron-right:before {
      content: '\e844';
    }
    
    .icon-chevron-up:before {
      content: '\e845';
    }
    
    .icon-chevrons-down:before {
      content: '\e846';
    }
    
    .icon-chevrons-right:before {
      content: '\e847';
    }
    
    .icon-chevrons-up:before {
      content: '\e848';
    }
    
    .icon-chevrons-left:before {
      content: '\e849';
    }
    
    .icon-circle:before {
      content: '\e84a';
    }
    
    .icon-clipboard:before {
      content: '\e84b';
    }
    
    .icon-chrome:before {
      content: '\e84c';
    }
    
    .icon-clock:before {
      content: '\e84d';
    }
    
    .icon-cloud-lightning:before {
      content: '\e84e';
    }
    
    .icon-cloud-drizzle:before {
      content: '\e84f';
    }
    
    .icon-cloud-rain:before {
      content: '\e850';
    }
    
    .icon-cloud-off:before {
      content: '\e851';
    }
    
    .icon-codepen:before {
      content: '\e852';
    }
    
    .icon-cloud-snow:before {
      content: '\e853';
    }
    
    .icon-compass:before {
      content: '\e854';
    }
    
    .icon-copy:before {
      content: '\e855';
    }
    
    .icon-corner-down-right:before {
      content: '\e856';
    }
    
    .icon-corner-down-left:before {
      content: '\e857';
    }
    
    .icon-corner-left-down:before {
      content: '\e858';
    }
    
    .icon-corner-left-up:before {
      content: '\e859';
    }
    
    .icon-corner-up-left:before {
      content: '\e85a';
    }
    
    .icon-corner-up-right:before {
      content: '\e85b';
    }
    
    .icon-corner-right-down:before {
      content: '\e85c';
    }
    
    .icon-corner-right-up:before {
      content: '\e85d';
    }
    
    .icon-cpu:before {
      content: '\e85e';
    }
    
    .icon-credit-card:before {
      content: '\e85f';
    }
    
    .icon-crosshair:before {
      content: '\e860';
    }
    
    .icon-disc:before {
      content: '\e861';
    }
    
    .icon-delete:before {
      content: '\e862';
    }
    
    .icon-download-cloud:before {
      content: '\e863';
    }
    
    .icon-download:before {
      content: '\e864';
    }
    
    .icon-droplet:before {
      content: '\e865';
    }
    
    .icon-edit-2:before {
      content: '\e866';
    }
    
    .icon-edit:before {
      content: '\e867';
    }
    
    .icon-edit-1:before {
      content: '\e868';
    }
    
    .icon-external-link:before {
      content: '\e869';
    }
    
    .icon-eye:before {
      content: '\e86a';
    }
    
    .icon-feather:before {
      content: '\e86b';
    }
    
    .icon-facebook:before {
      content: '\e86c';
    }
    
    .icon-file-minus:before {
      content: '\e86d';
    }
    
    .icon-eye-off:before {
      content: '\e86e';
    }
    
    .icon-fast-forward:before {
      content: '\e86f';
    }
    
    .icon-file-text:before {
      content: '\e870';
    }
    
    .icon-film:before {
      content: '\e871';
    }
    
    .icon-file:before {
      content: '\e872';
    }
    
    .icon-file-plus:before {
      content: '\e873';
    }
    
    .icon-folder:before {
      content: '\e874';
    }
    
    .icon-filter:before {
      content: '\e875';
    }
    
    .icon-flag:before {
      content: '\e876';
    }
    
    .icon-globe:before {
      content: '\e877';
    }
    
    .icon-grid:before {
      content: '\e878';
    }
    
    .icon-heart:before {
      content: '\e879';
    }
    
    .icon-home:before {
      content: '\e87a';
    }
    
    .icon-github:before {
      content: '\e87b';
    }
    
    .icon-image:before {
      content: '\e87c';
    }
    
    .icon-inbox:before {
      content: '\e87d';
    }
    
    .icon-layers:before {
      content: '\e87e';
    }
    
    .icon-info:before {
      content: '\e87f';
    }
    
    .icon-instagram:before {
      content: '\e880';
    }
    
    .icon-layout:before {
      content: '\e881';
    }
    
    .icon-link-2:before {
      content: '\e882';
    }
    
    .icon-life-buoy:before {
      content: '\e883';
    }
    
    .icon-link:before {
      content: '\e884';
    }
    
    .icon-log-in:before {
      content: '\e885';
    }
    
    .icon-list:before {
      content: '\e886';
    }
    
    .icon-lock:before {
      content: '\e887';
    }
    
    .icon-log-out:before {
      content: '\e888';
    }
    
    .icon-loader:before {
      content: '\e889';
    }
    
    .icon-mail:before {
      content: '\e88a';
    }
    
    .icon-maximize-2:before {
      content: '\e88b';
    }
    
    .icon-map:before {
      content: '\e88c';
    }
    
    .icon-map-pin:before {
      content: '\e88e';
    }
    
    .icon-menu:before {
      content: '\e88f';
    }
    
    .icon-message-circle:before {
      content: '\e890';
    }
    
    .icon-message-square:before {
      content: '\e891';
    }
    
    .icon-minimize-2:before {
      content: '\e892';
    }
    
    .icon-mic-off:before {
      content: '\e893';
    }
    
    .icon-minus-circle:before {
      content: '\e894';
    }
    
    .icon-mic:before {
      content: '\e895';
    }
    
    .icon-minus-square:before {
      content: '\e896';
    }
    
    .icon-minus:before {
      content: '\e897';
    }
    
    .icon-moon:before {
      content: '\e898';
    }
    
    .icon-monitor:before {
      content: '\e899';
    }
    
    .icon-more-vertical:before {
      content: '\e89a';
    }
    
    .icon-more-horizontal:before {
      content: '\e89b';
    }
    
    .icon-move:before {
      content: '\e89c';
    }
    
    .icon-music:before {
      content: '\e89d';
    }
    
    .icon-navigation-2:before {
      content: '\e89e';
    }
    
    .icon-navigation:before {
      content: '\e89f';
    }
    
    .icon-octagon:before {
      content: '\e8a0';
    }
    
    .icon-package:before {
      content: '\e8a1';
    }
    
    .icon-pause-circle:before {
      content: '\e8a2';
    }
    
    .icon-pause:before {
      content: '\e8a3';
    }
    
    .icon-percent:before {
      content: '\e8a4';
    }
    
    .icon-phone-call:before {
      content: '\e8a5';
    }
    
    .icon-phone-forwarded:before {
      content: '\e8a6';
    }
    
    .icon-phone-missed:before {
      content: '\e8a7';
    }
    
    .icon-phone-off:before {
      content: '\e8a8';
    }
    
    .icon-phone-incoming:before {
      content: '\e8a9';
    }
    
    .icon-phone:before {
      content: '\e8aa';
    }
    
    .icon-phone-outgoing:before {
      content: '\e8ab';
    }
    
    .icon-pie-chart:before {
      content: '\e8ac';
    }
    
    .icon-play-circle:before {
      content: '\e8ad';
    }
    
    .icon-play:before {
      content: '\e8ae';
    }
    
    .icon-plus-square:before {
      content: '\e8af';
    }
    
    .icon-plus-circle:before {
      content: '\e8b0';
    }
    
    .icon-plus:before {
      content: '\e8b1';
    }
    
    .icon-pocket:before {
      content: '\e8b2';
    }
    
    .icon-printer:before {
      content: '\e8b3';
    }
    
    .icon-power:before {
      content: '\e8b4';
    }
    
    .icon-radio:before {
      content: '\e8b5';
    }
    
    .icon-repeat:before {
      content: '\e8b6';
    }
    
    .icon-refresh-ccw:before {
      content: '\e8b7';
    }
    
    .icon-rewind:before {
      content: '\e8b8';
    }
    
    .icon-rotate-ccw:before {
      content: '\e8b9';
    }
    
    .icon-refresh-cw:before {
      content: '\e8ba';
    }
    
    .icon-rotate-cw:before {
      content: '\e8bb';
    }
    
    .icon-save:before {
      content: '\e8bc';
    }
    
    .icon-search:before {
      content: '\e8bd';
    }
    
    .icon-server:before {
      content: '\e8be';
    }
    
    .icon-scissors:before {
      content: '\e8bf';
    }
    
    .icon-share-2:before {
      content: '\e8c0';
    }
    
    .icon-share:before {
      content: '\e8c1';
    }
    
    .icon-shield:before {
      content: '\e8c2';
    }
    
    .icon-settings:before {
      content: '\e8c3';
    }
    
    .icon-skip-back:before {
      content: '\e8c4';
    }
    
    .icon-shuffle:before {
      content: '\e8c5';
    }
    
    .icon-sidebar:before {
      content: '\e8c6';
    }
    
    .icon-skip-forward:before {
      content: '\e8c7';
    }
    
    .icon-slack:before {
      content: '\e8c8';
    }
    
    .icon-slash:before {
      content: '\e8c9';
    }
    
    .icon-smartphone:before {
      content: '\e8ca';
    }
    
    .icon-square:before {
      content: '\e8cb';
    }
    
    .icon-speaker:before {
      content: '\e8cc';
    }
    
    .icon-star:before {
      content: '\e8cd';
    }
    
    .icon-stop-circle:before {
      content: '\e8ce';
    }
    
    .icon-sun:before {
      content: '\e8cf';
    }
    
    .icon-sunrise:before {
      content: '\e8d0';
    }
    
    .icon-tablet:before {
      content: '\e8d1';
    }
    
    .icon-tag:before {
      content: '\e8d2';
    }
    
    .icon-sunset:before {
      content: '\e8d3';
    }
    
    .icon-target:before {
      content: '\e8d4';
    }
    
    .icon-thermometer:before {
      content: '\e8d5';
    }
    
    .icon-thumbs-up:before {
      content: '\e8d6';
    }
    
    .icon-thumbs-down:before {
      content: '\e8d7';
    }
    
    .icon-toggle-left:before {
      content: '\e8d8';
    }
    
    .icon-toggle-right:before {
      content: '\e8d9';
    }
    
    .icon-trash-2:before {
      content: '\e8da';
    }
    
    .icon-trash:before {
      content: '\e8db';
    }
    
    .icon-trending-up:before {
      content: '\e8dc';
    }
    
    .icon-trending-down:before {
      content: '\e8dd';
    }
    
    .icon-triangle:before {
      content: '\e8de';
    }
    
    .icon-type:before {
      content: '\e8df';
    }
    
    .icon-twitter:before {
      content: '\e8e0';
    }
    
    .icon-upload:before {
      content: '\e8e1';
    }
    
    .icon-umbrella:before {
      content: '\e8e2';
    }
    
    .icon-upload-cloud:before {
      content: '\e8e3';
    }
    
    .icon-unlock:before {
      content: '\e8e4';
    }
    
    .icon-user-check:before {
      content: '\e8e5';
    }
    
    .icon-user-minus:before {
      content: '\e8e6';
    }
    
    .icon-user-plus:before {
      content: '\e8e7';
    }
    
    .icon-user-x:before {
      content: '\e8e8';
    }
    
    .icon-user:before {
      content: '\e8e9';
    }
    
    .icon-users:before {
      content: '\e8ea';
    }
    
    .icon-video-off:before {
      content: '\e8eb';
    }
    
    .icon-video:before {
      content: '\e8ec';
    }
    
    .icon-voicemail:before {
      content: '\e8ed';
    }
    
    .icon-volume-x:before {
      content: '\e8ee';
    }
    
    .icon-volume-2:before {
      content: '\e8ef';
    }
    
    .icon-volume-1:before {
      content: '\e8f0';
    }
    
    .icon-volume:before {
      content: '\e8f1';
    }
    
    .icon-watch:before {
      content: '\e8f2';
    }
    
    .icon-wifi:before {
      content: '\e8f3';
    }
    
    .icon-x-square:before {
      content: '\e8f4';
    }
    
    .icon-wind:before {
      content: '\e8f5';
    }
    
    .icon-x:before {
      content: '\e8f6';
    }
    
    .icon-x-circle:before {
      content: '\e8f7';
    }
    
    .icon-zap:before {
      content: '\e8f8';
    }
    
    .icon-zoom-in:before {
      content: '\e8f9';
    }
    
    .icon-zoom-out:before {
      content: '\e8fa';
    }
    
    .icon-command:before {
      content: '\e8fb';
    }
    
    .icon-cloud:before {
      content: '\e8fc';
    }
    
    .icon-hash:before {
      content: '\e8fd';
    }
    
    .icon-headphones:before {
      content: '\e8fe';
    }
    
    .icon-underline:before {
      content: '\e8ff';
    }
    
    .icon-italic:before {
      content: '\e900';
    }
    
    .icon-bold:before {
      content: '\e901';
    }
    
    .icon-crop:before {
      content: '\e902';
    }
    
    .icon-help-circle:before {
      content: '\e903';
    }
    
    .icon-paperclip:before {
      content: '\e904';
    }
    
    .icon-shopping-cart:before {
      content: '\e905';
    }
    
    .icon-tv:before {
      content: '\e906';
    }
    
    .icon-wifi-off:before {
      content: '\e907';
    }
    
    .icon-minimize:before {
      content: '\e88d';
    }
    
    .icon-maximize:before {
      content: '\e908';
    }
    
    .icon-gitlab:before {
      content: '\e909';
    }
    
    .icon-sliders:before {
      content: '\e90a';
    }
    
    .icon-star-on:before {
      content: '\e90b';
    }
    
    .icon-heart-on:before {
      content: '\e90c';
    }
    
    .icon-archive:before {
      content: '\e90d';
    }
    
    .icon-arrow-down-circle:before {
      content: '\e90e';
    }
    
    .icon-arrow-up-circle:before {
      content: '\e90f';
    }
    
    .icon-arrow-left-circle:before {
      content: '\e910';
    }
    
    .icon-arrow-right-circle:before {
      content: '\e911';
    }
    
    .icon-bar-chart-line-:before {
      content: '\e912';
    }
    
    .icon-bar-chart-line:before {
      content: '\e913';
    }
    
    .icon-book-open:before {
      content: '\e914';
    }
    
    .icon-code:before {
      content: '\e915';
    }
    
    .icon-database:before {
      content: '\e916';
    }
    
    .icon-dollar-sign:before {
      content: '\e917';
    }
    
    .icon-folder-plus:before {
      content: '\e918';
    }
    
    .icon-gift:before {
      content: '\e919';
    }
    
    .icon-folder-minus:before {
      content: '\e91a';
    }
    
    .icon-git-commit:before {
      content: '\e91b';
    }
    
    .icon-git-branch:before {
      content: '\e91c';
    }
    
    .icon-git-pull-request:before {
      content: '\e91d';
    }
    
    .icon-git-merge:before {
      content: '\e91e';
    }
    
    .icon-linkedin:before {
      content: '\e91f';
    }
    
    .icon-hard-drive:before {
      content: '\e920';
    }
    
    .icon-more-vertical-:before {
      content: '\e921';
    }
    
    .icon-more-horizontal-:before {
      content: '\e922';
    }
    
    .icon-rss:before {
      content: '\e923';
    }
    
    .icon-send:before {
      content: '\e924';
    }
    
    .icon-shield-off:before {
      content: '\e925';
    }
    
    .icon-shopping-bag:before {
      content: '\e926';
    }
    
    .icon-terminal:before {
      content: '\e927';
    }
    
    .icon-truck:before {
      content: '\e928';
    }
    
    .icon-zap-off:before {
      content: '\e929';
    }
    
    .icon-youtube:before {
      content: '\e92a';
    }
    
    @font-face {
      font-family: 'ezGolf';
      src:  url(/fonts/ezGolf.f35b9226.eot);
      src:  url(/fonts/ezGolf.f35b9226.eot#iefix) format('embedded-opentype'),
        url(/fonts/ezGolf.eaf2e88a.ttf) format('truetype'),
        url(/fonts/ezGolf.bc2c733b.woff) format('woff'),
        url(/img/ezGolf.6d63112e.svg#ezGolf) format('svg');
      font-weight: normal;
      font-style: normal;
      font-display: block;
    }
    
    [class^="ezGolf-icon-"], [class*=" ezGolf-icon-"] {
      /* use !important to prevent issues with browser extensions that change fonts */
      font-family: 'ezGolf' !important;
      speak: never;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
    
      /* Better Font Rendering =========== */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    
    .ezGolf-icon-golf-club:before {
      content: "\eac9";
      color: #5d5f65;
    }
    .ezGolf-icon-golf-practice:before {
      content: "\eaca";
      color: #5d5f65;
    }
    .ezGolf-icon-history:before {
      content: "\eacb";
      color: #5d5f65;
    }
    .ezGolf-icon-hotel:before {
      content: "\eacc";
      color: #5d5f65;
    }
    .ezGolf-icon-invoice:before {
      content: "\eacd";
      color: #5d5f65;
    }
    .ezGolf-icon-qrcode:before {
      content: "\eace";
      color: #5d5f65;
    }
    .ezGolf-icon-ticket:before {
      content: "\eacf";
      color: #5d5f65;
    }
    .ezGolf-icon-wallet:before {
      content: "\ead0";
      color: #5d5f65;
    }
    .ezGolf-icon-pants:before {
      content: "\ea2e";
      color: #5d5f65;
    }
    .ezGolf-icon-shirt:before {
      content: "\ea50";
      color: #5d5f65;
    }
    .ezGolf-icon-shoes:before {
      content: "\ea51";
      color: #5d5f65;
    }
    .ezGolf-icon-activity:before {
      content: "\e900";
      color: #5d5f65;
    }
    .ezGolf-icon-airplay:before {
      content: "\e901";
      color: #5d5f65;
    }
    .ezGolf-icon-alert-circle:before {
      content: "\e902";
      color: #5d5f65;
    }
    .ezGolf-icon-alert-octagon:before {
      content: "\e903";
      color: #5d5f65;
    }
    .ezGolf-icon-alert-triangle:before {
      content: "\e904";
      color: #5d5f65;
    }
    .ezGolf-icon-align-center:before {
      content: "\e905";
      color: #5d5f65;
    }
    .ezGolf-icon-align-justify:before {
      content: "\e906";
      color: #5d5f65;
    }
    .ezGolf-icon-align-left:before {
      content: "\e907";
      color: #5d5f65;
    }
    .ezGolf-icon-align-right:before {
      content: "\e908";
      color: #5d5f65;
    }
    .ezGolf-icon-anchor:before {
      content: "\e909";
      color: #5d5f65;
    }
    .ezGolf-icon-aperture:before {
      content: "\e90a";
      color: #5d5f65;
    }
    .ezGolf-icon-apps:before {
      content: "\e90b";
      color: #5d5f65;
    }
    .ezGolf-icon-archive:before {
      content: "\e90c";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-down:before {
      content: "\e90d";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-down-circle:before {
      content: "\e90e";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-down-left:before {
      content: "\e90f";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-down-right:before {
      content: "\e910";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-left:before {
      content: "\e911";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-left-circle:before {
      content: "\e912";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-right:before {
      content: "\e913";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-right-circle:before {
      content: "\e914";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-up:before {
      content: "\e915";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-up-circle:before {
      content: "\e916";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-up-left:before {
      content: "\e917";
      color: #5d5f65;
    }
    .ezGolf-icon-arrow-up-right:before {
      content: "\e918";
      color: #5d5f65;
    }
    .ezGolf-icon-at-sign:before {
      content: "\e919";
      color: #5d5f65;
    }
    .ezGolf-icon-award:before {
      content: "\e91a";
      color: #5d5f65;
    }
    .ezGolf-icon-bar-chart:before {
      content: "\e91b";
      color: #5d5f65;
    }
    .ezGolf-icon-bar-chart-2:before {
      content: "\e91c";
      color: #5d5f65;
    }
    .ezGolf-icon-battery:before {
      content: "\e91d";
      color: #5d5f65;
    }
    .ezGolf-icon-battery-charging:before {
      content: "\e91e";
      color: #5d5f65;
    }
    .ezGolf-icon-bell:before {
      content: "\e91f";
      color: #5d5f65;
    }
    .ezGolf-icon-bell-off:before {
      content: "\e920";
      color: #5d5f65;
    }
    .ezGolf-icon-bluetooth:before {
      content: "\e921";
      color: #5d5f65;
    }
    .ezGolf-icon-bold:before {
      content: "\e922";
      color: #5d5f65;
    }
    .ezGolf-icon-book:before {
      content: "\e923";
      color: #5d5f65;
    }
    .ezGolf-icon-bookmark:before {
      content: "\e924";
      color: #5d5f65;
    }
    .ezGolf-icon-book-open:before {
      content: "\e925";
      color: #5d5f65;
    }
    .ezGolf-icon-box:before {
      content: "\e926";
      color: #5d5f65;
    }
    .ezGolf-icon-briefcase:before {
      content: "\e927";
      color: #5d5f65;
    }
    .ezGolf-icon-cake:before {
      content: "\e928";
      color: #5d5f65;
    }
    .ezGolf-icon-calculate:before {
      content: "\e929";
      color: #5d5f65;
    }
    .ezGolf-icon-calendar:before {
      content: "\e92a";
      color: #5d5f65;
    }
    .ezGolf-icon-camera:before {
      content: "\e92b";
      color: #5d5f65;
    }
    .ezGolf-icon-camera-off:before {
      content: "\e92c";
      color: #5d5f65;
    }
    .ezGolf-icon-cast:before {
      content: "\e92d";
      color: #5d5f65;
    }
    .ezGolf-icon-chart-outlined:before {
      content: "\e92e";
      color: #5d5f65;
    }
    .ezGolf-icon-check:before {
      content: "\e92f";
      color: #5d5f65;
    }
    .ezGolf-icon-check-circle:before {
      content: "\e930";
      color: #5d5f65;
    }
    .ezGolf-icon-check-square:before {
      content: "\e931";
      color: #5d5f65;
    }
    .ezGolf-icon-chevron-down:before {
      content: "\e932";
      color: #5d5f65;
    }
    .ezGolf-icon-chevron-left:before {
      content: "\e933";
      color: #5d5f65;
    }
    .ezGolf-icon-chevron-right:before {
      content: "\e934";
      color: #5d5f65;
    }
    .ezGolf-icon-chevrons-down:before {
      content: "\e935";
      color: #5d5f65;
    }
    .ezGolf-icon-chevrons-left:before {
      content: "\e936";
      color: #5d5f65;
    }
    .ezGolf-icon-chevrons-right:before {
      content: "\e937";
      color: #5d5f65;
    }
    .ezGolf-icon-chevrons-up:before {
      content: "\e938";
      color: #5d5f65;
    }
    .ezGolf-icon-chevron-up:before {
      content: "\e939";
      color: #5d5f65;
    }
    .ezGolf-icon-circle:before {
      content: "\e93a";
      color: #5d5f65;
    }
    .ezGolf-icon-clock:before {
      content: "\e93b";
      color: #5d5f65;
    }
    .ezGolf-icon-cloud:before {
      content: "\e93c";
      color: #5d5f65;
    }
    .ezGolf-icon-cloud-drizzle:before {
      content: "\e93d";
      color: #5d5f65;
    }
    .ezGolf-icon-cloud-lightning:before {
      content: "\e93e";
      color: #5d5f65;
    }
    .ezGolf-icon-cloud-off:before {
      content: "\e93f";
      color: #5d5f65;
    }
    .ezGolf-icon-cloud-rain:before {
      content: "\e940";
      color: #5d5f65;
    }
    .ezGolf-icon-cloud-snow:before {
      content: "\e941";
      color: #5d5f65;
    }
    .ezGolf-icon-code:before {
      content: "\e942";
      color: #5d5f65;
    }
    .ezGolf-icon-Coffee:before {
      content: "\e943";
      color: #5d5f65;
    }
    .ezGolf-icon-contact-phone:before {
      content: "\e944";
      color: #5d5f65;
    }
    .ezGolf-icon-co-present:before {
      content: "\e945";
      color: #5d5f65;
    }
    .ezGolf-icon-copy:before {
      content: "\e946";
      color: #5d5f65;
    }
    .ezGolf-icon-corner-down-left:before {
      content: "\e947";
      color: #5d5f65;
    }
    .ezGolf-icon-corner-down-right:before {
      content: "\e948";
      color: #5d5f65;
    }
    .ezGolf-icon-corner-left-down:before {
      content: "\e949";
      color: #5d5f65;
    }
    .ezGolf-icon-corner-left-up:before {
      content: "\e94a";
      color: #5d5f65;
    }
    .ezGolf-icon-corner-right-down:before {
      content: "\e94b";
      color: #5d5f65;
    }
    .ezGolf-icon-corner-right-up:before {
      content: "\e94c";
      color: #5d5f65;
    }
    .ezGolf-icon-corner-up-left:before {
      content: "\e94d";
      color: #5d5f65;
    }
    .ezGolf-icon-corner-up-right:before {
      content: "\e94e";
      color: #5d5f65;
    }
    .ezGolf-icon-cpu:before {
      content: "\e94f";
      color: #5d5f65;
    }
    .ezGolf-icon-credit-card:before {
      content: "\e950";
      color: #5d5f65;
    }
    .ezGolf-icon-crop:before {
      content: "\e951";
      color: #5d5f65;
    }
    .ezGolf-icon-crosshair:before {
      content: "\e952";
      color: #5d5f65;
    }
    .ezGolf-icon-database:before {
      content: "\e953";
      color: #5d5f65;
    }
    .ezGolf-icon-delete:before {
      content: "\e954";
      color: #5d5f65;
    }
    .ezGolf-icon-diamond:before {
      content: "\e955";
      color: #5d5f65;
    }
    .ezGolf-icon-download:before {
      content: "\e956";
      color: #5d5f65;
    }
    .ezGolf-icon-download-cloud:before {
      content: "\e957";
      color: #5d5f65;
    }
    .ezGolf-icon-drag-vertical:before {
      content: "\e958";
      color: #5d5f65;
    }
    .ezGolf-icon-droplet:before {
      content: "\e959";
      color: #5d5f65;
    }
    .ezGolf-icon-edit:before {
      content: "\e95a";
      color: #5d5f65;
    }
    .ezGolf-icon-edit-2:before {
      content: "\e95b";
      color: #5d5f65;
    }
    .ezGolf-icon-edit-3:before {
      content: "\e95c";
      color: #5d5f65;
    }
    .ezGolf-icon-external-link:before {
      content: "\e95d";
      color: #5d5f65;
    }
    .ezGolf-icon-eye:before {
      content: "\e95e";
      color: #5d5f65;
    }
    .ezGolf-icon-facebook:before {
      content: "\e95f";
      color: #5d5f65;
    }
    .ezGolf-icon-facebook-1:before {
      content: "\e960";
      color: #3b5998;
    }
    .ezGolf-icon-fast-forward:before {
      content: "\e961";
      color: #5d5f65;
    }
    .ezGolf-icon-feather:before {
      content: "\e962";
      color: #5d5f65;
    }
    .ezGolf-icon-female:before {
      content: "\e963";
      color: #5d5f65;
    }
    .ezGolf-icon-file:before {
      content: "\e964";
      color: #5d5f65;
    }
    .ezGolf-icon-file-minus:before {
      content: "\e965";
      color: #5d5f65;
    }
    .ezGolf-icon-file-plus:before {
      content: "\e966";
      color: #5d5f65;
    }
    .ezGolf-icon-file-text:before {
      content: "\e967";
      color: #5d5f65;
    }
    .ezGolf-icon-film:before {
      content: "\e968";
      color: #5d5f65;
    }
    .ezGolf-icon-filter:before {
      content: "\e969";
      color: #5d5f65;
    }
    .ezGolf-icon-fitness-center:before {
      content: "\e96a";
      color: #5d5f65;
    }
    .ezGolf-icon-flag:before {
      content: "\e96b";
      color: #5d5f65;
    }
    .ezGolf-icon-flag-for-cambodia .path1:before {
      content: "\e96c";
      color: rgb(237, 76, 92);
    }
    .ezGolf-icon-flag-for-cambodia .path2:before {
      content: "\e96d";
      color: rgb(42, 95, 158);
    }
    [dir=ltr] .ezGolf-icon-flag-for-cambodia .path2:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-cambodia .path2:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-cambodia .path3:before {
      content: "\e96e";
      color: rgb(42, 95, 158);
    }
    [dir=ltr] .ezGolf-icon-flag-for-cambodia .path3:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-cambodia .path3:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-cambodia .path4:before {
      content: "\e96f";
      color: rgb(226, 226, 226);
    }
    [dir=ltr] .ezGolf-icon-flag-for-cambodia .path4:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-cambodia .path4:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-cambodia .path5:before {
      content: "\e970";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-cambodia .path5:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-cambodia .path5:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-cambodia .path6:before {
      content: "\e971";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-cambodia .path6:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-cambodia .path6:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-cambodia .path7:before {
      content: "\e972";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-cambodia .path7:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-cambodia .path7:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-cambodia .path8:before {
      content: "\e973";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-cambodia .path8:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-cambodia .path8:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-china .path1:before {
      content: "\e974";
      color: rgb(237, 76, 92);
    }
    .ezGolf-icon-flag-for-china .path2:before {
      content: "\e975";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-china .path2:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-china .path2:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-china .path3:before {
      content: "\e976";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-china .path3:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-china .path3:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-china .path4:before {
      content: "\e977";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-china .path4:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-china .path4:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-china .path5:before {
      content: "\e978";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-china .path5:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-china .path5:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-china .path6:before {
      content: "\e979";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-china .path6:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-china .path6:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path1:before {
      content: "\e97a";
      color: rgb(237, 76, 92);
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path2:before {
      content: "\e97b";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-hong-kong-sar-china .path2:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-hong-kong-sar-china .path2:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path3:before {
      content: "\e97c";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-hong-kong-sar-china .path3:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-hong-kong-sar-china .path3:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path4:before {
      content: "\e97d";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-hong-kong-sar-china .path4:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-hong-kong-sar-china .path4:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path5:before {
      content: "\e97e";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-hong-kong-sar-china .path5:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-hong-kong-sar-china .path5:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path6:before {
      content: "\e97f";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-hong-kong-sar-china .path6:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-hong-kong-sar-china .path6:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path7:before {
      content: "\e980";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-hong-kong-sar-china .path7:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-hong-kong-sar-china .path7:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path8:before {
      content: "\e981";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-hong-kong-sar-china .path8:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-hong-kong-sar-china .path8:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path9:before {
      content: "\e982";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-hong-kong-sar-china .path9:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-hong-kong-sar-china .path9:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path10:before {
      content: "\e983";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-hong-kong-sar-china .path10:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-hong-kong-sar-china .path10:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-hong-kong-sar-china .path11:before {
      content: "\e984";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-hong-kong-sar-china .path11:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-hong-kong-sar-china .path11:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path1:before {
      content: "\e985";
      color: rgb(105, 150, 53);
    }
    .ezGolf-icon-flag-for-portugal .path2:before {
      content: "\e986";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path2:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path2:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path3:before {
      content: "\e987";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path3:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path3:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path4:before {
      content: "\e988";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path4:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path4:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path5:before {
      content: "\e989";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path5:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path5:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path6:before {
      content: "\e98a";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path6:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path6:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path7:before {
      content: "\e98b";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path7:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path7:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path8:before {
      content: "\e98c";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path8:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path8:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path9:before {
      content: "\e98d";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path9:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path9:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path10:before {
      content: "\e98e";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path10:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path10:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path11:before {
      content: "\e98f";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path11:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path11:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path12:before {
      content: "\e990";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path12:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path12:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path13:before {
      content: "\e991";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path13:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path13:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path14:before {
      content: "\e992";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path14:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path14:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path15:before {
      content: "\e993";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path15:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path15:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path16:before {
      content: "\e994";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path16:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path16:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path17:before {
      content: "\e995";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path17:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path17:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path18:before {
      content: "\e996";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path18:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path18:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path19:before {
      content: "\e997";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path19:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path19:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path20:before {
      content: "\e998";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path20:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path20:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path21:before {
      content: "\e999";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path21:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path21:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path22:before {
      content: "\e99a";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path22:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path22:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path23:before {
      content: "\e99b";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path23:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path23:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path24:before {
      content: "\e99c";
      color: rgb(0, 113, 188);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path24:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path24:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path25:before {
      content: "\e99d";
      color: rgb(0, 113, 188);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path25:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path25:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path26:before {
      content: "\e99e";
      color: rgb(0, 113, 188);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path26:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path26:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path27:before {
      content: "\e99f";
      color: rgb(0, 113, 188);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path27:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path27:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path28:before {
      content: "\e9a0";
      color: rgb(0, 113, 188);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path28:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path28:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path29:before {
      content: "\e9a1";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path29:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path29:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path30:before {
      content: "\e9a2";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path30:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path30:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path31:before {
      content: "\e9a3";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path31:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path31:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path32:before {
      content: "\e9a4";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path32:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path32:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path33:before {
      content: "\e9a5";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path33:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path33:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path34:before {
      content: "\e9a6";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path34:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path34:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path35:before {
      content: "\e9a7";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path35:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path35:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path36:before {
      content: "\e9a8";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path36:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path36:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path37:before {
      content: "\e9a9";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path37:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path37:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path38:before {
      content: "\e9aa";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path38:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path38:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path39:before {
      content: "\e9ab";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path39:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path39:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path40:before {
      content: "\e9ac";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path40:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path40:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path41:before {
      content: "\e9ad";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path41:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path41:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path42:before {
      content: "\e9ae";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path42:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path42:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path43:before {
      content: "\e9af";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path43:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path43:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path44:before {
      content: "\e9b0";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path44:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path44:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path45:before {
      content: "\e9b1";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path45:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path45:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path46:before {
      content: "\e9b2";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path46:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path46:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path47:before {
      content: "\e9b3";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path47:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path47:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path48:before {
      content: "\e9b4";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path48:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path48:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path49:before {
      content: "\e9b5";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path49:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path49:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path50:before {
      content: "\e9b6";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path50:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path50:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path51:before {
      content: "\e9b7";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path51:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path51:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path52:before {
      content: "\e9b8";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path52:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path52:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path53:before {
      content: "\e9b9";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path53:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path53:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path54:before {
      content: "\e9ba";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path54:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path54:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path55:before {
      content: "\e9bb";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path55:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path55:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path56:before {
      content: "\e9bc";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path56:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path56:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path57:before {
      content: "\e9bd";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path57:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path57:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path58:before {
      content: "\e9be";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path58:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path58:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path59:before {
      content: "\e9bf";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path59:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path59:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path60:before {
      content: "\e9c0";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path60:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path60:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path61:before {
      content: "\e9c1";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path61:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path61:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path62:before {
      content: "\e9c2";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path62:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path62:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path63:before {
      content: "\e9c3";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path63:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path63:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path64:before {
      content: "\e9c4";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path64:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path64:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path65:before {
      content: "\e9c5";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path65:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path65:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path66:before {
      content: "\e9c6";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path66:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path66:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path67:before {
      content: "\e9c7";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path67:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path67:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path68:before {
      content: "\e9c8";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path68:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path68:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path69:before {
      content: "\e9c9";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path69:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path69:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path70:before {
      content: "\e9ca";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path70:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path70:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path71:before {
      content: "\e9cb";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path71:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path71:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path72:before {
      content: "\e9cc";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path72:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path72:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-portugal .path73:before {
      content: "\e9cd";
      color: rgb(62, 67, 71);
    }
    [dir=ltr] .ezGolf-icon-flag-for-portugal .path73:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-portugal .path73:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-russia .path1:before {
      content: "\e9ce";
      color: rgb(237, 76, 92);
    }
    .ezGolf-icon-flag-for-russia .path2:before {
      content: "\e9cf";
      color: rgb(66, 139, 193);
    }
    [dir=ltr] .ezGolf-icon-flag-for-russia .path2:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-russia .path2:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-russia .path3:before {
      content: "\e9d0";
      color: rgb(249, 249, 249);
    }
    [dir=ltr] .ezGolf-icon-flag-for-russia .path3:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-russia .path3:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path1:before {
      content: "\e9d1";
      color: rgb(255, 255, 255);
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path2:before {
      content: "\e9d2";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path2:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path2:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path3:before {
      content: "\e9d3";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path3:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path3:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path4:before {
      content: "\e9d4";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path4:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path4:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path5:before {
      content: "\e9d5";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path5:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path5:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path6:before {
      content: "\e9d6";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path6:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path6:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path7:before {
      content: "\e9d7";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path7:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path7:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path8:before {
      content: "\e9d8";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path8:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path8:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path9:before {
      content: "\e9d9";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path9:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path9:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path10:before {
      content: "\e9da";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path10:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path10:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path11:before {
      content: "\e9db";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path11:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path11:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path12:before {
      content: "\e9dc";
      color: rgb(237, 76, 92);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path12:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path12:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path13:before {
      content: "\e9dd";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path13:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path13:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path14:before {
      content: "\e9de";
      color: rgb(66, 139, 193);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path14:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path14:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path15:before {
      content: "\e9df";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path15:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path15:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path16:before {
      content: "\e9e0";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path16:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path16:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path17:before {
      content: "\e9e1";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path17:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path17:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path18:before {
      content: "\e9e2";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path18:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path18:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path19:before {
      content: "\e9e3";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path19:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path19:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path20:before {
      content: "\e9e4";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path20:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path20:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path21:before {
      content: "\e9e5";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path21:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path21:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path22:before {
      content: "\e9e6";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path22:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path22:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path23:before {
      content: "\e9e7";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path23:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path23:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path24:before {
      content: "\e9e8";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path24:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path24:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path25:before {
      content: "\e9e9";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path25:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path25:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path26:before {
      content: "\e9ea";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path26:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path26:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path27:before {
      content: "\e9eb";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path27:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path27:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-us-outlying-islands .path28:before {
      content: "\e9ec";
      color: rgb(255, 255, 255);
    }
    [dir=ltr] .ezGolf-icon-flag-for-us-outlying-islands .path28:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-us-outlying-islands .path28:before {
      margin-right: -1em;
    }
    .ezGolf-icon-flag-for-vietnam .path1:before {
      content: "\e9ed";
      color: rgb(244, 47, 76);
    }
    .ezGolf-icon-flag-for-vietnam .path2:before {
      content: "\e9ee";
      color: rgb(255, 230, 46);
    }
    [dir=ltr] .ezGolf-icon-flag-for-vietnam .path2:before {
      margin-left: -1em;
    }
    [dir=rtl] .ezGolf-icon-flag-for-vietnam .path2:before {
      margin-right: -1em;
    }
    .ezGolf-icon-FO:before {
      content: "\e9ef";
      color: #5d5f65;
    }
    .ezGolf-icon-folder:before {
      content: "\e9f0";
      color: #5d5f65;
    }
    .ezGolf-icon-folder-minus:before {
      content: "\e9f1";
      color: #5d5f65;
    }
    .ezGolf-icon-folder-plus:before {
      content: "\e9f2";
      color: #5d5f65;
    }
    .ezGolf-icon-gift:before {
      content: "\e9f3";
      color: #5d5f65;
    }
    .ezGolf-icon-git-commit:before {
      content: "\e9f4";
      color: #5d5f65;
    }
    .ezGolf-icon-github:before {
      content: "\e9f5";
      color: #5d5f65;
    }
    .ezGolf-icon-github-1:before {
      content: "\e9f6";
    }
    .ezGolf-icon-gitlab:before {
      content: "\e9f7";
      color: #5d5f65;
    }
    .ezGolf-icon-golf-bag:before {
      content: "\e9f8";
      color: #5d5f65;
    }
    .ezGolf-icon-golf-course:before {
      content: "\e9f9";
      color: #5d5f65;
    }
    .ezGolf-icon-golf-tee:before {
      content: "\e9fa";
      color: #5d5f65;
    }
    .ezGolf-icon-google:before {
      content: "\e9fb";
      color: #db3236;
    }
    .ezGolf-icon-grid:before {
      content: "\e9fc";
      color: #5d5f65;
    }
    .ezGolf-icon-hard-drive:before {
      content: "\e9fd";
      color: #5d5f65;
    }
    .ezGolf-icon-hash:before {
      content: "\e9fe";
      color: #5d5f65;
    }
    .ezGolf-icon-heart:before {
      content: "\e9ff";
      color: #5d5f65;
    }
    .ezGolf-icon-heart-fill:before {
      content: "\ea00";
      color: #5d5f65;
    }
    .ezGolf-icon-help-circle:before {
      content: "\ea01";
      color: #5d5f65;
    }
    .ezGolf-icon-home:before {
      content: "\ea02";
      color: #5d5f65;
    }
    .ezGolf-icon-image:before {
      content: "\ea03";
      color: #5d5f65;
    }
    .ezGolf-icon-inbox:before {
      content: "\ea04";
      color: #5d5f65;
    }
    .ezGolf-icon-info:before {
      content: "\ea05";
      color: #5d5f65;
    }
    .ezGolf-icon-instagram-1:before {
      content: "\ea06";
      color: #3f729b;
    }
    .ezGolf-icon-italic:before {
      content: "\ea07";
      color: #5d5f65;
    }
    .ezGolf-icon-layers:before {
      content: "\ea08";
      color: #5d5f65;
    }
    .ezGolf-icon-layout:before {
      content: "\ea09";
      color: #5d5f65;
    }
    .ezGolf-icon-link:before {
      content: "\ea0a";
      color: #5d5f65;
    }
    .ezGolf-icon-link-2:before {
      content: "\ea0b";
      color: #5d5f65;
    }
    .ezGolf-icon-linkedin-1:before {
      content: "\ea0c";
      color: #0e76a8;
    }
    .ezGolf-icon-list:before {
      content: "\ea0d";
      color: #5d5f65;
    }
    .ezGolf-icon-loader:before {
      content: "\ea0e";
      color: #5d5f65;
    }
    .ezGolf-icon-lock:before {
      content: "\ea0f";
      color: #5d5f65;
    }
    .ezGolf-icon-locker:before {
      content: "\ea10";
      color: #5d5f65;
    }
    .ezGolf-icon-log-in:before {
      content: "\ea11";
      color: #5d5f65;
    }
    .ezGolf-icon-log-out:before {
      content: "\ea12";
      color: #5d5f65;
    }
    .ezGolf-icon-mail:before {
      content: "\ea13";
      color: #5d5f65;
    }
    .ezGolf-icon-male:before {
      content: "\ea14";
      color: #5d5f65;
    }
    .ezGolf-icon-map:before {
      content: "\ea15";
      color: #5d5f65;
    }
    .ezGolf-icon-maximize:before {
      content: "\ea16";
      color: #5d5f65;
    }
    .ezGolf-icon-maximize-2:before {
      content: "\ea17";
      color: #5d5f65;
    }
    .ezGolf-icon-menu:before {
      content: "\ea18";
      color: #5d5f65;
    }
    .ezGolf-icon-message-circle:before {
      content: "\ea19";
      color: #5d5f65;
    }
    .ezGolf-icon-message-square:before {
      content: "\ea1a";
      color: #5d5f65;
    }
    .ezGolf-icon-mic:before {
      content: "\ea1b";
      color: #5d5f65;
    }
    .ezGolf-icon-mic-off:before {
      content: "\ea1c";
      color: #5d5f65;
    }
    .ezGolf-icon-military-tech:before {
      content: "\ea1d";
      color: #5d5f65;
    }
    .ezGolf-icon-minimize:before {
      content: "\ea1e";
      color: #5d5f65;
    }
    .ezGolf-icon-minimize-2:before {
      content: "\ea1f";
      color: #5d5f65;
    }
    .ezGolf-icon-minus:before {
      content: "\ea20";
      color: #5d5f65;
    }
    .ezGolf-icon-minus-circle:before {
      content: "\ea21";
      color: #5d5f65;
    }
    .ezGolf-icon-minus-square:before {
      content: "\ea22";
      color: #5d5f65;
    }
    .ezGolf-icon-monitor:before {
      content: "\ea23";
      color: #5d5f65;
    }
    .ezGolf-icon-moon:before {
      content: "\ea24";
      color: #5d5f65;
    }
    .ezGolf-icon-more-horizontal:before {
      content: "\ea25";
      color: #5d5f65;
    }
    .ezGolf-icon-more-vertical:before {
      content: "\ea26";
      color: #5d5f65;
    }
    .ezGolf-icon-move:before {
      content: "\ea27";
      color: #5d5f65;
    }
    .ezGolf-icon-navigation:before {
      content: "\ea28";
      color: #5d5f65;
    }
    .ezGolf-icon-navigation-2:before {
      content: "\ea29";
      color: #5d5f65;
    }
    .ezGolf-icon-note:before {
      content: "\ea2a";
      color: #5d5f65;
    }
    .ezGolf-icon-octagon:before {
      content: "\ea2b";
      color: #5d5f65;
    }
    .ezGolf-icon-other-gender:before {
      content: "\ea2c";
      color: #5d5f65;
    }
    .ezGolf-icon-package:before {
      content: "\ea2d";
      color: #5d5f65;
    }
    .ezGolf-icon-paperclip:before {
      content: "\ea2f";
      color: #5d5f65;
    }
    .ezGolf-icon-pause:before {
      content: "\ea30";
      color: #5d5f65;
    }
    .ezGolf-icon-pause-circle:before {
      content: "\ea31";
      color: #5d5f65;
    }
    .ezGolf-icon-phone:before {
      content: "\ea32";
      color: #5d5f65;
    }
    .ezGolf-icon-phone-call:before {
      content: "\ea33";
      color: #5d5f65;
    }
    .ezGolf-icon-phone-forwarded:before {
      content: "\ea34";
      color: #5d5f65;
    }
    .ezGolf-icon-phone-incoming:before {
      content: "\ea35";
      color: #5d5f65;
    }
    .ezGolf-icon-phone-missed:before {
      content: "\ea36";
      color: #5d5f65;
    }
    .ezGolf-icon-phone-outgoing:before {
      content: "\ea37";
      color: #5d5f65;
    }
    .ezGolf-icon-place:before {
      content: "\ea38";
      color: #5d5f65;
    }
    .ezGolf-icon-play:before {
      content: "\ea39";
      color: #5d5f65;
    }
    .ezGolf-icon-plus:before {
      content: "\ea3a";
      color: #5d5f65;
    }
    .ezGolf-icon-plus-circle:before {
      content: "\ea3b";
      color: #5d5f65;
    }
    .ezGolf-icon-plus-square:before {
      content: "\ea3c";
      color: #5d5f65;
    }
    .ezGolf-icon-pocket:before {
      content: "\ea3d";
      color: #5d5f65;
    }
    .ezGolf-icon-power:before {
      content: "\ea3e";
      color: #5d5f65;
    }
    .ezGolf-icon-printer:before {
      content: "\ea3f";
      color: #5d5f65;
    }
    .ezGolf-icon-radio:before {
      content: "\ea40";
      color: #5d5f65;
    }
    .ezGolf-icon-refresh-ccw:before {
      content: "\ea41";
      color: #5d5f65;
    }
    .ezGolf-icon-refresh-cw:before {
      content: "\ea42";
      color: #5d5f65;
    }
    .ezGolf-icon-repeat:before {
      content: "\ea43";
      color: #5d5f65;
    }
    .ezGolf-icon-Restaurant:before {
      content: "\ea44";
      color: #5d5f65;
    }
    .ezGolf-icon-rewind:before {
      content: "\ea45";
      color: #5d5f65;
    }
    .ezGolf-icon-rotate-ccw:before {
      content: "\ea46";
      color: #5d5f65;
    }
    .ezGolf-icon-rotate-cw:before {
      content: "\ea47";
      color: #5d5f65;
    }
    .ezGolf-icon-rss:before {
      content: "\ea48";
      color: #5d5f65;
    }
    .ezGolf-icon-save:before {
      content: "\ea49";
      color: #5d5f65;
    }
    .ezGolf-icon-scissors:before {
      content: "\ea4a";
      color: #5d5f65;
    }
    .ezGolf-icon-search:before {
      content: "\ea4b";
      color: #5d5f65;
    }
    .ezGolf-icon-server:before {
      content: "\ea4c";
      color: #5d5f65;
    }
    .ezGolf-icon-settings:before {
      content: "\ea4d";
      color: #5d5f65;
    }
    .ezGolf-icon-shield:before {
      content: "\ea4e";
      color: #5d5f65;
    }
    .ezGolf-icon-shield-off:before {
      content: "\ea4f";
      color: #5d5f65;
    }
    .ezGolf-icon-shopping-bag:before {
      content: "\ea52";
      color: #5d5f65;
    }
    .ezGolf-icon-shopping-cart:before {
      content: "\ea53";
      color: #5d5f65;
    }
    .ezGolf-icon-shuffle:before {
      content: "\ea54";
      color: #5d5f65;
    }
    .ezGolf-icon-sidebar:before {
      content: "\ea55";
      color: #5d5f65;
    }
    .ezGolf-icon-skip-back:before {
      content: "\ea56";
      color: #5d5f65;
    }
    .ezGolf-icon-skip-forward:before {
      content: "\ea57";
      color: #5d5f65;
    }
    .ezGolf-icon-slash:before {
      content: "\ea58";
      color: #5d5f65;
    }
    .ezGolf-icon-sliders:before {
      content: "\ea59";
      color: #5d5f65;
    }
    .ezGolf-icon-smartphone:before {
      content: "\ea5a";
      color: #5d5f65;
    }
    .ezGolf-icon-square:before {
      content: "\ea5b";
      color: #5d5f65;
    }
    .ezGolf-icon-star:before {
      content: "\ea5c";
      color: #5d5f65;
    }
    .ezGolf-icon-star-fill:before {
      content: "\ea5d";
      color: #5d5f65;
    }
    .ezGolf-icon-store:before {
      content: "\ea5e";
      color: #5d5f65;
    }
    .ezGolf-icon-straighten:before {
      content: "\ea5f";
      color: #5d5f65;
    }
    .ezGolf-icon-sunrise:before {
      content: "\ea60";
      color: #5d5f65;
    }
    .ezGolf-icon-sunset:before {
      content: "\ea61";
      color: #5d5f65;
    }
    .ezGolf-icon-system-update:before {
      content: "\ea62";
      color: #5d5f65;
    }
    .ezGolf-icon-table-bar:before {
      content: "\ea63";
      color: #5d5f65;
    }
    .ezGolf-icon-tablet:before {
      content: "\ea64";
      color: #5d5f65;
    }
    .ezGolf-icon-tag:before {
      content: "\ea65";
      color: #5d5f65;
    }
    .ezGolf-icon-terminal:before {
      content: "\ea66";
      color: #5d5f65;
    }
    .ezGolf-icon-text-snippet:before {
      content: "\ea67";
      color: #5d5f65;
    }
    .ezGolf-icon-thermometer:before {
      content: "\ea68";
      color: #5d5f65;
    }
    .ezGolf-icon-thumbs-down:before {
      content: "\ea69";
      color: #5d5f65;
    }
    .ezGolf-icon-thumbs-up:before {
      content: "\ea6a";
      color: #5d5f65;
    }
    .ezGolf-icon-traffic:before {
      content: "\ea6b";
      color: #5d5f65;
    }
    .ezGolf-icon-trending-down:before {
      content: "\ea6c";
      color: #5d5f65;
    }
    .ezGolf-icon-trending-up:before {
      content: "\ea6d";
      color: #5d5f65;
    }
    .ezGolf-icon-triangle:before {
      content: "\ea6e";
      color: #5d5f65;
    }
    .ezGolf-icon-truck:before {
      content: "\ea6f";
      color: #5d5f65;
    }
    .ezGolf-icon-tv:before {
      content: "\ea70";
      color: #5d5f65;
    }
    .ezGolf-icon-twitter:before {
      content: "\ea71";
      color: #5d5f65;
    }
    .ezGolf-icon-twitter-1:before {
      content: "\ea72";
      color: #00acee;
    }
    .ezGolf-icon-type:before {
      content: "\ea73";
      color: #5d5f65;
    }
    .ezGolf-icon-umbrella:before {
      content: "\ea74";
      color: #5d5f65;
    }
    .ezGolf-icon-underline:before {
      content: "\ea75";
      color: #5d5f65;
    }
    .ezGolf-icon-unlock:before {
      content: "\ea76";
      color: #5d5f65;
    }
    .ezGolf-icon-upload:before {
      content: "\ea77";
      color: #5d5f65;
    }
    .ezGolf-icon-upload-cloud:before {
      content: "\ea78";
      color: #5d5f65;
    }
    .ezGolf-icon-video:before {
      content: "\ea79";
      color: #5d5f65;
    }
    .ezGolf-icon-video-off:before {
      content: "\ea7a";
      color: #5d5f65;
    }
    .ezGolf-icon-voicemail:before {
      content: "\ea7b";
      color: #5d5f65;
    }
    .ezGolf-icon-volume:before {
      content: "\ea7c";
      color: #5d5f65;
    }
    .ezGolf-icon-volume-1:before {
      content: "\ea7d";
      color: #5d5f65;
    }
    .ezGolf-icon-volume-2:before {
      content: "\ea7e";
      color: #5d5f65;
    }
    .ezGolf-icon-volume-x:before {
      content: "\ea7f";
      color: #5d5f65;
    }
    .ezGolf-icon-watch:before {
      content: "\ea80";
      color: #5d5f65;
    }
    .ezGolf-icon-water-drop:before {
      content: "\ea81";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-cloudy:before {
      content: "\ea82";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-drizzle:before {
      content: "\ea83";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-fog:before {
      content: "\ea84";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-hail-day:before {
      content: "\ea85";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-hail-night:before {
      content: "\ea86";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-haze:before {
      content: "\ea87";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-moon:before {
      content: "\ea88";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-partly-cloudy-day:before {
      content: "\ea89";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-partly-cloudy-night:before {
      content: "\ea8a";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-rain:before {
      content: "\ea8b";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-rain-showers-day:before {
      content: "\ea8c";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-rain-showers-night:before {
      content: "\ea8d";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-rain-snow:before {
      content: "\ea8e";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-snow:before {
      content: "\ea8f";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-snow-shower-day:before {
      content: "\ea90";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-snow-shower-night:before {
      content: "\ea91";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-sunny:before {
      content: "\ea92";
      color: #5d5f65;
    }
    .ezGolf-icon-weather-thunderstorm:before {
      content: "\ea93";
      color: #5d5f65;
    }
    .ezGolf-icon-whistle-outline:before {
      content: "\ea94";
      color: #5d5f65;
    }
    .ezGolf-icon-wifi:before {
      content: "\ea95";
      color: #5d5f65;
    }
    .ezGolf-icon-wifi-off:before {
      content: "\ea96";
      color: #5d5f65;
    }
    .ezGolf-icon-wind:before {
      content: "\ea97";
      color: #5d5f65;
    }
    .ezGolf-icon-wine-bar:before {
      content: "\ea98";
      color: #5d5f65;
    }
    .ezGolf-icon-x:before {
      content: "\ea99";
      color: #5d5f65;
    }
    .ezGolf-icon-x-circle:before {
      content: "\ea9a";
      color: #5d5f65;
    }
    .ezGolf-icon-x-square:before {
      content: "\ea9b";
      color: #5d5f65;
    }
    .ezGolf-icon-zap:before {
      content: "\ea9c";
      color: #5d5f65;
    }
    .ezGolf-icon-zap-off:before {
      content: "\ea9d";
      color: #5d5f65;
    }
    .ezGolf-icon-zoom-in:before {
      content: "\ea9e";
      color: #5d5f65;
    }
    .ezGolf-icon-zoom-out:before {
      content: "\ea9f";
      color: #5d5f65;
    }
    .ezGolf-icon-chrome:before {
      content: "\eaa0";
      color: #5d5f65;
    }
    .ezGolf-icon-clipboard:before {
      content: "\eaa1";
      color: #5d5f65;
    }
    .ezGolf-icon-codepen:before {
      content: "\eaa2";
      color: #5d5f65;
    }
    .ezGolf-icon-command:before {
      content: "\eaa3";
      color: #5d5f65;
    }
    .ezGolf-icon-compass:before {
      content: "\eaa4";
      color: #5d5f65;
    }
    .ezGolf-icon-disc:before {
      content: "\eaa5";
      color: #5d5f65;
    }
    .ezGolf-icon-dollar-sign:before {
      content: "\eaa6";
      color: #5d5f65;
    }
    .ezGolf-icon-eye-off:before {
      content: "\eaa7";
      color: #5d5f65;
    }
    .ezGolf-icon-git-branch:before {
      content: "\eaa8";
      color: #5d5f65;
    }
    .ezGolf-icon-git-merge:before {
      content: "\eaa9";
      color: #5d5f65;
    }
    .ezGolf-icon-git-pull-request:before {
      content: "\eaaa";
      color: #5d5f65;
    }
    .ezGolf-icon-globe:before {
      content: "\eaab";
      color: #5d5f65;
    }
    .ezGolf-icon-headphones:before {
      content: "\eaac";
      color: #5d5f65;
    }
    .ezGolf-icon-instagram:before {
      content: "\eaad";
      color: #5d5f65;
    }
    .ezGolf-icon-life-buoy:before {
      content: "\eaae";
      color: #5d5f65;
    }
    .ezGolf-icon-linkedin:before {
      content: "\eaaf";
      color: #5d5f65;
    }
    .ezGolf-icon-map-pin:before {
      content: "\eab0";
      color: #5d5f65;
    }
    .ezGolf-icon-music:before {
      content: "\eab1";
      color: #5d5f65;
    }
    .ezGolf-icon-percent:before {
      content: "\eab2";
      color: #5d5f65;
    }
    .ezGolf-icon-phone-off:before {
      content: "\eab3";
      color: #5d5f65;
    }
    .ezGolf-icon-pie-chart:before {
      content: "\eab4";
      color: #5d5f65;
    }
    .ezGolf-icon-play-circle:before {
      content: "\eab5";
      color: #5d5f65;
    }
    .ezGolf-icon-send:before {
      content: "\eab6";
      color: #5d5f65;
    }
    .ezGolf-icon-share:before {
      content: "\eab7";
      color: #5d5f65;
    }
    .ezGolf-icon-share-2:before {
      content: "\eab8";
      color: #5d5f65;
    }
    .ezGolf-icon-slack:before {
      content: "\eab9";
      color: #5d5f65;
    }
    .ezGolf-icon-speaker:before {
      content: "\eaba";
      color: #5d5f65;
    }
    .ezGolf-icon-stop-circle:before {
      content: "\eabb";
      color: #5d5f65;
    }
    .ezGolf-icon-sun:before {
      content: "\eabc";
      color: #5d5f65;
    }
    .ezGolf-icon-target:before {
      content: "\eabd";
      color: #5d5f65;
    }
    .ezGolf-icon-toggle-left:before {
      content: "\eabe";
      color: #5d5f65;
    }
    .ezGolf-icon-toggle-right:before {
      content: "\eabf";
      color: #5d5f65;
    }
    .ezGolf-icon-trash:before {
      content: "\eac0";
      color: #5d5f65;
    }
    .ezGolf-icon-trash-2:before {
      content: "\eac1";
      color: #5d5f65;
    }
    .ezGolf-icon-user:before {
      content: "\eac2";
      color: #5d5f65;
    }
    .ezGolf-icon-user-check:before {
      content: "\eac3";
      color: #5d5f65;
    }
    .ezGolf-icon-user-minus:before {
      content: "\eac4";
      color: #5d5f65;
    }
    .ezGolf-icon-user-plus:before {
      content: "\eac5";
      color: #5d5f65;
    }
    .ezGolf-icon-users:before {
      content: "\eac6";
      color: #5d5f65;
    }
    .ezGolf-icon-user-x:before {
      content: "\eac7";
      color: #5d5f65;
    }
    .ezGolf-icon-youtube:before {
      content: "\eac8";
      color: #5d5f65;
    }
    
    @charset "UTF-8";
    :root {
      --blue: #0D6EFD;
      --indigo: #6610f2;
      --purple: #7367F0;
      --pink: #D63384;
      --red: #EA5455;
      --orange: #FD7E14;
      --yellow: #FF9F43;
      --green: #28C76F;
      --teal: #20c997;
      --cyan: #00CFE8;
      --white: #fff;
      --gray: #b8c2cc;
      --gray-dark: #1e1e1e;
      --primary: #114A9F;
      --secondary: #9C9EA4;
      --success: #17B75E;
      --info: #00CFE8;
      --warning: #FDB913;
      --danger: #EA5455;
      --light: #C1C1C1;
      --dark: #4B4B4B;
      --breakpoint-xs: 0;
      --breakpoint-sm: 576px;
      --breakpoint-md: 768px;
      --breakpoint-lg: 992px;
      --breakpoint-xl: 1200px;
      --font-family-sans-serif: "Roboto", Helvetica, Arial, serif;
      --font-family-monospace: "Roboto", Helvetica, Arial, serif;
    }
    
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }
    
    html {
      font-family: sans-serif;
      line-height: 1.15;
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(34, 41, 47, 0);
    }
    
    article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
      display: block;
    }
    
    body {
      font-family: "Roboto", Helvetica, Arial, serif;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.45;
      color: #424244;
    }
    
     body {
      margin: 0;
      background-color: #f8f8f8;
    }
    
    [dir=ltr] body {
      text-align: left;
    }
    
    [dir=rtl] body {
      text-align: right;
    }
    
    [tabindex="-1"]:focus:not(:focus-visible) {
      outline: 0 !important;
    }
    
    hr {
      box-sizing: content-box;
      height: 0;
      overflow: visible;
    }
    
     h1,  h2,  h3,  h4,  h5,  h6 {
      margin-top: 0;
      margin-bottom: 0.5rem;
    }
    
     p {
      margin-top: 0;
      margin-bottom: 1rem;
    }
    
    abbr[title],
    abbr[data-original-title] {
      text-decoration: underline;
      text-decoration: underline dotted;
      text-decoration-skip-ink: none;
    }
    
     abbr[title],  abbr[data-original-title] {
      cursor: help;
      border-bottom: 0;
    }
    
    address {
      font-style: normal;
      line-height: inherit;
    }
    
     address {
      margin-bottom: 1rem;
    }
    
     ol,  ul,  dl {
      margin-top: 0;
      margin-bottom: 1rem;
    }
    
     ol ol,  ul ul,  ol ul,  ul ol {
      margin-bottom: 0;
    }
    
    dt {
      font-weight: 500;
    }
    
     dd {
      margin-bottom: 0.5rem;
    }
    
    [dir=ltr] dd {
      margin-left: 0;
    }
    
    [dir=rtl] dd {
      margin-right: 0;
    }
    
     blockquote {
      margin: 0 0 1rem;
    }
    
    b,
    strong {
      font-weight: 600;
    }
    
    small {
      font-size: 80%;
    }
    
    sub,
    sup {
      position: relative;
      font-size: 75%;
      line-height: 0;
      vertical-align: baseline;
    }
    
    sub {
      bottom: -0.25em;
    }
    
    sup {
      top: -0.5em;
    }
    
    a {
      color: #114A9F;
      text-decoration: none;
    }
    
     a {
      background-color: transparent;
    }
    a:hover {
      color: #0f3f88;
      text-decoration: none;
    }
    
    a:not([href]):not([class]) {
      color: inherit;
      text-decoration: none;
    }
    a:not([href]):not([class]):hover {
      color: inherit;
      text-decoration: none;
    }
    
    pre,
    code,
    kbd,
    samp {
      font-family: "Roboto", Helvetica, Arial, serif;
      font-size: 1em;
    }
    
    pre {
      overflow: auto;
      -ms-overflow-style: scrollbar;
    }
    
     pre {
      margin-top: 0;
      margin-bottom: 1rem;
    }
    
     figure {
      margin: 0 0 1rem;
    }
    
    img {
      vertical-align: middle;
    }
    
     img {
      border-style: none;
    }
    
    svg {
      overflow: hidden;
      vertical-align: middle;
    }
    
    table {
      border-collapse: collapse;
    }
    
    caption {
      color: #b9b9c3;
      caption-side: bottom;
    }
    
     caption {
      padding-top: 0.72rem;
      padding-bottom: 0.72rem;
    }
    
    [dir=ltr] caption {
      text-align: left;
    }
    
    [dir=rtl] caption {
      text-align: right;
    }
    
     th {
      text-align: inherit;
      text-align: -webkit-match-parent;
    }
    
    label {
      display: inline-block;
    }
    
     label {
      margin-bottom: 0;
    }
    
     button {
      border-radius: 0;
    }
    
    button:focus:not(:focus-visible) {
      outline: 0;
    }
    
    input,
    button,
    select,
    optgroup,
    textarea {
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
    }
    
     input,  button,  select,  optgroup,  textarea {
      margin: 0;
    }
    
    button,
    input {
      overflow: visible;
    }
    
    button,
    select {
      text-transform: none;
    }
    
     [role=button] {
      cursor: pointer;
    }
    
    select {
      word-wrap: normal;
    }
    
    button,
    [type=button],
    [type=reset],
    [type=submit] {
      -webkit-appearance: button;
    }
    
     button:not(:disabled),  [type=button]:not(:disabled),  [type=reset]:not(:disabled),  [type=submit]:not(:disabled) {
      cursor: pointer;
    }
    
     button::-moz-focus-inner,  [type=button]::-moz-focus-inner,  [type=reset]::-moz-focus-inner,  [type=submit]::-moz-focus-inner {
      padding: 0;
      border-style: none;
    }
    
    input[type=radio],
    input[type=checkbox] {
      box-sizing: border-box;
    }
    
     input[type=radio],  input[type=checkbox] {
      padding: 0;
    }
    
    textarea {
      overflow: auto;
      resize: vertical;
    }
    
    fieldset {
      min-width: 0;
    }
    
     fieldset {
      padding: 0;
      margin: 0;
      border: 0;
    }
    
    legend {
      display: block;
      width: 100%;
      max-width: 100%;
      font-size: 1.5rem;
      line-height: inherit;
      color: inherit;
      white-space: normal;
    }
    
     legend {
      padding: 0;
      margin-bottom: 0.5rem;
    }
    
    progress {
      vertical-align: baseline;
    }
    
    [type=number]::-webkit-inner-spin-button,
    [type=number]::-webkit-outer-spin-button {
      height: auto;
    }
    
    [type=search] {
      outline-offset: -2px;
      -webkit-appearance: none;
    }
    
    [type=search]::-webkit-search-decoration {
      -webkit-appearance: none;
    }
    
    ::-webkit-file-upload-button {
      font: inherit;
      -webkit-appearance: button;
    }
    
    output {
      display: inline-block;
    }
    
    summary {
      display: list-item;
    }
    
     summary {
      cursor: pointer;
    }
    
    template {
      display: none;
    }
    
    [hidden] {
      display: none !important;
    }
    
    h1, h2, h3, h4, h5, h6,
    .h1, .h2, .h3, .h4, .h5, .h6 {
      font-family: inherit;
      font-weight: 500;
      line-height: 1.2;
      color: #424244;
    }
    
     h1,  h2,  h3,  h4,  h5,  h6,  .h1,  .h2,  .h3,  .h4,  .h5,  .h6 {
      margin-bottom: 0.5rem;
    }
    
    h1, .h1 {
      font-size: 2.3333333333rem;
    }
    
    h2, .h2 {
      font-size: 2rem;
    }
    
    h3, .h3 {
      font-size: 1.75rem;
    }
    
    h4, .h4 {
      font-size: 1.5rem;
    }
    
    h5, .h5 {
      font-size: 1.25rem;
    }
    
    h6, .h6 {
      font-size: 1.1666666667rem;
    }
    
    .lead {
      font-size: 1.14rem;
      font-weight: 400;
    }
    
    .display-1 {
      font-size: 6rem;
      font-weight: 400;
      line-height: 1.2;
    }
    
    .display-2 {
      font-size: 5.5rem;
      font-weight: 400;
      line-height: 1.2;
    }
    
    .display-3 {
      font-size: 4.5rem;
      font-weight: 400;
      line-height: 1.2;
    }
    
    .display-4 {
      font-size: 3.5rem;
      font-weight: 400;
      line-height: 1.2;
    }
    
     hr {
      margin-top: 1rem;
      margin-bottom: 1rem;
      border: 0;
      border-top: 1px solid #ebe9f1;
    }
    
    small,
    .small {
      font-size: 1rem;
      font-weight: 400;
    }
    
     mark,  .mark {
      padding: 0.2em;
      background-color: #fcf8e3;
    }
    
    .list-unstyled {
      list-style: none;
    }
    
    [dir=ltr] .list-unstyled {
      padding-left: 0;
    }
    
    [dir=rtl] .list-unstyled {
      padding-right: 0;
    }
    
    .list-inline {
      list-style: none;
    }
    
    [dir=ltr] .list-inline {
      padding-left: 0;
    }
    
    [dir=rtl] .list-inline {
      padding-right: 0;
    }
    
    .list-inline-item {
      display: inline-block;
    }
    [dir=ltr] .list-inline-item:not(:last-child) {
      margin-right: 0.5rem;
    }
    [dir=rtl] .list-inline-item:not(:last-child) {
      margin-left: 0.5rem;
    }
    
    .initialism {
      font-size: 90%;
      text-transform: uppercase;
    }
    
    .blockquote {
      font-size: 1.25rem;
    }
    
     .blockquote {
      margin-bottom: 1rem;
    }
    
    .blockquote-footer {
      display: block;
      font-size: 1rem;
      color: #b9b9c3;
    }
    .blockquote-footer::before {
      content: "—&nbsp;";
    }
    
    .img-fluid {
      max-width: 100%;
      height: auto;
    }
    
    .img-thumbnail {
      max-width: 100%;
      height: auto;
    }
    
     .img-thumbnail {
      padding: 0.25rem;
      background-color: #f8f8f8;
      border: 1px solid #dae1e7;
      border-radius: 0.357rem;
    }
    
    .figure {
      display: inline-block;
    }
    
    .figure-img {
      line-height: 1;
    }
    
     .figure-img {
      margin-bottom: 0.5rem;
    }
    
    .figure-caption {
      font-size: 90%;
      color: #b8c2cc;
    }
    
    code {
      font-size: 90%;
      color: #D63384;
      word-wrap: break-word;
    }
    a > code {
      color: inherit;
    }
    
    kbd {
      font-size: 90%;
      color: #fff;
    }
    
     kbd {
      padding: 0.2rem 0.4rem;
      background-color: #eee;
      border-radius: 0.25rem;
    }
    kbd kbd {
      font-size: 100%;
      font-weight: 500;
    }
     kbd kbd {
      padding: 0;
    }
    
    pre {
      display: block;
      font-size: 90%;
      color: #2a2e30;
    }
    pre code {
      font-size: inherit;
      color: inherit;
      word-break: normal;
    }
    
    .pre-scrollable {
      max-height: 340px;
      overflow-y: scroll;
    }
    
    .container,
    .container-fluid,
    .container-xxl,
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm {
      width: 100%;
    }
    
    [dir=ltr] .container, [dir=ltr] .container-fluid, [dir=ltr] .container-xxl, [dir=ltr] .container-xl, [dir=ltr] .container-lg, [dir=ltr] .container-md, [dir=ltr] .container-sm {
      padding-right: 1rem;
      padding-left: 1rem;
      margin-right: auto;
      margin-left: auto;
    }
    
    [dir=rtl] .container, [dir=rtl] .container-fluid, [dir=rtl] .container-xxl, [dir=rtl] .container-xl, [dir=rtl] .container-lg, [dir=rtl] .container-md, [dir=rtl] .container-sm {
      padding-left: 1rem;
      padding-right: 1rem;
      margin-left: auto;
      margin-right: auto;
    }
    
    @media (min-width: 576px) {
      .container-sm, .container {
        max-width: 540px;
      }
    }
    @media (min-width: 768px) {
      .container-md, .container-sm, .container {
        max-width: 720px;
      }
    }
    @media (min-width: 992px) {
      .container-lg, .container-md, .container-sm, .container {
        max-width: 960px;
      }
    }
    @media (min-width: 1200px) {
      .container-xl, .container-lg, .container-md, .container-sm, .container {
        max-width: 1140px;
      }
    }
    .container-xl, .container-lg, .container-md, .container-sm, .container {
      max-width: 1440px;
    }
    
    .row {
      display: flex;
      flex-wrap: wrap;
    }
    
    [dir=ltr] .row {
      margin-right: -1rem;
      margin-left: -1rem;
    }
    
    [dir=rtl] .row {
      margin-left: -1rem;
      margin-right: -1rem;
    }
    
    [dir=ltr] .no-gutters {
      margin-right: 0;
      margin-left: 0;
    }
    
    [dir=rtl] .no-gutters {
      margin-left: 0;
      margin-right: 0;
    }
    [dir=ltr] .no-gutters > .col, [dir=ltr] .no-gutters > [class*=col-] {
      padding-right: 0;
      padding-left: 0;
    }
    [dir=rtl] .no-gutters > .col, [dir=rtl] .no-gutters > [class*=col-] {
      padding-left: 0;
      padding-right: 0;
    }
    
    .col-xl,
    .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
    .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
    .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
    .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
    .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
      position: relative;
      width: 100%;
    }
    
    [dir=ltr] .col-xl, [dir=ltr] .col-xl-auto, [dir=ltr] .col-xl-12, [dir=ltr] .col-xl-11, [dir=ltr] .col-xl-10, [dir=ltr] .col-xl-9, [dir=ltr] .col-xl-8, [dir=ltr] .col-xl-7, [dir=ltr] .col-xl-6, [dir=ltr] .col-xl-5, [dir=ltr] .col-xl-4, [dir=ltr] .col-xl-3, [dir=ltr] .col-xl-2, [dir=ltr] .col-xl-1, [dir=ltr] .col-lg, [dir=ltr] .col-lg-auto, [dir=ltr] .col-lg-12, [dir=ltr] .col-lg-11, [dir=ltr] .col-lg-10, [dir=ltr] .col-lg-9, [dir=ltr] .col-lg-8, [dir=ltr] .col-lg-7, [dir=ltr] .col-lg-6, [dir=ltr] .col-lg-5, [dir=ltr] .col-lg-4, [dir=ltr] .col-lg-3, [dir=ltr] .col-lg-2, [dir=ltr] .col-lg-1, [dir=ltr] .col-md, [dir=ltr] .col-md-auto, [dir=ltr] .col-md-12, [dir=ltr] .col-md-11, [dir=ltr] .col-md-10, [dir=ltr] .col-md-9, [dir=ltr] .col-md-8, [dir=ltr] .col-md-7, [dir=ltr] .col-md-6, [dir=ltr] .col-md-5, [dir=ltr] .col-md-4, [dir=ltr] .col-md-3, [dir=ltr] .col-md-2, [dir=ltr] .col-md-1, [dir=ltr] .col-sm, [dir=ltr] .col-sm-auto, [dir=ltr] .col-sm-12, [dir=ltr] .col-sm-11, [dir=ltr] .col-sm-10, [dir=ltr] .col-sm-9, [dir=ltr] .col-sm-8, [dir=ltr] .col-sm-7, [dir=ltr] .col-sm-6, [dir=ltr] .col-sm-5, [dir=ltr] .col-sm-4, [dir=ltr] .col-sm-3, [dir=ltr] .col-sm-2, [dir=ltr] .col-sm-1, [dir=ltr] .col, [dir=ltr] .col-auto, [dir=ltr] .col-12, [dir=ltr] .col-11, [dir=ltr] .col-10, [dir=ltr] .col-9, [dir=ltr] .col-8, [dir=ltr] .col-7, [dir=ltr] .col-6, [dir=ltr] .col-5, [dir=ltr] .col-4, [dir=ltr] .col-3, [dir=ltr] .col-2, [dir=ltr] .col-1 {
      padding-right: 1rem;
      padding-left: 1rem;
    }
    
    [dir=rtl] .col-xl, [dir=rtl] .col-xl-auto, [dir=rtl] .col-xl-12, [dir=rtl] .col-xl-11, [dir=rtl] .col-xl-10, [dir=rtl] .col-xl-9, [dir=rtl] .col-xl-8, [dir=rtl] .col-xl-7, [dir=rtl] .col-xl-6, [dir=rtl] .col-xl-5, [dir=rtl] .col-xl-4, [dir=rtl] .col-xl-3, [dir=rtl] .col-xl-2, [dir=rtl] .col-xl-1, [dir=rtl] .col-lg, [dir=rtl] .col-lg-auto, [dir=rtl] .col-lg-12, [dir=rtl] .col-lg-11, [dir=rtl] .col-lg-10, [dir=rtl] .col-lg-9, [dir=rtl] .col-lg-8, [dir=rtl] .col-lg-7, [dir=rtl] .col-lg-6, [dir=rtl] .col-lg-5, [dir=rtl] .col-lg-4, [dir=rtl] .col-lg-3, [dir=rtl] .col-lg-2, [dir=rtl] .col-lg-1, [dir=rtl] .col-md, [dir=rtl] .col-md-auto, [dir=rtl] .col-md-12, [dir=rtl] .col-md-11, [dir=rtl] .col-md-10, [dir=rtl] .col-md-9, [dir=rtl] .col-md-8, [dir=rtl] .col-md-7, [dir=rtl] .col-md-6, [dir=rtl] .col-md-5, [dir=rtl] .col-md-4, [dir=rtl] .col-md-3, [dir=rtl] .col-md-2, [dir=rtl] .col-md-1, [dir=rtl] .col-sm, [dir=rtl] .col-sm-auto, [dir=rtl] .col-sm-12, [dir=rtl] .col-sm-11, [dir=rtl] .col-sm-10, [dir=rtl] .col-sm-9, [dir=rtl] .col-sm-8, [dir=rtl] .col-sm-7, [dir=rtl] .col-sm-6, [dir=rtl] .col-sm-5, [dir=rtl] .col-sm-4, [dir=rtl] .col-sm-3, [dir=rtl] .col-sm-2, [dir=rtl] .col-sm-1, [dir=rtl] .col, [dir=rtl] .col-auto, [dir=rtl] .col-12, [dir=rtl] .col-11, [dir=rtl] .col-10, [dir=rtl] .col-9, [dir=rtl] .col-8, [dir=rtl] .col-7, [dir=rtl] .col-6, [dir=rtl] .col-5, [dir=rtl] .col-4, [dir=rtl] .col-3, [dir=rtl] .col-2, [dir=rtl] .col-1 {
      padding-left: 1rem;
      padding-right: 1rem;
    }
    
    .col {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
    
    .row-cols-1 > * {
      flex: 0 0 100%;
      max-width: 100%;
    }
    
    .row-cols-2 > * {
      flex: 0 0 50%;
      max-width: 50%;
    }
    
    .row-cols-3 > * {
      flex: 0 0 33.3333333333%;
      max-width: 33.3333333333%;
    }
    
    .row-cols-4 > * {
      flex: 0 0 25%;
      max-width: 25%;
    }
    
    .row-cols-5 > * {
      flex: 0 0 20%;
      max-width: 20%;
    }
    
    .row-cols-6 > * {
      flex: 0 0 16.6666666667%;
      max-width: 16.6666666667%;
    }
    
    .col-auto {
      flex: 0 0 auto;
      width: auto;
      max-width: 100%;
    }
    
    .col-1 {
      flex: 0 0 8.3333333333%;
      max-width: 8.3333333333%;
    }
    
    .col-2 {
      flex: 0 0 16.6666666667%;
      max-width: 16.6666666667%;
    }
    
    .col-3 {
      flex: 0 0 25%;
      max-width: 25%;
    }
    
    .col-4 {
      flex: 0 0 33.3333333333%;
      max-width: 33.3333333333%;
    }
    
    .col-5 {
      flex: 0 0 41.6666666667%;
      max-width: 41.6666666667%;
    }
    
    .col-6 {
      flex: 0 0 50%;
      max-width: 50%;
    }
    
    .col-7 {
      flex: 0 0 58.3333333333%;
      max-width: 58.3333333333%;
    }
    
    .col-8 {
      flex: 0 0 66.6666666667%;
      max-width: 66.6666666667%;
    }
    
    .col-9 {
      flex: 0 0 75%;
      max-width: 75%;
    }
    
    .col-10 {
      flex: 0 0 83.3333333333%;
      max-width: 83.3333333333%;
    }
    
    .col-11 {
      flex: 0 0 91.6666666667%;
      max-width: 91.6666666667%;
    }
    
    .col-12 {
      flex: 0 0 100%;
      max-width: 100%;
    }
    
    .order-first {
      order: -1;
    }
    
    .order-last {
      order: 13;
    }
    
    .order-0 {
      order: 0;
    }
    
    .order-1 {
      order: 1;
    }
    
    .order-2 {
      order: 2;
    }
    
    .order-3 {
      order: 3;
    }
    
    .order-4 {
      order: 4;
    }
    
    .order-5 {
      order: 5;
    }
    
    .order-6 {
      order: 6;
    }
    
    .order-7 {
      order: 7;
    }
    
    .order-8 {
      order: 8;
    }
    
    .order-9 {
      order: 9;
    }
    
    .order-10 {
      order: 10;
    }
    
    .order-11 {
      order: 11;
    }
    
    .order-12 {
      order: 12;
    }
    
    [dir=ltr] .offset-1 {
      margin-left: 8.3333333333%;
    }
    
    [dir=rtl] .offset-1 {
      margin-right: 8.3333333333%;
    }
    
    [dir=ltr] .offset-2 {
      margin-left: 16.6666666667%;
    }
    
    [dir=rtl] .offset-2 {
      margin-right: 16.6666666667%;
    }
    
    [dir=ltr] .offset-3 {
      margin-left: 25%;
    }
    
    [dir=rtl] .offset-3 {
      margin-right: 25%;
    }
    
    [dir=ltr] .offset-4 {
      margin-left: 33.3333333333%;
    }
    
    [dir=rtl] .offset-4 {
      margin-right: 33.3333333333%;
    }
    
    [dir=ltr] .offset-5 {
      margin-left: 41.6666666667%;
    }
    
    [dir=rtl] .offset-5 {
      margin-right: 41.6666666667%;
    }
    
    [dir=ltr] .offset-6 {
      margin-left: 50%;
    }
    
    [dir=rtl] .offset-6 {
      margin-right: 50%;
    }
    
    [dir=ltr] .offset-7 {
      margin-left: 58.3333333333%;
    }
    
    [dir=rtl] .offset-7 {
      margin-right: 58.3333333333%;
    }
    
    [dir=ltr] .offset-8 {
      margin-left: 66.6666666667%;
    }
    
    [dir=rtl] .offset-8 {
      margin-right: 66.6666666667%;
    }
    
    [dir=ltr] .offset-9 {
      margin-left: 75%;
    }
    
    [dir=rtl] .offset-9 {
      margin-right: 75%;
    }
    
    [dir=ltr] .offset-10 {
      margin-left: 83.3333333333%;
    }
    
    [dir=rtl] .offset-10 {
      margin-right: 83.3333333333%;
    }
    
    [dir=ltr] .offset-11 {
      margin-left: 91.6666666667%;
    }
    
    [dir=rtl] .offset-11 {
      margin-right: 91.6666666667%;
    }
    
    @media (min-width: 576px) {
      .col-sm {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
      }
    
      .row-cols-sm-1 > * {
        flex: 0 0 100%;
        max-width: 100%;
      }
    
      .row-cols-sm-2 > * {
        flex: 0 0 50%;
        max-width: 50%;
      }
    
      .row-cols-sm-3 > * {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%;
      }
    
      .row-cols-sm-4 > * {
        flex: 0 0 25%;
        max-width: 25%;
      }
    
      .row-cols-sm-5 > * {
        flex: 0 0 20%;
        max-width: 20%;
      }
    
      .row-cols-sm-6 > * {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }
    
      .col-sm-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
      }
    
      .col-sm-1 {
        flex: 0 0 8.3333333333%;
        max-width: 8.3333333333%;
      }
    
      .col-sm-2 {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }
    
      .col-sm-3 {
        flex: 0 0 25%;
        max-width: 25%;
      }
    
      .col-sm-4 {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%;
      }
    
      .col-sm-5 {
        flex: 0 0 41.6666666667%;
        max-width: 41.6666666667%;
      }
    
      .col-sm-6 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    
      .col-sm-7 {
        flex: 0 0 58.3333333333%;
        max-width: 58.3333333333%;
      }
    
      .col-sm-8 {
        flex: 0 0 66.6666666667%;
        max-width: 66.6666666667%;
      }
    
      .col-sm-9 {
        flex: 0 0 75%;
        max-width: 75%;
      }
    
      .col-sm-10 {
        flex: 0 0 83.3333333333%;
        max-width: 83.3333333333%;
      }
    
      .col-sm-11 {
        flex: 0 0 91.6666666667%;
        max-width: 91.6666666667%;
      }
    
      .col-sm-12 {
        flex: 0 0 100%;
        max-width: 100%;
      }
    
      .order-sm-first {
        order: -1;
      }
    
      .order-sm-last {
        order: 13;
      }
    
      .order-sm-0 {
        order: 0;
      }
    
      .order-sm-1 {
        order: 1;
      }
    
      .order-sm-2 {
        order: 2;
      }
    
      .order-sm-3 {
        order: 3;
      }
    
      .order-sm-4 {
        order: 4;
      }
    
      .order-sm-5 {
        order: 5;
      }
    
      .order-sm-6 {
        order: 6;
      }
    
      .order-sm-7 {
        order: 7;
      }
    
      .order-sm-8 {
        order: 8;
      }
    
      .order-sm-9 {
        order: 9;
      }
    
      .order-sm-10 {
        order: 10;
      }
    
      .order-sm-11 {
        order: 11;
      }
    
      .order-sm-12 {
        order: 12;
      }
    
      [dir=ltr] .offset-sm-0 {
        margin-left: 0;
      }
    
      [dir=rtl] .offset-sm-0 {
        margin-right: 0;
      }
    
      [dir=ltr] .offset-sm-1 {
        margin-left: 8.3333333333%;
      }
    
      [dir=rtl] .offset-sm-1 {
        margin-right: 8.3333333333%;
      }
    
      [dir=ltr] .offset-sm-2 {
        margin-left: 16.6666666667%;
      }
    
      [dir=rtl] .offset-sm-2 {
        margin-right: 16.6666666667%;
      }
    
      [dir=ltr] .offset-sm-3 {
        margin-left: 25%;
      }
    
      [dir=rtl] .offset-sm-3 {
        margin-right: 25%;
      }
    
      [dir=ltr] .offset-sm-4 {
        margin-left: 33.3333333333%;
      }
    
      [dir=rtl] .offset-sm-4 {
        margin-right: 33.3333333333%;
      }
    
      [dir=ltr] .offset-sm-5 {
        margin-left: 41.6666666667%;
      }
    
      [dir=rtl] .offset-sm-5 {
        margin-right: 41.6666666667%;
      }
    
      [dir=ltr] .offset-sm-6 {
        margin-left: 50%;
      }
    
      [dir=rtl] .offset-sm-6 {
        margin-right: 50%;
      }
    
      [dir=ltr] .offset-sm-7 {
        margin-left: 58.3333333333%;
      }
    
      [dir=rtl] .offset-sm-7 {
        margin-right: 58.3333333333%;
      }
    
      [dir=ltr] .offset-sm-8 {
        margin-left: 66.6666666667%;
      }
    
      [dir=rtl] .offset-sm-8 {
        margin-right: 66.6666666667%;
      }
    
      [dir=ltr] .offset-sm-9 {
        margin-left: 75%;
      }
    
      [dir=rtl] .offset-sm-9 {
        margin-right: 75%;
      }
    
      [dir=ltr] .offset-sm-10 {
        margin-left: 83.3333333333%;
      }
    
      [dir=rtl] .offset-sm-10 {
        margin-right: 83.3333333333%;
      }
    
      [dir=ltr] .offset-sm-11 {
        margin-left: 91.6666666667%;
      }
    
      [dir=rtl] .offset-sm-11 {
        margin-right: 91.6666666667%;
      }
    }
    @media (min-width: 768px) {
      .col-md {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
      }
    
      .row-cols-md-1 > * {
        flex: 0 0 100%;
        max-width: 100%;
      }
    
      .row-cols-md-2 > * {
        flex: 0 0 50%;
        max-width: 50%;
      }
    
      .row-cols-md-3 > * {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%;
      }
    
      .row-cols-md-4 > * {
        flex: 0 0 25%;
        max-width: 25%;
      }
    
      .row-cols-md-5 > * {
        flex: 0 0 20%;
        max-width: 20%;
      }
    
      .row-cols-md-6 > * {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }
    
      .col-md-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
      }
    
      .col-md-1 {
        flex: 0 0 8.3333333333%;
        max-width: 8.3333333333%;
      }
    
      .col-md-2 {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }
    
      .col-md-3 {
        flex: 0 0 25%;
        max-width: 25%;
      }
    
      .col-md-4 {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%;
      }
    
      .col-md-5 {
        flex: 0 0 41.6666666667%;
        max-width: 41.6666666667%;
      }
    
      .col-md-6 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    
      .col-md-7 {
        flex: 0 0 58.3333333333%;
        max-width: 58.3333333333%;
      }
    
      .col-md-8 {
        flex: 0 0 66.6666666667%;
        max-width: 66.6666666667%;
      }
    
      .col-md-9 {
        flex: 0 0 75%;
        max-width: 75%;
      }
    
      .col-md-10 {
        flex: 0 0 83.3333333333%;
        max-width: 83.3333333333%;
      }
    
      .col-md-11 {
        flex: 0 0 91.6666666667%;
        max-width: 91.6666666667%;
      }
    
      .col-md-12 {
        flex: 0 0 100%;
        max-width: 100%;
      }
    
      .order-md-first {
        order: -1;
      }
    
      .order-md-last {
        order: 13;
      }
    
      .order-md-0 {
        order: 0;
      }
    
      .order-md-1 {
        order: 1;
      }
    
      .order-md-2 {
        order: 2;
      }
    
      .order-md-3 {
        order: 3;
      }
    
      .order-md-4 {
        order: 4;
      }
    
      .order-md-5 {
        order: 5;
      }
    
      .order-md-6 {
        order: 6;
      }
    
      .order-md-7 {
        order: 7;
      }
    
      .order-md-8 {
        order: 8;
      }
    
      .order-md-9 {
        order: 9;
      }
    
      .order-md-10 {
        order: 10;
      }
    
      .order-md-11 {
        order: 11;
      }
    
      .order-md-12 {
        order: 12;
      }
    
      [dir=ltr] .offset-md-0 {
        margin-left: 0;
      }
    
      [dir=rtl] .offset-md-0 {
        margin-right: 0;
      }
    
      [dir=ltr] .offset-md-1 {
        margin-left: 8.3333333333%;
      }
    
      [dir=rtl] .offset-md-1 {
        margin-right: 8.3333333333%;
      }
    
      [dir=ltr] .offset-md-2 {
        margin-left: 16.6666666667%;
      }
    
      [dir=rtl] .offset-md-2 {
        margin-right: 16.6666666667%;
      }
    
      [dir=ltr] .offset-md-3 {
        margin-left: 25%;
      }
    
      [dir=rtl] .offset-md-3 {
        margin-right: 25%;
      }
    
      [dir=ltr] .offset-md-4 {
        margin-left: 33.3333333333%;
      }
    
      [dir=rtl] .offset-md-4 {
        margin-right: 33.3333333333%;
      }
    
      [dir=ltr] .offset-md-5 {
        margin-left: 41.6666666667%;
      }
    
      [dir=rtl] .offset-md-5 {
        margin-right: 41.6666666667%;
      }
    
      [dir=ltr] .offset-md-6 {
        margin-left: 50%;
      }
    
      [dir=rtl] .offset-md-6 {
        margin-right: 50%;
      }
    
      [dir=ltr] .offset-md-7 {
        margin-left: 58.3333333333%;
      }
    
      [dir=rtl] .offset-md-7 {
        margin-right: 58.3333333333%;
      }
    
      [dir=ltr] .offset-md-8 {
        margin-left: 66.6666666667%;
      }
    
      [dir=rtl] .offset-md-8 {
        margin-right: 66.6666666667%;
      }
    
      [dir=ltr] .offset-md-9 {
        margin-left: 75%;
      }
    
      [dir=rtl] .offset-md-9 {
        margin-right: 75%;
      }
    
      [dir=ltr] .offset-md-10 {
        margin-left: 83.3333333333%;
      }
    
      [dir=rtl] .offset-md-10 {
        margin-right: 83.3333333333%;
      }
    
      [dir=ltr] .offset-md-11 {
        margin-left: 91.6666666667%;
      }
    
      [dir=rtl] .offset-md-11 {
        margin-right: 91.6666666667%;
      }
    }
    @media (min-width: 992px) {
      .col-lg {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
      }
    
      .row-cols-lg-1 > * {
        flex: 0 0 100%;
        max-width: 100%;
      }
    
      .row-cols-lg-2 > * {
        flex: 0 0 50%;
        max-width: 50%;
      }
    
      .row-cols-lg-3 > * {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%;
      }
    
      .row-cols-lg-4 > * {
        flex: 0 0 25%;
        max-width: 25%;
      }
    
      .row-cols-lg-5 > * {
        flex: 0 0 20%;
        max-width: 20%;
      }
    
      .row-cols-lg-6 > * {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }
    
      .col-lg-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
      }
    
      .col-lg-1 {
        flex: 0 0 8.3333333333%;
        max-width: 8.3333333333%;
      }
    
      .col-lg-2 {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }
    
      .col-lg-3 {
        flex: 0 0 25%;
        max-width: 25%;
      }
    
      .col-lg-4 {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%;
      }
    
      .col-lg-5 {
        flex: 0 0 41.6666666667%;
        max-width: 41.6666666667%;
      }
    
      .col-lg-6 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    
      .col-lg-7 {
        flex: 0 0 58.3333333333%;
        max-width: 58.3333333333%;
      }
    
      .col-lg-8 {
        flex: 0 0 66.6666666667%;
        max-width: 66.6666666667%;
      }
    
      .col-lg-9 {
        flex: 0 0 75%;
        max-width: 75%;
      }
    
      .col-lg-10 {
        flex: 0 0 83.3333333333%;
        max-width: 83.3333333333%;
      }
    
      .col-lg-11 {
        flex: 0 0 91.6666666667%;
        max-width: 91.6666666667%;
      }
    
      .col-lg-12 {
        flex: 0 0 100%;
        max-width: 100%;
      }
    
      .order-lg-first {
        order: -1;
      }
    
      .order-lg-last {
        order: 13;
      }
    
      .order-lg-0 {
        order: 0;
      }
    
      .order-lg-1 {
        order: 1;
      }
    
      .order-lg-2 {
        order: 2;
      }
    
      .order-lg-3 {
        order: 3;
      }
    
      .order-lg-4 {
        order: 4;
      }
    
      .order-lg-5 {
        order: 5;
      }
    
      .order-lg-6 {
        order: 6;
      }
    
      .order-lg-7 {
        order: 7;
      }
    
      .order-lg-8 {
        order: 8;
      }
    
      .order-lg-9 {
        order: 9;
      }
    
      .order-lg-10 {
        order: 10;
      }
    
      .order-lg-11 {
        order: 11;
      }
    
      .order-lg-12 {
        order: 12;
      }
    
      [dir=ltr] .offset-lg-0 {
        margin-left: 0;
      }
    
      [dir=rtl] .offset-lg-0 {
        margin-right: 0;
      }
    
      [dir=ltr] .offset-lg-1 {
        margin-left: 8.3333333333%;
      }
    
      [dir=rtl] .offset-lg-1 {
        margin-right: 8.3333333333%;
      }
    
      [dir=ltr] .offset-lg-2 {
        margin-left: 16.6666666667%;
      }
    
      [dir=rtl] .offset-lg-2 {
        margin-right: 16.6666666667%;
      }
    
      [dir=ltr] .offset-lg-3 {
        margin-left: 25%;
      }
    
      [dir=rtl] .offset-lg-3 {
        margin-right: 25%;
      }
    
      [dir=ltr] .offset-lg-4 {
        margin-left: 33.3333333333%;
      }
    
      [dir=rtl] .offset-lg-4 {
        margin-right: 33.3333333333%;
      }
    
      [dir=ltr] .offset-lg-5 {
        margin-left: 41.6666666667%;
      }
    
      [dir=rtl] .offset-lg-5 {
        margin-right: 41.6666666667%;
      }
    
      [dir=ltr] .offset-lg-6 {
        margin-left: 50%;
      }
    
      [dir=rtl] .offset-lg-6 {
        margin-right: 50%;
      }
    
      [dir=ltr] .offset-lg-7 {
        margin-left: 58.3333333333%;
      }
    
      [dir=rtl] .offset-lg-7 {
        margin-right: 58.3333333333%;
      }
    
      [dir=ltr] .offset-lg-8 {
        margin-left: 66.6666666667%;
      }
    
      [dir=rtl] .offset-lg-8 {
        margin-right: 66.6666666667%;
      }
    
      [dir=ltr] .offset-lg-9 {
        margin-left: 75%;
      }
    
      [dir=rtl] .offset-lg-9 {
        margin-right: 75%;
      }
    
      [dir=ltr] .offset-lg-10 {
        margin-left: 83.3333333333%;
      }
    
      [dir=rtl] .offset-lg-10 {
        margin-right: 83.3333333333%;
      }
    
      [dir=ltr] .offset-lg-11 {
        margin-left: 91.6666666667%;
      }
    
      [dir=rtl] .offset-lg-11 {
        margin-right: 91.6666666667%;
      }
    }
    @media (min-width: 1200px) {
      .col-xl {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
      }
    
      .row-cols-xl-1 > * {
        flex: 0 0 100%;
        max-width: 100%;
      }
    
      .row-cols-xl-2 > * {
        flex: 0 0 50%;
        max-width: 50%;
      }
    
      .row-cols-xl-3 > * {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%;
      }
    
      .row-cols-xl-4 > * {
        flex: 0 0 25%;
        max-width: 25%;
      }
    
      .row-cols-xl-5 > * {
        flex: 0 0 20%;
        max-width: 20%;
      }
    
      .row-cols-xl-6 > * {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }
    
      .col-xl-auto {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
      }
    
      .col-xl-1 {
        flex: 0 0 8.3333333333%;
        max-width: 8.3333333333%;
      }
    
      .col-xl-2 {
        flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }
    
      .col-xl-3 {
        flex: 0 0 25%;
        max-width: 25%;
      }
    
      .col-xl-4 {
        flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%;
      }
    
      .col-xl-5 {
        flex: 0 0 41.6666666667%;
        max-width: 41.6666666667%;
      }
    
      .col-xl-6 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    
      .col-xl-7 {
        flex: 0 0 58.3333333333%;
        max-width: 58.3333333333%;
      }
    
      .col-xl-8 {
        flex: 0 0 66.6666666667%;
        max-width: 66.6666666667%;
      }
    
      .col-xl-9 {
        flex: 0 0 75%;
        max-width: 75%;
      }
    
      .col-xl-10 {
        flex: 0 0 83.3333333333%;
        max-width: 83.3333333333%;
      }
    
      .col-xl-11 {
        flex: 0 0 91.6666666667%;
        max-width: 91.6666666667%;
      }
    
      .col-xl-12 {
        flex: 0 0 100%;
        max-width: 100%;
      }
    
      .order-xl-first {
        order: -1;
      }
    
      .order-xl-last {
        order: 13;
      }
    
      .order-xl-0 {
        order: 0;
      }
    
      .order-xl-1 {
        order: 1;
      }
    
      .order-xl-2 {
        order: 2;
      }
    
      .order-xl-3 {
        order: 3;
      }
    
      .order-xl-4 {
        order: 4;
      }
    
      .order-xl-5 {
        order: 5;
      }
    
      .order-xl-6 {
        order: 6;
      }
    
      .order-xl-7 {
        order: 7;
      }
    
      .order-xl-8 {
        order: 8;
      }
    
      .order-xl-9 {
        order: 9;
      }
    
      .order-xl-10 {
        order: 10;
      }
    
      .order-xl-11 {
        order: 11;
      }
    
      .order-xl-12 {
        order: 12;
      }
    
      [dir=ltr] .offset-xl-0 {
        margin-left: 0;
      }
    
      [dir=rtl] .offset-xl-0 {
        margin-right: 0;
      }
    
      [dir=ltr] .offset-xl-1 {
        margin-left: 8.3333333333%;
      }
    
      [dir=rtl] .offset-xl-1 {
        margin-right: 8.3333333333%;
      }
    
      [dir=ltr] .offset-xl-2 {
        margin-left: 16.6666666667%;
      }
    
      [dir=rtl] .offset-xl-2 {
        margin-right: 16.6666666667%;
      }
    
      [dir=ltr] .offset-xl-3 {
        margin-left: 25%;
      }
    
      [dir=rtl] .offset-xl-3 {
        margin-right: 25%;
      }
    
      [dir=ltr] .offset-xl-4 {
        margin-left: 33.3333333333%;
      }
    
      [dir=rtl] .offset-xl-4 {
        margin-right: 33.3333333333%;
      }
    
      [dir=ltr] .offset-xl-5 {
        margin-left: 41.6666666667%;
      }
    
      [dir=rtl] .offset-xl-5 {
        margin-right: 41.6666666667%;
      }
    
      [dir=ltr] .offset-xl-6 {
        margin-left: 50%;
      }
    
      [dir=rtl] .offset-xl-6 {
        margin-right: 50%;
      }
    
      [dir=ltr] .offset-xl-7 {
        margin-left: 58.3333333333%;
      }
    
      [dir=rtl] .offset-xl-7 {
        margin-right: 58.3333333333%;
      }
    
      [dir=ltr] .offset-xl-8 {
        margin-left: 66.6666666667%;
      }
    
      [dir=rtl] .offset-xl-8 {
        margin-right: 66.6666666667%;
      }
    
      [dir=ltr] .offset-xl-9 {
        margin-left: 75%;
      }
    
      [dir=rtl] .offset-xl-9 {
        margin-right: 75%;
      }
    
      [dir=ltr] .offset-xl-10 {
        margin-left: 83.3333333333%;
      }
    
      [dir=rtl] .offset-xl-10 {
        margin-right: 83.3333333333%;
      }
    
      [dir=ltr] .offset-xl-11 {
        margin-left: 91.6666666667%;
      }
    
      [dir=rtl] .offset-xl-11 {
        margin-right: 91.6666666667%;
      }
    }
    .table {
      width: 100%;
      color: #424244;
    }
     .table {
      margin-bottom: 1rem;
    }
    .table th,
    .table td {
      vertical-align: top;
    }
     .table th,  .table td {
      padding: 0.72rem;
      border-top: 1px solid #ebe9f1;
    }
    .table thead th {
      vertical-align: bottom;
    }
     .table thead th {
      border-bottom: 2px solid #ebe9f1;
    }
     .table tbody + tbody {
      border-top: 2px solid #ebe9f1;
    }
    
     .table-sm th,  .table-sm td {
      padding: 0.3rem;
    }
    
     .table-bordered {
      border: 1px solid #ebe9f1;
    }
     .table-bordered th,  .table-bordered td {
      border: 1px solid #ebe9f1;
    }
     .table-bordered thead th,  .table-bordered thead td {
      border-bottom-width: 2px;
    }
    
     .table-borderless th,  .table-borderless td,  .table-borderless thead th,  .table-borderless tbody + tbody {
      border: 0;
    }
    
     .table-striped tbody tr:nth-of-type(odd) {
      background-color: #fafafc;
    }
    
    .table-hover tbody tr:hover {
      color: #424244;
    }
    
     .table-hover tbody tr:hover {
      background-color: #f6f6f9;
    }
    
     .table-primary,  .table-primary > th,  .table-primary > td {
      background-color: #bccce4;
    }
     .table-primary th,  .table-primary td,  .table-primary thead th,  .table-primary tbody + tbody {
      border-color: #83a1cd;
    }
    
     .table-hover .table-primary:hover {
      background-color: #aabedd;
    }
     .table-hover .table-primary:hover > td,  .table-hover .table-primary:hover > th {
      background-color: #aabedd;
    }
    
     .table-secondary,  .table-secondary > th,  .table-secondary > td {
      background-color: #e3e4e6;
    }
     .table-secondary th,  .table-secondary td,  .table-secondary thead th,  .table-secondary tbody + tbody {
      border-color: #cccdd0;
    }
    
     .table-hover .table-secondary:hover {
      background-color: #d6d7da;
    }
     .table-hover .table-secondary:hover > td,  .table-hover .table-secondary:hover > th {
      background-color: #d6d7da;
    }
    
     .table-success,  .table-success > th,  .table-success > td {
      background-color: #beebd2;
    }
     .table-success th,  .table-success td,  .table-success thead th,  .table-success tbody + tbody {
      border-color: #86daab;
    }
    
     .table-hover .table-success:hover {
      background-color: #abe5c5;
    }
     .table-hover .table-success:hover > td,  .table-hover .table-success:hover > th {
      background-color: #abe5c5;
    }
    
     .table-info,  .table-info > th,  .table-info > td {
      background-color: #b8f2f9;
    }
     .table-info th,  .table-info td,  .table-info thead th,  .table-info tbody + tbody {
      border-color: #7ae6f3;
    }
    
     .table-hover .table-info:hover {
      background-color: #a0eef7;
    }
     .table-hover .table-info:hover > td,  .table-hover .table-info:hover > th {
      background-color: #a0eef7;
    }
    
     .table-warning,  .table-warning > th,  .table-warning > td {
      background-color: #feebbd;
    }
     .table-warning th,  .table-warning td,  .table-warning thead th,  .table-warning tbody + tbody {
      border-color: #fedb84;
    }
    
     .table-hover .table-warning:hover {
      background-color: #fee3a4;
    }
     .table-hover .table-warning:hover > td,  .table-hover .table-warning:hover > th {
      background-color: #fee3a4;
    }
    
     .table-danger,  .table-danger > th,  .table-danger > td {
      background-color: #f9cfcf;
    }
     .table-danger th,  .table-danger td,  .table-danger thead th,  .table-danger tbody + tbody {
      border-color: #f4a6a7;
    }
    
     .table-hover .table-danger:hover {
      background-color: #f6b8b8;
    }
     .table-hover .table-danger:hover > td,  .table-hover .table-danger:hover > th {
      background-color: #f6b8b8;
    }
    
     .table-light,  .table-light > th,  .table-light > td {
      background-color: #eeeeee;
    }
     .table-light th,  .table-light td,  .table-light thead th,  .table-light tbody + tbody {
      border-color: #dfdfdf;
    }
    
     .table-hover .table-light:hover {
      background-color: #e1e1e1;
    }
     .table-hover .table-light:hover > td,  .table-hover .table-light:hover > th {
      background-color: #e1e1e1;
    }
    
     .table-dark,  .table-dark > th,  .table-dark > td {
      background-color: #cdcdcd;
    }
     .table-dark th,  .table-dark td,  .table-dark thead th,  .table-dark tbody + tbody {
      border-color: #a1a1a1;
    }
    
     .table-hover .table-dark:hover {
      background-color: silver;
    }
     .table-hover .table-dark:hover > td,  .table-hover .table-dark:hover > th {
      background-color: silver;
    }
    
     .table-active,  .table-active > th,  .table-active > td {
      background-color: #f6f6f9;
    }
    
     .table-hover .table-active:hover {
      background-color: #e7e7ef;
    }
     .table-hover .table-active:hover > td,  .table-hover .table-active:hover > th {
      background-color: #e7e7ef;
    }
    
    .table .thead-dark th {
      color: #fff;
    }
    
     .table .thead-dark th {
      background-color: #4B4B4B;
      border-color: #404040;
    }
    .table .thead-light th {
      color: #424244;
    }
     .table .thead-light th {
      background-color: #f3f2f7;
      border-color: #ebe9f1;
    }
    
    .table-dark {
      color: #fff;
    }
    
     .table-dark {
      background-color: #4B4B4B;
    }
     .table-dark th,  .table-dark td,  .table-dark thead th {
      border-color: #404040;
    }
     .table-dark.table-bordered {
      border: 0;
    }
     .table-dark.table-striped tbody tr:nth-of-type(odd) {
      background-color: rgba(255, 255, 255, 0.05);
    }
    .table-dark.table-hover tbody tr:hover {
      color: #fff;
    }
     .table-dark.table-hover tbody tr:hover {
      background-color: rgba(255, 255, 255, 0.075);
    }
    
    @media (max-width: 575.98px) {
      .table-responsive-sm {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }
       .table-responsive-sm > .table-bordered {
        border: 0;
      }
    }
    @media (max-width: 767.98px) {
      .table-responsive-md {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }
       .table-responsive-md > .table-bordered {
        border: 0;
      }
    }
    @media (max-width: 991.98px) {
      .table-responsive-lg {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }
       .table-responsive-lg > .table-bordered {
        border: 0;
      }
    }
    @media (max-width: 1199.98px) {
      .table-responsive-xl {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }
       .table-responsive-xl > .table-bordered {
        border: 0;
      }
    }
    .table-responsive {
      display: block;
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
     .table-responsive > .table-bordered {
      border: 0;
    }
    
    .form-control {
      display: block;
      width: 100%;
      height: 2.6666666667rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.45;
      color: #424244;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    
     .form-control {
      padding: 0.438rem 1rem;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #D6D9E1;
      border-radius: 0.357rem;
    }
    @media (prefers-reduced-motion: reduce) {
      .form-control {
        transition: none;
      }
    }
     .form-control::-ms-expand {
      background-color: transparent;
      border: 0;
    }
    .form-control:-moz-focusring {
      color: transparent;
    }
     .form-control:-moz-focusring {
      text-shadow: 0 0 0 #424244;
    }
    .form-control:focus {
      color: #424244;
      outline: 0;
    }
     .form-control:focus {
      background-color: #fff;
      border-color: #114A9F;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
    .form-control::placeholder {
      color: #b9b9c3;
      opacity: 1;
    }
    .form-control:disabled, .form-control[readonly] {
      opacity: 1;
    }
     .form-control:disabled,  .form-control[readonly] {
      background-color: #efefef;
    }
    
    input[type=date].form-control,
    input[type=time].form-control,
    input[type=datetime-local].form-control,
    input[type=month].form-control {
      appearance: none;
    }
    
    select.form-control:focus::-ms-value {
      color: #424244;
    }
    
     select.form-control:focus::-ms-value {
      background-color: #fff;
    }
    
    .form-control-file,
    .form-control-range {
      display: block;
      width: 100%;
    }
    
    .col-form-label {
      font-size: inherit;
      line-height: 1.45;
    }
    
     .col-form-label {
      padding-top: calc(0.438rem + 1px);
      padding-bottom: calc(0.438rem + 1px);
      margin-bottom: 0;
    }
    
    .col-form-label-lg {
      font-size: 1.143rem;
      line-height: 1.25;
    }
    
     .col-form-label-lg {
      padding-top: calc(0.75rem + 1px);
      padding-bottom: calc(0.75rem + 1px);
    }
    
    .col-form-label-sm {
      font-size: 0.857rem;
      line-height: 1;
    }
    
     .col-form-label-sm {
      padding-top: calc(0.188rem + 1px);
      padding-bottom: calc(0.188rem + 1px);
    }
    
    .form-control-plaintext {
      display: block;
      width: 100%;
      font-size: 1rem;
      line-height: 1.45;
      color: #424244;
    }
    
     .form-control-plaintext {
      padding: 0.438rem 0;
      margin-bottom: 0;
      background-color: transparent;
      border: solid transparent;
      border-width: 1px 0;
    }
    [dir=ltr] .form-control-plaintext.form-control-sm, [dir=ltr] .form-control-plaintext.form-control-lg {
      padding-right: 0;
      padding-left: 0;
    }
    [dir=rtl] .form-control-plaintext.form-control-sm, [dir=rtl] .form-control-plaintext.form-control-lg {
      padding-left: 0;
      padding-right: 0;
    }
    
    .form-control-sm {
      height: 2.142rem;
      font-size: 0.857rem;
      line-height: 1;
    }
    
     .form-control-sm {
      padding: 0.188rem 0.857rem;
      border-radius: 0.357rem;
    }
    
    .form-control-lg {
      height: 3.2857rem;
      font-size: 1.143rem;
      line-height: 1.25;
    }
    
     .form-control-lg {
      padding: 0.75rem 1.143rem;
      border-radius: 0.357rem;
    }
    
    select.form-control[size], select.form-control[multiple] {
      height: auto;
    }
    
    textarea.form-control {
      height: auto;
    }
    
     .form-group {
      margin-bottom: 0.6666666667rem;
    }
    
    .form-text {
      display: block;
    }
    
     .form-text {
      margin-top: 0.25rem;
    }
    
    .form-row {
      display: flex;
      flex-wrap: wrap;
    }
    
    [dir=ltr] .form-row {
      margin-right: -5px;
      margin-left: -5px;
    }
    
    [dir=rtl] .form-row {
      margin-left: -5px;
      margin-right: -5px;
    }
    [dir=ltr] .form-row > .col, [dir=ltr] .form-row > [class*=col-] {
      padding-right: 5px;
      padding-left: 5px;
    }
    [dir=rtl] .form-row > .col, [dir=rtl] .form-row > [class*=col-] {
      padding-left: 5px;
      padding-right: 5px;
    }
    
    .form-check {
      position: relative;
      display: block;
    }
    
    [dir=ltr] .form-check {
      padding-left: 1.25rem;
    }
    
    [dir=rtl] .form-check {
      padding-right: 1.25rem;
    }
    
    .form-check-input {
      position: absolute;
    }
    
     .form-check-input {
      margin-top: 0.3rem;
    }
    
    [dir=ltr] .form-check-input {
      margin-left: -1.25rem;
    }
    
    [dir=rtl] .form-check-input {
      margin-right: -1.25rem;
    }
    .form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
      color: #b9b9c3;
    }
    
     .form-check-label {
      margin-bottom: 0;
    }
    
    .form-check-inline {
      display: inline-flex;
      align-items: center;
    }
    
    [dir=ltr] .form-check-inline {
      padding-left: 0;
      margin-right: 0.75rem;
    }
    
    [dir=rtl] .form-check-inline {
      padding-right: 0;
      margin-left: 0.75rem;
    }
    .form-check-inline .form-check-input {
      position: static;
    }
     .form-check-inline .form-check-input {
      margin-top: 0;
    }
    [dir=ltr] .form-check-inline .form-check-input {
      margin-right: 0.3125rem;
      margin-left: 0;
    }
    [dir=rtl] .form-check-inline .form-check-input {
      margin-left: 0.3125rem;
      margin-right: 0;
    }
    
    .valid-feedback {
      display: none;
      width: 100%;
      font-size: 1rem;
      color: #17B75E;
    }
    
     .valid-feedback {
      margin-top: 0.25rem;
    }
    
    .valid-tooltip {
      position: absolute;
      top: 100%;
      z-index: 5;
      display: none;
      max-width: 100%;
      font-size: 0.857rem;
      line-height: 1.45;
      color: #fff;
    }
    
     .valid-tooltip {
      padding: 0.4rem 0.775rem;
      margin-top: 0.1rem;
      background-color: #17b75e;
      border-radius: 0.358rem;
    }
    
    [dir=ltr] .valid-tooltip {
      left: 0;
    }
    
    [dir=rtl] .valid-tooltip {
      right: 0;
    }
    [dir=ltr] .form-row > .col > .valid-tooltip, [dir=ltr] .form-row > [class*=col-] > .valid-tooltip {
      left: 5px;
    }
    [dir=rtl] .form-row > .col > .valid-tooltip, [dir=rtl] .form-row > [class*=col-] > .valid-tooltip {
      right: 5px;
    }
    
    .was-validated :valid ~ .valid-feedback,
    .was-validated :valid ~ .valid-tooltip,
    .is-valid ~ .valid-feedback,
    .is-valid ~ .valid-tooltip {
      display: block;
    }
    
     .was-validated .form-control:valid,  .form-control.is-valid {
      border-color: #17B75E;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2317B75E' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);
    }
    
    [dir=ltr] .was-validated .form-control:valid, [dir=ltr] .form-control.is-valid {
      padding-right: calc(1.45em + 0.876rem);
      background-position: right calc(0.3625em + 0.219rem) center;
    }
    
    [dir=rtl] .was-validated .form-control:valid, [dir=rtl] .form-control.is-valid {
      padding-left: calc(1.45em + 0.876rem);
      background-position: left calc(0.3625em + 0.219rem) center;
    }
     .was-validated .form-control:valid:focus,  .form-control.is-valid:focus {
      border-color: #17B75E;
      box-shadow: 0 0 0 0.2rem rgba(23, 183, 94, 0.25);
    }
    
    [dir=ltr] .was-validated textarea.form-control:valid, [dir=ltr] textarea.form-control.is-valid {
      padding-right: calc(1.45em + 0.876rem);
      background-position: top calc(0.3625em + 0.219rem) right calc(0.3625em + 0.219rem);
    }
    
    [dir=rtl] .was-validated textarea.form-control:valid, [dir=rtl] textarea.form-control.is-valid {
      padding-left: calc(1.45em + 0.876rem);
      background-position: top calc(0.3625em + 0.219rem) left calc(0.3625em + 0.219rem);
    }
    
     .was-validated .custom-select:valid,  .custom-select.is-valid {
      border-color: #17B75E;
    }
    
    [dir=ltr] .was-validated .custom-select:valid, [dir=ltr] .custom-select.is-valid {
      padding-right: calc(0.75em + 2.657rem);
      background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23D6D9E1' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 1rem center/10px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2317B75E' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") center right 2rem/calc(0.725em + 0.438rem) calc(0.725em + 0.438rem) no-repeat;
    }
    
    [dir=rtl] .was-validated .custom-select:valid, [dir=rtl] .custom-select.is-valid {
      padding-left: calc(0.75em + 2.657rem);
      background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23D6D9E1' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") left 1rem center/10px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2317B75E' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") center left 2rem/calc(0.725em + 0.438rem) calc(0.725em + 0.438rem) no-repeat;
    }
     .was-validated .custom-select:valid:focus,  .custom-select.is-valid:focus {
      border-color: #17B75E;
      box-shadow: 0 0 0 0.2rem rgba(23, 183, 94, 0.25);
    }
    
    .was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
      color: #17B75E;
    }
    .was-validated .form-check-input:valid ~ .valid-feedback,
    .was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
    .form-check-input.is-valid ~ .valid-tooltip {
      display: block;
    }
    
    .was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
      color: #17B75E;
    }
     .was-validated .custom-control-input:valid ~ .custom-control-label::before,  .custom-control-input.is-valid ~ .custom-control-label::before {
      border-color: #17B75E;
    }
     .was-validated .custom-control-input:valid:checked ~ .custom-control-label::before,  .custom-control-input.is-valid:checked ~ .custom-control-label::before {
      border-color: #1ee375;
      background-color: #1ee375;
    }
     .was-validated .custom-control-input:valid:focus ~ .custom-control-label::before,  .custom-control-input.is-valid:focus ~ .custom-control-label::before {
      box-shadow: 0 0 0 0.2rem rgba(23, 183, 94, 0.25);
    }
     .was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before,  .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
      border-color: #17B75E;
    }
    
     .was-validated .custom-file-input:valid ~ .custom-file-label,  .custom-file-input.is-valid ~ .custom-file-label {
      border-color: #17B75E;
    }
     .was-validated .custom-file-input:valid:focus ~ .custom-file-label,  .custom-file-input.is-valid:focus ~ .custom-file-label {
      border-color: #17B75E;
      box-shadow: 0 0 0 0.2rem rgba(23, 183, 94, 0.25);
    }
    
    .invalid-feedback {
      display: none;
      width: 100%;
      font-size: 1rem;
      color: #EA5455;
    }
    
     .invalid-feedback {
      margin-top: 0.25rem;
    }
    
    .invalid-tooltip {
      position: absolute;
      top: 100%;
      z-index: 5;
      display: none;
      max-width: 100%;
      font-size: 0.857rem;
      line-height: 1.45;
      color: #fff;
    }
    
     .invalid-tooltip {
      padding: 0.4rem 0.775rem;
      margin-top: 0.1rem;
      background-color: #ea5455;
      border-radius: 0.358rem;
    }
    
    [dir=ltr] .invalid-tooltip {
      left: 0;
    }
    
    [dir=rtl] .invalid-tooltip {
      right: 0;
    }
    [dir=ltr] .form-row > .col > .invalid-tooltip, [dir=ltr] .form-row > [class*=col-] > .invalid-tooltip {
      left: 5px;
    }
    [dir=rtl] .form-row > .col > .invalid-tooltip, [dir=rtl] .form-row > [class*=col-] > .invalid-tooltip {
      right: 5px;
    }
    
    .was-validated :invalid ~ .invalid-feedback,
    .was-validated :invalid ~ .invalid-tooltip,
    .is-invalid ~ .invalid-feedback,
    .is-invalid ~ .invalid-tooltip {
      display: block;
    }
    
     .was-validated .form-control:invalid,  .form-control.is-invalid {
      border-color: #EA5455;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23EA5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23EA5455' stroke='none'/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);
    }
    
    [dir=ltr] .was-validated .form-control:invalid, [dir=ltr] .form-control.is-invalid {
      padding-right: calc(1.45em + 0.876rem);
      background-position: right calc(0.3625em + 0.219rem) center;
    }
    
    [dir=rtl] .was-validated .form-control:invalid, [dir=rtl] .form-control.is-invalid {
      padding-left: calc(1.45em + 0.876rem);
      background-position: left calc(0.3625em + 0.219rem) center;
    }
     .was-validated .form-control:invalid:focus,  .form-control.is-invalid:focus {
      border-color: #EA5455;
      box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.25);
    }
    
    [dir=ltr] .was-validated textarea.form-control:invalid, [dir=ltr] textarea.form-control.is-invalid {
      padding-right: calc(1.45em + 0.876rem);
      background-position: top calc(0.3625em + 0.219rem) right calc(0.3625em + 0.219rem);
    }
    
    [dir=rtl] .was-validated textarea.form-control:invalid, [dir=rtl] textarea.form-control.is-invalid {
      padding-left: calc(1.45em + 0.876rem);
      background-position: top calc(0.3625em + 0.219rem) left calc(0.3625em + 0.219rem);
    }
    
     .was-validated .custom-select:invalid,  .custom-select.is-invalid {
      border-color: #EA5455;
    }
    
    [dir=ltr] .was-validated .custom-select:invalid, [dir=ltr] .custom-select.is-invalid {
      padding-right: calc(0.75em + 2.657rem);
      background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23D6D9E1' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 1rem center/10px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23EA5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23EA5455' stroke='none'/%3e%3c/svg%3e") center right 2rem/calc(0.725em + 0.438rem) calc(0.725em + 0.438rem) no-repeat;
    }
    
    [dir=rtl] .was-validated .custom-select:invalid, [dir=rtl] .custom-select.is-invalid {
      padding-left: calc(0.75em + 2.657rem);
      background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23D6D9E1' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") left 1rem center/10px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23EA5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23EA5455' stroke='none'/%3e%3c/svg%3e") center left 2rem/calc(0.725em + 0.438rem) calc(0.725em + 0.438rem) no-repeat;
    }
     .was-validated .custom-select:invalid:focus,  .custom-select.is-invalid:focus {
      border-color: #EA5455;
      box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.25);
    }
    
    .was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
      color: #EA5455;
    }
    .was-validated .form-check-input:invalid ~ .invalid-feedback,
    .was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
    .form-check-input.is-invalid ~ .invalid-tooltip {
      display: block;
    }
    
    .was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
      color: #EA5455;
    }
     .was-validated .custom-control-input:invalid ~ .custom-control-label::before,  .custom-control-input.is-invalid ~ .custom-control-label::before {
      border-color: #EA5455;
    }
     .was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before,  .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
      border-color: #f08182;
      background-color: #f08182;
    }
     .was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before,  .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
      box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.25);
    }
     .was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before,  .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
      border-color: #EA5455;
    }
    
     .was-validated .custom-file-input:invalid ~ .custom-file-label,  .custom-file-input.is-invalid ~ .custom-file-label {
      border-color: #EA5455;
    }
     .was-validated .custom-file-input:invalid:focus ~ .custom-file-label,  .custom-file-input.is-invalid:focus ~ .custom-file-label {
      border-color: #EA5455;
      box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.25);
    }
    
    .form-inline {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
    }
    .form-inline .form-check {
      width: 100%;
    }
    @media (min-width: 576px) {
      .form-inline label {
        display: flex;
        align-items: center;
        justify-content: center;
      }
       .form-inline label {
        margin-bottom: 0;
      }
      .form-inline .form-group {
        display: flex;
        flex: 0 0 auto;
        flex-flow: row wrap;
        align-items: center;
      }
       .form-inline .form-group {
        margin-bottom: 0;
      }
      .form-inline .form-control {
        display: inline-block;
        width: auto;
        vertical-align: middle;
      }
      .form-inline .form-control-plaintext {
        display: inline-block;
      }
      .form-inline .input-group,
    .form-inline .custom-select {
        width: auto;
      }
      .form-inline .form-check {
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
      }
      [dir=ltr] .form-inline .form-check {
        padding-left: 0;
      }
      [dir=rtl] .form-inline .form-check {
        padding-right: 0;
      }
      .form-inline .form-check-input {
        position: relative;
        flex-shrink: 0;
      }
       .form-inline .form-check-input {
        margin-top: 0;
      }
      [dir=ltr] .form-inline .form-check-input {
        margin-right: 0.25rem;
        margin-left: 0;
      }
      [dir=rtl] .form-inline .form-check-input {
        margin-left: 0.25rem;
        margin-right: 0;
      }
      .form-inline .custom-control {
        align-items: center;
        justify-content: center;
      }
       .form-inline .custom-control-label {
        margin-bottom: 0;
      }
    }
    
    .btn {
      display: inline-block;
      font-weight: 400;
      color: #424244;
      vertical-align: middle;
      user-select: none;
      font-size: 1rem;
      line-height: 1;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border 0s;
    }
    
     .btn {
      text-align: center;
      background-color: transparent;
      border: 1px solid transparent;
      padding: 0.72rem 1.5rem;
      border-radius: 0.358rem;
    }
    @media (prefers-reduced-motion: reduce) {
      .btn {
        transition: none;
      }
    }
    .btn:hover {
      color: #424244;
      text-decoration: none;
    }
    .btn:focus, .btn.focus {
      outline: 0;
    }
     .btn:focus,  .btn.focus {
      box-shadow: 0 0 0 0.2rem rgba(17, 74, 159, 0.25);
    }
    .btn.disabled, .btn:disabled {
      opacity: 0.65;
    }
     .btn:not(:disabled):not(.disabled) {
      cursor: pointer;
    }
    a.btn.disabled,
    fieldset:disabled a.btn {
      pointer-events: none;
    }
    
    .btn-primary {
      color: #fff;
    }
    
     .btn-primary {
      background-color: #114A9F;
      border-color: #114A9F;
    }
    .btn-primary:hover {
      color: #fff;
    }
     .btn-primary:hover {
      background-color: #0d3a7c;
      border-color: #0c3571;
    }
    .btn-primary:focus, .btn-primary.focus {
      color: #fff;
    }
     .btn-primary:focus,  .btn-primary.focus {
      background-color: #0d3a7c;
      border-color: #0c3571;
      box-shadow: 0 0 0 0.2rem rgba(53, 101, 173, 0.5);
    }
    .btn-primary.disabled, .btn-primary:disabled {
      color: #fff;
    }
     .btn-primary.disabled,  .btn-primary:disabled {
      background-color: #114A9F;
      border-color: #114A9F;
    }
    .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
      color: #fff;
    }
     .btn-primary:not(:disabled):not(.disabled):active,  .btn-primary:not(:disabled):not(.disabled).active,  .show > .btn-primary.dropdown-toggle {
      background-color: #0c3571;
      border-color: #0b2f65;
    }
     .btn-primary:not(:disabled):not(.disabled):active:focus,  .btn-primary:not(:disabled):not(.disabled).active:focus,  .show > .btn-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(53, 101, 173, 0.5);
    }
    
    .btn-secondary {
      color: #2a2e30;
    }
    
     .btn-secondary {
      background-color: #9C9EA4;
      border-color: #9C9EA4;
    }
    .btn-secondary:hover {
      color: #fff;
    }
     .btn-secondary:hover {
      background-color: #888a92;
      border-color: #81848c;
    }
    .btn-secondary:focus, .btn-secondary.focus {
      color: #fff;
    }
     .btn-secondary:focus,  .btn-secondary.focus {
      background-color: #888a92;
      border-color: #81848c;
      box-shadow: 0 0 0 0.2rem rgba(139, 141, 147, 0.5);
    }
    .btn-secondary.disabled, .btn-secondary:disabled {
      color: #2a2e30;
    }
     .btn-secondary.disabled,  .btn-secondary:disabled {
      background-color: #9C9EA4;
      border-color: #9C9EA4;
    }
    .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
      color: #fff;
    }
     .btn-secondary:not(:disabled):not(.disabled):active,  .btn-secondary:not(:disabled):not(.disabled).active,  .show > .btn-secondary.dropdown-toggle {
      background-color: #81848c;
      border-color: #7b7d85;
    }
     .btn-secondary:not(:disabled):not(.disabled):active:focus,  .btn-secondary:not(:disabled):not(.disabled).active:focus,  .show > .btn-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(139, 141, 147, 0.5);
    }
    
    .btn-success {
      color: #fff;
    }
    
     .btn-success {
      background-color: #17B75E;
      border-color: #17B75E;
    }
    .btn-success:hover {
      color: #fff;
    }
     .btn-success:hover {
      background-color: #13954d;
      border-color: #118a47;
    }
    .btn-success:focus, .btn-success.focus {
      color: #fff;
    }
     .btn-success:focus,  .btn-success.focus {
      background-color: #13954d;
      border-color: #118a47;
      box-shadow: 0 0 0 0.2rem rgba(58, 194, 118, 0.5);
    }
    .btn-success.disabled, .btn-success:disabled {
      color: #fff;
    }
     .btn-success.disabled,  .btn-success:disabled {
      background-color: #17B75E;
      border-color: #17B75E;
    }
    .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
      color: #fff;
    }
     .btn-success:not(:disabled):not(.disabled):active,  .btn-success:not(:disabled):not(.disabled).active,  .show > .btn-success.dropdown-toggle {
      background-color: #118a47;
      border-color: #107e41;
    }
     .btn-success:not(:disabled):not(.disabled):active:focus,  .btn-success:not(:disabled):not(.disabled).active:focus,  .show > .btn-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(58, 194, 118, 0.5);
    }
    
    .btn-info {
      color: #fff;
    }
    
     .btn-info {
      background-color: #00CFE8;
      border-color: #00CFE8;
    }
    .btn-info:hover {
      color: #fff;
    }
     .btn-info:hover {
      background-color: #00adc2;
      border-color: #00a1b5;
    }
    .btn-info:focus, .btn-info.focus {
      color: #fff;
    }
     .btn-info:focus,  .btn-info.focus {
      background-color: #00adc2;
      border-color: #00a1b5;
      box-shadow: 0 0 0 0.2rem rgba(38, 214, 235, 0.5);
    }
    .btn-info.disabled, .btn-info:disabled {
      color: #fff;
    }
     .btn-info.disabled,  .btn-info:disabled {
      background-color: #00CFE8;
      border-color: #00CFE8;
    }
    .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
      color: #fff;
    }
     .btn-info:not(:disabled):not(.disabled):active,  .btn-info:not(:disabled):not(.disabled).active,  .show > .btn-info.dropdown-toggle {
      background-color: #00a1b5;
      border-color: #0096a8;
    }
     .btn-info:not(:disabled):not(.disabled):active:focus,  .btn-info:not(:disabled):not(.disabled).active:focus,  .show > .btn-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(38, 214, 235, 0.5);
    }
    
    .btn-warning {
      color: #2a2e30;
    }
    
     .btn-warning {
      background-color: #FDB913;
      border-color: #FDB913;
    }
    .btn-warning:hover {
      color: #2a2e30;
    }
     .btn-warning:hover {
      background-color: #e8a502;
      border-color: #db9c02;
    }
    .btn-warning:focus, .btn-warning.focus {
      color: #2a2e30;
    }
     .btn-warning:focus,  .btn-warning.focus {
      background-color: #e8a502;
      border-color: #db9c02;
      box-shadow: 0 0 0 0.2rem rgba(221, 164, 23, 0.5);
    }
    .btn-warning.disabled, .btn-warning:disabled {
      color: #2a2e30;
    }
     .btn-warning.disabled,  .btn-warning:disabled {
      background-color: #FDB913;
      border-color: #FDB913;
    }
    .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
      color: #2a2e30;
    }
     .btn-warning:not(:disabled):not(.disabled):active,  .btn-warning:not(:disabled):not(.disabled).active,  .show > .btn-warning.dropdown-toggle {
      background-color: #db9c02;
      border-color: #cf9302;
    }
     .btn-warning:not(:disabled):not(.disabled):active:focus,  .btn-warning:not(:disabled):not(.disabled).active:focus,  .show > .btn-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(221, 164, 23, 0.5);
    }
    
    .btn-danger {
      color: #fff;
    }
    
     .btn-danger {
      background-color: #EA5455;
      border-color: #EA5455;
    }
    .btn-danger:hover {
      color: #fff;
    }
     .btn-danger:hover {
      background-color: #e63233;
      border-color: #e42728;
    }
    .btn-danger:focus, .btn-danger.focus {
      color: #fff;
    }
     .btn-danger:focus,  .btn-danger.focus {
      background-color: #e63233;
      border-color: #e42728;
      box-shadow: 0 0 0 0.2rem rgba(237, 110, 111, 0.5);
    }
    .btn-danger.disabled, .btn-danger:disabled {
      color: #fff;
    }
     .btn-danger.disabled,  .btn-danger:disabled {
      background-color: #EA5455;
      border-color: #EA5455;
    }
    .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
      color: #fff;
    }
     .btn-danger:not(:disabled):not(.disabled):active,  .btn-danger:not(:disabled):not(.disabled).active,  .show > .btn-danger.dropdown-toggle {
      background-color: #e42728;
      border-color: #e21c1d;
    }
     .btn-danger:not(:disabled):not(.disabled):active:focus,  .btn-danger:not(:disabled):not(.disabled).active:focus,  .show > .btn-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(237, 110, 111, 0.5);
    }
    
    .btn-light {
      color: #2a2e30;
    }
    
     .btn-light {
      background-color: #C1C1C1;
      border-color: #C1C1C1;
    }
    .btn-light:hover {
      color: #2a2e30;
    }
     .btn-light:hover {
      background-color: #aeaeae;
      border-color: #a8a8a8;
    }
    .btn-light:focus, .btn-light.focus {
      color: #2a2e30;
    }
     .btn-light:focus,  .btn-light.focus {
      background-color: #aeaeae;
      border-color: #a8a8a8;
      box-shadow: 0 0 0 0.2rem rgba(170, 171, 171, 0.5);
    }
    .btn-light.disabled, .btn-light:disabled {
      color: #2a2e30;
    }
     .btn-light.disabled,  .btn-light:disabled {
      background-color: #C1C1C1;
      border-color: #C1C1C1;
    }
    .btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
      color: #2a2e30;
    }
     .btn-light:not(:disabled):not(.disabled):active,  .btn-light:not(:disabled):not(.disabled).active,  .show > .btn-light.dropdown-toggle {
      background-color: #a8a8a8;
      border-color: #a1a1a1;
    }
     .btn-light:not(:disabled):not(.disabled):active:focus,  .btn-light:not(:disabled):not(.disabled).active:focus,  .show > .btn-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(170, 171, 171, 0.5);
    }
    
    .btn-dark {
      color: #fff;
    }
    
     .btn-dark {
      background-color: #4B4B4B;
      border-color: #4B4B4B;
    }
    .btn-dark:hover {
      color: #fff;
    }
     .btn-dark:hover {
      background-color: #383838;
      border-color: #323232;
    }
    .btn-dark:focus, .btn-dark.focus {
      color: #fff;
    }
     .btn-dark:focus,  .btn-dark.focus {
      background-color: #383838;
      border-color: #323232;
      box-shadow: 0 0 0 0.2rem rgba(102, 102, 102, 0.5);
    }
    .btn-dark.disabled, .btn-dark:disabled {
      color: #fff;
    }
     .btn-dark.disabled,  .btn-dark:disabled {
      background-color: #4B4B4B;
      border-color: #4B4B4B;
    }
    .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
      color: #fff;
    }
     .btn-dark:not(:disabled):not(.disabled):active,  .btn-dark:not(:disabled):not(.disabled).active,  .show > .btn-dark.dropdown-toggle {
      background-color: #323232;
      border-color: #2b2b2b;
    }
     .btn-dark:not(:disabled):not(.disabled):active:focus,  .btn-dark:not(:disabled):not(.disabled).active:focus,  .show > .btn-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(102, 102, 102, 0.5);
    }
    
    .btn-outline-primary {
      color: #114A9F;
    }
    
     .btn-outline-primary {
      border-color: #114A9F;
    }
    .btn-outline-primary:hover {
      color: #fff;
    }
     .btn-outline-primary:hover {
      background-color: #114A9F;
      border-color: #114A9F;
    }
     .btn-outline-primary:focus,  .btn-outline-primary.focus {
      box-shadow: 0 0 0 0.2rem rgba(17, 74, 159, 0.5);
    }
    .btn-outline-primary.disabled, .btn-outline-primary:disabled {
      color: #114A9F;
    }
     .btn-outline-primary.disabled,  .btn-outline-primary:disabled {
      background-color: transparent;
    }
    .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
      color: #fff;
    }
     .btn-outline-primary:not(:disabled):not(.disabled):active,  .btn-outline-primary:not(:disabled):not(.disabled).active,  .show > .btn-outline-primary.dropdown-toggle {
      background-color: #114A9F;
      border-color: #114A9F;
    }
     .btn-outline-primary:not(:disabled):not(.disabled):active:focus,  .btn-outline-primary:not(:disabled):not(.disabled).active:focus,  .show > .btn-outline-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(17, 74, 159, 0.5);
    }
    
    .btn-outline-secondary {
      color: #9C9EA4;
    }
    
     .btn-outline-secondary {
      border-color: #9C9EA4;
    }
    .btn-outline-secondary:hover {
      color: #2a2e30;
    }
     .btn-outline-secondary:hover {
      background-color: #9C9EA4;
      border-color: #9C9EA4;
    }
     .btn-outline-secondary:focus,  .btn-outline-secondary.focus {
      box-shadow: 0 0 0 0.2rem rgba(156, 158, 164, 0.5);
    }
    .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
      color: #9C9EA4;
    }
     .btn-outline-secondary.disabled,  .btn-outline-secondary:disabled {
      background-color: transparent;
    }
    .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
      color: #2a2e30;
    }
     .btn-outline-secondary:not(:disabled):not(.disabled):active,  .btn-outline-secondary:not(:disabled):not(.disabled).active,  .show > .btn-outline-secondary.dropdown-toggle {
      background-color: #9C9EA4;
      border-color: #9C9EA4;
    }
     .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,  .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,  .show > .btn-outline-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(156, 158, 164, 0.5);
    }
    
    .btn-outline-success {
      color: #17B75E;
    }
    
     .btn-outline-success {
      border-color: #17B75E;
    }
    .btn-outline-success:hover {
      color: #fff;
    }
     .btn-outline-success:hover {
      background-color: #17B75E;
      border-color: #17B75E;
    }
     .btn-outline-success:focus,  .btn-outline-success.focus {
      box-shadow: 0 0 0 0.2rem rgba(23, 183, 94, 0.5);
    }
    .btn-outline-success.disabled, .btn-outline-success:disabled {
      color: #17B75E;
    }
     .btn-outline-success.disabled,  .btn-outline-success:disabled {
      background-color: transparent;
    }
    .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
      color: #fff;
    }
     .btn-outline-success:not(:disabled):not(.disabled):active,  .btn-outline-success:not(:disabled):not(.disabled).active,  .show > .btn-outline-success.dropdown-toggle {
      background-color: #17B75E;
      border-color: #17B75E;
    }
     .btn-outline-success:not(:disabled):not(.disabled):active:focus,  .btn-outline-success:not(:disabled):not(.disabled).active:focus,  .show > .btn-outline-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(23, 183, 94, 0.5);
    }
    
    .btn-outline-info {
      color: #00CFE8;
    }
    
     .btn-outline-info {
      border-color: #00CFE8;
    }
    .btn-outline-info:hover {
      color: #fff;
    }
     .btn-outline-info:hover {
      background-color: #00CFE8;
      border-color: #00CFE8;
    }
     .btn-outline-info:focus,  .btn-outline-info.focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 207, 232, 0.5);
    }
    .btn-outline-info.disabled, .btn-outline-info:disabled {
      color: #00CFE8;
    }
     .btn-outline-info.disabled,  .btn-outline-info:disabled {
      background-color: transparent;
    }
    .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
      color: #fff;
    }
     .btn-outline-info:not(:disabled):not(.disabled):active,  .btn-outline-info:not(:disabled):not(.disabled).active,  .show > .btn-outline-info.dropdown-toggle {
      background-color: #00CFE8;
      border-color: #00CFE8;
    }
     .btn-outline-info:not(:disabled):not(.disabled):active:focus,  .btn-outline-info:not(:disabled):not(.disabled).active:focus,  .show > .btn-outline-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 207, 232, 0.5);
    }
    
    .btn-outline-warning {
      color: #FDB913;
    }
    
     .btn-outline-warning {
      border-color: #FDB913;
    }
    .btn-outline-warning:hover {
      color: #2a2e30;
    }
     .btn-outline-warning:hover {
      background-color: #FDB913;
      border-color: #FDB913;
    }
     .btn-outline-warning:focus,  .btn-outline-warning.focus {
      box-shadow: 0 0 0 0.2rem rgba(253, 185, 19, 0.5);
    }
    .btn-outline-warning.disabled, .btn-outline-warning:disabled {
      color: #FDB913;
    }
     .btn-outline-warning.disabled,  .btn-outline-warning:disabled {
      background-color: transparent;
    }
    .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
      color: #2a2e30;
    }
     .btn-outline-warning:not(:disabled):not(.disabled):active,  .btn-outline-warning:not(:disabled):not(.disabled).active,  .show > .btn-outline-warning.dropdown-toggle {
      background-color: #FDB913;
      border-color: #FDB913;
    }
     .btn-outline-warning:not(:disabled):not(.disabled):active:focus,  .btn-outline-warning:not(:disabled):not(.disabled).active:focus,  .show > .btn-outline-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(253, 185, 19, 0.5);
    }
    
    .btn-outline-danger {
      color: #EA5455;
    }
    
     .btn-outline-danger {
      border-color: #EA5455;
    }
    .btn-outline-danger:hover {
      color: #fff;
    }
     .btn-outline-danger:hover {
      background-color: #EA5455;
      border-color: #EA5455;
    }
     .btn-outline-danger:focus,  .btn-outline-danger.focus {
      box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.5);
    }
    .btn-outline-danger.disabled, .btn-outline-danger:disabled {
      color: #EA5455;
    }
     .btn-outline-danger.disabled,  .btn-outline-danger:disabled {
      background-color: transparent;
    }
    .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
      color: #fff;
    }
     .btn-outline-danger:not(:disabled):not(.disabled):active,  .btn-outline-danger:not(:disabled):not(.disabled).active,  .show > .btn-outline-danger.dropdown-toggle {
      background-color: #EA5455;
      border-color: #EA5455;
    }
     .btn-outline-danger:not(:disabled):not(.disabled):active:focus,  .btn-outline-danger:not(:disabled):not(.disabled).active:focus,  .show > .btn-outline-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.5);
    }
    
    .btn-outline-light {
      color: #C1C1C1;
    }
    
     .btn-outline-light {
      border-color: #C1C1C1;
    }
    .btn-outline-light:hover {
      color: #2a2e30;
    }
     .btn-outline-light:hover {
      background-color: #C1C1C1;
      border-color: #C1C1C1;
    }
     .btn-outline-light:focus,  .btn-outline-light.focus {
      box-shadow: 0 0 0 0.2rem rgba(193, 193, 193, 0.5);
    }
    .btn-outline-light.disabled, .btn-outline-light:disabled {
      color: #C1C1C1;
    }
     .btn-outline-light.disabled,  .btn-outline-light:disabled {
      background-color: transparent;
    }
    .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
      color: #2a2e30;
    }
     .btn-outline-light:not(:disabled):not(.disabled):active,  .btn-outline-light:not(:disabled):not(.disabled).active,  .show > .btn-outline-light.dropdown-toggle {
      background-color: #C1C1C1;
      border-color: #C1C1C1;
    }
     .btn-outline-light:not(:disabled):not(.disabled):active:focus,  .btn-outline-light:not(:disabled):not(.disabled).active:focus,  .show > .btn-outline-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(193, 193, 193, 0.5);
    }
    
    .btn-outline-dark {
      color: #4B4B4B;
    }
    
     .btn-outline-dark {
      border-color: #4B4B4B;
    }
    .btn-outline-dark:hover {
      color: #fff;
    }
     .btn-outline-dark:hover {
      background-color: #4B4B4B;
      border-color: #4B4B4B;
    }
     .btn-outline-dark:focus,  .btn-outline-dark.focus {
      box-shadow: 0 0 0 0.2rem rgba(75, 75, 75, 0.5);
    }
    .btn-outline-dark.disabled, .btn-outline-dark:disabled {
      color: #4B4B4B;
    }
     .btn-outline-dark.disabled,  .btn-outline-dark:disabled {
      background-color: transparent;
    }
    .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
      color: #fff;
    }
     .btn-outline-dark:not(:disabled):not(.disabled):active,  .btn-outline-dark:not(:disabled):not(.disabled).active,  .show > .btn-outline-dark.dropdown-toggle {
      background-color: #4B4B4B;
      border-color: #4B4B4B;
    }
     .btn-outline-dark:not(:disabled):not(.disabled):active:focus,  .btn-outline-dark:not(:disabled):not(.disabled).active:focus,  .show > .btn-outline-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(75, 75, 75, 0.5);
    }
    
    .btn-link {
      font-weight: 400;
      color: #114A9F;
      text-decoration: none;
    }
    .btn-link:hover {
      color: #0f3f88;
      text-decoration: none;
    }
    .btn-link:focus, .btn-link.focus {
      text-decoration: none;
    }
    .btn-link:disabled, .btn-link.disabled {
      color: #b8c2cc;
      pointer-events: none;
    }
    
    .btn-lg, .btn-group-lg > .btn {
      font-size: 1.25rem;
      line-height: 1.25;
    }
    
     .btn-lg,  .btn-group-lg > .btn {
      padding: 0.8rem 2rem;
      border-radius: 0.358rem;
    }
    
    .btn-sm, .btn-group-sm > .btn {
      font-size: 0.9rem;
      line-height: 1;
    }
    
     .btn-sm,  .btn-group-sm > .btn {
      padding: 0.486rem 1rem;
      border-radius: 0.358rem;
    }
    
    .btn-block {
      display: block;
      width: 100%;
    }
     .btn-block + .btn-block {
      margin-top: 0.5rem;
    }
    
    input[type=submit].btn-block,
    input[type=reset].btn-block,
    input[type=button].btn-block {
      width: 100%;
    }
    
    .fade {
      transition: opacity 0.15s linear;
    }
    @media (prefers-reduced-motion: reduce) {
      .fade {
        transition: none;
      }
    }
    .fade:not(.show) {
      opacity: 0;
    }
    
    .collapse:not(.show) {
      display: none;
    }
    
    .collapsing {
      position: relative;
      height: 0;
      overflow: hidden;
      transition: height 0.35s ease;
    }
    @media (prefers-reduced-motion: reduce) {
      .collapsing {
        transition: none;
      }
    }
    
    .dropup,
    .dropright,
    .dropdown,
    .dropleft {
      position: relative;
    }
    
    .dropdown-toggle {
      white-space: nowrap;
    }
    .dropdown-toggle::after {
      display: inline-block;
      vertical-align: 0.255em;
      content: "";
    }
     .dropdown-toggle::after {
      border-top: 0.3em solid;
      border-bottom: 0;
    }
    [dir=ltr] .dropdown-toggle::after {
      margin-left: 0.255em;
      border-right: 0.3em solid transparent;
      border-left: 0.3em solid transparent;
    }
    [dir=rtl] .dropdown-toggle::after {
      margin-right: 0.255em;
      border-left: 0.3em solid transparent;
      border-right: 0.3em solid transparent;
    }
    [dir=ltr] .dropdown-toggle:empty::after {
      margin-left: 0;
    }
    [dir=rtl] .dropdown-toggle:empty::after {
      margin-right: 0;
    }
    
    .dropdown-menu {
      position: absolute;
      top: 100%;
      z-index: 10;
      display: none;
      min-width: 10rem;
      font-size: 1rem;
      color: #424244;
      list-style: none;
    }
    
     .dropdown-menu {
      padding: 0.5rem 0;
      margin: 0 0 0;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid rgba(34, 41, 47, 0.05);
      border-radius: 0.358rem;
    }
    
    [dir=ltr] .dropdown-menu {
      left: 0;
      float: left;
      text-align: left;
    }
    
    [dir=rtl] .dropdown-menu {
      right: 0;
      float: right;
      text-align: right;
    }
    
    [dir=ltr] .dropdown-menu-left {
      right: auto;
      left: 0;
    }
    
    [dir=rtl] .dropdown-menu-left {
      left: auto;
      right: 0;
    }
    
    [dir=ltr] .dropdown-menu-right {
      right: 0;
      left: auto;
    }
    
    [dir=rtl] .dropdown-menu-right {
      left: 0;
      right: auto;
    }
    
    @media (min-width: 576px) {
      [dir=ltr] .dropdown-menu-sm-left {
        right: auto;
        left: 0;
      }
      [dir=rtl] .dropdown-menu-sm-left {
        left: auto;
        right: 0;
      }
    
      [dir=ltr] .dropdown-menu-sm-right {
        right: 0;
        left: auto;
      }
    
      [dir=rtl] .dropdown-menu-sm-right {
        left: 0;
        right: auto;
      }
    }
    @media (min-width: 768px) {
      [dir=ltr] .dropdown-menu-md-left {
        right: auto;
        left: 0;
      }
      [dir=rtl] .dropdown-menu-md-left {
        left: auto;
        right: 0;
      }
    
      [dir=ltr] .dropdown-menu-md-right {
        right: 0;
        left: auto;
      }
    
      [dir=rtl] .dropdown-menu-md-right {
        left: 0;
        right: auto;
      }
    }
    @media (min-width: 992px) {
      [dir=ltr] .dropdown-menu-lg-left {
        right: auto;
        left: 0;
      }
      [dir=rtl] .dropdown-menu-lg-left {
        left: auto;
        right: 0;
      }
    
      [dir=ltr] .dropdown-menu-lg-right {
        right: 0;
        left: auto;
      }
    
      [dir=rtl] .dropdown-menu-lg-right {
        left: 0;
        right: auto;
      }
    }
    @media (min-width: 1200px) {
      [dir=ltr] .dropdown-menu-xl-left {
        right: auto;
        left: 0;
      }
      [dir=rtl] .dropdown-menu-xl-left {
        left: auto;
        right: 0;
      }
    
      [dir=ltr] .dropdown-menu-xl-right {
        right: 0;
        left: auto;
      }
    
      [dir=rtl] .dropdown-menu-xl-right {
        left: 0;
        right: auto;
      }
    }
    .dropup .dropdown-menu {
      top: auto;
      bottom: 100%;
    }
     .dropup .dropdown-menu {
      margin-top: 0;
      margin-bottom: 0;
    }
    .dropup .dropdown-toggle::after {
      display: inline-block;
      vertical-align: 0.255em;
      content: "";
    }
     .dropup .dropdown-toggle::after {
      border-top: 0;
      border-bottom: 0.3em solid;
    }
    [dir=ltr] .dropup .dropdown-toggle::after {
      margin-left: 0.255em;
      border-right: 0.3em solid transparent;
      border-left: 0.3em solid transparent;
    }
    [dir=rtl] .dropup .dropdown-toggle::after {
      margin-right: 0.255em;
      border-left: 0.3em solid transparent;
      border-right: 0.3em solid transparent;
    }
    [dir=ltr] .dropup .dropdown-toggle:empty::after {
      margin-left: 0;
    }
    [dir=rtl] .dropup .dropdown-toggle:empty::after {
      margin-right: 0;
    }
    
    .dropright .dropdown-menu {
      top: 0;
    }
    
     .dropright .dropdown-menu {
      margin-top: 0;
    }
    
    [dir=ltr] .dropright .dropdown-menu {
      right: auto;
      left: 100%;
      margin-left: 0;
    }
    
    [dir=rtl] .dropright .dropdown-menu {
      left: auto;
      right: 100%;
      margin-right: 0;
    }
    .dropright .dropdown-toggle::after {
      display: inline-block;
      vertical-align: 0.255em;
      content: "";
    }
     .dropright .dropdown-toggle::after {
      border-top: 0.3em solid transparent;
      border-bottom: 0.3em solid transparent;
    }
    [dir=ltr] .dropright .dropdown-toggle::after {
      margin-left: 0.255em;
      border-right: 0;
      border-left: 0.3em solid;
    }
    [dir=rtl] .dropright .dropdown-toggle::after {
      margin-right: 0.255em;
      border-left: 0;
      border-right: 0.3em solid;
    }
    [dir=ltr] .dropright .dropdown-toggle:empty::after {
      margin-left: 0;
    }
    [dir=rtl] .dropright .dropdown-toggle:empty::after {
      margin-right: 0;
    }
    .dropright .dropdown-toggle::after {
      vertical-align: 0;
    }
    
    .dropleft .dropdown-menu {
      top: 0;
    }
    
     .dropleft .dropdown-menu {
      margin-top: 0;
    }
    
    [dir=ltr] .dropleft .dropdown-menu {
      right: 100%;
      left: auto;
      margin-right: 0;
    }
    
    [dir=rtl] .dropleft .dropdown-menu {
      left: 100%;
      right: auto;
      margin-left: 0;
    }
    .dropleft .dropdown-toggle::after {
      display: inline-block;
      vertical-align: 0.255em;
      content: "";
    }
    [dir=ltr] .dropleft .dropdown-toggle::after {
      margin-left: 0.255em;
    }
    [dir=rtl] .dropleft .dropdown-toggle::after {
      margin-right: 0.255em;
    }
    .dropleft .dropdown-toggle::after {
      display: none;
    }
    .dropleft .dropdown-toggle::before {
      display: inline-block;
      vertical-align: 0.255em;
      content: "";
    }
     .dropleft .dropdown-toggle::before {
      border-top: 0.3em solid transparent;
      border-bottom: 0.3em solid transparent;
    }
    [dir=ltr] .dropleft .dropdown-toggle::before {
      margin-right: 0.255em;
      border-right: 0.3em solid;
    }
    [dir=rtl] .dropleft .dropdown-toggle::before {
      margin-left: 0.255em;
      border-left: 0.3em solid;
    }
    [dir=ltr] .dropleft .dropdown-toggle:empty::after {
      margin-left: 0;
    }
    [dir=rtl] .dropleft .dropdown-toggle:empty::after {
      margin-right: 0;
    }
    .dropleft .dropdown-toggle::before {
      vertical-align: 0;
    }
    
    .dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
      bottom: auto;
    }
    
    [dir=ltr] .dropdown-menu[x-placement^=top], [dir=ltr] .dropdown-menu[x-placement^=right], [dir=ltr] .dropdown-menu[x-placement^=bottom], [dir=ltr] .dropdown-menu[x-placement^=left] {
      right: auto;
    }
    
    [dir=rtl] .dropdown-menu[x-placement^=top], [dir=rtl] .dropdown-menu[x-placement^=right], [dir=rtl] .dropdown-menu[x-placement^=bottom], [dir=rtl] .dropdown-menu[x-placement^=left] {
      left: auto;
    }
    
    .dropdown-divider {
      height: 0;
      overflow: hidden;
    }
    
     .dropdown-divider {
      margin: 0.5rem 0;
      border-top: 1px solid rgba(34, 41, 47, 0.08);
    }
    
    .dropdown-item {
      display: block;
      width: 100%;
      font-weight: 400;
      color: #424244;
      white-space: nowrap;
    }
    
     .dropdown-item {
      padding: 0.65rem 1.28rem;
      clear: both;
      text-align: inherit;
      background-color: transparent;
      border: 0;
    }
    .dropdown-item:hover, .dropdown-item:focus {
      color: #114A9F;
      text-decoration: none;
    }
     .dropdown-item:hover,  .dropdown-item:focus {
      background-color: rgba(17, 74, 159, 0.12);
    }
    .dropdown-item.active, .dropdown-item:active {
      color: #fff;
      text-decoration: none;
    }
     .dropdown-item.active,  .dropdown-item:active {
      background-color: #114A9F;
    }
    .dropdown-item.disabled, .dropdown-item:disabled {
      color: #b9b9c3;
      pointer-events: none;
    }
     .dropdown-item.disabled,  .dropdown-item:disabled {
      background-color: transparent;
    }
    
    .dropdown-menu.show {
      display: block;
    }
    
    .dropdown-header {
      display: block;
      font-size: 1rem;
      color: #424244;
      white-space: nowrap;
    }
    
     .dropdown-header {
      padding: 0.5rem 1.28rem;
      margin-bottom: 0;
    }
    
    .dropdown-item-text {
      display: block;
      color: #424244;
    }
    
     .dropdown-item-text {
      padding: 0.65rem 1.28rem;
    }
    
    .btn-group,
    .btn-group-vertical {
      position: relative;
      display: inline-flex;
      vertical-align: middle;
    }
    .btn-group > .btn,
    .btn-group-vertical > .btn {
      position: relative;
      flex: 1 1 auto;
    }
    .btn-group > .btn:hover,
    .btn-group-vertical > .btn:hover {
      z-index: 1;
    }
    .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
    .btn-group-vertical > .btn:focus,
    .btn-group-vertical > .btn:active,
    .btn-group-vertical > .btn.active {
      z-index: 1;
    }
    
    .btn-toolbar {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
    .btn-toolbar .input-group {
      width: auto;
    }
    
    [dir=ltr] .btn-group > .btn:not(:first-child), [dir=ltr] .btn-group > .btn-group:not(:first-child) {
      margin-left: -1px;
    }
    
    [dir=rtl] .btn-group > .btn:not(:first-child), [dir=rtl] .btn-group > .btn-group:not(:first-child) {
      margin-right: -1px;
    }
    [dir=ltr] .btn-group > .btn:not(:last-child):not(.dropdown-toggle), [dir=ltr] .btn-group > .btn-group:not(:last-child) > .btn {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle), [dir=rtl] .btn-group > .btn-group:not(:last-child) > .btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=ltr] .btn-group > .btn:not(:first-child), [dir=ltr] .btn-group > .btn-group:not(:first-child) > .btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .btn-group > .btn:not(:first-child), [dir=rtl] .btn-group > .btn-group:not(:first-child) > .btn {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    [dir=ltr] .dropdown-toggle-split {
      padding-right: 1.125rem;
      padding-left: 1.125rem;
    }
    
    [dir=rtl] .dropdown-toggle-split {
      padding-left: 1.125rem;
      padding-right: 1.125rem;
    }
    [dir=ltr] .dropdown-toggle-split::after, [dir=ltr] .dropup .dropdown-toggle-split::after, [dir=ltr] .dropright .dropdown-toggle-split::after {
      margin-left: 0;
    }
    [dir=rtl] .dropdown-toggle-split::after, [dir=rtl] .dropup .dropdown-toggle-split::after, [dir=rtl] .dropright .dropdown-toggle-split::after {
      margin-right: 0;
    }
    [dir=ltr] .dropleft .dropdown-toggle-split::before {
      margin-right: 0;
    }
    [dir=rtl] .dropleft .dropdown-toggle-split::before {
      margin-left: 0;
    }
    
    [dir=ltr] .btn-sm + .dropdown-toggle-split, [dir=ltr] .btn-group-sm > .btn + .dropdown-toggle-split {
      padding-right: 0.75rem;
      padding-left: 0.75rem;
    }
    
    [dir=rtl] .btn-sm + .dropdown-toggle-split, [dir=rtl] .btn-group-sm > .btn + .dropdown-toggle-split {
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
    
    [dir=ltr] .btn-lg + .dropdown-toggle-split, [dir=ltr] .btn-group-lg > .btn + .dropdown-toggle-split {
      padding-right: 1.5rem;
      padding-left: 1.5rem;
    }
    
    [dir=rtl] .btn-lg + .dropdown-toggle-split, [dir=rtl] .btn-group-lg > .btn + .dropdown-toggle-split {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
    
    .btn-group-vertical {
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }
    .btn-group-vertical > .btn,
    .btn-group-vertical > .btn-group {
      width: 100%;
    }
     .btn-group-vertical > .btn:not(:first-child),  .btn-group-vertical > .btn-group:not(:first-child) {
      margin-top: -1px;
    }
    [dir=ltr] .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle), [dir=ltr] .btn-group-vertical > .btn-group:not(:last-child) > .btn {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle), [dir=rtl] .btn-group-vertical > .btn-group:not(:last-child) > .btn {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=ltr] .btn-group-vertical > .btn:not(:first-child), [dir=ltr] .btn-group-vertical > .btn-group:not(:first-child) > .btn {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    [dir=rtl] .btn-group-vertical > .btn:not(:first-child), [dir=rtl] .btn-group-vertical > .btn-group:not(:first-child) > .btn {
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }
    
     .btn-group-toggle > .btn,  .btn-group-toggle > .btn-group > .btn {
      margin-bottom: 0;
    }
    .btn-group-toggle > .btn input[type=radio],
    .btn-group-toggle > .btn input[type=checkbox],
    .btn-group-toggle > .btn-group > .btn input[type=radio],
    .btn-group-toggle > .btn-group > .btn input[type=checkbox] {
      position: absolute;
      clip: rect(0, 0, 0, 0);
      pointer-events: none;
    }
    
    .input-group {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      width: 100%;
    }
    .input-group > .form-control,
    .input-group > .form-control-plaintext,
    .input-group > .custom-select,
    .input-group > .custom-file {
      position: relative;
      flex: 1 1 auto;
      width: 1%;
      min-width: 0;
    }
     .input-group > .form-control,  .input-group > .form-control-plaintext,  .input-group > .custom-select,  .input-group > .custom-file {
      margin-bottom: 0;
    }
    [dir=ltr] .input-group > .form-control + .form-control, [dir=ltr] .input-group > .form-control + .custom-select, [dir=ltr] .input-group > .form-control + .custom-file, [dir=ltr] .input-group > .form-control-plaintext + .form-control, [dir=ltr] .input-group > .form-control-plaintext + .custom-select, [dir=ltr] .input-group > .form-control-plaintext + .custom-file, [dir=ltr] .input-group > .custom-select + .form-control, [dir=ltr] .input-group > .custom-select + .custom-select, [dir=ltr] .input-group > .custom-select + .custom-file, [dir=ltr] .input-group > .custom-file + .form-control, [dir=ltr] .input-group > .custom-file + .custom-select, [dir=ltr] .input-group > .custom-file + .custom-file {
      margin-left: -1px;
    }
    [dir=rtl] .input-group > .form-control + .form-control, [dir=rtl] .input-group > .form-control + .custom-select, [dir=rtl] .input-group > .form-control + .custom-file, [dir=rtl] .input-group > .form-control-plaintext + .form-control, [dir=rtl] .input-group > .form-control-plaintext + .custom-select, [dir=rtl] .input-group > .form-control-plaintext + .custom-file, [dir=rtl] .input-group > .custom-select + .form-control, [dir=rtl] .input-group > .custom-select + .custom-select, [dir=rtl] .input-group > .custom-select + .custom-file, [dir=rtl] .input-group > .custom-file + .form-control, [dir=rtl] .input-group > .custom-file + .custom-select, [dir=rtl] .input-group > .custom-file + .custom-file {
      margin-right: -1px;
    }
    .input-group > .form-control:focus,
    .input-group > .custom-select:focus,
    .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
      z-index: 3;
    }
    .input-group > .custom-file .custom-file-input:focus {
      z-index: 4;
    }
    [dir=ltr] .input-group > .form-control:not(:first-child), [dir=ltr] .input-group > .custom-select:not(:first-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .input-group > .form-control:not(:first-child), [dir=rtl] .input-group > .custom-select:not(:first-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .input-group > .custom-file {
      display: flex;
      align-items: center;
    }
    [dir=ltr] .input-group > .custom-file:not(:last-child) .custom-file-label, [dir=ltr] .input-group > .custom-file:not(:first-child) .custom-file-label {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .input-group > .custom-file:not(:last-child) .custom-file-label, [dir=rtl] .input-group > .custom-file:not(:first-child) .custom-file-label {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=ltr] .input-group:not(.has-validation) > .form-control:not(:last-child), [dir=ltr] .input-group:not(.has-validation) > .custom-select:not(:last-child), [dir=ltr] .input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=rtl] .input-group:not(.has-validation) > .form-control:not(:last-child), [dir=rtl] .input-group:not(.has-validation) > .custom-select:not(:last-child), [dir=rtl] .input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=ltr] .input-group.has-validation > .form-control:nth-last-child(n+3), [dir=ltr] .input-group.has-validation > .custom-select:nth-last-child(n+3), [dir=ltr] .input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=rtl] .input-group.has-validation > .form-control:nth-last-child(n+3), [dir=rtl] .input-group.has-validation > .custom-select:nth-last-child(n+3), [dir=rtl] .input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    
    .input-group-prepend,
    .input-group-append {
      display: flex;
    }
    .input-group-prepend .btn,
    .input-group-append .btn {
      position: relative;
      z-index: 2;
    }
    .input-group-prepend .btn:focus,
    .input-group-append .btn:focus {
      z-index: 3;
    }
    [dir=ltr] .input-group-prepend .btn + .btn, [dir=ltr] .input-group-prepend .btn + .input-group-text, [dir=ltr] .input-group-prepend .input-group-text + .input-group-text, [dir=ltr] .input-group-prepend .input-group-text + .btn, [dir=ltr] .input-group-append .btn + .btn, [dir=ltr] .input-group-append .btn + .input-group-text, [dir=ltr] .input-group-append .input-group-text + .input-group-text, [dir=ltr] .input-group-append .input-group-text + .btn {
      margin-left: -1px;
    }
    [dir=rtl] .input-group-prepend .btn + .btn, [dir=rtl] .input-group-prepend .btn + .input-group-text, [dir=rtl] .input-group-prepend .input-group-text + .input-group-text, [dir=rtl] .input-group-prepend .input-group-text + .btn, [dir=rtl] .input-group-append .btn + .btn, [dir=rtl] .input-group-append .btn + .input-group-text, [dir=rtl] .input-group-append .input-group-text + .input-group-text, [dir=rtl] .input-group-append .input-group-text + .btn {
      margin-right: -1px;
    }
    
    [dir=ltr] .input-group-prepend {
      margin-right: -1px;
    }
    
    [dir=rtl] .input-group-prepend {
      margin-left: -1px;
    }
    
    [dir=ltr] .input-group-append {
      margin-left: -1px;
    }
    
    [dir=rtl] .input-group-append {
      margin-right: -1px;
    }
    
    .input-group-text {
      display: flex;
      align-items: center;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.45;
      color: #424244;
      white-space: nowrap;
    }
    
     .input-group-text {
      padding: 0.438rem 1rem;
      margin-bottom: 0;
      text-align: center;
      background-color: white;
      border: 1px solid #D6D9E1;
      border-radius: 0.357rem;
    }
     .input-group-text input[type=radio],  .input-group-text input[type=checkbox] {
      margin-top: 0;
    }
    
    .input-group-lg > .form-control:not(textarea),
    .input-group-lg > .custom-select {
      height: 3.2857rem;
    }
    
    .input-group-lg > .form-control,
    .input-group-lg > .custom-select,
    .input-group-lg > .input-group-prepend > .input-group-text,
    .input-group-lg > .input-group-append > .input-group-text,
    .input-group-lg > .input-group-prepend > .btn,
    .input-group-lg > .input-group-append > .btn {
      font-size: 1.143rem;
      line-height: 1.25;
    }
    
     .input-group-lg > .form-control,  .input-group-lg > .custom-select,  .input-group-lg > .input-group-prepend > .input-group-text,  .input-group-lg > .input-group-append > .input-group-text,  .input-group-lg > .input-group-prepend > .btn,  .input-group-lg > .input-group-append > .btn {
      padding: 0.75rem 1.143rem;
      border-radius: 0.357rem;
    }
    
    .input-group-sm > .form-control:not(textarea),
    .input-group-sm > .custom-select {
      height: 2.142rem;
    }
    
    .input-group-sm > .form-control,
    .input-group-sm > .custom-select,
    .input-group-sm > .input-group-prepend > .input-group-text,
    .input-group-sm > .input-group-append > .input-group-text,
    .input-group-sm > .input-group-prepend > .btn,
    .input-group-sm > .input-group-append > .btn {
      font-size: 0.857rem;
      line-height: 1;
    }
    
     .input-group-sm > .form-control,  .input-group-sm > .custom-select,  .input-group-sm > .input-group-prepend > .input-group-text,  .input-group-sm > .input-group-append > .input-group-text,  .input-group-sm > .input-group-prepend > .btn,  .input-group-sm > .input-group-append > .btn {
      padding: 0.188rem 0.857rem;
      border-radius: 0.357rem;
    }
    
    [dir=ltr] .input-group-lg > .custom-select, [dir=ltr] .input-group-sm > .custom-select {
      padding-right: 2rem;
    }
    
    [dir=rtl] .input-group-lg > .custom-select, [dir=rtl] .input-group-sm > .custom-select {
      padding-left: 2rem;
    }
    
    [dir=ltr] .input-group > .input-group-prepend > .btn, [dir=ltr] .input-group > .input-group-prepend > .input-group-text, [dir=ltr] .input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn, [dir=ltr] .input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text, [dir=ltr] .input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn, [dir=ltr] .input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text, [dir=ltr] .input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle), [dir=ltr] .input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    [dir=rtl] .input-group > .input-group-prepend > .btn, [dir=rtl] .input-group > .input-group-prepend > .input-group-text, [dir=rtl] .input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn, [dir=rtl] .input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text, [dir=rtl] .input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn, [dir=rtl] .input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text, [dir=rtl] .input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle), [dir=rtl] .input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    
    [dir=ltr] .input-group > .input-group-append > .btn, [dir=ltr] .input-group > .input-group-append > .input-group-text, [dir=ltr] .input-group > .input-group-prepend:not(:first-child) > .btn, [dir=ltr] .input-group > .input-group-prepend:not(:first-child) > .input-group-text, [dir=ltr] .input-group > .input-group-prepend:first-child > .btn:not(:first-child), [dir=ltr] .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    
    [dir=rtl] .input-group > .input-group-append > .btn, [dir=rtl] .input-group > .input-group-append > .input-group-text, [dir=rtl] .input-group > .input-group-prepend:not(:first-child) > .btn, [dir=rtl] .input-group > .input-group-prepend:not(:first-child) > .input-group-text, [dir=rtl] .input-group > .input-group-prepend:first-child > .btn:not(:first-child), [dir=rtl] .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    .custom-control {
      position: relative;
      z-index: 1;
      display: block;
      min-height: 1.45rem;
      color-adjust: exact;
    }
    
    [dir=ltr] .custom-control {
      padding-left: 1.5rem;
    }
    
    [dir=rtl] .custom-control {
      padding-right: 1.5rem;
    }
    
    .custom-control-inline {
      display: inline-flex;
    }
    
    [dir=ltr] .custom-control-inline {
      margin-right: 1rem;
    }
    
    [dir=rtl] .custom-control-inline {
      margin-left: 1rem;
    }
    
    .custom-control-input {
      position: absolute;
      z-index: -1;
      width: 1rem;
      height: 1.225rem;
      opacity: 0;
    }
    
    [dir=ltr] .custom-control-input {
      left: 0;
    }
    
    [dir=rtl] .custom-control-input {
      right: 0;
    }
    .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
    }
     .custom-control-input:checked ~ .custom-control-label::before {
      border-color: #114A9F;
      background-color: #114A9F;
    }
     .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
     .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
      border-color: #114A9F;
    }
    .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
      color: #fff;
    }
     .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
      background-color: #73a5f0;
      border-color: #73a5f0;
    }
    .custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
      color: #b8c2cc;
    }
     .custom-control-input[disabled] ~ .custom-control-label::before,  .custom-control-input:disabled ~ .custom-control-label::before {
      background-color: #efefef;
    }
    
    .custom-control-label {
      position: relative;
      vertical-align: top;
    }
    
     .custom-control-label {
      margin-bottom: 0;
    }
    .custom-control-label::before {
      position: absolute;
      top: 0.225rem;
      display: block;
      width: 1rem;
      height: 1rem;
      pointer-events: none;
      content: "";
    }
     .custom-control-label::before {
      background-color: #fff;
      border: #d8d6de solid 1px;
    }
    [dir=ltr] .custom-control-label::before {
      left: -1.5rem;
    }
    [dir=rtl] .custom-control-label::before {
      right: -1.5rem;
    }
    .custom-control-label::after {
      position: absolute;
      top: 0.225rem;
      display: block;
      width: 1rem;
      height: 1rem;
      content: "";
    }
     .custom-control-label::after {
      background: 50%/50% 50% no-repeat;
    }
    [dir=ltr] .custom-control-label::after {
      left: -1.5rem;
    }
    [dir=rtl] .custom-control-label::after {
      right: -1.5rem;
    }
    
     .custom-checkbox .custom-control-label::before {
      border-radius: 3px;
    }
     .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9.5 7.5'%3E%3Cpolyline points='0.75 4.35 4.18 6.75 8.75 0.75' style='fill:none;stroke:%23fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px'/%3E%3C/svg%3E");
    }
     .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
      border-color: #114A9F;
      background-color: #114A9F;
    }
     .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-minus'%3E%3Cline x1='5' y1='12' x2='19' y2='12'%3E%3C/line%3E%3C/svg%3E");
    }
     .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
      background-color: rgba(17, 74, 159, 0.65);
    }
     .custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
      background-color: rgba(17, 74, 159, 0.65);
    }
    
     .custom-radio .custom-control-label::before {
      border-radius: 50%;
    }
     .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
      background-image: none;
    }
     .custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
      background-color: rgba(17, 74, 159, 0.65);
    }
    
    [dir=ltr] .custom-switch {
      padding-left: 3.5rem;
    }
    
    [dir=rtl] .custom-switch {
      padding-right: 3.5rem;
    }
    .custom-switch .custom-control-label::before {
      width: 3rem;
      pointer-events: all;
    }
     .custom-switch .custom-control-label::before {
      border-radius: 1rem;
    }
    [dir=ltr] .custom-switch .custom-control-label::before {
      left: -3.5rem;
    }
    [dir=rtl] .custom-switch .custom-control-label::before {
      right: -3.5rem;
    }
    .custom-switch .custom-control-label::after {
      top: calc(0.225rem + 2px);
      width: 1rem;
      height: 1rem;
      transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;
    }
     .custom-switch .custom-control-label::after {
      background-color: #d8d6de;
      border-radius: 1rem;
    }
    [dir=ltr] .custom-switch .custom-control-label::after {
      left: calc(-3.5rem + 2px);
    }
    [dir=rtl] .custom-switch .custom-control-label::after {
      right: calc(-3.5rem + 2px);
    }
    @media (prefers-reduced-motion: reduce) {
      .custom-switch .custom-control-label::after {
        transition: none;
      }
    }
     .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      background-color: #fff;
    }
    [dir=ltr] .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      transform: translateX(2rem);
    }
    [dir=rtl] .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      transform: translateX(-2rem);
    }
     .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
      background-color: rgba(17, 74, 159, 0.65);
    }
    
    .custom-select {
      display: inline-block;
      width: 100%;
      height: 2.6666666667rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.45;
      color: #424244;
      vertical-align: middle;
      appearance: none;
    }
    
     .custom-select {
      border: 1px solid #D6D9E1;
      border-radius: 0.357rem;
    }
    
    [dir=ltr] .custom-select {
      padding: 0.438rem 2rem 0.438rem 1rem;
      background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23D6D9E1' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 1rem center/10px 10px no-repeat;
    }
    
    [dir=rtl] .custom-select {
      padding: 0.438rem 1rem 0.438rem 2rem;
      background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23D6D9E1' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") left 1rem center/10px 10px no-repeat;
    }
    .custom-select:focus {
      outline: 0;
    }
     .custom-select:focus {
      border-color: #114A9F;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
    .custom-select:focus::-ms-value {
      color: #424244;
    }
     .custom-select:focus::-ms-value {
      background-color: #fff;
    }
    .custom-select[multiple], .custom-select[size]:not([size="1"]) {
      height: auto;
    }
     .custom-select[multiple],  .custom-select[size]:not([size="1"]) {
      background-image: none;
    }
    [dir=ltr] .custom-select[multiple], [dir=ltr] .custom-select[size]:not([size="1"]) {
      padding-right: 1rem;
    }
    [dir=rtl] .custom-select[multiple], [dir=rtl] .custom-select[size]:not([size="1"]) {
      padding-left: 1rem;
    }
    .custom-select:disabled {
      color: #b8c2cc;
    }
     .custom-select:disabled {
      background-color: #efefef;
    }
    .custom-select::-ms-expand {
      display: none;
    }
    .custom-select:-moz-focusring {
      color: transparent;
    }
     .custom-select:-moz-focusring {
      text-shadow: 0 0 0 #424244;
    }
    
    .custom-select-sm {
      height: 2.142rem;
      font-size: 0.857rem;
    }
    
     .custom-select-sm {
      padding-top: 0.188rem;
      padding-bottom: 0.188rem;
    }
    
    [dir=ltr] .custom-select-sm {
      padding-left: 0.857rem;
    }
    
    [dir=rtl] .custom-select-sm {
      padding-right: 0.857rem;
    }
    
    .custom-select-lg {
      height: 3.2857rem;
      font-size: 1.143rem;
    }
    
     .custom-select-lg {
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }
    
    [dir=ltr] .custom-select-lg {
      padding-left: 1.143rem;
    }
    
    [dir=rtl] .custom-select-lg {
      padding-right: 1.143rem;
    }
    
    .custom-file {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 2.6666666667rem;
    }
    
     .custom-file {
      margin-bottom: 0;
    }
    
    .custom-file-input {
      position: relative;
      z-index: 2;
      width: 100%;
      height: 2.6666666667rem;
      overflow: hidden;
      opacity: 0;
    }
    
     .custom-file-input {
      margin: 0;
    }
     .custom-file-input:focus ~ .custom-file-label {
      border-color: #114A9F;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
     .custom-file-input[disabled] ~ .custom-file-label,  .custom-file-input:disabled ~ .custom-file-label {
      background-color: #efefef;
    }
    .custom-file-input:lang(en) ~ .custom-file-label::after {
      content: "Browse";
    }
    .custom-file-input ~ .custom-file-label[data-browse]::after {
      content: attr(data-browse);
    }
    
    .custom-file-label {
      position: absolute;
      top: 0;
      z-index: 1;
      height: 2.6666666667rem;
      overflow: hidden;
      font-weight: 400;
      line-height: 1.45;
      color: #424244;
    }
    
     .custom-file-label {
      padding: 0.438rem 1rem;
      background-color: #fff;
      border: 1px solid #D6D9E1;
      border-radius: 0.357rem;
    }
    
    [dir=ltr] .custom-file-label {
      right: 0;
      left: 0;
    }
    
    [dir=rtl] .custom-file-label {
      left: 0;
      right: 0;
    }
    .custom-file-label::after {
      position: absolute;
      top: 0;
      bottom: 0;
      z-index: 3;
      display: block;
      height: 2.6666666667rem;
      line-height: 1.45;
      color: #424244;
      content: "Browse";
    }
     .custom-file-label::after {
      padding: 0.438rem 1rem;
      background-color: white;
    }
    [dir=ltr] .custom-file-label::after {
      right: 0;
      border-left: inherit;
      border-radius: 0 0.357rem 0.357rem 0;
    }
    [dir=rtl] .custom-file-label::after {
      left: 0;
      border-right: inherit;
      border-radius: 0.357rem 0 0 0.357rem;
    }
    
    .custom-range {
      width: 100%;
      height: 1.4rem;
      appearance: none;
    }
    
     .custom-range {
      padding: 0;
      background-color: transparent;
    }
    .custom-range:focus {
      outline: 0;
    }
     .custom-range:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
     .custom-range:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
     .custom-range:focus::-ms-thumb {
      box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
     .custom-range::-moz-focus-outer {
      border: 0;
    }
    .custom-range::-webkit-slider-thumb {
      width: 1rem;
      height: 1rem;
      transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;
      appearance: none;
    }
     .custom-range::-webkit-slider-thumb {
      margin-top: -0.25rem;
      background-color: #114A9F;
      border: 0;
      border-radius: 1rem;
    }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-webkit-slider-thumb {
        transition: none;
      }
    }
     .custom-range::-webkit-slider-thumb:active {
      background-color: #73a5f0;
    }
    .custom-range::-webkit-slider-runnable-track {
      width: 100%;
      height: 0.5rem;
      color: transparent;
    }
     .custom-range::-webkit-slider-runnable-track {
      cursor: pointer;
      background-color: #dae1e7;
      border-color: transparent;
      border-radius: 1rem;
    }
    .custom-range::-moz-range-thumb {
      width: 1rem;
      height: 1rem;
      transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;
      appearance: none;
    }
     .custom-range::-moz-range-thumb {
      background-color: #114A9F;
      border: 0;
      border-radius: 1rem;
    }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-moz-range-thumb {
        transition: none;
      }
    }
     .custom-range::-moz-range-thumb:active {
      background-color: #73a5f0;
    }
    .custom-range::-moz-range-track {
      width: 100%;
      height: 0.5rem;
      color: transparent;
    }
     .custom-range::-moz-range-track {
      cursor: pointer;
      background-color: #dae1e7;
      border-color: transparent;
      border-radius: 1rem;
    }
    .custom-range::-ms-thumb {
      width: 1rem;
      height: 1rem;
      transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;
      appearance: none;
    }
     .custom-range::-ms-thumb {
      margin-top: 0;
      background-color: #114A9F;
      border: 0;
      border-radius: 1rem;
    }
    [dir=ltr] .custom-range::-ms-thumb {
      margin-right: 0.2rem;
      margin-left: 0.2rem;
    }
    [dir=rtl] .custom-range::-ms-thumb {
      margin-left: 0.2rem;
      margin-right: 0.2rem;
    }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-ms-thumb {
        transition: none;
      }
    }
     .custom-range::-ms-thumb:active {
      background-color: #73a5f0;
    }
    .custom-range::-ms-track {
      width: 100%;
      height: 0.5rem;
      color: transparent;
    }
     .custom-range::-ms-track {
      cursor: pointer;
      background-color: transparent;
      border-color: transparent;
      border-width: 0.5rem;
    }
     .custom-range::-ms-fill-lower {
      background-color: #dae1e7;
      border-radius: 1rem;
    }
     .custom-range::-ms-fill-upper {
      background-color: #dae1e7;
      border-radius: 1rem;
    }
    [dir=ltr] .custom-range::-ms-fill-upper {
      margin-right: 15px;
    }
    [dir=rtl] .custom-range::-ms-fill-upper {
      margin-left: 15px;
    }
     .custom-range:disabled::-webkit-slider-thumb {
      background-color: #adb5bd;
    }
     .custom-range:disabled::-webkit-slider-runnable-track {
      cursor: default;
    }
     .custom-range:disabled::-moz-range-thumb {
      background-color: #adb5bd;
    }
     .custom-range:disabled::-moz-range-track {
      cursor: default;
    }
     .custom-range:disabled::-ms-thumb {
      background-color: #adb5bd;
    }
    
    .custom-control-label::before,
    .custom-file-label,
    .custom-select {
      transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;
    }
    @media (prefers-reduced-motion: reduce) {
      .custom-control-label::before,
    .custom-file-label,
    .custom-select {
        transition: none;
      }
    }
    
    .nav {
      display: flex;
      flex-wrap: wrap;
      list-style: none;
    }
    
     .nav {
      margin-bottom: 0;
    }
    
    [dir=ltr] .nav {
      padding-left: 0;
    }
    
    [dir=rtl] .nav {
      padding-right: 0;
    }
    
    .nav-link {
      display: block;
    }
    
     .nav-link {
      padding: 0.358rem 0.5rem;
    }
    .nav-link:hover, .nav-link:focus {
      text-decoration: none;
    }
    .nav-link.disabled {
      color: #b9b9c3;
      pointer-events: none;
    }
     .nav-link.disabled {
      cursor: default;
    }
    
     .nav-tabs {
      border-bottom: 0 solid #dae1e7;
    }
     .nav-tabs .nav-link {
      margin-bottom: 0;
      border: 0 solid transparent;
    }
    [dir=ltr] .nav-tabs .nav-link {
      border-top-left-radius: 0.25;
      border-top-right-radius: 0.25;
    }
    [dir=rtl] .nav-tabs .nav-link {
      border-top-right-radius: 0.25;
      border-top-left-radius: 0.25;
    }
     .nav-tabs .nav-link:hover,  .nav-tabs .nav-link:focus {
      border-color: #ededed #ededed #dae1e7;
    }
    .nav-tabs .nav-link.disabled {
      color: #b9b9c3;
    }
     .nav-tabs .nav-link.disabled {
      background-color: transparent;
      border-color: transparent;
    }
    .nav-tabs .nav-link.active,
    .nav-tabs .nav-item.show .nav-link {
      color: #114A9F;
    }
     .nav-tabs .nav-link.active,  .nav-tabs .nav-item.show .nav-link {
      background-color: transparent;
      border-color: #dae1e7 #dae1e7 transparent;
    }
     .nav-tabs .dropdown-menu {
      margin-top: 0;
    }
    [dir=ltr] .nav-tabs .dropdown-menu {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    [dir=rtl] .nav-tabs .dropdown-menu {
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }
    
     .nav-pills .nav-link {
      border-radius: 0.358rem;
    }
    .nav-pills .nav-link.active,
    .nav-pills .show > .nav-link {
      color: #fff;
    }
     .nav-pills .nav-link.active,  .nav-pills .show > .nav-link {
      background-color: #114A9F;
    }
    
    .nav-fill > .nav-link,
    .nav-fill .nav-item {
      flex: 1 1 auto;
    }
    
     .nav-fill > .nav-link,  .nav-fill .nav-item {
      text-align: center;
    }
    
    .nav-justified > .nav-link,
    .nav-justified .nav-item {
      flex-basis: 0;
      flex-grow: 1;
    }
    
     .nav-justified > .nav-link,  .nav-justified .nav-item {
      text-align: center;
    }
    
    .tab-content > .tab-pane {
      display: none;
    }
    .tab-content > .active {
      display: block;
    }
    
    .navbar {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
    }
    
     .navbar {
      padding: 0.5rem 1rem;
    }
    .navbar .container,
    .navbar .container-fluid,
    .navbar .container-sm,
    .navbar .container-md,
    .navbar .container-lg,
    .navbar .container-xl,
    .navbar .container-xxl {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
    }
    .navbar-brand {
      display: inline-block;
      font-size: 2rem;
      line-height: inherit;
      white-space: nowrap;
    }
     .navbar-brand {
      padding-top: -0.367rem;
      padding-bottom: -0.367rem;
    }
    [dir=ltr] .navbar-brand {
      margin-right: 1rem;
    }
    [dir=rtl] .navbar-brand {
      margin-left: 1rem;
    }
    .navbar-brand:hover, .navbar-brand:focus {
      text-decoration: none;
    }
    
    .navbar-nav {
      display: flex;
      flex-direction: column;
      list-style: none;
    }
    
     .navbar-nav {
      margin-bottom: 0;
    }
    
    [dir=ltr] .navbar-nav {
      padding-left: 0;
    }
    
    [dir=rtl] .navbar-nav {
      padding-right: 0;
    }
    [dir=ltr] .navbar-nav .nav-link {
      padding-right: 0;
      padding-left: 0;
    }
    [dir=rtl] .navbar-nav .nav-link {
      padding-left: 0;
      padding-right: 0;
    }
    .navbar-nav .dropdown-menu {
      position: static;
    }
     .navbar-nav .dropdown-menu {
      float: none;
    }
    
    .navbar-text {
      display: inline-block;
    }
    
     .navbar-text {
      padding-top: 0.358rem;
      padding-bottom: 0.358rem;
    }
    
    .navbar-collapse {
      flex-basis: 100%;
      flex-grow: 1;
      align-items: center;
    }
    
    .navbar-toggler {
      font-size: 2rem;
      line-height: 1;
    }
    
     .navbar-toggler {
      padding: 0.25rem 0.75rem;
      background-color: transparent;
      border: 1px solid transparent;
      border-radius: 0.358rem;
    }
    .navbar-toggler:hover, .navbar-toggler:focus {
      text-decoration: none;
    }
    
    .navbar-toggler-icon {
      display: inline-block;
      width: 1.5em;
      height: 1.5em;
      vertical-align: middle;
      content: "";
    }
    
     .navbar-toggler-icon {
      background: 50%/100% 100% no-repeat;
    }
    
    .navbar-nav-scroll {
      max-height: 75vh;
      overflow-y: auto;
    }
    
    @media (max-width: 575.98px) {
      [dir=ltr] .navbar-expand-sm > .container, [dir=ltr] .navbar-expand-sm > .container-fluid, [dir=ltr] .navbar-expand-sm > .container-sm, [dir=ltr] .navbar-expand-sm > .container-md, [dir=ltr] .navbar-expand-sm > .container-lg, [dir=ltr] .navbar-expand-sm > .container-xl, [dir=ltr] .navbar-expand-sm > .container-xxl {
        padding-right: 0;
        padding-left: 0;
      }
      [dir=rtl] .navbar-expand-sm > .container, [dir=rtl] .navbar-expand-sm > .container-fluid, [dir=rtl] .navbar-expand-sm > .container-sm, [dir=rtl] .navbar-expand-sm > .container-md, [dir=rtl] .navbar-expand-sm > .container-lg, [dir=rtl] .navbar-expand-sm > .container-xl, [dir=rtl] .navbar-expand-sm > .container-xxl {
        padding-left: 0;
        padding-right: 0;
      }
    }
    @media (min-width: 576px) {
      .navbar-expand-sm {
        flex-flow: row nowrap;
        justify-content: flex-start;
      }
      .navbar-expand-sm .navbar-nav {
        flex-direction: row;
      }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute;
      }
      [dir=ltr] .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem;
      }
      [dir=rtl] .navbar-expand-sm .navbar-nav .nav-link {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
      .navbar-expand-sm > .container,
    .navbar-expand-sm > .container-fluid,
    .navbar-expand-sm > .container-sm,
    .navbar-expand-sm > .container-md,
    .navbar-expand-sm > .container-lg,
    .navbar-expand-sm > .container-xl,
    .navbar-expand-sm > .container-xxl {
        flex-wrap: nowrap;
      }
      .navbar-expand-sm .navbar-nav-scroll {
        overflow: visible;
      }
      .navbar-expand-sm .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
      }
      .navbar-expand-sm .navbar-toggler {
        display: none;
      }
    }
    @media (max-width: 767.98px) {
      [dir=ltr] .navbar-expand-md > .container, [dir=ltr] .navbar-expand-md > .container-fluid, [dir=ltr] .navbar-expand-md > .container-sm, [dir=ltr] .navbar-expand-md > .container-md, [dir=ltr] .navbar-expand-md > .container-lg, [dir=ltr] .navbar-expand-md > .container-xl, [dir=ltr] .navbar-expand-md > .container-xxl {
        padding-right: 0;
        padding-left: 0;
      }
      [dir=rtl] .navbar-expand-md > .container, [dir=rtl] .navbar-expand-md > .container-fluid, [dir=rtl] .navbar-expand-md > .container-sm, [dir=rtl] .navbar-expand-md > .container-md, [dir=rtl] .navbar-expand-md > .container-lg, [dir=rtl] .navbar-expand-md > .container-xl, [dir=rtl] .navbar-expand-md > .container-xxl {
        padding-left: 0;
        padding-right: 0;
      }
    }
    @media (min-width: 768px) {
      .navbar-expand-md {
        flex-flow: row nowrap;
        justify-content: flex-start;
      }
      .navbar-expand-md .navbar-nav {
        flex-direction: row;
      }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute;
      }
      [dir=ltr] .navbar-expand-md .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem;
      }
      [dir=rtl] .navbar-expand-md .navbar-nav .nav-link {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
      .navbar-expand-md > .container,
    .navbar-expand-md > .container-fluid,
    .navbar-expand-md > .container-sm,
    .navbar-expand-md > .container-md,
    .navbar-expand-md > .container-lg,
    .navbar-expand-md > .container-xl,
    .navbar-expand-md > .container-xxl {
        flex-wrap: nowrap;
      }
      .navbar-expand-md .navbar-nav-scroll {
        overflow: visible;
      }
      .navbar-expand-md .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
      }
      .navbar-expand-md .navbar-toggler {
        display: none;
      }
    }
    @media (max-width: 991.98px) {
      [dir=ltr] .navbar-expand-lg > .container, [dir=ltr] .navbar-expand-lg > .container-fluid, [dir=ltr] .navbar-expand-lg > .container-sm, [dir=ltr] .navbar-expand-lg > .container-md, [dir=ltr] .navbar-expand-lg > .container-lg, [dir=ltr] .navbar-expand-lg > .container-xl, [dir=ltr] .navbar-expand-lg > .container-xxl {
        padding-right: 0;
        padding-left: 0;
      }
      [dir=rtl] .navbar-expand-lg > .container, [dir=rtl] .navbar-expand-lg > .container-fluid, [dir=rtl] .navbar-expand-lg > .container-sm, [dir=rtl] .navbar-expand-lg > .container-md, [dir=rtl] .navbar-expand-lg > .container-lg, [dir=rtl] .navbar-expand-lg > .container-xl, [dir=rtl] .navbar-expand-lg > .container-xxl {
        padding-left: 0;
        padding-right: 0;
      }
    }
    @media (min-width: 992px) {
      .navbar-expand-lg {
        flex-flow: row nowrap;
        justify-content: flex-start;
      }
      .navbar-expand-lg .navbar-nav {
        flex-direction: row;
      }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute;
      }
      [dir=ltr] .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem;
      }
      [dir=rtl] .navbar-expand-lg .navbar-nav .nav-link {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
      .navbar-expand-lg > .container,
    .navbar-expand-lg > .container-fluid,
    .navbar-expand-lg > .container-sm,
    .navbar-expand-lg > .container-md,
    .navbar-expand-lg > .container-lg,
    .navbar-expand-lg > .container-xl,
    .navbar-expand-lg > .container-xxl {
        flex-wrap: nowrap;
      }
      .navbar-expand-lg .navbar-nav-scroll {
        overflow: visible;
      }
      .navbar-expand-lg .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
      }
      .navbar-expand-lg .navbar-toggler {
        display: none;
      }
    }
    @media (max-width: 1199.98px) {
      [dir=ltr] .navbar-expand-xl > .container, [dir=ltr] .navbar-expand-xl > .container-fluid, [dir=ltr] .navbar-expand-xl > .container-sm, [dir=ltr] .navbar-expand-xl > .container-md, [dir=ltr] .navbar-expand-xl > .container-lg, [dir=ltr] .navbar-expand-xl > .container-xl, [dir=ltr] .navbar-expand-xl > .container-xxl {
        padding-right: 0;
        padding-left: 0;
      }
      [dir=rtl] .navbar-expand-xl > .container, [dir=rtl] .navbar-expand-xl > .container-fluid, [dir=rtl] .navbar-expand-xl > .container-sm, [dir=rtl] .navbar-expand-xl > .container-md, [dir=rtl] .navbar-expand-xl > .container-lg, [dir=rtl] .navbar-expand-xl > .container-xl, [dir=rtl] .navbar-expand-xl > .container-xxl {
        padding-left: 0;
        padding-right: 0;
      }
    }
    @media (min-width: 1200px) {
      .navbar-expand-xl {
        flex-flow: row nowrap;
        justify-content: flex-start;
      }
      .navbar-expand-xl .navbar-nav {
        flex-direction: row;
      }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute;
      }
      [dir=ltr] .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem;
      }
      [dir=rtl] .navbar-expand-xl .navbar-nav .nav-link {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
      .navbar-expand-xl > .container,
    .navbar-expand-xl > .container-fluid,
    .navbar-expand-xl > .container-sm,
    .navbar-expand-xl > .container-md,
    .navbar-expand-xl > .container-lg,
    .navbar-expand-xl > .container-xl,
    .navbar-expand-xl > .container-xxl {
        flex-wrap: nowrap;
      }
      .navbar-expand-xl .navbar-nav-scroll {
        overflow: visible;
      }
      .navbar-expand-xl .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
      }
      .navbar-expand-xl .navbar-toggler {
        display: none;
      }
    }
    .navbar-expand {
      flex-flow: row nowrap;
      justify-content: flex-start;
    }
    [dir=ltr] .navbar-expand > .container, [dir=ltr] .navbar-expand > .container-fluid, [dir=ltr] .navbar-expand > .container-sm, [dir=ltr] .navbar-expand > .container-md, [dir=ltr] .navbar-expand > .container-lg, [dir=ltr] .navbar-expand > .container-xl, [dir=ltr] .navbar-expand > .container-xxl {
      padding-right: 0;
      padding-left: 0;
    }
    [dir=rtl] .navbar-expand > .container, [dir=rtl] .navbar-expand > .container-fluid, [dir=rtl] .navbar-expand > .container-sm, [dir=rtl] .navbar-expand > .container-md, [dir=rtl] .navbar-expand > .container-lg, [dir=rtl] .navbar-expand > .container-xl, [dir=rtl] .navbar-expand > .container-xxl {
      padding-left: 0;
      padding-right: 0;
    }
    .navbar-expand .navbar-nav {
      flex-direction: row;
    }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute;
    }
    [dir=ltr] .navbar-expand .navbar-nav .nav-link {
      padding-right: 0.5rem;
      padding-left: 0.5rem;
    }
    [dir=rtl] .navbar-expand .navbar-nav .nav-link {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
    .navbar-expand > .container,
    .navbar-expand > .container-fluid,
    .navbar-expand > .container-sm,
    .navbar-expand > .container-md,
    .navbar-expand > .container-lg,
    .navbar-expand > .container-xl,
    .navbar-expand > .container-xxl {
      flex-wrap: nowrap;
    }
    .navbar-expand .navbar-nav-scroll {
      overflow: visible;
    }
    .navbar-expand .navbar-collapse {
      display: flex !important;
      flex-basis: auto;
    }
    .navbar-expand .navbar-toggler {
      display: none;
    }
    
    .navbar-light .navbar-brand {
      color: rgba(34, 41, 47, 0.9);
    }
    .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
      color: rgba(34, 41, 47, 0.9);
    }
    .navbar-light .navbar-nav .nav-link {
      color: rgba(34, 41, 47, 0.5);
    }
    .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
      color: rgba(34, 41, 47, 0.7);
    }
    .navbar-light .navbar-nav .nav-link.disabled {
      color: rgba(34, 41, 47, 0.3);
    }
    .navbar-light .navbar-nav .show > .nav-link,
    .navbar-light .navbar-nav .active > .nav-link,
    .navbar-light .navbar-nav .nav-link.show,
    .navbar-light .navbar-nav .nav-link.active {
      color: rgba(34, 41, 47, 0.9);
    }
    .navbar-light .navbar-toggler {
      color: rgba(34, 41, 47, 0.5);
    }
     .navbar-light .navbar-toggler {
      border-color: rgba(34, 41, 47, 0.1);
    }
     .navbar-light .navbar-toggler-icon {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2834, 41, 47, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
    }
    .navbar-light .navbar-text {
      color: rgba(34, 41, 47, 0.5);
    }
    .navbar-light .navbar-text a {
      color: rgba(34, 41, 47, 0.9);
    }
    .navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
      color: rgba(34, 41, 47, 0.9);
    }
    
    .navbar-dark .navbar-brand {
      color: #fff;
    }
    .navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
      color: #fff;
    }
    .navbar-dark .navbar-nav .nav-link {
      color: rgba(255, 255, 255, 0.5);
    }
    .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
      color: rgba(255, 255, 255, 0.75);
    }
    .navbar-dark .navbar-nav .nav-link.disabled {
      color: rgba(255, 255, 255, 0.25);
    }
    .navbar-dark .navbar-nav .show > .nav-link,
    .navbar-dark .navbar-nav .active > .nav-link,
    .navbar-dark .navbar-nav .nav-link.show,
    .navbar-dark .navbar-nav .nav-link.active {
      color: #fff;
    }
    .navbar-dark .navbar-toggler {
      color: rgba(255, 255, 255, 0.5);
    }
     .navbar-dark .navbar-toggler {
      border-color: rgba(255, 255, 255, 0.1);
    }
     .navbar-dark .navbar-toggler-icon {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
    }
    .navbar-dark .navbar-text {
      color: rgba(255, 255, 255, 0.5);
    }
    .navbar-dark .navbar-text a {
      color: #fff;
    }
    .navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
      color: #fff;
    }
    
    .card {
      position: relative;
      display: flex;
      flex-direction: column;
      min-width: 0;
      word-wrap: break-word;
    }
    
     .card {
      background-color: #fff;
      background-clip: border-box;
      border: 1px solid rgba(34, 41, 47, 0.125);
      border-radius: 0.428rem;
    }
    [dir=ltr] .card > hr {
      margin-right: 0;
      margin-left: 0;
    }
    [dir=rtl] .card > hr {
      margin-left: 0;
      margin-right: 0;
    }
     .card > .list-group {
      border-top: inherit;
      border-bottom: inherit;
    }
     .card > .list-group:first-child {
      border-top-width: 0;
    }
    [dir=ltr] .card > .list-group:first-child {
      border-top-left-radius: calc(0.428rem - 1px);
      border-top-right-radius: calc(0.428rem - 1px);
    }
    [dir=rtl] .card > .list-group:first-child {
      border-top-right-radius: calc(0.428rem - 1px);
      border-top-left-radius: calc(0.428rem - 1px);
    }
     .card > .list-group:last-child {
      border-bottom-width: 0;
    }
    [dir=ltr] .card > .list-group:last-child {
      border-bottom-right-radius: calc(0.428rem - 1px);
      border-bottom-left-radius: calc(0.428rem - 1px);
    }
    [dir=rtl] .card > .list-group:last-child {
      border-bottom-left-radius: calc(0.428rem - 1px);
      border-bottom-right-radius: calc(0.428rem - 1px);
    }
     .card > .card-header + .list-group,  .card > .list-group + .card-footer {
      border-top: 0;
    }
    
    .card-body {
      flex: 1 1 auto;
      min-height: 1px;
    }
    
     .card-body {
      padding: 1.5rem;
    }
    
     .card-title {
      margin-bottom: 1.5rem;
    }
    
     .card-subtitle {
      margin-top: -0.75rem;
      margin-bottom: 0;
    }
    
     .card-text:last-child {
      margin-bottom: 0;
    }
    
    .card-link:hover {
      text-decoration: none;
    }
    [dir=ltr] .card-link + .card-link {
      margin-left: 1.5rem;
    }
    [dir=rtl] .card-link + .card-link {
      margin-right: 1.5rem;
    }
    
     .card-header {
      padding: 1.5rem 1.5rem;
      margin-bottom: 0;
      background-color: rgba(34, 41, 47, 0.03);
      border-bottom: 1px solid rgba(34, 41, 47, 0.125);
    }
     .card-header:first-child {
      border-radius: calc(0.428rem - 1px) calc(0.428rem - 1px) 0 0;
    }
    
     .card-footer {
      padding: 1.5rem 1.5rem;
      background-color: rgba(34, 41, 47, 0.03);
      border-top: 1px solid rgba(34, 41, 47, 0.125);
    }
     .card-footer:last-child {
      border-radius: 0 0 calc(0.428rem - 1px) calc(0.428rem - 1px);
    }
    
     .card-header-tabs {
      margin-bottom: -1.5rem;
      border-bottom: 0;
    }
    
    [dir=ltr] .card-header-tabs {
      margin-right: -0.75rem;
      margin-left: -0.75rem;
    }
    
    [dir=rtl] .card-header-tabs {
      margin-left: -0.75rem;
      margin-right: -0.75rem;
    }
    
    [dir=ltr] .card-header-pills {
      margin-right: -0.75rem;
      margin-left: -0.75rem;
    }
    
    [dir=rtl] .card-header-pills {
      margin-left: -0.75rem;
      margin-right: -0.75rem;
    }
    
    .card-img-overlay {
      position: absolute;
      top: 0;
      bottom: 0;
    }
    
     .card-img-overlay {
      padding: 1.25rem;
      border-radius: calc(0.428rem - 1px);
    }
    
    [dir=ltr] .card-img-overlay {
      right: 0;
      left: 0;
    }
    
    [dir=rtl] .card-img-overlay {
      left: 0;
      right: 0;
    }
    
    .card-img,
    .card-img-top,
    .card-img-bottom {
      flex-shrink: 0;
      width: 100%;
    }
    
    [dir=ltr] .card-img, [dir=ltr] .card-img-top {
      border-top-left-radius: calc(0.428rem - 1px);
      border-top-right-radius: calc(0.428rem - 1px);
    }
    
    [dir=rtl] .card-img, [dir=rtl] .card-img-top {
      border-top-right-radius: calc(0.428rem - 1px);
      border-top-left-radius: calc(0.428rem - 1px);
    }
    
    [dir=ltr] .card-img, [dir=ltr] .card-img-bottom {
      border-bottom-right-radius: calc(0.428rem - 1px);
      border-bottom-left-radius: calc(0.428rem - 1px);
    }
    
    [dir=rtl] .card-img, [dir=rtl] .card-img-bottom {
      border-bottom-left-radius: calc(0.428rem - 1px);
      border-bottom-right-radius: calc(0.428rem - 1px);
    }
    
     .card-deck .card {
      margin-bottom: 1rem;
    }
    @media (min-width: 576px) {
      .card-deck {
        display: flex;
        flex-flow: row wrap;
      }
      [dir=ltr] .card-deck {
        margin-right: -1rem;
        margin-left: -1rem;
      }
      [dir=rtl] .card-deck {
        margin-left: -1rem;
        margin-right: -1rem;
      }
      .card-deck .card {
        flex: 1 0 0%;
      }
       .card-deck .card {
        margin-bottom: 0;
      }
      [dir=ltr] .card-deck .card {
        margin-right: 1rem;
        margin-left: 1rem;
      }
      [dir=rtl] .card-deck .card {
        margin-left: 1rem;
        margin-right: 1rem;
      }
    }
    
     .card-group > .card {
      margin-bottom: 1rem;
    }
    @media (min-width: 576px) {
      .card-group {
        display: flex;
        flex-flow: row wrap;
      }
      .card-group > .card {
        flex: 1 0 0%;
      }
       .card-group > .card {
        margin-bottom: 0;
      }
      [dir=ltr] .card-group > .card + .card {
        margin-left: 0;
        border-left: 0;
      }
      [dir=rtl] .card-group > .card + .card {
        margin-right: 0;
        border-right: 0;
      }
      [dir=ltr] .card-group > .card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      [dir=rtl] .card-group > .card:not(:last-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      [dir=ltr] .card-group > .card:not(:last-child) .card-img-top, [dir=ltr] .card-group > .card:not(:last-child) .card-header {
        border-top-right-radius: 0;
      }
      [dir=rtl] .card-group > .card:not(:last-child) .card-img-top, [dir=rtl] .card-group > .card:not(:last-child) .card-header {
        border-top-left-radius: 0;
      }
      [dir=ltr] .card-group > .card:not(:last-child) .card-img-bottom, [dir=ltr] .card-group > .card:not(:last-child) .card-footer {
        border-bottom-right-radius: 0;
      }
      [dir=rtl] .card-group > .card:not(:last-child) .card-img-bottom, [dir=rtl] .card-group > .card:not(:last-child) .card-footer {
        border-bottom-left-radius: 0;
      }
      [dir=ltr] .card-group > .card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      [dir=rtl] .card-group > .card:not(:first-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      [dir=ltr] .card-group > .card:not(:first-child) .card-img-top, [dir=ltr] .card-group > .card:not(:first-child) .card-header {
        border-top-left-radius: 0;
      }
      [dir=rtl] .card-group > .card:not(:first-child) .card-img-top, [dir=rtl] .card-group > .card:not(:first-child) .card-header {
        border-top-right-radius: 0;
      }
      [dir=ltr] .card-group > .card:not(:first-child) .card-img-bottom, [dir=ltr] .card-group > .card:not(:first-child) .card-footer {
        border-bottom-left-radius: 0;
      }
      [dir=rtl] .card-group > .card:not(:first-child) .card-img-bottom, [dir=rtl] .card-group > .card:not(:first-child) .card-footer {
        border-bottom-right-radius: 0;
      }
    }
    
     .card-columns .card {
      margin-bottom: 1.5rem;
    }
    @media (min-width: 576px) {
      .card-columns {
        column-count: 3;
        column-gap: 1.25rem;
        orphans: 1;
        widows: 1;
      }
      .card-columns .card {
        display: inline-block;
        width: 100%;
      }
    }
    
    .accordion {
      overflow-anchor: none;
    }
    .accordion > .card {
      overflow: hidden;
    }
     .accordion > .card:not(:last-of-type) {
      border-bottom: 0;
    }
    [dir=ltr] .accordion > .card:not(:last-of-type) {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .accordion > .card:not(:last-of-type) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=ltr] .accordion > .card:not(:first-of-type) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    [dir=rtl] .accordion > .card:not(:first-of-type) {
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }
     .accordion > .card > .card-header {
      border-radius: 0;
      margin-bottom: -1px;
    }
    
    .breadcrumb {
      display: flex;
      flex-wrap: wrap;
      font-size: 1rem;
      list-style: none;
    }
    
     .breadcrumb {
      padding: 0.3rem 1rem;
      margin-bottom: 0;
      background-color: transparent;
      border-radius: 0;
    }
    
    [dir=ltr] .breadcrumb-item + .breadcrumb-item {
      padding-left: 0.6rem;
    }
    
    [dir=rtl] .breadcrumb-item + .breadcrumb-item {
      padding-right: 0.6rem;
    }
    .breadcrumb-item + .breadcrumb-item::before {
      color: #424244;
      content: "/";
    }
    [dir=ltr] .breadcrumb-item + .breadcrumb-item::before {
      float: left;
      padding-right: 0.6rem;
    }
    [dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
      float: right;
      padding-left: 0.6rem;
    }
    .breadcrumb-item + .breadcrumb-item:hover::before {
      text-decoration: underline;
    }
    .breadcrumb-item + .breadcrumb-item:hover::before {
      text-decoration: none;
    }
    .breadcrumb-item.active {
      color: #424244;
    }
    
    .pagination {
      display: flex;
      list-style: none;
    }
    
     .pagination {
      border-radius: 0.357rem;
    }
    
    [dir=ltr] .pagination {
      padding-left: 0;
    }
    
    [dir=rtl] .pagination {
      padding-right: 0;
    }
    
    .page-link {
      position: relative;
      display: block;
      line-height: 1.25;
      color: #424244;
    }
    
     .page-link {
      padding: 0.5rem 0.85rem;
      background-color: #f3f2f7;
      border: 1px solid #dae1e7;
    }
    
    [dir=ltr] .page-link {
      margin-left: -1px;
    }
    
    [dir=rtl] .page-link {
      margin-right: -1px;
    }
    .page-link:hover {
      z-index: 2;
      color: #114A9F;
      text-decoration: none;
    }
     .page-link:hover {
      background-color: #f3f2f7;
      border-color: #dae1e7;
    }
    .page-link:focus {
      z-index: 3;
      outline: 0;
    }
     .page-link:focus {
      box-shadow: 0 0 0 0.2rem rgba(17, 74, 159, 0.25);
    }
    
    [dir=ltr] .page-item:first-child .page-link {
      margin-left: 0;
      border-top-left-radius: 0.357rem;
      border-bottom-left-radius: 0.357rem;
    }
    
    [dir=rtl] .page-item:first-child .page-link {
      margin-right: 0;
      border-top-right-radius: 0.357rem;
      border-bottom-right-radius: 0.357rem;
    }
    [dir=ltr] .page-item:last-child .page-link {
      border-top-right-radius: 0.357rem;
      border-bottom-right-radius: 0.357rem;
    }
    [dir=rtl] .page-item:last-child .page-link {
      border-top-left-radius: 0.357rem;
      border-bottom-left-radius: 0.357rem;
    }
    .page-item.active .page-link {
      z-index: 3;
      color: #114A9F;
    }
     .page-item.active .page-link {
      background-color: #114A9F;
      border-color: #114A9F;
    }
    .page-item.disabled .page-link {
      color: #b9b9c3;
      pointer-events: none;
    }
     .page-item.disabled .page-link {
      cursor: auto;
      background-color: #f3f2f7;
      border-color: #dae1e7;
    }
    
    .pagination-lg .page-link {
      font-size: 2rem;
      line-height: 1.25;
    }
    
     .pagination-lg .page-link {
      padding: 0.5575rem 1rem;
    }
    [dir=ltr] .pagination-lg .page-item:first-child .page-link {
      border-top-left-radius: 0.6rem;
      border-bottom-left-radius: 0.6rem;
    }
    [dir=rtl] .pagination-lg .page-item:first-child .page-link {
      border-top-right-radius: 0.6rem;
      border-bottom-right-radius: 0.6rem;
    }
    [dir=ltr] .pagination-lg .page-item:last-child .page-link {
      border-top-right-radius: 0.6rem;
      border-bottom-right-radius: 0.6rem;
    }
    [dir=rtl] .pagination-lg .page-item:last-child .page-link {
      border-top-left-radius: 0.6rem;
      border-bottom-left-radius: 0.6rem;
    }
    
    .pagination-sm .page-link {
      font-size: 1rem;
      line-height: 1;
    }
    
     .pagination-sm .page-link {
      padding: 0.443rem 0.745rem;
    }
    [dir=ltr] .pagination-sm .page-item:first-child .page-link {
      border-top-left-radius: 0.25rem;
      border-bottom-left-radius: 0.25rem;
    }
    [dir=rtl] .pagination-sm .page-item:first-child .page-link {
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }
    [dir=ltr] .pagination-sm .page-item:last-child .page-link {
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }
    [dir=rtl] .pagination-sm .page-item:last-child .page-link {
      border-top-left-radius: 0.25rem;
      border-bottom-left-radius: 0.25rem;
    }
    
    .badge {
      display: inline-block;
      font-size: 85%;
      font-weight: 600;
      line-height: 1;
      white-space: nowrap;
      vertical-align: baseline;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border 0s;
    }
    
     .badge {
      padding: 0.3rem 0.5rem;
      text-align: center;
      border-radius: 0.358rem;
    }
    @media (prefers-reduced-motion: reduce) {
      .badge {
        transition: none;
      }
    }
    a.badge:hover, a.badge:focus {
      text-decoration: none;
    }
    
    .badge:empty {
      display: none;
    }
    
    .btn .badge {
      position: relative;
      top: -1px;
    }
    
     .badge-pill {
      border-radius: 10rem;
    }
    
    [dir=ltr] .badge-pill {
      padding-right: 0.5rem;
      padding-left: 0.5rem;
    }
    
    [dir=rtl] .badge-pill {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
    
    .badge-primary {
      color: #fff;
    }
    
     .badge-primary {
      background-color: #114A9F;
    }
    a.badge-primary:hover, a.badge-primary:focus {
      color: #fff;
    }
     a.badge-primary:hover,  a.badge-primary:focus {
      background-color: #0c3571;
    }
    a.badge-primary:focus, a.badge-primary.focus {
      outline: 0;
    }
     a.badge-primary:focus,  a.badge-primary.focus {
      box-shadow: 0 0 0 0.2rem rgba(17, 74, 159, 0.5);
    }
    
    .badge-secondary {
      color: #2a2e30;
    }
    
     .badge-secondary {
      background-color: #9C9EA4;
    }
    a.badge-secondary:hover, a.badge-secondary:focus {
      color: #2a2e30;
    }
     a.badge-secondary:hover,  a.badge-secondary:focus {
      background-color: #81848c;
    }
    a.badge-secondary:focus, a.badge-secondary.focus {
      outline: 0;
    }
     a.badge-secondary:focus,  a.badge-secondary.focus {
      box-shadow: 0 0 0 0.2rem rgba(156, 158, 164, 0.5);
    }
    
    .badge-success {
      color: #fff;
    }
    
     .badge-success {
      background-color: #17B75E;
    }
    a.badge-success:hover, a.badge-success:focus {
      color: #fff;
    }
     a.badge-success:hover,  a.badge-success:focus {
      background-color: #118a47;
    }
    a.badge-success:focus, a.badge-success.focus {
      outline: 0;
    }
     a.badge-success:focus,  a.badge-success.focus {
      box-shadow: 0 0 0 0.2rem rgba(23, 183, 94, 0.5);
    }
    
    .badge-info {
      color: #fff;
    }
    
     .badge-info {
      background-color: #00CFE8;
    }
    a.badge-info:hover, a.badge-info:focus {
      color: #fff;
    }
     a.badge-info:hover,  a.badge-info:focus {
      background-color: #00a1b5;
    }
    a.badge-info:focus, a.badge-info.focus {
      outline: 0;
    }
     a.badge-info:focus,  a.badge-info.focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 207, 232, 0.5);
    }
    
    .badge-warning {
      color: #2a2e30;
    }
    
     .badge-warning {
      background-color: #FDB913;
    }
    a.badge-warning:hover, a.badge-warning:focus {
      color: #2a2e30;
    }
     a.badge-warning:hover,  a.badge-warning:focus {
      background-color: #db9c02;
    }
    a.badge-warning:focus, a.badge-warning.focus {
      outline: 0;
    }
     a.badge-warning:focus,  a.badge-warning.focus {
      box-shadow: 0 0 0 0.2rem rgba(253, 185, 19, 0.5);
    }
    
    .badge-danger {
      color: #fff;
    }
    
     .badge-danger {
      background-color: #EA5455;
    }
    a.badge-danger:hover, a.badge-danger:focus {
      color: #fff;
    }
     a.badge-danger:hover,  a.badge-danger:focus {
      background-color: #e42728;
    }
    a.badge-danger:focus, a.badge-danger.focus {
      outline: 0;
    }
     a.badge-danger:focus,  a.badge-danger.focus {
      box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.5);
    }
    
    .badge-light {
      color: #2a2e30;
    }
    
     .badge-light {
      background-color: #C1C1C1;
    }
    a.badge-light:hover, a.badge-light:focus {
      color: #2a2e30;
    }
     a.badge-light:hover,  a.badge-light:focus {
      background-color: #a8a8a8;
    }
    a.badge-light:focus, a.badge-light.focus {
      outline: 0;
    }
     a.badge-light:focus,  a.badge-light.focus {
      box-shadow: 0 0 0 0.2rem rgba(193, 193, 193, 0.5);
    }
    
    .badge-dark {
      color: #fff;
    }
    
     .badge-dark {
      background-color: #4B4B4B;
    }
    a.badge-dark:hover, a.badge-dark:focus {
      color: #fff;
    }
     a.badge-dark:hover,  a.badge-dark:focus {
      background-color: #323232;
    }
    a.badge-dark:focus, a.badge-dark.focus {
      outline: 0;
    }
     a.badge-dark:focus,  a.badge-dark.focus {
      box-shadow: 0 0 0 0.2rem rgba(75, 75, 75, 0.5);
    }
    
     .jumbotron {
      padding: 2rem 1rem;
      margin-bottom: 2rem;
      background-color: #ededed;
      border-radius: 0.6rem;
    }
    @media (min-width: 576px) {
       .jumbotron {
        padding: 4rem 2rem;
      }
    }
    
     .jumbotron-fluid {
      border-radius: 0;
    }
    
    [dir=ltr] .jumbotron-fluid {
      padding-right: 0;
      padding-left: 0;
    }
    
    [dir=rtl] .jumbotron-fluid {
      padding-left: 0;
      padding-right: 0;
    }
    
    .alert {
      position: relative;
    }
    
     .alert {
      padding: 0.71rem 1rem;
      margin-bottom: 1rem;
      border: 1px solid transparent;
      border-radius: 0.358rem;
    }
    
    .alert-heading {
      color: inherit;
    }
    
    .alert-link {
      font-weight: 700;
    }
    
    [dir=ltr] .alert-dismissible {
      padding-right: 4rem;
    }
    
    [dir=rtl] .alert-dismissible {
      padding-left: 4rem;
    }
    .alert-dismissible .close {
      position: absolute;
      top: 0;
      z-index: 2;
      color: inherit;
    }
     .alert-dismissible .close {
      padding: 0.71rem 1rem;
    }
    [dir=ltr] .alert-dismissible .close {
      right: 0;
    }
    [dir=rtl] .alert-dismissible .close {
      left: 0;
    }
    
    .alert-primary {
      color: #193a69;
    }
    
     .alert-primary {
      background-color: #cfdbec;
      border-color: #bccce4;
    }
     .alert-primary hr {
      border-top-color: #aabedd;
    }
    .alert-primary .alert-link {
      color: #0f2340;
    }
    
    .alert-secondary {
      color: #61666c;
    }
    
     .alert-secondary {
      background-color: #ebeced;
      border-color: #e3e4e6;
    }
     .alert-secondary hr {
      border-top-color: #d6d7da;
    }
    .alert-secondary .alert-link {
      color: #494d51;
    }
    
    .alert-success {
      color: #1c7347;
    }
    
     .alert-success {
      background-color: #d1f1df;
      border-color: #beebd2;
    }
     .alert-success hr {
      border-top-color: #abe5c5;
    }
    .alert-success .alert-link {
      color: #124a2e;
    }
    
    .alert-info {
      color: #107f8f;
    }
    
     .alert-info {
      background-color: #ccf5fa;
      border-color: #b8f2f9;
    }
     .alert-info hr {
      border-top-color: #a0eef7;
    }
    .alert-info .alert-link {
      color: #0b5661;
    }
    
    .alert-warning {
      color: #947420;
    }
    
     .alert-warning {
      background-color: #fff1d0;
      border-color: #feebbd;
    }
     .alert-warning hr {
      border-top-color: #fee3a4;
    }
    .alert-warning .alert-link {
      color: #6a5317;
    }
    
    .alert-danger {
      color: #8a3f43;
    }
    
     .alert-danger {
      background-color: #fbdddd;
      border-color: #f9cfcf;
    }
     .alert-danger hr {
      border-top-color: #f6b8b8;
    }
    .alert-danger .alert-link {
      color: #672f32;
    }
    
    .alert-light {
      color: #75787b;
    }
    
     .alert-light {
      background-color: #f3f3f3;
      border-color: #eeeeee;
    }
     .alert-light hr {
      border-top-color: #e1e1e1;
    }
    .alert-light .alert-link {
      color: #5c5f61;
    }
    
    .alert-dark {
      color: #373b3e;
    }
    
     .alert-dark {
      background-color: #dbdbdb;
      border-color: #cdcdcd;
    }
     .alert-dark hr {
      border-top-color: silver;
    }
    .alert-dark .alert-link {
      color: #1f2123;
    }
    
    @keyframes progress-bar-stripes-ltr {
      from {
        background-position: 0.857rem 0;
      }
      to {
        background-position: 0 0;
      }
    }
    
    @keyframes progress-bar-stripes-rtl {
      from {
        background-position: 0.857rem 0;
      }
      to {
        background-position: 100% 0;
      }
    }
    .progress {
      display: flex;
      height: 0.857rem;
      overflow: hidden;
      line-height: 0;
      font-size: 0.857rem;
    }
     .progress {
      background-color: rgba(17, 74, 159, 0.12);
      border-radius: 5rem;
    }
    
    .progress-bar {
      display: flex;
      flex-direction: column;
      justify-content: center;
      overflow: hidden;
      color: #fff;
      white-space: nowrap;
      transition: width 0.6s ease;
    }
    
     .progress-bar {
      text-align: center;
      background-color: #114A9F;
    }
    @media (prefers-reduced-motion: reduce) {
      .progress-bar {
        transition: none;
      }
    }
    
     .progress-bar-striped {
      background-size: 0.857rem 0.857rem;
    }
    
    [dir=ltr] .progress-bar-striped {
      background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    }
    
    [dir=rtl] .progress-bar-striped {
      background-image: linear-gradient(-45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    }
    
    [dir=ltr] .progress-bar-animated {
      animation: 1s linear infinite progress-bar-stripes-ltr ;
    }
    
    [dir=rtl] .progress-bar-animated {
      animation: 1s linear infinite progress-bar-stripes-rtl ;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .progress-bar-animated {
        animation: none;
      }
      [dir=rtl] .progress-bar-animated {
        animation: none;
      }
    }
    
    .media {
      display: flex;
      align-items: flex-start;
    }
    
    .media-body {
      flex: 1;
    }
    
    .list-group {
      display: flex;
      flex-direction: column;
    }
    
     .list-group {
      margin-bottom: 0;
      border-radius: 0.358rem;
    }
    
    [dir=ltr] .list-group {
      padding-left: 0;
    }
    
    [dir=rtl] .list-group {
      padding-right: 0;
    }
    
    .list-group-item-action {
      width: 100%;
      color: #4e5154;
    }
    
     .list-group-item-action {
      text-align: inherit;
    }
    .list-group-item-action:hover, .list-group-item-action:focus {
      z-index: 1;
      color: #4e5154;
      text-decoration: none;
    }
     .list-group-item-action:hover,  .list-group-item-action:focus {
      background-color: #babfc7;
    }
    .list-group-item-action:active {
      color: #424244;
    }
     .list-group-item-action:active {
      background-color: #ededed;
    }
    
    .list-group-item {
      position: relative;
      display: block;
    }
    
     .list-group-item {
      padding: 0.75rem 1.25rem;
      background-color: #fff;
      border: 1px solid rgba(34, 41, 47, 0.125);
    }
    [dir=ltr] .list-group-item:first-child {
      border-top-left-radius: inherit;
      border-top-right-radius: inherit;
    }
    [dir=rtl] .list-group-item:first-child {
      border-top-right-radius: inherit;
      border-top-left-radius: inherit;
    }
    [dir=ltr] .list-group-item:last-child {
      border-bottom-right-radius: inherit;
      border-bottom-left-radius: inherit;
    }
    [dir=rtl] .list-group-item:last-child {
      border-bottom-left-radius: inherit;
      border-bottom-right-radius: inherit;
    }
    .list-group-item.disabled, .list-group-item:disabled {
      color: #b9b9c3;
      pointer-events: none;
    }
     .list-group-item.disabled,  .list-group-item:disabled {
      background-color: #fff;
    }
    .list-group-item.active {
      z-index: 2;
      color: #fff;
    }
     .list-group-item.active {
      background-color: #114A9F;
      border-color: #114A9F;
    }
     .list-group-item + .list-group-item {
      border-top-width: 0;
    }
     .list-group-item + .list-group-item.active {
      margin-top: -1px;
      border-top-width: 1px;
    }
    
    .list-group-horizontal {
      flex-direction: row;
    }
    [dir=ltr] .list-group-horizontal > .list-group-item:first-child {
      border-bottom-left-radius: 0.358rem;
      border-top-right-radius: 0;
    }
    [dir=rtl] .list-group-horizontal > .list-group-item:first-child {
      border-bottom-right-radius: 0.358rem;
      border-top-left-radius: 0;
    }
    [dir=ltr] .list-group-horizontal > .list-group-item:last-child {
      border-top-right-radius: 0.358rem;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .list-group-horizontal > .list-group-item:last-child {
      border-top-left-radius: 0.358rem;
      border-bottom-right-radius: 0;
    }
     .list-group-horizontal > .list-group-item.active {
      margin-top: 0;
    }
     .list-group-horizontal > .list-group-item + .list-group-item {
      border-top-width: 1px;
    }
    [dir=ltr] .list-group-horizontal > .list-group-item + .list-group-item {
      border-left-width: 0;
    }
    [dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item {
      border-right-width: 0;
    }
    [dir=ltr] .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-left: -1px;
      border-left-width: 1px;
    }
    [dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-right: -1px;
      border-right-width: 1px;
    }
    
    @media (min-width: 576px) {
      .list-group-horizontal-sm {
        flex-direction: row;
      }
      [dir=ltr] .list-group-horizontal-sm > .list-group-item:first-child {
        border-bottom-left-radius: 0.358rem;
        border-top-right-radius: 0;
      }
      [dir=rtl] .list-group-horizontal-sm > .list-group-item:first-child {
        border-bottom-right-radius: 0.358rem;
        border-top-left-radius: 0;
      }
      [dir=ltr] .list-group-horizontal-sm > .list-group-item:last-child {
        border-top-right-radius: 0.358rem;
        border-bottom-left-radius: 0;
      }
      [dir=rtl] .list-group-horizontal-sm > .list-group-item:last-child {
        border-top-left-radius: 0.358rem;
        border-bottom-right-radius: 0;
      }
       .list-group-horizontal-sm > .list-group-item.active {
        margin-top: 0;
      }
       .list-group-horizontal-sm > .list-group-item + .list-group-item {
        border-top-width: 1px;
      }
      [dir=ltr] .list-group-horizontal-sm > .list-group-item + .list-group-item {
        border-left-width: 0;
      }
      [dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item {
        border-right-width: 0;
      }
      [dir=ltr] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px;
      }
      [dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-right: -1px;
        border-right-width: 1px;
      }
    }
    @media (min-width: 768px) {
      .list-group-horizontal-md {
        flex-direction: row;
      }
      [dir=ltr] .list-group-horizontal-md > .list-group-item:first-child {
        border-bottom-left-radius: 0.358rem;
        border-top-right-radius: 0;
      }
      [dir=rtl] .list-group-horizontal-md > .list-group-item:first-child {
        border-bottom-right-radius: 0.358rem;
        border-top-left-radius: 0;
      }
      [dir=ltr] .list-group-horizontal-md > .list-group-item:last-child {
        border-top-right-radius: 0.358rem;
        border-bottom-left-radius: 0;
      }
      [dir=rtl] .list-group-horizontal-md > .list-group-item:last-child {
        border-top-left-radius: 0.358rem;
        border-bottom-right-radius: 0;
      }
       .list-group-horizontal-md > .list-group-item.active {
        margin-top: 0;
      }
       .list-group-horizontal-md > .list-group-item + .list-group-item {
        border-top-width: 1px;
      }
      [dir=ltr] .list-group-horizontal-md > .list-group-item + .list-group-item {
        border-left-width: 0;
      }
      [dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item {
        border-right-width: 0;
      }
      [dir=ltr] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px;
      }
      [dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-right: -1px;
        border-right-width: 1px;
      }
    }
    @media (min-width: 992px) {
      .list-group-horizontal-lg {
        flex-direction: row;
      }
      [dir=ltr] .list-group-horizontal-lg > .list-group-item:first-child {
        border-bottom-left-radius: 0.358rem;
        border-top-right-radius: 0;
      }
      [dir=rtl] .list-group-horizontal-lg > .list-group-item:first-child {
        border-bottom-right-radius: 0.358rem;
        border-top-left-radius: 0;
      }
      [dir=ltr] .list-group-horizontal-lg > .list-group-item:last-child {
        border-top-right-radius: 0.358rem;
        border-bottom-left-radius: 0;
      }
      [dir=rtl] .list-group-horizontal-lg > .list-group-item:last-child {
        border-top-left-radius: 0.358rem;
        border-bottom-right-radius: 0;
      }
       .list-group-horizontal-lg > .list-group-item.active {
        margin-top: 0;
      }
       .list-group-horizontal-lg > .list-group-item + .list-group-item {
        border-top-width: 1px;
      }
      [dir=ltr] .list-group-horizontal-lg > .list-group-item + .list-group-item {
        border-left-width: 0;
      }
      [dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item {
        border-right-width: 0;
      }
      [dir=ltr] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px;
      }
      [dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-right: -1px;
        border-right-width: 1px;
      }
    }
    @media (min-width: 1200px) {
      .list-group-horizontal-xl {
        flex-direction: row;
      }
      [dir=ltr] .list-group-horizontal-xl > .list-group-item:first-child {
        border-bottom-left-radius: 0.358rem;
        border-top-right-radius: 0;
      }
      [dir=rtl] .list-group-horizontal-xl > .list-group-item:first-child {
        border-bottom-right-radius: 0.358rem;
        border-top-left-radius: 0;
      }
      [dir=ltr] .list-group-horizontal-xl > .list-group-item:last-child {
        border-top-right-radius: 0.358rem;
        border-bottom-left-radius: 0;
      }
      [dir=rtl] .list-group-horizontal-xl > .list-group-item:last-child {
        border-top-left-radius: 0.358rem;
        border-bottom-right-radius: 0;
      }
       .list-group-horizontal-xl > .list-group-item.active {
        margin-top: 0;
      }
       .list-group-horizontal-xl > .list-group-item + .list-group-item {
        border-top-width: 1px;
      }
      [dir=ltr] .list-group-horizontal-xl > .list-group-item + .list-group-item {
        border-left-width: 0;
      }
      [dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item {
        border-right-width: 0;
      }
      [dir=ltr] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px;
      }
      [dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-right: -1px;
        border-right-width: 1px;
      }
    }
     .list-group-flush {
      border-radius: 0;
    }
     .list-group-flush > .list-group-item {
      border-width: 0 0 1px;
    }
     .list-group-flush > .list-group-item:last-child {
      border-bottom-width: 0;
    }
    
    .list-group-item-primary {
      color: #193a69;
    }
    
     .list-group-item-primary {
      background-color: #bccce4;
    }
    .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
      color: #193a69;
    }
     .list-group-item-primary.list-group-item-action:hover,  .list-group-item-primary.list-group-item-action:focus {
      background-color: #aabedd;
    }
    .list-group-item-primary.list-group-item-action.active {
      color: #fff;
    }
     .list-group-item-primary.list-group-item-action.active {
      background-color: #193a69;
      border-color: #193a69;
    }
    
    .list-group-item-secondary {
      color: #61666c;
    }
    
     .list-group-item-secondary {
      background-color: #e3e4e6;
    }
    .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
      color: #61666c;
    }
     .list-group-item-secondary.list-group-item-action:hover,  .list-group-item-secondary.list-group-item-action:focus {
      background-color: #d6d7da;
    }
    .list-group-item-secondary.list-group-item-action.active {
      color: #fff;
    }
     .list-group-item-secondary.list-group-item-action.active {
      background-color: #61666c;
      border-color: #61666c;
    }
    
    .list-group-item-success {
      color: #1c7347;
    }
    
     .list-group-item-success {
      background-color: #beebd2;
    }
    .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
      color: #1c7347;
    }
     .list-group-item-success.list-group-item-action:hover,  .list-group-item-success.list-group-item-action:focus {
      background-color: #abe5c5;
    }
    .list-group-item-success.list-group-item-action.active {
      color: #fff;
    }
     .list-group-item-success.list-group-item-action.active {
      background-color: #1c7347;
      border-color: #1c7347;
    }
    
    .list-group-item-info {
      color: #107f8f;
    }
    
     .list-group-item-info {
      background-color: #b8f2f9;
    }
    .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
      color: #107f8f;
    }
     .list-group-item-info.list-group-item-action:hover,  .list-group-item-info.list-group-item-action:focus {
      background-color: #a0eef7;
    }
    .list-group-item-info.list-group-item-action.active {
      color: #fff;
    }
     .list-group-item-info.list-group-item-action.active {
      background-color: #107f8f;
      border-color: #107f8f;
    }
    
    .list-group-item-warning {
      color: #947420;
    }
    
     .list-group-item-warning {
      background-color: #feebbd;
    }
    .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
      color: #947420;
    }
     .list-group-item-warning.list-group-item-action:hover,  .list-group-item-warning.list-group-item-action:focus {
      background-color: #fee3a4;
    }
    .list-group-item-warning.list-group-item-action.active {
      color: #fff;
    }
     .list-group-item-warning.list-group-item-action.active {
      background-color: #947420;
      border-color: #947420;
    }
    
    .list-group-item-danger {
      color: #8a3f43;
    }
    
     .list-group-item-danger {
      background-color: #f9cfcf;
    }
    .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
      color: #8a3f43;
    }
     .list-group-item-danger.list-group-item-action:hover,  .list-group-item-danger.list-group-item-action:focus {
      background-color: #f6b8b8;
    }
    .list-group-item-danger.list-group-item-action.active {
      color: #fff;
    }
     .list-group-item-danger.list-group-item-action.active {
      background-color: #8a3f43;
      border-color: #8a3f43;
    }
    
    .list-group-item-light {
      color: #75787b;
    }
    
     .list-group-item-light {
      background-color: #eeeeee;
    }
    .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
      color: #75787b;
    }
     .list-group-item-light.list-group-item-action:hover,  .list-group-item-light.list-group-item-action:focus {
      background-color: #e1e1e1;
    }
    .list-group-item-light.list-group-item-action.active {
      color: #fff;
    }
     .list-group-item-light.list-group-item-action.active {
      background-color: #75787b;
      border-color: #75787b;
    }
    
    .list-group-item-dark {
      color: #373b3e;
    }
    
     .list-group-item-dark {
      background-color: #cdcdcd;
    }
    .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
      color: #373b3e;
    }
     .list-group-item-dark.list-group-item-action:hover,  .list-group-item-dark.list-group-item-action:focus {
      background-color: silver;
    }
    .list-group-item-dark.list-group-item-action.active {
      color: #fff;
    }
     .list-group-item-dark.list-group-item-action.active {
      background-color: #373b3e;
      border-color: #373b3e;
    }
    
    .close {
      font-size: 2rem;
      font-weight: 400;
      line-height: 1;
      color: #424244;
      opacity: 0.5;
    }
    
     .close {
      text-shadow: 0 1px 0 #fff;
    }
    
    [dir=ltr] .close {
      float: right;
    }
    
    [dir=rtl] .close {
      float: left;
    }
    .close:hover {
      color: #424244;
      text-decoration: none;
    }
    .close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
      opacity: 0.75;
    }
    
     button.close {
      padding: 0;
      background-color: transparent;
      border: 0;
    }
    
    a.close.disabled {
      pointer-events: none;
    }
    
    .toast {
      flex-basis: 380px;
      max-width: 380px;
      font-size: 0.857rem;
      color: #424244;
      opacity: 0;
    }
    
     .toast {
      background-color: rgba(255, 255, 255, 0.85);
      background-clip: padding-box;
      border: 0 solid rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 20px 0 rgba(34, 41, 47, 0.08);
      border-radius: 0.286rem;
    }
     .toast:not(:last-child) {
      margin-bottom: 1.14rem;
    }
    .toast.showing {
      opacity: 1;
    }
    .toast.show {
      display: block;
      opacity: 1;
    }
    .toast.hide {
      display: none;
    }
    
    .toast-header {
      display: flex;
      align-items: center;
      color: #424244;
    }
    
     .toast-header {
      padding: 0.15rem 1.14rem;
      background-color: #fff;
      background-clip: padding-box;
      border-bottom: 0 solid rgba(0, 0, 0, 0.05);
    }
    
    [dir=ltr] .toast-header {
      border-top-left-radius: 0.286rem;
      border-top-right-radius: 0.286rem;
    }
    
    [dir=rtl] .toast-header {
      border-top-right-radius: 0.286rem;
      border-top-left-radius: 0.286rem;
    }
    
     .toast-body {
      padding: 1.14rem;
    }
    
    .modal-open {
      overflow: hidden;
    }
    .modal-open .modal {
      overflow-x: hidden;
      overflow-y: auto;
    }
    
    .modal {
      position: fixed;
      top: 0;
      z-index: 1050;
      display: none;
      width: 100%;
      height: 100%;
      overflow: hidden;
      outline: 0;
    }
    
    [dir=ltr] .modal {
      left: 0;
    }
    
    [dir=rtl] .modal {
      right: 0;
    }
    
    .modal-dialog {
      position: relative;
      width: auto;
      pointer-events: none;
    }
    
     .modal-dialog {
      margin: 0.5rem;
    }
    .modal.fade .modal-dialog {
      transition: transform 0.3s ease-out;
    }
     .modal.fade .modal-dialog {
      transform: translate(0, -50px);
    }
    @media (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none;
      }
    }
     .modal.show .modal-dialog {
      transform: none;
    }
     .modal.modal-static .modal-dialog {
      transform: scale(1.02);
    }
    
    .modal-dialog-scrollable {
      display: flex;
      max-height: calc(100% - 1rem);
    }
    .modal-dialog-scrollable .modal-content {
      max-height: calc(100vh - 1rem);
      overflow: hidden;
    }
    .modal-dialog-scrollable .modal-header,
    .modal-dialog-scrollable .modal-footer {
      flex-shrink: 0;
    }
    .modal-dialog-scrollable .modal-body {
      overflow-y: auto;
    }
    
    .modal-dialog-centered {
      display: flex;
      align-items: center;
      min-height: calc(100% - 1rem);
    }
    .modal-dialog-centered::before {
      display: block;
      height: calc(100vh - 1rem);
      height: min-content;
      content: "";
    }
    .modal-dialog-centered.modal-dialog-scrollable {
      flex-direction: column;
      justify-content: center;
      height: 100%;
    }
    .modal-dialog-centered.modal-dialog-scrollable .modal-content {
      max-height: none;
    }
    .modal-dialog-centered.modal-dialog-scrollable::before {
      content: none;
    }
    
    .modal-content {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      pointer-events: auto;
      outline: 0;
    }
    
     .modal-content {
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid rgba(34, 41, 47, 0.2);
      border-radius: 0.358rem;
    }
    
    .modal-backdrop {
      position: fixed;
      top: 0;
      z-index: 1040;
      width: 100vw;
      height: 100vh;
    }
    
     .modal-backdrop {
      background-color: #22292f;
    }
    
    [dir=ltr] .modal-backdrop {
      left: 0;
    }
    
    [dir=rtl] .modal-backdrop {
      right: 0;
    }
    .modal-backdrop.fade {
      opacity: 0;
    }
    .modal-backdrop.show {
      opacity: 0.5;
    }
    
    .modal-header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }
    
     .modal-header {
      padding: 0.8rem 1.4rem;
      border-bottom: 1px solid #ebe9f1;
    }
    
    [dir=ltr] .modal-header {
      border-top-left-radius: calc(0.358rem - 1px);
      border-top-right-radius: calc(0.358rem - 1px);
    }
    
    [dir=rtl] .modal-header {
      border-top-right-radius: calc(0.358rem - 1px);
      border-top-left-radius: calc(0.358rem - 1px);
    }
     .modal-header .close {
      padding: 0.8rem 1.4rem;
    }
    [dir=ltr] .modal-header .close {
      margin: -0.8rem -1.4rem -0.8rem auto;
    }
    [dir=rtl] .modal-header .close {
      margin: -0.8rem auto -0.8rem -1.4rem;
    }
    
    .modal-title {
      line-height: 1.45;
    }
    
     .modal-title {
      margin-bottom: 0;
    }
    
    .modal-body {
      position: relative;
      flex: 1 1 auto;
    }
    
     .modal-body {
      padding: 0.8rem 1.4rem;
    }
    
    .modal-footer {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-end;
    }
    
     .modal-footer {
      padding: 0.8rem 1.4rem-0.25rem;
      border-top: 1px solid rgba(34, 41, 47, 0.05);
    }
    
    [dir=ltr] .modal-footer {
      border-bottom-right-radius: calc(0.358rem - 1px);
      border-bottom-left-radius: calc(0.358rem - 1px);
    }
    
    [dir=rtl] .modal-footer {
      border-bottom-left-radius: calc(0.358rem - 1px);
      border-bottom-right-radius: calc(0.358rem - 1px);
    }
     .modal-footer > * {
      margin: 0.25rem;
    }
    
    .modal-scrollbar-measure {
      position: absolute;
      top: -9999px;
      width: 50px;
      height: 50px;
      overflow: scroll;
    }
    
    @media (min-width: 576px) {
      .modal-dialog {
        max-width: 500px;
      }
       .modal-dialog {
        margin: 1.75rem auto;
      }
    
      .modal-dialog-scrollable {
        max-height: calc(100% - 3.5rem);
      }
      .modal-dialog-scrollable .modal-content {
        max-height: calc(100vh - 3.5rem);
      }
    
      .modal-dialog-centered {
        min-height: calc(100% - 3.5rem);
      }
      .modal-dialog-centered::before {
        height: calc(100vh - 3.5rem);
        height: min-content;
      }
    
      .modal-sm {
        max-width: 400px;
      }
    }
    @media (min-width: 992px) {
      .modal-lg,
    .modal-xl {
        max-width: 800px;
      }
    }
    @media (min-width: 1200px) {
      .modal-xl {
        max-width: 94%;
      }
    }
    .tooltip {
      position: absolute;
      z-index: 1070;
      display: block;
      font-family: "Roboto", Helvetica, Arial, serif;
      font-style: normal;
      font-weight: 400;
      line-height: 1.45;
      text-decoration: none;
      text-transform: none;
      letter-spacing: normal;
      word-break: normal;
      word-spacing: normal;
      white-space: normal;
      line-break: auto;
      font-size: 0.857rem;
      word-wrap: break-word;
      opacity: 0;
    }
     .tooltip {
      margin: 0;
      text-align: start;
      text-shadow: none;
    }
    [dir=ltr] .tooltip {
      text-align: left;
    }
    [dir=rtl] .tooltip {
      text-align: right;
    }
    .tooltip.show {
      opacity: 1;
    }
    .tooltip .arrow {
      position: absolute;
      display: block;
      width: 0.8rem;
      height: 0.4rem;
    }
    .tooltip .arrow::before {
      position: absolute;
      content: "";
    }
     .tooltip .arrow::before {
      border-color: transparent;
      border-style: solid;
    }
    
    .tooltip-inner {
      max-width: 220px;
      color: #fff;
    }
    
     .tooltip-inner {
      padding: 0.4rem 0.775rem;
      text-align: center;
      background-color: #323232;
      border-radius: 0.358rem;
    }
    
    .popover {
      position: absolute;
      top: 0;
      z-index: 1060;
      display: block;
      max-width: 276px;
      font-family: "Roboto", Helvetica, Arial, serif;
      font-style: normal;
      font-weight: 400;
      line-height: 1.45;
      text-decoration: none;
      text-transform: none;
      letter-spacing: normal;
      word-break: normal;
      word-spacing: normal;
      white-space: normal;
      line-break: auto;
      font-size: 1rem;
      word-wrap: break-word;
    }
    
     .popover {
      text-align: start;
      text-shadow: none;
      background-color: #fff;
      background-clip: padding-box;
      border: 0 solid #ebe9f1;
      border-radius: 0.358rem;
    }
    
    [dir=ltr] .popover {
      left: 0;
      text-align: left;
    }
    
    [dir=rtl] .popover {
      right: 0;
      text-align: right;
    }
    .popover .arrow {
      position: absolute;
      display: block;
      width: 1rem;
      height: 0.5rem;
    }
     .popover .arrow {
      margin: 0 0.358rem;
    }
    .popover .arrow::before, .popover .arrow::after {
      position: absolute;
      display: block;
      content: "";
    }
     .popover .arrow::before,  .popover .arrow::after {
      border-color: transparent;
      border-style: solid;
    }
    .bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
      bottom: -0.5rem;
    }
    .bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
      bottom: 0;
    }
     .bs-popover-top > .arrow::before,  .bs-popover-auto[x-placement^=top] > .arrow::before {
      border-width: 0.5rem 0.5rem 0;
      border-top-color: #ebe9f1;
    }
    .bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
      bottom: 0;
    }
     .bs-popover-top > .arrow::after,  .bs-popover-auto[x-placement^=top] > .arrow::after {
      border-width: 0.5rem 0.5rem 0;
      border-top-color: #fff;
    }
    .bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
      width: 0.5rem;
      height: 1rem;
    }
     .bs-popover-right > .arrow,  .bs-popover-auto[x-placement^=right] > .arrow {
      margin: 0.358rem 0;
    }
    [dir=ltr] .bs-popover-right > .arrow, [dir=ltr] .bs-popover-auto[x-placement^=right] > .arrow {
      left: -0.5rem;
    }
    [dir=rtl] .bs-popover-right > .arrow, [dir=rtl] .bs-popover-auto[x-placement^=right] > .arrow {
      right: -0.5rem;
    }
    [dir=ltr] .bs-popover-right > .arrow::before, [dir=ltr] .bs-popover-auto[x-placement^=right] > .arrow::before {
      left: 0;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: #ebe9f1;
    }
    [dir=rtl] .bs-popover-right > .arrow::before, [dir=rtl] .bs-popover-auto[x-placement^=right] > .arrow::before {
      right: 0;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: #ebe9f1;
    }
    [dir=ltr] .bs-popover-right > .arrow::after, [dir=ltr] .bs-popover-auto[x-placement^=right] > .arrow::after {
      left: 0;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: #fff;
    }
    [dir=rtl] .bs-popover-right > .arrow::after, [dir=rtl] .bs-popover-auto[x-placement^=right] > .arrow::after {
      right: 0;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: #fff;
    }
    .bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
      top: -0.5rem;
    }
    .bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
      top: 0;
    }
     .bs-popover-bottom > .arrow::before,  .bs-popover-auto[x-placement^=bottom] > .arrow::before {
      border-width: 0 0.5rem 0.5rem 0.5rem;
      border-bottom-color: #ebe9f1;
    }
    .bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
      top: 0;
    }
     .bs-popover-bottom > .arrow::after,  .bs-popover-auto[x-placement^=bottom] > .arrow::after {
      border-width: 0 0.5rem 0.5rem 0.5rem;
      border-bottom-color: #fff;
    }
    .bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
      position: absolute;
      top: 0;
      display: block;
      width: 1rem;
      content: "";
    }
     .bs-popover-bottom .popover-header::before,  .bs-popover-auto[x-placement^=bottom] .popover-header::before {
      border-bottom: 0 solid #114A9F;
    }
    [dir=ltr] .bs-popover-bottom .popover-header::before, [dir=ltr] .bs-popover-auto[x-placement^=bottom] .popover-header::before {
      left: 50%;
      margin-left: -0.5rem;
    }
    [dir=rtl] .bs-popover-bottom .popover-header::before, [dir=rtl] .bs-popover-auto[x-placement^=bottom] .popover-header::before {
      right: 50%;
      margin-right: -0.5rem;
    }
    .bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
      width: 0.5rem;
      height: 1rem;
    }
     .bs-popover-left > .arrow,  .bs-popover-auto[x-placement^=left] > .arrow {
      margin: 0.358rem 0;
    }
    [dir=ltr] .bs-popover-left > .arrow, [dir=ltr] .bs-popover-auto[x-placement^=left] > .arrow {
      right: -0.5rem;
    }
    [dir=rtl] .bs-popover-left > .arrow, [dir=rtl] .bs-popover-auto[x-placement^=left] > .arrow {
      left: -0.5rem;
    }
    [dir=ltr] .bs-popover-left > .arrow::before, [dir=ltr] .bs-popover-auto[x-placement^=left] > .arrow::before {
      right: 0;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: #ebe9f1;
    }
    [dir=rtl] .bs-popover-left > .arrow::before, [dir=rtl] .bs-popover-auto[x-placement^=left] > .arrow::before {
      left: 0;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: #ebe9f1;
    }
    [dir=ltr] .bs-popover-left > .arrow::after, [dir=ltr] .bs-popover-auto[x-placement^=left] > .arrow::after {
      right: 0;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: #fff;
    }
    [dir=rtl] .bs-popover-left > .arrow::after, [dir=rtl] .bs-popover-auto[x-placement^=left] > .arrow::after {
      left: 0;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: #fff;
    }
    
    .popover-header {
      font-size: 1rem;
      color: #fff;
    }
    
     .popover-header {
      padding: 0.65rem 1.21rem;
      margin-bottom: 0;
      background-color: #114A9F;
      border-bottom: 0 solid #0f3f88;
    }
    
    [dir=ltr] .popover-header {
      border-top-left-radius: 0.358rem;
      border-top-right-radius: 0.358rem;
    }
    
    [dir=rtl] .popover-header {
      border-top-right-radius: 0.358rem;
      border-top-left-radius: 0.358rem;
    }
    .popover-header:empty {
      display: none;
    }
    
    .popover-body {
      color: #424244;
    }
    
     .popover-body {
      padding: 0.65rem 1.21rem;
    }
    
    .carousel {
      position: relative;
    }
    
    .carousel.pointer-event {
      touch-action: pan-y;
    }
    
    .carousel-inner {
      position: relative;
      width: 100%;
      overflow: hidden;
    }
    .carousel-inner::after {
      display: block;
      content: "";
    }
     .carousel-inner::after {
      clear: both;
    }
    
    .carousel-item {
      position: relative;
      display: none;
      width: 100%;
      backface-visibility: hidden;
      transition: transform 0.6s ease-in-out;
    }
    
    [dir=ltr] .carousel-item {
      float: left;
      margin-right: -100%;
    }
    
    [dir=rtl] .carousel-item {
      float: right;
      margin-left: -100%;
    }
    @media (prefers-reduced-motion: reduce) {
      .carousel-item {
        transition: none;
      }
    }
    
    .carousel-item.active,
    .carousel-item-next,
    .carousel-item-prev {
      display: block;
    }
    
    [dir=ltr] .carousel-item-next:not(.carousel-item-left), [dir=ltr] .active.carousel-item-right {
      transform: translateX(100%);
    }
    
    [dir=rtl] .carousel-item-next:not(.carousel-item-left), [dir=rtl] .active.carousel-item-right {
      transform: translateX(-100%);
    }
    
    [dir=ltr] .carousel-item-prev:not(.carousel-item-right), [dir=ltr] .active.carousel-item-left {
      transform: translateX(-100%);
    }
    
    [dir=rtl] .carousel-item-prev:not(.carousel-item-right), [dir=rtl] .active.carousel-item-left {
      transform: translateX(100%);
    }
    
    .carousel-fade .carousel-item {
      opacity: 0;
    }
    
     .carousel-fade .carousel-item {
      transition-property: opacity;
      transform: none;
    }
    .carousel-fade .carousel-item.active,
    .carousel-fade .carousel-item-next.carousel-item-left,
    .carousel-fade .carousel-item-prev.carousel-item-right {
      z-index: 1;
      opacity: 1;
    }
    .carousel-fade .active.carousel-item-left,
    .carousel-fade .active.carousel-item-right {
      z-index: 0;
      opacity: 0;
      transition: opacity 0s 0.6s;
    }
    @media (prefers-reduced-motion: reduce) {
      .carousel-fade .active.carousel-item-left,
    .carousel-fade .active.carousel-item-right {
        transition: none;
      }
    }
    
    .carousel-control-prev,
    .carousel-control-next {
      position: absolute;
      top: 0;
      bottom: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15%;
      color: #fff;
      opacity: 0.5;
      transition: opacity 0.15s ease;
    }
    
     .carousel-control-prev,  .carousel-control-next {
      text-align: center;
    }
    @media (prefers-reduced-motion: reduce) {
      .carousel-control-prev,
    .carousel-control-next {
        transition: none;
      }
    }
    .carousel-control-prev:hover, .carousel-control-prev:focus,
    .carousel-control-next:hover,
    .carousel-control-next:focus {
      color: #fff;
      text-decoration: none;
      outline: 0;
      opacity: 0.9;
    }
    
    [dir=ltr] .carousel-control-prev {
      left: 0;
    }
    
    [dir=rtl] .carousel-control-prev {
      right: 0;
    }
    
    [dir=ltr] .carousel-control-next {
      right: 0;
    }
    
    [dir=rtl] .carousel-control-next {
      left: 0;
    }
    
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
    }
    
    .carousel-indicators {
      position: absolute;
      bottom: 0;
      z-index: 15;
      display: flex;
      justify-content: center;
      list-style: none;
    }
    
    [dir=ltr] .carousel-indicators {
      right: 0;
      left: 0;
      padding-left: 0;
      margin-right: 15%;
      margin-left: 15%;
    }
    
    [dir=rtl] .carousel-indicators {
      left: 0;
      right: 0;
      padding-right: 0;
      margin-left: 15%;
      margin-right: 15%;
    }
    .carousel-indicators li {
      box-sizing: content-box;
      flex: 0 1 auto;
      width: 30px;
      height: 3px;
      text-indent: -999px;
      opacity: 0.5;
      transition: opacity 0.6s ease;
    }
     .carousel-indicators li {
      cursor: pointer;
      background-color: #fff;
      background-clip: padding-box;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
    }
    [dir=ltr] .carousel-indicators li {
      margin-right: 3px;
      margin-left: 3px;
    }
    [dir=rtl] .carousel-indicators li {
      margin-left: 3px;
      margin-right: 3px;
    }
    @media (prefers-reduced-motion: reduce) {
      .carousel-indicators li {
        transition: none;
      }
    }
    .carousel-indicators .active {
      opacity: 1;
    }
    
    .carousel-caption {
      position: absolute;
      bottom: 20px;
      z-index: 10;
      color: #fff;
    }
    
     .carousel-caption {
      padding-top: 20px;
      padding-bottom: 20px;
      text-align: center;
    }
    
    [dir=ltr] .carousel-caption {
      right: 15%;
      left: 15%;
    }
    
    [dir=rtl] .carousel-caption {
      left: 15%;
      right: 15%;
    }
    
    @keyframes spinner-border-ltr {
      to {
        transform: rotate(360deg);
      }
    }
    
    @keyframes spinner-border-rtl {
      to {
        transform: rotate(-360deg);
      }
    }
    .spinner-border {
      display: inline-block;
      width: 2rem;
      height: 2rem;
      vertical-align: text-bottom;
    }
     .spinner-border {
      border: 0.25em solid currentColor;
      border-radius: 50%;
    }
    [dir=ltr] .spinner-border {
      border-right-color: transparent;
      animation: 0.75s linear infinite spinner-border-ltr ;
    }
    [dir=rtl] .spinner-border {
      border-left-color: transparent;
      animation: 0.75s linear infinite spinner-border-rtl ;
    }
    
    .spinner-border-sm {
      width: 1rem;
      height: 1rem;
    }
    
     .spinner-border-sm {
      border-width: 0.2em;
    }
    
    @keyframes spinner-grow {
      0% {
        transform: scale(0);
      }
      50% {
        opacity: 1;
        transform: none;
      }
    }
    .spinner-grow {
      display: inline-block;
      width: 2rem;
      height: 2rem;
      vertical-align: text-bottom;
      opacity: 0;
    }
     .spinner-grow {
      background-color: currentColor;
      border-radius: 50%;
    }
    [dir=ltr] .spinner-grow {
      animation: 0.75s linear infinite spinner-grow;
    }
    [dir=rtl] .spinner-grow {
      animation: 0.75s linear infinite spinner-grow;
    }
    
    .spinner-grow-sm {
      width: 1rem;
      height: 1rem;
    }
    
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .spinner-border, [dir=ltr] .spinner-grow {
        animation-duration: 1.5s;
      }
      [dir=rtl] .spinner-border, [dir=rtl] .spinner-grow {
        animation-duration: 1.5s;
      }
    }
    .align-baseline {
      vertical-align: baseline !important;
    }
    
    .align-top {
      vertical-align: top !important;
    }
    
    .align-middle {
      vertical-align: middle !important;
    }
    
    .align-bottom {
      vertical-align: bottom !important;
    }
    
    .align-text-bottom {
      vertical-align: text-bottom !important;
    }
    
    .align-text-top {
      vertical-align: text-top !important;
    }
    
     .bg-primary {
      background-color: #114A9F !important;
    }
    
     a.bg-primary:hover,  a.bg-primary:focus,  button.bg-primary:hover,  button.bg-primary:focus {
      background-color: #0c3571 !important;
    }
    
     .bg-secondary {
      background-color: #9C9EA4 !important;
    }
    
     a.bg-secondary:hover,  a.bg-secondary:focus,  button.bg-secondary:hover,  button.bg-secondary:focus {
      background-color: #81848c !important;
    }
    
     .bg-success {
      background-color: #17B75E !important;
    }
    
     a.bg-success:hover,  a.bg-success:focus,  button.bg-success:hover,  button.bg-success:focus {
      background-color: #118a47 !important;
    }
    
     .bg-info {
      background-color: #00CFE8 !important;
    }
    
     a.bg-info:hover,  a.bg-info:focus,  button.bg-info:hover,  button.bg-info:focus {
      background-color: #00a1b5 !important;
    }
    
     .bg-warning {
      background-color: #FDB913 !important;
    }
    
     a.bg-warning:hover,  a.bg-warning:focus,  button.bg-warning:hover,  button.bg-warning:focus {
      background-color: #db9c02 !important;
    }
    
     .bg-danger {
      background-color: #EA5455 !important;
    }
    
     a.bg-danger:hover,  a.bg-danger:focus,  button.bg-danger:hover,  button.bg-danger:focus {
      background-color: #e42728 !important;
    }
    
     .bg-light {
      background-color: #C1C1C1 !important;
    }
    
     a.bg-light:hover,  a.bg-light:focus,  button.bg-light:hover,  button.bg-light:focus {
      background-color: #a8a8a8 !important;
    }
    
     .bg-dark {
      background-color: #4B4B4B !important;
    }
    
     a.bg-dark:hover,  a.bg-dark:focus,  button.bg-dark:hover,  button.bg-dark:focus {
      background-color: #323232 !important;
    }
    
     .bg-white {
      background-color: #fff !important;
    }
    
     .bg-transparent {
      background-color: transparent !important;
    }
    
     .border {
      border: 1px solid #ebe9f1 !important;
    }
    
     .border-top {
      border-top: 1px solid #ebe9f1 !important;
    }
    
    [dir=ltr] .border-right {
      border-right: 1px solid #ebe9f1 !important;
    }
    
    [dir=rtl] .border-right {
      border-left: 1px solid #ebe9f1 !important;
    }
    
     .border-bottom {
      border-bottom: 1px solid #ebe9f1 !important;
    }
    
    [dir=ltr] .border-left {
      border-left: 1px solid #ebe9f1 !important;
    }
    
    [dir=rtl] .border-left {
      border-right: 1px solid #ebe9f1 !important;
    }
    
     .border-0 {
      border: 0 !important;
    }
    
     .border-top-0 {
      border-top: 0 !important;
    }
    
    [dir=ltr] .border-right-0 {
      border-right: 0 !important;
    }
    
    [dir=rtl] .border-right-0 {
      border-left: 0 !important;
    }
    
     .border-bottom-0 {
      border-bottom: 0 !important;
    }
    
    [dir=ltr] .border-left-0 {
      border-left: 0 !important;
    }
    
    [dir=rtl] .border-left-0 {
      border-right: 0 !important;
    }
    
     .border-primary {
      border-color: #114A9F !important;
    }
    
     .border-secondary {
      border-color: #9C9EA4 !important;
    }
    
     .border-success {
      border-color: #17B75E !important;
    }
    
     .border-info {
      border-color: #00CFE8 !important;
    }
    
     .border-warning {
      border-color: #FDB913 !important;
    }
    
     .border-danger {
      border-color: #EA5455 !important;
    }
    
     .border-light {
      border-color: #C1C1C1 !important;
    }
    
     .border-dark {
      border-color: #4B4B4B !important;
    }
    
     .border-white {
      border-color: #fff !important;
    }
    
     .rounded-sm {
      border-radius: 0.25rem !important;
    }
    
     .rounded {
      border-radius: 0.357rem !important;
    }
    
    [dir=ltr] .rounded-top {
      border-top-left-radius: 0.357rem !important;
      border-top-right-radius: 0.357rem !important;
    }
    
    [dir=rtl] .rounded-top {
      border-top-right-radius: 0.357rem !important;
      border-top-left-radius: 0.357rem !important;
    }
    
    [dir=ltr] .rounded-right {
      border-top-right-radius: 0.357rem !important;
      border-bottom-right-radius: 0.357rem !important;
    }
    
    [dir=rtl] .rounded-right {
      border-top-left-radius: 0.357rem !important;
      border-bottom-left-radius: 0.357rem !important;
    }
    
    [dir=ltr] .rounded-bottom {
      border-bottom-right-radius: 0.357rem !important;
      border-bottom-left-radius: 0.357rem !important;
    }
    
    [dir=rtl] .rounded-bottom {
      border-bottom-left-radius: 0.357rem !important;
      border-bottom-right-radius: 0.357rem !important;
    }
    
    [dir=ltr] .rounded-left {
      border-top-left-radius: 0.357rem !important;
      border-bottom-left-radius: 0.357rem !important;
    }
    
    [dir=rtl] .rounded-left {
      border-top-right-radius: 0.357rem !important;
      border-bottom-right-radius: 0.357rem !important;
    }
    
     .rounded-lg {
      border-radius: 0.6rem !important;
    }
    
     .rounded-circle {
      border-radius: 50% !important;
    }
    
     .rounded-pill {
      border-radius: 50rem !important;
    }
    
     .rounded-0 {
      border-radius: 0 !important;
    }
    
    .clearfix::after {
      display: block;
      content: "";
    }
    
     .clearfix::after {
      clear: both;
    }
    
    .d-none {
      display: none !important;
    }
    
    .d-inline {
      display: inline !important;
    }
    
    .d-inline-block {
      display: inline-block !important;
    }
    
    .d-block {
      display: block !important;
    }
    
    .d-table {
      display: table !important;
    }
    
    .d-table-row {
      display: table-row !important;
    }
    
    .d-table-cell {
      display: table-cell !important;
    }
    
    .d-flex {
      display: flex !important;
    }
    
    .d-inline-flex {
      display: inline-flex !important;
    }
    
    @media (min-width: 576px) {
      .d-sm-none {
        display: none !important;
      }
    
      .d-sm-inline {
        display: inline !important;
      }
    
      .d-sm-inline-block {
        display: inline-block !important;
      }
    
      .d-sm-block {
        display: block !important;
      }
    
      .d-sm-table {
        display: table !important;
      }
    
      .d-sm-table-row {
        display: table-row !important;
      }
    
      .d-sm-table-cell {
        display: table-cell !important;
      }
    
      .d-sm-flex {
        display: flex !important;
      }
    
      .d-sm-inline-flex {
        display: inline-flex !important;
      }
    }
    @media (min-width: 768px) {
      .d-md-none {
        display: none !important;
      }
    
      .d-md-inline {
        display: inline !important;
      }
    
      .d-md-inline-block {
        display: inline-block !important;
      }
    
      .d-md-block {
        display: block !important;
      }
    
      .d-md-table {
        display: table !important;
      }
    
      .d-md-table-row {
        display: table-row !important;
      }
    
      .d-md-table-cell {
        display: table-cell !important;
      }
    
      .d-md-flex {
        display: flex !important;
      }
    
      .d-md-inline-flex {
        display: inline-flex !important;
      }
    }
    @media (min-width: 992px) {
      .d-lg-none {
        display: none !important;
      }
    
      .d-lg-inline {
        display: inline !important;
      }
    
      .d-lg-inline-block {
        display: inline-block !important;
      }
    
      .d-lg-block {
        display: block !important;
      }
    
      .d-lg-table {
        display: table !important;
      }
    
      .d-lg-table-row {
        display: table-row !important;
      }
    
      .d-lg-table-cell {
        display: table-cell !important;
      }
    
      .d-lg-flex {
        display: flex !important;
      }
    
      .d-lg-inline-flex {
        display: inline-flex !important;
      }
    }
    @media (min-width: 1200px) {
      .d-xl-none {
        display: none !important;
      }
    
      .d-xl-inline {
        display: inline !important;
      }
    
      .d-xl-inline-block {
        display: inline-block !important;
      }
    
      .d-xl-block {
        display: block !important;
      }
    
      .d-xl-table {
        display: table !important;
      }
    
      .d-xl-table-row {
        display: table-row !important;
      }
    
      .d-xl-table-cell {
        display: table-cell !important;
      }
    
      .d-xl-flex {
        display: flex !important;
      }
    
      .d-xl-inline-flex {
        display: inline-flex !important;
      }
    }
    .embed-responsive {
      position: relative;
      display: block;
      width: 100%;
      overflow: hidden;
    }
     .embed-responsive {
      padding: 0;
    }
    .embed-responsive::before {
      display: block;
      content: "";
    }
    .embed-responsive .embed-responsive-item,
    .embed-responsive iframe,
    .embed-responsive embed,
    .embed-responsive object,
    .embed-responsive video {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
    }
     .embed-responsive .embed-responsive-item,  .embed-responsive iframe,  .embed-responsive embed,  .embed-responsive object,  .embed-responsive video {
      border: 0;
    }
    [dir=ltr] .embed-responsive .embed-responsive-item, [dir=ltr] .embed-responsive iframe, [dir=ltr] .embed-responsive embed, [dir=ltr] .embed-responsive object, [dir=ltr] .embed-responsive video {
      left: 0;
    }
    [dir=rtl] .embed-responsive .embed-responsive-item, [dir=rtl] .embed-responsive iframe, [dir=rtl] .embed-responsive embed, [dir=rtl] .embed-responsive object, [dir=rtl] .embed-responsive video {
      right: 0;
    }
    
     .embed-responsive-21by9::before {
      padding-top: 42.8571428571%;
    }
    
     .embed-responsive-16by9::before {
      padding-top: 56.25%;
    }
    
     .embed-responsive-4by3::before {
      padding-top: 75%;
    }
    
     .embed-responsive-1by1::before {
      padding-top: 100%;
    }
    
     .embed-responsive-21by9::before {
      padding-top: 42.8571428571%;
    }
    
     .embed-responsive-16by9::before {
      padding-top: 56.25%;
    }
    
     .embed-responsive-4by3::before {
      padding-top: 75%;
    }
    
     .embed-responsive-1by1::before {
      padding-top: 100%;
    }
    
    .flex-row {
      flex-direction: row !important;
    }
    
    .flex-column {
      flex-direction: column !important;
    }
    
    .flex-row-reverse {
      flex-direction: row-reverse !important;
    }
    
    .flex-column-reverse {
      flex-direction: column-reverse !important;
    }
    
    .flex-wrap {
      flex-wrap: wrap !important;
    }
    
    .flex-nowrap {
      flex-wrap: nowrap !important;
    }
    
    .flex-wrap-reverse {
      flex-wrap: wrap-reverse !important;
    }
    
    .flex-fill {
      flex: 1 1 auto !important;
    }
    
    .flex-grow-0 {
      flex-grow: 0 !important;
    }
    
    .flex-grow-1 {
      flex-grow: 1 !important;
    }
    
    .flex-shrink-0 {
      flex-shrink: 0 !important;
    }
    
    .flex-shrink-1 {
      flex-shrink: 1 !important;
    }
    
    .justify-content-start {
      justify-content: flex-start !important;
    }
    
    .justify-content-end {
      justify-content: flex-end !important;
    }
    
    .justify-content-center {
      justify-content: center !important;
    }
    
    .justify-content-between {
      justify-content: space-between !important;
    }
    
    .justify-content-around {
      justify-content: space-around !important;
    }
    
    .align-items-start {
      align-items: flex-start !important;
    }
    
    .align-items-end {
      align-items: flex-end !important;
    }
    
    .align-items-center {
      align-items: center !important;
    }
    
    .align-items-baseline {
      align-items: baseline !important;
    }
    
    .align-items-stretch {
      align-items: stretch !important;
    }
    
    .align-content-start {
      align-content: flex-start !important;
    }
    
    .align-content-end {
      align-content: flex-end !important;
    }
    
    .align-content-center {
      align-content: center !important;
    }
    
    .align-content-between {
      align-content: space-between !important;
    }
    
    .align-content-around {
      align-content: space-around !important;
    }
    
    .align-content-stretch {
      align-content: stretch !important;
    }
    
    .align-self-auto {
      align-self: auto !important;
    }
    
    .align-self-start {
      align-self: flex-start !important;
    }
    
    .align-self-end {
      align-self: flex-end !important;
    }
    
    .align-self-center {
      align-self: center !important;
    }
    
    .align-self-baseline {
      align-self: baseline !important;
    }
    
    .align-self-stretch {
      align-self: stretch !important;
    }
    
    @media (min-width: 576px) {
      .flex-sm-row {
        flex-direction: row !important;
      }
    
      .flex-sm-column {
        flex-direction: column !important;
      }
    
      .flex-sm-row-reverse {
        flex-direction: row-reverse !important;
      }
    
      .flex-sm-column-reverse {
        flex-direction: column-reverse !important;
      }
    
      .flex-sm-wrap {
        flex-wrap: wrap !important;
      }
    
      .flex-sm-nowrap {
        flex-wrap: nowrap !important;
      }
    
      .flex-sm-wrap-reverse {
        flex-wrap: wrap-reverse !important;
      }
    
      .flex-sm-fill {
        flex: 1 1 auto !important;
      }
    
      .flex-sm-grow-0 {
        flex-grow: 0 !important;
      }
    
      .flex-sm-grow-1 {
        flex-grow: 1 !important;
      }
    
      .flex-sm-shrink-0 {
        flex-shrink: 0 !important;
      }
    
      .flex-sm-shrink-1 {
        flex-shrink: 1 !important;
      }
    
      .justify-content-sm-start {
        justify-content: flex-start !important;
      }
    
      .justify-content-sm-end {
        justify-content: flex-end !important;
      }
    
      .justify-content-sm-center {
        justify-content: center !important;
      }
    
      .justify-content-sm-between {
        justify-content: space-between !important;
      }
    
      .justify-content-sm-around {
        justify-content: space-around !important;
      }
    
      .align-items-sm-start {
        align-items: flex-start !important;
      }
    
      .align-items-sm-end {
        align-items: flex-end !important;
      }
    
      .align-items-sm-center {
        align-items: center !important;
      }
    
      .align-items-sm-baseline {
        align-items: baseline !important;
      }
    
      .align-items-sm-stretch {
        align-items: stretch !important;
      }
    
      .align-content-sm-start {
        align-content: flex-start !important;
      }
    
      .align-content-sm-end {
        align-content: flex-end !important;
      }
    
      .align-content-sm-center {
        align-content: center !important;
      }
    
      .align-content-sm-between {
        align-content: space-between !important;
      }
    
      .align-content-sm-around {
        align-content: space-around !important;
      }
    
      .align-content-sm-stretch {
        align-content: stretch !important;
      }
    
      .align-self-sm-auto {
        align-self: auto !important;
      }
    
      .align-self-sm-start {
        align-self: flex-start !important;
      }
    
      .align-self-sm-end {
        align-self: flex-end !important;
      }
    
      .align-self-sm-center {
        align-self: center !important;
      }
    
      .align-self-sm-baseline {
        align-self: baseline !important;
      }
    
      .align-self-sm-stretch {
        align-self: stretch !important;
      }
    }
    @media (min-width: 768px) {
      .flex-md-row {
        flex-direction: row !important;
      }
    
      .flex-md-column {
        flex-direction: column !important;
      }
    
      .flex-md-row-reverse {
        flex-direction: row-reverse !important;
      }
    
      .flex-md-column-reverse {
        flex-direction: column-reverse !important;
      }
    
      .flex-md-wrap {
        flex-wrap: wrap !important;
      }
    
      .flex-md-nowrap {
        flex-wrap: nowrap !important;
      }
    
      .flex-md-wrap-reverse {
        flex-wrap: wrap-reverse !important;
      }
    
      .flex-md-fill {
        flex: 1 1 auto !important;
      }
    
      .flex-md-grow-0 {
        flex-grow: 0 !important;
      }
    
      .flex-md-grow-1 {
        flex-grow: 1 !important;
      }
    
      .flex-md-shrink-0 {
        flex-shrink: 0 !important;
      }
    
      .flex-md-shrink-1 {
        flex-shrink: 1 !important;
      }
    
      .justify-content-md-start {
        justify-content: flex-start !important;
      }
    
      .justify-content-md-end {
        justify-content: flex-end !important;
      }
    
      .justify-content-md-center {
        justify-content: center !important;
      }
    
      .justify-content-md-between {
        justify-content: space-between !important;
      }
    
      .justify-content-md-around {
        justify-content: space-around !important;
      }
    
      .align-items-md-start {
        align-items: flex-start !important;
      }
    
      .align-items-md-end {
        align-items: flex-end !important;
      }
    
      .align-items-md-center {
        align-items: center !important;
      }
    
      .align-items-md-baseline {
        align-items: baseline !important;
      }
    
      .align-items-md-stretch {
        align-items: stretch !important;
      }
    
      .align-content-md-start {
        align-content: flex-start !important;
      }
    
      .align-content-md-end {
        align-content: flex-end !important;
      }
    
      .align-content-md-center {
        align-content: center !important;
      }
    
      .align-content-md-between {
        align-content: space-between !important;
      }
    
      .align-content-md-around {
        align-content: space-around !important;
      }
    
      .align-content-md-stretch {
        align-content: stretch !important;
      }
    
      .align-self-md-auto {
        align-self: auto !important;
      }
    
      .align-self-md-start {
        align-self: flex-start !important;
      }
    
      .align-self-md-end {
        align-self: flex-end !important;
      }
    
      .align-self-md-center {
        align-self: center !important;
      }
    
      .align-self-md-baseline {
        align-self: baseline !important;
      }
    
      .align-self-md-stretch {
        align-self: stretch !important;
      }
    }
    @media (min-width: 992px) {
      .flex-lg-row {
        flex-direction: row !important;
      }
    
      .flex-lg-column {
        flex-direction: column !important;
      }
    
      .flex-lg-row-reverse {
        flex-direction: row-reverse !important;
      }
    
      .flex-lg-column-reverse {
        flex-direction: column-reverse !important;
      }
    
      .flex-lg-wrap {
        flex-wrap: wrap !important;
      }
    
      .flex-lg-nowrap {
        flex-wrap: nowrap !important;
      }
    
      .flex-lg-wrap-reverse {
        flex-wrap: wrap-reverse !important;
      }
    
      .flex-lg-fill {
        flex: 1 1 auto !important;
      }
    
      .flex-lg-grow-0 {
        flex-grow: 0 !important;
      }
    
      .flex-lg-grow-1 {
        flex-grow: 1 !important;
      }
    
      .flex-lg-shrink-0 {
        flex-shrink: 0 !important;
      }
    
      .flex-lg-shrink-1 {
        flex-shrink: 1 !important;
      }
    
      .justify-content-lg-start {
        justify-content: flex-start !important;
      }
    
      .justify-content-lg-end {
        justify-content: flex-end !important;
      }
    
      .justify-content-lg-center {
        justify-content: center !important;
      }
    
      .justify-content-lg-between {
        justify-content: space-between !important;
      }
    
      .justify-content-lg-around {
        justify-content: space-around !important;
      }
    
      .align-items-lg-start {
        align-items: flex-start !important;
      }
    
      .align-items-lg-end {
        align-items: flex-end !important;
      }
    
      .align-items-lg-center {
        align-items: center !important;
      }
    
      .align-items-lg-baseline {
        align-items: baseline !important;
      }
    
      .align-items-lg-stretch {
        align-items: stretch !important;
      }
    
      .align-content-lg-start {
        align-content: flex-start !important;
      }
    
      .align-content-lg-end {
        align-content: flex-end !important;
      }
    
      .align-content-lg-center {
        align-content: center !important;
      }
    
      .align-content-lg-between {
        align-content: space-between !important;
      }
    
      .align-content-lg-around {
        align-content: space-around !important;
      }
    
      .align-content-lg-stretch {
        align-content: stretch !important;
      }
    
      .align-self-lg-auto {
        align-self: auto !important;
      }
    
      .align-self-lg-start {
        align-self: flex-start !important;
      }
    
      .align-self-lg-end {
        align-self: flex-end !important;
      }
    
      .align-self-lg-center {
        align-self: center !important;
      }
    
      .align-self-lg-baseline {
        align-self: baseline !important;
      }
    
      .align-self-lg-stretch {
        align-self: stretch !important;
      }
    }
    @media (min-width: 1200px) {
      .flex-xl-row {
        flex-direction: row !important;
      }
    
      .flex-xl-column {
        flex-direction: column !important;
      }
    
      .flex-xl-row-reverse {
        flex-direction: row-reverse !important;
      }
    
      .flex-xl-column-reverse {
        flex-direction: column-reverse !important;
      }
    
      .flex-xl-wrap {
        flex-wrap: wrap !important;
      }
    
      .flex-xl-nowrap {
        flex-wrap: nowrap !important;
      }
    
      .flex-xl-wrap-reverse {
        flex-wrap: wrap-reverse !important;
      }
    
      .flex-xl-fill {
        flex: 1 1 auto !important;
      }
    
      .flex-xl-grow-0 {
        flex-grow: 0 !important;
      }
    
      .flex-xl-grow-1 {
        flex-grow: 1 !important;
      }
    
      .flex-xl-shrink-0 {
        flex-shrink: 0 !important;
      }
    
      .flex-xl-shrink-1 {
        flex-shrink: 1 !important;
      }
    
      .justify-content-xl-start {
        justify-content: flex-start !important;
      }
    
      .justify-content-xl-end {
        justify-content: flex-end !important;
      }
    
      .justify-content-xl-center {
        justify-content: center !important;
      }
    
      .justify-content-xl-between {
        justify-content: space-between !important;
      }
    
      .justify-content-xl-around {
        justify-content: space-around !important;
      }
    
      .align-items-xl-start {
        align-items: flex-start !important;
      }
    
      .align-items-xl-end {
        align-items: flex-end !important;
      }
    
      .align-items-xl-center {
        align-items: center !important;
      }
    
      .align-items-xl-baseline {
        align-items: baseline !important;
      }
    
      .align-items-xl-stretch {
        align-items: stretch !important;
      }
    
      .align-content-xl-start {
        align-content: flex-start !important;
      }
    
      .align-content-xl-end {
        align-content: flex-end !important;
      }
    
      .align-content-xl-center {
        align-content: center !important;
      }
    
      .align-content-xl-between {
        align-content: space-between !important;
      }
    
      .align-content-xl-around {
        align-content: space-around !important;
      }
    
      .align-content-xl-stretch {
        align-content: stretch !important;
      }
    
      .align-self-xl-auto {
        align-self: auto !important;
      }
    
      .align-self-xl-start {
        align-self: flex-start !important;
      }
    
      .align-self-xl-end {
        align-self: flex-end !important;
      }
    
      .align-self-xl-center {
        align-self: center !important;
      }
    
      .align-self-xl-baseline {
        align-self: baseline !important;
      }
    
      .align-self-xl-stretch {
        align-self: stretch !important;
      }
    }
    [dir=ltr] .float-left {
      float: left !important;
    }
    [dir=rtl] .float-left {
      float: right !important;
    }
    
    [dir=ltr] .float-right {
      float: right !important;
    }
    
    [dir=rtl] .float-right {
      float: left !important;
    }
    
     .float-none {
      float: none !important;
    }
    
    @media (min-width: 576px) {
      [dir=ltr] .float-sm-left {
        float: left !important;
      }
      [dir=rtl] .float-sm-left {
        float: right !important;
      }
    
      [dir=ltr] .float-sm-right {
        float: right !important;
      }
    
      [dir=rtl] .float-sm-right {
        float: left !important;
      }
    
       .float-sm-none {
        float: none !important;
      }
    }
    @media (min-width: 768px) {
      [dir=ltr] .float-md-left {
        float: left !important;
      }
      [dir=rtl] .float-md-left {
        float: right !important;
      }
    
      [dir=ltr] .float-md-right {
        float: right !important;
      }
    
      [dir=rtl] .float-md-right {
        float: left !important;
      }
    
       .float-md-none {
        float: none !important;
      }
    }
    @media (min-width: 992px) {
      [dir=ltr] .float-lg-left {
        float: left !important;
      }
      [dir=rtl] .float-lg-left {
        float: right !important;
      }
    
      [dir=ltr] .float-lg-right {
        float: right !important;
      }
    
      [dir=rtl] .float-lg-right {
        float: left !important;
      }
    
       .float-lg-none {
        float: none !important;
      }
    }
    @media (min-width: 1200px) {
      [dir=ltr] .float-xl-left {
        float: left !important;
      }
      [dir=rtl] .float-xl-left {
        float: right !important;
      }
    
      [dir=ltr] .float-xl-right {
        float: right !important;
      }
    
      [dir=rtl] .float-xl-right {
        float: left !important;
      }
    
       .float-xl-none {
        float: none !important;
      }
    }
    .user-select-all {
      user-select: all !important;
    }
    
    .user-select-auto {
      user-select: auto !important;
    }
    
    .user-select-none {
      user-select: none !important;
    }
    
    .overflow-auto {
      overflow: auto !important;
    }
    
    .overflow-hidden {
      overflow: hidden !important;
    }
    
    .position-static {
      position: static !important;
    }
    
    .position-relative {
      position: relative !important;
    }
    
    .position-absolute {
      position: absolute !important;
    }
    
    .position-fixed {
      position: fixed !important;
    }
    
    .position-sticky {
      position: sticky !important;
    }
    
    .fixed-top {
      position: fixed;
      top: 0;
      z-index: 1030;
    }
    
    [dir=ltr] .fixed-top {
      right: 0;
      left: 0;
    }
    
    [dir=rtl] .fixed-top {
      left: 0;
      right: 0;
    }
    
    .fixed-bottom {
      position: fixed;
      bottom: 0;
      z-index: 1030;
    }
    
    [dir=ltr] .fixed-bottom {
      right: 0;
      left: 0;
    }
    
    [dir=rtl] .fixed-bottom {
      left: 0;
      right: 0;
    }
    
    @supports (position: sticky) {
      .sticky-top {
        position: sticky;
        top: 0;
        z-index: 1020;
      }
    }
    
    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
    }
    
     .sr-only {
      padding: 0;
      margin: -1px;
      border: 0;
    }
    
    .sr-only-focusable:active, .sr-only-focusable:focus {
      position: static;
      width: auto;
      height: auto;
      overflow: visible;
      clip: auto;
      white-space: normal;
    }
    
     .shadow-sm {
      box-shadow: 0 0.125rem 0.25rem rgba(34, 41, 47, 0.075) !important;
    }
    
     .shadow {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;
    }
    
     .shadow-lg {
      box-shadow: 0 1rem 3rem rgba(34, 41, 47, 0.175) !important;
    }
    
     .shadow-none {
      box-shadow: none !important;
    }
    
    .w-25 {
      width: 25% !important;
    }
    
    .w-50 {
      width: 50% !important;
    }
    
    .w-75 {
      width: 75% !important;
    }
    
    .w-100 {
      width: 100% !important;
    }
    
    .w-auto {
      width: auto !important;
    }
    
    .h-25 {
      height: 25% !important;
    }
    
    .h-50 {
      height: 50% !important;
    }
    
    .h-75 {
      height: 75% !important;
    }
    
    .h-100 {
      height: 100% !important;
    }
    
    .h-auto {
      height: auto !important;
    }
    
    .mw-100 {
      max-width: 100% !important;
    }
    
    .mh-100 {
      max-height: 100% !important;
    }
    
    .min-vw-100 {
      min-width: 100vw !important;
    }
    
    .min-vh-100 {
      min-height: 100vh !important;
    }
    
    .vw-100 {
      width: 100vw !important;
    }
    
    .vh-100 {
      height: 100vh !important;
    }
    
     .m-0 {
      margin: 0 !important;
    }
    
     .mt-0,  .my-0 {
      margin-top: 0 !important;
    }
    
    [dir=ltr] .mr-0, [dir=ltr] .mx-0 {
      margin-right: 0 !important;
    }
    
    [dir=rtl] .mr-0, [dir=rtl] .mx-0 {
      margin-left: 0 !important;
    }
    
     .mb-0,  .my-0 {
      margin-bottom: 0 !important;
    }
    
    [dir=ltr] .ml-0, [dir=ltr] .mx-0 {
      margin-left: 0 !important;
    }
    
    [dir=rtl] .ml-0, [dir=rtl] .mx-0 {
      margin-right: 0 !important;
    }
    
     .m-1 {
      margin: 1rem !important;
    }
    
     .mt-1,  .my-1 {
      margin-top: 1rem !important;
    }
    
    [dir=ltr] .mr-1, [dir=ltr] .mx-1 {
      margin-right: 1rem !important;
    }
    
    [dir=rtl] .mr-1, [dir=rtl] .mx-1 {
      margin-left: 1rem !important;
    }
    
     .mb-1,  .my-1 {
      margin-bottom: 1rem !important;
    }
    
    [dir=ltr] .ml-1, [dir=ltr] .mx-1 {
      margin-left: 1rem !important;
    }
    
    [dir=rtl] .ml-1, [dir=rtl] .mx-1 {
      margin-right: 1rem !important;
    }
    
     .m-2 {
      margin: 1.5rem !important;
    }
    
     .mt-2,  .my-2 {
      margin-top: 1.5rem !important;
    }
    
    [dir=ltr] .mr-2, [dir=ltr] .mx-2 {
      margin-right: 1.5rem !important;
    }
    
    [dir=rtl] .mr-2, [dir=rtl] .mx-2 {
      margin-left: 1.5rem !important;
    }
    
     .mb-2,  .my-2 {
      margin-bottom: 1.5rem !important;
    }
    
    [dir=ltr] .ml-2, [dir=ltr] .mx-2 {
      margin-left: 1.5rem !important;
    }
    
    [dir=rtl] .ml-2, [dir=rtl] .mx-2 {
      margin-right: 1.5rem !important;
    }
    
     .m-3 {
      margin: 3rem !important;
    }
    
     .mt-3,  .my-3 {
      margin-top: 3rem !important;
    }
    
    [dir=ltr] .mr-3, [dir=ltr] .mx-3 {
      margin-right: 3rem !important;
    }
    
    [dir=rtl] .mr-3, [dir=rtl] .mx-3 {
      margin-left: 3rem !important;
    }
    
     .mb-3,  .my-3 {
      margin-bottom: 3rem !important;
    }
    
    [dir=ltr] .ml-3, [dir=ltr] .mx-3 {
      margin-left: 3rem !important;
    }
    
    [dir=rtl] .ml-3, [dir=rtl] .mx-3 {
      margin-right: 3rem !important;
    }
    
     .m-4 {
      margin: 3.5rem !important;
    }
    
     .mt-4,  .my-4 {
      margin-top: 3.5rem !important;
    }
    
    [dir=ltr] .mr-4, [dir=ltr] .mx-4 {
      margin-right: 3.5rem !important;
    }
    
    [dir=rtl] .mr-4, [dir=rtl] .mx-4 {
      margin-left: 3.5rem !important;
    }
    
     .mb-4,  .my-4 {
      margin-bottom: 3.5rem !important;
    }
    
    [dir=ltr] .ml-4, [dir=ltr] .mx-4 {
      margin-left: 3.5rem !important;
    }
    
    [dir=rtl] .ml-4, [dir=rtl] .mx-4 {
      margin-right: 3.5rem !important;
    }
    
     .m-5 {
      margin: 4rem !important;
    }
    
     .mt-5,  .my-5 {
      margin-top: 4rem !important;
    }
    
    [dir=ltr] .mr-5, [dir=ltr] .mx-5 {
      margin-right: 4rem !important;
    }
    
    [dir=rtl] .mr-5, [dir=rtl] .mx-5 {
      margin-left: 4rem !important;
    }
    
     .mb-5,  .my-5 {
      margin-bottom: 4rem !important;
    }
    
    [dir=ltr] .ml-5, [dir=ltr] .mx-5 {
      margin-left: 4rem !important;
    }
    
    [dir=rtl] .ml-5, [dir=rtl] .mx-5 {
      margin-right: 4rem !important;
    }
    
     .m-25 {
      margin: 0.25rem !important;
    }
    
     .mt-25,  .my-25 {
      margin-top: 0.25rem !important;
    }
    
    [dir=ltr] .mr-25, [dir=ltr] .mx-25 {
      margin-right: 0.25rem !important;
    }
    
    [dir=rtl] .mr-25, [dir=rtl] .mx-25 {
      margin-left: 0.25rem !important;
    }
    
     .mb-25,  .my-25 {
      margin-bottom: 0.25rem !important;
    }
    
    [dir=ltr] .ml-25, [dir=ltr] .mx-25 {
      margin-left: 0.25rem !important;
    }
    
    [dir=rtl] .ml-25, [dir=rtl] .mx-25 {
      margin-right: 0.25rem !important;
    }
    
     .m-50 {
      margin: 0.5rem !important;
    }
    
     .mt-50,  .my-50 {
      margin-top: 0.5rem !important;
    }
    
    [dir=ltr] .mr-50, [dir=ltr] .mx-50 {
      margin-right: 0.5rem !important;
    }
    
    [dir=rtl] .mr-50, [dir=rtl] .mx-50 {
      margin-left: 0.5rem !important;
    }
    
     .mb-50,  .my-50 {
      margin-bottom: 0.5rem !important;
    }
    
    [dir=ltr] .ml-50, [dir=ltr] .mx-50 {
      margin-left: 0.5rem !important;
    }
    
    [dir=rtl] .ml-50, [dir=rtl] .mx-50 {
      margin-right: 0.5rem !important;
    }
    
     .m-75 {
      margin: 0.75rem !important;
    }
    
     .mt-75,  .my-75 {
      margin-top: 0.75rem !important;
    }
    
    [dir=ltr] .mr-75, [dir=ltr] .mx-75 {
      margin-right: 0.75rem !important;
    }
    
    [dir=rtl] .mr-75, [dir=rtl] .mx-75 {
      margin-left: 0.75rem !important;
    }
    
     .mb-75,  .my-75 {
      margin-bottom: 0.75rem !important;
    }
    
    [dir=ltr] .ml-75, [dir=ltr] .mx-75 {
      margin-left: 0.75rem !important;
    }
    
    [dir=rtl] .ml-75, [dir=rtl] .mx-75 {
      margin-right: 0.75rem !important;
    }
    
     .p-0 {
      padding: 0 !important;
    }
    
     .pt-0,  .py-0 {
      padding-top: 0 !important;
    }
    
    [dir=ltr] .pr-0, [dir=ltr] .px-0 {
      padding-right: 0 !important;
    }
    
    [dir=rtl] .pr-0, [dir=rtl] .px-0 {
      padding-left: 0 !important;
    }
    
     .pb-0,  .py-0 {
      padding-bottom: 0 !important;
    }
    
    [dir=ltr] .pl-0, [dir=ltr] .px-0 {
      padding-left: 0 !important;
    }
    
    [dir=rtl] .pl-0, [dir=rtl] .px-0 {
      padding-right: 0 !important;
    }
    
     .p-1 {
      padding: 1rem !important;
    }
    
     .pt-1,  .py-1 {
      padding-top: 1rem !important;
    }
    
    [dir=ltr] .pr-1, [dir=ltr] .px-1 {
      padding-right: 1rem !important;
    }
    
    [dir=rtl] .pr-1, [dir=rtl] .px-1 {
      padding-left: 1rem !important;
    }
    
     .pb-1,  .py-1 {
      padding-bottom: 1rem !important;
    }
    
    [dir=ltr] .pl-1, [dir=ltr] .px-1 {
      padding-left: 1rem !important;
    }
    
    [dir=rtl] .pl-1, [dir=rtl] .px-1 {
      padding-right: 1rem !important;
    }
    
     .p-2 {
      padding: 1.5rem !important;
    }
    
     .pt-2,  .py-2 {
      padding-top: 1.5rem !important;
    }
    
    [dir=ltr] .pr-2, [dir=ltr] .px-2 {
      padding-right: 1.5rem !important;
    }
    
    [dir=rtl] .pr-2, [dir=rtl] .px-2 {
      padding-left: 1.5rem !important;
    }
    
     .pb-2,  .py-2 {
      padding-bottom: 1.5rem !important;
    }
    
    [dir=ltr] .pl-2, [dir=ltr] .px-2 {
      padding-left: 1.5rem !important;
    }
    
    [dir=rtl] .pl-2, [dir=rtl] .px-2 {
      padding-right: 1.5rem !important;
    }
    
     .p-3 {
      padding: 3rem !important;
    }
    
     .pt-3,  .py-3 {
      padding-top: 3rem !important;
    }
    
    [dir=ltr] .pr-3, [dir=ltr] .px-3 {
      padding-right: 3rem !important;
    }
    
    [dir=rtl] .pr-3, [dir=rtl] .px-3 {
      padding-left: 3rem !important;
    }
    
     .pb-3,  .py-3 {
      padding-bottom: 3rem !important;
    }
    
    [dir=ltr] .pl-3, [dir=ltr] .px-3 {
      padding-left: 3rem !important;
    }
    
    [dir=rtl] .pl-3, [dir=rtl] .px-3 {
      padding-right: 3rem !important;
    }
    
     .p-4 {
      padding: 3.5rem !important;
    }
    
     .pt-4,  .py-4 {
      padding-top: 3.5rem !important;
    }
    
    [dir=ltr] .pr-4, [dir=ltr] .px-4 {
      padding-right: 3.5rem !important;
    }
    
    [dir=rtl] .pr-4, [dir=rtl] .px-4 {
      padding-left: 3.5rem !important;
    }
    
     .pb-4,  .py-4 {
      padding-bottom: 3.5rem !important;
    }
    
    [dir=ltr] .pl-4, [dir=ltr] .px-4 {
      padding-left: 3.5rem !important;
    }
    
    [dir=rtl] .pl-4, [dir=rtl] .px-4 {
      padding-right: 3.5rem !important;
    }
    
     .p-5 {
      padding: 4rem !important;
    }
    
     .pt-5,  .py-5 {
      padding-top: 4rem !important;
    }
    
    [dir=ltr] .pr-5, [dir=ltr] .px-5 {
      padding-right: 4rem !important;
    }
    
    [dir=rtl] .pr-5, [dir=rtl] .px-5 {
      padding-left: 4rem !important;
    }
    
     .pb-5,  .py-5 {
      padding-bottom: 4rem !important;
    }
    
    [dir=ltr] .pl-5, [dir=ltr] .px-5 {
      padding-left: 4rem !important;
    }
    
    [dir=rtl] .pl-5, [dir=rtl] .px-5 {
      padding-right: 4rem !important;
    }
    
     .p-25 {
      padding: 0.25rem !important;
    }
    
     .pt-25,  .py-25 {
      padding-top: 0.25rem !important;
    }
    
    [dir=ltr] .pr-25, [dir=ltr] .px-25 {
      padding-right: 0.25rem !important;
    }
    
    [dir=rtl] .pr-25, [dir=rtl] .px-25 {
      padding-left: 0.25rem !important;
    }
    
     .pb-25,  .py-25 {
      padding-bottom: 0.25rem !important;
    }
    
    [dir=ltr] .pl-25, [dir=ltr] .px-25 {
      padding-left: 0.25rem !important;
    }
    
    [dir=rtl] .pl-25, [dir=rtl] .px-25 {
      padding-right: 0.25rem !important;
    }
    
     .p-50 {
      padding: 0.5rem !important;
    }
    
     .pt-50,  .py-50 {
      padding-top: 0.5rem !important;
    }
    
    [dir=ltr] .pr-50, [dir=ltr] .px-50 {
      padding-right: 0.5rem !important;
    }
    
    [dir=rtl] .pr-50, [dir=rtl] .px-50 {
      padding-left: 0.5rem !important;
    }
    
     .pb-50,  .py-50 {
      padding-bottom: 0.5rem !important;
    }
    
    [dir=ltr] .pl-50, [dir=ltr] .px-50 {
      padding-left: 0.5rem !important;
    }
    
    [dir=rtl] .pl-50, [dir=rtl] .px-50 {
      padding-right: 0.5rem !important;
    }
    
     .p-75 {
      padding: 0.75rem !important;
    }
    
     .pt-75,  .py-75 {
      padding-top: 0.75rem !important;
    }
    
    [dir=ltr] .pr-75, [dir=ltr] .px-75 {
      padding-right: 0.75rem !important;
    }
    
    [dir=rtl] .pr-75, [dir=rtl] .px-75 {
      padding-left: 0.75rem !important;
    }
    
     .pb-75,  .py-75 {
      padding-bottom: 0.75rem !important;
    }
    
    [dir=ltr] .pl-75, [dir=ltr] .px-75 {
      padding-left: 0.75rem !important;
    }
    
    [dir=rtl] .pl-75, [dir=rtl] .px-75 {
      padding-right: 0.75rem !important;
    }
    
     .m-n1 {
      margin: -1rem !important;
    }
    
     .mt-n1,  .my-n1 {
      margin-top: -1rem !important;
    }
    
    [dir=ltr] .mr-n1, [dir=ltr] .mx-n1 {
      margin-right: -1rem !important;
    }
    
    [dir=rtl] .mr-n1, [dir=rtl] .mx-n1 {
      margin-left: -1rem !important;
    }
    
     .mb-n1,  .my-n1 {
      margin-bottom: -1rem !important;
    }
    
    [dir=ltr] .ml-n1, [dir=ltr] .mx-n1 {
      margin-left: -1rem !important;
    }
    
    [dir=rtl] .ml-n1, [dir=rtl] .mx-n1 {
      margin-right: -1rem !important;
    }
    
     .m-n2 {
      margin: -1.5rem !important;
    }
    
     .mt-n2,  .my-n2 {
      margin-top: -1.5rem !important;
    }
    
    [dir=ltr] .mr-n2, [dir=ltr] .mx-n2 {
      margin-right: -1.5rem !important;
    }
    
    [dir=rtl] .mr-n2, [dir=rtl] .mx-n2 {
      margin-left: -1.5rem !important;
    }
    
     .mb-n2,  .my-n2 {
      margin-bottom: -1.5rem !important;
    }
    
    [dir=ltr] .ml-n2, [dir=ltr] .mx-n2 {
      margin-left: -1.5rem !important;
    }
    
    [dir=rtl] .ml-n2, [dir=rtl] .mx-n2 {
      margin-right: -1.5rem !important;
    }
    
     .m-n3 {
      margin: -3rem !important;
    }
    
     .mt-n3,  .my-n3 {
      margin-top: -3rem !important;
    }
    
    [dir=ltr] .mr-n3, [dir=ltr] .mx-n3 {
      margin-right: -3rem !important;
    }
    
    [dir=rtl] .mr-n3, [dir=rtl] .mx-n3 {
      margin-left: -3rem !important;
    }
    
     .mb-n3,  .my-n3 {
      margin-bottom: -3rem !important;
    }
    
    [dir=ltr] .ml-n3, [dir=ltr] .mx-n3 {
      margin-left: -3rem !important;
    }
    
    [dir=rtl] .ml-n3, [dir=rtl] .mx-n3 {
      margin-right: -3rem !important;
    }
    
     .m-n4 {
      margin: -3.5rem !important;
    }
    
     .mt-n4,  .my-n4 {
      margin-top: -3.5rem !important;
    }
    
    [dir=ltr] .mr-n4, [dir=ltr] .mx-n4 {
      margin-right: -3.5rem !important;
    }
    
    [dir=rtl] .mr-n4, [dir=rtl] .mx-n4 {
      margin-left: -3.5rem !important;
    }
    
     .mb-n4,  .my-n4 {
      margin-bottom: -3.5rem !important;
    }
    
    [dir=ltr] .ml-n4, [dir=ltr] .mx-n4 {
      margin-left: -3.5rem !important;
    }
    
    [dir=rtl] .ml-n4, [dir=rtl] .mx-n4 {
      margin-right: -3.5rem !important;
    }
    
     .m-n5 {
      margin: -4rem !important;
    }
    
     .mt-n5,  .my-n5 {
      margin-top: -4rem !important;
    }
    
    [dir=ltr] .mr-n5, [dir=ltr] .mx-n5 {
      margin-right: -4rem !important;
    }
    
    [dir=rtl] .mr-n5, [dir=rtl] .mx-n5 {
      margin-left: -4rem !important;
    }
    
     .mb-n5,  .my-n5 {
      margin-bottom: -4rem !important;
    }
    
    [dir=ltr] .ml-n5, [dir=ltr] .mx-n5 {
      margin-left: -4rem !important;
    }
    
    [dir=rtl] .ml-n5, [dir=rtl] .mx-n5 {
      margin-right: -4rem !important;
    }
    
     .m-n25 {
      margin: -0.25rem !important;
    }
    
     .mt-n25,  .my-n25 {
      margin-top: -0.25rem !important;
    }
    
    [dir=ltr] .mr-n25, [dir=ltr] .mx-n25 {
      margin-right: -0.25rem !important;
    }
    
    [dir=rtl] .mr-n25, [dir=rtl] .mx-n25 {
      margin-left: -0.25rem !important;
    }
    
     .mb-n25,  .my-n25 {
      margin-bottom: -0.25rem !important;
    }
    
    [dir=ltr] .ml-n25, [dir=ltr] .mx-n25 {
      margin-left: -0.25rem !important;
    }
    
    [dir=rtl] .ml-n25, [dir=rtl] .mx-n25 {
      margin-right: -0.25rem !important;
    }
    
     .m-n50 {
      margin: -0.5rem !important;
    }
    
     .mt-n50,  .my-n50 {
      margin-top: -0.5rem !important;
    }
    
    [dir=ltr] .mr-n50, [dir=ltr] .mx-n50 {
      margin-right: -0.5rem !important;
    }
    
    [dir=rtl] .mr-n50, [dir=rtl] .mx-n50 {
      margin-left: -0.5rem !important;
    }
    
     .mb-n50,  .my-n50 {
      margin-bottom: -0.5rem !important;
    }
    
    [dir=ltr] .ml-n50, [dir=ltr] .mx-n50 {
      margin-left: -0.5rem !important;
    }
    
    [dir=rtl] .ml-n50, [dir=rtl] .mx-n50 {
      margin-right: -0.5rem !important;
    }
    
     .m-n75 {
      margin: -0.75rem !important;
    }
    
     .mt-n75,  .my-n75 {
      margin-top: -0.75rem !important;
    }
    
    [dir=ltr] .mr-n75, [dir=ltr] .mx-n75 {
      margin-right: -0.75rem !important;
    }
    
    [dir=rtl] .mr-n75, [dir=rtl] .mx-n75 {
      margin-left: -0.75rem !important;
    }
    
     .mb-n75,  .my-n75 {
      margin-bottom: -0.75rem !important;
    }
    
    [dir=ltr] .ml-n75, [dir=ltr] .mx-n75 {
      margin-left: -0.75rem !important;
    }
    
    [dir=rtl] .ml-n75, [dir=rtl] .mx-n75 {
      margin-right: -0.75rem !important;
    }
    
     .m-auto {
      margin: auto !important;
    }
    
     .mt-auto,  .my-auto {
      margin-top: auto !important;
    }
    
    [dir=ltr] .mr-auto, [dir=ltr] .mx-auto {
      margin-right: auto !important;
    }
    
    [dir=rtl] .mr-auto, [dir=rtl] .mx-auto {
      margin-left: auto !important;
    }
    
     .mb-auto,  .my-auto {
      margin-bottom: auto !important;
    }
    
    [dir=ltr] .ml-auto, [dir=ltr] .mx-auto {
      margin-left: auto !important;
    }
    
    [dir=rtl] .ml-auto, [dir=rtl] .mx-auto {
      margin-right: auto !important;
    }
    
    @media (min-width: 576px) {
       .m-sm-0 {
        margin: 0 !important;
      }
    
       .mt-sm-0,  .my-sm-0 {
        margin-top: 0 !important;
      }
    
      [dir=ltr] .mr-sm-0, [dir=ltr] .mx-sm-0 {
        margin-right: 0 !important;
      }
    
      [dir=rtl] .mr-sm-0, [dir=rtl] .mx-sm-0 {
        margin-left: 0 !important;
      }
    
       .mb-sm-0,  .my-sm-0 {
        margin-bottom: 0 !important;
      }
    
      [dir=ltr] .ml-sm-0, [dir=ltr] .mx-sm-0 {
        margin-left: 0 !important;
      }
    
      [dir=rtl] .ml-sm-0, [dir=rtl] .mx-sm-0 {
        margin-right: 0 !important;
      }
    
       .m-sm-1 {
        margin: 1rem !important;
      }
    
       .mt-sm-1,  .my-sm-1 {
        margin-top: 1rem !important;
      }
    
      [dir=ltr] .mr-sm-1, [dir=ltr] .mx-sm-1 {
        margin-right: 1rem !important;
      }
    
      [dir=rtl] .mr-sm-1, [dir=rtl] .mx-sm-1 {
        margin-left: 1rem !important;
      }
    
       .mb-sm-1,  .my-sm-1 {
        margin-bottom: 1rem !important;
      }
    
      [dir=ltr] .ml-sm-1, [dir=ltr] .mx-sm-1 {
        margin-left: 1rem !important;
      }
    
      [dir=rtl] .ml-sm-1, [dir=rtl] .mx-sm-1 {
        margin-right: 1rem !important;
      }
    
       .m-sm-2 {
        margin: 1.5rem !important;
      }
    
       .mt-sm-2,  .my-sm-2 {
        margin-top: 1.5rem !important;
      }
    
      [dir=ltr] .mr-sm-2, [dir=ltr] .mx-sm-2 {
        margin-right: 1.5rem !important;
      }
    
      [dir=rtl] .mr-sm-2, [dir=rtl] .mx-sm-2 {
        margin-left: 1.5rem !important;
      }
    
       .mb-sm-2,  .my-sm-2 {
        margin-bottom: 1.5rem !important;
      }
    
      [dir=ltr] .ml-sm-2, [dir=ltr] .mx-sm-2 {
        margin-left: 1.5rem !important;
      }
    
      [dir=rtl] .ml-sm-2, [dir=rtl] .mx-sm-2 {
        margin-right: 1.5rem !important;
      }
    
       .m-sm-3 {
        margin: 3rem !important;
      }
    
       .mt-sm-3,  .my-sm-3 {
        margin-top: 3rem !important;
      }
    
      [dir=ltr] .mr-sm-3, [dir=ltr] .mx-sm-3 {
        margin-right: 3rem !important;
      }
    
      [dir=rtl] .mr-sm-3, [dir=rtl] .mx-sm-3 {
        margin-left: 3rem !important;
      }
    
       .mb-sm-3,  .my-sm-3 {
        margin-bottom: 3rem !important;
      }
    
      [dir=ltr] .ml-sm-3, [dir=ltr] .mx-sm-3 {
        margin-left: 3rem !important;
      }
    
      [dir=rtl] .ml-sm-3, [dir=rtl] .mx-sm-3 {
        margin-right: 3rem !important;
      }
    
       .m-sm-4 {
        margin: 3.5rem !important;
      }
    
       .mt-sm-4,  .my-sm-4 {
        margin-top: 3.5rem !important;
      }
    
      [dir=ltr] .mr-sm-4, [dir=ltr] .mx-sm-4 {
        margin-right: 3.5rem !important;
      }
    
      [dir=rtl] .mr-sm-4, [dir=rtl] .mx-sm-4 {
        margin-left: 3.5rem !important;
      }
    
       .mb-sm-4,  .my-sm-4 {
        margin-bottom: 3.5rem !important;
      }
    
      [dir=ltr] .ml-sm-4, [dir=ltr] .mx-sm-4 {
        margin-left: 3.5rem !important;
      }
    
      [dir=rtl] .ml-sm-4, [dir=rtl] .mx-sm-4 {
        margin-right: 3.5rem !important;
      }
    
       .m-sm-5 {
        margin: 4rem !important;
      }
    
       .mt-sm-5,  .my-sm-5 {
        margin-top: 4rem !important;
      }
    
      [dir=ltr] .mr-sm-5, [dir=ltr] .mx-sm-5 {
        margin-right: 4rem !important;
      }
    
      [dir=rtl] .mr-sm-5, [dir=rtl] .mx-sm-5 {
        margin-left: 4rem !important;
      }
    
       .mb-sm-5,  .my-sm-5 {
        margin-bottom: 4rem !important;
      }
    
      [dir=ltr] .ml-sm-5, [dir=ltr] .mx-sm-5 {
        margin-left: 4rem !important;
      }
    
      [dir=rtl] .ml-sm-5, [dir=rtl] .mx-sm-5 {
        margin-right: 4rem !important;
      }
    
       .m-sm-25 {
        margin: 0.25rem !important;
      }
    
       .mt-sm-25,  .my-sm-25 {
        margin-top: 0.25rem !important;
      }
    
      [dir=ltr] .mr-sm-25, [dir=ltr] .mx-sm-25 {
        margin-right: 0.25rem !important;
      }
    
      [dir=rtl] .mr-sm-25, [dir=rtl] .mx-sm-25 {
        margin-left: 0.25rem !important;
      }
    
       .mb-sm-25,  .my-sm-25 {
        margin-bottom: 0.25rem !important;
      }
    
      [dir=ltr] .ml-sm-25, [dir=ltr] .mx-sm-25 {
        margin-left: 0.25rem !important;
      }
    
      [dir=rtl] .ml-sm-25, [dir=rtl] .mx-sm-25 {
        margin-right: 0.25rem !important;
      }
    
       .m-sm-50 {
        margin: 0.5rem !important;
      }
    
       .mt-sm-50,  .my-sm-50 {
        margin-top: 0.5rem !important;
      }
    
      [dir=ltr] .mr-sm-50, [dir=ltr] .mx-sm-50 {
        margin-right: 0.5rem !important;
      }
    
      [dir=rtl] .mr-sm-50, [dir=rtl] .mx-sm-50 {
        margin-left: 0.5rem !important;
      }
    
       .mb-sm-50,  .my-sm-50 {
        margin-bottom: 0.5rem !important;
      }
    
      [dir=ltr] .ml-sm-50, [dir=ltr] .mx-sm-50 {
        margin-left: 0.5rem !important;
      }
    
      [dir=rtl] .ml-sm-50, [dir=rtl] .mx-sm-50 {
        margin-right: 0.5rem !important;
      }
    
       .m-sm-75 {
        margin: 0.75rem !important;
      }
    
       .mt-sm-75,  .my-sm-75 {
        margin-top: 0.75rem !important;
      }
    
      [dir=ltr] .mr-sm-75, [dir=ltr] .mx-sm-75 {
        margin-right: 0.75rem !important;
      }
    
      [dir=rtl] .mr-sm-75, [dir=rtl] .mx-sm-75 {
        margin-left: 0.75rem !important;
      }
    
       .mb-sm-75,  .my-sm-75 {
        margin-bottom: 0.75rem !important;
      }
    
      [dir=ltr] .ml-sm-75, [dir=ltr] .mx-sm-75 {
        margin-left: 0.75rem !important;
      }
    
      [dir=rtl] .ml-sm-75, [dir=rtl] .mx-sm-75 {
        margin-right: 0.75rem !important;
      }
    
       .p-sm-0 {
        padding: 0 !important;
      }
    
       .pt-sm-0,  .py-sm-0 {
        padding-top: 0 !important;
      }
    
      [dir=ltr] .pr-sm-0, [dir=ltr] .px-sm-0 {
        padding-right: 0 !important;
      }
    
      [dir=rtl] .pr-sm-0, [dir=rtl] .px-sm-0 {
        padding-left: 0 !important;
      }
    
       .pb-sm-0,  .py-sm-0 {
        padding-bottom: 0 !important;
      }
    
      [dir=ltr] .pl-sm-0, [dir=ltr] .px-sm-0 {
        padding-left: 0 !important;
      }
    
      [dir=rtl] .pl-sm-0, [dir=rtl] .px-sm-0 {
        padding-right: 0 !important;
      }
    
       .p-sm-1 {
        padding: 1rem !important;
      }
    
       .pt-sm-1,  .py-sm-1 {
        padding-top: 1rem !important;
      }
    
      [dir=ltr] .pr-sm-1, [dir=ltr] .px-sm-1 {
        padding-right: 1rem !important;
      }
    
      [dir=rtl] .pr-sm-1, [dir=rtl] .px-sm-1 {
        padding-left: 1rem !important;
      }
    
       .pb-sm-1,  .py-sm-1 {
        padding-bottom: 1rem !important;
      }
    
      [dir=ltr] .pl-sm-1, [dir=ltr] .px-sm-1 {
        padding-left: 1rem !important;
      }
    
      [dir=rtl] .pl-sm-1, [dir=rtl] .px-sm-1 {
        padding-right: 1rem !important;
      }
    
       .p-sm-2 {
        padding: 1.5rem !important;
      }
    
       .pt-sm-2,  .py-sm-2 {
        padding-top: 1.5rem !important;
      }
    
      [dir=ltr] .pr-sm-2, [dir=ltr] .px-sm-2 {
        padding-right: 1.5rem !important;
      }
    
      [dir=rtl] .pr-sm-2, [dir=rtl] .px-sm-2 {
        padding-left: 1.5rem !important;
      }
    
       .pb-sm-2,  .py-sm-2 {
        padding-bottom: 1.5rem !important;
      }
    
      [dir=ltr] .pl-sm-2, [dir=ltr] .px-sm-2 {
        padding-left: 1.5rem !important;
      }
    
      [dir=rtl] .pl-sm-2, [dir=rtl] .px-sm-2 {
        padding-right: 1.5rem !important;
      }
    
       .p-sm-3 {
        padding: 3rem !important;
      }
    
       .pt-sm-3,  .py-sm-3 {
        padding-top: 3rem !important;
      }
    
      [dir=ltr] .pr-sm-3, [dir=ltr] .px-sm-3 {
        padding-right: 3rem !important;
      }
    
      [dir=rtl] .pr-sm-3, [dir=rtl] .px-sm-3 {
        padding-left: 3rem !important;
      }
    
       .pb-sm-3,  .py-sm-3 {
        padding-bottom: 3rem !important;
      }
    
      [dir=ltr] .pl-sm-3, [dir=ltr] .px-sm-3 {
        padding-left: 3rem !important;
      }
    
      [dir=rtl] .pl-sm-3, [dir=rtl] .px-sm-3 {
        padding-right: 3rem !important;
      }
    
       .p-sm-4 {
        padding: 3.5rem !important;
      }
    
       .pt-sm-4,  .py-sm-4 {
        padding-top: 3.5rem !important;
      }
    
      [dir=ltr] .pr-sm-4, [dir=ltr] .px-sm-4 {
        padding-right: 3.5rem !important;
      }
    
      [dir=rtl] .pr-sm-4, [dir=rtl] .px-sm-4 {
        padding-left: 3.5rem !important;
      }
    
       .pb-sm-4,  .py-sm-4 {
        padding-bottom: 3.5rem !important;
      }
    
      [dir=ltr] .pl-sm-4, [dir=ltr] .px-sm-4 {
        padding-left: 3.5rem !important;
      }
    
      [dir=rtl] .pl-sm-4, [dir=rtl] .px-sm-4 {
        padding-right: 3.5rem !important;
      }
    
       .p-sm-5 {
        padding: 4rem !important;
      }
    
       .pt-sm-5,  .py-sm-5 {
        padding-top: 4rem !important;
      }
    
      [dir=ltr] .pr-sm-5, [dir=ltr] .px-sm-5 {
        padding-right: 4rem !important;
      }
    
      [dir=rtl] .pr-sm-5, [dir=rtl] .px-sm-5 {
        padding-left: 4rem !important;
      }
    
       .pb-sm-5,  .py-sm-5 {
        padding-bottom: 4rem !important;
      }
    
      [dir=ltr] .pl-sm-5, [dir=ltr] .px-sm-5 {
        padding-left: 4rem !important;
      }
    
      [dir=rtl] .pl-sm-5, [dir=rtl] .px-sm-5 {
        padding-right: 4rem !important;
      }
    
       .p-sm-25 {
        padding: 0.25rem !important;
      }
    
       .pt-sm-25,  .py-sm-25 {
        padding-top: 0.25rem !important;
      }
    
      [dir=ltr] .pr-sm-25, [dir=ltr] .px-sm-25 {
        padding-right: 0.25rem !important;
      }
    
      [dir=rtl] .pr-sm-25, [dir=rtl] .px-sm-25 {
        padding-left: 0.25rem !important;
      }
    
       .pb-sm-25,  .py-sm-25 {
        padding-bottom: 0.25rem !important;
      }
    
      [dir=ltr] .pl-sm-25, [dir=ltr] .px-sm-25 {
        padding-left: 0.25rem !important;
      }
    
      [dir=rtl] .pl-sm-25, [dir=rtl] .px-sm-25 {
        padding-right: 0.25rem !important;
      }
    
       .p-sm-50 {
        padding: 0.5rem !important;
      }
    
       .pt-sm-50,  .py-sm-50 {
        padding-top: 0.5rem !important;
      }
    
      [dir=ltr] .pr-sm-50, [dir=ltr] .px-sm-50 {
        padding-right: 0.5rem !important;
      }
    
      [dir=rtl] .pr-sm-50, [dir=rtl] .px-sm-50 {
        padding-left: 0.5rem !important;
      }
    
       .pb-sm-50,  .py-sm-50 {
        padding-bottom: 0.5rem !important;
      }
    
      [dir=ltr] .pl-sm-50, [dir=ltr] .px-sm-50 {
        padding-left: 0.5rem !important;
      }
    
      [dir=rtl] .pl-sm-50, [dir=rtl] .px-sm-50 {
        padding-right: 0.5rem !important;
      }
    
       .p-sm-75 {
        padding: 0.75rem !important;
      }
    
       .pt-sm-75,  .py-sm-75 {
        padding-top: 0.75rem !important;
      }
    
      [dir=ltr] .pr-sm-75, [dir=ltr] .px-sm-75 {
        padding-right: 0.75rem !important;
      }
    
      [dir=rtl] .pr-sm-75, [dir=rtl] .px-sm-75 {
        padding-left: 0.75rem !important;
      }
    
       .pb-sm-75,  .py-sm-75 {
        padding-bottom: 0.75rem !important;
      }
    
      [dir=ltr] .pl-sm-75, [dir=ltr] .px-sm-75 {
        padding-left: 0.75rem !important;
      }
    
      [dir=rtl] .pl-sm-75, [dir=rtl] .px-sm-75 {
        padding-right: 0.75rem !important;
      }
    
       .m-sm-n1 {
        margin: -1rem !important;
      }
    
       .mt-sm-n1,  .my-sm-n1 {
        margin-top: -1rem !important;
      }
    
      [dir=ltr] .mr-sm-n1, [dir=ltr] .mx-sm-n1 {
        margin-right: -1rem !important;
      }
    
      [dir=rtl] .mr-sm-n1, [dir=rtl] .mx-sm-n1 {
        margin-left: -1rem !important;
      }
    
       .mb-sm-n1,  .my-sm-n1 {
        margin-bottom: -1rem !important;
      }
    
      [dir=ltr] .ml-sm-n1, [dir=ltr] .mx-sm-n1 {
        margin-left: -1rem !important;
      }
    
      [dir=rtl] .ml-sm-n1, [dir=rtl] .mx-sm-n1 {
        margin-right: -1rem !important;
      }
    
       .m-sm-n2 {
        margin: -1.5rem !important;
      }
    
       .mt-sm-n2,  .my-sm-n2 {
        margin-top: -1.5rem !important;
      }
    
      [dir=ltr] .mr-sm-n2, [dir=ltr] .mx-sm-n2 {
        margin-right: -1.5rem !important;
      }
    
      [dir=rtl] .mr-sm-n2, [dir=rtl] .mx-sm-n2 {
        margin-left: -1.5rem !important;
      }
    
       .mb-sm-n2,  .my-sm-n2 {
        margin-bottom: -1.5rem !important;
      }
    
      [dir=ltr] .ml-sm-n2, [dir=ltr] .mx-sm-n2 {
        margin-left: -1.5rem !important;
      }
    
      [dir=rtl] .ml-sm-n2, [dir=rtl] .mx-sm-n2 {
        margin-right: -1.5rem !important;
      }
    
       .m-sm-n3 {
        margin: -3rem !important;
      }
    
       .mt-sm-n3,  .my-sm-n3 {
        margin-top: -3rem !important;
      }
    
      [dir=ltr] .mr-sm-n3, [dir=ltr] .mx-sm-n3 {
        margin-right: -3rem !important;
      }
    
      [dir=rtl] .mr-sm-n3, [dir=rtl] .mx-sm-n3 {
        margin-left: -3rem !important;
      }
    
       .mb-sm-n3,  .my-sm-n3 {
        margin-bottom: -3rem !important;
      }
    
      [dir=ltr] .ml-sm-n3, [dir=ltr] .mx-sm-n3 {
        margin-left: -3rem !important;
      }
    
      [dir=rtl] .ml-sm-n3, [dir=rtl] .mx-sm-n3 {
        margin-right: -3rem !important;
      }
    
       .m-sm-n4 {
        margin: -3.5rem !important;
      }
    
       .mt-sm-n4,  .my-sm-n4 {
        margin-top: -3.5rem !important;
      }
    
      [dir=ltr] .mr-sm-n4, [dir=ltr] .mx-sm-n4 {
        margin-right: -3.5rem !important;
      }
    
      [dir=rtl] .mr-sm-n4, [dir=rtl] .mx-sm-n4 {
        margin-left: -3.5rem !important;
      }
    
       .mb-sm-n4,  .my-sm-n4 {
        margin-bottom: -3.5rem !important;
      }
    
      [dir=ltr] .ml-sm-n4, [dir=ltr] .mx-sm-n4 {
        margin-left: -3.5rem !important;
      }
    
      [dir=rtl] .ml-sm-n4, [dir=rtl] .mx-sm-n4 {
        margin-right: -3.5rem !important;
      }
    
       .m-sm-n5 {
        margin: -4rem !important;
      }
    
       .mt-sm-n5,  .my-sm-n5 {
        margin-top: -4rem !important;
      }
    
      [dir=ltr] .mr-sm-n5, [dir=ltr] .mx-sm-n5 {
        margin-right: -4rem !important;
      }
    
      [dir=rtl] .mr-sm-n5, [dir=rtl] .mx-sm-n5 {
        margin-left: -4rem !important;
      }
    
       .mb-sm-n5,  .my-sm-n5 {
        margin-bottom: -4rem !important;
      }
    
      [dir=ltr] .ml-sm-n5, [dir=ltr] .mx-sm-n5 {
        margin-left: -4rem !important;
      }
    
      [dir=rtl] .ml-sm-n5, [dir=rtl] .mx-sm-n5 {
        margin-right: -4rem !important;
      }
    
       .m-sm-n25 {
        margin: -0.25rem !important;
      }
    
       .mt-sm-n25,  .my-sm-n25 {
        margin-top: -0.25rem !important;
      }
    
      [dir=ltr] .mr-sm-n25, [dir=ltr] .mx-sm-n25 {
        margin-right: -0.25rem !important;
      }
    
      [dir=rtl] .mr-sm-n25, [dir=rtl] .mx-sm-n25 {
        margin-left: -0.25rem !important;
      }
    
       .mb-sm-n25,  .my-sm-n25 {
        margin-bottom: -0.25rem !important;
      }
    
      [dir=ltr] .ml-sm-n25, [dir=ltr] .mx-sm-n25 {
        margin-left: -0.25rem !important;
      }
    
      [dir=rtl] .ml-sm-n25, [dir=rtl] .mx-sm-n25 {
        margin-right: -0.25rem !important;
      }
    
       .m-sm-n50 {
        margin: -0.5rem !important;
      }
    
       .mt-sm-n50,  .my-sm-n50 {
        margin-top: -0.5rem !important;
      }
    
      [dir=ltr] .mr-sm-n50, [dir=ltr] .mx-sm-n50 {
        margin-right: -0.5rem !important;
      }
    
      [dir=rtl] .mr-sm-n50, [dir=rtl] .mx-sm-n50 {
        margin-left: -0.5rem !important;
      }
    
       .mb-sm-n50,  .my-sm-n50 {
        margin-bottom: -0.5rem !important;
      }
    
      [dir=ltr] .ml-sm-n50, [dir=ltr] .mx-sm-n50 {
        margin-left: -0.5rem !important;
      }
    
      [dir=rtl] .ml-sm-n50, [dir=rtl] .mx-sm-n50 {
        margin-right: -0.5rem !important;
      }
    
       .m-sm-n75 {
        margin: -0.75rem !important;
      }
    
       .mt-sm-n75,  .my-sm-n75 {
        margin-top: -0.75rem !important;
      }
    
      [dir=ltr] .mr-sm-n75, [dir=ltr] .mx-sm-n75 {
        margin-right: -0.75rem !important;
      }
    
      [dir=rtl] .mr-sm-n75, [dir=rtl] .mx-sm-n75 {
        margin-left: -0.75rem !important;
      }
    
       .mb-sm-n75,  .my-sm-n75 {
        margin-bottom: -0.75rem !important;
      }
    
      [dir=ltr] .ml-sm-n75, [dir=ltr] .mx-sm-n75 {
        margin-left: -0.75rem !important;
      }
    
      [dir=rtl] .ml-sm-n75, [dir=rtl] .mx-sm-n75 {
        margin-right: -0.75rem !important;
      }
    
       .m-sm-auto {
        margin: auto !important;
      }
    
       .mt-sm-auto,  .my-sm-auto {
        margin-top: auto !important;
      }
    
      [dir=ltr] .mr-sm-auto, [dir=ltr] .mx-sm-auto {
        margin-right: auto !important;
      }
    
      [dir=rtl] .mr-sm-auto, [dir=rtl] .mx-sm-auto {
        margin-left: auto !important;
      }
    
       .mb-sm-auto,  .my-sm-auto {
        margin-bottom: auto !important;
      }
    
      [dir=ltr] .ml-sm-auto, [dir=ltr] .mx-sm-auto {
        margin-left: auto !important;
      }
    
      [dir=rtl] .ml-sm-auto, [dir=rtl] .mx-sm-auto {
        margin-right: auto !important;
      }
    }
    @media (min-width: 768px) {
       .m-md-0 {
        margin: 0 !important;
      }
    
       .mt-md-0,  .my-md-0 {
        margin-top: 0 !important;
      }
    
      [dir=ltr] .mr-md-0, [dir=ltr] .mx-md-0 {
        margin-right: 0 !important;
      }
    
      [dir=rtl] .mr-md-0, [dir=rtl] .mx-md-0 {
        margin-left: 0 !important;
      }
    
       .mb-md-0,  .my-md-0 {
        margin-bottom: 0 !important;
      }
    
      [dir=ltr] .ml-md-0, [dir=ltr] .mx-md-0 {
        margin-left: 0 !important;
      }
    
      [dir=rtl] .ml-md-0, [dir=rtl] .mx-md-0 {
        margin-right: 0 !important;
      }
    
       .m-md-1 {
        margin: 1rem !important;
      }
    
       .mt-md-1,  .my-md-1 {
        margin-top: 1rem !important;
      }
    
      [dir=ltr] .mr-md-1, [dir=ltr] .mx-md-1 {
        margin-right: 1rem !important;
      }
    
      [dir=rtl] .mr-md-1, [dir=rtl] .mx-md-1 {
        margin-left: 1rem !important;
      }
    
       .mb-md-1,  .my-md-1 {
        margin-bottom: 1rem !important;
      }
    
      [dir=ltr] .ml-md-1, [dir=ltr] .mx-md-1 {
        margin-left: 1rem !important;
      }
    
      [dir=rtl] .ml-md-1, [dir=rtl] .mx-md-1 {
        margin-right: 1rem !important;
      }
    
       .m-md-2 {
        margin: 1.5rem !important;
      }
    
       .mt-md-2,  .my-md-2 {
        margin-top: 1.5rem !important;
      }
    
      [dir=ltr] .mr-md-2, [dir=ltr] .mx-md-2 {
        margin-right: 1.5rem !important;
      }
    
      [dir=rtl] .mr-md-2, [dir=rtl] .mx-md-2 {
        margin-left: 1.5rem !important;
      }
    
       .mb-md-2,  .my-md-2 {
        margin-bottom: 1.5rem !important;
      }
    
      [dir=ltr] .ml-md-2, [dir=ltr] .mx-md-2 {
        margin-left: 1.5rem !important;
      }
    
      [dir=rtl] .ml-md-2, [dir=rtl] .mx-md-2 {
        margin-right: 1.5rem !important;
      }
    
       .m-md-3 {
        margin: 3rem !important;
      }
    
       .mt-md-3,  .my-md-3 {
        margin-top: 3rem !important;
      }
    
      [dir=ltr] .mr-md-3, [dir=ltr] .mx-md-3 {
        margin-right: 3rem !important;
      }
    
      [dir=rtl] .mr-md-3, [dir=rtl] .mx-md-3 {
        margin-left: 3rem !important;
      }
    
       .mb-md-3,  .my-md-3 {
        margin-bottom: 3rem !important;
      }
    
      [dir=ltr] .ml-md-3, [dir=ltr] .mx-md-3 {
        margin-left: 3rem !important;
      }
    
      [dir=rtl] .ml-md-3, [dir=rtl] .mx-md-3 {
        margin-right: 3rem !important;
      }
    
       .m-md-4 {
        margin: 3.5rem !important;
      }
    
       .mt-md-4,  .my-md-4 {
        margin-top: 3.5rem !important;
      }
    
      [dir=ltr] .mr-md-4, [dir=ltr] .mx-md-4 {
        margin-right: 3.5rem !important;
      }
    
      [dir=rtl] .mr-md-4, [dir=rtl] .mx-md-4 {
        margin-left: 3.5rem !important;
      }
    
       .mb-md-4,  .my-md-4 {
        margin-bottom: 3.5rem !important;
      }
    
      [dir=ltr] .ml-md-4, [dir=ltr] .mx-md-4 {
        margin-left: 3.5rem !important;
      }
    
      [dir=rtl] .ml-md-4, [dir=rtl] .mx-md-4 {
        margin-right: 3.5rem !important;
      }
    
       .m-md-5 {
        margin: 4rem !important;
      }
    
       .mt-md-5,  .my-md-5 {
        margin-top: 4rem !important;
      }
    
      [dir=ltr] .mr-md-5, [dir=ltr] .mx-md-5 {
        margin-right: 4rem !important;
      }
    
      [dir=rtl] .mr-md-5, [dir=rtl] .mx-md-5 {
        margin-left: 4rem !important;
      }
    
       .mb-md-5,  .my-md-5 {
        margin-bottom: 4rem !important;
      }
    
      [dir=ltr] .ml-md-5, [dir=ltr] .mx-md-5 {
        margin-left: 4rem !important;
      }
    
      [dir=rtl] .ml-md-5, [dir=rtl] .mx-md-5 {
        margin-right: 4rem !important;
      }
    
       .m-md-25 {
        margin: 0.25rem !important;
      }
    
       .mt-md-25,  .my-md-25 {
        margin-top: 0.25rem !important;
      }
    
      [dir=ltr] .mr-md-25, [dir=ltr] .mx-md-25 {
        margin-right: 0.25rem !important;
      }
    
      [dir=rtl] .mr-md-25, [dir=rtl] .mx-md-25 {
        margin-left: 0.25rem !important;
      }
    
       .mb-md-25,  .my-md-25 {
        margin-bottom: 0.25rem !important;
      }
    
      [dir=ltr] .ml-md-25, [dir=ltr] .mx-md-25 {
        margin-left: 0.25rem !important;
      }
    
      [dir=rtl] .ml-md-25, [dir=rtl] .mx-md-25 {
        margin-right: 0.25rem !important;
      }
    
       .m-md-50 {
        margin: 0.5rem !important;
      }
    
       .mt-md-50,  .my-md-50 {
        margin-top: 0.5rem !important;
      }
    
      [dir=ltr] .mr-md-50, [dir=ltr] .mx-md-50 {
        margin-right: 0.5rem !important;
      }
    
      [dir=rtl] .mr-md-50, [dir=rtl] .mx-md-50 {
        margin-left: 0.5rem !important;
      }
    
       .mb-md-50,  .my-md-50 {
        margin-bottom: 0.5rem !important;
      }
    
      [dir=ltr] .ml-md-50, [dir=ltr] .mx-md-50 {
        margin-left: 0.5rem !important;
      }
    
      [dir=rtl] .ml-md-50, [dir=rtl] .mx-md-50 {
        margin-right: 0.5rem !important;
      }
    
       .m-md-75 {
        margin: 0.75rem !important;
      }
    
       .mt-md-75,  .my-md-75 {
        margin-top: 0.75rem !important;
      }
    
      [dir=ltr] .mr-md-75, [dir=ltr] .mx-md-75 {
        margin-right: 0.75rem !important;
      }
    
      [dir=rtl] .mr-md-75, [dir=rtl] .mx-md-75 {
        margin-left: 0.75rem !important;
      }
    
       .mb-md-75,  .my-md-75 {
        margin-bottom: 0.75rem !important;
      }
    
      [dir=ltr] .ml-md-75, [dir=ltr] .mx-md-75 {
        margin-left: 0.75rem !important;
      }
    
      [dir=rtl] .ml-md-75, [dir=rtl] .mx-md-75 {
        margin-right: 0.75rem !important;
      }
    
       .p-md-0 {
        padding: 0 !important;
      }
    
       .pt-md-0,  .py-md-0 {
        padding-top: 0 !important;
      }
    
      [dir=ltr] .pr-md-0, [dir=ltr] .px-md-0 {
        padding-right: 0 !important;
      }
    
      [dir=rtl] .pr-md-0, [dir=rtl] .px-md-0 {
        padding-left: 0 !important;
      }
    
       .pb-md-0,  .py-md-0 {
        padding-bottom: 0 !important;
      }
    
      [dir=ltr] .pl-md-0, [dir=ltr] .px-md-0 {
        padding-left: 0 !important;
      }
    
      [dir=rtl] .pl-md-0, [dir=rtl] .px-md-0 {
        padding-right: 0 !important;
      }
    
       .p-md-1 {
        padding: 1rem !important;
      }
    
       .pt-md-1,  .py-md-1 {
        padding-top: 1rem !important;
      }
    
      [dir=ltr] .pr-md-1, [dir=ltr] .px-md-1 {
        padding-right: 1rem !important;
      }
    
      [dir=rtl] .pr-md-1, [dir=rtl] .px-md-1 {
        padding-left: 1rem !important;
      }
    
       .pb-md-1,  .py-md-1 {
        padding-bottom: 1rem !important;
      }
    
      [dir=ltr] .pl-md-1, [dir=ltr] .px-md-1 {
        padding-left: 1rem !important;
      }
    
      [dir=rtl] .pl-md-1, [dir=rtl] .px-md-1 {
        padding-right: 1rem !important;
      }
    
       .p-md-2 {
        padding: 1.5rem !important;
      }
    
       .pt-md-2,  .py-md-2 {
        padding-top: 1.5rem !important;
      }
    
      [dir=ltr] .pr-md-2, [dir=ltr] .px-md-2 {
        padding-right: 1.5rem !important;
      }
    
      [dir=rtl] .pr-md-2, [dir=rtl] .px-md-2 {
        padding-left: 1.5rem !important;
      }
    
       .pb-md-2,  .py-md-2 {
        padding-bottom: 1.5rem !important;
      }
    
      [dir=ltr] .pl-md-2, [dir=ltr] .px-md-2 {
        padding-left: 1.5rem !important;
      }
    
      [dir=rtl] .pl-md-2, [dir=rtl] .px-md-2 {
        padding-right: 1.5rem !important;
      }
    
       .p-md-3 {
        padding: 3rem !important;
      }
    
       .pt-md-3,  .py-md-3 {
        padding-top: 3rem !important;
      }
    
      [dir=ltr] .pr-md-3, [dir=ltr] .px-md-3 {
        padding-right: 3rem !important;
      }
    
      [dir=rtl] .pr-md-3, [dir=rtl] .px-md-3 {
        padding-left: 3rem !important;
      }
    
       .pb-md-3,  .py-md-3 {
        padding-bottom: 3rem !important;
      }
    
      [dir=ltr] .pl-md-3, [dir=ltr] .px-md-3 {
        padding-left: 3rem !important;
      }
    
      [dir=rtl] .pl-md-3, [dir=rtl] .px-md-3 {
        padding-right: 3rem !important;
      }
    
       .p-md-4 {
        padding: 3.5rem !important;
      }
    
       .pt-md-4,  .py-md-4 {
        padding-top: 3.5rem !important;
      }
    
      [dir=ltr] .pr-md-4, [dir=ltr] .px-md-4 {
        padding-right: 3.5rem !important;
      }
    
      [dir=rtl] .pr-md-4, [dir=rtl] .px-md-4 {
        padding-left: 3.5rem !important;
      }
    
       .pb-md-4,  .py-md-4 {
        padding-bottom: 3.5rem !important;
      }
    
      [dir=ltr] .pl-md-4, [dir=ltr] .px-md-4 {
        padding-left: 3.5rem !important;
      }
    
      [dir=rtl] .pl-md-4, [dir=rtl] .px-md-4 {
        padding-right: 3.5rem !important;
      }
    
       .p-md-5 {
        padding: 4rem !important;
      }
    
       .pt-md-5,  .py-md-5 {
        padding-top: 4rem !important;
      }
    
      [dir=ltr] .pr-md-5, [dir=ltr] .px-md-5 {
        padding-right: 4rem !important;
      }
    
      [dir=rtl] .pr-md-5, [dir=rtl] .px-md-5 {
        padding-left: 4rem !important;
      }
    
       .pb-md-5,  .py-md-5 {
        padding-bottom: 4rem !important;
      }
    
      [dir=ltr] .pl-md-5, [dir=ltr] .px-md-5 {
        padding-left: 4rem !important;
      }
    
      [dir=rtl] .pl-md-5, [dir=rtl] .px-md-5 {
        padding-right: 4rem !important;
      }
    
       .p-md-25 {
        padding: 0.25rem !important;
      }
    
       .pt-md-25,  .py-md-25 {
        padding-top: 0.25rem !important;
      }
    
      [dir=ltr] .pr-md-25, [dir=ltr] .px-md-25 {
        padding-right: 0.25rem !important;
      }
    
      [dir=rtl] .pr-md-25, [dir=rtl] .px-md-25 {
        padding-left: 0.25rem !important;
      }
    
       .pb-md-25,  .py-md-25 {
        padding-bottom: 0.25rem !important;
      }
    
      [dir=ltr] .pl-md-25, [dir=ltr] .px-md-25 {
        padding-left: 0.25rem !important;
      }
    
      [dir=rtl] .pl-md-25, [dir=rtl] .px-md-25 {
        padding-right: 0.25rem !important;
      }
    
       .p-md-50 {
        padding: 0.5rem !important;
      }
    
       .pt-md-50,  .py-md-50 {
        padding-top: 0.5rem !important;
      }
    
      [dir=ltr] .pr-md-50, [dir=ltr] .px-md-50 {
        padding-right: 0.5rem !important;
      }
    
      [dir=rtl] .pr-md-50, [dir=rtl] .px-md-50 {
        padding-left: 0.5rem !important;
      }
    
       .pb-md-50,  .py-md-50 {
        padding-bottom: 0.5rem !important;
      }
    
      [dir=ltr] .pl-md-50, [dir=ltr] .px-md-50 {
        padding-left: 0.5rem !important;
      }
    
      [dir=rtl] .pl-md-50, [dir=rtl] .px-md-50 {
        padding-right: 0.5rem !important;
      }
    
       .p-md-75 {
        padding: 0.75rem !important;
      }
    
       .pt-md-75,  .py-md-75 {
        padding-top: 0.75rem !important;
      }
    
      [dir=ltr] .pr-md-75, [dir=ltr] .px-md-75 {
        padding-right: 0.75rem !important;
      }
    
      [dir=rtl] .pr-md-75, [dir=rtl] .px-md-75 {
        padding-left: 0.75rem !important;
      }
    
       .pb-md-75,  .py-md-75 {
        padding-bottom: 0.75rem !important;
      }
    
      [dir=ltr] .pl-md-75, [dir=ltr] .px-md-75 {
        padding-left: 0.75rem !important;
      }
    
      [dir=rtl] .pl-md-75, [dir=rtl] .px-md-75 {
        padding-right: 0.75rem !important;
      }
    
       .m-md-n1 {
        margin: -1rem !important;
      }
    
       .mt-md-n1,  .my-md-n1 {
        margin-top: -1rem !important;
      }
    
      [dir=ltr] .mr-md-n1, [dir=ltr] .mx-md-n1 {
        margin-right: -1rem !important;
      }
    
      [dir=rtl] .mr-md-n1, [dir=rtl] .mx-md-n1 {
        margin-left: -1rem !important;
      }
    
       .mb-md-n1,  .my-md-n1 {
        margin-bottom: -1rem !important;
      }
    
      [dir=ltr] .ml-md-n1, [dir=ltr] .mx-md-n1 {
        margin-left: -1rem !important;
      }
    
      [dir=rtl] .ml-md-n1, [dir=rtl] .mx-md-n1 {
        margin-right: -1rem !important;
      }
    
       .m-md-n2 {
        margin: -1.5rem !important;
      }
    
       .mt-md-n2,  .my-md-n2 {
        margin-top: -1.5rem !important;
      }
    
      [dir=ltr] .mr-md-n2, [dir=ltr] .mx-md-n2 {
        margin-right: -1.5rem !important;
      }
    
      [dir=rtl] .mr-md-n2, [dir=rtl] .mx-md-n2 {
        margin-left: -1.5rem !important;
      }
    
       .mb-md-n2,  .my-md-n2 {
        margin-bottom: -1.5rem !important;
      }
    
      [dir=ltr] .ml-md-n2, [dir=ltr] .mx-md-n2 {
        margin-left: -1.5rem !important;
      }
    
      [dir=rtl] .ml-md-n2, [dir=rtl] .mx-md-n2 {
        margin-right: -1.5rem !important;
      }
    
       .m-md-n3 {
        margin: -3rem !important;
      }
    
       .mt-md-n3,  .my-md-n3 {
        margin-top: -3rem !important;
      }
    
      [dir=ltr] .mr-md-n3, [dir=ltr] .mx-md-n3 {
        margin-right: -3rem !important;
      }
    
      [dir=rtl] .mr-md-n3, [dir=rtl] .mx-md-n3 {
        margin-left: -3rem !important;
      }
    
       .mb-md-n3,  .my-md-n3 {
        margin-bottom: -3rem !important;
      }
    
      [dir=ltr] .ml-md-n3, [dir=ltr] .mx-md-n3 {
        margin-left: -3rem !important;
      }
    
      [dir=rtl] .ml-md-n3, [dir=rtl] .mx-md-n3 {
        margin-right: -3rem !important;
      }
    
       .m-md-n4 {
        margin: -3.5rem !important;
      }
    
       .mt-md-n4,  .my-md-n4 {
        margin-top: -3.5rem !important;
      }
    
      [dir=ltr] .mr-md-n4, [dir=ltr] .mx-md-n4 {
        margin-right: -3.5rem !important;
      }
    
      [dir=rtl] .mr-md-n4, [dir=rtl] .mx-md-n4 {
        margin-left: -3.5rem !important;
      }
    
       .mb-md-n4,  .my-md-n4 {
        margin-bottom: -3.5rem !important;
      }
    
      [dir=ltr] .ml-md-n4, [dir=ltr] .mx-md-n4 {
        margin-left: -3.5rem !important;
      }
    
      [dir=rtl] .ml-md-n4, [dir=rtl] .mx-md-n4 {
        margin-right: -3.5rem !important;
      }
    
       .m-md-n5 {
        margin: -4rem !important;
      }
    
       .mt-md-n5,  .my-md-n5 {
        margin-top: -4rem !important;
      }
    
      [dir=ltr] .mr-md-n5, [dir=ltr] .mx-md-n5 {
        margin-right: -4rem !important;
      }
    
      [dir=rtl] .mr-md-n5, [dir=rtl] .mx-md-n5 {
        margin-left: -4rem !important;
      }
    
       .mb-md-n5,  .my-md-n5 {
        margin-bottom: -4rem !important;
      }
    
      [dir=ltr] .ml-md-n5, [dir=ltr] .mx-md-n5 {
        margin-left: -4rem !important;
      }
    
      [dir=rtl] .ml-md-n5, [dir=rtl] .mx-md-n5 {
        margin-right: -4rem !important;
      }
    
       .m-md-n25 {
        margin: -0.25rem !important;
      }
    
       .mt-md-n25,  .my-md-n25 {
        margin-top: -0.25rem !important;
      }
    
      [dir=ltr] .mr-md-n25, [dir=ltr] .mx-md-n25 {
        margin-right: -0.25rem !important;
      }
    
      [dir=rtl] .mr-md-n25, [dir=rtl] .mx-md-n25 {
        margin-left: -0.25rem !important;
      }
    
       .mb-md-n25,  .my-md-n25 {
        margin-bottom: -0.25rem !important;
      }
    
      [dir=ltr] .ml-md-n25, [dir=ltr] .mx-md-n25 {
        margin-left: -0.25rem !important;
      }
    
      [dir=rtl] .ml-md-n25, [dir=rtl] .mx-md-n25 {
        margin-right: -0.25rem !important;
      }
    
       .m-md-n50 {
        margin: -0.5rem !important;
      }
    
       .mt-md-n50,  .my-md-n50 {
        margin-top: -0.5rem !important;
      }
    
      [dir=ltr] .mr-md-n50, [dir=ltr] .mx-md-n50 {
        margin-right: -0.5rem !important;
      }
    
      [dir=rtl] .mr-md-n50, [dir=rtl] .mx-md-n50 {
        margin-left: -0.5rem !important;
      }
    
       .mb-md-n50,  .my-md-n50 {
        margin-bottom: -0.5rem !important;
      }
    
      [dir=ltr] .ml-md-n50, [dir=ltr] .mx-md-n50 {
        margin-left: -0.5rem !important;
      }
    
      [dir=rtl] .ml-md-n50, [dir=rtl] .mx-md-n50 {
        margin-right: -0.5rem !important;
      }
    
       .m-md-n75 {
        margin: -0.75rem !important;
      }
    
       .mt-md-n75,  .my-md-n75 {
        margin-top: -0.75rem !important;
      }
    
      [dir=ltr] .mr-md-n75, [dir=ltr] .mx-md-n75 {
        margin-right: -0.75rem !important;
      }
    
      [dir=rtl] .mr-md-n75, [dir=rtl] .mx-md-n75 {
        margin-left: -0.75rem !important;
      }
    
       .mb-md-n75,  .my-md-n75 {
        margin-bottom: -0.75rem !important;
      }
    
      [dir=ltr] .ml-md-n75, [dir=ltr] .mx-md-n75 {
        margin-left: -0.75rem !important;
      }
    
      [dir=rtl] .ml-md-n75, [dir=rtl] .mx-md-n75 {
        margin-right: -0.75rem !important;
      }
    
       .m-md-auto {
        margin: auto !important;
      }
    
       .mt-md-auto,  .my-md-auto {
        margin-top: auto !important;
      }
    
      [dir=ltr] .mr-md-auto, [dir=ltr] .mx-md-auto {
        margin-right: auto !important;
      }
    
      [dir=rtl] .mr-md-auto, [dir=rtl] .mx-md-auto {
        margin-left: auto !important;
      }
    
       .mb-md-auto,  .my-md-auto {
        margin-bottom: auto !important;
      }
    
      [dir=ltr] .ml-md-auto, [dir=ltr] .mx-md-auto {
        margin-left: auto !important;
      }
    
      [dir=rtl] .ml-md-auto, [dir=rtl] .mx-md-auto {
        margin-right: auto !important;
      }
    }
    @media (min-width: 992px) {
       .m-lg-0 {
        margin: 0 !important;
      }
    
       .mt-lg-0,  .my-lg-0 {
        margin-top: 0 !important;
      }
    
      [dir=ltr] .mr-lg-0, [dir=ltr] .mx-lg-0 {
        margin-right: 0 !important;
      }
    
      [dir=rtl] .mr-lg-0, [dir=rtl] .mx-lg-0 {
        margin-left: 0 !important;
      }
    
       .mb-lg-0,  .my-lg-0 {
        margin-bottom: 0 !important;
      }
    
      [dir=ltr] .ml-lg-0, [dir=ltr] .mx-lg-0 {
        margin-left: 0 !important;
      }
    
      [dir=rtl] .ml-lg-0, [dir=rtl] .mx-lg-0 {
        margin-right: 0 !important;
      }
    
       .m-lg-1 {
        margin: 1rem !important;
      }
    
       .mt-lg-1,  .my-lg-1 {
        margin-top: 1rem !important;
      }
    
      [dir=ltr] .mr-lg-1, [dir=ltr] .mx-lg-1 {
        margin-right: 1rem !important;
      }
    
      [dir=rtl] .mr-lg-1, [dir=rtl] .mx-lg-1 {
        margin-left: 1rem !important;
      }
    
       .mb-lg-1,  .my-lg-1 {
        margin-bottom: 1rem !important;
      }
    
      [dir=ltr] .ml-lg-1, [dir=ltr] .mx-lg-1 {
        margin-left: 1rem !important;
      }
    
      [dir=rtl] .ml-lg-1, [dir=rtl] .mx-lg-1 {
        margin-right: 1rem !important;
      }
    
       .m-lg-2 {
        margin: 1.5rem !important;
      }
    
       .mt-lg-2,  .my-lg-2 {
        margin-top: 1.5rem !important;
      }
    
      [dir=ltr] .mr-lg-2, [dir=ltr] .mx-lg-2 {
        margin-right: 1.5rem !important;
      }
    
      [dir=rtl] .mr-lg-2, [dir=rtl] .mx-lg-2 {
        margin-left: 1.5rem !important;
      }
    
       .mb-lg-2,  .my-lg-2 {
        margin-bottom: 1.5rem !important;
      }
    
      [dir=ltr] .ml-lg-2, [dir=ltr] .mx-lg-2 {
        margin-left: 1.5rem !important;
      }
    
      [dir=rtl] .ml-lg-2, [dir=rtl] .mx-lg-2 {
        margin-right: 1.5rem !important;
      }
    
       .m-lg-3 {
        margin: 3rem !important;
      }
    
       .mt-lg-3,  .my-lg-3 {
        margin-top: 3rem !important;
      }
    
      [dir=ltr] .mr-lg-3, [dir=ltr] .mx-lg-3 {
        margin-right: 3rem !important;
      }
    
      [dir=rtl] .mr-lg-3, [dir=rtl] .mx-lg-3 {
        margin-left: 3rem !important;
      }
    
       .mb-lg-3,  .my-lg-3 {
        margin-bottom: 3rem !important;
      }
    
      [dir=ltr] .ml-lg-3, [dir=ltr] .mx-lg-3 {
        margin-left: 3rem !important;
      }
    
      [dir=rtl] .ml-lg-3, [dir=rtl] .mx-lg-3 {
        margin-right: 3rem !important;
      }
    
       .m-lg-4 {
        margin: 3.5rem !important;
      }
    
       .mt-lg-4,  .my-lg-4 {
        margin-top: 3.5rem !important;
      }
    
      [dir=ltr] .mr-lg-4, [dir=ltr] .mx-lg-4 {
        margin-right: 3.5rem !important;
      }
    
      [dir=rtl] .mr-lg-4, [dir=rtl] .mx-lg-4 {
        margin-left: 3.5rem !important;
      }
    
       .mb-lg-4,  .my-lg-4 {
        margin-bottom: 3.5rem !important;
      }
    
      [dir=ltr] .ml-lg-4, [dir=ltr] .mx-lg-4 {
        margin-left: 3.5rem !important;
      }
    
      [dir=rtl] .ml-lg-4, [dir=rtl] .mx-lg-4 {
        margin-right: 3.5rem !important;
      }
    
       .m-lg-5 {
        margin: 4rem !important;
      }
    
       .mt-lg-5,  .my-lg-5 {
        margin-top: 4rem !important;
      }
    
      [dir=ltr] .mr-lg-5, [dir=ltr] .mx-lg-5 {
        margin-right: 4rem !important;
      }
    
      [dir=rtl] .mr-lg-5, [dir=rtl] .mx-lg-5 {
        margin-left: 4rem !important;
      }
    
       .mb-lg-5,  .my-lg-5 {
        margin-bottom: 4rem !important;
      }
    
      [dir=ltr] .ml-lg-5, [dir=ltr] .mx-lg-5 {
        margin-left: 4rem !important;
      }
    
      [dir=rtl] .ml-lg-5, [dir=rtl] .mx-lg-5 {
        margin-right: 4rem !important;
      }
    
       .m-lg-25 {
        margin: 0.25rem !important;
      }
    
       .mt-lg-25,  .my-lg-25 {
        margin-top: 0.25rem !important;
      }
    
      [dir=ltr] .mr-lg-25, [dir=ltr] .mx-lg-25 {
        margin-right: 0.25rem !important;
      }
    
      [dir=rtl] .mr-lg-25, [dir=rtl] .mx-lg-25 {
        margin-left: 0.25rem !important;
      }
    
       .mb-lg-25,  .my-lg-25 {
        margin-bottom: 0.25rem !important;
      }
    
      [dir=ltr] .ml-lg-25, [dir=ltr] .mx-lg-25 {
        margin-left: 0.25rem !important;
      }
    
      [dir=rtl] .ml-lg-25, [dir=rtl] .mx-lg-25 {
        margin-right: 0.25rem !important;
      }
    
       .m-lg-50 {
        margin: 0.5rem !important;
      }
    
       .mt-lg-50,  .my-lg-50 {
        margin-top: 0.5rem !important;
      }
    
      [dir=ltr] .mr-lg-50, [dir=ltr] .mx-lg-50 {
        margin-right: 0.5rem !important;
      }
    
      [dir=rtl] .mr-lg-50, [dir=rtl] .mx-lg-50 {
        margin-left: 0.5rem !important;
      }
    
       .mb-lg-50,  .my-lg-50 {
        margin-bottom: 0.5rem !important;
      }
    
      [dir=ltr] .ml-lg-50, [dir=ltr] .mx-lg-50 {
        margin-left: 0.5rem !important;
      }
    
      [dir=rtl] .ml-lg-50, [dir=rtl] .mx-lg-50 {
        margin-right: 0.5rem !important;
      }
    
       .m-lg-75 {
        margin: 0.75rem !important;
      }
    
       .mt-lg-75,  .my-lg-75 {
        margin-top: 0.75rem !important;
      }
    
      [dir=ltr] .mr-lg-75, [dir=ltr] .mx-lg-75 {
        margin-right: 0.75rem !important;
      }
    
      [dir=rtl] .mr-lg-75, [dir=rtl] .mx-lg-75 {
        margin-left: 0.75rem !important;
      }
    
       .mb-lg-75,  .my-lg-75 {
        margin-bottom: 0.75rem !important;
      }
    
      [dir=ltr] .ml-lg-75, [dir=ltr] .mx-lg-75 {
        margin-left: 0.75rem !important;
      }
    
      [dir=rtl] .ml-lg-75, [dir=rtl] .mx-lg-75 {
        margin-right: 0.75rem !important;
      }
    
       .p-lg-0 {
        padding: 0 !important;
      }
    
       .pt-lg-0,  .py-lg-0 {
        padding-top: 0 !important;
      }
    
      [dir=ltr] .pr-lg-0, [dir=ltr] .px-lg-0 {
        padding-right: 0 !important;
      }
    
      [dir=rtl] .pr-lg-0, [dir=rtl] .px-lg-0 {
        padding-left: 0 !important;
      }
    
       .pb-lg-0,  .py-lg-0 {
        padding-bottom: 0 !important;
      }
    
      [dir=ltr] .pl-lg-0, [dir=ltr] .px-lg-0 {
        padding-left: 0 !important;
      }
    
      [dir=rtl] .pl-lg-0, [dir=rtl] .px-lg-0 {
        padding-right: 0 !important;
      }
    
       .p-lg-1 {
        padding: 1rem !important;
      }
    
       .pt-lg-1,  .py-lg-1 {
        padding-top: 1rem !important;
      }
    
      [dir=ltr] .pr-lg-1, [dir=ltr] .px-lg-1 {
        padding-right: 1rem !important;
      }
    
      [dir=rtl] .pr-lg-1, [dir=rtl] .px-lg-1 {
        padding-left: 1rem !important;
      }
    
       .pb-lg-1,  .py-lg-1 {
        padding-bottom: 1rem !important;
      }
    
      [dir=ltr] .pl-lg-1, [dir=ltr] .px-lg-1 {
        padding-left: 1rem !important;
      }
    
      [dir=rtl] .pl-lg-1, [dir=rtl] .px-lg-1 {
        padding-right: 1rem !important;
      }
    
       .p-lg-2 {
        padding: 1.5rem !important;
      }
    
       .pt-lg-2,  .py-lg-2 {
        padding-top: 1.5rem !important;
      }
    
      [dir=ltr] .pr-lg-2, [dir=ltr] .px-lg-2 {
        padding-right: 1.5rem !important;
      }
    
      [dir=rtl] .pr-lg-2, [dir=rtl] .px-lg-2 {
        padding-left: 1.5rem !important;
      }
    
       .pb-lg-2,  .py-lg-2 {
        padding-bottom: 1.5rem !important;
      }
    
      [dir=ltr] .pl-lg-2, [dir=ltr] .px-lg-2 {
        padding-left: 1.5rem !important;
      }
    
      [dir=rtl] .pl-lg-2, [dir=rtl] .px-lg-2 {
        padding-right: 1.5rem !important;
      }
    
       .p-lg-3 {
        padding: 3rem !important;
      }
    
       .pt-lg-3,  .py-lg-3 {
        padding-top: 3rem !important;
      }
    
      [dir=ltr] .pr-lg-3, [dir=ltr] .px-lg-3 {
        padding-right: 3rem !important;
      }
    
      [dir=rtl] .pr-lg-3, [dir=rtl] .px-lg-3 {
        padding-left: 3rem !important;
      }
    
       .pb-lg-3,  .py-lg-3 {
        padding-bottom: 3rem !important;
      }
    
      [dir=ltr] .pl-lg-3, [dir=ltr] .px-lg-3 {
        padding-left: 3rem !important;
      }
    
      [dir=rtl] .pl-lg-3, [dir=rtl] .px-lg-3 {
        padding-right: 3rem !important;
      }
    
       .p-lg-4 {
        padding: 3.5rem !important;
      }
    
       .pt-lg-4,  .py-lg-4 {
        padding-top: 3.5rem !important;
      }
    
      [dir=ltr] .pr-lg-4, [dir=ltr] .px-lg-4 {
        padding-right: 3.5rem !important;
      }
    
      [dir=rtl] .pr-lg-4, [dir=rtl] .px-lg-4 {
        padding-left: 3.5rem !important;
      }
    
       .pb-lg-4,  .py-lg-4 {
        padding-bottom: 3.5rem !important;
      }
    
      [dir=ltr] .pl-lg-4, [dir=ltr] .px-lg-4 {
        padding-left: 3.5rem !important;
      }
    
      [dir=rtl] .pl-lg-4, [dir=rtl] .px-lg-4 {
        padding-right: 3.5rem !important;
      }
    
       .p-lg-5 {
        padding: 4rem !important;
      }
    
       .pt-lg-5,  .py-lg-5 {
        padding-top: 4rem !important;
      }
    
      [dir=ltr] .pr-lg-5, [dir=ltr] .px-lg-5 {
        padding-right: 4rem !important;
      }
    
      [dir=rtl] .pr-lg-5, [dir=rtl] .px-lg-5 {
        padding-left: 4rem !important;
      }
    
       .pb-lg-5,  .py-lg-5 {
        padding-bottom: 4rem !important;
      }
    
      [dir=ltr] .pl-lg-5, [dir=ltr] .px-lg-5 {
        padding-left: 4rem !important;
      }
    
      [dir=rtl] .pl-lg-5, [dir=rtl] .px-lg-5 {
        padding-right: 4rem !important;
      }
    
       .p-lg-25 {
        padding: 0.25rem !important;
      }
    
       .pt-lg-25,  .py-lg-25 {
        padding-top: 0.25rem !important;
      }
    
      [dir=ltr] .pr-lg-25, [dir=ltr] .px-lg-25 {
        padding-right: 0.25rem !important;
      }
    
      [dir=rtl] .pr-lg-25, [dir=rtl] .px-lg-25 {
        padding-left: 0.25rem !important;
      }
    
       .pb-lg-25,  .py-lg-25 {
        padding-bottom: 0.25rem !important;
      }
    
      [dir=ltr] .pl-lg-25, [dir=ltr] .px-lg-25 {
        padding-left: 0.25rem !important;
      }
    
      [dir=rtl] .pl-lg-25, [dir=rtl] .px-lg-25 {
        padding-right: 0.25rem !important;
      }
    
       .p-lg-50 {
        padding: 0.5rem !important;
      }
    
       .pt-lg-50,  .py-lg-50 {
        padding-top: 0.5rem !important;
      }
    
      [dir=ltr] .pr-lg-50, [dir=ltr] .px-lg-50 {
        padding-right: 0.5rem !important;
      }
    
      [dir=rtl] .pr-lg-50, [dir=rtl] .px-lg-50 {
        padding-left: 0.5rem !important;
      }
    
       .pb-lg-50,  .py-lg-50 {
        padding-bottom: 0.5rem !important;
      }
    
      [dir=ltr] .pl-lg-50, [dir=ltr] .px-lg-50 {
        padding-left: 0.5rem !important;
      }
    
      [dir=rtl] .pl-lg-50, [dir=rtl] .px-lg-50 {
        padding-right: 0.5rem !important;
      }
    
       .p-lg-75 {
        padding: 0.75rem !important;
      }
    
       .pt-lg-75,  .py-lg-75 {
        padding-top: 0.75rem !important;
      }
    
      [dir=ltr] .pr-lg-75, [dir=ltr] .px-lg-75 {
        padding-right: 0.75rem !important;
      }
    
      [dir=rtl] .pr-lg-75, [dir=rtl] .px-lg-75 {
        padding-left: 0.75rem !important;
      }
    
       .pb-lg-75,  .py-lg-75 {
        padding-bottom: 0.75rem !important;
      }
    
      [dir=ltr] .pl-lg-75, [dir=ltr] .px-lg-75 {
        padding-left: 0.75rem !important;
      }
    
      [dir=rtl] .pl-lg-75, [dir=rtl] .px-lg-75 {
        padding-right: 0.75rem !important;
      }
    
       .m-lg-n1 {
        margin: -1rem !important;
      }
    
       .mt-lg-n1,  .my-lg-n1 {
        margin-top: -1rem !important;
      }
    
      [dir=ltr] .mr-lg-n1, [dir=ltr] .mx-lg-n1 {
        margin-right: -1rem !important;
      }
    
      [dir=rtl] .mr-lg-n1, [dir=rtl] .mx-lg-n1 {
        margin-left: -1rem !important;
      }
    
       .mb-lg-n1,  .my-lg-n1 {
        margin-bottom: -1rem !important;
      }
    
      [dir=ltr] .ml-lg-n1, [dir=ltr] .mx-lg-n1 {
        margin-left: -1rem !important;
      }
    
      [dir=rtl] .ml-lg-n1, [dir=rtl] .mx-lg-n1 {
        margin-right: -1rem !important;
      }
    
       .m-lg-n2 {
        margin: -1.5rem !important;
      }
    
       .mt-lg-n2,  .my-lg-n2 {
        margin-top: -1.5rem !important;
      }
    
      [dir=ltr] .mr-lg-n2, [dir=ltr] .mx-lg-n2 {
        margin-right: -1.5rem !important;
      }
    
      [dir=rtl] .mr-lg-n2, [dir=rtl] .mx-lg-n2 {
        margin-left: -1.5rem !important;
      }
    
       .mb-lg-n2,  .my-lg-n2 {
        margin-bottom: -1.5rem !important;
      }
    
      [dir=ltr] .ml-lg-n2, [dir=ltr] .mx-lg-n2 {
        margin-left: -1.5rem !important;
      }
    
      [dir=rtl] .ml-lg-n2, [dir=rtl] .mx-lg-n2 {
        margin-right: -1.5rem !important;
      }
    
       .m-lg-n3 {
        margin: -3rem !important;
      }
    
       .mt-lg-n3,  .my-lg-n3 {
        margin-top: -3rem !important;
      }
    
      [dir=ltr] .mr-lg-n3, [dir=ltr] .mx-lg-n3 {
        margin-right: -3rem !important;
      }
    
      [dir=rtl] .mr-lg-n3, [dir=rtl] .mx-lg-n3 {
        margin-left: -3rem !important;
      }
    
       .mb-lg-n3,  .my-lg-n3 {
        margin-bottom: -3rem !important;
      }
    
      [dir=ltr] .ml-lg-n3, [dir=ltr] .mx-lg-n3 {
        margin-left: -3rem !important;
      }
    
      [dir=rtl] .ml-lg-n3, [dir=rtl] .mx-lg-n3 {
        margin-right: -3rem !important;
      }
    
       .m-lg-n4 {
        margin: -3.5rem !important;
      }
    
       .mt-lg-n4,  .my-lg-n4 {
        margin-top: -3.5rem !important;
      }
    
      [dir=ltr] .mr-lg-n4, [dir=ltr] .mx-lg-n4 {
        margin-right: -3.5rem !important;
      }
    
      [dir=rtl] .mr-lg-n4, [dir=rtl] .mx-lg-n4 {
        margin-left: -3.5rem !important;
      }
    
       .mb-lg-n4,  .my-lg-n4 {
        margin-bottom: -3.5rem !important;
      }
    
      [dir=ltr] .ml-lg-n4, [dir=ltr] .mx-lg-n4 {
        margin-left: -3.5rem !important;
      }
    
      [dir=rtl] .ml-lg-n4, [dir=rtl] .mx-lg-n4 {
        margin-right: -3.5rem !important;
      }
    
       .m-lg-n5 {
        margin: -4rem !important;
      }
    
       .mt-lg-n5,  .my-lg-n5 {
        margin-top: -4rem !important;
      }
    
      [dir=ltr] .mr-lg-n5, [dir=ltr] .mx-lg-n5 {
        margin-right: -4rem !important;
      }
    
      [dir=rtl] .mr-lg-n5, [dir=rtl] .mx-lg-n5 {
        margin-left: -4rem !important;
      }
    
       .mb-lg-n5,  .my-lg-n5 {
        margin-bottom: -4rem !important;
      }
    
      [dir=ltr] .ml-lg-n5, [dir=ltr] .mx-lg-n5 {
        margin-left: -4rem !important;
      }
    
      [dir=rtl] .ml-lg-n5, [dir=rtl] .mx-lg-n5 {
        margin-right: -4rem !important;
      }
    
       .m-lg-n25 {
        margin: -0.25rem !important;
      }
    
       .mt-lg-n25,  .my-lg-n25 {
        margin-top: -0.25rem !important;
      }
    
      [dir=ltr] .mr-lg-n25, [dir=ltr] .mx-lg-n25 {
        margin-right: -0.25rem !important;
      }
    
      [dir=rtl] .mr-lg-n25, [dir=rtl] .mx-lg-n25 {
        margin-left: -0.25rem !important;
      }
    
       .mb-lg-n25,  .my-lg-n25 {
        margin-bottom: -0.25rem !important;
      }
    
      [dir=ltr] .ml-lg-n25, [dir=ltr] .mx-lg-n25 {
        margin-left: -0.25rem !important;
      }
    
      [dir=rtl] .ml-lg-n25, [dir=rtl] .mx-lg-n25 {
        margin-right: -0.25rem !important;
      }
    
       .m-lg-n50 {
        margin: -0.5rem !important;
      }
    
       .mt-lg-n50,  .my-lg-n50 {
        margin-top: -0.5rem !important;
      }
    
      [dir=ltr] .mr-lg-n50, [dir=ltr] .mx-lg-n50 {
        margin-right: -0.5rem !important;
      }
    
      [dir=rtl] .mr-lg-n50, [dir=rtl] .mx-lg-n50 {
        margin-left: -0.5rem !important;
      }
    
       .mb-lg-n50,  .my-lg-n50 {
        margin-bottom: -0.5rem !important;
      }
    
      [dir=ltr] .ml-lg-n50, [dir=ltr] .mx-lg-n50 {
        margin-left: -0.5rem !important;
      }
    
      [dir=rtl] .ml-lg-n50, [dir=rtl] .mx-lg-n50 {
        margin-right: -0.5rem !important;
      }
    
       .m-lg-n75 {
        margin: -0.75rem !important;
      }
    
       .mt-lg-n75,  .my-lg-n75 {
        margin-top: -0.75rem !important;
      }
    
      [dir=ltr] .mr-lg-n75, [dir=ltr] .mx-lg-n75 {
        margin-right: -0.75rem !important;
      }
    
      [dir=rtl] .mr-lg-n75, [dir=rtl] .mx-lg-n75 {
        margin-left: -0.75rem !important;
      }
    
       .mb-lg-n75,  .my-lg-n75 {
        margin-bottom: -0.75rem !important;
      }
    
      [dir=ltr] .ml-lg-n75, [dir=ltr] .mx-lg-n75 {
        margin-left: -0.75rem !important;
      }
    
      [dir=rtl] .ml-lg-n75, [dir=rtl] .mx-lg-n75 {
        margin-right: -0.75rem !important;
      }
    
       .m-lg-auto {
        margin: auto !important;
      }
    
       .mt-lg-auto,  .my-lg-auto {
        margin-top: auto !important;
      }
    
      [dir=ltr] .mr-lg-auto, [dir=ltr] .mx-lg-auto {
        margin-right: auto !important;
      }
    
      [dir=rtl] .mr-lg-auto, [dir=rtl] .mx-lg-auto {
        margin-left: auto !important;
      }
    
       .mb-lg-auto,  .my-lg-auto {
        margin-bottom: auto !important;
      }
    
      [dir=ltr] .ml-lg-auto, [dir=ltr] .mx-lg-auto {
        margin-left: auto !important;
      }
    
      [dir=rtl] .ml-lg-auto, [dir=rtl] .mx-lg-auto {
        margin-right: auto !important;
      }
    }
    @media (min-width: 1200px) {
       .m-xl-0 {
        margin: 0 !important;
      }
    
       .mt-xl-0,  .my-xl-0 {
        margin-top: 0 !important;
      }
    
      [dir=ltr] .mr-xl-0, [dir=ltr] .mx-xl-0 {
        margin-right: 0 !important;
      }
    
      [dir=rtl] .mr-xl-0, [dir=rtl] .mx-xl-0 {
        margin-left: 0 !important;
      }
    
       .mb-xl-0,  .my-xl-0 {
        margin-bottom: 0 !important;
      }
    
      [dir=ltr] .ml-xl-0, [dir=ltr] .mx-xl-0 {
        margin-left: 0 !important;
      }
    
      [dir=rtl] .ml-xl-0, [dir=rtl] .mx-xl-0 {
        margin-right: 0 !important;
      }
    
       .m-xl-1 {
        margin: 1rem !important;
      }
    
       .mt-xl-1,  .my-xl-1 {
        margin-top: 1rem !important;
      }
    
      [dir=ltr] .mr-xl-1, [dir=ltr] .mx-xl-1 {
        margin-right: 1rem !important;
      }
    
      [dir=rtl] .mr-xl-1, [dir=rtl] .mx-xl-1 {
        margin-left: 1rem !important;
      }
    
       .mb-xl-1,  .my-xl-1 {
        margin-bottom: 1rem !important;
      }
    
      [dir=ltr] .ml-xl-1, [dir=ltr] .mx-xl-1 {
        margin-left: 1rem !important;
      }
    
      [dir=rtl] .ml-xl-1, [dir=rtl] .mx-xl-1 {
        margin-right: 1rem !important;
      }
    
       .m-xl-2 {
        margin: 1.5rem !important;
      }
    
       .mt-xl-2,  .my-xl-2 {
        margin-top: 1.5rem !important;
      }
    
      [dir=ltr] .mr-xl-2, [dir=ltr] .mx-xl-2 {
        margin-right: 1.5rem !important;
      }
    
      [dir=rtl] .mr-xl-2, [dir=rtl] .mx-xl-2 {
        margin-left: 1.5rem !important;
      }
    
       .mb-xl-2,  .my-xl-2 {
        margin-bottom: 1.5rem !important;
      }
    
      [dir=ltr] .ml-xl-2, [dir=ltr] .mx-xl-2 {
        margin-left: 1.5rem !important;
      }
    
      [dir=rtl] .ml-xl-2, [dir=rtl] .mx-xl-2 {
        margin-right: 1.5rem !important;
      }
    
       .m-xl-3 {
        margin: 3rem !important;
      }
    
       .mt-xl-3,  .my-xl-3 {
        margin-top: 3rem !important;
      }
    
      [dir=ltr] .mr-xl-3, [dir=ltr] .mx-xl-3 {
        margin-right: 3rem !important;
      }
    
      [dir=rtl] .mr-xl-3, [dir=rtl] .mx-xl-3 {
        margin-left: 3rem !important;
      }
    
       .mb-xl-3,  .my-xl-3 {
        margin-bottom: 3rem !important;
      }
    
      [dir=ltr] .ml-xl-3, [dir=ltr] .mx-xl-3 {
        margin-left: 3rem !important;
      }
    
      [dir=rtl] .ml-xl-3, [dir=rtl] .mx-xl-3 {
        margin-right: 3rem !important;
      }
    
       .m-xl-4 {
        margin: 3.5rem !important;
      }
    
       .mt-xl-4,  .my-xl-4 {
        margin-top: 3.5rem !important;
      }
    
      [dir=ltr] .mr-xl-4, [dir=ltr] .mx-xl-4 {
        margin-right: 3.5rem !important;
      }
    
      [dir=rtl] .mr-xl-4, [dir=rtl] .mx-xl-4 {
        margin-left: 3.5rem !important;
      }
    
       .mb-xl-4,  .my-xl-4 {
        margin-bottom: 3.5rem !important;
      }
    
      [dir=ltr] .ml-xl-4, [dir=ltr] .mx-xl-4 {
        margin-left: 3.5rem !important;
      }
    
      [dir=rtl] .ml-xl-4, [dir=rtl] .mx-xl-4 {
        margin-right: 3.5rem !important;
      }
    
       .m-xl-5 {
        margin: 4rem !important;
      }
    
       .mt-xl-5,  .my-xl-5 {
        margin-top: 4rem !important;
      }
    
      [dir=ltr] .mr-xl-5, [dir=ltr] .mx-xl-5 {
        margin-right: 4rem !important;
      }
    
      [dir=rtl] .mr-xl-5, [dir=rtl] .mx-xl-5 {
        margin-left: 4rem !important;
      }
    
       .mb-xl-5,  .my-xl-5 {
        margin-bottom: 4rem !important;
      }
    
      [dir=ltr] .ml-xl-5, [dir=ltr] .mx-xl-5 {
        margin-left: 4rem !important;
      }
    
      [dir=rtl] .ml-xl-5, [dir=rtl] .mx-xl-5 {
        margin-right: 4rem !important;
      }
    
       .m-xl-25 {
        margin: 0.25rem !important;
      }
    
       .mt-xl-25,  .my-xl-25 {
        margin-top: 0.25rem !important;
      }
    
      [dir=ltr] .mr-xl-25, [dir=ltr] .mx-xl-25 {
        margin-right: 0.25rem !important;
      }
    
      [dir=rtl] .mr-xl-25, [dir=rtl] .mx-xl-25 {
        margin-left: 0.25rem !important;
      }
    
       .mb-xl-25,  .my-xl-25 {
        margin-bottom: 0.25rem !important;
      }
    
      [dir=ltr] .ml-xl-25, [dir=ltr] .mx-xl-25 {
        margin-left: 0.25rem !important;
      }
    
      [dir=rtl] .ml-xl-25, [dir=rtl] .mx-xl-25 {
        margin-right: 0.25rem !important;
      }
    
       .m-xl-50 {
        margin: 0.5rem !important;
      }
    
       .mt-xl-50,  .my-xl-50 {
        margin-top: 0.5rem !important;
      }
    
      [dir=ltr] .mr-xl-50, [dir=ltr] .mx-xl-50 {
        margin-right: 0.5rem !important;
      }
    
      [dir=rtl] .mr-xl-50, [dir=rtl] .mx-xl-50 {
        margin-left: 0.5rem !important;
      }
    
       .mb-xl-50,  .my-xl-50 {
        margin-bottom: 0.5rem !important;
      }
    
      [dir=ltr] .ml-xl-50, [dir=ltr] .mx-xl-50 {
        margin-left: 0.5rem !important;
      }
    
      [dir=rtl] .ml-xl-50, [dir=rtl] .mx-xl-50 {
        margin-right: 0.5rem !important;
      }
    
       .m-xl-75 {
        margin: 0.75rem !important;
      }
    
       .mt-xl-75,  .my-xl-75 {
        margin-top: 0.75rem !important;
      }
    
      [dir=ltr] .mr-xl-75, [dir=ltr] .mx-xl-75 {
        margin-right: 0.75rem !important;
      }
    
      [dir=rtl] .mr-xl-75, [dir=rtl] .mx-xl-75 {
        margin-left: 0.75rem !important;
      }
    
       .mb-xl-75,  .my-xl-75 {
        margin-bottom: 0.75rem !important;
      }
    
      [dir=ltr] .ml-xl-75, [dir=ltr] .mx-xl-75 {
        margin-left: 0.75rem !important;
      }
    
      [dir=rtl] .ml-xl-75, [dir=rtl] .mx-xl-75 {
        margin-right: 0.75rem !important;
      }
    
       .p-xl-0 {
        padding: 0 !important;
      }
    
       .pt-xl-0,  .py-xl-0 {
        padding-top: 0 !important;
      }
    
      [dir=ltr] .pr-xl-0, [dir=ltr] .px-xl-0 {
        padding-right: 0 !important;
      }
    
      [dir=rtl] .pr-xl-0, [dir=rtl] .px-xl-0 {
        padding-left: 0 !important;
      }
    
       .pb-xl-0,  .py-xl-0 {
        padding-bottom: 0 !important;
      }
    
      [dir=ltr] .pl-xl-0, [dir=ltr] .px-xl-0 {
        padding-left: 0 !important;
      }
    
      [dir=rtl] .pl-xl-0, [dir=rtl] .px-xl-0 {
        padding-right: 0 !important;
      }
    
       .p-xl-1 {
        padding: 1rem !important;
      }
    
       .pt-xl-1,  .py-xl-1 {
        padding-top: 1rem !important;
      }
    
      [dir=ltr] .pr-xl-1, [dir=ltr] .px-xl-1 {
        padding-right: 1rem !important;
      }
    
      [dir=rtl] .pr-xl-1, [dir=rtl] .px-xl-1 {
        padding-left: 1rem !important;
      }
    
       .pb-xl-1,  .py-xl-1 {
        padding-bottom: 1rem !important;
      }
    
      [dir=ltr] .pl-xl-1, [dir=ltr] .px-xl-1 {
        padding-left: 1rem !important;
      }
    
      [dir=rtl] .pl-xl-1, [dir=rtl] .px-xl-1 {
        padding-right: 1rem !important;
      }
    
       .p-xl-2 {
        padding: 1.5rem !important;
      }
    
       .pt-xl-2,  .py-xl-2 {
        padding-top: 1.5rem !important;
      }
    
      [dir=ltr] .pr-xl-2, [dir=ltr] .px-xl-2 {
        padding-right: 1.5rem !important;
      }
    
      [dir=rtl] .pr-xl-2, [dir=rtl] .px-xl-2 {
        padding-left: 1.5rem !important;
      }
    
       .pb-xl-2,  .py-xl-2 {
        padding-bottom: 1.5rem !important;
      }
    
      [dir=ltr] .pl-xl-2, [dir=ltr] .px-xl-2 {
        padding-left: 1.5rem !important;
      }
    
      [dir=rtl] .pl-xl-2, [dir=rtl] .px-xl-2 {
        padding-right: 1.5rem !important;
      }
    
       .p-xl-3 {
        padding: 3rem !important;
      }
    
       .pt-xl-3,  .py-xl-3 {
        padding-top: 3rem !important;
      }
    
      [dir=ltr] .pr-xl-3, [dir=ltr] .px-xl-3 {
        padding-right: 3rem !important;
      }
    
      [dir=rtl] .pr-xl-3, [dir=rtl] .px-xl-3 {
        padding-left: 3rem !important;
      }
    
       .pb-xl-3,  .py-xl-3 {
        padding-bottom: 3rem !important;
      }
    
      [dir=ltr] .pl-xl-3, [dir=ltr] .px-xl-3 {
        padding-left: 3rem !important;
      }
    
      [dir=rtl] .pl-xl-3, [dir=rtl] .px-xl-3 {
        padding-right: 3rem !important;
      }
    
       .p-xl-4 {
        padding: 3.5rem !important;
      }
    
       .pt-xl-4,  .py-xl-4 {
        padding-top: 3.5rem !important;
      }
    
      [dir=ltr] .pr-xl-4, [dir=ltr] .px-xl-4 {
        padding-right: 3.5rem !important;
      }
    
      [dir=rtl] .pr-xl-4, [dir=rtl] .px-xl-4 {
        padding-left: 3.5rem !important;
      }
    
       .pb-xl-4,  .py-xl-4 {
        padding-bottom: 3.5rem !important;
      }
    
      [dir=ltr] .pl-xl-4, [dir=ltr] .px-xl-4 {
        padding-left: 3.5rem !important;
      }
    
      [dir=rtl] .pl-xl-4, [dir=rtl] .px-xl-4 {
        padding-right: 3.5rem !important;
      }
    
       .p-xl-5 {
        padding: 4rem !important;
      }
    
       .pt-xl-5,  .py-xl-5 {
        padding-top: 4rem !important;
      }
    
      [dir=ltr] .pr-xl-5, [dir=ltr] .px-xl-5 {
        padding-right: 4rem !important;
      }
    
      [dir=rtl] .pr-xl-5, [dir=rtl] .px-xl-5 {
        padding-left: 4rem !important;
      }
    
       .pb-xl-5,  .py-xl-5 {
        padding-bottom: 4rem !important;
      }
    
      [dir=ltr] .pl-xl-5, [dir=ltr] .px-xl-5 {
        padding-left: 4rem !important;
      }
    
      [dir=rtl] .pl-xl-5, [dir=rtl] .px-xl-5 {
        padding-right: 4rem !important;
      }
    
       .p-xl-25 {
        padding: 0.25rem !important;
      }
    
       .pt-xl-25,  .py-xl-25 {
        padding-top: 0.25rem !important;
      }
    
      [dir=ltr] .pr-xl-25, [dir=ltr] .px-xl-25 {
        padding-right: 0.25rem !important;
      }
    
      [dir=rtl] .pr-xl-25, [dir=rtl] .px-xl-25 {
        padding-left: 0.25rem !important;
      }
    
       .pb-xl-25,  .py-xl-25 {
        padding-bottom: 0.25rem !important;
      }
    
      [dir=ltr] .pl-xl-25, [dir=ltr] .px-xl-25 {
        padding-left: 0.25rem !important;
      }
    
      [dir=rtl] .pl-xl-25, [dir=rtl] .px-xl-25 {
        padding-right: 0.25rem !important;
      }
    
       .p-xl-50 {
        padding: 0.5rem !important;
      }
    
       .pt-xl-50,  .py-xl-50 {
        padding-top: 0.5rem !important;
      }
    
      [dir=ltr] .pr-xl-50, [dir=ltr] .px-xl-50 {
        padding-right: 0.5rem !important;
      }
    
      [dir=rtl] .pr-xl-50, [dir=rtl] .px-xl-50 {
        padding-left: 0.5rem !important;
      }
    
       .pb-xl-50,  .py-xl-50 {
        padding-bottom: 0.5rem !important;
      }
    
      [dir=ltr] .pl-xl-50, [dir=ltr] .px-xl-50 {
        padding-left: 0.5rem !important;
      }
    
      [dir=rtl] .pl-xl-50, [dir=rtl] .px-xl-50 {
        padding-right: 0.5rem !important;
      }
    
       .p-xl-75 {
        padding: 0.75rem !important;
      }
    
       .pt-xl-75,  .py-xl-75 {
        padding-top: 0.75rem !important;
      }
    
      [dir=ltr] .pr-xl-75, [dir=ltr] .px-xl-75 {
        padding-right: 0.75rem !important;
      }
    
      [dir=rtl] .pr-xl-75, [dir=rtl] .px-xl-75 {
        padding-left: 0.75rem !important;
      }
    
       .pb-xl-75,  .py-xl-75 {
        padding-bottom: 0.75rem !important;
      }
    
      [dir=ltr] .pl-xl-75, [dir=ltr] .px-xl-75 {
        padding-left: 0.75rem !important;
      }
    
      [dir=rtl] .pl-xl-75, [dir=rtl] .px-xl-75 {
        padding-right: 0.75rem !important;
      }
    
       .m-xl-n1 {
        margin: -1rem !important;
      }
    
       .mt-xl-n1,  .my-xl-n1 {
        margin-top: -1rem !important;
      }
    
      [dir=ltr] .mr-xl-n1, [dir=ltr] .mx-xl-n1 {
        margin-right: -1rem !important;
      }
    
      [dir=rtl] .mr-xl-n1, [dir=rtl] .mx-xl-n1 {
        margin-left: -1rem !important;
      }
    
       .mb-xl-n1,  .my-xl-n1 {
        margin-bottom: -1rem !important;
      }
    
      [dir=ltr] .ml-xl-n1, [dir=ltr] .mx-xl-n1 {
        margin-left: -1rem !important;
      }
    
      [dir=rtl] .ml-xl-n1, [dir=rtl] .mx-xl-n1 {
        margin-right: -1rem !important;
      }
    
       .m-xl-n2 {
        margin: -1.5rem !important;
      }
    
       .mt-xl-n2,  .my-xl-n2 {
        margin-top: -1.5rem !important;
      }
    
      [dir=ltr] .mr-xl-n2, [dir=ltr] .mx-xl-n2 {
        margin-right: -1.5rem !important;
      }
    
      [dir=rtl] .mr-xl-n2, [dir=rtl] .mx-xl-n2 {
        margin-left: -1.5rem !important;
      }
    
       .mb-xl-n2,  .my-xl-n2 {
        margin-bottom: -1.5rem !important;
      }
    
      [dir=ltr] .ml-xl-n2, [dir=ltr] .mx-xl-n2 {
        margin-left: -1.5rem !important;
      }
    
      [dir=rtl] .ml-xl-n2, [dir=rtl] .mx-xl-n2 {
        margin-right: -1.5rem !important;
      }
    
       .m-xl-n3 {
        margin: -3rem !important;
      }
    
       .mt-xl-n3,  .my-xl-n3 {
        margin-top: -3rem !important;
      }
    
      [dir=ltr] .mr-xl-n3, [dir=ltr] .mx-xl-n3 {
        margin-right: -3rem !important;
      }
    
      [dir=rtl] .mr-xl-n3, [dir=rtl] .mx-xl-n3 {
        margin-left: -3rem !important;
      }
    
       .mb-xl-n3,  .my-xl-n3 {
        margin-bottom: -3rem !important;
      }
    
      [dir=ltr] .ml-xl-n3, [dir=ltr] .mx-xl-n3 {
        margin-left: -3rem !important;
      }
    
      [dir=rtl] .ml-xl-n3, [dir=rtl] .mx-xl-n3 {
        margin-right: -3rem !important;
      }
    
       .m-xl-n4 {
        margin: -3.5rem !important;
      }
    
       .mt-xl-n4,  .my-xl-n4 {
        margin-top: -3.5rem !important;
      }
    
      [dir=ltr] .mr-xl-n4, [dir=ltr] .mx-xl-n4 {
        margin-right: -3.5rem !important;
      }
    
      [dir=rtl] .mr-xl-n4, [dir=rtl] .mx-xl-n4 {
        margin-left: -3.5rem !important;
      }
    
       .mb-xl-n4,  .my-xl-n4 {
        margin-bottom: -3.5rem !important;
      }
    
      [dir=ltr] .ml-xl-n4, [dir=ltr] .mx-xl-n4 {
        margin-left: -3.5rem !important;
      }
    
      [dir=rtl] .ml-xl-n4, [dir=rtl] .mx-xl-n4 {
        margin-right: -3.5rem !important;
      }
    
       .m-xl-n5 {
        margin: -4rem !important;
      }
    
       .mt-xl-n5,  .my-xl-n5 {
        margin-top: -4rem !important;
      }
    
      [dir=ltr] .mr-xl-n5, [dir=ltr] .mx-xl-n5 {
        margin-right: -4rem !important;
      }
    
      [dir=rtl] .mr-xl-n5, [dir=rtl] .mx-xl-n5 {
        margin-left: -4rem !important;
      }
    
       .mb-xl-n5,  .my-xl-n5 {
        margin-bottom: -4rem !important;
      }
    
      [dir=ltr] .ml-xl-n5, [dir=ltr] .mx-xl-n5 {
        margin-left: -4rem !important;
      }
    
      [dir=rtl] .ml-xl-n5, [dir=rtl] .mx-xl-n5 {
        margin-right: -4rem !important;
      }
    
       .m-xl-n25 {
        margin: -0.25rem !important;
      }
    
       .mt-xl-n25,  .my-xl-n25 {
        margin-top: -0.25rem !important;
      }
    
      [dir=ltr] .mr-xl-n25, [dir=ltr] .mx-xl-n25 {
        margin-right: -0.25rem !important;
      }
    
      [dir=rtl] .mr-xl-n25, [dir=rtl] .mx-xl-n25 {
        margin-left: -0.25rem !important;
      }
    
       .mb-xl-n25,  .my-xl-n25 {
        margin-bottom: -0.25rem !important;
      }
    
      [dir=ltr] .ml-xl-n25, [dir=ltr] .mx-xl-n25 {
        margin-left: -0.25rem !important;
      }
    
      [dir=rtl] .ml-xl-n25, [dir=rtl] .mx-xl-n25 {
        margin-right: -0.25rem !important;
      }
    
       .m-xl-n50 {
        margin: -0.5rem !important;
      }
    
       .mt-xl-n50,  .my-xl-n50 {
        margin-top: -0.5rem !important;
      }
    
      [dir=ltr] .mr-xl-n50, [dir=ltr] .mx-xl-n50 {
        margin-right: -0.5rem !important;
      }
    
      [dir=rtl] .mr-xl-n50, [dir=rtl] .mx-xl-n50 {
        margin-left: -0.5rem !important;
      }
    
       .mb-xl-n50,  .my-xl-n50 {
        margin-bottom: -0.5rem !important;
      }
    
      [dir=ltr] .ml-xl-n50, [dir=ltr] .mx-xl-n50 {
        margin-left: -0.5rem !important;
      }
    
      [dir=rtl] .ml-xl-n50, [dir=rtl] .mx-xl-n50 {
        margin-right: -0.5rem !important;
      }
    
       .m-xl-n75 {
        margin: -0.75rem !important;
      }
    
       .mt-xl-n75,  .my-xl-n75 {
        margin-top: -0.75rem !important;
      }
    
      [dir=ltr] .mr-xl-n75, [dir=ltr] .mx-xl-n75 {
        margin-right: -0.75rem !important;
      }
    
      [dir=rtl] .mr-xl-n75, [dir=rtl] .mx-xl-n75 {
        margin-left: -0.75rem !important;
      }
    
       .mb-xl-n75,  .my-xl-n75 {
        margin-bottom: -0.75rem !important;
      }
    
      [dir=ltr] .ml-xl-n75, [dir=ltr] .mx-xl-n75 {
        margin-left: -0.75rem !important;
      }
    
      [dir=rtl] .ml-xl-n75, [dir=rtl] .mx-xl-n75 {
        margin-right: -0.75rem !important;
      }
    
       .m-xl-auto {
        margin: auto !important;
      }
    
       .mt-xl-auto,  .my-xl-auto {
        margin-top: auto !important;
      }
    
      [dir=ltr] .mr-xl-auto, [dir=ltr] .mx-xl-auto {
        margin-right: auto !important;
      }
    
      [dir=rtl] .mr-xl-auto, [dir=rtl] .mx-xl-auto {
        margin-left: auto !important;
      }
    
       .mb-xl-auto,  .my-xl-auto {
        margin-bottom: auto !important;
      }
    
      [dir=ltr] .ml-xl-auto, [dir=ltr] .mx-xl-auto {
        margin-left: auto !important;
      }
    
      [dir=rtl] .ml-xl-auto, [dir=rtl] .mx-xl-auto {
        margin-right: auto !important;
      }
    }
    .stretched-link::after {
      position: absolute;
      top: 0;
      bottom: 0;
      z-index: 1;
      pointer-events: auto;
      content: "";
    }
     .stretched-link::after {
      background-color: rgba(0, 0, 0, 0);
    }
    [dir=ltr] .stretched-link::after {
      right: 0;
      left: 0;
    }
    [dir=rtl] .stretched-link::after {
      left: 0;
      right: 0;
    }
    
    .text-monospace {
      font-family: "Roboto", Helvetica, Arial, serif !important;
    }
    
     .text-justify {
      text-align: justify !important;
    }
    
    .text-wrap {
      white-space: normal !important;
    }
    
    .text-nowrap {
      white-space: nowrap !important;
    }
    
    .text-truncate {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 300px;
      display: block;
    }
    
    [dir=ltr] .text-left {
      text-align: left !important;
    }
    
    [dir=rtl] .text-left {
      text-align: right !important;
    }
    
    [dir=ltr] .text-right {
      text-align: right !important;
    }
    
    [dir=rtl] .text-right {
      text-align: left !important;
    }
    
     .text-center {
      text-align: center !important;
    }
    
    @media (min-width: 576px) {
      [dir=ltr] .text-sm-left {
        text-align: left !important;
      }
      [dir=rtl] .text-sm-left {
        text-align: right !important;
      }
    
      [dir=ltr] .text-sm-right {
        text-align: right !important;
      }
    
      [dir=rtl] .text-sm-right {
        text-align: left !important;
      }
    
       .text-sm-center {
        text-align: center !important;
      }
    }
    @media (min-width: 768px) {
      [dir=ltr] .text-md-left {
        text-align: left !important;
      }
      [dir=rtl] .text-md-left {
        text-align: right !important;
      }
    
      [dir=ltr] .text-md-right {
        text-align: right !important;
      }
    
      [dir=rtl] .text-md-right {
        text-align: left !important;
      }
    
       .text-md-center {
        text-align: center !important;
      }
    }
    @media (min-width: 992px) {
      [dir=ltr] .text-lg-left {
        text-align: left !important;
      }
      [dir=rtl] .text-lg-left {
        text-align: right !important;
      }
    
      [dir=ltr] .text-lg-right {
        text-align: right !important;
      }
    
      [dir=rtl] .text-lg-right {
        text-align: left !important;
      }
    
       .text-lg-center {
        text-align: center !important;
      }
    }
    @media (min-width: 1200px) {
      [dir=ltr] .text-xl-left {
        text-align: left !important;
      }
      [dir=rtl] .text-xl-left {
        text-align: right !important;
      }
    
      [dir=ltr] .text-xl-right {
        text-align: right !important;
      }
    
      [dir=rtl] .text-xl-right {
        text-align: left !important;
      }
    
       .text-xl-center {
        text-align: center !important;
      }
    }
    .text-lowercase {
      text-transform: lowercase !important;
    }
    
    .text-uppercase {
      text-transform: uppercase !important;
    }
    
    .text-capitalize {
      text-transform: capitalize !important;
    }
    
    .font-weight-light {
      font-weight: 300 !important;
    }
    
    .font-weight-lighter {
      font-weight: lighter !important;
    }
    
    .font-weight-normal {
      font-weight: 400 !important;
    }
    
    .font-weight-bold {
      font-weight: 500 !important;
    }
    
    .font-weight-bolder {
      font-weight: 600 !important;
    }
    
    .font-italic {
      font-style: italic !important;
    }
    
    .text-white {
      color: #fff !important;
    }
    
    .text-primary {
      color: #114A9F !important;
    }
    
    a.text-primary:hover, a.text-primary:focus {
      color: #0a2a5a !important;
    }
    
    .text-secondary {
      color: #9C9EA4 !important;
    }
    
    a.text-secondary:hover, a.text-secondary:focus {
      color: #75777f !important;
    }
    
    .text-success {
      color: #17B75E !important;
    }
    
    a.text-success:hover, a.text-success:focus {
      color: #0e733b !important;
    }
    
    .text-info {
      color: #00CFE8 !important;
    }
    
    a.text-info:hover, a.text-info:focus {
      color: #008b9c !important;
    }
    
    .text-warning {
      color: #FDB913 !important;
    }
    
    a.text-warning:hover, a.text-warning:focus {
      color: #c28a02 !important;
    }
    
    .text-danger {
      color: #EA5455 !important;
    }
    
    a.text-danger:hover, a.text-danger:focus {
      color: #d71a1c !important;
    }
    
    .text-light {
      color: #C1C1C1 !important;
    }
    
    a.text-light:hover, a.text-light:focus {
      color: #9b9b9b !important;
    }
    
    .text-dark {
      color: #4B4B4B !important;
    }
    
    a.text-dark:hover, a.text-dark:focus {
      color: #252525 !important;
    }
    
    .text-body {
      color: #424244 !important;
    }
    
    .text-muted {
      color: #b9b9c3 !important;
    }
    
    .text-black-50 {
      color: rgba(34, 41, 47, 0.5) !important;
    }
    
    .text-white-50 {
      color: rgba(255, 255, 255, 0.5) !important;
    }
    
    .text-hide {
      font: 0/0 a;
      color: transparent;
    }
    
     .text-hide {
      text-shadow: none;
      background-color: transparent;
      border: 0;
    }
    
    .text-decoration-none {
      text-decoration: none !important;
    }
    
    .text-break {
      word-break: break-word !important;
      word-wrap: break-word !important;
    }
    
    .text-reset {
      color: inherit !important;
    }
    
    .visible {
      visibility: visible !important;
    }
    
    .invisible {
      visibility: hidden !important;
    }
    a:focus {
      outline: none;
    }
    
    a:not([href]) {
      color: inherit;
      text-decoration: none;
    }
    a:not([href]):hover {
      color: inherit;
      text-decoration: none;
    }
    
    .list-style-icons {
      list-style: none;
    }
    
    [dir=ltr] .list-style-icons {
      padding-left: 10px;
      margin-left: 0;
    }
    
    [dir=rtl] .list-style-icons {
      padding-right: 10px;
      margin-right: 0;
    }
    [dir=ltr] .list-style-icons > li svg, [dir=ltr] .list-style-icons > li i {
      margin-right: 6px;
    }
    [dir=rtl] .list-style-icons > li svg, [dir=rtl] .list-style-icons > li i {
      margin-left: 6px;
    }
    
    .pull-up {
      transition: all 0.25s ease;
    }
    .pull-up:hover {
      z-index: 30;
    }
     .pull-up:hover {
      transform: translateY(-4px) scale(1.02);
      box-shadow: 0px 14px 24px rgba(62, 57, 107, 0.2);
    }
    
    .spinner {
      display: inline-block;
    }
    
    [dir=ltr] .spinner {
      animation:  spin-ltr 1s linear infinite;
    }
    
    [dir=rtl] .spinner {
      animation:  spin-rtl 1s linear infinite;
    }
    
    @keyframes spin-ltr {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    
    @keyframes spin-rtl {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
    .spinner-reverse {
      display: inline-block;
    }
    [dir=ltr] .spinner-reverse {
      animation:  spin-reverse-ltr 1s linear infinite;
    }
    [dir=rtl] .spinner-reverse {
      animation:  spin-reverse-rtl 1s linear infinite;
    }
    
    @keyframes spin-reverse-ltr {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
    
    @keyframes spin-reverse-rtl {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .bullet {
      width: 1rem;
      height: 1rem;
      display: inline-block;
    }
     .bullet {
      border-radius: 50%;
    }
    .bullet.bullet-xs {
      width: 0.5rem;
      height: 0.5rem;
    }
    .bullet.bullet-sm {
      width: 0.714rem;
      height: 0.714rem;
    }
    .bullet.bullet-lg {
      width: 1.25rem;
      height: 1.25rem;
    }
    
    .section-label {
      font-size: 0.85rem;
      color: #b9b9c3;
      text-transform: uppercase;
      letter-spacing: 0.6px;
    }
    
    .cell-fit {
      width: 0.1%;
      white-space: nowrap;
    }
    
    .match-height > [class*=col] {
      display: flex;
      flex-flow: column;
    }
    .match-height > [class*=col] > .card {
      flex: 1 1 auto;
    }
    
    .text-body-heading {
      color: #424244;
    }
    .text-body-heading:hover {
      color: inherit !important;
    }
    
    .text-body[href]:hover {
      color: #0f3f88 !important;
    }
    
    code {
      font-size: 90%;
      color: #D63384;
    }
    
     code {
      padding: 0.1rem 0.4rem;
      background-color: #eee;
      border-radius: 0.1785rem;
    }
    
     pre {
      background-color: #f7f7f9;
    }
     pre code {
      background-color: transparent !important;
    }
    
    .table-white-space th,
    .table-white-space td {
      white-space: nowrap;
    }
    
    .table thead th,
    .table tfoot th {
      vertical-align: top;
      text-transform: uppercase;
      font-size: 0.857rem;
      letter-spacing: 0.5px;
    }
    .table th,
    .table td {
      vertical-align: middle;
    }
     .table th,  .table td {
      padding: 0.72rem 2rem;
    }
     .table.table-sm th,  .table.table-sm td {
      padding: 0.3rem 0.5rem;
    }
    [dir=ltr] .table.table-sm th:first-child, [dir=ltr] .table.table-sm td:first-child {
      padding-left: 0.75rem;
    }
    [dir=rtl] .table.table-sm th:first-child, [dir=rtl] .table.table-sm td:first-child {
      padding-right: 0.75rem;
    }
    
     .table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th,  .table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {
      background-color: #f3f2f7;
    }
    
     .table-hover tbody tr {
      cursor: pointer;
    }
    
     .table-hover-animation {
      background-color: #f8f8f8;
    }
     .table-hover-animation thead th {
      border-bottom: 0;
    }
     .table-hover-animation th,  .table-hover-animation td {
      border: 0;
    }
    .table-hover-animation tbody tr {
      transition: all 0.25s ease;
    }
     .table-hover-animation tbody tr {
      background-color: #fff;
    }
     .table-hover-animation tbody tr:hover {
      transform: translateY(-4px);
    }
    
     .card .table {
      margin-bottom: 0;
    }
    
    [dir=ltr] .card .table {
      border-bottom-left-radius: 0.357rem;
      border-bottom-right-radius: 0.357rem;
    }
    
    [dir=rtl] .card .table {
      border-bottom-right-radius: 0.357rem;
      border-bottom-left-radius: 0.357rem;
    }
    [dir=ltr] .card .table tbody tr:last-child td:first-child {
      border-bottom-left-radius: 0.357rem;
    }
    [dir=rtl] .card .table tbody tr:last-child td:first-child {
      border-bottom-right-radius: 0.357rem;
    }
    [dir=ltr] .card .table tbody tr:last-child td:last-child {
      border-bottom-right-radius: 0.357rem;
    }
    [dir=rtl] .card .table tbody tr:last-child td:last-child {
      border-bottom-left-radius: 0.357rem;
    }
    
    [dir=ltr] .card table tr[class*=table-]:last-child td:first-child {
      border-bottom-left-radius: 0.357rem;
    }
    
    [dir=rtl] .card table tr[class*=table-]:last-child td:first-child {
      border-bottom-right-radius: 0.357rem;
    }
    [dir=ltr] .card table tr[class*=table-]:last-child td:last-child {
      border-bottom-right-radius: 0.357rem;
    }
    [dir=rtl] .card table tr[class*=table-]:last-child td:last-child {
      border-bottom-left-radius: 0.357rem;
    }
    
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
       .table-hover-animation tr:hover {
        border-bottom-color: #ebe9f1;
      }
    }
    label {
      color: #424244;
      font-size: 1rem;
    }
    
    .form-control::placeholder {
      transition: all 0.2s ease;
    }
    .form-control:focus::placeholder {
      transition: all 0.2s ease;
    }
    [dir=ltr] .form-control:focus::placeholder {
      transform: translate(5px);
    }
    [dir=rtl] .form-control:focus::placeholder {
      transform: translate(-5px);
    }
     .form-control:focus:valid,  .form-control:focus.is-valid {
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
    
    .form-control-plaintext:focus {
      outline: none;
    }
    
    .custom-file-label {
      line-height: 1.75;
      height: 2.6666666667rem !important;
    }
    .custom-file-label:after {
      height: 2.58rem;
      line-height: 1.75;
    }
    
    .valid-tooltip,
    .invalid-tooltip {
      top: 102%;
    }
    
    [dir=ltr] .valid-tooltip, [dir=ltr] .invalid-tooltip {
      left: 5px;
    }
    
    [dir=rtl] .valid-tooltip, [dir=rtl] .invalid-tooltip {
      right: 5px;
    }
    
    /***************
    * Form Group
    ***************/
     .input-group:not(.bootstrap-touchspin):focus-within {
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
      border-radius: 0.357rem;
    }
     .input-group:not(.bootstrap-touchspin):focus-within .form-control,  .input-group:not(.bootstrap-touchspin):focus-within .input-group-text {
      border-color: #114A9F;
      box-shadow: none;
    }
     .input-group:not(.bootstrap-touchspin):focus-within .form-control.is-valid,  .input-group:not(.bootstrap-touchspin):focus-within .input-group-text.is-valid {
      border-color: #17B75E;
    }
     .input-group:not(.bootstrap-touchspin):focus-within .form-control.is-invalid,  .input-group:not(.bootstrap-touchspin):focus-within .input-group-text.is-invalid {
      border-color: #EA5455;
    }
     .input-group.is-valid .input-group-text {
      border-color: #17B75E !important;
    }
     .input-group.is-valid:not(.bootstrap-touchspin):focus-within .input-group-text {
      border-color: #17B75E;
    }
     .input-group.is-invalid .input-group-text {
      border-color: #EA5455 !important;
    }
     .input-group.is-invalid:not(.bootstrap-touchspin):focus-within .input-group-text {
      border-color: #EA5455;
    }
     .input-group.disabled .input-group-text {
      background-color: #efefef;
    }
     .input-group.round .form-control,  .input-group.round .input-group-text,  .input-group.round:focus-within {
      border-radius: 1.5rem;
    }
     .input-group.square .form-control,  .input-group.square .input-group-text,  .input-group.square:focus-within {
      border-radius: 0;
    }
    [dir=ltr] .input-group.round .input-group-prepend .input-group-text, [dir=ltr] .input-group.square .input-group-prepend .input-group-text {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=rtl] .input-group.round .input-group-prepend .input-group-text, [dir=rtl] .input-group.square .input-group-prepend .input-group-text {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=ltr] .input-group.round .input-group-append .input-group-text, [dir=ltr] .input-group.square .input-group-append .input-group-text {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .input-group.round .input-group-append .input-group-text, [dir=rtl] .input-group.square .input-group-append .input-group-text {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=ltr] .input-group.round .form-control:not(:first-child), [dir=ltr] .input-group.square .form-control:not(:first-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .input-group.round .form-control:not(:first-child), [dir=rtl] .input-group.square .form-control:not(:first-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=ltr] .input-group.round .form-control:not(:last-child), [dir=ltr] .input-group.square .form-control:not(:last-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=rtl] .input-group.round .form-control:not(:last-child), [dir=rtl] .input-group.square .form-control:not(:last-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
     .input-group.square .form-control,  .input-group.square .input-group-text {
      border-radius: 0;
    }
    
    .input-group-text {
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
      .input-group-text {
        transition: none;
      }
    }
    
    [dir=ltr] .input-group-prepend .input-group-text {
      border-right: 0;
    }
    
    [dir=rtl] .input-group-prepend .input-group-text {
      border-left: 0;
    }
    
    [dir=ltr] .input-group-append .input-group-text {
      border-left: 0;
    }
    
    [dir=rtl] .input-group-append .input-group-text {
      border-right: 0;
    }
    [dir=ltr] .input-group-append:not(:last-child) .input-group-text {
      border-right: 0;
    }
    [dir=rtl] .input-group-append:not(:last-child) .input-group-text {
      border-left: 0;
    }
    
    [dir=ltr] .input-group-merge .form-control:not(:first-child) {
      padding-left: 0;
      border-left: 0;
    }
    
    [dir=rtl] .input-group-merge .form-control:not(:first-child) {
      padding-right: 0;
      border-right: 0;
    }
    [dir=ltr] .input-group-merge .form-control:not(:last-child) {
      padding-right: 0;
      border-right: 0;
    }
    [dir=rtl] .input-group-merge .form-control:not(:last-child) {
      padding-left: 0;
      border-left: 0;
    }
     .input-group-merge .form-control.is-valid ~ .input-group-append .input-group-text {
      border-color: #17B75E;
    }
     .input-group-text .input-group-merge .input-group-prepend ~ .form-control.is-valid {
      border-color: #17B75E;
    }
    
    textarea.form-control {
      line-height: 1.6rem;
    }
    
     textarea.form-control {
      padding: 0.8rem 1rem !important;
    }
     textarea.form-control-sm {
      padding: 0.4rem 0.857rem !important;
    }
     textarea.form-control-lg {
      padding: 1rem 1.143rem !important;
    }
    
     .form-actions {
      border-top: 1px solid #dfdfdf;
      padding: 20px 0;
      margin-top: 20px;
    }
     .form-actions.filled {
      background-color: #f8f8f8;
    }
     .form-actions.center {
      text-align: center;
    }
    [dir=ltr] .form-actions.right {
      text-align: right;
    }
    [dir=rtl] .form-actions.right {
      text-align: left;
    }
     .form-actions.top {
      border-top: 0;
      border-bottom: 1px solid #dfdfdf;
      margin-top: 0;
      margin-bottom: 20px;
    }
    @media (max-width: 767.98px) {
       .form-actions .buttons-group {
        margin-bottom: 10px;
      }
      [dir=ltr] .form-actions .buttons-group {
        float: left !important;
      }
      [dir=rtl] .form-actions .buttons-group {
        float: right !important;
      }
    }
    
    @media (min-width: 576px) {
      [dir=ltr] .form-horizontal .form-group .label-control {
        text-align: right;
      }
      [dir=rtl] .form-horizontal .form-group .label-control {
        text-align: left;
      }
    }
    
    select.form-control:not([multiple=multiple]) {
      -webkit-appearance: none;
      -moz-appearance: none;
    }
    
    [dir=ltr] select.form-control:not([multiple=multiple]) {
      background-position: calc(100% - 12px) 13px, calc(100% - 20px) 13px, 100% 0;
      padding-right: 1.5rem;
    }
    
    [dir=rtl] select.form-control:not([multiple=multiple]) {
      background-position: calc(100% - (100% - 12px)) 13px, calc(100% - (100% - 20px)) 13px, 0% 0;
      padding-left: 1.5rem;
    }
    [dir=ltr] select.form-control.form-control-lg {
      background-position: calc(100% - 12px) 16px, calc(100% - 20px) 16px, 100% 0;
    }
    [dir=rtl] select.form-control.form-control-lg {
      background-position: calc(100% - (100% - 12px)) 16px, calc(100% - (100% - 20px)) 16px, 0% 0;
    }
    [dir=ltr] select.form-control.form-control-sm {
      background-position: calc(100% - 12px) 8px, calc(100% - 20px) 8px, 100% 0;
    }
    [dir=rtl] select.form-control.form-control-sm {
      background-position: calc(100% - (100% - 12px)) 8px, calc(100% - (100% - 20px)) 8px, 0% 0;
    }
    
    .custom-select {
      -moz-appearance: none;
      -webkit-appearance: none;
    }
    
    .custom-checkbox .custom-control-label::before,
    .custom-checkbox .custom-control-label::after {
      top: 0.07rem;
    }
     .custom-checkbox .custom-control-label::after {
      background-size: 57%;
    }
    
    .custom-radio .custom-control-label::before {
      top: 0.1rem;
    }
    
    [dir=ltr] .custom-checkbox.custom-control, [dir=ltr] .custom-radio.custom-control {
      padding-left: 1.8rem;
    }
    
    [dir=rtl] .custom-checkbox.custom-control, [dir=rtl] .custom-radio.custom-control {
      padding-right: 1.8rem;
    }
    [dir=ltr] .input-group .custom-checkbox.custom-control, [dir=ltr] .input-group .custom-radio.custom-control {
      padding-left: 1.3rem;
    }
    [dir=rtl] .input-group .custom-checkbox.custom-control, [dir=rtl] .input-group .custom-radio.custom-control {
      padding-right: 1.3rem;
    }
    .custom-checkbox .custom-control-input,
    .custom-radio .custom-control-input {
      width: 1.285rem;
      height: 1.285rem;
    }
    .custom-checkbox .custom-control-label,
    .custom-radio .custom-control-label {
      font-size: 1rem;
      position: static;
    }
    .custom-checkbox .custom-control-label::before, .custom-checkbox .custom-control-label::after,
    .custom-radio .custom-control-label::before,
    .custom-radio .custom-control-label::after {
      width: 18px;
      height: 18px;
    }
    [dir=ltr] .custom-checkbox .custom-control-label::before, [dir=ltr] .custom-checkbox .custom-control-label::after, [dir=ltr] .custom-radio .custom-control-label::before, [dir=ltr] .custom-radio .custom-control-label::after {
      left: 0;
    }
    [dir=rtl] .custom-checkbox .custom-control-label::before, [dir=rtl] .custom-checkbox .custom-control-label::after, [dir=rtl] .custom-radio .custom-control-label::before, [dir=rtl] .custom-radio .custom-control-label::after {
      right: 0;
    }
     .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,  .custom-radio .custom-control-input:checked ~ .custom-control-label::before {
      box-shadow: 0 2px 4px 0 rgba(17, 74, 159, 0.4) !important;
    }
     .custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before,  .custom-radio .custom-control-input:disabled ~ .custom-control-label::before {
      border: none;
      box-shadow: none !important;
    }
     .custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,  .custom-radio .custom-control-input:focus ~ .custom-control-label::before {
      border-color: none;
      box-shadow: 0 2px 4px 0 rgba(17, 74, 159, 0.4) !important;
    }
    
     .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
      background-color: #114A9F;
      border-color: #114A9F;
    }
    
    /* Floating label Group */
    .form-label-group {
      position: relative;
    }
     .form-label-group {
      margin-bottom: 0.6666666667rem;
    }
    .form-label-group .form-control-lg ~ label {
      font-size: 1rem;
    }
     .form-label-group .form-control-lg ~ label {
      padding: 1rem;
    }
    .form-label-group > label {
      position: absolute;
      top: 0;
      display: block;
      transition: all 0.25s ease-in-out;
      pointer-events: none;
      color: rgba(34, 41, 47, 0.4);
      font-size: 0.7rem;
      opacity: 0;
    }
     .form-label-group > label {
      padding: 0.6rem;
      cursor: text;
    }
    [dir=ltr] .form-label-group > label {
      left: 0;
    }
    [dir=rtl] .form-label-group > label {
      right: 0;
    }
    .form-label-group > input:focus:not(:placeholder-shown) ~ label, .form-label-group > input:not(:active):not(:placeholder-shown) ~ label,
    .form-label-group textarea:focus:not(:placeholder-shown) ~ label,
    .form-label-group textarea:not(:active):not(:placeholder-shown) ~ label {
      color: #114a9f !important;
      transition: all 0.25s ease-in-out;
      opacity: 1;
    }
    .form-label-group > input:not(:focus):not(:placeholder-shown) ~ label,
    .form-label-group textarea:not(:focus):not(:placeholder-shown) ~ label {
      color: rgba(34, 41, 47, 0.4) !important;
    }
    .form-label-group > input:not(:placeholder-shown) ~ label,
    .form-label-group textarea:not(:placeholder-shown) ~ label {
      top: -20px;
    }
     .form-label-group > input:not(:placeholder-shown) ~ label,  .form-label-group textarea:not(:placeholder-shown) ~ label {
      padding: 0.25rem 0;
    }
    [dir=ltr] .form-label-group > input:not(:placeholder-shown) ~ label, [dir=ltr] .form-label-group textarea:not(:placeholder-shown) ~ label {
      left: 3px;
    }
    [dir=rtl] .form-label-group > input:not(:placeholder-shown) ~ label, [dir=rtl] .form-label-group textarea:not(:placeholder-shown) ~ label {
      right: 3px;
    }
    .form-label-group > input.form-control-lg:not(:placeholder-shown) ~ label,
    .form-label-group textarea.form-control-lg:not(:placeholder-shown) ~ label {
      top: -23px;
    }
    .form-label-group > input.form-control-sm:not(:placeholder-shown) ~ label,
    .form-label-group textarea.form-control-sm:not(:placeholder-shown) ~ label {
      top: -18px;
    }
    
    /* Switches */
    .custom-switch {
      line-height: 1.7rem;
      /*For Switch label*/
      /*For Switch Handle Animation*/
    }
    [dir=ltr] .custom-switch {
      padding-left: 0;
    }
    [dir=rtl] .custom-switch {
      padding-right: 0;
    }
    .custom-switch .custom-control-label {
      line-height: 1.7rem;
      /* For bg color of switch*/
      /*For Switch handle*/
      /*For Switch text*/
    }
    [dir=ltr] .custom-switch .custom-control-label {
      padding-left: 3.5rem;
    }
    [dir=rtl] .custom-switch .custom-control-label {
      padding-right: 3.5rem;
    }
    .custom-switch .custom-control-label::before {
      height: 1.7rem;
      transition: opacity 0.25s ease, background-color 0.1s ease;
      user-select: none;
      top: 0;
    }
     .custom-switch .custom-control-label::before {
      border: none;
      background-color: #e2e2e2;
      box-shadow: none !important;
      cursor: pointer;
    }
    [dir=ltr] .custom-switch .custom-control-label::before {
      left: 0;
    }
    [dir=rtl] .custom-switch .custom-control-label::before {
      right: 0;
    }
    .custom-switch .custom-control-label:after {
      position: absolute;
      top: 4px;
      transition: all 0.15s ease-out;
      user-select: none;
    }
     .custom-switch .custom-control-label:after {
      background-color: #fff;
      cursor: pointer;
    }
    [dir=ltr] .custom-switch .custom-control-label:after {
      left: 4px;
      box-shadow: -1px 2px 3px 0 rgba(34, 41, 47, 0.2);
    }
    [dir=rtl] .custom-switch .custom-control-label:after {
      right: 4px;
      box-shadow: 1px 2px 3px 0 rgba(34, 41, 47, 0.2);
    }
    .custom-switch .custom-control-label .switch-text-left,
    .custom-switch .custom-control-label .switch-text-right,
    .custom-switch .custom-control-label .switch-icon-left,
    .custom-switch .custom-control-label .switch-icon-right {
      position: absolute;
      user-select: none;
      line-height: 1.8;
    }
     .custom-switch .custom-control-label .switch-text-left,  .custom-switch .custom-control-label .switch-text-right,  .custom-switch .custom-control-label .switch-icon-left,  .custom-switch .custom-control-label .switch-icon-right {
      cursor: pointer;
    }
    .custom-switch .custom-control-label .switch-text-left i,
    .custom-switch .custom-control-label .switch-text-left svg,
    .custom-switch .custom-control-label .switch-text-right i,
    .custom-switch .custom-control-label .switch-text-right svg,
    .custom-switch .custom-control-label .switch-icon-left i,
    .custom-switch .custom-control-label .switch-icon-left svg,
    .custom-switch .custom-control-label .switch-icon-right i,
    .custom-switch .custom-control-label .switch-icon-right svg {
      height: 13px;
      width: 13px;
      font-size: 13px;
    }
    .custom-switch .custom-control-label .switch-text-left,
    .custom-switch .custom-control-label .switch-icon-left {
      color: #fff;
      opacity: 0;
      transition: opacity 0.1s ease, transform 0.15s ease;
    }
    [dir=ltr] .custom-switch .custom-control-label .switch-text-left, [dir=ltr] .custom-switch .custom-control-label .switch-icon-left {
      left: 6px;
      transform: translateX(8px);
    }
    [dir=rtl] .custom-switch .custom-control-label .switch-text-left, [dir=rtl] .custom-switch .custom-control-label .switch-icon-left {
      right: 6px;
      transform: translateX(-8px);
    }
    .custom-switch .custom-control-label .switch-text-right,
    .custom-switch .custom-control-label .switch-icon-right {
      opacity: 1;
      transition: opacity 0.08s ease, transform 0.15s ease;
    }
     .custom-switch .custom-control-label .switch-text-right,  .custom-switch .custom-control-label .switch-icon-right {
      transform: translateX(0px);
    }
    [dir=ltr] .custom-switch .custom-control-label .switch-text-right, [dir=ltr] .custom-switch .custom-control-label .switch-icon-right {
      right: 13px;
    }
    [dir=rtl] .custom-switch .custom-control-label .switch-text-right, [dir=rtl] .custom-switch .custom-control-label .switch-icon-right {
      left: 13px;
    }
    .custom-switch .custom-control-label:focus {
      outline: 0;
    }
    [dir=ltr] .custom-switch .switch-label {
      padding-left: 1rem;
    }
    [dir=rtl] .custom-switch .switch-label {
      padding-right: 1rem;
    }
     .custom-switch .custom-control-input:checked ~ .custom-control-label::before {
      box-shadow: none;
    }
    [dir=ltr] .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      transform: translateX(1.4rem);
    }
    [dir=rtl] .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      transform: translateX(-1.4rem);
    }
    .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-left,
    .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-icon-left {
      opacity: 1;
    }
     .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-left,  .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-icon-left {
      transform: translateX(0);
    }
    .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-right,
    .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-icon-right {
      opacity: 0;
    }
    [dir=ltr] .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-right, [dir=ltr] .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-icon-right {
      transform: translateX(-8px);
    }
    [dir=rtl] .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-right, [dir=rtl] .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-icon-right {
      transform: translateX(8px);
    }
    .custom-switch .custom-control-input:not(:checked) ~ .custom-control-label .switch-text-left {
      opacity: 0;
    }
    .custom-switch .custom-control-input:not(:checked) ~ .custom-control-label .switch-text-right {
      opacity: 1;
    }
    .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-right {
      opacity: 0;
    }
    .custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-left {
      opacity: 1;
    }
    
    /* Textarea with Counter */
    .textarea-counter-value {
      color: #fff;
      font-size: 0.6rem;
    }
     .textarea-counter-value {
      background-color: #114A9F;
      padding: 1px 6px;
      border-radius: 0 0 5px 5px;
    }
    [dir=ltr] .textarea-counter-value {
      margin-right: 1rem;
    }
    [dir=rtl] .textarea-counter-value {
      margin-left: 1rem;
    }
    
     .btn.disabled-max-min {
      background-color: rgba(34, 41, 47, 0.5) !important;
      cursor: default;
    }
    
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }
    
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      .form-label-group label {
        display: none;
      }
    
       select.form-control:not([multiple=multiple]) {
        background: none;
      }
    }
     .picker__input.form-control {
      background-color: #fff;
    }
    
    .btn {
      font-weight: 500;
    }
    
     .btn {
      box-shadow: none;
    }
    .btn[class*=bg-gradient-] {
      transition: all 0.2s ease;
    }
     .btn[class*=bg-gradient-]:hover {
      transform: translateY(-2px);
    }
     .btn.btn-icon {
      padding: 0.715rem 0.736rem;
    }
    .btn.btn-sm.btn-icon, .btn-group-sm > .btn.btn-icon {
      line-height: 0.5;
    }
     .btn.btn-sm.btn-icon,  .btn-group-sm > .btn.btn-icon {
      padding: 0.5rem;
    }
    .btn.btn-lg.btn-icon, .btn-group-lg > .btn.btn-icon {
      line-height: 0.75;
    }
     .btn.btn-lg.btn-icon,  .btn-group-lg > .btn.btn-icon {
      padding: 1rem;
    }
    .btn:focus, .btn.focus, .btn:active, .btn.active {
      outline: none;
    }
     .btn:focus,  .btn.focus,  .btn:active,  .btn.active {
      box-shadow: none;
    }
     .btn:not(:disabled):not(.disabled):active:focus,  .btn:not(:disabled):not(.disabled).active:focus {
      box-shadow: none !important;
    }
    .btn .feather {
      vertical-align: bottom;
    }
    
     .btn.waves-input-wrapper {
      padding: 0;
    }
    
    @media (max-width: 767.98px) {
      .btn-sm-block {
        display: block;
        width: 100%;
      }
    }
     .waves-effect {
      cursor: inherit;
    }
    
    [dir=ltr] .dropdown-toggle-split {
      padding-right: 0.7894736842rem;
      padding-left: 0.7894736842rem;
    }
    
    [dir=rtl] .dropdown-toggle-split {
      padding-left: 0.7894736842rem;
      padding-right: 0.7894736842rem;
    }
    
    [dir=ltr] .btn-lg + .dropdown-toggle-split, [dir=ltr] .btn-group-lg > .btn + .dropdown-toggle-split {
      padding-right: 1.1428571429rem;
      padding-left: 1.1428571429rem;
    }
    
    [dir=rtl] .btn-lg + .dropdown-toggle-split, [dir=rtl] .btn-group-lg > .btn + .dropdown-toggle-split {
      padding-left: 1.1428571429rem;
      padding-right: 1.1428571429rem;
    }
    
    [dir=ltr] .btn-sm + .dropdown-toggle-split, [dir=ltr] .btn-group-sm > .btn + .dropdown-toggle-split {
      padding-right: 0.5263157895rem;
      padding-left: 0.5263157895rem;
    }
    
    [dir=rtl] .btn-sm + .dropdown-toggle-split, [dir=rtl] .btn-group-sm > .btn + .dropdown-toggle-split {
      padding-left: 0.5263157895rem;
      padding-right: 0.5263157895rem;
    }
    
    [dir=ltr] .btn-group [class*=btn-]:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]) {
      border-left-color: rgba(34, 41, 47, 0.08) !important;
      border-right-color: rgba(34, 41, 47, 0.08) !important;
    }
    
    [dir=rtl] .btn-group [class*=btn-]:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]) {
      border-right-color: rgba(34, 41, 47, 0.08) !important;
      border-left-color: rgba(34, 41, 47, 0.08) !important;
    }
    
    [dir=ltr] .btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):first-child, [dir=ltr] .btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):first-of-type {
      border-left-color: transparent !important;
    }
    
    [dir=rtl] .btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):first-child, [dir=rtl] .btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):first-of-type {
      border-right-color: transparent !important;
    }
    
    [dir=ltr] .btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):last-child, [dir=ltr] .btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):last-of-type {
      border-right-color: transparent !important;
    }
    
    [dir=rtl] .btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):last-child, [dir=rtl] .btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):last-of-type {
      border-left-color: transparent !important;
    }
    
    [dir=ltr] .btn-group-toggle [class*=btn-outline-]:not(:last-child) {
      border-right-width: 0 !important;
    }
    
    [dir=rtl] .btn-group-toggle [class*=btn-outline-]:not(:last-child) {
      border-left-width: 0 !important;
    }
     .btn-group-toggle :not([class*=btn-outline-]).active,  .btn-group-toggle :not([class*=btn-outline-]):active {
      box-shadow: inset 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    }
    
    [dir=ltr] .dropdown [class*=btn-outline-].dropdown-toggle.dropdown-toggle-split {
      border-left: 0 !important;
    }
    
    [dir=rtl] .dropdown [class*=btn-outline-].dropdown-toggle.dropdown-toggle-split {
      border-right: 0 !important;
    }
    .dropdown.no-arrow .dropdown-toggle:after {
      display: none;
    }
    [dir=ltr] .dropdown.no-arrow .dropdown-toggle i, [dir=ltr] .dropdown.no-arrow .dropdown-toggle svg {
      margin-right: 0;
    }
    [dir=rtl] .dropdown.no-arrow .dropdown-toggle i, [dir=rtl] .dropdown.no-arrow .dropdown-toggle svg {
      margin-left: 0;
    }
    
     .dropdown-menu {
      border-radius: 0.358rem;
      transform: scale(1, 0);
      box-shadow: 0 5px 25px rgba(34, 41, 47, 0.1);
    }
    .dropdown-menu .dropdown-item {
      width: auto;
    }
     .dropdown-menu .dropdown-item {
      cursor: pointer;
    }
    .dropdown-menu .dropdown-header {
      font-weight: 500;
      line-height: 1;
    }
    
    .show > .dropdown-menu {
      opacity: 1;
      display: block;
    }
    
     .show > .dropdown-menu {
      transform: scale(1, 1);
    }
     .show .dropdown-toggle:focus {
      box-shadow: none;
    }
     .show .btn.dropdown-toggle:focus {
      box-shadow: none;
    }
    
    .dropdown-toggle::after {
      content: " ";
      color: #424244;
      width: 14px;
      height: 11px;
      position: relative;
      top: 1px;
      vertical-align: 0;
    }
    
    [dir=ltr] .dropdown-toggle::after {
      right: 0px;
      left: 0.714rem;
    }
    
    [dir=rtl] .dropdown-toggle::after {
      left: 0px;
      right: 0.714rem;
    }
     .dropdown-toggle.btn-lg::after,  .btn-group-lg > .dropdown-toggle.btn::after {
      background-size: 18px;
    }
     .dropdown-toggle.btn-sm::after,  .btn-group-sm > .dropdown-toggle.btn::after {
      background-size: 14px;
    }
    [dir=ltr] .dropdown-toggle.dropdown-toggle-split:after {
      left: 0;
    }
    [dir=rtl] .dropdown-toggle.dropdown-toggle-split:after {
      right: 0;
    }
    .dropdown-toggle.nav-hide-arrow::after {
      display: none;
    }
    .dropdown-toggle:focus {
      outline: 0;
    }
    
    .dropup {
      position: relative;
    }
    .dropup .dropdown-toggle::after {
      width: 14px;
      height: 11px;
      content: "";
      vertical-align: 0.05rem;
    }
     .dropup .dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 16px;
    }
    .dropup .dropdown-menu {
      min-width: 8rem;
    }
    
    .dropleft .dropdown-toggle::before {
      width: 14px;
      height: 11px;
      content: "";
      position: relative;
    }
    
     .dropleft .dropdown-toggle::before {
      border: none !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 16px;
    }
    
    [dir=ltr] .dropleft .dropdown-toggle::before {
      left: 0;
    }
    
    [dir=rtl] .dropleft .dropdown-toggle::before {
      right: 0;
    }
    .dropleft .dropdown-menu {
      min-width: 8rem;
    }
    
    .dropright .dropdown-toggle::after {
      width: 14px;
      height: 11px;
      content: "";
    }
    
     .dropright .dropdown-toggle::after {
      border: none !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 16px;
    }
    .dropright .dropdown-menu {
      min-width: 8rem;
    }
    
     .dropdown-menu[x-placement=bottom-start],  .dropdown-menu[x-placement=bottom-end] {
      margin-top: 0.5rem;
    }
     .dropdown-menu[x-placement=top-start],  .dropdown-menu[x-placement=top-end] {
      margin-bottom: 0.5rem;
    }
    [dir=ltr] .dropdown-menu[x-placement=right-start] {
      margin-left: 0.5rem;
    }
    [dir=rtl] .dropdown-menu[x-placement=right-start] {
      margin-right: 0.5rem;
    }
    [dir=ltr] .dropdown-menu[x-placement=left-start] {
      margin-right: 0.5rem;
    }
    [dir=rtl] .dropdown-menu[x-placement=left-start] {
      margin-left: 0.5rem;
    }
    
    .dropdown.dropdown-icon-wrapper .dropdown-toggle:after,
    .dropup.dropdown-icon-wrapper .dropdown-toggle:after {
      display: none;
    }
    .dropdown.dropdown-icon-wrapper .dropdown-menu,
    .dropup.dropdown-icon-wrapper .dropdown-menu {
      min-width: auto;
    }
     .dropdown.dropdown-icon-wrapper .dropdown-menu .dropdown-item,  .dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item {
      padding: 0.5rem 1.1rem;
      cursor: pointer;
    }
    .dropdown.dropdown-icon-wrapper .dropdown-menu .dropdown-item i,
    .dropdown.dropdown-icon-wrapper .dropdown-menu .dropdown-item svg,
    .dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item i,
    .dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item svg {
      height: 1.3rem;
      width: 1.3rem;
      font-size: 1.3rem;
    }
    
    [dir=ltr] .horizontal-menu-wrapper .dropdown-menu, [dir=ltr] .header-navbar .dropdown-menu {
      animation-duration: 0.3s;
      animation-fill-mode: both;
      animation-name: slideIn;
    }
    
    [dir=rtl] .horizontal-menu-wrapper .dropdown-menu, [dir=rtl] .header-navbar .dropdown-menu {
      animation-duration: 0.3s;
      animation-fill-mode: both;
      animation-name: slideIn;
    }
    
    .dropdown-toggle.hide-arrow::before, .dropdown-toggle.hide-arrow::after,
    .dropdown-toggle-hide-arrow > .dropdown-toggle::before,
    .dropdown-toggle-hide-arrow > .dropdown-toggle::after {
      display: none;
    }
    
    @keyframes slideIn {
      0% {
        transform: translateY(1rem);
        opacity: 0;
      }
      100% {
        transform: translateY(0rem);
        opacity: 1;
      }
      0% {
        transform: translateY(1rem);
        opacity: 0;
      }
    }
    .header-navbar {
      max-height: 4rem;
      font-family: "Roboto", Helvetica, Arial, serif;
      transition: 300ms ease all, background 0s;
      z-index: 997;
    }
     .header-navbar {
      padding: 0px;
    }
    [dir=ltr] .header-navbar.fixed-top {
      left: 0 !important;
    }
    [dir=rtl] .header-navbar.fixed-top {
      right: 0 !important;
    }
    .header-navbar[class*=bg-] .navbar-nav .nav-item > a {
      color: #fff !important;
    }
    .header-navbar[class*=bg-] .navbar-nav .nav-item > a i,
    .header-navbar[class*=bg-] .navbar-nav .nav-item > a svg,
    .header-navbar[class*=bg-] .navbar-nav .nav-item > a span {
      color: #fff !important;
    }
    .header-navbar[class*=bg-] .navbar-nav .nav-item .dropdown-menu i,
    .header-navbar[class*=bg-] .navbar-nav .nav-item .dropdown-menu svg {
      color: inherit !important;
    }
    .header-navbar[class*=bg-] .navbar-nav .search-input .input,
    .header-navbar[class*=bg-] .navbar-nav .search-input .search-list .auto-suggestion span {
      color: #424244 !important;
    }
    .header-navbar[class*=bg-] .navbar-nav .icon-nav-act {
      color: #fff;
    }
     .header-navbar[class*=bg-] .navbar-nav .icon-nav-act {
      cursor: pointer;
    }
     .header-navbar[class*=bg-] .navbar-nav .icon-nav-act .item-icon-nav-act {
      margin: 5px;
    }
    .header-navbar.floating-nav {
      position: fixed;
      width: calc(100vw - (100vw - 100%) - calc(1rem * 2) - 260px);
      z-index: 12;
    }
     .header-navbar.floating-nav {
      margin: 1.3rem 1rem 0;
      border-radius: 0.428rem;
    }
    [dir=ltr] .header-navbar.floating-nav {
      right: 0;
    }
    [dir=rtl] .header-navbar.floating-nav {
      left: 0;
    }
    .header-navbar.navbar-static-top {
      top: 0;
      width: calc(100vw - (100vw - 100%) - 260px);
    }
     .header-navbar.navbar-static-top {
      background: transparent;
      box-shadow: none !important;
    }
    [dir=ltr] .header-navbar.navbar-static-top {
      right: 0;
      left: 260px;
    }
    [dir=rtl] .header-navbar.navbar-static-top {
      left: 0;
      right: 260px;
    }
     .header-navbar.navbar-border {
      border-bottom: 1px solid #ebe9f1;
    }
     .header-navbar.navbar-shadow {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    }
     .header-navbar.navbar-dark.navbar-border {
      border-bottom: 1px solid #3b4253;
    }
    .header-navbar:not(.navbar-horizontal) .nav-link.dropdown-toggle::after {
      display: none;
    }
    .header-navbar .navbar-container {
      flex-basis: 100%;
      transition: 300ms ease all;
    }
     .header-navbar .navbar-container {
      padding: 0.8rem 1rem;
    }
    [dir=ltr] .header-navbar .navbar-container {
      margin-left: 0;
    }
    [dir=rtl] .header-navbar .navbar-container {
      margin-right: 0;
    }
    .header-navbar .navbar-container .bookmark-wrapper .bookmark-input {
      z-index: 1;
    }
    .header-navbar .navbar-container .dropdown-language .selected-language {
      font-weight: 500;
    }
    [dir=ltr] .header-navbar .navbar-container .dropdown-language .nav-link .flag-icon {
      margin-right: 0.4rem;
    }
    [dir=rtl] .header-navbar .navbar-container .dropdown-language .nav-link .flag-icon {
      margin-left: 0.4rem;
    }
    [dir=ltr] .header-navbar .navbar-container .dropdown-language .dropdown-menu .dropdown-item .flag-icon {
      margin-right: 0.4rem;
    }
    [dir=rtl] .header-navbar .navbar-container .dropdown-language .dropdown-menu .dropdown-item .flag-icon {
      margin-left: 0.4rem;
    }
    .header-navbar .navbar-container ul.navbar-nav li {
      line-height: 1.5;
    }
    .vertical-layout .header-navbar .navbar-container ul.navbar-nav li.dropdown .dropdown-menu {
      top: 41px !important;
    }
    [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-language .dropdown-menu.dropdown-menu-right {
      right: -2px;
    }
    [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-language .dropdown-menu.dropdown-menu-right {
      left: -2px;
    }
    [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .badge.badge-up, [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .badge.badge-up {
      right: -3px;
    }
    [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .badge.badge-up, [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .badge.badge-up {
      left: -3px;
    }
     .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .dropdown-menu.dropdown-menu-right,  .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .dropdown-menu.dropdown-menu-right {
      padding: 0;
    }
    [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .dropdown-menu.dropdown-menu-right, [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .dropdown-menu.dropdown-menu-right {
      right: -2px;
      left: inherit;
    }
    [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .dropdown-menu.dropdown-menu-right, [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .dropdown-menu.dropdown-menu-right {
      left: -2px;
      right: inherit;
    }
     .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .dropdown-menu.dropdown-menu-right::before,  .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .dropdown-menu.dropdown-menu-right::before {
      background: #114A9F;
      border-color: #114A9F;
    }
    [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .dropdown-menu-header, [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .dropdown-menu-header {
      border-top-left-radius: 0.358rem;
      border-top-right-radius: 0.358rem;
    }
    [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .dropdown-menu-header, [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .dropdown-menu-header {
      border-top-right-radius: 0.358rem;
      border-top-left-radius: 0.358rem;
    }
     .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .dropdown-menu-header .dropdown-header,  .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .dropdown-menu-header .dropdown-header {
      padding: 1.22rem 1.28rem;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .notification-text, .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .notification-text {
      font-size: smaller;
      color: #b9b9c3;
    }
     .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .notification-text,  .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .notification-text {
      margin-bottom: 0.5rem;
    }
     .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .dropdown-menu-footer,  .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .dropdown-menu-footer {
      padding: 1.28rem;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .media-body .media-heading {
      color: #424244;
      line-height: 1.2;
    }
     .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .media-body .media-heading {
      margin-bottom: 0;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .media {
      position: relative;
    }
     .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .media img {
      background: #f8f8f8;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .media:hover .cart-item-remove {
      visibility: visible;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .media-heading {
      width: 8rem;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .media-heading h6.cart-item-title {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .media-heading .cart-item-by {
      color: #b9b9c3;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .media-body {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .cart-item-price {
      width: 5rem;
    }
     .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .cart-item-price {
      margin-bottom: 0;
    }
    [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .cart-item-price {
      text-align: right;
    }
    [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .cart-item-price {
      text-align: left;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .cart-item-remove {
      position: absolute;
      top: 10px;
      width: 14px;
      height: 14px;
    }
     .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .cart-item-remove {
      cursor: pointer;
    }
    [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .cart-item-remove {
      right: 17px;
    }
    [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .cart-item-remove {
      left: 17px;
    }
    @media (min-width: 768px) {
      .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .cart-item-remove {
        visibility: hidden;
      }
    }
    .header-navbar .navbar-container ul.navbar-nav li > a.nav-link {
      color: #fff;
      position: relative;
    }
     .header-navbar .navbar-container ul.navbar-nav li > a.nav-link {
      padding: 1.25rem 0.5rem;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-user {
      line-height: 1 !important;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-user .dropdown-menu {
      width: 12rem;
    }
     .header-navbar .navbar-container ul.navbar-nav li.dropdown-user .dropdown-menu {
      margin-top: 10px;
    }
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-user .dropdown-menu i,
    .header-navbar .navbar-container ul.navbar-nav li.dropdown-user .dropdown-menu svg {
      height: 16px;
      width: 16px;
      font-size: 16px;
      vertical-align: top;
    }
    .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link {
      display: flex;
      align-items: center;
    }
    .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link .user-name {
      display: inline-block;
    }
     .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link .user-name {
      margin-bottom: 0.435rem;
    }
    [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link .user-name {
      margin-left: 0.2rem;
    }
    [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link .user-name {
      margin-right: 0.2rem;
    }
    .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link .user-status {
      font-size: smaller;
    }
     .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link img {
      box-shadow: 0 4px 8px 0 rgba(34, 41, 47, 0.12), 0 2px 4px 0 rgba(34, 41, 47, 0.08);
    }
    .header-navbar .navbar-container ul.navbar-nav li a.menu-toggle i,
    .header-navbar .navbar-container ul.navbar-nav li a.menu-toggle svg {
      height: 1.6rem;
      width: 1.6rem;
      font-size: 1.6rem;
    }
    .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link .user-nav {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link .user-nav {
      float: left;
      margin-right: 0.8rem;
    }
    [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link .user-nav {
      float: right;
      margin-left: 0.8rem;
    }
     .header-navbar .navbar-container ul.navbar-nav li div.input-group {
      padding: 0.7rem 1rem;
    }
    .header-navbar .navbar-container ul.navbar-nav li i.ficon,
    .header-navbar .navbar-container ul.navbar-nav li svg.ficon {
      height: 1.5rem;
      width: 1.5rem;
      font-size: 1.5rem;
      color: #424244;
    }
    .header-navbar .navbar-container ul.navbar-nav li i.ficon:hover,
    .header-navbar .navbar-container ul.navbar-nav li svg.ficon:hover {
      color: #114A9F;
    }
    .header-navbar .navbar-container ul.navbar-nav li .media-list {
      max-height: 25rem;
    }
    .header-navbar .navbar-container ul.navbar-nav li .scrollable-container {
      position: relative;
    }
    .header-navbar .navbar-container .dropdown-menu-media {
      width: 30rem;
    }
     .header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-header {
      border-bottom: 1px solid #ebe9f1;
    }
     .header-navbar .navbar-container .dropdown-menu-media .media-list .media {
      padding: 0.9rem 1.28rem;
      border: none;
      border-bottom: 1px solid #ebe9f1;
    }
     .header-navbar .navbar-container .dropdown-menu-media .media-list .media:hover {
      background: #f8f8f8;
    }
    .header-navbar .navbar-container .dropdown-menu-media .media-list .media .media-meta {
      color: #424244;
    }
     .header-navbar .navbar-container .dropdown-menu-media .media-list a:last-of-type .media {
      border-bottom: none;
    }
     .header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-footer {
      border-top: 1px solid #ebe9f1;
    }
    .header-navbar .navbar-container .grid-icon {
      color: #fff;
    }
     .header-navbar .navbar-container .grid-icon {
      cursor: pointer;
    }
    [dir=ltr] .header-navbar .navbar-container .grid-icon {
      margin-left: -4px;
    }
    [dir=rtl] .header-navbar .navbar-container .grid-icon {
      margin-right: -4px;
    }
    @media screen and (max-width: 1200px) {
      .header-navbar .navbar-container .grid-icon {
        display: none !important;
      }
    }
    
    .header-navbar-shadow {
      display: none;
    }
    
     .navbar-floating .navbar-container {
      padding: 0.8rem 1rem;
    }
    .navbar-floating .header-navbar-shadow {
      display: block;
      width: 100%;
      height: 102px;
      position: fixed;
      top: 0;
      z-index: 11;
    }
     .navbar-floating .header-navbar-shadow {
      padding-top: 2.2rem;
      background-repeat: repeat;
    }
    [dir=ltr] .navbar-floating .header-navbar-shadow {
      background: linear-gradient(180deg, rgba(248, 248, 248, 0.95) 44%, rgba(248, 248, 248, 0.46) 73%, rgba(255, 255, 255, 0));
      left: 0;
    }
    [dir=rtl] .navbar-floating .header-navbar-shadow {
      background: linear-gradient(-180deg, rgba(248, 248, 248, 0.95) 44%, rgba(248, 248, 248, 0.46) 73%, rgba(255, 255, 255, 0));
      right: 0;
    }
    
     .navbar-light {
      background: #fff;
    }
     .navbar-light.navbar-horizontal {
      background: #fff;
    }
     .navbar-light .navbar-nav .active.nav-link {
      background-color: rgba(34, 41, 47, 0.03);
    }
    .navbar-light .navbar-nav .disabled.nav-link {
      color: #b9b9c3;
    }
    
     .navbar-dark {
      background: #b8c2cc;
    }
    .navbar-dark .navbar-brand {
      color: #fff !important;
    }
     .navbar-dark.navbar-horizontal {
      background: #b8c2cc;
    }
    .navbar-dark .nav-search .form-control,
    .navbar-dark .nav-search .btn-secondary {
      color: #fff;
    }
     .navbar-dark .nav-search .form-control,  .navbar-dark .nav-search .btn-secondary {
      background: #b8c2cc;
    }
    .navbar-dark .navbar-nav li {
      line-height: 1;
    }
     .navbar-dark .navbar-nav .active.nav-link {
      background-color: rgba(255, 255, 255, 0.05);
    }
    .navbar-dark .navbar-nav .disabled.nav-link {
      color: #dae1e7;
    }
    
     .courses-dropdown {
      background-color: #fff;
      padding: 0.435rem;
      border-radius: 5px;
    }
    .courses-dropdown .nav-link {
      color: #5D5F65 !important;
    }
    .courses-dropdown .dropdown-menu {
      top: 43px !important;
    }
    
    .language-dropdown {
      line-height: 14px;
    }
    
     .language-dropdown {
      padding: 0 0.5rem;
    }
    .language-dropdown a::after {
      display: none;
    }
    .language-dropdown .dropdown-menu {
      min-width: auto !important;
      width: auto !important;
      top: 43px !important;
    }
    
    .user-dropdown .user-name {
      color: #fff;
    }
    .user-dropdown a::after {
      display: none;
    }
    .user-dropdown .dropdown-menu {
      min-width: auto !important;
      width: auto !important;
      top: 43px !important;
    }
    
    @media (max-width: 767.98px) {
      .header-navbar .navbar-nav .show {
        position: static;
      }
       .header-navbar .navbar-nav .open-navbar-container {
        padding-top: 0.625rem;
      }
      .header-navbar .navbar-container .show .dropdown-menu {
        width: auto !important;
        overflow: hidden;
      }
       .header-navbar .navbar-container .show .dropdown-menu {
        float: none;
        margin-top: 0;
      }
      [dir=ltr] .header-navbar .navbar-container .show .dropdown-menu {
        right: 0;
        left: 0 !important;
      }
      [dir=rtl] .header-navbar .navbar-container .show .dropdown-menu {
        left: 0;
        right: 0 !important;
      }
      [dir=ltr] .header-navbar .navbar-container .dropdown-user .dropdown-menu-right {
        right: 0 !important;
      }
      [dir=rtl] .header-navbar .navbar-container .dropdown-user .dropdown-menu-right {
        left: 0 !important;
      }
      [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li .dropdown-toggle::after {
        margin-right: 0;
        margin-left: -2px;
      }
      [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li .dropdown-toggle::after {
        margin-left: 0;
        margin-right: -2px;
      }
    
      .navbar-dark .navbar-header .navbar-nav .nav-link {
        color: #fff;
      }
      .navbar-dark .navbar-container .navbar-nav .nav-link {
        color: #b8c2cc;
      }
    
      .navbar-light .navbar-header .navbar-nav .nav-link {
        color: #b8c2cc;
      }
      .navbar-light .navbar-container .navbar-nav .nav-link {
        color: #b8c2cc;
      }
    }
    @media (max-width: 1199.98px) {
      .header-navbar.floating-nav {
        width: calc(100vw - (100vw - 100%) - calc(1rem * 2));
      }
      .header-navbar.navbar-static-top {
        width: 100%;
      }
      [dir=ltr] .header-navbar.navbar-static-top {
        left: 0;
      }
      [dir=rtl] .header-navbar.navbar-static-top {
        right: 0;
      }
    }
    @media (max-width: 991.98px) {
      .header-navbar .navbar-nav {
        flex-flow: row wrap;
      }
       .header-navbar .navbar-nav {
        margin: 0;
      }
      .header-navbar .navbar-nav .dropdown-menu {
        position: absolute;
      }
      [dir=ltr] .header-navbar .navbar-nav .nav-item {
        float: left;
      }
      [dir=rtl] .header-navbar .navbar-nav .nav-item {
        float: right;
      }
    }
    @media (max-width: 767px) {
      .header-navbar .navbar-nav {
        flex-flow: row wrap;
      }
       .header-navbar .navbar-nav {
        margin: 0;
      }
      .header-navbar .navbar-nav .dropdown-menu {
        position: absolute;
      }
      [dir=ltr] .header-navbar .navbar-nav .nav-item {
        float: left;
      }
      [dir=rtl] .header-navbar .navbar-nav .nav-item {
        float: right;
      }
    }
    @media (max-width: 575.98px) {
      .header-navbar.floating-nav {
        width: calc( 100vw - (100vw - 100%) - calc(1rem + 0.4rem) ) !important;
      }
      [dir=ltr] .header-navbar.floating-nav {
        margin-left: 1rem;
        margin-right: 1.2rem;
      }
      [dir=rtl] .header-navbar.floating-nav {
        margin-right: 1rem;
        margin-left: 1.2rem;
      }
      .header-navbar .navbar-container ul.navbar-nav li .selected-language {
        display: none;
      }
    }
    /* ----------- iPhone 5, 5S  iPhone 6----------- */
    /* Landscape */
    @media only screen and (min-device-width: 26.78em) and (max-device-width: 47.64em) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
      .header-navbar .navbar-container .show .dropdown-menu {
        max-height: 180px;
      }
    }
    /* ----------- iPhone 6+ ----------- */
    /* Landscape */
    @media only screen and (min-device-width: 29.57em) and (max-device-width: 52.57em) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
      .header-navbar .navbar-container .show .dropdown-menu {
        max-height: 280px;
      }
    }
    @media (max-width: 1201px) {
      [dir=ltr] .header-navbar.fixed-top {
        left: 0;
      }
      [dir=rtl] .header-navbar.fixed-top {
        right: 0;
      }
    
      [dir=ltr] .horizontal-layout .header-navbar .navbar-container {
        padding-left: 0.8rem;
        padding-right: 0.8rem;
      }
    
      [dir=rtl] .horizontal-layout .header-navbar .navbar-container {
        padding-right: 0.8rem;
        padding-left: 0.8rem;
      }
    }
    @media (max-width: 1199px) {
       .header-navbar .navbar-container ul.navbar-nav li a.dropdown-user-link .user-name {
        margin-bottom: 0;
      }
    }
    .card {
      transition: all 0.3s ease-in-out, background 0s, color 0s, border-color 0s;
    }
     .card {
      border: none;
      margin-bottom: 1rem;
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    }
     .card .card {
      box-shadow: none !important;
    }
     .card .card-title {
      margin-bottom: 0.5rem;
    }
     .card .card-bordered {
      border: 1px solid rgba(34, 41, 47, 0.125);
    }
    .card .card-img {
      object-fit: cover;
    }
     .card .card-img-overlay {
      border-radius: 0.428rem;
    }
    .card.card-fullscreen {
      display: block;
      z-index: 9999;
      position: fixed;
      width: 100% !important;
      height: 100% !important;
      top: 0;
      bottom: 0;
      overflow: auto;
    }
    [dir=ltr] .card.card-fullscreen {
      right: 0;
      left: 0;
    }
    [dir=rtl] .card.card-fullscreen {
      left: 0;
      right: 0;
    }
     .card .card-body[class*=border-bottom-] {
      border-bottom-width: 2px !important;
    }
     .card .card-img-overlay.bg-overlay {
      background: rgba(34, 41, 47, 0.45);
    }
    .card .card-img-overlay .text-muted {
      color: #1e1e1e !important;
    }
     .card.card-minimal {
      border: none;
      box-shadow: none;
    }
    .card .card-header {
      position: relative;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
    }
     .card .card-header {
      border-bottom: none;
      padding: 1.5rem;
      background-color: transparent;
    }
     .card .card-header .card-title {
      margin-bottom: 0;
    }
    .card .card-header .heading-elements {
      position: relative;
      top: -1px;
    }
    [dir=ltr] .card .card-header .heading-elements li:not(:first-child) a {
      margin-left: 0.75rem;
    }
    [dir=rtl] .card .card-header .heading-elements li:not(:first-child) a {
      margin-right: 0.75rem;
    }
     .card .card-header .heading-elements a.btn {
      padding-top: 6px;
      padding-bottom: 6px;
    }
    .card .card-header .heading-elements a i,
    .card .card-header .heading-elements a svg {
      height: 1rem;
      width: 1rem;
      font-size: 1rem;
    }
    .card .card-header .heading-elements a[data-action=collapse] i,
    .card .card-header .heading-elements a[data-action=collapse] svg {
      transition: all 0.25s ease-out;
      display: inline-block;
    }
    [dir=ltr] .card .card-header .heading-elements a[data-action=collapse].rotate i, [dir=ltr] .card .card-header .heading-elements a[data-action=collapse].rotate svg {
      transform: rotate(-180deg);
    }
    [dir=rtl] .card .card-header .heading-elements a[data-action=collapse].rotate i, [dir=rtl] .card .card-header .heading-elements a[data-action=collapse].rotate svg {
      transform: rotate(180deg);
    }
     .card .card-header + .card-content > .card-body:first-of-type,  .card .card-header + .card-body {
      padding-top: 0px;
    }
     .card .card-footer {
      border-top: 1px solid #dae1e7;
      background-color: transparent;
    }
    
     .card-columns .card {
      margin-bottom: 2.2rem;
    }
    
     .card-group,  .card-deck {
      margin-bottom: 0.75rem;
    }
    
    .card-head-inverse {
      color: #fff;
    }
    .card-head-inverse .heading-elements i,
    .card-head-inverse .heading-elements svg {
      color: #fff;
    }
    
     .card-transparent {
      background-color: transparent;
    }
    
    .text-white .card-img-overlay .text-muted {
      color: #fff !important;
    }
     .text-white code {
      background-color: white;
    }
    .text-white .heading-elements i,
    .text-white .heading-elements svg {
      color: #fff;
    }
    
    .overlay-img-card .card-img-overlay,
    .overlay-img-card img {
      max-height: 34.64rem;
    }
    
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      .card-body,
    .card-content {
        min-height: 1px;
      }
    }
    .card-congratulations {
      color: #fff;
    }
    [dir=ltr] .card-congratulations {
      background: linear-gradient(118deg, #114a9f, rgba(17, 74, 159, 0.7));
    }
    [dir=rtl] .card-congratulations {
      background: linear-gradient(-118deg, #114a9f, rgba(17, 74, 159, 0.7));
    }
    .card-congratulations .congratulations-img-left {
      width: 200px;
      position: absolute;
      top: 0;
    }
    [dir=ltr] .card-congratulations .congratulations-img-left {
      left: 0;
    }
    [dir=rtl] .card-congratulations .congratulations-img-left {
      right: 0;
    }
    @media (max-width: 575.98px) {
      .card-congratulations .congratulations-img-left {
        width: 140px;
      }
    }
    .card-congratulations .congratulations-img-right {
      width: 175px;
      position: absolute;
      top: 0;
    }
    [dir=ltr] .card-congratulations .congratulations-img-right {
      right: 0;
    }
    [dir=rtl] .card-congratulations .congratulations-img-right {
      left: 0;
    }
    @media (max-width: 575.98px) {
      .card-congratulations .congratulations-img-right {
        width: 140px;
      }
    }
     .card-congratulations .avatar {
      margin-bottom: 2rem;
    }
    
    .congratulation-medal {
      position: absolute;
      top: 0;
    }
    
    [dir=ltr] .congratulation-medal {
      right: 37px;
    }
    
    [dir=rtl] .congratulation-medal {
      left: 37px;
    }
    
     .card-deposits .deposits-divider {
      margin-top: 1.8rem;
      margin-bottom: 1.4rem;
    }
    
     .card-employee-task .employee-task:not(:last-child) {
      margin-bottom: 1.5rem;
    }
    
     .card-developer-meetup .meetup-img-wrapper {
      background-color: rgba(17, 74, 159, 0.1);
    }
     .card-developer-meetup .meetup-header {
      margin-bottom: 2rem;
    }
     .card-developer-meetup .meetup-header .meetup-day {
      text-align: center;
    }
    [dir=ltr] .card-developer-meetup .meetup-header .meetup-day {
      border-right: 1px solid #d8d6de;
      padding-right: 1.3rem;
      margin-right: 1.3rem;
    }
    [dir=rtl] .card-developer-meetup .meetup-header .meetup-day {
      border-left: 1px solid #d8d6de;
      padding-left: 1.3rem;
      margin-left: 1.3rem;
    }
    .card-developer-meetup .media .avatar .avatar-content {
      width: 34px;
      height: 34px;
    }
     .card-developer-meetup .media + .media {
      margin-top: 1.2rem;
    }
     .card-developer-meetup .avatar-group {
      margin-top: 2rem;
    }
    
     .card-profile {
      text-align: center;
    }
    .card-profile .card-body {
      position: relative;
    }
     .card-profile .card-body {
      padding: 5rem 2.3rem 1.5rem 2.3rem;
    }
    .card-profile .card-body .profile-image-wrapper {
      display: flex;
      justify-content: center;
    }
    .card-profile .card-body .profile-image-wrapper .profile-image {
      position: absolute;
      top: -4rem;
    }
     .card-profile .card-body .profile-image-wrapper .profile-image {
      padding: 0.5rem;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: 0 0 8px 0 rgba(34, 41, 47, 0.14);
      margin-bottom: 1.15rem;
    }
    .card-profile .card-body .profile-image-wrapper .profile-image img {
      width: 100px;
      height: 100px;
    }
     .card-profile .card-body .profile-badge {
      margin-top: 0.8rem;
      margin-bottom: 0.8rem;
    }
    
    .card-apply-job .apply-job-package {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    
     .card-apply-job .apply-job-package {
      padding: 1.2rem;
      margin-bottom: 1.15rem;
    }
    .card-apply-job .apply-job-package sup {
      top: -0.8rem;
    }
    
    .card-transaction .transaction-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
     .card-transaction .transaction-item:not(:last-child) {
      margin-bottom: 1.2rem;
    }
    [dir=ltr] .card-transaction .transaction-item .avatar {
      margin-right: 1.2rem;
    }
    [dir=rtl] .card-transaction .transaction-item .avatar {
      margin-left: 1.2rem;
    }
    .card-transaction .transaction-item .avatar .avatar-content {
      width: 42px;
      height: 42px;
    }
     .card-transaction .transaction-item .transaction-title {
      margin-bottom: 0.2rem;
      margin-top: 0.2rem;
    }
    
    .card-user-timeline .user-timeline-title-icon {
      width: 1.714rem;
      height: 1.714rem;
    }
    
    [dir=ltr] .card-user-timeline .user-timeline-title-icon {
      margin-right: 1.3rem;
    }
    
    [dir=rtl] .card-user-timeline .user-timeline-title-icon {
      margin-left: 1.3rem;
    }
    .card-user-timeline .timeline .timeline-item:last-child .timeline-event {
      min-height: auto;
    }
     .card-user-timeline .timeline .timeline-item:not(:last-child) {
      padding-bottom: 2.3rem;
    }
    
     .business-card .business-items:not(:last-child) {
      margin-bottom: 1.3rem;
    }
     .business-card .business-items .business-item {
      border: 1px solid #ebe9f1;
      border-radius: 0.357rem;
    }
    [dir=ltr] .business-card .business-items .business-item {
      padding: 1rem 1rem 1rem 1.3rem;
    }
    [dir=rtl] .business-card .business-items .business-item {
      padding: 1rem 1.3rem 1rem 1rem;
    }
     .business-card .business-items .business-item:not(:last-child) {
      margin-bottom: 0.85rem;
    }
    
    .card-browser-states .browser-states {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    
     .card-browser-states .browser-states {
      margin-top: 2.14rem;
    }
    
     .card-app-design .design-group {
      margin-bottom: 2rem;
    }
    [dir=ltr] .card-app-design .design-group .avatar:not(:last-child) {
      margin-right: 0.6rem;
    }
    [dir=rtl] .card-app-design .design-group .avatar:not(:last-child) {
      margin-left: 0.6rem;
    }
    .card-app-design .design-planning-wrapper {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
     .card-app-design .design-planning-wrapper:not(:last-child) {
      margin-bottom: 1.3rem;
    }
    .card-app-design .design-planning-wrapper .design-planning {
      min-width: 6.4rem;
    }
     .card-app-design .design-planning-wrapper .design-planning {
      padding: 0.5rem;
      margin-bottom: 0.7rem;
      text-align: center;
      background-color: #f8f8f8;
      border-radius: 0.357rem;
    }
    [dir=ltr] .card-app-design .design-planning-wrapper .design-planning:not(:last-child) {
      margin-right: 0.7rem;
    }
    [dir=rtl] .card-app-design .design-planning-wrapper .design-planning:not(:last-child) {
      margin-left: 0.7rem;
    }
    
    [dir=ltr] .card-statistics .card-header {
      padding-left: 2.4rem;
    }
    
    [dir=rtl] .card-statistics .card-header {
      padding-right: 2.4rem;
    }
     .card-statistics .statistics-body {
      padding: 2rem 2.4rem 2.8rem !important;
    }
    .card-statistics .statistics-body .avatar .avatar-content {
      width: 48px;
      height: 48px;
    }
    .card-statistics .statistics-body .avatar .avatar-content .avatar-icon {
      width: 24px;
      height: 24px;
    }
    
    .chart-dropdown .btn {
      font-size: 1rem;
      font-weight: 400;
    }
    .chart-dropdown .btn:after {
      display: none;
    }
    
     .card-revenue-budget .revenue-report-wrapper {
      padding: 1.286rem 1.5rem;
    }
    @media (min-width: 768px) {
      [dir=ltr] .card-revenue-budget .revenue-report-wrapper {
        border-right: 1px solid #ebe9f1;
      }
      [dir=rtl] .card-revenue-budget .revenue-report-wrapper {
        border-left: 1px solid #ebe9f1;
      }
    }
     .card-revenue-budget .revenue-report-wrapper #revenue-report-chart .apexcharts-series[seriesName=Earning] {
      transform: scaleY(0.965);
    }
     .card-revenue-budget .revenue-report-wrapper #revenue-report-chart .apexcharts-series[seriesName=Expense] {
      transform: scaleY(1.035);
    }
     .card-revenue-budget .budget-wrapper {
      padding: 2rem 3rem;
      text-align: center;
    }
    @media (max-width: 767.98px) {
       .card-revenue-budget .budget-wrapper {
        padding-top: 0;
      }
    }
     .card-revenue-budget .budget-wrapper .budget-dropdown {
      margin-bottom: 2rem;
    }
     .card-revenue-budget .budget-wrapper #budget-chart {
      margin-top: 2rem;
      margin-bottom: 2rem;
    }
    
    .earnings-card .apexcharts-canvas .apexcharts-pie .apexcharts-datalabel-label {
      font-size: 0.8rem;
      fill: #424244 !important;
    }
    .earnings-card .apexcharts-canvas .apexcharts-pie .apexcharts-datalabel-value {
      fill: #424244;
      font-size: 1.286rem;
      font-weight: 500;
    }
    
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
       #dashboard-analytics .avatar .avatar-content,  #statistics-card .avatar .avatar-content {
        padding: 0 !important;
      }
    }
    .breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before {
      content: " ";
      color: #424244;
    }
     .breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px;
    }
    [dir=ltr] .breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before {
      margin-right: 0.6rem;
    }
    [dir=rtl] .breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before {
      margin-left: 0.6rem;
    }
    .breadcrumb .breadcrumb-item + .breadcrumb-item:before {
      height: 20px;
    }
    
    /* Component Specific */
    .breadcrumb-slash.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
      content: "/";
    }
    
    .breadcrumb-dots.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
      content: ".";
      position: relative;
      top: -4px;
    }
    
    .breadcrumb-dashes.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
      content: "-";
    }
    
    .breadcrumb-pipes.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
      content: "|";
    }
    
    .breadcrumb-chevron.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
      content: " ";
      color: #424244;
    }
    
     .breadcrumb-chevron.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px;
    }
    
    [dir=ltr] .breadcrumb-chevron.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
      margin-right: 0.6rem;
    }
    
    [dir=rtl] .breadcrumb-chevron.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
      margin-left: 0.6rem;
    }
    
    @media (max-width: 648px) {
      .content-header .breadcrumb {
        display: none;
      }
    
      .breadcrumbs-top .content-header-title {
        display: contents !important;
      }
    }
    .badge {
      color: #fff;
    }
    .badge[class*=badge-] [class*=icon-] {
      line-height: 1;
    }
    .badge[class*=badge-] a {
      color: #fff;
    }
    .badge[class*=badge-] .dropdown-toggle span,
    .badge[class*=badge-] .dropdown-toggle i,
    .badge[class*=badge-] .dropdown-toggle svg, .badge[class*=badge-].dropdown-toggle span,
    .badge[class*=badge-].dropdown-toggle i,
    .badge[class*=badge-].dropdown-toggle svg {
      vertical-align: text-top;
    }
    [dir=ltr] .badge[class*=badge-] .dropdown-toggle i, [dir=ltr] .badge[class*=badge-] .dropdown-toggle svg, [dir=ltr] .badge[class*=badge-].dropdown-toggle i, [dir=ltr] .badge[class*=badge-].dropdown-toggle svg {
      padding-left: 0.2rem;
    }
    [dir=rtl] .badge[class*=badge-] .dropdown-toggle i, [dir=rtl] .badge[class*=badge-] .dropdown-toggle svg, [dir=rtl] .badge[class*=badge-].dropdown-toggle i, [dir=rtl] .badge[class*=badge-].dropdown-toggle svg {
      padding-right: 0.2rem;
    }
    .badge[class*=badge-] .dropdown-toggle::after, .badge[class*=badge-].dropdown-toggle::after {
      position: relative;
      top: 0;
      font-size: 1rem;
    }
    [dir=ltr] .badge[class*=badge-] .dropdown-toggle::after, [dir=ltr] .badge[class*=badge-].dropdown-toggle::after {
      left: 0;
    }
    [dir=rtl] .badge[class*=badge-] .dropdown-toggle::after, [dir=rtl] .badge[class*=badge-].dropdown-toggle::after {
      right: 0;
    }
    .badge[class*=badge-] .dropdown-menu a {
      color: #424244;
    }
    .badge i,
    .badge svg {
      height: 12px;
      width: 11px;
      font-size: 12px;
      stroke-width: 3;
      vertical-align: top;
    }
     .badge.badge-square {
      border-radius: 0;
    }
    .badge.badge-up {
      position: absolute;
      top: -11px;
      min-width: 1.429rem;
      min-height: 1.429rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.786rem;
      line-height: 0.786;
    }
    [dir=ltr] .badge.badge-up {
      right: -9px;
      padding-left: 0.25rem;
      padding-right: 0.25rem;
    }
    [dir=rtl] .badge.badge-up {
      left: -9px;
      padding-right: 0.25rem;
      padding-left: 0.25rem;
    }
    .badge.badge-up.badge-sm {
      top: -0.5rem;
    }
    [dir=ltr] .badge.badge-up.badge-sm {
      right: -0.5rem;
    }
    [dir=rtl] .badge.badge-up.badge-sm {
      left: -0.5rem;
    }
    
    .badge-icon i,
    .badge-icon svg {
      font-size: 100%;
    }
    
    [dir=ltr] .badge-icon i, [dir=ltr] .badge-icon svg {
      margin-right: 5px;
    }
    
    [dir=rtl] .badge-icon i, [dir=rtl] .badge-icon svg {
      margin-left: 5px;
    }
    
     .dropup .badge {
      cursor: pointer;
    }
    
     .nav {
      border-radius: 0.25rem;
    }
     .nav.wrap-border {
      border: 1px solid #ddd;
    }
     .nav.wrap-border li.nav-header {
      margin: 0 0.5rem;
    }
     .nav.wrap-border li.nav-item,  .nav.wrap-border div {
      padding: 2px 0.714rem;
    }
    .nav.nav-left .nav-item .nav-link {
      justify-content: flex-start;
    }
    .nav.nav-right .nav-item .nav-link {
      justify-content: flex-end;
    }
     .nav.square-border {
      border-radius: 0;
    }
     .nav.square-border .nav-item .nav-link.active {
      border-radius: 0;
    }
     .nav .modern-nav-toggle {
      padding: 0;
      margin: 1.571rem 0;
    }
     .nav .dropdown.show .dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .nav .dropdown-toggle:not(.active)::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    
    .nav-pills .nav-link,
    .nav-tabs .nav-link {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    [dir=ltr] .nav-pills .nav-link i, [dir=ltr] .nav-pills .nav-link svg, [dir=ltr] .nav-tabs .nav-link i, [dir=ltr] .nav-tabs .nav-link svg {
      margin-right: 0.5rem;
    }
    [dir=rtl] .nav-pills .nav-link i, [dir=rtl] .nav-pills .nav-link svg, [dir=rtl] .nav-tabs .nav-link i, [dir=rtl] .nav-tabs .nav-link svg {
      margin-left: 0.5rem;
    }
    
     .nav-pills {
      margin-bottom: 1rem;
    }
    .nav-pills .nav-link {
      font-size: 1rem;
      line-height: 1rem;
      color: #424244;
    }
     .nav-pills .nav-link {
      padding: 0.72rem 1.5rem;
      border: 1px solid transparent;
    }
     .nav-pills .nav-link.active {
      border-color: #114A9F;
      box-shadow: 0 4px 18px -4px rgba(17, 74, 159, 0.65);
    }
    .nav-pills .nav-link.disabled {
      color: #b9b9c3;
    }
    .nav-pills .nav-link.dropdown-toggle::after {
      top: 1px;
    }
    [dir=ltr] .nav-pills .nav-link.dropdown-toggle::after {
      left: 1px;
    }
    [dir=rtl] .nav-pills .nav-link.dropdown-toggle::after {
      right: 1px;
    }
    .nav-pills.dropdown.show .nav-link {
      color: #fff;
    }
    .nav-pills.dropdown.show .dropdown-item.active:hover {
      color: #114A9F;
    }
    .nav-pills.nav-justified {
      width: 100%;
    }
     .nav-pills.nav-justified .nav-item {
      float: none;
    }
     .nav-pills.nav-justified .nav-link {
      text-align: center;
      margin-bottom: 5px;
    }
    .nav-pills.nav-justified > .dropdown .dropdown-menu {
      top: auto;
    }
    [dir=ltr] .nav-pills.nav-justified > .dropdown .dropdown-menu {
      left: auto;
    }
    [dir=rtl] .nav-pills.nav-justified > .dropdown .dropdown-menu {
      right: auto;
    }
    @media (min-width: 576px) {
      .nav-pills.nav-justified .nav-item {
        display: block;
        width: 1%;
      }
       .nav-pills.nav-justified .nav-link {
        margin-bottom: 0;
      }
    }
     .nav-pills.nav-justified .nav-link {
      border-radius: 0.357rem;
    }
    [dir=ltr] .nav-pills.nav-justified .nav-link {
      margin-right: 0;
    }
    [dir=rtl] .nav-pills.nav-justified .nav-link {
      margin-left: 0;
    }
    @media (min-width: 576px) {
       .nav-pills.nav-justified .nav-link.active,  .nav-pills.nav-justified .nav-link.active:hover,  .nav-pills.nav-justified .nav-link.active:focus {
        border-bottom-color: transparent;
      }
    }
    .nav-pills.nav-justified .nav-link {
      display: block;
    }
     .nav-pills.nav-justified .nav-link.active {
      border: none;
    }
     .nav-pills.nav-justified .nav-link.active:hover,  .nav-pills.nav-justified .nav-link.active:focus {
      border: none;
    }
    
    .nav-tabs {
      position: relative;
    }
    
     .nav-tabs {
      margin-bottom: 1rem;
    }
    .nav-tabs .nav-item {
      position: relative;
    }
    .nav-tabs .nav-link {
      color: #424244;
      min-width: auto;
      font-weight: 450;
      position: relative;
      overflow: hidden;
    }
     .nav-tabs .nav-link {
      border: none;
      padding: 0.61rem 1.2rem;
      border-radius: 0;
    }
    .nav-tabs .nav-link:after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 3px;
      transition: transform 0.3s;
    }
     .nav-tabs .nav-link:after {
      transform: translate3d(0, 150%, 0);
    }
    [dir=ltr] .nav-tabs .nav-link:after {
      left: 0;
      background: linear-gradient(30deg, #114a9f, rgba(17, 74, 159, 0.5)) !important;
    }
    [dir=rtl] .nav-tabs .nav-link:after {
      right: 0;
      background: linear-gradient(-30deg, #114a9f, rgba(17, 74, 159, 0.5)) !important;
    }
    .nav-tabs .nav-link.active {
      position: relative;
      color: #114A9F;
    }
     .nav-tabs .nav-link.active:after {
      transform: translate3d(0, 0, 0);
    }
    .nav-tabs .nav-link.dropdown-toggle::after {
      top: 1px;
    }
    [dir=ltr] .nav-tabs .nav-link.dropdown-toggle::after {
      left: 1px;
    }
    [dir=rtl] .nav-tabs .nav-link.dropdown-toggle::after {
      right: 1px;
    }
    .nav-tabs.nav-justified {
      width: 100%;
    }
     .nav-tabs.nav-justified .nav-item {
      float: none;
    }
     .nav-tabs.nav-justified .nav-link {
      text-align: center;
      margin-bottom: 5px;
    }
    .nav-tabs.nav-justified > .dropdown .dropdown-menu {
      top: auto;
    }
    [dir=ltr] .nav-tabs.nav-justified > .dropdown .dropdown-menu {
      left: auto;
    }
    [dir=rtl] .nav-tabs.nav-justified > .dropdown .dropdown-menu {
      right: auto;
    }
    @media (min-width: 576px) {
      .nav-tabs.nav-justified .nav-item {
        display: block;
        width: 1%;
      }
       .nav-tabs.nav-justified .nav-link {
        margin-bottom: 0;
      }
    }
     .nav-tabs.nav-justified .nav-link {
      border-radius: 0.357rem;
    }
    [dir=ltr] .nav-tabs.nav-justified .nav-link {
      margin-right: 0;
    }
    [dir=rtl] .nav-tabs.nav-justified .nav-link {
      margin-left: 0;
    }
    @media (min-width: 576px) {
       .nav-tabs.nav-justified .nav-link.active,  .nav-tabs.nav-justified .nav-link.active:hover,  .nav-tabs.nav-justified .nav-link.active:focus {
        border-bottom-color: transparent;
      }
    }
    .nav-tabs.nav-justified .nav-item a.nav-link {
      display: block;
    }
     .nav-tabs.nav-justified .nav-item a.nav-link {
      border-radius: 0;
    }
     .nav-tabs.nav-justified .nav-item a.nav-link.active {
      border: none;
    }
     .nav-tabs.nav-justified .nav-item a.nav-link:hover {
      border-color: transparent;
    }
    
    .nav-vertical {
      overflow: hidden;
    }
     .nav-vertical .nav.nav-tabs .nav-item .nav-link {
      margin-bottom: 0;
    }
    [dir=ltr] .nav-vertical .nav.nav-tabs .nav-item .nav-link:after {
      transform: rotate(90deg) translate3d(0, 150%, 0);
      left: 70%;
    }
    [dir=rtl] .nav-vertical .nav.nav-tabs .nav-item .nav-link:after {
      transform: rotate(-90deg) translate3d(0, 150%, 0);
      right: 70%;
    }
    .nav-vertical .nav.nav-tabs .nav-item .nav-link.active:after {
      top: 1.25rem;
      width: 2.14rem;
    }
    [dir=ltr] .nav-vertical .nav.nav-tabs .nav-item .nav-link.active:after {
      left: auto;
      right: -1.4rem;
      transform: rotate(90deg) translate3d(0, 225%, 0);
    }
    [dir=rtl] .nav-vertical .nav.nav-tabs .nav-item .nav-link.active:after {
      right: auto;
      left: -1.4rem;
      transform: rotate(-90deg) translate3d(0, 225%, 0);
    }
    .nav-vertical .nav.nav-tabs.nav-left {
      display: table;
    }
    [dir=ltr] .nav-vertical .nav.nav-tabs.nav-left {
      float: left;
      margin-right: 1rem;
    }
    [dir=rtl] .nav-vertical .nav.nav-tabs.nav-left {
      float: right;
      margin-left: 1rem;
    }
    .nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane {
      display: none;
      overflow-y: auto;
    }
    [dir=ltr] .nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane {
      padding-left: 1rem;
    }
    [dir=rtl] .nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane {
      padding-right: 1rem;
    }
    .nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane.active {
      display: block;
    }
    .nav-vertical .nav.nav-tabs.nav-right {
      display: table;
    }
    [dir=ltr] .nav-vertical .nav.nav-tabs.nav-right {
      float: right;
      margin-left: 1rem;
    }
    [dir=rtl] .nav-vertical .nav.nav-tabs.nav-right {
      float: left;
      margin-right: 1rem;
    }
    [dir=ltr] .nav-vertical .nav.nav-tabs.nav-right .nav-item .nav-link.active:after {
      left: -0.9rem;
      transform: rotate(90deg) translate3d(0, 10%, 0);
    }
    [dir=rtl] .nav-vertical .nav.nav-tabs.nav-right .nav-item .nav-link.active:after {
      right: -0.9rem;
      transform: rotate(-90deg) translate3d(0, 10%, 0);
    }
    .nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane {
      display: none;
      overflow-y: auto;
    }
    [dir=ltr] .nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane {
      padding-right: 1rem;
    }
    [dir=rtl] .nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane {
      padding-left: 1rem;
    }
    .nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane.active {
      display: block;
    }
    
    .alert {
      font-weight: 500;
    }
    
     .alert {
      border: none;
      padding: 0;
    }
     .alert.alert-dismissible .close {
      padding: 0.5rem 1rem 0.5rem 1rem;
      background-color: transparent !important;
      box-shadow: none !important;
    }
    [dir=ltr] .alert.alert-dismissible .alert-body {
      padding: 0.71rem 2rem 0.71rem 1rem;
    }
    [dir=rtl] .alert.alert-dismissible .alert-body {
      padding: 0.71rem 1rem 0.71rem 2rem;
    }
    .alert .close:focus {
      outline: 0;
    }
    .alert .alert-link:hover {
      text-decoration: underline;
    }
    .alert p {
      font-weight: 500;
      vertical-align: middle;
    }
     .alert p {
      padding: 2px 0;
      margin-bottom: 0;
    }
    .alert .alert-heading {
      font-weight: 600;
      font-size: 1rem;
    }
     .alert .alert-heading {
      padding: 0.71rem 1rem;
      margin-bottom: 0;
    }
     .alert .alert-body {
      padding: 0.71rem 1rem;
    }
    .alert .alert-body i,
    .alert .alert-body svg {
      position: relative;
      top: -2px;
    }
     .alert.alert-dark .alert-heading {
      box-shadow: rgba(75, 75, 75, 0.4) 0px 6px 15px -7px;
    }
    
    .media-list .media {
      width: 100%;
    }
    
     .media-list .media {
      padding: 1.25rem;
      margin-top: 0;
    }
    [dir=ltr] .media-list .media .media-left {
      margin-right: 1rem;
    }
    [dir=rtl] .media-list .media .media-left {
      margin-left: 1rem;
    }
    [dir=ltr] .media-list .media .media-right {
      margin-left: 1rem;
    }
    [dir=rtl] .media-list .media .media-right {
      margin-right: 1rem;
    }
    .media-list a.media {
      color: #b8c2cc !important;
    }
    
     .media-bordered .media:not(:first-child) {
      border-top: 1px solid #ebe9f1;
    }
    
    /*=========================================================================================
      File Name: progress.scss
      Description: Extended bootstrap progress bar scss.
    
      ----------------------------------------------------------------------------------------
    ==========================================================================================*/
     .progress .progress-bar + .progress-bar:not(:last-child) {
      border-radius: 0;
    }
    [dir=ltr] .progress .progress-bar:last-child {
      border-top-right-radius: 5rem;
      border-bottom-right-radius: 5rem;
    }
    [dir=rtl] .progress .progress-bar:last-child {
      border-top-left-radius: 5rem;
      border-bottom-left-radius: 5rem;
    }
    
    /* ===============================================================================================
      File Name: list-group.scss
      Description: Contain list item, list group related extended SCSS.
    
    ================================================================================================*/
    ul.list-inline li {
      display: inline-block;
    }
    ul.list-inline.list-inline-pipe > li + li:before {
      content: " | ";
    }
    [dir=ltr] ul.list-inline.list-inline-pipe > li + li:before {
      padding-right: 2px;
    }
    [dir=rtl] ul.list-inline.list-inline-pipe > li + li:before {
      padding-left: 2px;
    }
    
    .list-group .list-group-item {
      line-height: 1.5;
    }
     .list-group .list-group-item.active:hover {
      background-color: #114A9F;
    }
    .list-group .list-group-item.active:focus {
      outline: 0;
    }
    .list-group .list-group-item.active:focus:hover {
      color: #fff;
    }
    .list-group .list-group-item.active small {
      color: #fff !important;
    }
     .list-group .list-group-item:hover {
      background-color: #f8f8f8;
    }
    .list-group .list-group-item i,
    .list-group .list-group-item svg {
      position: relative;
    }
    .list-group .list-group-item:not(.active):focus:active {
      color: inherit;
    }
    .list-group .list-group-item-action.active {
      color: #fff;
    }
     .list-group .list-group-item-action.active {
      background-color: #114A9F;
    }
     .list-group .list-group-item-action.active:focus {
      background-color: #114A9F;
    }
    .list-group .list-group-item-action:focus {
      outline: 0;
    }
     .list-group .list-group-item-action:focus {
      background-color: #f8f8f8;
    }
     .list-group.list-group-circle {
      border: none;
    }
    .list-group.list-group-circle .list-group-item {
      position: relative;
    }
     .list-group.list-group-circle .list-group-item {
      border: none;
    }
    [dir=ltr] .list-group.list-group-circle .list-group-item {
      padding-left: 1.5rem;
    }
    [dir=rtl] .list-group.list-group-circle .list-group-item {
      padding-right: 1.5rem;
    }
    .list-group.list-group-circle .list-group-item:after {
      content: " ";
      color: #424244;
      position: absolute;
      height: 10px;
      width: 10px;
      top: 1.15rem;
    }
     .list-group.list-group-circle .list-group-item:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 10px;
    }
    [dir=ltr] .list-group.list-group-circle .list-group-item:after {
      left: 0;
    }
    [dir=rtl] .list-group.list-group-circle .list-group-item:after {
      right: 0;
    }
     .list-group.list-group-circle .list-group-item:hover {
      background-color: transparent;
    }
    
     .list-group-item.gu-mirror {
      border-radius: 0;
    }
    
    .toast.show {
      z-index: 1030;
    }
    .toast .close:focus {
      outline: none;
    }
    
    @media (max-width: 575.98px) {
      [dir=ltr] .toast {
        left: 1rem;
      }
      [dir=rtl] .toast {
        right: 1rem;
      }
    }
    [class*=collapse-] .collapse-title {
      font-weight: 500;
      font-size: 1.1rem;
    }
     [class*=collapse-] .card {
      margin-bottom: 0;
    }
     [class*=collapse-] .card:last-of-type {
      margin-bottom: 0;
    }
     [class*=collapse-] .card:not(:last-of-type) {
      border-bottom: 1px solid #ebe9f1;
    }
     [class*=collapse-] .card .card-header {
      cursor: pointer;
    }
    [dir=ltr] [class*=collapse-] .card .card-header {
      padding: 1rem 2.8rem 1rem 1rem;
    }
    [dir=rtl] [class*=collapse-] .card .card-header {
      padding: 1rem 1rem 1rem 2.8rem;
    }
    [class*=collapse-] .card .card-body {
      line-height: 1.5;
    }
     [class*=collapse-] .card .card-body {
      padding: 1rem;
      padding-top: 0.42rem;
    }
    
    .collapse-title {
      color: inherit;
    }
    .collapse-title:hover {
      color: inherit;
    }
    
     .collapse-default .card:first-child {
      border-top: 0;
    }
     .collapse-default .card:last-child {
      border-bottom: 0;
    }
     .collapse-default .card {
      border-radius: 0;
    }
    
     .collapse-border .card {
      border: 1px solid #ebe9f1;
    }
     .collapse-border .card:not(:last-of-type) {
      border-bottom: 0;
    }
    [dir=ltr] .collapse-border .card:not(:last-of-type) {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .collapse-border .card:not(:last-of-type) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=ltr] .collapse-border .card:not(:first-of-type) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    [dir=rtl] .collapse-border .card:not(:first-of-type) {
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }
    
     .collapse-shadow {
      box-shadow: 0 0px 4px 0 rgba(34, 41, 47, 0.1);
      padding: 0.15rem 0.75rem;
      border-radius: 0.357rem;
    }
    .collapse-shadow .card {
      transition: border 0.5s ease-in-out, all 0.3s ease-in-out;
    }
     .collapse-shadow .card {
      border-radius: 0;
    }
     .collapse-shadow .card.open {
      border-radius: 0.571rem;
      margin: 10px 0;
      border: 0;
      box-shadow: 0px 0px 8px 0px rgba(34, 41, 47, 0.1) !important;
    }
    [dir=ltr] .collapse-shadow .card:first-child {
      border-top-left-radius: 0.571rem;
      border-top-right-radius: 0.571rem;
    }
    [dir=rtl] .collapse-shadow .card:first-child {
      border-top-right-radius: 0.571rem;
      border-top-left-radius: 0.571rem;
    }
    [dir=ltr] .collapse-shadow .card:last-child {
      border-bottom-left-radius: 0.571rem;
      border-bottom-right-radius: 0.571rem;
    }
    [dir=rtl] .collapse-shadow .card:last-child {
      border-bottom-right-radius: 0.571rem;
      border-bottom-left-radius: 0.571rem;
    }
    
     .collapse-margin .card {
      margin-top: 0.71rem;
      margin-bottom: 0.71rem;
      box-shadow: 0 2px 15px 0 rgba(34, 41, 47, 0.05) !important;
      border-radius: 0.358rem;
      border-bottom: 0 solid transparent !important;
    }
     .collapse-margin .card-header {
      border-radius: 0.358rem;
    }
    
    .collapse-icon .card-header {
      position: relative;
    }
    .collapse-icon [data-toggle=collapse]:after {
      position: absolute;
      top: 58%;
      width: 14px;
      height: 11px;
      content: "";
      transition: all 300ms linear 0s;
    }
     .collapse-icon [data-toggle=collapse]:after {
      margin-top: -8px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px;
    }
    [dir=ltr] .collapse-icon [data-toggle=collapse]:after {
      right: 1rem;
    }
    [dir=rtl] .collapse-icon [data-toggle=collapse]:after {
      left: 1rem;
    }
     .collapse-icon [data-toggle=collapse]:disabled:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E");
    }
    [dir=ltr] .collapse-icon [aria-expanded=false]:after {
      transform: rotate(-180deg);
    }
    [dir=rtl] .collapse-icon [aria-expanded=false]:after {
      transform: rotate(180deg);
    }
    
     .page-item {
      border-radius: 5rem;
    }
    .page-item:not(.prev-item) .page-link, .page-item:not(.next-item) .page-link, .page-item:not(.first) .page-link, .page-item:not(.last) .page-link, .page-item:not(.active) .page-link {
      line-height: 1.3;
    }
    .page-item .page-link {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .page-item.previous .page-link, .page-item.prev .page-link, .page-item.next .page-link, .page-item.first .page-link, .page-item.last .page-link {
      width: auto;
    }
    .page-item.prev-item .page-link, .page-item.next-item .page-link {
      transition: all 0.2s ease-out;
    }
    [dir=ltr] .page-item.prev-item {
      margin-right: 0.3571rem;
    }
    [dir=rtl] .page-item.prev-item {
      margin-left: 0.3571rem;
    }
     .page-item.prev-item .page-link {
      border-radius: 50%;
    }
    .page-item.prev-item .page-link:before {
      color: #424244;
      width: 8px;
      height: 18px;
      content: "";
    }
     .page-item.prev-item .page-link:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px;
    }
    .page-item.prev-item .page-link:hover {
      color: #114A9F;
    }
     .page-item.prev-item .page-link:hover {
      background: #f3f2f7;
    }
     .page-item.prev-item .page-link:active,  .page-item.prev-item .page-link:hover {
      background-color: #114A9F !important;
    }
     .page-item.prev-item .page-link:active:before,  .page-item.prev-item .page-link:hover:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
     .page-item.prev-item.disabled .page-link:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b9b9c3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
    [dir=ltr] .page-item.prev-item ~ .page-item:nth-child(2) {
      border-top-left-radius: 5rem;
      border-bottom-left-radius: 5rem;
    }
    [dir=rtl] .page-item.prev-item ~ .page-item:nth-child(2) {
      border-top-right-radius: 5rem;
      border-bottom-right-radius: 5rem;
    }
    [dir=ltr] .page-item.prev-item ~ .page-item:nth-child(2) .page-link {
      border-top-left-radius: 5rem !important;
      border-bottom-left-radius: 5rem !important;
    }
    [dir=rtl] .page-item.prev-item ~ .page-item:nth-child(2) .page-link {
      border-top-right-radius: 5rem !important;
      border-bottom-right-radius: 5rem !important;
    }
    [dir=ltr] .page-item.prev-item ~ .page-item:nth-last-child(2) {
      border-top-right-radius: 5rem;
      border-bottom-right-radius: 5rem;
    }
    [dir=rtl] .page-item.prev-item ~ .page-item:nth-last-child(2) {
      border-top-left-radius: 5rem;
      border-bottom-left-radius: 5rem;
    }
    [dir=ltr] .page-item.prev-item ~ .page-item:nth-last-child(2) .page-link {
      border-top-right-radius: 5rem !important;
      border-bottom-right-radius: 5rem !important;
    }
    [dir=rtl] .page-item.prev-item ~ .page-item:nth-last-child(2) .page-link {
      border-top-left-radius: 5rem !important;
      border-bottom-left-radius: 5rem !important;
    }
    [dir=ltr] .page-item.next-item {
      margin-left: 0.3571rem;
    }
    [dir=rtl] .page-item.next-item {
      margin-right: 0.3571rem;
    }
     .page-item.next-item .page-link {
      border-radius: 50%;
    }
    .page-item.next-item .page-link:after {
      width: 8px;
      height: 18px;
      content: "";
    }
     .page-item.next-item .page-link:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px;
    }
    .page-item.next-item .page-link:hover {
      color: #114A9F;
    }
     .page-item.next-item .page-link:hover {
      background: #f3f2f7;
    }
     .page-item.next-item .page-link:active,  .page-item.next-item .page-link:hover {
      background-color: #114A9F !important;
    }
     .page-item.next-item .page-link:active:after,  .page-item.next-item .page-link:hover:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
     .page-item.next-item.disabled .page-link:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b9b9c3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .page-item.prev .page-link:before, .page-item.previous .page-link:before {
      color: #424244;
      width: 12px;
      height: 18px;
      content: "";
    }
     .page-item.prev .page-link:before,  .page-item.previous .page-link:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px;
    }
     .page-item.prev .page-link:hover:before,  .page-item.previous .page-link:hover:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23114A9F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
     .page-item.prev.disabled .page-link:before,  .page-item.previous.disabled .page-link:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b9b9c3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .page-item.next .page-link:after {
      color: #424244;
      width: 12px;
      height: 18px;
      content: "";
    }
     .page-item.next .page-link:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px;
    }
     .page-item.next .page-link:hover:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23114A9F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
     .page-item.next.disabled .page-link:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b9b9c3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .page-item.disabled .page-link {
      color: #b9b9c3;
    }
    .page-item .page-link {
      font-size: 1rem;
      min-width: 2.286rem;
    }
     .page-item .page-link {
      border: none;
      margin: 0;
    }
    [dir=ltr] .page-item .page-link {
      margin-left: 0;
    }
    [dir=rtl] .page-item .page-link {
      margin-right: 0;
    }
     .page-item .page-link:focus {
      box-shadow: none;
    }
    .page-item .page-link:hover {
      color: #114A9F;
    }
     .page-item.active {
      background-color: #f3f2f7;
      border-radius: 0;
    }
    .page-item.active .page-link {
      z-index: 3;
      color: #fff !important;
      font-weight: 600;
    }
     .page-item.active .page-link {
      border-radius: 5rem;
      background-color: #114A9F;
    }
    [dir=ltr] .page-item:first-child:not(.prev-item).active {
      border-top-left-radius: 1.428rem;
      border-bottom-left-radius: 1.428rem;
    }
    [dir=rtl] .page-item:first-child:not(.prev-item).active {
      border-top-right-radius: 1.428rem;
      border-bottom-right-radius: 1.428rem;
    }
     .page-item:first-child:not(.prev-item).active .page-link {
      border-radius: 5rem;
    }
    [dir=ltr] .page-item:first-child:not(.prev-item) .page-link {
      border-top-left-radius: 1.428rem;
      border-bottom-left-radius: 1.428rem;
    }
    [dir=rtl] .page-item:first-child:not(.prev-item) .page-link {
      border-top-right-radius: 1.428rem;
      border-bottom-right-radius: 1.428rem;
    }
    [dir=ltr] .page-item:last-child:not(.next-item).active {
      border-top-right-radius: 1.428rem;
      border-bottom-right-radius: 1.428rem;
    }
    [dir=rtl] .page-item:last-child:not(.next-item).active {
      border-top-left-radius: 1.428rem;
      border-bottom-left-radius: 1.428rem;
    }
     .page-item:last-child:not(.next-item).active .page-link {
      border-radius: 5rem;
    }
    [dir=ltr] .page-item:last-child:not(.next-item) .page-link {
      border-top-right-radius: 1.428rem;
      border-bottom-right-radius: 1.428rem;
    }
    [dir=rtl] .page-item:last-child:not(.next-item) .page-link {
      border-top-left-radius: 1.428rem;
      border-bottom-left-radius: 1.428rem;
    }
    
    .pagination.pagination-lg .page-item .page-link {
      font-size: 1.14rem;
      min-width: 2.6rem;
    }
    .pagination.pagination-sm .page-item .page-link {
      font-size: 0.857rem;
      min-width: 2rem;
    }
    
     .modal .modal-header {
      background-color: #f8f8f8;
      border-bottom: none;
    }
    
    [dir=ltr] .modal .modal-header {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    [dir=rtl] .modal .modal-header {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    .modal .modal-header .close {
      opacity: 1;
      transition: all 0.23s ease 0.1s;
      position: relative;
    }
     .modal .modal-header .close {
      padding: 0.2rem 0.62rem;
      box-shadow: 0 5px 20px 0 rgba(34, 41, 47, 0.1);
      border-radius: 0.357rem;
      background: #fff;
    }
    [dir=ltr] .modal .modal-header .close {
      transform: translate(8px, -2px);
    }
    [dir=rtl] .modal .modal-header .close {
      transform: translate(-8px, -2px);
    }
    .modal .modal-header .close:hover, .modal .modal-header .close:focus, .modal .modal-header .close:active {
      opacity: 1;
      outline: none;
    }
     .modal .modal-header .close:hover,  .modal .modal-header .close:focus,  .modal .modal-header .close:active {
      box-shadow: none;
    }
    [dir=ltr] .modal .modal-header .close:hover, [dir=ltr] .modal .modal-header .close:focus, [dir=ltr] .modal .modal-header .close:active {
      transform: translate(5px, 3px);
    }
    [dir=rtl] .modal .modal-header .close:hover, [dir=rtl] .modal .modal-header .close:focus, [dir=rtl] .modal .modal-header .close:active {
      transform: translate(-5px, 3px);
    }
    .modal .modal-content {
      overflow: visible;
    }
     .modal .modal-content {
      border: none;
      box-shadow: 0 5px 20px 0 rgba(34, 41, 47, 0.1);
    }
     .modal .modal-footer {
      padding: 0.8rem 1.4rem;
    }
    .modal.modal-sticky {
      bottom: 0;
      top: auto;
      height: auto;
      position: fixed;
    }
    [dir=ltr] .modal.modal-sticky {
      right: 0;
      left: auto;
    }
    [dir=rtl] .modal.modal-sticky {
      left: 0;
      right: auto;
    }
    .modal.modal-sticky .modal-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
     .modal.modal-sticky .modal-dialog {
      box-shadow: 0px 0px 24px 0 rgba(34, 41, 47, 0.25);
      border-radius: 0.357rem;
    }
    [dir=ltr] .modal.modal-sticky .modal-dialog {
      margin-right: 1rem !important;
    }
    [dir=rtl] .modal.modal-sticky .modal-dialog {
      margin-left: 1rem !important;
    }
    .modal.modal-sticky .modal-actions {
      line-height: 0;
    }
     .modal.modal-sticky .modal-actions {
      background: transparent;
      box-shadow: none;
    }
    
    .modal-xs {
      max-width: 300px;
    }
    
    @media (min-width: 1200px) {
      [dir=ltr] .modal-xl {
        margin-left: 3%;
        margin-right: 3%;
      }
      [dir=rtl] .modal-xl {
        margin-right: 3%;
        margin-left: 3%;
      }
    }
    .modal-slide-in,
    .modal-slide-in .modal {
      overflow: hidden !important;
    }
     .modal-slide-in,  .modal-slide-in .modal {
      padding: 0 !important;
    }
    
    .modal-slide-in .modal-dialog {
      position: fixed;
      top: 0;
      bottom: 0;
      max-width: none;
      width: 20rem;
    }
    
     .modal-slide-in .modal-dialog {
      margin: 0;
    }
    
    [dir=ltr] .modal-slide-in .modal-dialog {
      right: 0;
      left: auto;
    }
    
    [dir=rtl] .modal-slide-in .modal-dialog {
      left: 0;
      right: auto;
    }
    .modal-slide-in .modal-dialog .modal-content {
      overflow: auto;
      height: 100%;
    }
     .modal-slide-in .modal-dialog .modal-content {
      padding-bottom: 3.7rem;
      padding-top: 3.7rem;
      border-radius: 0;
    }
    .modal-slide-in .modal-dialog .modal-body {
      flex-grow: 0;
    }
     .modal-slide-in .modal-dialog .modal-body {
      padding-bottom: 0;
      padding-top: 0;
      margin: auto 0;
    }
    @media (min-width: 576px) {
      .modal-slide-in .modal-dialog {
        width: 28rem;
      }
    }
    .modal-slide-in .modal-dialog.sidebar-sm {
      width: 25rem;
    }
    @media (min-width: 576px) {
      .modal-slide-in .modal-dialog.sidebar-lg {
        width: 30rem;
      }
    }
    .modal-slide-in .close {
      top: 0.4rem;
      z-index: 10;
      position: absolute;
      top: 1.5rem;
      line-height: 0.5;
    }
     .modal-slide-in .close {
      transform: none;
      margin: 0;
      padding: 0 !important;
      transform: translate(0, -50%);
    }
    [dir=ltr] .modal-slide-in .close {
      right: 1.4rem;
    }
    [dir=rtl] .modal-slide-in .close {
      left: 1.4rem;
    }
    
    .modal-slide-in.fade .modal-dialog,
    .modal-slide-in .modal.fade .modal-dialog {
      transition: transform 0.1s ease-out;
    }
    
    [dir=ltr] .modal-slide-in.fade .modal-dialog, [dir=ltr] .modal-slide-in .modal.fade .modal-dialog {
      transform: translateX(100%);
    }
    
    [dir=rtl] .modal-slide-in.fade .modal-dialog, [dir=rtl] .modal-slide-in .modal.fade .modal-dialog {
      transform: translateX(-100%);
    }
    
    .modal-slide-in.show .modal-dialog,
    .modal-slide-in .modal.show .modal-dialog {
      transition: transform 0.1s ease-out;
    }
    
     .modal-slide-in.show .modal-dialog,  .modal-slide-in .modal.show .modal-dialog {
      transform: translateX(0) !important;
    }
    
    @media (max-width: 576px) {
      [dir=ltr] .modal {
        padding-right: 1rem;
        padding-left: 1rem;
      }
      [dir=rtl] .modal {
        padding-left: 1rem;
        padding-right: 1rem;
      }
      .modal .modal-xs,
    .modal .modal-sm {
        max-width: unset;
      }
       .modal.modal-sticky .modal-dialog {
        margin-bottom: 3rem;
      }
      [dir=ltr] .modal.modal-sticky .modal-dialog {
        margin-right: 0.2rem !important;
        margin-left: 0.2rem;
      }
      [dir=rtl] .modal.modal-sticky .modal-dialog {
        margin-left: 0.2rem !important;
        margin-right: 0.2rem;
      }
    }
     .popover {
      box-shadow: 0 0 10px 0 rgba(34, 41, 47, 0.1);
    }
    .popover .popover-header {
      font-size: 1.07rem;
    }
     .popover .popover-header {
      border: 1px solid #114A9F;
    }
     .popover .popover-body {
      border: 1px solid #ebe9f1;
      border-top-color: #fff;
    }
    [dir=ltr] .popover .popover-body {
      border-bottom-left-radius: 0.358rem;
      border-bottom-right-radius: 0.358rem;
    }
    [dir=rtl] .popover .popover-body {
      border-bottom-right-radius: 0.358rem;
      border-bottom-left-radius: 0.358rem;
    }
     .popover.bs-popover-bottom .arrow:after,  .popover.bs-popover-auto[x-placement^=bottom] .arrow:after {
      border-bottom-color: #114A9F;
    }
    
    .bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
      bottom: 1px;
    }
    
    [dir=ltr] .bs-popover-right > .arrow::after, [dir=ltr] .bs-popover-auto[x-placement^=right] > .arrow::after {
      left: 1px;
    }
    
    [dir=rtl] .bs-popover-right > .arrow::after, [dir=rtl] .bs-popover-auto[x-placement^=right] > .arrow::after {
      right: 1px;
    }
    
    [dir=ltr] .bs-popover-left > .arrow::after, [dir=ltr] .bs-popover-auto[x-placement^=left] > .arrow::after {
      right: 1px;
    }
    
    [dir=rtl] .bs-popover-left > .arrow::after, [dir=rtl] .bs-popover-auto[x-placement^=left] > .arrow::after {
      left: 1px;
    }
    
    .font-small-1 {
      font-size: 0.7rem !important;
    }
    svg.font-small-1 {
      height: 0.7rem !important;
      width: 0.7rem !important;
    }
    
    .font-small-2 {
      font-size: 0.8rem !important;
    }
    svg.font-small-2 {
      height: 0.8rem !important;
      width: 0.8rem !important;
    }
    
    .font-small-3 {
      font-size: 0.9rem !important;
    }
    svg.font-small-3 {
      height: 0.9rem !important;
      width: 0.9rem !important;
    }
    
    .font-small-4 {
      font-size: 1rem !important;
    }
    svg.font-small-4 {
      height: 1rem !important;
      width: 1rem !important;
    }
    
    .font-medium-1 {
      font-size: 1.1rem !important;
    }
    svg.font-medium-1 {
      height: 1.1rem !important;
      width: 1.1rem !important;
    }
    
    .font-medium-2 {
      font-size: 1.2rem !important;
    }
    svg.font-medium-2 {
      height: 1.2rem !important;
      width: 1.2rem !important;
    }
    
    .font-medium-3 {
      font-size: 1.3rem !important;
    }
    svg.font-medium-3 {
      height: 1.3rem !important;
      width: 1.3rem !important;
    }
    
    .font-medium-4 {
      font-size: 1.4rem !important;
    }
    svg.font-medium-4 {
      height: 1.4rem !important;
      width: 1.4rem !important;
    }
    
    .font-medium-5 {
      font-size: 1.5rem !important;
    }
    svg.font-medium-5 {
      height: 1.5rem !important;
      width: 1.5rem !important;
    }
    
    .font-large-1 {
      font-size: 2rem !important;
    }
    svg.font-large-1 {
      height: 2rem !important;
      width: 2rem !important;
    }
    
    .font-large-2 {
      font-size: 3rem !important;
    }
    svg.font-large-2 {
      height: 3rem !important;
      width: 3rem !important;
    }
    
    .font-large-3 {
      font-size: 4rem !important;
    }
    svg.font-large-3 {
      height: 4rem !important;
      width: 4rem !important;
    }
    
    .font-large-4 {
      font-size: 5rem !important;
    }
    svg.font-large-4 {
      height: 5rem !important;
      width: 5rem !important;
    }
    
    .font-large-5 {
      font-size: 6rem !important;
    }
    svg.font-large-5 {
      height: 6rem !important;
      width: 6rem !important;
    }
    
    .line-height-1 {
      line-height: 1 !important;
    }
    
    .line-height-condensed {
      line-height: 1.5 !important;
    }
    
    .line-height-inherit {
      line-height: inherit !important;
    }
    
    [dir=ltr] .rotate-45 {
      transform: rotate(45deg);
    }
    
    [dir=rtl] .rotate-45 {
      transform: rotate(-45deg);
    }
    
    [dir=ltr] .rotate-45-inverse {
      transform: rotate(-45deg);
    }
    
    [dir=rtl] .rotate-45-inverse {
      transform: rotate(45deg);
    }
    
    [dir=ltr] .rotate-90 {
      transform: rotate(90deg);
    }
    
    [dir=rtl] .rotate-90 {
      transform: rotate(-90deg);
    }
    
    [dir=ltr] .rotate-90-inverse {
      transform: rotate(-90deg);
    }
    
    [dir=rtl] .rotate-90-inverse {
      transform: rotate(90deg);
    }
    
    [dir=ltr] .rotate-180 {
      transform: rotate(180deg);
    }
    
    [dir=rtl] .rotate-180 {
      transform: rotate(-180deg);
    }
    
    [dir=ltr] .rotate-180-inverse {
      transform: rotate(-180deg);
    }
    
    [dir=rtl] .rotate-180-inverse {
      transform: rotate(180deg);
    }
    
     .border-2 {
      border-width: 2px !important;
    }
    
     .border-top-2 {
      border-top-width: 2px !important;
    }
    
     .border-bottom-2 {
      border-bottom-width: 2px !important;
    }
    
    [dir=ltr] .border-left-2 {
      border-left-width: 2px !important;
    }
    
    [dir=rtl] .border-left-2 {
      border-right-width: 2px !important;
    }
    
    [dir=ltr] .border-right-2 {
      border-right-width: 2px !important;
    }
    
    [dir=rtl] .border-right-2 {
      border-left-width: 2px !important;
    }
    
     .border-3 {
      border-width: 3px !important;
    }
    
     .border-top-3 {
      border-top-width: 3px !important;
    }
    
     .border-bottom-3 {
      border-bottom-width: 3px !important;
    }
    
    [dir=ltr] .border-left-3 {
      border-left-width: 3px !important;
    }
    
    [dir=rtl] .border-left-3 {
      border-right-width: 3px !important;
    }
    
    [dir=ltr] .border-right-3 {
      border-right-width: 3px !important;
    }
    
    [dir=rtl] .border-right-3 {
      border-left-width: 3px !important;
    }
    
     .round {
      border-radius: 1.5rem;
    }
    
     .square {
      border-radius: 0;
    }
    
    .fit {
      max-width: 100% !important;
    }
    
    .half-width {
      width: 50% !important;
    }
    
    .full-width {
      width: 100% !important;
    }
    
    .full-height {
      height: 100% !important;
    }
    
    .height-50 {
      height: 50px !important;
    }
    
    .width-50 {
      width: 50px !important;
    }
    
    .height-100 {
      height: 100px !important;
    }
    
    .width-100 {
      width: 100px !important;
    }
    
    .height-150 {
      height: 150px !important;
    }
    
    .width-150 {
      width: 150px !important;
    }
    
    .height-200 {
      height: 200px !important;
    }
    
    .width-200 {
      width: 200px !important;
    }
    
    .height-250 {
      height: 250px !important;
    }
    
    .width-250 {
      width: 250px !important;
    }
    
    .height-300 {
      height: 300px !important;
    }
    
    .width-300 {
      width: 300px !important;
    }
    
    .height-350 {
      height: 350px !important;
    }
    
    .width-350 {
      width: 350px !important;
    }
    
    .height-400 {
      height: 405px !important;
    }
    
    .width-400 {
      width: 405px !important;
    }
    
    .height-450 {
      height: 455px !important;
    }
    
    .width-450 {
      width: 455px !important;
    }
    
    .height-500 {
      height: 500px !important;
    }
    
    .width-500 {
      width: 500px !important;
    }
    
    .height-550 {
      height: 550px !important;
    }
    
    .width-550 {
      width: 550px !important;
    }
    
    .height-600 {
      height: 600px !important;
    }
    
    .width-600 {
      width: 600px !important;
    }
    
    .height-650 {
      height: 650px !important;
    }
    
    .width-650 {
      width: 650px !important;
    }
    
    .height-700 {
      height: 700px !important;
    }
    
    .width-700 {
      width: 700px !important;
    }
    
    .height-750 {
      height: 750px !important;
    }
    
    .width-750 {
      width: 750px !important;
    }
    
    .height-800 {
      height: 800px !important;
    }
    
    .width-800 {
      width: 800px !important;
    }
    
    .height-5-per {
      height: 5% !important;
    }
    
    .width-5-per {
      width: 5% !important;
    }
    
    .height-10-per {
      height: 10% !important;
    }
    
    .width-10-per {
      width: 10% !important;
    }
    
    .height-15-per {
      height: 15% !important;
    }
    
    .width-15-per {
      width: 15% !important;
    }
    
    .height-20-per {
      height: 20% !important;
    }
    
    .width-20-per {
      width: 20% !important;
    }
    
    .height-25-per {
      height: 25% !important;
    }
    
    .width-25-per {
      width: 25% !important;
    }
    
    .height-30-per {
      height: 30% !important;
    }
    
    .width-30-per {
      width: 30% !important;
    }
    
    .height-35-per {
      height: 35% !important;
    }
    
    .width-35-per {
      width: 35% !important;
    }
    
    .height-40-per {
      height: 40% !important;
    }
    
    .width-40-per {
      width: 40% !important;
    }
    
    .height-45-per {
      height: 45% !important;
    }
    
    .width-45-per {
      width: 45% !important;
    }
    
    .height-50-per {
      height: 50% !important;
    }
    
    .width-50-per {
      width: 50% !important;
    }
    
    .height-55-per {
      height: 55% !important;
    }
    
    .width-55-per {
      width: 55% !important;
    }
    
    .height-60-per {
      height: 60% !important;
    }
    
    .width-60-per {
      width: 60% !important;
    }
    
    .height-65-per {
      height: 65% !important;
    }
    
    .width-65-per {
      width: 65% !important;
    }
    
    .height-70-per {
      height: 70% !important;
    }
    
    .width-70-per {
      width: 70% !important;
    }
    
    .height-75-per {
      height: 75% !important;
    }
    
    .width-75-per {
      width: 75% !important;
    }
    
    .height-80-per {
      height: 80% !important;
    }
    
    .width-80-per {
      width: 80% !important;
    }
    
    .height-85-per {
      height: 85% !important;
    }
    
    .width-85-per {
      width: 85% !important;
    }
    
    .height-90-per {
      height: 90% !important;
    }
    
    .width-90-per {
      width: 90% !important;
    }
    
    .height-95-per {
      height: 95% !important;
    }
    
    .width-95-per {
      width: 95% !important;
    }
    
    .position-top-0 {
      top: 0;
    }
    
    [dir=ltr] .position-right-0 {
      right: 0;
    }
    
    [dir=rtl] .position-right-0 {
      left: 0;
    }
    
    .position-bottom-0 {
      bottom: 0;
    }
    
    [dir=ltr] .position-left-0 {
      left: 0;
    }
    
    [dir=rtl] .position-left-0 {
      right: 0;
    }
    
    .overflow-visible {
      overflow: visible;
    }
    
    .overflow-scroll {
      overflow: scroll;
    }
    
    .overflow-x-scroll {
      overflow: scroll;
    }
    
    .overflow-y-scroll {
      overflow: scroll;
    }
    
     .cursor-pointer {
      cursor: pointer;
    }
    
     .cursor-move {
      cursor: move;
    }
    
     .cursor-default {
      cursor: default;
    }
    
     .cursor-progress {
      cursor: progress;
    }
    
     .cursor-not-allowed {
      cursor: not-allowed;
    }
    
    .zindex-1 {
      z-index: 1 !important;
    }
    
    .zindex-2 {
      z-index: 2 !important;
    }
    
    .zindex-3 {
      z-index: 3 !important;
    }
    
    .zindex-4 {
      z-index: 4 !important;
    }
    
    .zindex-0 {
      z-index: 0 !important;
    }
    
    .zindex-minus-1 {
      z-index: -1 !important;
    }
    
    .zindex-minus-2 {
      z-index: -2 !important;
    }
    
    .zindex-minus-3 {
      z-index: -3 !important;
    }
    
    .zindex-minus-4 {
      z-index: -4 !important;
    }
    
     .box-shadow-0 {
      box-shadow: none !important;
    }
    
     .box-shadow-1 {
      box-shadow: 0 2px 5px 0 rgba(34, 41, 47, 0.16), 0 2px 10px 0 rgba(34, 41, 47, 0.12);
    }
    
     .box-shadow-2 {
      box-shadow: 0 8px 17px 0 rgba(34, 41, 47, 0.2), 0 6px 20px 0 rgba(34, 41, 47, 0.19);
    }
    
     .box-shadow-3 {
      box-shadow: 0 12px 15px 0 rgba(34, 41, 47, 0.24), 0 17px 50px 0 rgba(34, 41, 47, 0.19);
    }
    
     .box-shadow-4 {
      box-shadow: 0 16px 28px 0 rgba(34, 41, 47, 0.22), 0 25px 55px 0 rgba(34, 41, 47, 0.21);
    }
    
     .box-shadow-5 {
      box-shadow: 0 27px 24px 0 rgba(34, 41, 47, 0.2), 0 40px 77px 0 rgba(34, 41, 47, 0.22);
    }
    
     .box-shadow-6 {
      box-shadow: 0 4px 8px 0 rgba(34, 41, 47, 0.12), 0 2px 4px 0 rgba(34, 41, 47, 0.08);
    }
    
    .outline-none {
      outline: none !important;
    }
    
    .list-style-inside {
      list-style: inside;
    }
    
    .list-style-circle {
      list-style: circle;
    }
    
    .list-style-square {
      list-style: square;
    }
    
     .bg-cover {
      background-size: cover !important;
    }
    
     .background-repeat {
      background-repeat: repeat !important;
    }
    
     .background-no-repeat {
      background-repeat: no-repeat !important;
    }
    
    .icon-bg-circle {
      color: #fff;
    }
    
     .icon-bg-circle {
      padding: 0.5rem;
      border-radius: 50%;
    }
    
    [dir=ltr] .icon-left {
      margin-right: 0.5rem;
    }
    
    [dir=rtl] .icon-left {
      margin-left: 0.5rem;
    }
    
    [dir=ltr] .icon-right {
      margin-right: 0.5rem;
    }
    
    [dir=rtl] .icon-right {
      margin-left: 0.5rem;
    }
    
    .blockOverlay {
      z-index: 1050 !important;
    }
    
    .blockElement,
    .blockPage {
      z-index: 1051 !important;
    }
    
    .hidden {
      display: none;
      visibility: hidden;
    }
    
     a:hover {
      cursor: pointer;
    }
    
    .table-middle td {
      vertical-align: middle;
    }
    
    .fill-current {
      fill: currentColor;
    }
    
    .pointer-events-none {
      pointer-events: none;
    }
    
     .bg-white {
      background-color: #ffffff !important;
    }
     .bg-white .card-header,  .bg-white .card-footer {
      background-color: transparent;
    }
    
     .border-white {
      border: 1px solid #ffffff !important;
    }
    
     .border-top-white {
      border-top: 1px solid #ffffff;
    }
    
     .border-bottom-white {
      border-bottom: 1px solid #ffffff;
    }
    
    [dir=ltr] .border-left-white {
      border-left: 1px solid #ffffff;
    }
    
    [dir=rtl] .border-left-white {
      border-right: 1px solid #ffffff;
    }
    
    [dir=ltr] .border-right-white {
      border-right: 1px solid #ffffff;
    }
    
    [dir=rtl] .border-right-white {
      border-left: 1px solid #ffffff;
    }
    
     .bg-white.badge-glow,  .border-white.badge-glow,  .badge-white.badge-glow {
      box-shadow: 0px 0px 10px #ffffff;
    }
    
    .overlay-white {
      /* The Fallback */
    }
    
     .overlay-white {
      background: #ffffff;
      background: rgba(255, 255, 255, 0.6);
    }
    
     input:focus ~ .bg-white {
      box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #ffffff !important;
    }
    
     .bg-black {
      background-color: #000000 !important;
    }
     .bg-black .card-header,  .bg-black .card-footer {
      background-color: transparent;
    }
    
     .border-black {
      border: 1px solid #000000 !important;
    }
    
     .border-top-black {
      border-top: 1px solid #000000;
    }
    
     .border-bottom-black {
      border-bottom: 1px solid #000000;
    }
    
    [dir=ltr] .border-left-black {
      border-left: 1px solid #000000;
    }
    
    [dir=rtl] .border-left-black {
      border-right: 1px solid #000000;
    }
    
    [dir=ltr] .border-right-black {
      border-right: 1px solid #000000;
    }
    
    [dir=rtl] .border-right-black {
      border-left: 1px solid #000000;
    }
    
     .bg-black.badge-glow,  .border-black.badge-glow,  .badge-black.badge-glow {
      box-shadow: 0px 0px 10px #000000;
    }
    
    .overlay-black {
      /* The Fallback */
    }
    
     .overlay-black {
      background: #000000;
      background: rgba(0, 0, 0, 0.6);
    }
    
     input:focus ~ .bg-black {
      box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #000000 !important;
    }
    
     .bg-dark {
      background-color: #4B4B4B !important;
    }
     .bg-dark .card-header,  .bg-dark .card-footer {
      background-color: transparent;
    }
    
    .alert-dark {
      color: #4B4B4B !important;
    }
    
     .alert-dark {
      background: rgba(75, 75, 75, 0.12) !important;
    }
     .alert-dark .alert-heading {
      box-shadow: rgba(75, 75, 75, 0.4) 0px 6px 15px -7px;
    }
    .alert-dark .alert-link {
      color: #3e3e3e !important;
    }
    .alert-dark .close {
      color: #4B4B4B !important;
    }
    
     .border-dark {
      border: 1px solid #4B4B4B !important;
    }
    
     .border-top-dark {
      border-top: 1px solid #4B4B4B;
    }
    
     .border-bottom-dark {
      border-bottom: 1px solid #4B4B4B;
    }
    
    [dir=ltr] .border-left-dark {
      border-left: 1px solid #4B4B4B;
    }
    
    [dir=rtl] .border-left-dark {
      border-right: 1px solid #4B4B4B;
    }
    
    [dir=ltr] .border-right-dark {
      border-right: 1px solid #4B4B4B;
    }
    
    [dir=rtl] .border-right-dark {
      border-left: 1px solid #4B4B4B;
    }
    
     .bg-dark.badge-glow,  .border-dark.badge-glow,  .badge-dark.badge-glow {
      box-shadow: 0px 0px 10px #4B4B4B;
    }
    
    .badge.badge-light-dark {
      color: #4B4B4B !important;
    }
    
     .badge.badge-light-dark {
      background-color: rgba(75, 75, 75, 0.12);
    }
    
    .overlay-dark {
      /* The Fallback */
    }
    
     .overlay-dark {
      background: #4B4B4B;
      background: rgba(75, 75, 75, 0.6);
    }
    
    .btn-dark {
      color: #fff !important;
    }
    
     .btn-dark {
      border-color: #4B4B4B !important;
      background-color: #4B4B4B !important;
    }
    .btn-dark:focus, .btn-dark:active, .btn-dark.active {
      color: #fff;
    }
     .btn-dark:focus,  .btn-dark:active,  .btn-dark.active {
      background-color: #343434 !important;
    }
     .btn-dark:hover:not(.disabled):not(:disabled) {
      box-shadow: 0 8px 25px -8px #4b4b4b;
    }
     .btn-dark:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    
    .btn-flat-dark {
      color: #4B4B4B;
    }
    
     .btn-flat-dark {
      background-color: transparent;
    }
    .btn-flat-dark:hover {
      color: #4B4B4B;
    }
     .btn-flat-dark:hover:not(.disabled):not(:disabled) {
      background-color: rgba(75, 75, 75, 0.12);
    }
    .btn-flat-dark:active, .btn-flat-dark.active, .btn-flat-dark:focus {
      color: #4B4B4B;
    }
     .btn-flat-dark:active,  .btn-flat-dark.active,  .btn-flat-dark:focus {
      background-color: rgba(75, 75, 75, 0.2);
    }
     .btn-flat-dark.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%234B4B4B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    
    .btn-relief-dark {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .btn-relief-dark {
      background-color: #4B4B4B;
      box-shadow: inset 0 -3px 0 0 rgba(34, 41, 47, 0.2);
    }
     .btn-relief-dark:hover:not(.disabled):not(:disabled) {
      background-color: #626262;
    }
     .btn-relief-dark:active,  .btn-relief-dark.active,  .btn-relief-dark:focus {
      background-color: #343434;
    }
    .btn-relief-dark:hover {
      color: #fff;
    }
    .btn-relief-dark:active, .btn-relief-dark.active {
      outline: none;
    }
     .btn-relief-dark:active,  .btn-relief-dark.active {
      box-shadow: none;
      transform: translateY(3px);
    }
    
    .btn-outline-dark {
      color: #4B4B4B;
    }
    
     .btn-outline-dark {
      border: 1px solid #4B4B4B !important;
      background-color: transparent;
    }
    .btn-outline-dark:hover:not(.disabled):not(:disabled) {
      color: #4B4B4B;
    }
     .btn-outline-dark:hover:not(.disabled):not(:disabled) {
      background-color: rgba(75, 75, 75, 0.04);
    }
     .btn-outline-dark:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .btn-outline-dark:not(:disabled):not(.disabled):focus {
      color: #4B4B4B;
    }
     .btn-outline-dark:not(:disabled):not(.disabled):active,  .btn-outline-dark:not(:disabled):not(.disabled).active,  .btn-outline-dark:not(:disabled):not(.disabled):focus {
      background-color: rgba(75, 75, 75, 0.2);
    }
     .btn-outline-dark.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%234B4B4B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .show > .btn-outline-dark.dropdown-toggle {
      color: #4B4B4B;
    }
     .show > .btn-outline-dark.dropdown-toggle {
      background-color: rgba(75, 75, 75, 0.2);
    }
    
     .btn-outline-dark.waves-effect .waves-ripple,  .btn-flat-dark.waves-effect .waves-ripple {
      background: radial-gradient(rgba(75, 75, 75, 0.2) 0, rgba(75, 75, 75, 0.3) 40%, rgba(75, 75, 75, 0.4) 50%, rgba(75, 75, 75, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
    }
    
     .bullet.bullet-dark {
      background-color: #4B4B4B;
    }
    
    .modal.modal-dark .modal-header .modal-title {
      color: #4B4B4B;
    }
    .modal.modal-dark .modal-header .close {
      color: #4B4B4B !important;
    }
    
     .progress-bar-dark {
      background-color: rgba(75, 75, 75, 0.12);
    }
     .progress-bar-dark .progress-bar {
      background-color: #4B4B4B;
    }
    
     .timeline .timeline-point-dark {
      border-color: #4B4B4B !important;
    }
    .timeline .timeline-point-dark i,
    .timeline .timeline-point-dark svg {
      stroke: #4B4B4B !important;
    }
     .timeline .timeline-point-dark.timeline-point-indicator {
      background-color: #4B4B4B !important;
    }
     .timeline .timeline-point-dark.timeline-point-indicator:before {
      background: rgba(75, 75, 75, 0.12) !important;
    }
    
     .divider.divider-dark .divider-text:before,  .divider.divider-dark .divider-text:after {
      border-color: #4B4B4B !important;
    }
    
     input:focus ~ .bg-dark {
      box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #4B4B4B !important;
    }
    
     .custom-control-dark .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-dark .custom-control-input:active ~ .custom-control-label::before {
      border-color: #4B4B4B;
      background-color: #4B4B4B;
    }
     .custom-control-dark.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-dark.custom-checkbox .custom-control-input:active ~ .custom-control-label::before,  .custom-control-dark.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,  .custom-control-dark.custom-radio .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-dark.custom-radio .custom-control-input:active ~ .custom-control-label::before,  .custom-control-dark.custom-radio .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: 0 2px 4px 0 rgba(75, 75, 75, 0.4) !important;
    }
     .custom-control-dark .custom-control-input:disabled:checked ~ .custom-control-label::before {
      background-color: rgba(75, 75, 75, 0.65) !important;
      border: none;
      box-shadow: none !important;
    }
     .custom-control-dark .custom-control-input:focus ~ .custom-control-label::before {
      border-color: #4B4B4B;
    }
    
    .custom-switch-dark .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      transition: all 0.2s ease-out;
    }
    
     .custom-switch-dark .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #4B4B4B !important;
    }
    
     .select2-dark .select2-container--default .select2-selection--multiple .select2-selection__choice {
      background: #4B4B4B !important;
      border-color: #4B4B4B !important;
    }
    
    .text-dark.text-darken-1 {
      color: #343434 !important;
    }
    
     .bg-dark.bg-darken-1 {
      background-color: #343434 !important;
    }
    
     .border-dark.border-darken-1 {
      border: 1px solid #343434 !important;
    }
    
     .border-top-dark.border-top-darken-1 {
      border-top: 1px solid #343434 !important;
    }
    
     .border-bottom-dark.border-bottom-darken-1 {
      border-bottom: 1px solid #343434 !important;
    }
    
    [dir=ltr] .border-left-dark.border-left-darken-1 {
      border-left: 1px solid #343434 !important;
    }
    
    [dir=rtl] .border-left-dark.border-left-darken-1 {
      border-right: 1px solid #343434 !important;
    }
    
    [dir=ltr] .border-right-dark.border-right-darken-1 {
      border-right: 1px solid #343434 !important;
    }
    
    [dir=rtl] .border-right-dark.border-right-darken-1 {
      border-left: 1px solid #343434 !important;
    }
    
    .overlay-dark.overlay-darken-1 {
      /* The Fallback */
    }
    
     .overlay-dark.overlay-darken-1 {
      background: #343434;
      background: rgba(52, 52, 52, 0.6);
    }
    
    .text-dark.text-darken-2 {
      color: #1e1e1e !important;
    }
    
     .bg-dark.bg-darken-2 {
      background-color: #1e1e1e !important;
    }
    
     .border-dark.border-darken-2 {
      border: 1px solid #1e1e1e !important;
    }
    
     .border-top-dark.border-top-darken-2 {
      border-top: 1px solid #1e1e1e !important;
    }
    
     .border-bottom-dark.border-bottom-darken-2 {
      border-bottom: 1px solid #1e1e1e !important;
    }
    
    [dir=ltr] .border-left-dark.border-left-darken-2 {
      border-left: 1px solid #1e1e1e !important;
    }
    
    [dir=rtl] .border-left-dark.border-left-darken-2 {
      border-right: 1px solid #1e1e1e !important;
    }
    
    [dir=ltr] .border-right-dark.border-right-darken-2 {
      border-right: 1px solid #1e1e1e !important;
    }
    
    [dir=rtl] .border-right-dark.border-right-darken-2 {
      border-left: 1px solid #1e1e1e !important;
    }
    
    .overlay-dark.overlay-darken-2 {
      /* The Fallback */
    }
    
     .overlay-dark.overlay-darken-2 {
      background: #1e1e1e;
      background: rgba(30, 30, 30, 0.6);
    }
    
    .text-dark.text-darken-3 {
      color: #626262 !important;
    }
    
     .bg-dark.bg-darken-3 {
      background-color: #626262 !important;
    }
    
     .border-dark.border-darken-3 {
      border: 1px solid #626262 !important;
    }
    
     .border-top-dark.border-top-darken-3 {
      border-top: 1px solid #626262 !important;
    }
    
     .border-bottom-dark.border-bottom-darken-3 {
      border-bottom: 1px solid #626262 !important;
    }
    
    [dir=ltr] .border-left-dark.border-left-darken-3 {
      border-left: 1px solid #626262 !important;
    }
    
    [dir=rtl] .border-left-dark.border-left-darken-3 {
      border-right: 1px solid #626262 !important;
    }
    
    [dir=ltr] .border-right-dark.border-right-darken-3 {
      border-right: 1px solid #626262 !important;
    }
    
    [dir=rtl] .border-right-dark.border-right-darken-3 {
      border-left: 1px solid #626262 !important;
    }
    
    .overlay-dark.overlay-darken-3 {
      /* The Fallback */
    }
    
     .overlay-dark.overlay-darken-3 {
      background: #626262;
      background: rgba(98, 98, 98, 0.6);
    }
    
     .bg-light {
      background-color: #C1C1C1 !important;
    }
     .bg-light .card-header,  .bg-light .card-footer {
      background-color: transparent;
    }
    
     .border-light {
      border: 1px solid #C1C1C1 !important;
    }
    
     .border-top-light {
      border-top: 1px solid #C1C1C1;
    }
    
     .border-bottom-light {
      border-bottom: 1px solid #C1C1C1;
    }
    
    [dir=ltr] .border-left-light {
      border-left: 1px solid #C1C1C1;
    }
    
    [dir=rtl] .border-left-light {
      border-right: 1px solid #C1C1C1;
    }
    
    [dir=ltr] .border-right-light {
      border-right: 1px solid #C1C1C1;
    }
    
    [dir=rtl] .border-right-light {
      border-left: 1px solid #C1C1C1;
    }
    
     .bg-light.badge-glow,  .border-light.badge-glow,  .badge-light.badge-glow {
      box-shadow: 0px 0px 10px #C1C1C1;
    }
    
    .overlay-light {
      /* The Fallback */
    }
    
     .overlay-light {
      background: #C1C1C1;
      background: rgba(193, 193, 193, 0.6);
    }
    
     input:focus ~ .bg-light {
      box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #C1C1C1 !important;
    }
    
    .text-primary.text-lighten-5 {
      color: #4487eb !important;
    }
    
     .bg-primary.bg-lighten-5 {
      background-color: #4487eb !important;
    }
    
     .border-primary.border-lighten-5 {
      border: 1px solid #4487eb !important;
    }
    
     .border-top-primary.border-top-lighten-5 {
      border-top: 1px solid #4487eb !important;
    }
    
     .border-bottom-primary.border-bottom-lighten-5 {
      border-bottom: 1px solid #4487eb !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-lighten-5 {
      border-left: 1px solid #4487eb !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-lighten-5 {
      border-right: 1px solid #4487eb !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-lighten-5 {
      border-right: 1px solid #4487eb !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-lighten-5 {
      border-left: 1px solid #4487eb !important;
    }
    
    .overlay-primary.overlay-lighten-5 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-lighten-5 {
      background: #4487eb;
      background: rgba(68, 135, 235, 0.6);
    }
    
    .text-primary.text-lighten-4 {
      color: #2d79e9 !important;
    }
    
     .bg-primary.bg-lighten-4 {
      background-color: #2d79e9 !important;
    }
    
     .border-primary.border-lighten-4 {
      border: 1px solid #2d79e9 !important;
    }
    
     .border-top-primary.border-top-lighten-4 {
      border-top: 1px solid #2d79e9 !important;
    }
    
     .border-bottom-primary.border-bottom-lighten-4 {
      border-bottom: 1px solid #2d79e9 !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-lighten-4 {
      border-left: 1px solid #2d79e9 !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-lighten-4 {
      border-right: 1px solid #2d79e9 !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-lighten-4 {
      border-right: 1px solid #2d79e9 !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-lighten-4 {
      border-left: 1px solid #2d79e9 !important;
    }
    
    .overlay-primary.overlay-lighten-4 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-lighten-4 {
      background: #2d79e9;
      background: rgba(45, 121, 233, 0.6);
    }
    
    .text-primary.text-lighten-3 {
      color: #186ae4 !important;
    }
    
     .bg-primary.bg-lighten-3 {
      background-color: #186ae4 !important;
    }
    
     .border-primary.border-lighten-3 {
      border: 1px solid #186ae4 !important;
    }
    
     .border-top-primary.border-top-lighten-3 {
      border-top: 1px solid #186ae4 !important;
    }
    
     .border-bottom-primary.border-bottom-lighten-3 {
      border-bottom: 1px solid #186ae4 !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-lighten-3 {
      border-left: 1px solid #186ae4 !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-lighten-3 {
      border-right: 1px solid #186ae4 !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-lighten-3 {
      border-right: 1px solid #186ae4 !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-lighten-3 {
      border-left: 1px solid #186ae4 !important;
    }
    
    .overlay-primary.overlay-lighten-3 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-lighten-3 {
      background: #186ae4;
      background: rgba(24, 106, 228, 0.6);
    }
    
    .text-primary.text-lighten-2 {
      color: #165fcd !important;
    }
    
     .bg-primary.bg-lighten-2 {
      background-color: #165fcd !important;
    }
    
     .border-primary.border-lighten-2 {
      border: 1px solid #165fcd !important;
    }
    
     .border-top-primary.border-top-lighten-2 {
      border-top: 1px solid #165fcd !important;
    }
    
     .border-bottom-primary.border-bottom-lighten-2 {
      border-bottom: 1px solid #165fcd !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-lighten-2 {
      border-left: 1px solid #165fcd !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-lighten-2 {
      border-right: 1px solid #165fcd !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-lighten-2 {
      border-right: 1px solid #165fcd !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-lighten-2 {
      border-left: 1px solid #165fcd !important;
    }
    
    .overlay-primary.overlay-lighten-2 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-lighten-2 {
      background: #165fcd;
      background: rgba(22, 95, 205, 0.6);
    }
    
    .text-primary.text-lighten-1 {
      color: #1355b6 !important;
    }
    
     .bg-primary.bg-lighten-1 {
      background-color: #1355b6 !important;
    }
    
     .border-primary.border-lighten-1 {
      border: 1px solid #1355b6 !important;
    }
    
     .border-top-primary.border-top-lighten-1 {
      border-top: 1px solid #1355b6 !important;
    }
    
     .border-bottom-primary.border-bottom-lighten-1 {
      border-bottom: 1px solid #1355b6 !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-lighten-1 {
      border-left: 1px solid #1355b6 !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-lighten-1 {
      border-right: 1px solid #1355b6 !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-lighten-1 {
      border-right: 1px solid #1355b6 !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-lighten-1 {
      border-left: 1px solid #1355b6 !important;
    }
    
    .overlay-primary.overlay-lighten-1 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-lighten-1 {
      background: #1355b6;
      background: rgba(19, 85, 182, 0.6);
    }
    
     .bg-primary {
      background-color: #114A9F !important;
    }
     .bg-primary .card-header,  .bg-primary .card-footer {
      background-color: transparent;
    }
    
    .alert-primary {
      color: #114A9F !important;
    }
    
     .alert-primary {
      background: rgba(17, 74, 159, 0.12) !important;
    }
     .alert-primary .alert-heading {
      box-shadow: rgba(17, 74, 159, 0.4) 0px 6px 15px -7px;
    }
    .alert-primary .alert-link {
      color: #0f3f88 !important;
    }
    .alert-primary .close {
      color: #114A9F !important;
    }
    
    .bg-light-primary {
      color: #114A9F !important;
    }
    
     .bg-light-primary {
      background: rgba(17, 74, 159, 0.12) !important;
    }
     .bg-light-primary.fc-h-event,  .bg-light-primary.fc-v-event {
      border-color: rgba(17, 74, 159, 0.1);
    }
     .bg-light-primary .fc-list-event-dot {
      border-color: #114A9F !important;
    }
     .bg-light-primary.fc-list-event:hover td {
      background: rgba(17, 74, 159, 0.1) !important;
    }
    .bg-light-primary.fc-list-event .fc-list-event-title {
      color: #424244;
    }
    
    .avatar.bg-light-primary {
      color: #114A9F !important;
    }
    
     .border-primary {
      border: 1px solid #114A9F !important;
    }
    
     .border-top-primary {
      border-top: 1px solid #114A9F;
    }
    
     .border-bottom-primary {
      border-bottom: 1px solid #114A9F;
    }
    
    [dir=ltr] .border-left-primary {
      border-left: 1px solid #114A9F;
    }
    
    [dir=rtl] .border-left-primary {
      border-right: 1px solid #114A9F;
    }
    
    [dir=ltr] .border-right-primary {
      border-right: 1px solid #114A9F;
    }
    
    [dir=rtl] .border-right-primary {
      border-left: 1px solid #114A9F;
    }
    
     .bg-primary.badge-glow,  .border-primary.badge-glow,  .badge-primary.badge-glow {
      box-shadow: 0px 0px 10px #114A9F;
    }
    
    .badge.badge-light-primary {
      color: #114A9F !important;
    }
    
     .badge.badge-light-primary {
      background-color: rgba(17, 74, 159, 0.12);
    }
    
    .overlay-primary {
      /* The Fallback */
    }
    
     .overlay-primary {
      background: #114A9F;
      background: rgba(17, 74, 159, 0.6);
    }
    
    .btn-primary {
      color: #fff !important;
    }
    
     .btn-primary {
      border-color: #114A9F !important;
      background-color: #114A9F !important;
    }
    .btn-primary:focus, .btn-primary:active, .btn-primary.active {
      color: #fff;
    }
     .btn-primary:focus,  .btn-primary:active,  .btn-primary.active {
      background-color: #0f3f88 !important;
    }
     .btn-primary:hover:not(.disabled):not(:disabled) {
      box-shadow: 0 8px 25px -8px #114a9f;
    }
     .btn-primary:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    
    .btn-flat-primary {
      color: #114A9F;
    }
    
     .btn-flat-primary {
      background-color: transparent;
    }
    .btn-flat-primary:hover {
      color: #114A9F;
    }
     .btn-flat-primary:hover:not(.disabled):not(:disabled) {
      background-color: rgba(17, 74, 159, 0.12);
    }
    .btn-flat-primary:active, .btn-flat-primary.active, .btn-flat-primary:focus {
      color: #114A9F;
    }
     .btn-flat-primary:active,  .btn-flat-primary.active,  .btn-flat-primary:focus {
      background-color: rgba(17, 74, 159, 0.2);
    }
     .btn-flat-primary.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23114A9F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    
    .btn-relief-primary {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .btn-relief-primary {
      background-color: #114A9F;
      box-shadow: inset 0 -3px 0 0 rgba(34, 41, 47, 0.2);
    }
     .btn-relief-primary:hover:not(.disabled):not(:disabled) {
      background-color: #1355b6;
    }
     .btn-relief-primary:active,  .btn-relief-primary.active,  .btn-relief-primary:focus {
      background-color: #0f3f88;
    }
    .btn-relief-primary:hover {
      color: #fff;
    }
    .btn-relief-primary:active, .btn-relief-primary.active {
      outline: none;
    }
     .btn-relief-primary:active,  .btn-relief-primary.active {
      box-shadow: none;
      transform: translateY(3px);
    }
    
    .btn-outline-primary {
      color: #114A9F;
    }
    
     .btn-outline-primary {
      border: 1px solid #114A9F !important;
      background-color: transparent;
    }
    .btn-outline-primary:hover:not(.disabled):not(:disabled) {
      color: #114A9F;
    }
     .btn-outline-primary:hover:not(.disabled):not(:disabled) {
      background-color: rgba(17, 74, 159, 0.04);
    }
     .btn-outline-primary:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .btn-outline-primary:not(:disabled):not(.disabled):focus {
      color: #114A9F;
    }
     .btn-outline-primary:not(:disabled):not(.disabled):active,  .btn-outline-primary:not(:disabled):not(.disabled).active,  .btn-outline-primary:not(:disabled):not(.disabled):focus {
      background-color: rgba(17, 74, 159, 0.2);
    }
     .btn-outline-primary.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23114A9F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .show > .btn-outline-primary.dropdown-toggle {
      color: #114A9F;
    }
     .show > .btn-outline-primary.dropdown-toggle {
      background-color: rgba(17, 74, 159, 0.2);
    }
    
     .btn-outline-primary.waves-effect .waves-ripple,  .btn-flat-primary.waves-effect .waves-ripple {
      background: radial-gradient(rgba(17, 74, 159, 0.2) 0, rgba(17, 74, 159, 0.3) 40%, rgba(17, 74, 159, 0.4) 50%, rgba(17, 74, 159, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
    }
    
     .bullet.bullet-primary {
      background-color: #114A9F;
    }
    
    .modal.modal-primary .modal-header .modal-title {
      color: #114A9F;
    }
    .modal.modal-primary .modal-header .close {
      color: #114A9F !important;
    }
    
    .pagination-primary .page-item.active .page-link {
      color: #fff;
    }
    
     .pagination-primary .page-item.active .page-link {
      background: #114A9F !important;
    }
    .pagination-primary .page-item.active .page-link:hover {
      color: #fff;
    }
    .pagination-primary .page-item .page-link:hover {
      color: #114A9F;
    }
    .pagination-primary .page-item.prev-item .page-link:hover, .pagination-primary .page-item.next-item .page-link:hover {
      color: #fff;
    }
     .pagination-primary .page-item.prev-item .page-link:hover,  .pagination-primary .page-item.next-item .page-link:hover {
      background: #114A9F;
    }
     .pagination-primary .page-item.next-item .page-link:active:after,  .pagination-primary .page-item.next-item .page-link:hover:after,  .pagination-primary .page-item.next .page-link:active:after,  .pagination-primary .page-item.next .page-link:hover:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23114A9F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
     .pagination-primary .page-item.prev-item .page-link:active:before,  .pagination-primary .page-item.prev-item .page-link:hover:before,  .pagination-primary .page-item.prev .page-link:active:before,  .pagination-primary .page-item.prev .page-link:hover:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23114A9F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
    
    .nav-pill-primary .nav-item .nav-link.active {
      color: #fff;
    }
    
     .nav-pill-primary .nav-item .nav-link.active {
      background-color: #114A9F !important;
      border-color: #114A9F;
      box-shadow: 0 4px 18px -4px rgba(17, 74, 159, 0.65);
    }
    
     .progress-bar-primary {
      background-color: rgba(17, 74, 159, 0.12);
    }
     .progress-bar-primary .progress-bar {
      background-color: #114A9F;
    }
    
     .timeline .timeline-point-primary {
      border-color: #114A9F !important;
    }
    .timeline .timeline-point-primary i,
    .timeline .timeline-point-primary svg {
      stroke: #114A9F !important;
    }
     .timeline .timeline-point-primary.timeline-point-indicator {
      background-color: #114A9F !important;
    }
     .timeline .timeline-point-primary.timeline-point-indicator:before {
      background: rgba(17, 74, 159, 0.12) !important;
    }
    
     .divider.divider-primary .divider-text:before,  .divider.divider-primary .divider-text:after {
      border-color: #114A9F !important;
    }
    
     input:focus ~ .bg-primary {
      box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #114A9F !important;
    }
    
     .custom-control-primary .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-primary .custom-control-input:active ~ .custom-control-label::before {
      border-color: #114A9F;
      background-color: #114A9F;
    }
     .custom-control-primary.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-primary.custom-checkbox .custom-control-input:active ~ .custom-control-label::before,  .custom-control-primary.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,  .custom-control-primary.custom-radio .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-primary.custom-radio .custom-control-input:active ~ .custom-control-label::before,  .custom-control-primary.custom-radio .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: 0 2px 4px 0 rgba(17, 74, 159, 0.4) !important;
    }
     .custom-control-primary .custom-control-input:disabled:checked ~ .custom-control-label::before {
      background-color: rgba(17, 74, 159, 0.65) !important;
      border: none;
      box-shadow: none !important;
    }
     .custom-control-primary .custom-control-input:focus ~ .custom-control-label::before {
      border-color: #114A9F;
    }
    
    .custom-switch-primary .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      transition: all 0.2s ease-out;
    }
    
     .custom-switch-primary .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #114A9F !important;
    }
    
     .select2-primary .select2-container--default .select2-selection--multiple .select2-selection__choice {
      background: #114A9F !important;
      border-color: #114A9F !important;
    }
    
    .text-primary.text-darken-1 {
      color: #0f3f88 !important;
    }
    
     .bg-primary.bg-darken-1 {
      background-color: #0f3f88 !important;
    }
    
     .border-primary.border-darken-1 {
      border: 1px solid #0f3f88 !important;
    }
    
     .border-top-primary.border-top-darken-1 {
      border-top: 1px solid #0f3f88 !important;
    }
    
     .border-bottom-primary.border-bottom-darken-1 {
      border-bottom: 1px solid #0f3f88 !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-darken-1 {
      border-left: 1px solid #0f3f88 !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-darken-1 {
      border-right: 1px solid #0f3f88 !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-darken-1 {
      border-right: 1px solid #0f3f88 !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-darken-1 {
      border-left: 1px solid #0f3f88 !important;
    }
    
    .overlay-primary.overlay-darken-1 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-darken-1 {
      background: #0f3f88;
      background: rgba(15, 63, 136, 0.6);
    }
    
    .text-primary.text-darken-2 {
      color: #0c3571 !important;
    }
    
     .bg-primary.bg-darken-2 {
      background-color: #0c3571 !important;
    }
    
     .border-primary.border-darken-2 {
      border: 1px solid #0c3571 !important;
    }
    
     .border-top-primary.border-top-darken-2 {
      border-top: 1px solid #0c3571 !important;
    }
    
     .border-bottom-primary.border-bottom-darken-2 {
      border-bottom: 1px solid #0c3571 !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-darken-2 {
      border-left: 1px solid #0c3571 !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-darken-2 {
      border-right: 1px solid #0c3571 !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-darken-2 {
      border-right: 1px solid #0c3571 !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-darken-2 {
      border-left: 1px solid #0c3571 !important;
    }
    
    .overlay-primary.overlay-darken-2 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-darken-2 {
      background: #0c3571;
      background: rgba(12, 53, 113, 0.6);
    }
    
    .text-primary.text-darken-3 {
      color: #0a2a5a !important;
    }
    
     .bg-primary.bg-darken-3 {
      background-color: #0a2a5a !important;
    }
    
     .border-primary.border-darken-3 {
      border: 1px solid #0a2a5a !important;
    }
    
     .border-top-primary.border-top-darken-3 {
      border-top: 1px solid #0a2a5a !important;
    }
    
     .border-bottom-primary.border-bottom-darken-3 {
      border-bottom: 1px solid #0a2a5a !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-darken-3 {
      border-left: 1px solid #0a2a5a !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-darken-3 {
      border-right: 1px solid #0a2a5a !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-darken-3 {
      border-right: 1px solid #0a2a5a !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-darken-3 {
      border-left: 1px solid #0a2a5a !important;
    }
    
    .overlay-primary.overlay-darken-3 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-darken-3 {
      background: #0a2a5a;
      background: rgba(10, 42, 90, 0.6);
    }
    
    .text-primary.text-darken-4 {
      color: #071f43 !important;
    }
    
     .bg-primary.bg-darken-4 {
      background-color: #071f43 !important;
    }
    
     .border-primary.border-darken-4 {
      border: 1px solid #071f43 !important;
    }
    
     .border-top-primary.border-top-darken-4 {
      border-top: 1px solid #071f43 !important;
    }
    
     .border-bottom-primary.border-bottom-darken-4 {
      border-bottom: 1px solid #071f43 !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-darken-4 {
      border-left: 1px solid #071f43 !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-darken-4 {
      border-right: 1px solid #071f43 !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-darken-4 {
      border-right: 1px solid #071f43 !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-darken-4 {
      border-left: 1px solid #071f43 !important;
    }
    
    .overlay-primary.overlay-darken-4 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-darken-4 {
      background: #071f43;
      background: rgba(7, 31, 67, 0.6);
    }
    
    .text-primary.text-accent-1 {
      color: #bdfdff !important;
    }
    
     .bg-primary.bg-accent-1 {
      background-color: #bdfdff !important;
    }
    
     .border-primary.border-accent-1 {
      border: 1px solid #bdfdff !important;
    }
    
     .border-top-primary.border-top-accent-1 {
      border-top: 1px solid #bdfdff !important;
    }
    
     .border-bottom-primary.border-bottom-accent-1 {
      border-bottom: 1px solid #bdfdff !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-accent-1 {
      border-left: 1px solid #bdfdff !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-accent-1 {
      border-right: 1px solid #bdfdff !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-accent-1 {
      border-right: 1px solid #bdfdff !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-accent-1 {
      border-left: 1px solid #bdfdff !important;
    }
    
    .overlay-primary.overlay-accent-1 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-accent-1 {
      background: #bdfdff;
      background: rgba(189, 253, 255, 0.6);
    }
    
    .text-primary.text-accent-2 {
      color: #8afbff !important;
    }
    
     .bg-primary.bg-accent-2 {
      background-color: #8afbff !important;
    }
    
     .border-primary.border-accent-2 {
      border: 1px solid #8afbff !important;
    }
    
     .border-top-primary.border-top-accent-2 {
      border-top: 1px solid #8afbff !important;
    }
    
     .border-bottom-primary.border-bottom-accent-2 {
      border-bottom: 1px solid #8afbff !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-accent-2 {
      border-left: 1px solid #8afbff !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-accent-2 {
      border-right: 1px solid #8afbff !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-accent-2 {
      border-right: 1px solid #8afbff !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-accent-2 {
      border-left: 1px solid #8afbff !important;
    }
    
    .overlay-primary.overlay-accent-2 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-accent-2 {
      background: #8afbff;
      background: rgba(138, 251, 255, 0.6);
    }
    
    .text-primary.text-accent-3 {
      color: #57faff !important;
    }
    
     .bg-primary.bg-accent-3 {
      background-color: #57faff !important;
    }
    
     .border-primary.border-accent-3 {
      border: 1px solid #57faff !important;
    }
    
     .border-top-primary.border-top-accent-3 {
      border-top: 1px solid #57faff !important;
    }
    
     .border-bottom-primary.border-bottom-accent-3 {
      border-bottom: 1px solid #57faff !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-accent-3 {
      border-left: 1px solid #57faff !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-accent-3 {
      border-right: 1px solid #57faff !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-accent-3 {
      border-right: 1px solid #57faff !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-accent-3 {
      border-left: 1px solid #57faff !important;
    }
    
    .overlay-primary.overlay-accent-3 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-accent-3 {
      background: #57faff;
      background: rgba(87, 250, 255, 0.6);
    }
    
    .text-primary.text-accent-4 {
      color: #3df9ff !important;
    }
    
     .bg-primary.bg-accent-4 {
      background-color: #3df9ff !important;
    }
    
     .border-primary.border-accent-4 {
      border: 1px solid #3df9ff !important;
    }
    
     .border-top-primary.border-top-accent-4 {
      border-top: 1px solid #3df9ff !important;
    }
    
     .border-bottom-primary.border-bottom-accent-4 {
      border-bottom: 1px solid #3df9ff !important;
    }
    
    [dir=ltr] .border-left-primary.border-left-accent-4 {
      border-left: 1px solid #3df9ff !important;
    }
    
    [dir=rtl] .border-left-primary.border-left-accent-4 {
      border-right: 1px solid #3df9ff !important;
    }
    
    [dir=ltr] .border-right-primary.border-right-accent-4 {
      border-right: 1px solid #3df9ff !important;
    }
    
    [dir=rtl] .border-right-primary.border-right-accent-4 {
      border-left: 1px solid #3df9ff !important;
    }
    
    .overlay-primary.overlay-accent-4 {
      /* The Fallback */
    }
    
     .overlay-primary.overlay-accent-4 {
      background: #3df9ff;
      background: rgba(61, 249, 255, 0.6);
    }
    
    .text-secondary.text-lighten-5 {
      color: #dedfe1 !important;
    }
    
     .bg-secondary.bg-lighten-5 {
      background-color: #dedfe1 !important;
    }
    
     .border-secondary.border-lighten-5 {
      border: 1px solid #dedfe1 !important;
    }
    
     .border-top-secondary.border-top-lighten-5 {
      border-top: 1px solid #dedfe1 !important;
    }
    
     .border-bottom-secondary.border-bottom-lighten-5 {
      border-bottom: 1px solid #dedfe1 !important;
    }
    
    [dir=ltr] .border-left-secondary.border-left-lighten-5 {
      border-left: 1px solid #dedfe1 !important;
    }
    
    [dir=rtl] .border-left-secondary.border-left-lighten-5 {
      border-right: 1px solid #dedfe1 !important;
    }
    
    [dir=ltr] .border-right-secondary.border-right-lighten-5 {
      border-right: 1px solid #dedfe1 !important;
    }
    
    [dir=rtl] .border-right-secondary.border-right-lighten-5 {
      border-left: 1px solid #dedfe1 !important;
    }
    
    .overlay-secondary.overlay-lighten-5 {
      /* The Fallback */
    }
    
     .overlay-secondary.overlay-lighten-5 {
      background: #dedfe1;
      background: rgba(222, 223, 225, 0.6);
    }
    
    .text-secondary.text-lighten-4 {
      color: #d1d2d5 !important;
    }
    
     .bg-secondary.bg-lighten-4 {
      background-color: #d1d2d5 !important;
    }
    
     .border-secondary.border-lighten-4 {
      border: 1px solid #d1d2d5 !important;
    }
    
     .border-top-secondary.border-top-lighten-4 {
      border-top: 1px solid #d1d2d5 !important;
    }
    
     .border-bottom-secondary.border-bottom-lighten-4 {
      border-bottom: 1px solid #d1d2d5 !important;
    }
    
    [dir=ltr] .border-left-secondary.border-left-lighten-4 {
      border-left: 1px solid #d1d2d5 !important;
    }
    
    [dir=rtl] .border-left-secondary.border-left-lighten-4 {
      border-right: 1px solid #d1d2d5 !important;
    }
    
    [dir=ltr] .border-right-secondary.border-right-lighten-4 {
      border-right: 1px solid #d1d2d5 !important;
    }
    
    [dir=rtl] .border-right-secondary.border-right-lighten-4 {
      border-left: 1px solid #d1d2d5 !important;
    }
    
    .overlay-secondary.overlay-lighten-4 {
      /* The Fallback */
    }
    
     .overlay-secondary.overlay-lighten-4 {
      background: #d1d2d5;
      background: rgba(209, 210, 213, 0.6);
    }
    
    .text-secondary.text-lighten-3 {
      color: #c4c5c9 !important;
    }
    
     .bg-secondary.bg-lighten-3 {
      background-color: #c4c5c9 !important;
    }
    
     .border-secondary.border-lighten-3 {
      border: 1px solid #c4c5c9 !important;
    }
    
     .border-top-secondary.border-top-lighten-3 {
      border-top: 1px solid #c4c5c9 !important;
    }
    
     .border-bottom-secondary.border-bottom-lighten-3 {
      border-bottom: 1px solid #c4c5c9 !important;
    }
    
    [dir=ltr] .border-left-secondary.border-left-lighten-3 {
      border-left: 1px solid #c4c5c9 !important;
    }
    
    [dir=rtl] .border-left-secondary.border-left-lighten-3 {
      border-right: 1px solid #c4c5c9 !important;
    }
    
    [dir=ltr] .border-right-secondary.border-right-lighten-3 {
      border-right: 1px solid #c4c5c9 !important;
    }
    
    [dir=rtl] .border-right-secondary.border-right-lighten-3 {
      border-left: 1px solid #c4c5c9 !important;
    }
    
    .overlay-secondary.overlay-lighten-3 {
      /* The Fallback */
    }
    
     .overlay-secondary.overlay-lighten-3 {
      background: #c4c5c9;
      background: rgba(196, 197, 201, 0.6);
    }
    
    .text-secondary.text-lighten-2 {
      color: #b7b8bc !important;
    }
    
     .bg-secondary.bg-lighten-2 {
      background-color: #b7b8bc !important;
    }
    
     .border-secondary.border-lighten-2 {
      border: 1px solid #b7b8bc !important;
    }
    
     .border-top-secondary.border-top-lighten-2 {
      border-top: 1px solid #b7b8bc !important;
    }
    
     .border-bottom-secondary.border-bottom-lighten-2 {
      border-bottom: 1px solid #b7b8bc !important;
    }
    
    [dir=ltr] .border-left-secondary.border-left-lighten-2 {
      border-left: 1px solid #b7b8bc !important;
    }
    
    [dir=rtl] .border-left-secondary.border-left-lighten-2 {
      border-right: 1px solid #b7b8bc !important;
    }
    
    [dir=ltr] .border-right-secondary.border-right-lighten-2 {
      border-right: 1px solid #b7b8bc !important;
    }
    
    [dir=rtl] .border-right-secondary.border-right-lighten-2 {
      border-left: 1px solid #b7b8bc !important;
    }
    
    .overlay-secondary.overlay-lighten-2 {
      /* The Fallback */
    }
    
     .overlay-secondary.overlay-lighten-2 {
      background: #b7b8bc;
      background: rgba(183, 184, 188, 0.6);
    }
    
    .text-secondary.text-lighten-1 {
      color: #a9abb0 !important;
    }
    
     .bg-secondary.bg-lighten-1 {
      background-color: #a9abb0 !important;
    }
    
     .border-secondary.border-lighten-1 {
      border: 1px solid #a9abb0 !important;
    }
    
     .border-top-secondary.border-top-lighten-1 {
      border-top: 1px solid #a9abb0 !important;
    }
    
     .border-bottom-secondary.border-bottom-lighten-1 {
      border-bottom: 1px solid #a9abb0 !important;
    }
    
    [dir=ltr] .border-left-secondary.border-left-lighten-1 {
      border-left: 1px solid #a9abb0 !important;
    }
    
    [dir=rtl] .border-left-secondary.border-left-lighten-1 {
      border-right: 1px solid #a9abb0 !important;
    }
    
    [dir=ltr] .border-right-secondary.border-right-lighten-1 {
      border-right: 1px solid #a9abb0 !important;
    }
    
    [dir=rtl] .border-right-secondary.border-right-lighten-1 {
      border-left: 1px solid #a9abb0 !important;
    }
    
    .overlay-secondary.overlay-lighten-1 {
      /* The Fallback */
    }
    
     .overlay-secondary.overlay-lighten-1 {
      background: #a9abb0;
      background: rgba(169, 171, 176, 0.6);
    }
    
     .bg-secondary {
      background-color: #9C9EA4 !important;
    }
     .bg-secondary .card-header,  .bg-secondary .card-footer {
      background-color: transparent;
    }
    
    .alert-secondary {
      color: #9C9EA4 !important;
    }
    
     .alert-secondary {
      background: rgba(156, 158, 164, 0.12) !important;
    }
     .alert-secondary .alert-heading {
      box-shadow: rgba(156, 158, 164, 0.4) 0px 6px 15px -7px;
    }
    .alert-secondary .alert-link {
      color: #8f9198 !important;
    }
    .alert-secondary .close {
      color: #9C9EA4 !important;
    }
    
    .bg-light-secondary {
      color: #9C9EA4 !important;
    }
    
     .bg-light-secondary {
      background: rgba(156, 158, 164, 0.12) !important;
    }
     .bg-light-secondary.fc-h-event,  .bg-light-secondary.fc-v-event {
      border-color: rgba(156, 158, 164, 0.1);
    }
     .bg-light-secondary .fc-list-event-dot {
      border-color: #9C9EA4 !important;
    }
     .bg-light-secondary.fc-list-event:hover td {
      background: rgba(156, 158, 164, 0.1) !important;
    }
    .bg-light-secondary.fc-list-event .fc-list-event-title {
      color: #424244;
    }
    
    .avatar.bg-light-secondary {
      color: #9C9EA4 !important;
    }
    
     .border-secondary {
      border: 1px solid #9C9EA4 !important;
    }
    
     .border-top-secondary {
      border-top: 1px solid #9C9EA4;
    }
    
     .border-bottom-secondary {
      border-bottom: 1px solid #9C9EA4;
    }
    
    [dir=ltr] .border-left-secondary {
      border-left: 1px solid #9C9EA4;
    }
    
    [dir=rtl] .border-left-secondary {
      border-right: 1px solid #9C9EA4;
    }
    
    [dir=ltr] .border-right-secondary {
      border-right: 1px solid #9C9EA4;
    }
    
    [dir=rtl] .border-right-secondary {
      border-left: 1px solid #9C9EA4;
    }
    
     .bg-secondary.badge-glow,  .border-secondary.badge-glow,  .badge-secondary.badge-glow {
      box-shadow: 0px 0px 10px #9C9EA4;
    }
    
    .badge.badge-light-secondary {
      color: #9C9EA4 !important;
    }
    
     .badge.badge-light-secondary {
      background-color: rgba(156, 158, 164, 0.12);
    }
    
    .overlay-secondary {
      /* The Fallback */
    }
    
     .overlay-secondary {
      background: #9C9EA4;
      background: rgba(156, 158, 164, 0.6);
    }
    
    .btn-secondary {
      color: #fff !important;
    }
    
     .btn-secondary {
      border-color: #9C9EA4 !important;
      background-color: #9C9EA4 !important;
    }
    .btn-secondary:focus, .btn-secondary:active, .btn-secondary.active {
      color: #fff;
    }
     .btn-secondary:focus,  .btn-secondary:active,  .btn-secondary.active {
      background-color: #8f9198 !important;
    }
     .btn-secondary:hover:not(.disabled):not(:disabled) {
      box-shadow: 0 8px 25px -8px #9c9ea4;
    }
     .btn-secondary:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    
    .btn-flat-secondary {
      color: #9C9EA4;
    }
    
     .btn-flat-secondary {
      background-color: transparent;
    }
    .btn-flat-secondary:hover {
      color: #9C9EA4;
    }
     .btn-flat-secondary:hover:not(.disabled):not(:disabled) {
      background-color: rgba(156, 158, 164, 0.12);
    }
    .btn-flat-secondary:active, .btn-flat-secondary.active, .btn-flat-secondary:focus {
      color: #9C9EA4;
    }
     .btn-flat-secondary:active,  .btn-flat-secondary.active,  .btn-flat-secondary:focus {
      background-color: rgba(156, 158, 164, 0.2);
    }
     .btn-flat-secondary.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%239C9EA4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    
    .btn-relief-secondary {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .btn-relief-secondary {
      background-color: #9C9EA4;
      box-shadow: inset 0 -3px 0 0 rgba(34, 41, 47, 0.2);
    }
     .btn-relief-secondary:hover:not(.disabled):not(:disabled) {
      background-color: #a9abb0;
    }
     .btn-relief-secondary:active,  .btn-relief-secondary.active,  .btn-relief-secondary:focus {
      background-color: #8f9198;
    }
    .btn-relief-secondary:hover {
      color: #fff;
    }
    .btn-relief-secondary:active, .btn-relief-secondary.active {
      outline: none;
    }
     .btn-relief-secondary:active,  .btn-relief-secondary.active {
      box-shadow: none;
      transform: translateY(3px);
    }
    
    .btn-outline-secondary {
      color: #9C9EA4;
    }
    
     .btn-outline-secondary {
      border: 1px solid #9C9EA4 !important;
      background-color: transparent;
    }
    .btn-outline-secondary:hover:not(.disabled):not(:disabled) {
      color: #9C9EA4;
    }
     .btn-outline-secondary:hover:not(.disabled):not(:disabled) {
      background-color: rgba(156, 158, 164, 0.04);
    }
     .btn-outline-secondary:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .btn-outline-secondary:not(:disabled):not(.disabled):focus {
      color: #9C9EA4;
    }
     .btn-outline-secondary:not(:disabled):not(.disabled):active,  .btn-outline-secondary:not(:disabled):not(.disabled).active,  .btn-outline-secondary:not(:disabled):not(.disabled):focus {
      background-color: rgba(156, 158, 164, 0.2);
    }
     .btn-outline-secondary.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%239C9EA4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .show > .btn-outline-secondary.dropdown-toggle {
      color: #9C9EA4;
    }
     .show > .btn-outline-secondary.dropdown-toggle {
      background-color: rgba(156, 158, 164, 0.2);
    }
    
     .btn-outline-secondary.waves-effect .waves-ripple,  .btn-flat-secondary.waves-effect .waves-ripple {
      background: radial-gradient(rgba(156, 158, 164, 0.2) 0, rgba(156, 158, 164, 0.3) 40%, rgba(156, 158, 164, 0.4) 50%, rgba(156, 158, 164, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
    }
    
     .bullet.bullet-secondary {
      background-color: #9C9EA4;
    }
    
    .modal.modal-secondary .modal-header .modal-title {
      color: #9C9EA4;
    }
    .modal.modal-secondary .modal-header .close {
      color: #9C9EA4 !important;
    }
    
    .pagination-secondary .page-item.active .page-link {
      color: #fff;
    }
    
     .pagination-secondary .page-item.active .page-link {
      background: #9C9EA4 !important;
    }
    .pagination-secondary .page-item.active .page-link:hover {
      color: #fff;
    }
    .pagination-secondary .page-item .page-link:hover {
      color: #9C9EA4;
    }
    .pagination-secondary .page-item.prev-item .page-link:hover, .pagination-secondary .page-item.next-item .page-link:hover {
      color: #fff;
    }
     .pagination-secondary .page-item.prev-item .page-link:hover,  .pagination-secondary .page-item.next-item .page-link:hover {
      background: #9C9EA4;
    }
     .pagination-secondary .page-item.next-item .page-link:active:after,  .pagination-secondary .page-item.next-item .page-link:hover:after,  .pagination-secondary .page-item.next .page-link:active:after,  .pagination-secondary .page-item.next .page-link:hover:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%239C9EA4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
     .pagination-secondary .page-item.prev-item .page-link:active:before,  .pagination-secondary .page-item.prev-item .page-link:hover:before,  .pagination-secondary .page-item.prev .page-link:active:before,  .pagination-secondary .page-item.prev .page-link:hover:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%239C9EA4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
    
    .nav-pill-secondary .nav-item .nav-link.active {
      color: #fff;
    }
    
     .nav-pill-secondary .nav-item .nav-link.active {
      background-color: #9C9EA4 !important;
      border-color: #9C9EA4;
      box-shadow: 0 4px 18px -4px rgba(156, 158, 164, 0.65);
    }
    
     .progress-bar-secondary {
      background-color: rgba(156, 158, 164, 0.12);
    }
     .progress-bar-secondary .progress-bar {
      background-color: #9C9EA4;
    }
    
     .timeline .timeline-point-secondary {
      border-color: #9C9EA4 !important;
    }
    .timeline .timeline-point-secondary i,
    .timeline .timeline-point-secondary svg {
      stroke: #9C9EA4 !important;
    }
     .timeline .timeline-point-secondary.timeline-point-indicator {
      background-color: #9C9EA4 !important;
    }
     .timeline .timeline-point-secondary.timeline-point-indicator:before {
      background: rgba(156, 158, 164, 0.12) !important;
    }
    
     .divider.divider-secondary .divider-text:before,  .divider.divider-secondary .divider-text:after {
      border-color: #9C9EA4 !important;
    }
    
     input:focus ~ .bg-secondary {
      box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #9C9EA4 !important;
    }
    
     .custom-control-secondary .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-secondary .custom-control-input:active ~ .custom-control-label::before {
      border-color: #9C9EA4;
      background-color: #9C9EA4;
    }
     .custom-control-secondary.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-secondary.custom-checkbox .custom-control-input:active ~ .custom-control-label::before,  .custom-control-secondary.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,  .custom-control-secondary.custom-radio .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-secondary.custom-radio .custom-control-input:active ~ .custom-control-label::before,  .custom-control-secondary.custom-radio .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: 0 2px 4px 0 rgba(156, 158, 164, 0.4) !important;
    }
     .custom-control-secondary .custom-control-input:disabled:checked ~ .custom-control-label::before {
      background-color: rgba(156, 158, 164, 0.65) !important;
      border: none;
      box-shadow: none !important;
    }
     .custom-control-secondary .custom-control-input:focus ~ .custom-control-label::before {
      border-color: #9C9EA4;
    }
    
    .custom-switch-secondary .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      transition: all 0.2s ease-out;
    }
    
     .custom-switch-secondary .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #9C9EA4 !important;
    }
    
     .select2-secondary .select2-container--default .select2-selection--multiple .select2-selection__choice {
      background: #9C9EA4 !important;
      border-color: #9C9EA4 !important;
    }
    
    .text-secondary.text-darken-1 {
      color: #8f9198 !important;
    }
    
     .bg-secondary.bg-darken-1 {
      background-color: #8f9198 !important;
    }
    
     .border-secondary.border-darken-1 {
      border: 1px solid #8f9198 !important;
    }
    
     .border-top-secondary.border-top-darken-1 {
      border-top: 1px solid #8f9198 !important;
    }
    
     .border-bottom-secondary.border-bottom-darken-1 {
      border-bottom: 1px solid #8f9198 !important;
    }
    
    [dir=ltr] .border-left-secondary.border-left-darken-1 {
      border-left: 1px solid #8f9198 !important;
    }
    
    [dir=rtl] .border-left-secondary.border-left-darken-1 {
      border-right: 1px solid #8f9198 !important;
    }
    
    [dir=ltr] .border-right-secondary.border-right-darken-1 {
      border-right: 1px solid #8f9198 !important;
    }
    
    [dir=rtl] .border-right-secondary.border-right-darken-1 {
      border-left: 1px solid #8f9198 !important;
    }
    
    .overlay-secondary.overlay-darken-1 {
      /* The Fallback */
    }
    
     .overlay-secondary.overlay-darken-1 {
      background: #8f9198;
      background: rgba(143, 145, 152, 0.6);
    }
    
    .text-secondary.text-darken-2 {
      color: #81848c !important;
    }
    
     .bg-secondary.bg-darken-2 {
      background-color: #81848c !important;
    }
    
     .border-secondary.border-darken-2 {
      border: 1px solid #81848c !important;
    }
    
     .border-top-secondary.border-top-darken-2 {
      border-top: 1px solid #81848c !important;
    }
    
     .border-bottom-secondary.border-bottom-darken-2 {
      border-bottom: 1px solid #81848c !important;
    }
    
    [dir=ltr] .border-left-secondary.border-left-darken-2 {
      border-left: 1px solid #81848c !important;
    }
    
    [dir=rtl] .border-left-secondary.border-left-darken-2 {
      border-right: 1px solid #81848c !important;
    }
    
    [dir=ltr] .border-right-secondary.border-right-darken-2 {
      border-right: 1px solid #81848c !important;
    }
    
    [dir=rtl] .border-right-secondary.border-right-darken-2 {
      border-left: 1px solid #81848c !important;
    }
    
    .overlay-secondary.overlay-darken-2 {
      /* The Fallback */
    }
    
     .overlay-secondary.overlay-darken-2 {
      background: #81848c;
      background: rgba(129, 132, 140, 0.6);
    }
    
    .text-secondary.text-darken-3 {
      color: #75777f !important;
    }
    
     .bg-secondary.bg-darken-3 {
      background-color: #75777f !important;
    }
    
     .border-secondary.border-darken-3 {
      border: 1px solid #75777f !important;
    }
    
     .border-top-secondary.border-top-darken-3 {
      border-top: 1px solid #75777f !important;
    }
    
     .border-bottom-secondary.border-bottom-darken-3 {
      border-bottom: 1px solid #75777f !important;
    }
    
    [dir=ltr] .border-left-secondary.border-left-darken-3 {
      border-left: 1px solid #75777f !important;
    }
    
    [dir=rtl] .border-left-secondary.border-left-darken-3 {
      border-right: 1px solid #75777f !important;
    }
    
    [dir=ltr] .border-right-secondary.border-right-darken-3 {
      border-right: 1px solid #75777f !important;
    }
    
    [dir=rtl] .border-right-secondary.border-right-darken-3 {
      border-left: 1px solid #75777f !important;
    }
    
    .overlay-secondary.overlay-darken-3 {
      /* The Fallback */
    }
    
     .overlay-secondary.overlay-darken-3 {
      background: #75777f;
      background: rgba(117, 119, 127, 0.6);
    }
    
    .text-secondary.text-darken-4 {
      color: #686b72 !important;
    }
    
     .bg-secondary.bg-darken-4 {
      background-color: #686b72 !important;
    }
    
     .border-secondary.border-darken-4 {
      border: 1px solid #686b72 !important;
    }
    
     .border-top-secondary.border-top-darken-4 {
      border-top: 1px solid #686b72 !important;
    }
    
     .border-bottom-secondary.border-bottom-darken-4 {
      border-bottom: 1px solid #686b72 !important;
    }
    
    [dir=ltr] .border-left-secondary.border-left-darken-4 {
      border-left: 1px solid #686b72 !important;
    }
    
    [dir=rtl] .border-left-secondary.border-left-darken-4 {
      border-right: 1px solid #686b72 !important;
    }
    
    [dir=ltr] .border-right-secondary.border-right-darken-4 {
      border-right: 1px solid #686b72 !important;
    }
    
    [dir=rtl] .border-right-secondary.border-right-darken-4 {
      border-left: 1px solid #686b72 !important;
    }
    
    .overlay-secondary.overlay-darken-4 {
      /* The Fallback */
    }
    
     .overlay-secondary.overlay-darken-4 {
      background: #686b72;
      background: rgba(104, 107, 114, 0.6);
    }
    
    .text-success.text-lighten-5 {
      color: #62eb9f !important;
    }
    
     .bg-success.bg-lighten-5 {
      background-color: #62eb9f !important;
    }
    
     .border-success.border-lighten-5 {
      border: 1px solid #62eb9f !important;
    }
    
     .border-top-success.border-top-lighten-5 {
      border-top: 1px solid #62eb9f !important;
    }
    
     .border-bottom-success.border-bottom-lighten-5 {
      border-bottom: 1px solid #62eb9f !important;
    }
    
    [dir=ltr] .border-left-success.border-left-lighten-5 {
      border-left: 1px solid #62eb9f !important;
    }
    
    [dir=rtl] .border-left-success.border-left-lighten-5 {
      border-right: 1px solid #62eb9f !important;
    }
    
    [dir=ltr] .border-right-success.border-right-lighten-5 {
      border-right: 1px solid #62eb9f !important;
    }
    
    [dir=rtl] .border-right-success.border-right-lighten-5 {
      border-left: 1px solid #62eb9f !important;
    }
    
    .overlay-success.overlay-lighten-5 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-lighten-5 {
      background: #62eb9f;
      background: rgba(98, 235, 159, 0.6);
    }
    
    .text-success.text-lighten-4 {
      color: #4ce891 !important;
    }
    
     .bg-success.bg-lighten-4 {
      background-color: #4ce891 !important;
    }
    
     .border-success.border-lighten-4 {
      border: 1px solid #4ce891 !important;
    }
    
     .border-top-success.border-top-lighten-4 {
      border-top: 1px solid #4ce891 !important;
    }
    
     .border-bottom-success.border-bottom-lighten-4 {
      border-bottom: 1px solid #4ce891 !important;
    }
    
    [dir=ltr] .border-left-success.border-left-lighten-4 {
      border-left: 1px solid #4ce891 !important;
    }
    
    [dir=rtl] .border-left-success.border-left-lighten-4 {
      border-right: 1px solid #4ce891 !important;
    }
    
    [dir=ltr] .border-right-success.border-right-lighten-4 {
      border-right: 1px solid #4ce891 !important;
    }
    
    [dir=rtl] .border-right-success.border-right-lighten-4 {
      border-left: 1px solid #4ce891 !important;
    }
    
    .overlay-success.overlay-lighten-4 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-lighten-4 {
      background: #4ce891;
      background: rgba(76, 232, 145, 0.6);
    }
    
    .text-success.text-lighten-3 {
      color: #35e683 !important;
    }
    
     .bg-success.bg-lighten-3 {
      background-color: #35e683 !important;
    }
    
     .border-success.border-lighten-3 {
      border: 1px solid #35e683 !important;
    }
    
     .border-top-success.border-top-lighten-3 {
      border-top: 1px solid #35e683 !important;
    }
    
     .border-bottom-success.border-bottom-lighten-3 {
      border-bottom: 1px solid #35e683 !important;
    }
    
    [dir=ltr] .border-left-success.border-left-lighten-3 {
      border-left: 1px solid #35e683 !important;
    }
    
    [dir=rtl] .border-left-success.border-left-lighten-3 {
      border-right: 1px solid #35e683 !important;
    }
    
    [dir=ltr] .border-right-success.border-right-lighten-3 {
      border-right: 1px solid #35e683 !important;
    }
    
    [dir=rtl] .border-right-success.border-right-lighten-3 {
      border-left: 1px solid #35e683 !important;
    }
    
    .overlay-success.overlay-lighten-3 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-lighten-3 {
      background: #35e683;
      background: rgba(53, 230, 131, 0.6);
    }
    
    .text-success.text-lighten-2 {
      color: #1ee375 !important;
    }
    
     .bg-success.bg-lighten-2 {
      background-color: #1ee375 !important;
    }
    
     .border-success.border-lighten-2 {
      border: 1px solid #1ee375 !important;
    }
    
     .border-top-success.border-top-lighten-2 {
      border-top: 1px solid #1ee375 !important;
    }
    
     .border-bottom-success.border-bottom-lighten-2 {
      border-bottom: 1px solid #1ee375 !important;
    }
    
    [dir=ltr] .border-left-success.border-left-lighten-2 {
      border-left: 1px solid #1ee375 !important;
    }
    
    [dir=rtl] .border-left-success.border-left-lighten-2 {
      border-right: 1px solid #1ee375 !important;
    }
    
    [dir=ltr] .border-right-success.border-right-lighten-2 {
      border-right: 1px solid #1ee375 !important;
    }
    
    [dir=rtl] .border-right-success.border-right-lighten-2 {
      border-left: 1px solid #1ee375 !important;
    }
    
    .overlay-success.overlay-lighten-2 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-lighten-2 {
      background: #1ee375;
      background: rgba(30, 227, 117, 0.6);
    }
    
    .text-success.text-lighten-1 {
      color: #1ace6a !important;
    }
    
     .bg-success.bg-lighten-1 {
      background-color: #1ace6a !important;
    }
    
     .border-success.border-lighten-1 {
      border: 1px solid #1ace6a !important;
    }
    
     .border-top-success.border-top-lighten-1 {
      border-top: 1px solid #1ace6a !important;
    }
    
     .border-bottom-success.border-bottom-lighten-1 {
      border-bottom: 1px solid #1ace6a !important;
    }
    
    [dir=ltr] .border-left-success.border-left-lighten-1 {
      border-left: 1px solid #1ace6a !important;
    }
    
    [dir=rtl] .border-left-success.border-left-lighten-1 {
      border-right: 1px solid #1ace6a !important;
    }
    
    [dir=ltr] .border-right-success.border-right-lighten-1 {
      border-right: 1px solid #1ace6a !important;
    }
    
    [dir=rtl] .border-right-success.border-right-lighten-1 {
      border-left: 1px solid #1ace6a !important;
    }
    
    .overlay-success.overlay-lighten-1 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-lighten-1 {
      background: #1ace6a;
      background: rgba(26, 206, 106, 0.6);
    }
    
     .bg-success {
      background-color: #17B75E !important;
    }
     .bg-success .card-header,  .bg-success .card-footer {
      background-color: transparent;
    }
    
    .alert-success {
      color: #17B75E !important;
    }
    
     .alert-success {
      background: rgba(23, 183, 94, 0.12) !important;
    }
     .alert-success .alert-heading {
      box-shadow: rgba(23, 183, 94, 0.4) 0px 6px 15px -7px;
    }
    .alert-success .alert-link {
      color: #14a052 !important;
    }
    .alert-success .close {
      color: #17B75E !important;
    }
    
    .bg-light-success {
      color: #17B75E !important;
    }
    
     .bg-light-success {
      background: rgba(23, 183, 94, 0.12) !important;
    }
     .bg-light-success.fc-h-event,  .bg-light-success.fc-v-event {
      border-color: rgba(23, 183, 94, 0.1);
    }
     .bg-light-success .fc-list-event-dot {
      border-color: #17B75E !important;
    }
     .bg-light-success.fc-list-event:hover td {
      background: rgba(23, 183, 94, 0.1) !important;
    }
    .bg-light-success.fc-list-event .fc-list-event-title {
      color: #424244;
    }
    
    .avatar.bg-light-success {
      color: #17B75E !important;
    }
    
     .border-success {
      border: 1px solid #17B75E !important;
    }
    
     .border-top-success {
      border-top: 1px solid #17B75E;
    }
    
     .border-bottom-success {
      border-bottom: 1px solid #17B75E;
    }
    
    [dir=ltr] .border-left-success {
      border-left: 1px solid #17B75E;
    }
    
    [dir=rtl] .border-left-success {
      border-right: 1px solid #17B75E;
    }
    
    [dir=ltr] .border-right-success {
      border-right: 1px solid #17B75E;
    }
    
    [dir=rtl] .border-right-success {
      border-left: 1px solid #17B75E;
    }
    
     .bg-success.badge-glow,  .border-success.badge-glow,  .badge-success.badge-glow {
      box-shadow: 0px 0px 10px #17B75E;
    }
    
    .badge.badge-light-success {
      color: #17B75E !important;
    }
    
     .badge.badge-light-success {
      background-color: rgba(23, 183, 94, 0.12);
    }
    
    .overlay-success {
      /* The Fallback */
    }
    
     .overlay-success {
      background: #17B75E;
      background: rgba(23, 183, 94, 0.6);
    }
    
    .btn-success {
      color: #fff !important;
    }
    
     .btn-success {
      border-color: #17B75E !important;
      background-color: #17B75E !important;
    }
    .btn-success:focus, .btn-success:active, .btn-success.active {
      color: #fff;
    }
     .btn-success:focus,  .btn-success:active,  .btn-success.active {
      background-color: #14a052 !important;
    }
     .btn-success:hover:not(.disabled):not(:disabled) {
      box-shadow: 0 8px 25px -8px #17b75e;
    }
     .btn-success:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    
    .btn-flat-success {
      color: #17B75E;
    }
    
     .btn-flat-success {
      background-color: transparent;
    }
    .btn-flat-success:hover {
      color: #17B75E;
    }
     .btn-flat-success:hover:not(.disabled):not(:disabled) {
      background-color: rgba(23, 183, 94, 0.12);
    }
    .btn-flat-success:active, .btn-flat-success.active, .btn-flat-success:focus {
      color: #17B75E;
    }
     .btn-flat-success:active,  .btn-flat-success.active,  .btn-flat-success:focus {
      background-color: rgba(23, 183, 94, 0.2);
    }
     .btn-flat-success.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2317B75E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    
    .btn-relief-success {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .btn-relief-success {
      background-color: #17B75E;
      box-shadow: inset 0 -3px 0 0 rgba(34, 41, 47, 0.2);
    }
     .btn-relief-success:hover:not(.disabled):not(:disabled) {
      background-color: #1ace6a;
    }
     .btn-relief-success:active,  .btn-relief-success.active,  .btn-relief-success:focus {
      background-color: #14a052;
    }
    .btn-relief-success:hover {
      color: #fff;
    }
    .btn-relief-success:active, .btn-relief-success.active {
      outline: none;
    }
     .btn-relief-success:active,  .btn-relief-success.active {
      box-shadow: none;
      transform: translateY(3px);
    }
    
    .btn-outline-success {
      color: #17B75E;
    }
    
     .btn-outline-success {
      border: 1px solid #17B75E !important;
      background-color: transparent;
    }
    .btn-outline-success:hover:not(.disabled):not(:disabled) {
      color: #17B75E;
    }
     .btn-outline-success:hover:not(.disabled):not(:disabled) {
      background-color: rgba(23, 183, 94, 0.04);
    }
     .btn-outline-success:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .btn-outline-success:not(:disabled):not(.disabled):focus {
      color: #17B75E;
    }
     .btn-outline-success:not(:disabled):not(.disabled):active,  .btn-outline-success:not(:disabled):not(.disabled).active,  .btn-outline-success:not(:disabled):not(.disabled):focus {
      background-color: rgba(23, 183, 94, 0.2);
    }
     .btn-outline-success.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2317B75E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .show > .btn-outline-success.dropdown-toggle {
      color: #17B75E;
    }
     .show > .btn-outline-success.dropdown-toggle {
      background-color: rgba(23, 183, 94, 0.2);
    }
    
     .btn-outline-success.waves-effect .waves-ripple,  .btn-flat-success.waves-effect .waves-ripple {
      background: radial-gradient(rgba(23, 183, 94, 0.2) 0, rgba(23, 183, 94, 0.3) 40%, rgba(23, 183, 94, 0.4) 50%, rgba(23, 183, 94, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
    }
    
     .bullet.bullet-success {
      background-color: #17B75E;
    }
    
    .modal.modal-success .modal-header .modal-title {
      color: #17B75E;
    }
    .modal.modal-success .modal-header .close {
      color: #17B75E !important;
    }
    
    .pagination-success .page-item.active .page-link {
      color: #fff;
    }
    
     .pagination-success .page-item.active .page-link {
      background: #17B75E !important;
    }
    .pagination-success .page-item.active .page-link:hover {
      color: #fff;
    }
    .pagination-success .page-item .page-link:hover {
      color: #17B75E;
    }
    .pagination-success .page-item.prev-item .page-link:hover, .pagination-success .page-item.next-item .page-link:hover {
      color: #fff;
    }
     .pagination-success .page-item.prev-item .page-link:hover,  .pagination-success .page-item.next-item .page-link:hover {
      background: #17B75E;
    }
     .pagination-success .page-item.next-item .page-link:active:after,  .pagination-success .page-item.next-item .page-link:hover:after,  .pagination-success .page-item.next .page-link:active:after,  .pagination-success .page-item.next .page-link:hover:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2317B75E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
     .pagination-success .page-item.prev-item .page-link:active:before,  .pagination-success .page-item.prev-item .page-link:hover:before,  .pagination-success .page-item.prev .page-link:active:before,  .pagination-success .page-item.prev .page-link:hover:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2317B75E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
    
    .nav-pill-success .nav-item .nav-link.active {
      color: #fff;
    }
    
     .nav-pill-success .nav-item .nav-link.active {
      background-color: #17B75E !important;
      border-color: #17B75E;
      box-shadow: 0 4px 18px -4px rgba(23, 183, 94, 0.65);
    }
    
     .progress-bar-success {
      background-color: rgba(23, 183, 94, 0.12);
    }
     .progress-bar-success .progress-bar {
      background-color: #17B75E;
    }
    
     .timeline .timeline-point-success {
      border-color: #17B75E !important;
    }
    .timeline .timeline-point-success i,
    .timeline .timeline-point-success svg {
      stroke: #17B75E !important;
    }
     .timeline .timeline-point-success.timeline-point-indicator {
      background-color: #17B75E !important;
    }
     .timeline .timeline-point-success.timeline-point-indicator:before {
      background: rgba(23, 183, 94, 0.12) !important;
    }
    
     .divider.divider-success .divider-text:before,  .divider.divider-success .divider-text:after {
      border-color: #17B75E !important;
    }
    
     input:focus ~ .bg-success {
      box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #17B75E !important;
    }
    
     .custom-control-success .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-success .custom-control-input:active ~ .custom-control-label::before {
      border-color: #17B75E;
      background-color: #17B75E;
    }
     .custom-control-success.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-success.custom-checkbox .custom-control-input:active ~ .custom-control-label::before,  .custom-control-success.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,  .custom-control-success.custom-radio .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-success.custom-radio .custom-control-input:active ~ .custom-control-label::before,  .custom-control-success.custom-radio .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: 0 2px 4px 0 rgba(23, 183, 94, 0.4) !important;
    }
     .custom-control-success .custom-control-input:disabled:checked ~ .custom-control-label::before {
      background-color: rgba(23, 183, 94, 0.65) !important;
      border: none;
      box-shadow: none !important;
    }
     .custom-control-success .custom-control-input:focus ~ .custom-control-label::before {
      border-color: #17B75E;
    }
    
    .custom-switch-success .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      transition: all 0.2s ease-out;
    }
    
     .custom-switch-success .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #17B75E !important;
    }
    
     .select2-success .select2-container--default .select2-selection--multiple .select2-selection__choice {
      background: #17B75E !important;
      border-color: #17B75E !important;
    }
    
    .text-success.text-darken-1 {
      color: #14a052 !important;
    }
    
     .bg-success.bg-darken-1 {
      background-color: #14a052 !important;
    }
    
     .border-success.border-darken-1 {
      border: 1px solid #14a052 !important;
    }
    
     .border-top-success.border-top-darken-1 {
      border-top: 1px solid #14a052 !important;
    }
    
     .border-bottom-success.border-bottom-darken-1 {
      border-bottom: 1px solid #14a052 !important;
    }
    
    [dir=ltr] .border-left-success.border-left-darken-1 {
      border-left: 1px solid #14a052 !important;
    }
    
    [dir=rtl] .border-left-success.border-left-darken-1 {
      border-right: 1px solid #14a052 !important;
    }
    
    [dir=ltr] .border-right-success.border-right-darken-1 {
      border-right: 1px solid #14a052 !important;
    }
    
    [dir=rtl] .border-right-success.border-right-darken-1 {
      border-left: 1px solid #14a052 !important;
    }
    
    .overlay-success.overlay-darken-1 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-darken-1 {
      background: #14a052;
      background: rgba(20, 160, 82, 0.6);
    }
    
    .text-success.text-darken-2 {
      color: #118a47 !important;
    }
    
     .bg-success.bg-darken-2 {
      background-color: #118a47 !important;
    }
    
     .border-success.border-darken-2 {
      border: 1px solid #118a47 !important;
    }
    
     .border-top-success.border-top-darken-2 {
      border-top: 1px solid #118a47 !important;
    }
    
     .border-bottom-success.border-bottom-darken-2 {
      border-bottom: 1px solid #118a47 !important;
    }
    
    [dir=ltr] .border-left-success.border-left-darken-2 {
      border-left: 1px solid #118a47 !important;
    }
    
    [dir=rtl] .border-left-success.border-left-darken-2 {
      border-right: 1px solid #118a47 !important;
    }
    
    [dir=ltr] .border-right-success.border-right-darken-2 {
      border-right: 1px solid #118a47 !important;
    }
    
    [dir=rtl] .border-right-success.border-right-darken-2 {
      border-left: 1px solid #118a47 !important;
    }
    
    .overlay-success.overlay-darken-2 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-darken-2 {
      background: #118a47;
      background: rgba(17, 138, 71, 0.6);
    }
    
    .text-success.text-darken-3 {
      color: #0e733b !important;
    }
    
     .bg-success.bg-darken-3 {
      background-color: #0e733b !important;
    }
    
     .border-success.border-darken-3 {
      border: 1px solid #0e733b !important;
    }
    
     .border-top-success.border-top-darken-3 {
      border-top: 1px solid #0e733b !important;
    }
    
     .border-bottom-success.border-bottom-darken-3 {
      border-bottom: 1px solid #0e733b !important;
    }
    
    [dir=ltr] .border-left-success.border-left-darken-3 {
      border-left: 1px solid #0e733b !important;
    }
    
    [dir=rtl] .border-left-success.border-left-darken-3 {
      border-right: 1px solid #0e733b !important;
    }
    
    [dir=ltr] .border-right-success.border-right-darken-3 {
      border-right: 1px solid #0e733b !important;
    }
    
    [dir=rtl] .border-right-success.border-right-darken-3 {
      border-left: 1px solid #0e733b !important;
    }
    
    .overlay-success.overlay-darken-3 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-darken-3 {
      background: #0e733b;
      background: rgba(14, 115, 59, 0.6);
    }
    
    .text-success.text-darken-4 {
      color: #0c5c2f !important;
    }
    
     .bg-success.bg-darken-4 {
      background-color: #0c5c2f !important;
    }
    
     .border-success.border-darken-4 {
      border: 1px solid #0c5c2f !important;
    }
    
     .border-top-success.border-top-darken-4 {
      border-top: 1px solid #0c5c2f !important;
    }
    
     .border-bottom-success.border-bottom-darken-4 {
      border-bottom: 1px solid #0c5c2f !important;
    }
    
    [dir=ltr] .border-left-success.border-left-darken-4 {
      border-left: 1px solid #0c5c2f !important;
    }
    
    [dir=rtl] .border-left-success.border-left-darken-4 {
      border-right: 1px solid #0c5c2f !important;
    }
    
    [dir=ltr] .border-right-success.border-right-darken-4 {
      border-right: 1px solid #0c5c2f !important;
    }
    
    [dir=rtl] .border-right-success.border-right-darken-4 {
      border-left: 1px solid #0c5c2f !important;
    }
    
    .overlay-success.overlay-darken-4 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-darken-4 {
      background: #0c5c2f;
      background: rgba(12, 92, 47, 0.6);
    }
    
    .text-success.text-accent-1 {
      color: #e1fff1 !important;
    }
    
     .bg-success.bg-accent-1 {
      background-color: #e1fff1 !important;
    }
    
     .border-success.border-accent-1 {
      border: 1px solid #e1fff1 !important;
    }
    
     .border-top-success.border-top-accent-1 {
      border-top: 1px solid #e1fff1 !important;
    }
    
     .border-bottom-success.border-bottom-accent-1 {
      border-bottom: 1px solid #e1fff1 !important;
    }
    
    [dir=ltr] .border-left-success.border-left-accent-1 {
      border-left: 1px solid #e1fff1 !important;
    }
    
    [dir=rtl] .border-left-success.border-left-accent-1 {
      border-right: 1px solid #e1fff1 !important;
    }
    
    [dir=ltr] .border-right-success.border-right-accent-1 {
      border-right: 1px solid #e1fff1 !important;
    }
    
    [dir=rtl] .border-right-success.border-right-accent-1 {
      border-left: 1px solid #e1fff1 !important;
    }
    
    .overlay-success.overlay-accent-1 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-accent-1 {
      background: #e1fff1;
      background: rgba(225, 255, 241, 0.6);
    }
    
    .text-success.text-accent-2 {
      color: #aeffd9 !important;
    }
    
     .bg-success.bg-accent-2 {
      background-color: #aeffd9 !important;
    }
    
     .border-success.border-accent-2 {
      border: 1px solid #aeffd9 !important;
    }
    
     .border-top-success.border-top-accent-2 {
      border-top: 1px solid #aeffd9 !important;
    }
    
     .border-bottom-success.border-bottom-accent-2 {
      border-bottom: 1px solid #aeffd9 !important;
    }
    
    [dir=ltr] .border-left-success.border-left-accent-2 {
      border-left: 1px solid #aeffd9 !important;
    }
    
    [dir=rtl] .border-left-success.border-left-accent-2 {
      border-right: 1px solid #aeffd9 !important;
    }
    
    [dir=ltr] .border-right-success.border-right-accent-2 {
      border-right: 1px solid #aeffd9 !important;
    }
    
    [dir=rtl] .border-right-success.border-right-accent-2 {
      border-left: 1px solid #aeffd9 !important;
    }
    
    .overlay-success.overlay-accent-2 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-accent-2 {
      background: #aeffd9;
      background: rgba(174, 255, 217, 0.6);
    }
    
    .text-success.text-accent-3 {
      color: #7bffc1 !important;
    }
    
     .bg-success.bg-accent-3 {
      background-color: #7bffc1 !important;
    }
    
     .border-success.border-accent-3 {
      border: 1px solid #7bffc1 !important;
    }
    
     .border-top-success.border-top-accent-3 {
      border-top: 1px solid #7bffc1 !important;
    }
    
     .border-bottom-success.border-bottom-accent-3 {
      border-bottom: 1px solid #7bffc1 !important;
    }
    
    [dir=ltr] .border-left-success.border-left-accent-3 {
      border-left: 1px solid #7bffc1 !important;
    }
    
    [dir=rtl] .border-left-success.border-left-accent-3 {
      border-right: 1px solid #7bffc1 !important;
    }
    
    [dir=ltr] .border-right-success.border-right-accent-3 {
      border-right: 1px solid #7bffc1 !important;
    }
    
    [dir=rtl] .border-right-success.border-right-accent-3 {
      border-left: 1px solid #7bffc1 !important;
    }
    
    .overlay-success.overlay-accent-3 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-accent-3 {
      background: #7bffc1;
      background: rgba(123, 255, 193, 0.6);
    }
    
    .text-success.text-accent-4 {
      color: #62ffb5 !important;
    }
    
     .bg-success.bg-accent-4 {
      background-color: #62ffb5 !important;
    }
    
     .border-success.border-accent-4 {
      border: 1px solid #62ffb5 !important;
    }
    
     .border-top-success.border-top-accent-4 {
      border-top: 1px solid #62ffb5 !important;
    }
    
     .border-bottom-success.border-bottom-accent-4 {
      border-bottom: 1px solid #62ffb5 !important;
    }
    
    [dir=ltr] .border-left-success.border-left-accent-4 {
      border-left: 1px solid #62ffb5 !important;
    }
    
    [dir=rtl] .border-left-success.border-left-accent-4 {
      border-right: 1px solid #62ffb5 !important;
    }
    
    [dir=ltr] .border-right-success.border-right-accent-4 {
      border-right: 1px solid #62ffb5 !important;
    }
    
    [dir=rtl] .border-right-success.border-right-accent-4 {
      border-left: 1px solid #62ffb5 !important;
    }
    
    .overlay-success.overlay-accent-4 {
      /* The Fallback */
    }
    
     .overlay-success.overlay-accent-4 {
      background: #62ffb5;
      background: rgba(98, 255, 181, 0.6);
    }
    
    .text-info.text-lighten-5 {
      color: #69efff !important;
    }
    
     .bg-info.bg-lighten-5 {
      background-color: #69efff !important;
    }
    
     .border-info.border-lighten-5 {
      border: 1px solid #69efff !important;
    }
    
     .border-top-info.border-top-lighten-5 {
      border-top: 1px solid #69efff !important;
    }
    
     .border-bottom-info.border-bottom-lighten-5 {
      border-bottom: 1px solid #69efff !important;
    }
    
    [dir=ltr] .border-left-info.border-left-lighten-5 {
      border-left: 1px solid #69efff !important;
    }
    
    [dir=rtl] .border-left-info.border-left-lighten-5 {
      border-right: 1px solid #69efff !important;
    }
    
    [dir=ltr] .border-right-info.border-right-lighten-5 {
      border-right: 1px solid #69efff !important;
    }
    
    [dir=rtl] .border-right-info.border-right-lighten-5 {
      border-left: 1px solid #69efff !important;
    }
    
    .overlay-info.overlay-lighten-5 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-lighten-5 {
      background: #69efff;
      background: rgba(105, 239, 255, 0.6);
    }
    
    .text-info.text-lighten-4 {
      color: #4fecff !important;
    }
    
     .bg-info.bg-lighten-4 {
      background-color: #4fecff !important;
    }
    
     .border-info.border-lighten-4 {
      border: 1px solid #4fecff !important;
    }
    
     .border-top-info.border-top-lighten-4 {
      border-top: 1px solid #4fecff !important;
    }
    
     .border-bottom-info.border-bottom-lighten-4 {
      border-bottom: 1px solid #4fecff !important;
    }
    
    [dir=ltr] .border-left-info.border-left-lighten-4 {
      border-left: 1px solid #4fecff !important;
    }
    
    [dir=rtl] .border-left-info.border-left-lighten-4 {
      border-right: 1px solid #4fecff !important;
    }
    
    [dir=ltr] .border-right-info.border-right-lighten-4 {
      border-right: 1px solid #4fecff !important;
    }
    
    [dir=rtl] .border-right-info.border-right-lighten-4 {
      border-left: 1px solid #4fecff !important;
    }
    
    .overlay-info.overlay-lighten-4 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-lighten-4 {
      background: #4fecff;
      background: rgba(79, 236, 255, 0.6);
    }
    
    .text-info.text-lighten-3 {
      color: #36e9ff !important;
    }
    
     .bg-info.bg-lighten-3 {
      background-color: #36e9ff !important;
    }
    
     .border-info.border-lighten-3 {
      border: 1px solid #36e9ff !important;
    }
    
     .border-top-info.border-top-lighten-3 {
      border-top: 1px solid #36e9ff !important;
    }
    
     .border-bottom-info.border-bottom-lighten-3 {
      border-bottom: 1px solid #36e9ff !important;
    }
    
    [dir=ltr] .border-left-info.border-left-lighten-3 {
      border-left: 1px solid #36e9ff !important;
    }
    
    [dir=rtl] .border-left-info.border-left-lighten-3 {
      border-right: 1px solid #36e9ff !important;
    }
    
    [dir=ltr] .border-right-info.border-right-lighten-3 {
      border-right: 1px solid #36e9ff !important;
    }
    
    [dir=rtl] .border-right-info.border-right-lighten-3 {
      border-left: 1px solid #36e9ff !important;
    }
    
    .overlay-info.overlay-lighten-3 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-lighten-3 {
      background: #36e9ff;
      background: rgba(54, 233, 255, 0.6);
    }
    
    .text-info.text-lighten-2 {
      color: #1ce7ff !important;
    }
    
     .bg-info.bg-lighten-2 {
      background-color: #1ce7ff !important;
    }
    
     .border-info.border-lighten-2 {
      border: 1px solid #1ce7ff !important;
    }
    
     .border-top-info.border-top-lighten-2 {
      border-top: 1px solid #1ce7ff !important;
    }
    
     .border-bottom-info.border-bottom-lighten-2 {
      border-bottom: 1px solid #1ce7ff !important;
    }
    
    [dir=ltr] .border-left-info.border-left-lighten-2 {
      border-left: 1px solid #1ce7ff !important;
    }
    
    [dir=rtl] .border-left-info.border-left-lighten-2 {
      border-right: 1px solid #1ce7ff !important;
    }
    
    [dir=ltr] .border-right-info.border-right-lighten-2 {
      border-right: 1px solid #1ce7ff !important;
    }
    
    [dir=rtl] .border-right-info.border-right-lighten-2 {
      border-left: 1px solid #1ce7ff !important;
    }
    
    .overlay-info.overlay-lighten-2 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-lighten-2 {
      background: #1ce7ff;
      background: rgba(28, 231, 255, 0.6);
    }
    
    .text-info.text-lighten-1 {
      color: #03e4ff !important;
    }
    
     .bg-info.bg-lighten-1 {
      background-color: #03e4ff !important;
    }
    
     .border-info.border-lighten-1 {
      border: 1px solid #03e4ff !important;
    }
    
     .border-top-info.border-top-lighten-1 {
      border-top: 1px solid #03e4ff !important;
    }
    
     .border-bottom-info.border-bottom-lighten-1 {
      border-bottom: 1px solid #03e4ff !important;
    }
    
    [dir=ltr] .border-left-info.border-left-lighten-1 {
      border-left: 1px solid #03e4ff !important;
    }
    
    [dir=rtl] .border-left-info.border-left-lighten-1 {
      border-right: 1px solid #03e4ff !important;
    }
    
    [dir=ltr] .border-right-info.border-right-lighten-1 {
      border-right: 1px solid #03e4ff !important;
    }
    
    [dir=rtl] .border-right-info.border-right-lighten-1 {
      border-left: 1px solid #03e4ff !important;
    }
    
    .overlay-info.overlay-lighten-1 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-lighten-1 {
      background: #03e4ff;
      background: rgba(3, 228, 255, 0.6);
    }
    
     .bg-info {
      background-color: #00CFE8 !important;
    }
     .bg-info .card-header,  .bg-info .card-footer {
      background-color: transparent;
    }
    
    .alert-info {
      color: #00CFE8 !important;
    }
    
     .alert-info {
      background: rgba(0, 207, 232, 0.12) !important;
    }
     .alert-info .alert-heading {
      box-shadow: rgba(0, 207, 232, 0.4) 0px 6px 15px -7px;
    }
    .alert-info .alert-link {
      color: #00b8cf !important;
    }
    .alert-info .close {
      color: #00CFE8 !important;
    }
    
    .bg-light-info {
      color: #00CFE8 !important;
    }
    
     .bg-light-info {
      background: rgba(0, 207, 232, 0.12) !important;
    }
     .bg-light-info.fc-h-event,  .bg-light-info.fc-v-event {
      border-color: rgba(0, 207, 232, 0.1);
    }
     .bg-light-info .fc-list-event-dot {
      border-color: #00CFE8 !important;
    }
     .bg-light-info.fc-list-event:hover td {
      background: rgba(0, 207, 232, 0.1) !important;
    }
    .bg-light-info.fc-list-event .fc-list-event-title {
      color: #424244;
    }
    
    .avatar.bg-light-info {
      color: #00CFE8 !important;
    }
    
     .border-info {
      border: 1px solid #00CFE8 !important;
    }
    
     .border-top-info {
      border-top: 1px solid #00CFE8;
    }
    
     .border-bottom-info {
      border-bottom: 1px solid #00CFE8;
    }
    
    [dir=ltr] .border-left-info {
      border-left: 1px solid #00CFE8;
    }
    
    [dir=rtl] .border-left-info {
      border-right: 1px solid #00CFE8;
    }
    
    [dir=ltr] .border-right-info {
      border-right: 1px solid #00CFE8;
    }
    
    [dir=rtl] .border-right-info {
      border-left: 1px solid #00CFE8;
    }
    
     .bg-info.badge-glow,  .border-info.badge-glow,  .badge-info.badge-glow {
      box-shadow: 0px 0px 10px #00CFE8;
    }
    
    .badge.badge-light-info {
      color: #00CFE8 !important;
    }
    
     .badge.badge-light-info {
      background-color: rgba(0, 207, 232, 0.12);
    }
    
    .overlay-info {
      /* The Fallback */
    }
    
     .overlay-info {
      background: #00CFE8;
      background: rgba(0, 207, 232, 0.6);
    }
    
    .btn-info {
      color: #fff !important;
    }
    
     .btn-info {
      border-color: #00CFE8 !important;
      background-color: #00CFE8 !important;
    }
    .btn-info:focus, .btn-info:active, .btn-info.active {
      color: #fff;
    }
     .btn-info:focus,  .btn-info:active,  .btn-info.active {
      background-color: #00b8cf !important;
    }
     .btn-info:hover:not(.disabled):not(:disabled) {
      box-shadow: 0 8px 25px -8px #00cfe8;
    }
     .btn-info:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    
    .btn-flat-info {
      color: #00CFE8;
    }
    
     .btn-flat-info {
      background-color: transparent;
    }
    .btn-flat-info:hover {
      color: #00CFE8;
    }
     .btn-flat-info:hover:not(.disabled):not(:disabled) {
      background-color: rgba(0, 207, 232, 0.12);
    }
    .btn-flat-info:active, .btn-flat-info.active, .btn-flat-info:focus {
      color: #00CFE8;
    }
     .btn-flat-info:active,  .btn-flat-info.active,  .btn-flat-info:focus {
      background-color: rgba(0, 207, 232, 0.2);
    }
     .btn-flat-info.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300CFE8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    
    .btn-relief-info {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .btn-relief-info {
      background-color: #00CFE8;
      box-shadow: inset 0 -3px 0 0 rgba(34, 41, 47, 0.2);
    }
     .btn-relief-info:hover:not(.disabled):not(:disabled) {
      background-color: #03e4ff;
    }
     .btn-relief-info:active,  .btn-relief-info.active,  .btn-relief-info:focus {
      background-color: #00b8cf;
    }
    .btn-relief-info:hover {
      color: #fff;
    }
    .btn-relief-info:active, .btn-relief-info.active {
      outline: none;
    }
     .btn-relief-info:active,  .btn-relief-info.active {
      box-shadow: none;
      transform: translateY(3px);
    }
    
    .btn-outline-info {
      color: #00CFE8;
    }
    
     .btn-outline-info {
      border: 1px solid #00CFE8 !important;
      background-color: transparent;
    }
    .btn-outline-info:hover:not(.disabled):not(:disabled) {
      color: #00CFE8;
    }
     .btn-outline-info:hover:not(.disabled):not(:disabled) {
      background-color: rgba(0, 207, 232, 0.04);
    }
     .btn-outline-info:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .btn-outline-info:not(:disabled):not(.disabled):focus {
      color: #00CFE8;
    }
     .btn-outline-info:not(:disabled):not(.disabled):active,  .btn-outline-info:not(:disabled):not(.disabled).active,  .btn-outline-info:not(:disabled):not(.disabled):focus {
      background-color: rgba(0, 207, 232, 0.2);
    }
     .btn-outline-info.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300CFE8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .show > .btn-outline-info.dropdown-toggle {
      color: #00CFE8;
    }
     .show > .btn-outline-info.dropdown-toggle {
      background-color: rgba(0, 207, 232, 0.2);
    }
    
     .btn-outline-info.waves-effect .waves-ripple,  .btn-flat-info.waves-effect .waves-ripple {
      background: radial-gradient(rgba(0, 207, 232, 0.2) 0, rgba(0, 207, 232, 0.3) 40%, rgba(0, 207, 232, 0.4) 50%, rgba(0, 207, 232, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
    }
    
     .bullet.bullet-info {
      background-color: #00CFE8;
    }
    
    .modal.modal-info .modal-header .modal-title {
      color: #00CFE8;
    }
    .modal.modal-info .modal-header .close {
      color: #00CFE8 !important;
    }
    
    .pagination-info .page-item.active .page-link {
      color: #fff;
    }
    
     .pagination-info .page-item.active .page-link {
      background: #00CFE8 !important;
    }
    .pagination-info .page-item.active .page-link:hover {
      color: #fff;
    }
    .pagination-info .page-item .page-link:hover {
      color: #00CFE8;
    }
    .pagination-info .page-item.prev-item .page-link:hover, .pagination-info .page-item.next-item .page-link:hover {
      color: #fff;
    }
     .pagination-info .page-item.prev-item .page-link:hover,  .pagination-info .page-item.next-item .page-link:hover {
      background: #00CFE8;
    }
     .pagination-info .page-item.next-item .page-link:active:after,  .pagination-info .page-item.next-item .page-link:hover:after,  .pagination-info .page-item.next .page-link:active:after,  .pagination-info .page-item.next .page-link:hover:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300CFE8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
     .pagination-info .page-item.prev-item .page-link:active:before,  .pagination-info .page-item.prev-item .page-link:hover:before,  .pagination-info .page-item.prev .page-link:active:before,  .pagination-info .page-item.prev .page-link:hover:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300CFE8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
    
    .nav-pill-info .nav-item .nav-link.active {
      color: #fff;
    }
    
     .nav-pill-info .nav-item .nav-link.active {
      background-color: #00CFE8 !important;
      border-color: #00CFE8;
      box-shadow: 0 4px 18px -4px rgba(0, 207, 232, 0.65);
    }
    
     .progress-bar-info {
      background-color: rgba(0, 207, 232, 0.12);
    }
     .progress-bar-info .progress-bar {
      background-color: #00CFE8;
    }
    
     .timeline .timeline-point-info {
      border-color: #00CFE8 !important;
    }
    .timeline .timeline-point-info i,
    .timeline .timeline-point-info svg {
      stroke: #00CFE8 !important;
    }
     .timeline .timeline-point-info.timeline-point-indicator {
      background-color: #00CFE8 !important;
    }
     .timeline .timeline-point-info.timeline-point-indicator:before {
      background: rgba(0, 207, 232, 0.12) !important;
    }
    
     .divider.divider-info .divider-text:before,  .divider.divider-info .divider-text:after {
      border-color: #00CFE8 !important;
    }
    
     input:focus ~ .bg-info {
      box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #00CFE8 !important;
    }
    
     .custom-control-info .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-info .custom-control-input:active ~ .custom-control-label::before {
      border-color: #00CFE8;
      background-color: #00CFE8;
    }
     .custom-control-info.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-info.custom-checkbox .custom-control-input:active ~ .custom-control-label::before,  .custom-control-info.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,  .custom-control-info.custom-radio .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-info.custom-radio .custom-control-input:active ~ .custom-control-label::before,  .custom-control-info.custom-radio .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: 0 2px 4px 0 rgba(0, 207, 232, 0.4) !important;
    }
     .custom-control-info .custom-control-input:disabled:checked ~ .custom-control-label::before {
      background-color: rgba(0, 207, 232, 0.65) !important;
      border: none;
      box-shadow: none !important;
    }
     .custom-control-info .custom-control-input:focus ~ .custom-control-label::before {
      border-color: #00CFE8;
    }
    
    .custom-switch-info .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      transition: all 0.2s ease-out;
    }
    
     .custom-switch-info .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #00CFE8 !important;
    }
    
     .select2-info .select2-container--default .select2-selection--multiple .select2-selection__choice {
      background: #00CFE8 !important;
      border-color: #00CFE8 !important;
    }
    
    .text-info.text-darken-1 {
      color: #00b8cf !important;
    }
    
     .bg-info.bg-darken-1 {
      background-color: #00b8cf !important;
    }
    
     .border-info.border-darken-1 {
      border: 1px solid #00b8cf !important;
    }
    
     .border-top-info.border-top-darken-1 {
      border-top: 1px solid #00b8cf !important;
    }
    
     .border-bottom-info.border-bottom-darken-1 {
      border-bottom: 1px solid #00b8cf !important;
    }
    
    [dir=ltr] .border-left-info.border-left-darken-1 {
      border-left: 1px solid #00b8cf !important;
    }
    
    [dir=rtl] .border-left-info.border-left-darken-1 {
      border-right: 1px solid #00b8cf !important;
    }
    
    [dir=ltr] .border-right-info.border-right-darken-1 {
      border-right: 1px solid #00b8cf !important;
    }
    
    [dir=rtl] .border-right-info.border-right-darken-1 {
      border-left: 1px solid #00b8cf !important;
    }
    
    .overlay-info.overlay-darken-1 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-darken-1 {
      background: #00b8cf;
      background: rgba(0, 184, 207, 0.6);
    }
    
    .text-info.text-darken-2 {
      color: #00a1b5 !important;
    }
    
     .bg-info.bg-darken-2 {
      background-color: #00a1b5 !important;
    }
    
     .border-info.border-darken-2 {
      border: 1px solid #00a1b5 !important;
    }
    
     .border-top-info.border-top-darken-2 {
      border-top: 1px solid #00a1b5 !important;
    }
    
     .border-bottom-info.border-bottom-darken-2 {
      border-bottom: 1px solid #00a1b5 !important;
    }
    
    [dir=ltr] .border-left-info.border-left-darken-2 {
      border-left: 1px solid #00a1b5 !important;
    }
    
    [dir=rtl] .border-left-info.border-left-darken-2 {
      border-right: 1px solid #00a1b5 !important;
    }
    
    [dir=ltr] .border-right-info.border-right-darken-2 {
      border-right: 1px solid #00a1b5 !important;
    }
    
    [dir=rtl] .border-right-info.border-right-darken-2 {
      border-left: 1px solid #00a1b5 !important;
    }
    
    .overlay-info.overlay-darken-2 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-darken-2 {
      background: #00a1b5;
      background: rgba(0, 161, 181, 0.6);
    }
    
    .text-info.text-darken-3 {
      color: #008b9c !important;
    }
    
     .bg-info.bg-darken-3 {
      background-color: #008b9c !important;
    }
    
     .border-info.border-darken-3 {
      border: 1px solid #008b9c !important;
    }
    
     .border-top-info.border-top-darken-3 {
      border-top: 1px solid #008b9c !important;
    }
    
     .border-bottom-info.border-bottom-darken-3 {
      border-bottom: 1px solid #008b9c !important;
    }
    
    [dir=ltr] .border-left-info.border-left-darken-3 {
      border-left: 1px solid #008b9c !important;
    }
    
    [dir=rtl] .border-left-info.border-left-darken-3 {
      border-right: 1px solid #008b9c !important;
    }
    
    [dir=ltr] .border-right-info.border-right-darken-3 {
      border-right: 1px solid #008b9c !important;
    }
    
    [dir=rtl] .border-right-info.border-right-darken-3 {
      border-left: 1px solid #008b9c !important;
    }
    
    .overlay-info.overlay-darken-3 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-darken-3 {
      background: #008b9c;
      background: rgba(0, 139, 156, 0.6);
    }
    
    .text-info.text-darken-4 {
      color: #007482 !important;
    }
    
     .bg-info.bg-darken-4 {
      background-color: #007482 !important;
    }
    
     .border-info.border-darken-4 {
      border: 1px solid #007482 !important;
    }
    
     .border-top-info.border-top-darken-4 {
      border-top: 1px solid #007482 !important;
    }
    
     .border-bottom-info.border-bottom-darken-4 {
      border-bottom: 1px solid #007482 !important;
    }
    
    [dir=ltr] .border-left-info.border-left-darken-4 {
      border-left: 1px solid #007482 !important;
    }
    
    [dir=rtl] .border-left-info.border-left-darken-4 {
      border-right: 1px solid #007482 !important;
    }
    
    [dir=ltr] .border-right-info.border-right-darken-4 {
      border-right: 1px solid #007482 !important;
    }
    
    [dir=rtl] .border-right-info.border-right-darken-4 {
      border-left: 1px solid #007482 !important;
    }
    
    .overlay-info.overlay-darken-4 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-darken-4 {
      background: #007482;
      background: rgba(0, 116, 130, 0.6);
    }
    
    .text-info.text-accent-1 {
      color: #feffff !important;
    }
    
     .bg-info.bg-accent-1 {
      background-color: #feffff !important;
    }
    
     .border-info.border-accent-1 {
      border: 1px solid #feffff !important;
    }
    
     .border-top-info.border-top-accent-1 {
      border-top: 1px solid #feffff !important;
    }
    
     .border-bottom-info.border-bottom-accent-1 {
      border-bottom: 1px solid #feffff !important;
    }
    
    [dir=ltr] .border-left-info.border-left-accent-1 {
      border-left: 1px solid #feffff !important;
    }
    
    [dir=rtl] .border-left-info.border-left-accent-1 {
      border-right: 1px solid #feffff !important;
    }
    
    [dir=ltr] .border-right-info.border-right-accent-1 {
      border-right: 1px solid #feffff !important;
    }
    
    [dir=rtl] .border-right-info.border-right-accent-1 {
      border-left: 1px solid #feffff !important;
    }
    
    .overlay-info.overlay-accent-1 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-accent-1 {
      background: #feffff;
      background: rgba(254, 255, 255, 0.6);
    }
    
    .text-info.text-accent-2 {
      color: #cbf5ff !important;
    }
    
     .bg-info.bg-accent-2 {
      background-color: #cbf5ff !important;
    }
    
     .border-info.border-accent-2 {
      border: 1px solid #cbf5ff !important;
    }
    
     .border-top-info.border-top-accent-2 {
      border-top: 1px solid #cbf5ff !important;
    }
    
     .border-bottom-info.border-bottom-accent-2 {
      border-bottom: 1px solid #cbf5ff !important;
    }
    
    [dir=ltr] .border-left-info.border-left-accent-2 {
      border-left: 1px solid #cbf5ff !important;
    }
    
    [dir=rtl] .border-left-info.border-left-accent-2 {
      border-right: 1px solid #cbf5ff !important;
    }
    
    [dir=ltr] .border-right-info.border-right-accent-2 {
      border-right: 1px solid #cbf5ff !important;
    }
    
    [dir=rtl] .border-right-info.border-right-accent-2 {
      border-left: 1px solid #cbf5ff !important;
    }
    
    .overlay-info.overlay-accent-2 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-accent-2 {
      background: #cbf5ff;
      background: rgba(203, 245, 255, 0.6);
    }
    
    .text-info.text-accent-3 {
      color: #98ecff !important;
    }
    
     .bg-info.bg-accent-3 {
      background-color: #98ecff !important;
    }
    
     .border-info.border-accent-3 {
      border: 1px solid #98ecff !important;
    }
    
     .border-top-info.border-top-accent-3 {
      border-top: 1px solid #98ecff !important;
    }
    
     .border-bottom-info.border-bottom-accent-3 {
      border-bottom: 1px solid #98ecff !important;
    }
    
    [dir=ltr] .border-left-info.border-left-accent-3 {
      border-left: 1px solid #98ecff !important;
    }
    
    [dir=rtl] .border-left-info.border-left-accent-3 {
      border-right: 1px solid #98ecff !important;
    }
    
    [dir=ltr] .border-right-info.border-right-accent-3 {
      border-right: 1px solid #98ecff !important;
    }
    
    [dir=rtl] .border-right-info.border-right-accent-3 {
      border-left: 1px solid #98ecff !important;
    }
    
    .overlay-info.overlay-accent-3 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-accent-3 {
      background: #98ecff;
      background: rgba(152, 236, 255, 0.6);
    }
    
    .text-info.text-accent-4 {
      color: #7fe7ff !important;
    }
    
     .bg-info.bg-accent-4 {
      background-color: #7fe7ff !important;
    }
    
     .border-info.border-accent-4 {
      border: 1px solid #7fe7ff !important;
    }
    
     .border-top-info.border-top-accent-4 {
      border-top: 1px solid #7fe7ff !important;
    }
    
     .border-bottom-info.border-bottom-accent-4 {
      border-bottom: 1px solid #7fe7ff !important;
    }
    
    [dir=ltr] .border-left-info.border-left-accent-4 {
      border-left: 1px solid #7fe7ff !important;
    }
    
    [dir=rtl] .border-left-info.border-left-accent-4 {
      border-right: 1px solid #7fe7ff !important;
    }
    
    [dir=ltr] .border-right-info.border-right-accent-4 {
      border-right: 1px solid #7fe7ff !important;
    }
    
    [dir=rtl] .border-right-info.border-right-accent-4 {
      border-left: 1px solid #7fe7ff !important;
    }
    
    .overlay-info.overlay-accent-4 {
      /* The Fallback */
    }
    
     .overlay-info.overlay-accent-4 {
      background: #7fe7ff;
      background: rgba(127, 231, 255, 0.6);
    }
    
    .text-warning.text-lighten-5 {
      color: #fedf91 !important;
    }
    
     .bg-warning.bg-lighten-5 {
      background-color: #fedf91 !important;
    }
    
     .border-warning.border-lighten-5 {
      border: 1px solid #fedf91 !important;
    }
    
     .border-top-warning.border-top-lighten-5 {
      border-top: 1px solid #fedf91 !important;
    }
    
     .border-bottom-warning.border-bottom-lighten-5 {
      border-bottom: 1px solid #fedf91 !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-lighten-5 {
      border-left: 1px solid #fedf91 !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-lighten-5 {
      border-right: 1px solid #fedf91 !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-lighten-5 {
      border-right: 1px solid #fedf91 !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-lighten-5 {
      border-left: 1px solid #fedf91 !important;
    }
    
    .overlay-warning.overlay-lighten-5 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-lighten-5 {
      background: #fedf91;
      background: rgba(254, 223, 145, 0.6);
    }
    
    .text-warning.text-lighten-4 {
      color: #fed778 !important;
    }
    
     .bg-warning.bg-lighten-4 {
      background-color: #fed778 !important;
    }
    
     .border-warning.border-lighten-4 {
      border: 1px solid #fed778 !important;
    }
    
     .border-top-warning.border-top-lighten-4 {
      border-top: 1px solid #fed778 !important;
    }
    
     .border-bottom-warning.border-bottom-lighten-4 {
      border-bottom: 1px solid #fed778 !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-lighten-4 {
      border-left: 1px solid #fed778 !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-lighten-4 {
      border-right: 1px solid #fed778 !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-lighten-4 {
      border-right: 1px solid #fed778 !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-lighten-4 {
      border-left: 1px solid #fed778 !important;
    }
    
    .overlay-warning.overlay-lighten-4 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-lighten-4 {
      background: #fed778;
      background: rgba(254, 215, 120, 0.6);
    }
    
    .text-warning.text-lighten-3 {
      color: #fed05f !important;
    }
    
     .bg-warning.bg-lighten-3 {
      background-color: #fed05f !important;
    }
    
     .border-warning.border-lighten-3 {
      border: 1px solid #fed05f !important;
    }
    
     .border-top-warning.border-top-lighten-3 {
      border-top: 1px solid #fed05f !important;
    }
    
     .border-bottom-warning.border-bottom-lighten-3 {
      border-bottom: 1px solid #fed05f !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-lighten-3 {
      border-left: 1px solid #fed05f !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-lighten-3 {
      border-right: 1px solid #fed05f !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-lighten-3 {
      border-right: 1px solid #fed05f !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-lighten-3 {
      border-left: 1px solid #fed05f !important;
    }
    
    .overlay-warning.overlay-lighten-3 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-lighten-3 {
      background: #fed05f;
      background: rgba(254, 208, 95, 0.6);
    }
    
    .text-warning.text-lighten-2 {
      color: #fdc846 !important;
    }
    
     .bg-warning.bg-lighten-2 {
      background-color: #fdc846 !important;
    }
    
     .border-warning.border-lighten-2 {
      border: 1px solid #fdc846 !important;
    }
    
     .border-top-warning.border-top-lighten-2 {
      border-top: 1px solid #fdc846 !important;
    }
    
     .border-bottom-warning.border-bottom-lighten-2 {
      border-bottom: 1px solid #fdc846 !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-lighten-2 {
      border-left: 1px solid #fdc846 !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-lighten-2 {
      border-right: 1px solid #fdc846 !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-lighten-2 {
      border-right: 1px solid #fdc846 !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-lighten-2 {
      border-left: 1px solid #fdc846 !important;
    }
    
    .overlay-warning.overlay-lighten-2 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-lighten-2 {
      background: #fdc846;
      background: rgba(253, 200, 70, 0.6);
    }
    
    .text-warning.text-lighten-1 {
      color: #fdc12c !important;
    }
    
     .bg-warning.bg-lighten-1 {
      background-color: #fdc12c !important;
    }
    
     .border-warning.border-lighten-1 {
      border: 1px solid #fdc12c !important;
    }
    
     .border-top-warning.border-top-lighten-1 {
      border-top: 1px solid #fdc12c !important;
    }
    
     .border-bottom-warning.border-bottom-lighten-1 {
      border-bottom: 1px solid #fdc12c !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-lighten-1 {
      border-left: 1px solid #fdc12c !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-lighten-1 {
      border-right: 1px solid #fdc12c !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-lighten-1 {
      border-right: 1px solid #fdc12c !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-lighten-1 {
      border-left: 1px solid #fdc12c !important;
    }
    
    .overlay-warning.overlay-lighten-1 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-lighten-1 {
      background: #fdc12c;
      background: rgba(253, 193, 44, 0.6);
    }
    
     .bg-warning {
      background-color: #FDB913 !important;
    }
     .bg-warning .card-header,  .bg-warning .card-footer {
      background-color: transparent;
    }
    
    .alert-warning {
      color: #FDB913 !important;
    }
    
     .alert-warning {
      background: rgba(253, 185, 19, 0.12) !important;
    }
     .alert-warning .alert-heading {
      box-shadow: rgba(253, 185, 19, 0.4) 0px 6px 15px -7px;
    }
    .alert-warning .alert-link {
      color: #f4ae02 !important;
    }
    .alert-warning .close {
      color: #FDB913 !important;
    }
    
    .bg-light-warning {
      color: #FDB913 !important;
    }
    
     .bg-light-warning {
      background: rgba(253, 185, 19, 0.12) !important;
    }
     .bg-light-warning.fc-h-event,  .bg-light-warning.fc-v-event {
      border-color: rgba(253, 185, 19, 0.1);
    }
     .bg-light-warning .fc-list-event-dot {
      border-color: #FDB913 !important;
    }
     .bg-light-warning.fc-list-event:hover td {
      background: rgba(253, 185, 19, 0.1) !important;
    }
    .bg-light-warning.fc-list-event .fc-list-event-title {
      color: #424244;
    }
    
    .avatar.bg-light-warning {
      color: #FDB913 !important;
    }
    
     .border-warning {
      border: 1px solid #FDB913 !important;
    }
    
     .border-top-warning {
      border-top: 1px solid #FDB913;
    }
    
     .border-bottom-warning {
      border-bottom: 1px solid #FDB913;
    }
    
    [dir=ltr] .border-left-warning {
      border-left: 1px solid #FDB913;
    }
    
    [dir=rtl] .border-left-warning {
      border-right: 1px solid #FDB913;
    }
    
    [dir=ltr] .border-right-warning {
      border-right: 1px solid #FDB913;
    }
    
    [dir=rtl] .border-right-warning {
      border-left: 1px solid #FDB913;
    }
    
     .bg-warning.badge-glow,  .border-warning.badge-glow,  .badge-warning.badge-glow {
      box-shadow: 0px 0px 10px #FDB913;
    }
    
    .badge.badge-light-warning {
      color: #FDB913 !important;
    }
    
     .badge.badge-light-warning {
      background-color: rgba(253, 185, 19, 0.12);
    }
    
    .overlay-warning {
      /* The Fallback */
    }
    
     .overlay-warning {
      background: #FDB913;
      background: rgba(253, 185, 19, 0.6);
    }
    
    .btn-warning {
      color: #fff !important;
    }
    
     .btn-warning {
      border-color: #FDB913 !important;
      background-color: #FDB913 !important;
    }
    .btn-warning:focus, .btn-warning:active, .btn-warning.active {
      color: #fff;
    }
     .btn-warning:focus,  .btn-warning:active,  .btn-warning.active {
      background-color: #f4ae02 !important;
    }
     .btn-warning:hover:not(.disabled):not(:disabled) {
      box-shadow: 0 8px 25px -8px #fdb913;
    }
     .btn-warning:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    
    .btn-flat-warning {
      color: #FDB913;
    }
    
     .btn-flat-warning {
      background-color: transparent;
    }
    .btn-flat-warning:hover {
      color: #FDB913;
    }
     .btn-flat-warning:hover:not(.disabled):not(:disabled) {
      background-color: rgba(253, 185, 19, 0.12);
    }
    .btn-flat-warning:active, .btn-flat-warning.active, .btn-flat-warning:focus {
      color: #FDB913;
    }
     .btn-flat-warning:active,  .btn-flat-warning.active,  .btn-flat-warning:focus {
      background-color: rgba(253, 185, 19, 0.2);
    }
     .btn-flat-warning.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23FDB913' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    
    .btn-relief-warning {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .btn-relief-warning {
      background-color: #FDB913;
      box-shadow: inset 0 -3px 0 0 rgba(34, 41, 47, 0.2);
    }
     .btn-relief-warning:hover:not(.disabled):not(:disabled) {
      background-color: #fdc12c;
    }
     .btn-relief-warning:active,  .btn-relief-warning.active,  .btn-relief-warning:focus {
      background-color: #f4ae02;
    }
    .btn-relief-warning:hover {
      color: #fff;
    }
    .btn-relief-warning:active, .btn-relief-warning.active {
      outline: none;
    }
     .btn-relief-warning:active,  .btn-relief-warning.active {
      box-shadow: none;
      transform: translateY(3px);
    }
    
    .btn-outline-warning {
      color: #FDB913;
    }
    
     .btn-outline-warning {
      border: 1px solid #FDB913 !important;
      background-color: transparent;
    }
    .btn-outline-warning:hover:not(.disabled):not(:disabled) {
      color: #FDB913;
    }
     .btn-outline-warning:hover:not(.disabled):not(:disabled) {
      background-color: rgba(253, 185, 19, 0.04);
    }
     .btn-outline-warning:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .btn-outline-warning:not(:disabled):not(.disabled):focus {
      color: #FDB913;
    }
     .btn-outline-warning:not(:disabled):not(.disabled):active,  .btn-outline-warning:not(:disabled):not(.disabled).active,  .btn-outline-warning:not(:disabled):not(.disabled):focus {
      background-color: rgba(253, 185, 19, 0.2);
    }
     .btn-outline-warning.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23FDB913' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .show > .btn-outline-warning.dropdown-toggle {
      color: #FDB913;
    }
     .show > .btn-outline-warning.dropdown-toggle {
      background-color: rgba(253, 185, 19, 0.2);
    }
    
     .btn-outline-warning.waves-effect .waves-ripple,  .btn-flat-warning.waves-effect .waves-ripple {
      background: radial-gradient(rgba(253, 185, 19, 0.2) 0, rgba(253, 185, 19, 0.3) 40%, rgba(253, 185, 19, 0.4) 50%, rgba(253, 185, 19, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
    }
    
     .bullet.bullet-warning {
      background-color: #FDB913;
    }
    
    .modal.modal-warning .modal-header .modal-title {
      color: #FDB913;
    }
    .modal.modal-warning .modal-header .close {
      color: #FDB913 !important;
    }
    
    .pagination-warning .page-item.active .page-link {
      color: #fff;
    }
    
     .pagination-warning .page-item.active .page-link {
      background: #FDB913 !important;
    }
    .pagination-warning .page-item.active .page-link:hover {
      color: #fff;
    }
    .pagination-warning .page-item .page-link:hover {
      color: #FDB913;
    }
    .pagination-warning .page-item.prev-item .page-link:hover, .pagination-warning .page-item.next-item .page-link:hover {
      color: #fff;
    }
     .pagination-warning .page-item.prev-item .page-link:hover,  .pagination-warning .page-item.next-item .page-link:hover {
      background: #FDB913;
    }
     .pagination-warning .page-item.next-item .page-link:active:after,  .pagination-warning .page-item.next-item .page-link:hover:after,  .pagination-warning .page-item.next .page-link:active:after,  .pagination-warning .page-item.next .page-link:hover:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23FDB913' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
     .pagination-warning .page-item.prev-item .page-link:active:before,  .pagination-warning .page-item.prev-item .page-link:hover:before,  .pagination-warning .page-item.prev .page-link:active:before,  .pagination-warning .page-item.prev .page-link:hover:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23FDB913' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
    
    .nav-pill-warning .nav-item .nav-link.active {
      color: #fff;
    }
    
     .nav-pill-warning .nav-item .nav-link.active {
      background-color: #FDB913 !important;
      border-color: #FDB913;
      box-shadow: 0 4px 18px -4px rgba(253, 185, 19, 0.65);
    }
    
     .progress-bar-warning {
      background-color: rgba(253, 185, 19, 0.12);
    }
     .progress-bar-warning .progress-bar {
      background-color: #FDB913;
    }
    
     .timeline .timeline-point-warning {
      border-color: #FDB913 !important;
    }
    .timeline .timeline-point-warning i,
    .timeline .timeline-point-warning svg {
      stroke: #FDB913 !important;
    }
     .timeline .timeline-point-warning.timeline-point-indicator {
      background-color: #FDB913 !important;
    }
     .timeline .timeline-point-warning.timeline-point-indicator:before {
      background: rgba(253, 185, 19, 0.12) !important;
    }
    
     .divider.divider-warning .divider-text:before,  .divider.divider-warning .divider-text:after {
      border-color: #FDB913 !important;
    }
    
     input:focus ~ .bg-warning {
      box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #FDB913 !important;
    }
    
     .custom-control-warning .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-warning .custom-control-input:active ~ .custom-control-label::before {
      border-color: #FDB913;
      background-color: #FDB913;
    }
     .custom-control-warning.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-warning.custom-checkbox .custom-control-input:active ~ .custom-control-label::before,  .custom-control-warning.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,  .custom-control-warning.custom-radio .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-warning.custom-radio .custom-control-input:active ~ .custom-control-label::before,  .custom-control-warning.custom-radio .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: 0 2px 4px 0 rgba(253, 185, 19, 0.4) !important;
    }
     .custom-control-warning .custom-control-input:disabled:checked ~ .custom-control-label::before {
      background-color: rgba(253, 185, 19, 0.65) !important;
      border: none;
      box-shadow: none !important;
    }
     .custom-control-warning .custom-control-input:focus ~ .custom-control-label::before {
      border-color: #FDB913;
    }
    
    .custom-switch-warning .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      transition: all 0.2s ease-out;
    }
    
     .custom-switch-warning .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #FDB913 !important;
    }
    
     .select2-warning .select2-container--default .select2-selection--multiple .select2-selection__choice {
      background: #FDB913 !important;
      border-color: #FDB913 !important;
    }
    
    .text-warning.text-darken-1 {
      color: #f4ae02 !important;
    }
    
     .bg-warning.bg-darken-1 {
      background-color: #f4ae02 !important;
    }
    
     .border-warning.border-darken-1 {
      border: 1px solid #f4ae02 !important;
    }
    
     .border-top-warning.border-top-darken-1 {
      border-top: 1px solid #f4ae02 !important;
    }
    
     .border-bottom-warning.border-bottom-darken-1 {
      border-bottom: 1px solid #f4ae02 !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-darken-1 {
      border-left: 1px solid #f4ae02 !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-darken-1 {
      border-right: 1px solid #f4ae02 !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-darken-1 {
      border-right: 1px solid #f4ae02 !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-darken-1 {
      border-left: 1px solid #f4ae02 !important;
    }
    
    .overlay-warning.overlay-darken-1 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-darken-1 {
      background: #f4ae02;
      background: rgba(244, 174, 2, 0.6);
    }
    
    .text-warning.text-darken-2 {
      color: #db9c02 !important;
    }
    
     .bg-warning.bg-darken-2 {
      background-color: #db9c02 !important;
    }
    
     .border-warning.border-darken-2 {
      border: 1px solid #db9c02 !important;
    }
    
     .border-top-warning.border-top-darken-2 {
      border-top: 1px solid #db9c02 !important;
    }
    
     .border-bottom-warning.border-bottom-darken-2 {
      border-bottom: 1px solid #db9c02 !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-darken-2 {
      border-left: 1px solid #db9c02 !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-darken-2 {
      border-right: 1px solid #db9c02 !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-darken-2 {
      border-right: 1px solid #db9c02 !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-darken-2 {
      border-left: 1px solid #db9c02 !important;
    }
    
    .overlay-warning.overlay-darken-2 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-darken-2 {
      background: #db9c02;
      background: rgba(219, 156, 2, 0.6);
    }
    
    .text-warning.text-darken-3 {
      color: #c28a02 !important;
    }
    
     .bg-warning.bg-darken-3 {
      background-color: #c28a02 !important;
    }
    
     .border-warning.border-darken-3 {
      border: 1px solid #c28a02 !important;
    }
    
     .border-top-warning.border-top-darken-3 {
      border-top: 1px solid #c28a02 !important;
    }
    
     .border-bottom-warning.border-bottom-darken-3 {
      border-bottom: 1px solid #c28a02 !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-darken-3 {
      border-left: 1px solid #c28a02 !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-darken-3 {
      border-right: 1px solid #c28a02 !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-darken-3 {
      border-right: 1px solid #c28a02 !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-darken-3 {
      border-left: 1px solid #c28a02 !important;
    }
    
    .overlay-warning.overlay-darken-3 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-darken-3 {
      background: #c28a02;
      background: rgba(194, 138, 2, 0.6);
    }
    
    .text-warning.text-darken-4 {
      color: #a97801 !important;
    }
    
     .bg-warning.bg-darken-4 {
      background-color: #a97801 !important;
    }
    
     .border-warning.border-darken-4 {
      border: 1px solid #a97801 !important;
    }
    
     .border-top-warning.border-top-darken-4 {
      border-top: 1px solid #a97801 !important;
    }
    
     .border-bottom-warning.border-bottom-darken-4 {
      border-bottom: 1px solid #a97801 !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-darken-4 {
      border-left: 1px solid #a97801 !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-darken-4 {
      border-right: 1px solid #a97801 !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-darken-4 {
      border-right: 1px solid #a97801 !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-darken-4 {
      border-left: 1px solid #a97801 !important;
    }
    
    .overlay-warning.overlay-darken-4 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-darken-4 {
      background: #a97801;
      background: rgba(169, 120, 1, 0.6);
    }
    
    .text-warning.text-accent-1 {
      color: #fff5ef !important;
    }
    
     .bg-warning.bg-accent-1 {
      background-color: #fff5ef !important;
    }
    
     .border-warning.border-accent-1 {
      border: 1px solid #fff5ef !important;
    }
    
     .border-top-warning.border-top-accent-1 {
      border-top: 1px solid #fff5ef !important;
    }
    
     .border-bottom-warning.border-bottom-accent-1 {
      border-bottom: 1px solid #fff5ef !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-accent-1 {
      border-left: 1px solid #fff5ef !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-accent-1 {
      border-right: 1px solid #fff5ef !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-accent-1 {
      border-right: 1px solid #fff5ef !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-accent-1 {
      border-left: 1px solid #fff5ef !important;
    }
    
    .overlay-warning.overlay-accent-1 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-accent-1 {
      background: #fff5ef;
      background: rgba(255, 245, 239, 0.6);
    }
    
    .text-warning.text-accent-2 {
      color: #ffe5d8 !important;
    }
    
     .bg-warning.bg-accent-2 {
      background-color: #ffe5d8 !important;
    }
    
     .border-warning.border-accent-2 {
      border: 1px solid #ffe5d8 !important;
    }
    
     .border-top-warning.border-top-accent-2 {
      border-top: 1px solid #ffe5d8 !important;
    }
    
     .border-bottom-warning.border-bottom-accent-2 {
      border-bottom: 1px solid #ffe5d8 !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-accent-2 {
      border-left: 1px solid #ffe5d8 !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-accent-2 {
      border-right: 1px solid #ffe5d8 !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-accent-2 {
      border-right: 1px solid #ffe5d8 !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-accent-2 {
      border-left: 1px solid #ffe5d8 !important;
    }
    
    .overlay-warning.overlay-accent-2 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-accent-2 {
      background: #ffe5d8;
      background: rgba(255, 229, 216, 0.6);
    }
    
    .text-warning.text-accent-3 {
      color: #fff6f3 !important;
    }
    
     .bg-warning.bg-accent-3 {
      background-color: #fff6f3 !important;
    }
    
     .border-warning.border-accent-3 {
      border: 1px solid #fff6f3 !important;
    }
    
     .border-top-warning.border-top-accent-3 {
      border-top: 1px solid #fff6f3 !important;
    }
    
     .border-bottom-warning.border-bottom-accent-3 {
      border-bottom: 1px solid #fff6f3 !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-accent-3 {
      border-left: 1px solid #fff6f3 !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-accent-3 {
      border-right: 1px solid #fff6f3 !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-accent-3 {
      border-right: 1px solid #fff6f3 !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-accent-3 {
      border-left: 1px solid #fff6f3 !important;
    }
    
    .overlay-warning.overlay-accent-3 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-accent-3 {
      background: #fff6f3;
      background: rgba(255, 246, 243, 0.6);
    }
    
    .text-warning.text-accent-4 {
      color: #ffe3da !important;
    }
    
     .bg-warning.bg-accent-4 {
      background-color: #ffe3da !important;
    }
    
     .border-warning.border-accent-4 {
      border: 1px solid #ffe3da !important;
    }
    
     .border-top-warning.border-top-accent-4 {
      border-top: 1px solid #ffe3da !important;
    }
    
     .border-bottom-warning.border-bottom-accent-4 {
      border-bottom: 1px solid #ffe3da !important;
    }
    
    [dir=ltr] .border-left-warning.border-left-accent-4 {
      border-left: 1px solid #ffe3da !important;
    }
    
    [dir=rtl] .border-left-warning.border-left-accent-4 {
      border-right: 1px solid #ffe3da !important;
    }
    
    [dir=ltr] .border-right-warning.border-right-accent-4 {
      border-right: 1px solid #ffe3da !important;
    }
    
    [dir=rtl] .border-right-warning.border-right-accent-4 {
      border-left: 1px solid #ffe3da !important;
    }
    
    .overlay-warning.overlay-accent-4 {
      /* The Fallback */
    }
    
     .overlay-warning.overlay-accent-4 {
      background: #ffe3da;
      background: rgba(255, 227, 218, 0.6);
    }
    
    .text-danger.text-lighten-5 {
      color: #f8c6c6 !important;
    }
    
     .bg-danger.bg-lighten-5 {
      background-color: #f8c6c6 !important;
    }
    
     .border-danger.border-lighten-5 {
      border: 1px solid #f8c6c6 !important;
    }
    
     .border-top-danger.border-top-lighten-5 {
      border-top: 1px solid #f8c6c6 !important;
    }
    
     .border-bottom-danger.border-bottom-lighten-5 {
      border-bottom: 1px solid #f8c6c6 !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-lighten-5 {
      border-left: 1px solid #f8c6c6 !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-lighten-5 {
      border-right: 1px solid #f8c6c6 !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-lighten-5 {
      border-right: 1px solid #f8c6c6 !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-lighten-5 {
      border-left: 1px solid #f8c6c6 !important;
    }
    
    .overlay-danger.overlay-lighten-5 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-lighten-5 {
      background: #f8c6c6;
      background: rgba(248, 198, 198, 0.6);
    }
    
    .text-danger.text-lighten-4 {
      color: #f5afaf !important;
    }
    
     .bg-danger.bg-lighten-4 {
      background-color: #f5afaf !important;
    }
    
     .border-danger.border-lighten-4 {
      border: 1px solid #f5afaf !important;
    }
    
     .border-top-danger.border-top-lighten-4 {
      border-top: 1px solid #f5afaf !important;
    }
    
     .border-bottom-danger.border-bottom-lighten-4 {
      border-bottom: 1px solid #f5afaf !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-lighten-4 {
      border-left: 1px solid #f5afaf !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-lighten-4 {
      border-right: 1px solid #f5afaf !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-lighten-4 {
      border-right: 1px solid #f5afaf !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-lighten-4 {
      border-left: 1px solid #f5afaf !important;
    }
    
    .overlay-danger.overlay-lighten-4 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-lighten-4 {
      background: #f5afaf;
      background: rgba(245, 175, 175, 0.6);
    }
    
    .text-danger.text-lighten-3 {
      color: #f29899 !important;
    }
    
     .bg-danger.bg-lighten-3 {
      background-color: #f29899 !important;
    }
    
     .border-danger.border-lighten-3 {
      border: 1px solid #f29899 !important;
    }
    
     .border-top-danger.border-top-lighten-3 {
      border-top: 1px solid #f29899 !important;
    }
    
     .border-bottom-danger.border-bottom-lighten-3 {
      border-bottom: 1px solid #f29899 !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-lighten-3 {
      border-left: 1px solid #f29899 !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-lighten-3 {
      border-right: 1px solid #f29899 !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-lighten-3 {
      border-right: 1px solid #f29899 !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-lighten-3 {
      border-left: 1px solid #f29899 !important;
    }
    
    .overlay-danger.overlay-lighten-3 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-lighten-3 {
      background: #f29899;
      background: rgba(242, 152, 153, 0.6);
    }
    
    .text-danger.text-lighten-2 {
      color: #f08182 !important;
    }
    
     .bg-danger.bg-lighten-2 {
      background-color: #f08182 !important;
    }
    
     .border-danger.border-lighten-2 {
      border: 1px solid #f08182 !important;
    }
    
     .border-top-danger.border-top-lighten-2 {
      border-top: 1px solid #f08182 !important;
    }
    
     .border-bottom-danger.border-bottom-lighten-2 {
      border-bottom: 1px solid #f08182 !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-lighten-2 {
      border-left: 1px solid #f08182 !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-lighten-2 {
      border-right: 1px solid #f08182 !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-lighten-2 {
      border-right: 1px solid #f08182 !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-lighten-2 {
      border-left: 1px solid #f08182 !important;
    }
    
    .overlay-danger.overlay-lighten-2 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-lighten-2 {
      background: #f08182;
      background: rgba(240, 129, 130, 0.6);
    }
    
    .text-danger.text-lighten-1 {
      color: #ed6b6c !important;
    }
    
     .bg-danger.bg-lighten-1 {
      background-color: #ed6b6c !important;
    }
    
     .border-danger.border-lighten-1 {
      border: 1px solid #ed6b6c !important;
    }
    
     .border-top-danger.border-top-lighten-1 {
      border-top: 1px solid #ed6b6c !important;
    }
    
     .border-bottom-danger.border-bottom-lighten-1 {
      border-bottom: 1px solid #ed6b6c !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-lighten-1 {
      border-left: 1px solid #ed6b6c !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-lighten-1 {
      border-right: 1px solid #ed6b6c !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-lighten-1 {
      border-right: 1px solid #ed6b6c !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-lighten-1 {
      border-left: 1px solid #ed6b6c !important;
    }
    
    .overlay-danger.overlay-lighten-1 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-lighten-1 {
      background: #ed6b6c;
      background: rgba(237, 107, 108, 0.6);
    }
    
     .bg-danger {
      background-color: #EA5455 !important;
    }
     .bg-danger .card-header,  .bg-danger .card-footer {
      background-color: transparent;
    }
    
    .alert-danger {
      color: #EA5455 !important;
    }
    
     .alert-danger {
      background: rgba(234, 84, 85, 0.12) !important;
    }
     .alert-danger .alert-heading {
      box-shadow: rgba(234, 84, 85, 0.4) 0px 6px 15px -7px;
    }
    .alert-danger .alert-link {
      color: #e73d3e !important;
    }
    .alert-danger .close {
      color: #EA5455 !important;
    }
    
    .bg-light-danger {
      color: #EA5455 !important;
    }
    
     .bg-light-danger {
      background: rgba(234, 84, 85, 0.12) !important;
    }
     .bg-light-danger.fc-h-event,  .bg-light-danger.fc-v-event {
      border-color: rgba(234, 84, 85, 0.1);
    }
     .bg-light-danger .fc-list-event-dot {
      border-color: #EA5455 !important;
    }
     .bg-light-danger.fc-list-event:hover td {
      background: rgba(234, 84, 85, 0.1) !important;
    }
    .bg-light-danger.fc-list-event .fc-list-event-title {
      color: #424244;
    }
    
    .avatar.bg-light-danger {
      color: #EA5455 !important;
    }
    
     .border-danger {
      border: 1px solid #EA5455 !important;
    }
    
     .border-top-danger {
      border-top: 1px solid #EA5455;
    }
    
     .border-bottom-danger {
      border-bottom: 1px solid #EA5455;
    }
    
    [dir=ltr] .border-left-danger {
      border-left: 1px solid #EA5455;
    }
    
    [dir=rtl] .border-left-danger {
      border-right: 1px solid #EA5455;
    }
    
    [dir=ltr] .border-right-danger {
      border-right: 1px solid #EA5455;
    }
    
    [dir=rtl] .border-right-danger {
      border-left: 1px solid #EA5455;
    }
    
     .bg-danger.badge-glow,  .border-danger.badge-glow,  .badge-danger.badge-glow {
      box-shadow: 0px 0px 10px #EA5455;
    }
    
    .badge.badge-light-danger {
      color: #EA5455 !important;
    }
    
     .badge.badge-light-danger {
      background-color: rgba(234, 84, 85, 0.12);
    }
    
    .overlay-danger {
      /* The Fallback */
    }
    
     .overlay-danger {
      background: #EA5455;
      background: rgba(234, 84, 85, 0.6);
    }
    
    .btn-danger {
      color: #fff !important;
    }
    
     .btn-danger {
      border-color: #EA5455 !important;
      background-color: #EA5455 !important;
    }
    .btn-danger:focus, .btn-danger:active, .btn-danger.active {
      color: #fff;
    }
     .btn-danger:focus,  .btn-danger:active,  .btn-danger.active {
      background-color: #e73d3e !important;
    }
     .btn-danger:hover:not(.disabled):not(:disabled) {
      box-shadow: 0 8px 25px -8px #ea5455;
    }
     .btn-danger:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    
    .btn-flat-danger {
      color: #EA5455;
    }
    
     .btn-flat-danger {
      background-color: transparent;
    }
    .btn-flat-danger:hover {
      color: #EA5455;
    }
     .btn-flat-danger:hover:not(.disabled):not(:disabled) {
      background-color: rgba(234, 84, 85, 0.12);
    }
    .btn-flat-danger:active, .btn-flat-danger.active, .btn-flat-danger:focus {
      color: #EA5455;
    }
     .btn-flat-danger:active,  .btn-flat-danger.active,  .btn-flat-danger:focus {
      background-color: rgba(234, 84, 85, 0.2);
    }
     .btn-flat-danger.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23EA5455' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    
    .btn-relief-danger {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .btn-relief-danger {
      background-color: #EA5455;
      box-shadow: inset 0 -3px 0 0 rgba(34, 41, 47, 0.2);
    }
     .btn-relief-danger:hover:not(.disabled):not(:disabled) {
      background-color: #ed6b6c;
    }
     .btn-relief-danger:active,  .btn-relief-danger.active,  .btn-relief-danger:focus {
      background-color: #e73d3e;
    }
    .btn-relief-danger:hover {
      color: #fff;
    }
    .btn-relief-danger:active, .btn-relief-danger.active {
      outline: none;
    }
     .btn-relief-danger:active,  .btn-relief-danger.active {
      box-shadow: none;
      transform: translateY(3px);
    }
    
    .btn-outline-danger {
      color: #EA5455;
    }
    
     .btn-outline-danger {
      border: 1px solid #EA5455 !important;
      background-color: transparent;
    }
    .btn-outline-danger:hover:not(.disabled):not(:disabled) {
      color: #EA5455;
    }
     .btn-outline-danger:hover:not(.disabled):not(:disabled) {
      background-color: rgba(234, 84, 85, 0.04);
    }
     .btn-outline-danger:not(:disabled):not(.disabled):active:focus {
      box-shadow: none;
    }
    .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .btn-outline-danger:not(:disabled):not(.disabled):focus {
      color: #EA5455;
    }
     .btn-outline-danger:not(:disabled):not(.disabled):active,  .btn-outline-danger:not(:disabled):not(.disabled).active,  .btn-outline-danger:not(:disabled):not(.disabled):focus {
      background-color: rgba(234, 84, 85, 0.2);
    }
     .btn-outline-danger.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23EA5455' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .show > .btn-outline-danger.dropdown-toggle {
      color: #EA5455;
    }
     .show > .btn-outline-danger.dropdown-toggle {
      background-color: rgba(234, 84, 85, 0.2);
    }
    
     .btn-outline-danger.waves-effect .waves-ripple,  .btn-flat-danger.waves-effect .waves-ripple {
      background: radial-gradient(rgba(234, 84, 85, 0.2) 0, rgba(234, 84, 85, 0.3) 40%, rgba(234, 84, 85, 0.4) 50%, rgba(234, 84, 85, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
    }
    
     .bullet.bullet-danger {
      background-color: #EA5455;
    }
    
    .modal.modal-danger .modal-header .modal-title {
      color: #EA5455;
    }
    .modal.modal-danger .modal-header .close {
      color: #EA5455 !important;
    }
    
    .pagination-danger .page-item.active .page-link {
      color: #fff;
    }
    
     .pagination-danger .page-item.active .page-link {
      background: #EA5455 !important;
    }
    .pagination-danger .page-item.active .page-link:hover {
      color: #fff;
    }
    .pagination-danger .page-item .page-link:hover {
      color: #EA5455;
    }
    .pagination-danger .page-item.prev-item .page-link:hover, .pagination-danger .page-item.next-item .page-link:hover {
      color: #fff;
    }
     .pagination-danger .page-item.prev-item .page-link:hover,  .pagination-danger .page-item.next-item .page-link:hover {
      background: #EA5455;
    }
     .pagination-danger .page-item.next-item .page-link:active:after,  .pagination-danger .page-item.next-item .page-link:hover:after,  .pagination-danger .page-item.next .page-link:active:after,  .pagination-danger .page-item.next .page-link:hover:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23EA5455' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
     .pagination-danger .page-item.prev-item .page-link:active:before,  .pagination-danger .page-item.prev-item .page-link:hover:before,  .pagination-danger .page-item.prev .page-link:active:before,  .pagination-danger .page-item.prev .page-link:hover:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23EA5455' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
    
    .nav-pill-danger .nav-item .nav-link.active {
      color: #fff;
    }
    
     .nav-pill-danger .nav-item .nav-link.active {
      background-color: #EA5455 !important;
      border-color: #EA5455;
      box-shadow: 0 4px 18px -4px rgba(234, 84, 85, 0.65);
    }
    
     .progress-bar-danger {
      background-color: rgba(234, 84, 85, 0.12);
    }
     .progress-bar-danger .progress-bar {
      background-color: #EA5455;
    }
    
     .timeline .timeline-point-danger {
      border-color: #EA5455 !important;
    }
    .timeline .timeline-point-danger i,
    .timeline .timeline-point-danger svg {
      stroke: #EA5455 !important;
    }
     .timeline .timeline-point-danger.timeline-point-indicator {
      background-color: #EA5455 !important;
    }
     .timeline .timeline-point-danger.timeline-point-indicator:before {
      background: rgba(234, 84, 85, 0.12) !important;
    }
    
     .divider.divider-danger .divider-text:before,  .divider.divider-danger .divider-text:after {
      border-color: #EA5455 !important;
    }
    
     input:focus ~ .bg-danger {
      box-shadow: 0 0 0 0.075rem #fff, 0 0 0 0.21rem #EA5455 !important;
    }
    
     .custom-control-danger .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-danger .custom-control-input:active ~ .custom-control-label::before {
      border-color: #EA5455;
      background-color: #EA5455;
    }
     .custom-control-danger.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-danger.custom-checkbox .custom-control-input:active ~ .custom-control-label::before,  .custom-control-danger.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,  .custom-control-danger.custom-radio .custom-control-input:checked ~ .custom-control-label::before,  .custom-control-danger.custom-radio .custom-control-input:active ~ .custom-control-label::before,  .custom-control-danger.custom-radio .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: 0 2px 4px 0 rgba(234, 84, 85, 0.4) !important;
    }
     .custom-control-danger .custom-control-input:disabled:checked ~ .custom-control-label::before {
      background-color: rgba(234, 84, 85, 0.65) !important;
      border: none;
      box-shadow: none !important;
    }
     .custom-control-danger .custom-control-input:focus ~ .custom-control-label::before {
      border-color: #EA5455;
    }
    
    .custom-switch-danger .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      transition: all 0.2s ease-out;
    }
    
     .custom-switch-danger .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #EA5455 !important;
    }
    
     .select2-danger .select2-container--default .select2-selection--multiple .select2-selection__choice {
      background: #EA5455 !important;
      border-color: #EA5455 !important;
    }
    
    .text-danger.text-darken-1 {
      color: #e73d3e !important;
    }
    
     .bg-danger.bg-darken-1 {
      background-color: #e73d3e !important;
    }
    
     .border-danger.border-darken-1 {
      border: 1px solid #e73d3e !important;
    }
    
     .border-top-danger.border-top-darken-1 {
      border-top: 1px solid #e73d3e !important;
    }
    
     .border-bottom-danger.border-bottom-darken-1 {
      border-bottom: 1px solid #e73d3e !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-darken-1 {
      border-left: 1px solid #e73d3e !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-darken-1 {
      border-right: 1px solid #e73d3e !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-darken-1 {
      border-right: 1px solid #e73d3e !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-darken-1 {
      border-left: 1px solid #e73d3e !important;
    }
    
    .overlay-danger.overlay-darken-1 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-darken-1 {
      background: #e73d3e;
      background: rgba(231, 61, 62, 0.6);
    }
    
    .text-danger.text-darken-2 {
      color: #e42728 !important;
    }
    
     .bg-danger.bg-darken-2 {
      background-color: #e42728 !important;
    }
    
     .border-danger.border-darken-2 {
      border: 1px solid #e42728 !important;
    }
    
     .border-top-danger.border-top-darken-2 {
      border-top: 1px solid #e42728 !important;
    }
    
     .border-bottom-danger.border-bottom-darken-2 {
      border-bottom: 1px solid #e42728 !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-darken-2 {
      border-left: 1px solid #e42728 !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-darken-2 {
      border-right: 1px solid #e42728 !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-darken-2 {
      border-right: 1px solid #e42728 !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-darken-2 {
      border-left: 1px solid #e42728 !important;
    }
    
    .overlay-danger.overlay-darken-2 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-darken-2 {
      background: #e42728;
      background: rgba(228, 39, 40, 0.6);
    }
    
    .text-danger.text-darken-3 {
      color: #d71a1c !important;
    }
    
     .bg-danger.bg-darken-3 {
      background-color: #d71a1c !important;
    }
    
     .border-danger.border-darken-3 {
      border: 1px solid #d71a1c !important;
    }
    
     .border-top-danger.border-top-darken-3 {
      border-top: 1px solid #d71a1c !important;
    }
    
     .border-bottom-danger.border-bottom-darken-3 {
      border-bottom: 1px solid #d71a1c !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-darken-3 {
      border-left: 1px solid #d71a1c !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-darken-3 {
      border-right: 1px solid #d71a1c !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-darken-3 {
      border-right: 1px solid #d71a1c !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-darken-3 {
      border-left: 1px solid #d71a1c !important;
    }
    
    .overlay-danger.overlay-darken-3 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-darken-3 {
      background: #d71a1c;
      background: rgba(215, 26, 28, 0.6);
    }
    
    .text-danger.text-darken-4 {
      color: #c01819 !important;
    }
    
     .bg-danger.bg-darken-4 {
      background-color: #c01819 !important;
    }
    
     .border-danger.border-darken-4 {
      border: 1px solid #c01819 !important;
    }
    
     .border-top-danger.border-top-darken-4 {
      border-top: 1px solid #c01819 !important;
    }
    
     .border-bottom-danger.border-bottom-darken-4 {
      border-bottom: 1px solid #c01819 !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-darken-4 {
      border-left: 1px solid #c01819 !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-darken-4 {
      border-right: 1px solid #c01819 !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-darken-4 {
      border-right: 1px solid #c01819 !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-darken-4 {
      border-left: 1px solid #c01819 !important;
    }
    
    .overlay-danger.overlay-darken-4 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-darken-4 {
      background: #c01819;
      background: rgba(192, 24, 25, 0.6);
    }
    
    .text-danger.text-accent-1 {
      color: #ffeef1 !important;
    }
    
     .bg-danger.bg-accent-1 {
      background-color: #ffeef1 !important;
    }
    
     .border-danger.border-accent-1 {
      border: 1px solid #ffeef1 !important;
    }
    
     .border-top-danger.border-top-accent-1 {
      border-top: 1px solid #ffeef1 !important;
    }
    
     .border-bottom-danger.border-bottom-accent-1 {
      border-bottom: 1px solid #ffeef1 !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-accent-1 {
      border-left: 1px solid #ffeef1 !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-accent-1 {
      border-right: 1px solid #ffeef1 !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-accent-1 {
      border-right: 1px solid #ffeef1 !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-accent-1 {
      border-left: 1px solid #ffeef1 !important;
    }
    
    .overlay-danger.overlay-accent-1 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-accent-1 {
      background: #ffeef1;
      background: rgba(255, 238, 241, 0.6);
    }
    
    .text-danger.text-accent-2 {
      color: #ffd6db !important;
    }
    
     .bg-danger.bg-accent-2 {
      background-color: #ffd6db !important;
    }
    
     .border-danger.border-accent-2 {
      border: 1px solid #ffd6db !important;
    }
    
     .border-top-danger.border-top-accent-2 {
      border-top: 1px solid #ffd6db !important;
    }
    
     .border-bottom-danger.border-bottom-accent-2 {
      border-bottom: 1px solid #ffd6db !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-accent-2 {
      border-left: 1px solid #ffd6db !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-accent-2 {
      border-right: 1px solid #ffd6db !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-accent-2 {
      border-right: 1px solid #ffd6db !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-accent-2 {
      border-left: 1px solid #ffd6db !important;
    }
    
    .overlay-danger.overlay-accent-2 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-accent-2 {
      background: #ffd6db;
      background: rgba(255, 214, 219, 0.6);
    }
    
    .text-danger.text-accent-3 {
      color: #ffecee !important;
    }
    
     .bg-danger.bg-accent-3 {
      background-color: #ffecee !important;
    }
    
     .border-danger.border-accent-3 {
      border: 1px solid #ffecee !important;
    }
    
     .border-top-danger.border-top-accent-3 {
      border-top: 1px solid #ffecee !important;
    }
    
     .border-bottom-danger.border-bottom-accent-3 {
      border-bottom: 1px solid #ffecee !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-accent-3 {
      border-left: 1px solid #ffecee !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-accent-3 {
      border-right: 1px solid #ffecee !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-accent-3 {
      border-right: 1px solid #ffecee !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-accent-3 {
      border-left: 1px solid #ffecee !important;
    }
    
    .overlay-danger.overlay-accent-3 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-accent-3 {
      background: #ffecee;
      background: rgba(255, 236, 238, 0.6);
    }
    
    .text-danger.text-accent-4 {
      color: #ffd3d7 !important;
    }
    
     .bg-danger.bg-accent-4 {
      background-color: #ffd3d7 !important;
    }
    
     .border-danger.border-accent-4 {
      border: 1px solid #ffd3d7 !important;
    }
    
     .border-top-danger.border-top-accent-4 {
      border-top: 1px solid #ffd3d7 !important;
    }
    
     .border-bottom-danger.border-bottom-accent-4 {
      border-bottom: 1px solid #ffd3d7 !important;
    }
    
    [dir=ltr] .border-left-danger.border-left-accent-4 {
      border-left: 1px solid #ffd3d7 !important;
    }
    
    [dir=rtl] .border-left-danger.border-left-accent-4 {
      border-right: 1px solid #ffd3d7 !important;
    }
    
    [dir=ltr] .border-right-danger.border-right-accent-4 {
      border-right: 1px solid #ffd3d7 !important;
    }
    
    [dir=rtl] .border-right-danger.border-right-accent-4 {
      border-left: 1px solid #ffd3d7 !important;
    }
    
    .overlay-danger.overlay-accent-4 {
      /* The Fallback */
    }
    
     .overlay-danger.overlay-accent-4 {
      background: #ffd3d7;
      background: rgba(255, 211, 215, 0.6);
    }
    
    .bg-gradient-dark,
    .btn-gradient-dark {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .bg-gradient-dark,  .btn-gradient-dark {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    
    [dir=ltr] .bg-gradient-dark, [dir=ltr] .btn-gradient-dark {
      background-image: linear-gradient(47deg, #4B4B4B, #1e1e1e);
    }
    
    [dir=rtl] .bg-gradient-dark, [dir=rtl] .btn-gradient-dark {
      background-image: linear-gradient(-47deg, #4B4B4B, #1e1e1e);
    }
     .dark-layout .bg-gradient-dark,  .dark-layout .btn-gradient-dark {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    [dir=ltr] .dark-layout .bg-gradient-dark, [dir=ltr] .dark-layout .btn-gradient-dark {
      background-image: linear-gradient(47deg, #1e1e1e, #4B4B4B);
    }
    [dir=rtl] .dark-layout .bg-gradient-dark, [dir=rtl] .dark-layout .btn-gradient-dark {
      background-image: linear-gradient(-47deg, #1e1e1e, #4B4B4B);
    }
    .bg-gradient-dark:hover, .bg-gradient-dark:active,
    .btn-gradient-dark:hover,
    .btn-gradient-dark:active {
      color: #fff;
    }
     .bg-gradient-dark:hover:not(.disabled):not(:disabled),  .btn-gradient-dark:hover:not(.disabled):not(:disabled) {
      transform: translateY(-2px);
    }
     .bg-gradient-dark:active,  .btn-gradient-dark:active {
      transform: translateY(0);
    }
     .bg-gradient-dark:active,  .bg-gradient-dark:focus,  .btn-gradient-dark:active,  .btn-gradient-dark:focus {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    [dir=ltr] .bg-gradient-dark:active, [dir=ltr] .bg-gradient-dark:focus, [dir=ltr] .btn-gradient-dark:active, [dir=ltr] .btn-gradient-dark:focus {
      background-image: linear-gradient(47deg, #1e1e1e, #4B4B4B);
    }
    [dir=rtl] .bg-gradient-dark:active, [dir=rtl] .bg-gradient-dark:focus, [dir=rtl] .btn-gradient-dark:active, [dir=rtl] .btn-gradient-dark:focus {
      background-image: linear-gradient(-47deg, #1e1e1e, #4B4B4B);
    }
    
    .bg-gradient-primary,
    .btn-gradient-primary {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .bg-gradient-primary,  .btn-gradient-primary {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    
    [dir=ltr] .bg-gradient-primary, [dir=ltr] .btn-gradient-primary {
      background-image: linear-gradient(47deg, #114A9F, #165fcd);
    }
    
    [dir=rtl] .bg-gradient-primary, [dir=rtl] .btn-gradient-primary {
      background-image: linear-gradient(-47deg, #114A9F, #165fcd);
    }
    .bg-gradient-primary:hover, .bg-gradient-primary:active,
    .btn-gradient-primary:hover,
    .btn-gradient-primary:active {
      color: #fff;
    }
     .bg-gradient-primary:hover:not(.disabled):not(:disabled),  .btn-gradient-primary:hover:not(.disabled):not(:disabled) {
      transform: translateY(-2px);
    }
     .bg-gradient-primary:active,  .btn-gradient-primary:active {
      transform: translateY(0);
    }
     .bg-gradient-primary:active,  .bg-gradient-primary:focus,  .btn-gradient-primary:active,  .btn-gradient-primary:focus {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    [dir=ltr] .bg-gradient-primary:active, [dir=ltr] .bg-gradient-primary:focus, [dir=ltr] .btn-gradient-primary:active, [dir=ltr] .btn-gradient-primary:focus {
      background-image: linear-gradient(47deg, #0c3571, #114A9F);
    }
    [dir=rtl] .bg-gradient-primary:active, [dir=rtl] .bg-gradient-primary:focus, [dir=rtl] .btn-gradient-primary:active, [dir=rtl] .btn-gradient-primary:focus {
      background-image: linear-gradient(-47deg, #0c3571, #114A9F);
    }
    
    .bg-gradient-secondary,
    .btn-gradient-secondary {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .bg-gradient-secondary,  .btn-gradient-secondary {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    
    [dir=ltr] .bg-gradient-secondary, [dir=ltr] .btn-gradient-secondary {
      background-image: linear-gradient(47deg, #9C9EA4, #b7b8bc);
    }
    
    [dir=rtl] .bg-gradient-secondary, [dir=rtl] .btn-gradient-secondary {
      background-image: linear-gradient(-47deg, #9C9EA4, #b7b8bc);
    }
    .bg-gradient-secondary:hover, .bg-gradient-secondary:active,
    .btn-gradient-secondary:hover,
    .btn-gradient-secondary:active {
      color: #fff;
    }
     .bg-gradient-secondary:hover:not(.disabled):not(:disabled),  .btn-gradient-secondary:hover:not(.disabled):not(:disabled) {
      transform: translateY(-2px);
    }
     .bg-gradient-secondary:active,  .btn-gradient-secondary:active {
      transform: translateY(0);
    }
     .bg-gradient-secondary:active,  .bg-gradient-secondary:focus,  .btn-gradient-secondary:active,  .btn-gradient-secondary:focus {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    [dir=ltr] .bg-gradient-secondary:active, [dir=ltr] .bg-gradient-secondary:focus, [dir=ltr] .btn-gradient-secondary:active, [dir=ltr] .btn-gradient-secondary:focus {
      background-image: linear-gradient(47deg, #81848c, #9C9EA4);
    }
    [dir=rtl] .bg-gradient-secondary:active, [dir=rtl] .bg-gradient-secondary:focus, [dir=rtl] .btn-gradient-secondary:active, [dir=rtl] .btn-gradient-secondary:focus {
      background-image: linear-gradient(-47deg, #81848c, #9C9EA4);
    }
    
    .bg-gradient-success,
    .btn-gradient-success {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .bg-gradient-success,  .btn-gradient-success {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    
    [dir=ltr] .bg-gradient-success, [dir=ltr] .btn-gradient-success {
      background-image: linear-gradient(47deg, #17B75E, #1ee375);
    }
    
    [dir=rtl] .bg-gradient-success, [dir=rtl] .btn-gradient-success {
      background-image: linear-gradient(-47deg, #17B75E, #1ee375);
    }
    .bg-gradient-success:hover, .bg-gradient-success:active,
    .btn-gradient-success:hover,
    .btn-gradient-success:active {
      color: #fff;
    }
     .bg-gradient-success:hover:not(.disabled):not(:disabled),  .btn-gradient-success:hover:not(.disabled):not(:disabled) {
      transform: translateY(-2px);
    }
     .bg-gradient-success:active,  .btn-gradient-success:active {
      transform: translateY(0);
    }
     .bg-gradient-success:active,  .bg-gradient-success:focus,  .btn-gradient-success:active,  .btn-gradient-success:focus {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    [dir=ltr] .bg-gradient-success:active, [dir=ltr] .bg-gradient-success:focus, [dir=ltr] .btn-gradient-success:active, [dir=ltr] .btn-gradient-success:focus {
      background-image: linear-gradient(47deg, #118a47, #17B75E);
    }
    [dir=rtl] .bg-gradient-success:active, [dir=rtl] .bg-gradient-success:focus, [dir=rtl] .btn-gradient-success:active, [dir=rtl] .btn-gradient-success:focus {
      background-image: linear-gradient(-47deg, #118a47, #17B75E);
    }
    
    .bg-gradient-info,
    .btn-gradient-info {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .bg-gradient-info,  .btn-gradient-info {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    
    [dir=ltr] .bg-gradient-info, [dir=ltr] .btn-gradient-info {
      background-image: linear-gradient(47deg, #00CFE8, #1ce7ff);
    }
    
    [dir=rtl] .bg-gradient-info, [dir=rtl] .btn-gradient-info {
      background-image: linear-gradient(-47deg, #00CFE8, #1ce7ff);
    }
    .bg-gradient-info:hover, .bg-gradient-info:active,
    .btn-gradient-info:hover,
    .btn-gradient-info:active {
      color: #fff;
    }
     .bg-gradient-info:hover:not(.disabled):not(:disabled),  .btn-gradient-info:hover:not(.disabled):not(:disabled) {
      transform: translateY(-2px);
    }
     .bg-gradient-info:active,  .btn-gradient-info:active {
      transform: translateY(0);
    }
     .bg-gradient-info:active,  .bg-gradient-info:focus,  .btn-gradient-info:active,  .btn-gradient-info:focus {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    [dir=ltr] .bg-gradient-info:active, [dir=ltr] .bg-gradient-info:focus, [dir=ltr] .btn-gradient-info:active, [dir=ltr] .btn-gradient-info:focus {
      background-image: linear-gradient(47deg, #00a1b5, #00CFE8);
    }
    [dir=rtl] .bg-gradient-info:active, [dir=rtl] .bg-gradient-info:focus, [dir=rtl] .btn-gradient-info:active, [dir=rtl] .btn-gradient-info:focus {
      background-image: linear-gradient(-47deg, #00a1b5, #00CFE8);
    }
    
    .bg-gradient-warning,
    .btn-gradient-warning {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .bg-gradient-warning,  .btn-gradient-warning {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    
    [dir=ltr] .bg-gradient-warning, [dir=ltr] .btn-gradient-warning {
      background-image: linear-gradient(47deg, #FDB913, #fdc846);
    }
    
    [dir=rtl] .bg-gradient-warning, [dir=rtl] .btn-gradient-warning {
      background-image: linear-gradient(-47deg, #FDB913, #fdc846);
    }
    .bg-gradient-warning:hover, .bg-gradient-warning:active,
    .btn-gradient-warning:hover,
    .btn-gradient-warning:active {
      color: #fff;
    }
     .bg-gradient-warning:hover:not(.disabled):not(:disabled),  .btn-gradient-warning:hover:not(.disabled):not(:disabled) {
      transform: translateY(-2px);
    }
     .bg-gradient-warning:active,  .btn-gradient-warning:active {
      transform: translateY(0);
    }
     .bg-gradient-warning:active,  .bg-gradient-warning:focus,  .btn-gradient-warning:active,  .btn-gradient-warning:focus {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    [dir=ltr] .bg-gradient-warning:active, [dir=ltr] .bg-gradient-warning:focus, [dir=ltr] .btn-gradient-warning:active, [dir=ltr] .btn-gradient-warning:focus {
      background-image: linear-gradient(47deg, #db9c02, #FDB913);
    }
    [dir=rtl] .bg-gradient-warning:active, [dir=rtl] .bg-gradient-warning:focus, [dir=rtl] .btn-gradient-warning:active, [dir=rtl] .btn-gradient-warning:focus {
      background-image: linear-gradient(-47deg, #db9c02, #FDB913);
    }
    
    .bg-gradient-danger,
    .btn-gradient-danger {
      color: #fff;
      transition: all 0.2s ease;
    }
    
     .bg-gradient-danger,  .btn-gradient-danger {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    
    [dir=ltr] .bg-gradient-danger, [dir=ltr] .btn-gradient-danger {
      background-image: linear-gradient(47deg, #EA5455, #f08182);
    }
    
    [dir=rtl] .bg-gradient-danger, [dir=rtl] .btn-gradient-danger {
      background-image: linear-gradient(-47deg, #EA5455, #f08182);
    }
    .bg-gradient-danger:hover, .bg-gradient-danger:active,
    .btn-gradient-danger:hover,
    .btn-gradient-danger:active {
      color: #fff;
    }
     .bg-gradient-danger:hover:not(.disabled):not(:disabled),  .btn-gradient-danger:hover:not(.disabled):not(:disabled) {
      transform: translateY(-2px);
    }
     .bg-gradient-danger:active,  .btn-gradient-danger:active {
      transform: translateY(0);
    }
     .bg-gradient-danger:active,  .bg-gradient-danger:focus,  .btn-gradient-danger:active,  .btn-gradient-danger:focus {
      background-repeat: repeat-x;
      background-repeat: repeat;
    }
    [dir=ltr] .bg-gradient-danger:active, [dir=ltr] .bg-gradient-danger:focus, [dir=ltr] .btn-gradient-danger:active, [dir=ltr] .btn-gradient-danger:focus {
      background-image: linear-gradient(47deg, #e42728, #EA5455);
    }
    [dir=rtl] .bg-gradient-danger:active, [dir=rtl] .bg-gradient-danger:focus, [dir=rtl] .btn-gradient-danger:active, [dir=rtl] .btn-gradient-danger:focus {
      background-image: linear-gradient(-47deg, #e42728, #EA5455);
    }
    
    html {
      font-size: 12px;
      height: 100%;
      letter-spacing: 0.01rem;
      /*
        * Blank page
        */
    }
    html body {
      height: 100%;
    }
    html body {
      background-color: #f8f8f8;
    }
    html[dir=ltr] body {
      direction: ltr;
    }
    html[dir=rtl] body {
      direction: rtl;
    }
    html body p {
      line-height: 1.5rem;
    }
    html .content {
      position: relative;
      transition: 300ms ease all;
      backface-visibility: hidden;
      min-height: calc(100% - 3.35rem);
    }
    html .content {
      padding: 0;
    }
    html[dir=ltr] .content {
      margin-left: 260px;
    }
    html[dir=rtl] .content {
      margin-right: 260px;
    }
    html .content.app-content {
      padding: calc(1rem + 4rem + 1.3rem) 1rem 0;
    }
    html .content.app-content.show-overlay .content-overlay {
      z-index: 10;
      opacity: 1;
    }
    html .content.app-content.show-overlay .content-overlay ~ .header-navbar-shadow {
      display: none;
    }
    html .content.app-content .content-overlay {
      position: fixed;
      opacity: 0;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      transition: all 0.7s, z-index 0s;
      z-index: -1;
    }
    html .content.app-content .content-overlay {
      background-color: rgba(34, 41, 47, 0.5);
      cursor: pointer;
    }
    html[dir=ltr] .content.app-content .content-overlay {
      left: 0;
      right: 0;
    }
    html[dir=rtl] .content.app-content .content-overlay {
      right: 0;
      left: 0;
    }
    html .content.app-content .content-area-wrapper {
      display: flex;
      position: relative;
      overflow: hidden;
    }
    html .content.app-content .content-area-wrapper .content-wrapper,
    html .content.app-content .content-area-wrapper .content-body {
      height: 100%;
    }
    html .content .body-content-overlay {
      top: 0;
      bottom: 0;
      position: absolute;
      display: block;
      z-index: 4;
      visibility: hidden;
      opacity: 0;
      transition: all 0.3s ease;
    }
    html[dir=ltr] .content .body-content-overlay {
      left: 0;
      right: 0;
    }
    html[dir=rtl] .content .body-content-overlay {
      right: 0;
      left: 0;
    }
    html .content .body-content-overlay.show {
      visibility: visible;
      transition: all 0.3s ease;
      opacity: 1;
    }
    html .content .body-content-overlay.show {
      background-color: rgba(34, 41, 47, 0.2);
      border-radius: 0.1785rem;
    }
    html .content .content-wrapper .content-header-title {
      font-weight: 500;
      color: #636363;
    }
    html[dir=ltr] .content .content-wrapper .content-header-title {
      padding-right: 1rem;
      border-right: 1px solid #d6dce1;
    }
    html[dir=rtl] .content .content-wrapper .content-header-title {
      padding-left: 1rem;
      border-left: 1px solid #d6dce1;
    }
    html .content .content-wrapper .content-header-right .dropdown-toggle::after {
      display: none;
    }
    html[dir=ltr] .content .content-wrapper .content-header-right .dropdown-toggle i, html[dir=ltr] .content .content-wrapper .content-header-right .dropdown-toggle svg {
      margin-right: 0;
    }
    html[dir=rtl] .content .content-wrapper .content-header-right .dropdown-toggle i, html[dir=rtl] .content .content-wrapper .content-header-right .dropdown-toggle svg {
      margin-left: 0;
    }
    html .content .content-wrapper .content-header-right .btn-icon {
      padding: 0.8rem;
    }
    html .content .content-wrapper .content-header-right .btn-icon i,
    html .content .content-wrapper .content-header-right .btn-icon svg {
      height: 1rem;
      width: 1rem;
    }
    html .navbar-floating.footer-static .app-content .content-area-wrapper,
    html .navbar-floating.footer-static .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 1) + 4rem + 3.35rem + 1.3rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 1) + 4rem + 3.35rem + 1.3rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-floating.footer-static .app-content .content-area-wrapper,
    html .navbar-floating.footer-static .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 1) - calc(0.8rem * 1)) + 4rem + 3.35rem + 1.3rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 1) - calc(0.8rem * 1)) + 4rem + 3.35rem + 1.3rem + 0rem ) );
      }
    }
    html .navbar-floating.footer-hidden .app-content .content-area-wrapper,
    html .navbar-floating.footer-hidden .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 0rem + 1.3rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 0rem + 1.3rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-floating.footer-hidden .app-content .content-area-wrapper,
    html .navbar-floating.footer-hidden .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 0rem + 1.3rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 0rem + 1.3rem + 0rem ) );
      }
    }
    html .navbar-floating.footer-fixed .app-content .content-area-wrapper,
    html .navbar-floating.footer-fixed .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 3.35rem + 1.3rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 3.35rem + 1.3rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-floating.footer-fixed .app-content .content-area-wrapper,
    html .navbar-floating.footer-fixed .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 3.35rem + 1.3rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 3.35rem + 1.3rem + 0rem ) );
      }
    }
    html .navbar-hidden .app-content {
      padding: 1rem 1rem 0 1rem !important;
    }
    html .navbar-hidden.footer-static .app-content .content-area-wrapper,
    html .navbar-hidden.footer-static .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 1) + 0rem + 3.35rem + 0rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 1) + 0rem + 3.35rem + 0rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-hidden.footer-static .app-content .content-area-wrapper,
    html .navbar-hidden.footer-static .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 1) - calc(0.8rem * 1)) + 0rem + 3.35rem + 0rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 1) - calc(0.8rem * 1)) + 0rem + 3.35rem + 0rem + 0rem ) );
      }
    }
    html .navbar-hidden.footer-hidden .app-content .content-area-wrapper,
    html .navbar-hidden.footer-hidden .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 0rem + 0rem + 0rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 0rem + 0rem + 0rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-hidden.footer-hidden .app-content .content-area-wrapper,
    html .navbar-hidden.footer-hidden .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 0rem + 0rem + 0rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 0rem + 0rem + 0rem + 0rem ) );
      }
    }
    html .navbar-hidden.footer-fixed .app-content .content-area-wrapper,
    html .navbar-hidden.footer-fixed .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 0rem + 3.35rem + 0rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 0rem + 3.35rem + 0rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-hidden.footer-fixed .app-content .content-area-wrapper,
    html .navbar-hidden.footer-fixed .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 0rem + 3.35rem + 0rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 0rem + 3.35rem + 0rem + 0rem ) );
      }
    }
    html .navbar-static .main-menu {
      top: 0;
    }
    html .navbar-static .content {
      min-height: calc(100% - calc(4rem + 3.35rem));
    }
    html .navbar-static .app-content {
      padding: 1rem 1rem 0 1rem;
    }
    html .navbar-static.footer-static .app-content .content-area-wrapper,
    html .navbar-static.footer-static .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 1) + 4rem + 3.35rem + 0rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 1) + 4rem + 3.35rem + 0rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-static.footer-static .app-content .content-area-wrapper,
    html .navbar-static.footer-static .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 1) - calc(0.8rem * 1)) + 4rem + 3.35rem + 0rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 1) - calc(0.8rem * 1)) + 4rem + 3.35rem + 0rem + 0rem ) );
      }
    }
    html .navbar-static.footer-hidden .app-content .content-area-wrapper,
    html .navbar-static.footer-hidden .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 0rem + 0rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 0rem + 0rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-static.footer-hidden .app-content .content-area-wrapper,
    html .navbar-static.footer-hidden .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 0rem + 0rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 0rem + 0rem + 0rem ) );
      }
    }
    html .navbar-static.footer-fixed .app-content .content-area-wrapper,
    html .navbar-static.footer-fixed .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 3.35rem + 0rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 3.35rem + 0rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-static.footer-fixed .app-content .content-area-wrapper,
    html .navbar-static.footer-fixed .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 3.35rem + 0rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 3.35rem + 0rem + 0rem ) );
      }
    }
    html .navbar-sticky .app-content {
      padding: calc(1rem + 4rem) 14px 0 14px;
    }
    html .navbar-sticky.footer-static .app-content .content-area-wrapper,
    html .navbar-sticky.footer-static .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 1) + 4rem + 3.35rem + 0rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 1) + 4rem + 3.35rem + 0rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-sticky.footer-static .app-content .content-area-wrapper,
    html .navbar-sticky.footer-static .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 1) - calc(0.8rem * 1)) + 4rem + 3.35rem + 0rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 1) - calc(0.8rem * 1)) + 4rem + 3.35rem + 0rem + 0rem ) );
      }
    }
    html .navbar-sticky.footer-hidden .app-content .content-area-wrapper,
    html .navbar-sticky.footer-hidden .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 0rem + 0rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 0rem + 0rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-sticky.footer-hidden .app-content .content-area-wrapper,
    html .navbar-sticky.footer-hidden .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 0rem + 0rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 0rem + 0rem + 0rem ) );
      }
    }
    html .navbar-sticky.footer-fixed .app-content .content-area-wrapper,
    html .navbar-sticky.footer-fixed .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 3.35rem + 0rem + 0rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 3.35rem + 0rem + 0rem ) );
    }
    @media (max-width: 575.98px) {
      html .navbar-sticky.footer-fixed .app-content .content-area-wrapper,
    html .navbar-sticky.footer-fixed .app-content .kanban-wrapper {
        height: calc( 100vh - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 3.35rem + 0rem + 0rem ) );
        height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1rem * 2) - calc(0.8rem * 2)) + 4rem + 3.35rem + 0rem + 0rem ) );
      }
    }
    html[dir=ltr] .navbar-static .nav.header-navbar .navbar-container, html[dir=ltr] .navbar-sticky .nav.header-navbar .navbar-container {
      padding-left: 1.6rem;
      padding-right: 1.6rem;
    }
    html[dir=rtl] .navbar-static .nav.header-navbar .navbar-container, html[dir=rtl] .navbar-sticky .nav.header-navbar .navbar-container {
      padding-right: 1.6rem;
      padding-left: 1.6rem;
    }
    html .navbar-static .nav.header-navbar .navbar-container .search-input .search-list.show,
    html .navbar-sticky .nav.header-navbar .navbar-container .search-input .search-list.show {
      width: 98%;
    }
    html[dir=ltr] .navbar-static .nav.header-navbar .navbar-container .search-input .search-list.show, html[dir=ltr] .navbar-sticky .nav.header-navbar .navbar-container .search-input .search-list.show {
      left: 1%;
    }
    html[dir=rtl] .navbar-static .nav.header-navbar .navbar-container .search-input .search-list.show, html[dir=rtl] .navbar-sticky .nav.header-navbar .navbar-container .search-input .search-list.show {
      right: 1%;
    }
    html .footer-fixed .content.app-content {
      padding-bottom: 3.35rem !important;
    }
    html [data-col="1-column"] .header-navbar {
      width: 100%;
    }
    html[dir=ltr] [data-col="1-column"] .header-navbar {
      left: 0 !important;
    }
    html[dir=rtl] [data-col="1-column"] .header-navbar {
      right: 0 !important;
    }
    html [data-col="1-column"] .header-navbar.floating-nav {
      width: calc( 100vw - (100vw - 100%) - calc(1rem * 2) ) !important;
    }
    html[dir=ltr] [data-col="1-column"] .content, html[dir=ltr] [data-col="1-column"] .footer {
      margin-left: 0px !important;
    }
    html[dir=rtl] [data-col="1-column"] .content, html[dir=rtl] [data-col="1-column"] .footer {
      margin-right: 0px !important;
    }
    html [data-col="1-column"].horizontal-layout .header-navbar {
      width: 100% !important;
    }
    html [data-col="1-column"].horizontal-layout .app-content {
      padding: calc(1rem + 4rem + 1.3rem) 1rem 0 1rem !important;
    }
    html [data-col="1-column"].horizontal-layout.footer-fixed .app-content {
      padding: calc(1rem + 4rem + 1.3rem) 1rem 3.35rem 1rem !important;
    }
    html[dir=ltr] .blank-page .content {
      margin-left: 0;
    }
    html[dir=rtl] .blank-page .content {
      margin-right: 0;
    }
    html .blank-page .content.app-content {
      overflow: overlay;
      overflow-x: hidden;
      transition: none;
    }
    html .blank-page .content.app-content {
      padding: 0 !important;
    }
    html .blank-page .content.app-content .header-navbar-shadow {
      display: none;
    }
    html .blank-page .content-wrapper {
      padding: 0 !important;
    }
    html .blank-page .content-wrapper .flexbox-container {
      display: flex;
      align-items: center;
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
      justify-content: center;
    }
    html .pace .pace-progress {
      background: #114A9F;
    }
    
    .app-content.center-layout {
      overflow: hidden;
    }
    
    /*
    * Col 3 layout for detached and general type
    */
    @media (min-width: 992px) {
      body .content-right {
        width: calc(100vw - (100vw - 100%) - 260px);
      }
      [dir=ltr] body .content-right {
        float: right;
      }
      [dir=rtl] body .content-right {
        float: left;
      }
      body .content-left {
        width: calc(100vw - (100vw - 100%) - 260px);
      }
      [dir=ltr] body .content-left {
        float: left;
      }
      [dir=rtl] body .content-left {
        float: right;
      }
      body .content-detached {
        width: 100%;
      }
      [dir=ltr] body .content-detached.content-right {
        float: right;
        margin-left: -260px;
      }
      [dir=rtl] body .content-detached.content-right {
        float: left;
        margin-right: -260px;
      }
      [dir=ltr] body .content-detached.content-right .content-body {
        margin-left: calc(260px + 1rem);
      }
      [dir=rtl] body .content-detached.content-right .content-body {
        margin-right: calc(260px + 1rem);
      }
      [dir=ltr] body .content-detached.content-left {
        float: left;
        margin-right: -260px;
      }
      [dir=rtl] body .content-detached.content-left {
        float: right;
        margin-left: -260px;
      }
      [dir=ltr] body .content-detached.content-left .content-body {
        margin-right: calc(260px + 1rem);
      }
      [dir=rtl] body .content-detached.content-left .content-body {
        margin-left: calc(260px + 1rem);
      }
      body .show-overlay .content-overlay {
        z-index: 99 !important;
      }
    
      .sidebar-right.sidebar-sticky {
        width: 260px !important;
      }
    
       .sidebar-right.sidebar-sticky {
        margin-top: 5.25rem;
      }
    
      [dir=ltr] .sidebar-right.sidebar-sticky {
        float: right !important;
        margin-left: -260px;
      }
    
      [dir=rtl] .sidebar-right.sidebar-sticky {
        float: left !important;
        margin-right: -260px;
      }
    }
    @media (max-width: 575.98px) {
      html body .app-content {
        padding: calc(1rem - 0.8rem + 4rem + 1.3rem) calc(1rem - 0.8rem) 0 calc(1rem - 0.8rem) !important;
      }
    
      html body.navbar-static .app-content {
        padding: calc(1rem - 0.8rem) calc(1rem - 0.8rem) 0 calc(1rem - 0.8rem) !important;
      }
    
      html body.navbar-sticky .app-content {
        padding: calc(1rem - 0.8rem + 4rem) calc(1rem - 0.8rem) 0 calc(1rem - 0.8rem) !important;
      }
    
      html body.navbar-hidden .app-content {
        padding: calc(1rem - 0.8rem) calc(1rem - 0.8rem) 0 calc(1rem - 0.8rem) !important;
      }
    }
    @media (max-width: 575.98px) {
      [dir=ltr] .navbar-static .app-content .header-navbar .navbar-container, [dir=ltr] .navbar-sticky .app-content .header-navbar .navbar-container {
        padding-left: 1rem;
        padding-right: 0.5rem;
      }
      [dir=rtl] .navbar-static .app-content .header-navbar .navbar-container, [dir=rtl] .navbar-sticky .app-content .header-navbar .navbar-container {
        padding-right: 1rem;
        padding-left: 0.5rem;
      }
    }
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      html.full-screen {
        width: 100%;
      }
      html.full-screen .content.app-content {
        height: 100%;
        overflow: scroll;
        overflow-x: hidden;
      }
    }
    /*=========================================================================================
        File Name: sidebar.scss
        Description: content sidebar specific scss.
    
    ==========================================================================================*/
    .sidebar {
      position: relative;
      width: 100%;
      height: 100%;
    }
    @media (min-width: 992px) {
      .sidebar {
        vertical-align: top;
      }
    }
    
    .sidebar-fixed {
      position: fixed;
      height: 100%;
      overflow: scroll;
    }
    
    .sidenav-overlay {
      position: fixed;
      top: 0;
      height: 120vh;
      z-index: 997;
      display: block;
      visibility: hidden;
      opacity: 0;
      transition: all 0.5s ease;
    }
    
     .sidenav-overlay {
      background-color: rgba(34, 41, 47, 0.5);
    }
    
    [dir=ltr] .sidenav-overlay {
      left: 0;
      right: 0;
    }
    
    [dir=rtl] .sidenav-overlay {
      right: 0;
      left: 0;
    }
    .sidenav-overlay.show {
      opacity: 1;
      visibility: visible;
      transition: all 0.5s ease;
    }
    
    .drag-target {
      height: 100%;
      width: 40px;
      position: fixed;
      top: 0;
      z-index: 1036;
    }
    
    [dir=ltr] .drag-target {
      left: -10px;
    }
    
    [dir=rtl] .drag-target {
      right: -10px;
    }
    
    .sidebar-detached .sidebar {
      width: 260px;
    }
    
    @media (min-width: 992px) {
      [dir=ltr] .sidebar-left {
        float: left;
      }
      [dir=rtl] .sidebar-left {
        float: right;
      }
    
      [dir=ltr] .sidebar-right {
        float: right;
      }
    
      [dir=rtl] .sidebar-right {
        float: left;
      }
    }
    @media (max-width: 991.98px) {
      .sidebar-detached .sidebar {
        width: 100%;
      }
    }
    footer.footer {
      min-height: 3.35rem;
      transition: 300ms ease all;
    }
     footer.footer {
      padding: 0.8rem 1rem;
    }
    footer.footer span i,
    footer.footer span svg {
      height: 1.51rem;
      width: 1.51rem;
      font-size: 1.51rem;
      color: #EA5455;
    }
    [dir=ltr] footer.footer span i, [dir=ltr] footer.footer span svg {
      margin-left: 0.5rem;
    }
    [dir=rtl] footer.footer span i, [dir=rtl] footer.footer span svg {
      margin-right: 0.5rem;
    }
     footer.footer .scroll-top {
      padding: 0.81rem 0.83rem;
    }
     footer.footer-shadow {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    }
     footer.footer-border {
      border-top: 1px solid #ebe9f1;
    }
    
    .footer-fixed footer {
      position: fixed !important;
      z-index: 1030;
      bottom: 0;
    }
    
    [dir=ltr] .footer-fixed footer {
      right: 0;
      left: 0;
    }
    
    [dir=rtl] .footer-fixed footer {
      left: 0;
      right: 0;
    }
     .footer-fixed footer.footer-light {
      background: #fff;
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    }
    .footer-fixed footer.footer-dark {
      color: #fff;
    }
     .footer-fixed footer.footer-dark {
      background: #b8c2cc;
    }
    
    .scroll-top {
      position: fixed;
      bottom: 5%;
      display: none;
      z-index: 99;
    }
    
    [dir=ltr] .scroll-top {
      right: 30px;
    }
    
    [dir=rtl] .scroll-top {
      left: 30px;
    }
    
    /*=========================================================================================
        File Name: navigation.scss
        Description: Common mixin for menus, contain dark and light version scss.
    
    ==========================================================================================*/
    .main-menu {
      z-index: 1031;
      position: absolute;
      display: table-cell;
      height: 100%;
      overflow: hidden;
    }
     .main-menu {
      margin-top: 4rem;
    }
    .main-menu.menu-light {
      color: #424244;
    }
     .main-menu.menu-light {
      background: #fff;
    }
     .main-menu.menu-light .navigation {
      background: #fff;
    }
    .main-menu.menu-light .navigation .navigation-header {
      color: #78787c;
      line-height: 1.5;
      letter-spacing: 0.01rem;
    }
     .main-menu.menu-light .navigation .navigation-header {
      padding: 0;
    }
    [dir=ltr] .main-menu.menu-light .navigation .navigation-header {
      margin: calc(1rem + 0.286rem) 0 0.8rem 1.2rem;
    }
    [dir=rtl] .main-menu.menu-light .navigation .navigation-header {
      margin: calc(1rem + 0.286rem) 1.2rem 0.8rem 0;
    }
    .main-menu.menu-light .navigation .navigation-header span {
      font-weight: 500;
    }
    .main-menu.menu-light .navigation li.has-sub > a {
      transition: all 0.5s ease, background 0s, color 0s;
    }
    .main-menu.menu-light .navigation li a {
      color: #363637;
      line-height: 1.45;
    }
     .main-menu.menu-light .navigation li a {
      padding: 10px 15px 10px 15px;
    }
    .main-menu.menu-light .navigation li a span.menu-sub-title {
      color: #8e8e91;
    }
    .main-menu.menu-light .navigation li a > * {
      transition: transform 0.25s ease;
    }
     .main-menu.menu-light .navigation > li > a .label {
      margin-top: 4px;
    }
    [dir=ltr] .main-menu.menu-light .navigation > li > a .label {
      margin-right: 5px;
    }
    [dir=rtl] .main-menu.menu-light .navigation > li > a .label {
      margin-left: 5px;
    }
    .main-menu.menu-light .navigation > li > a i,
    .main-menu.menu-light .navigation > li > a svg {
      position: relative;
      top: -3px;
    }
     .main-menu.menu-light .navigation > li > ul li:first-of-type {
      margin-top: 7px !important;
    }
    [dir=ltr] .main-menu.menu-light .navigation > li > ul li:not(.has-sub) {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .main-menu.menu-light .navigation > li > ul li:not(.has-sub) {
      margin: 0 15px 0 0;
    }
    [dir=ltr] .main-menu.menu-light .navigation > li > ul li.has-sub > a {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .main-menu.menu-light .navigation > li > ul li.has-sub > a {
      margin: 0 15px 0 0;
    }
    [dir=ltr] .main-menu.menu-light .navigation > li > ul li.has-sub > ul > li {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .main-menu.menu-light .navigation > li > ul li.has-sub > ul > li {
      margin: 0 15px 0 0;
    }
    .main-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a, .main-menu.menu-light .navigation > li.sidebar-group-active > a {
      color: #114A9F;
    }
     .main-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a,  .main-menu.menu-light .navigation > li.sidebar-group-active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 6px;
    }
    .main-menu.menu-light .navigation > li:not(.open) > ul {
      display: none;
    }
     .main-menu.menu-light .navigation > li:not(.open) > ul .active {
      background: transparent;
      box-shadow: none;
    }
    .main-menu.menu-light .navigation > li.active {
      z-index: 1;
    }
    .main-menu.menu-light .navigation > li.active > a {
      color: #114A9F;
      font-weight: 400;
    }
     .main-menu.menu-light .navigation > li.active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 4px;
    }
    .main-menu.menu-light .navigation > li.level1.open {
      z-index: 1;
    }
    .main-menu.menu-light .navigation > li.level1.open > a {
      color: #114A9F;
      font-weight: 400;
    }
     .main-menu.menu-light .navigation > li.level1.open > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 4px;
    }
     .main-menu.menu-light .navigation > li .active {
      background: #f0f0f0;
    }
    .main-menu.menu-light .navigation > li .active > a {
      color: #114A9F;
    }
     .main-menu.menu-light .navigation > li .active > a {
      margin-bottom: 0;
    }
     .main-menu.menu-light .navigation > li .active .hover > a,  .main-menu.menu-light .navigation > li .active :hover > a {
      background: whitesmoke;
    }
     .main-menu.menu-light .navigation > li ul {
      padding: 0;
      margin: 0;
    }
    .main-menu.menu-light .navigation > li ul li {
      color: #424244;
    }
     .main-menu.menu-light .navigation > li ul li {
      background: transparent;
    }
    [dir=ltr] .main-menu.menu-light .navigation > li ul li > a {
      padding: 10px 15px 10px 20px;
    }
    [dir=rtl] .main-menu.menu-light .navigation > li ul li > a {
      padding: 10px 20px 10px 15px;
    }
    [dir=ltr] .main-menu.menu-light .navigation > li ul li ul a {
      padding: 10px 15px 10px 53px;
    }
    [dir=rtl] .main-menu.menu-light .navigation > li ul li ul a {
      padding: 10px 53px 10px 15px;
    }
    .main-menu.menu-light .navigation > li ul .has-sub:not(.open) > ul {
      display: none;
    }
     .main-menu.menu-light .navigation > li ul .has-sub:not(.open) > ul .active {
      background: transparent;
      box-shadow: none;
    }
    .main-menu.menu-light .navigation > li ul .open > a,
    .main-menu.menu-light .navigation > li ul .sidebar-group-active > a {
      color: #114A9F;
    }
     .main-menu.menu-light .navigation > li ul .open > a,  .main-menu.menu-light .navigation > li ul .sidebar-group-active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 6px;
    }
    .main-menu.menu-light .navigation > li ul .open > ul,
    .main-menu.menu-light .navigation > li ul .sidebar-group-active > ul {
      display: block;
    }
    .main-menu.menu-light .navigation > li ul .open > ul .open > ul,
    .main-menu.menu-light .navigation > li ul .sidebar-group-active > ul .open > ul {
      display: block;
    }
    .main-menu.menu-light .navigation > li ul .hover > a, .main-menu.menu-light .navigation > li ul:hover > a {
      color: #4c4c4e;
    }
    .main-menu.menu-light .navigation > li ul .active {
      z-index: 1;
    }
     .main-menu.menu-light .navigation > li ul .active {
      border-radius: 4px;
    }
    .main-menu.menu-light .navigation > li ul .active > a {
      color: #114A9F;
    }
     .main-menu.menu-light .navigation > li ul .active > a {
      background: rgba(17, 74, 159, 0.12);
    }
    .main-menu.menu-dark {
      color: #dcdcdc;
    }
     .main-menu.menu-dark {
      background: #10163a;
    }
     .main-menu.menu-dark .navigation {
      background: #10163a;
    }
    .main-menu.menu-dark .navigation .navigation-header {
      color: white;
      line-height: 1.5;
      letter-spacing: 0.01rem;
    }
     .main-menu.menu-dark .navigation .navigation-header {
      padding: 0;
    }
    [dir=ltr] .main-menu.menu-dark .navigation .navigation-header {
      margin: calc(1rem + 0.286rem) 0 0.8rem 1.2rem;
    }
    [dir=rtl] .main-menu.menu-dark .navigation .navigation-header {
      margin: calc(1rem + 0.286rem) 1.2rem 0.8rem 0;
    }
    .main-menu.menu-dark .navigation .navigation-header span {
      font-weight: 500;
    }
    .main-menu.menu-dark .navigation li.has-sub > a {
      transition: all 0.5s ease, background 0s, color 0s;
    }
    .main-menu.menu-dark .navigation li a {
      color: #d0d0d0;
      line-height: 1.45;
    }
     .main-menu.menu-dark .navigation li a {
      padding: 10px 15px 10px 15px;
    }
    .main-menu.menu-dark .navigation li a span.menu-sub-title {
      color: white;
    }
    .main-menu.menu-dark .navigation li a > * {
      transition: transform 0.25s ease;
    }
     .main-menu.menu-dark .navigation > li > a .label {
      margin-top: 4px;
    }
    [dir=ltr] .main-menu.menu-dark .navigation > li > a .label {
      margin-right: 5px;
    }
    [dir=rtl] .main-menu.menu-dark .navigation > li > a .label {
      margin-left: 5px;
    }
    .main-menu.menu-dark .navigation > li > a i,
    .main-menu.menu-dark .navigation > li > a svg {
      position: relative;
      top: -3px;
    }
     .main-menu.menu-dark .navigation > li > ul li:first-of-type {
      margin-top: 7px !important;
    }
    [dir=ltr] .main-menu.menu-dark .navigation > li > ul li:not(.has-sub) {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .main-menu.menu-dark .navigation > li > ul li:not(.has-sub) {
      margin: 0 15px 0 0;
    }
    [dir=ltr] .main-menu.menu-dark .navigation > li > ul li.has-sub > a {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .main-menu.menu-dark .navigation > li > ul li.has-sub > a {
      margin: 0 15px 0 0;
    }
    [dir=ltr] .main-menu.menu-dark .navigation > li > ul li.has-sub > ul > li {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .main-menu.menu-dark .navigation > li > ul li.has-sub > ul > li {
      margin: 0 15px 0 0;
    }
    .main-menu.menu-dark .navigation > li.open:not(.menu-item-closing) > a, .main-menu.menu-dark .navigation > li.sidebar-group-active > a {
      color: #114A9F;
    }
     .main-menu.menu-dark .navigation > li.open:not(.menu-item-closing) > a,  .main-menu.menu-dark .navigation > li.sidebar-group-active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 6px;
    }
    .main-menu.menu-dark .navigation > li:not(.open) > ul {
      display: none;
    }
     .main-menu.menu-dark .navigation > li:not(.open) > ul .active {
      background: transparent;
      box-shadow: none;
    }
    .main-menu.menu-dark .navigation > li.active {
      z-index: 1;
    }
    .main-menu.menu-dark .navigation > li.active > a {
      color: #114A9F;
      font-weight: 400;
    }
     .main-menu.menu-dark .navigation > li.active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 4px;
    }
    .main-menu.menu-dark .navigation > li.level1.open {
      z-index: 1;
    }
    .main-menu.menu-dark .navigation > li.level1.open > a {
      color: #114A9F;
      font-weight: 400;
    }
     .main-menu.menu-dark .navigation > li.level1.open > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 4px;
    }
     .main-menu.menu-dark .navigation > li .active {
      background: #090d22;
    }
    .main-menu.menu-dark .navigation > li .active > a {
      color: #114A9F;
    }
     .main-menu.menu-dark .navigation > li .active > a {
      margin-bottom: 0;
    }
     .main-menu.menu-dark .navigation > li .active .hover > a,  .main-menu.menu-dark .navigation > li .active :hover > a {
      background: #0c102a;
    }
     .main-menu.menu-dark .navigation > li ul {
      padding: 0;
      margin: 0;
    }
    .main-menu.menu-dark .navigation > li ul li {
      color: #dcdcdc;
    }
     .main-menu.menu-dark .navigation > li ul li {
      background: transparent;
    }
    [dir=ltr] .main-menu.menu-dark .navigation > li ul li > a {
      padding: 10px 15px 10px 20px;
    }
    [dir=rtl] .main-menu.menu-dark .navigation > li ul li > a {
      padding: 10px 20px 10px 15px;
    }
    [dir=ltr] .main-menu.menu-dark .navigation > li ul li ul a {
      padding: 10px 15px 10px 53px;
    }
    [dir=rtl] .main-menu.menu-dark .navigation > li ul li ul a {
      padding: 10px 53px 10px 15px;
    }
    .main-menu.menu-dark .navigation > li ul .has-sub:not(.open) > ul {
      display: none;
    }
     .main-menu.menu-dark .navigation > li ul .has-sub:not(.open) > ul .active {
      background: transparent;
      box-shadow: none;
    }
    .main-menu.menu-dark .navigation > li ul .open > a,
    .main-menu.menu-dark .navigation > li ul .sidebar-group-active > a {
      color: #114A9F;
    }
     .main-menu.menu-dark .navigation > li ul .open > a,  .main-menu.menu-dark .navigation > li ul .sidebar-group-active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 6px;
    }
    .main-menu.menu-dark .navigation > li ul .open > ul,
    .main-menu.menu-dark .navigation > li ul .sidebar-group-active > ul {
      display: block;
    }
    .main-menu.menu-dark .navigation > li ul .open > ul .open > ul,
    .main-menu.menu-dark .navigation > li ul .sidebar-group-active > ul .open > ul {
      display: block;
    }
    .main-menu.menu-dark .navigation > li ul .hover > a, .main-menu.menu-dark .navigation > li ul:hover > a {
      color: #e6e6e6;
    }
    .main-menu.menu-dark .navigation > li ul .active {
      z-index: 1;
    }
     .main-menu.menu-dark .navigation > li ul .active {
      border-radius: 4px;
    }
    .main-menu.menu-dark .navigation > li ul .active > a {
      color: #114A9F;
    }
     .main-menu.menu-dark .navigation > li ul .active > a {
      background: rgba(17, 74, 159, 0.12);
    }
    .main-menu.menu-fixed {
      position: fixed;
    }
    .main-menu.menu-static {
      height: 100%;
    }
     .main-menu.menu-static {
      padding-bottom: calc(100% - 20rem);
    }
    .main-menu.menu-static .main-menu-content {
      height: unset !important;
    }
     .main-menu.menu-shadow {
      box-shadow: 0 0 15px 0 rgba(34, 41, 47, 0.05);
    }
    [dir=ltr] .main-menu.menu-border {
      border-right: 1px solid #ebe9f1;
    }
    [dir=rtl] .main-menu.menu-border {
      border-left: 1px solid #ebe9f1;
    }
    .main-menu .shadow-bottom {
      display: none;
      position: absolute;
      z-index: 2;
      height: 50px;
      width: 100%;
      pointer-events: none;
      filter: blur(5px);
    }
     .main-menu .shadow-bottom {
      margin-top: -0.7rem;
      background: linear-gradient(#fff 41%, rgba(255, 255, 255, 0.11) 95%, rgba(255, 255, 255, 0));
    }
     .bordered-layout .main-menu .shadow-bottom {
      background: linear-gradient(#f8f8f8 41%, rgba(255, 255, 255, 0.11) 95%, rgba(255, 255, 255, 0));
    }
    .main-menu.menu-native-scroll .main-menu-content {
      overflow-y: scroll !important;
    }
    .main-menu .navbar-header {
      height: 100%;
      width: 260px;
      height: 4rem;
      position: relative;
      transition: 300ms ease all, background 0s;
    }
     .main-menu .navbar-header {
      padding: 0.35rem 1rem;
    }
    .main-menu .navbar-header .navbar-brand {
      display: flex;
      align-items: center;
      font-size: inherit;
    }
     .main-menu .navbar-header .navbar-brand {
      margin-top: 1.35rem;
    }
    .main-menu .navbar-header .navbar-brand .brand-logo img {
      max-width: 36px;
    }
    .main-menu .navbar-header .navbar-brand .brand-text {
      color: #114A9F;
      font-weight: 600;
      letter-spacing: 0.01rem;
      font-size: 1.45rem;
    }
     .main-menu .navbar-header .navbar-brand .brand-text {
      margin-bottom: 0;
    }
    [dir=ltr] .main-menu .navbar-header .navbar-brand .brand-text {
      padding-left: 1rem;
      animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
    }
    [dir=rtl] .main-menu .navbar-header .navbar-brand .brand-text {
      padding-right: 1rem;
      animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
    }
    [dir=ltr] .main-menu .navbar-header .modern-nav-toggle {
      animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
    }
    [dir=rtl] .main-menu .navbar-header .modern-nav-toggle {
      animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
    }
    .main-menu .main-menu-content {
      height: calc(100% - 4rem) !important;
      position: relative;
    }
    .main-menu .main-menu-content .ps__rail-y {
      z-index: 3;
    }
    .main-menu ul {
      list-style: none;
    }
     .main-menu ul {
      margin: 0;
      padding: 0;
    }
    .main-menu ul.navigation-main {
      overflow-x: hidden;
      font-weight: 400;
    }
     .main-menu ul.navigation-main {
      padding-bottom: 0.75rem;
    }
     .main-menu ul.navigation-main > li:first-child {
      margin-top: 0.5rem;
    }
    .main-menu ul.navigation-main > li.active > a > span {
      font-weight: 500;
    }
    .main-menu a {
      outline: none;
    }
    .main-menu a:hover, .main-menu a:focus {
      text-decoration: none;
    }
    
    .second-menu {
      z-index: 1032;
      position: absolute;
      display: table-cell;
      height: 100%;
      overflow: hidden;
      width: 260px;
    }
    
     .second-menu {
      margin-top: 3.9rem;
    }
    
    [dir=ltr] .second-menu {
      margin-left: 260px;
    }
    
    [dir=rtl] .second-menu {
      margin-right: 260px;
    }
    .second-menu.menu-light {
      color: #424244;
    }
     .second-menu.menu-light {
      background: #fff;
    }
     .second-menu.menu-light .navigation {
      background: #fff;
    }
    .second-menu.menu-light .navigation .navigation-header {
      color: #78787c;
      line-height: 1.5;
      letter-spacing: 0.01rem;
    }
     .second-menu.menu-light .navigation .navigation-header {
      padding: 0;
    }
    [dir=ltr] .second-menu.menu-light .navigation .navigation-header {
      margin: calc(1rem + 0.286rem) 0 0.8rem 1.2rem;
    }
    [dir=rtl] .second-menu.menu-light .navigation .navigation-header {
      margin: calc(1rem + 0.286rem) 1.2rem 0.8rem 0;
    }
    .second-menu.menu-light .navigation .navigation-header span {
      font-weight: 500;
    }
    .second-menu.menu-light .navigation li.has-sub > a {
      transition: all 0.5s ease, background 0s, color 0s;
    }
    .second-menu.menu-light .navigation li a {
      color: #363637;
      line-height: 1.45;
    }
     .second-menu.menu-light .navigation li a {
      padding: 10px 15px 10px 15px;
    }
    .second-menu.menu-light .navigation li a span.menu-sub-title {
      color: #8e8e91;
    }
    .second-menu.menu-light .navigation li a > * {
      transition: transform 0.25s ease;
    }
     .second-menu.menu-light .navigation > li > a .label {
      margin-top: 4px;
    }
    [dir=ltr] .second-menu.menu-light .navigation > li > a .label {
      margin-right: 5px;
    }
    [dir=rtl] .second-menu.menu-light .navigation > li > a .label {
      margin-left: 5px;
    }
    .second-menu.menu-light .navigation > li > a i,
    .second-menu.menu-light .navigation > li > a svg {
      position: relative;
      top: -3px;
    }
     .second-menu.menu-light .navigation > li > ul li:first-of-type {
      margin-top: 7px !important;
    }
    [dir=ltr] .second-menu.menu-light .navigation > li > ul li:not(.has-sub) {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .second-menu.menu-light .navigation > li > ul li:not(.has-sub) {
      margin: 0 15px 0 0;
    }
    [dir=ltr] .second-menu.menu-light .navigation > li > ul li.has-sub > a {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .second-menu.menu-light .navigation > li > ul li.has-sub > a {
      margin: 0 15px 0 0;
    }
    [dir=ltr] .second-menu.menu-light .navigation > li > ul li.has-sub > ul > li {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .second-menu.menu-light .navigation > li > ul li.has-sub > ul > li {
      margin: 0 15px 0 0;
    }
    .second-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a, .second-menu.menu-light .navigation > li.sidebar-group-active > a {
      color: #114A9F;
    }
     .second-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a,  .second-menu.menu-light .navigation > li.sidebar-group-active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 6px;
    }
    .second-menu.menu-light .navigation > li:not(.open) > ul {
      display: none;
    }
     .second-menu.menu-light .navigation > li:not(.open) > ul .active {
      background: transparent;
      box-shadow: none;
    }
    .second-menu.menu-light .navigation > li.active {
      z-index: 1;
    }
    .second-menu.menu-light .navigation > li.active > a {
      color: #114A9F;
      font-weight: 400;
    }
     .second-menu.menu-light .navigation > li.active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 4px;
    }
    .second-menu.menu-light .navigation > li.level1.open {
      z-index: 1;
    }
    .second-menu.menu-light .navigation > li.level1.open > a {
      color: #114A9F;
      font-weight: 400;
    }
     .second-menu.menu-light .navigation > li.level1.open > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 4px;
    }
     .second-menu.menu-light .navigation > li .active {
      background: #f0f0f0;
    }
    .second-menu.menu-light .navigation > li .active > a {
      color: #114A9F;
    }
     .second-menu.menu-light .navigation > li .active > a {
      margin-bottom: 0;
    }
     .second-menu.menu-light .navigation > li .active .hover > a,  .second-menu.menu-light .navigation > li .active :hover > a {
      background: whitesmoke;
    }
     .second-menu.menu-light .navigation > li ul {
      padding: 0;
      margin: 0;
    }
    .second-menu.menu-light .navigation > li ul li {
      color: #424244;
    }
     .second-menu.menu-light .navigation > li ul li {
      background: transparent;
    }
    [dir=ltr] .second-menu.menu-light .navigation > li ul li > a {
      padding: 10px 15px 10px 20px;
    }
    [dir=rtl] .second-menu.menu-light .navigation > li ul li > a {
      padding: 10px 20px 10px 15px;
    }
    [dir=ltr] .second-menu.menu-light .navigation > li ul li ul a {
      padding: 10px 15px 10px 53px;
    }
    [dir=rtl] .second-menu.menu-light .navigation > li ul li ul a {
      padding: 10px 53px 10px 15px;
    }
    .second-menu.menu-light .navigation > li ul .has-sub:not(.open) > ul {
      display: none;
    }
     .second-menu.menu-light .navigation > li ul .has-sub:not(.open) > ul .active {
      background: transparent;
      box-shadow: none;
    }
    .second-menu.menu-light .navigation > li ul .open > a,
    .second-menu.menu-light .navigation > li ul .sidebar-group-active > a {
      color: #114A9F;
    }
     .second-menu.menu-light .navigation > li ul .open > a,  .second-menu.menu-light .navigation > li ul .sidebar-group-active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 6px;
    }
    .second-menu.menu-light .navigation > li ul .open > ul,
    .second-menu.menu-light .navigation > li ul .sidebar-group-active > ul {
      display: block;
    }
    .second-menu.menu-light .navigation > li ul .open > ul .open > ul,
    .second-menu.menu-light .navigation > li ul .sidebar-group-active > ul .open > ul {
      display: block;
    }
    .second-menu.menu-light .navigation > li ul .hover > a, .second-menu.menu-light .navigation > li ul:hover > a {
      color: #4c4c4e;
    }
    .second-menu.menu-light .navigation > li ul .active {
      z-index: 1;
    }
     .second-menu.menu-light .navigation > li ul .active {
      border-radius: 4px;
    }
    .second-menu.menu-light .navigation > li ul .active > a {
      color: #114A9F;
    }
     .second-menu.menu-light .navigation > li ul .active > a {
      background: rgba(17, 74, 159, 0.12);
    }
    .second-menu.menu-dark {
      color: #dcdcdc;
    }
     .second-menu.menu-dark {
      background: #10163a;
    }
     .second-menu.menu-dark .navigation {
      background: #10163a;
    }
    .second-menu.menu-dark .navigation .navigation-header {
      color: white;
      line-height: 1.5;
      letter-spacing: 0.01rem;
    }
     .second-menu.menu-dark .navigation .navigation-header {
      padding: 0;
    }
    [dir=ltr] .second-menu.menu-dark .navigation .navigation-header {
      margin: calc(1rem + 0.286rem) 0 0.8rem 1.2rem;
    }
    [dir=rtl] .second-menu.menu-dark .navigation .navigation-header {
      margin: calc(1rem + 0.286rem) 1.2rem 0.8rem 0;
    }
    .second-menu.menu-dark .navigation .navigation-header span {
      font-weight: 500;
    }
    .second-menu.menu-dark .navigation li.has-sub > a {
      transition: all 0.5s ease, background 0s, color 0s;
    }
    .second-menu.menu-dark .navigation li a {
      color: #d0d0d0;
      line-height: 1.45;
    }
     .second-menu.menu-dark .navigation li a {
      padding: 10px 15px 10px 15px;
    }
    .second-menu.menu-dark .navigation li a span.menu-sub-title {
      color: white;
    }
    .second-menu.menu-dark .navigation li a > * {
      transition: transform 0.25s ease;
    }
     .second-menu.menu-dark .navigation > li > a .label {
      margin-top: 4px;
    }
    [dir=ltr] .second-menu.menu-dark .navigation > li > a .label {
      margin-right: 5px;
    }
    [dir=rtl] .second-menu.menu-dark .navigation > li > a .label {
      margin-left: 5px;
    }
    .second-menu.menu-dark .navigation > li > a i,
    .second-menu.menu-dark .navigation > li > a svg {
      position: relative;
      top: -3px;
    }
     .second-menu.menu-dark .navigation > li > ul li:first-of-type {
      margin-top: 7px !important;
    }
    [dir=ltr] .second-menu.menu-dark .navigation > li > ul li:not(.has-sub) {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .second-menu.menu-dark .navigation > li > ul li:not(.has-sub) {
      margin: 0 15px 0 0;
    }
    [dir=ltr] .second-menu.menu-dark .navigation > li > ul li.has-sub > a {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .second-menu.menu-dark .navigation > li > ul li.has-sub > a {
      margin: 0 15px 0 0;
    }
    [dir=ltr] .second-menu.menu-dark .navigation > li > ul li.has-sub > ul > li {
      margin: 0 0 0 15px;
    }
    [dir=rtl] .second-menu.menu-dark .navigation > li > ul li.has-sub > ul > li {
      margin: 0 15px 0 0;
    }
    .second-menu.menu-dark .navigation > li.open:not(.menu-item-closing) > a, .second-menu.menu-dark .navigation > li.sidebar-group-active > a {
      color: #114A9F;
    }
     .second-menu.menu-dark .navigation > li.open:not(.menu-item-closing) > a,  .second-menu.menu-dark .navigation > li.sidebar-group-active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 6px;
    }
    .second-menu.menu-dark .navigation > li:not(.open) > ul {
      display: none;
    }
     .second-menu.menu-dark .navigation > li:not(.open) > ul .active {
      background: transparent;
      box-shadow: none;
    }
    .second-menu.menu-dark .navigation > li.active {
      z-index: 1;
    }
    .second-menu.menu-dark .navigation > li.active > a {
      color: #114A9F;
      font-weight: 400;
    }
     .second-menu.menu-dark .navigation > li.active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 4px;
    }
    .second-menu.menu-dark .navigation > li.level1.open {
      z-index: 1;
    }
    .second-menu.menu-dark .navigation > li.level1.open > a {
      color: #114A9F;
      font-weight: 400;
    }
     .second-menu.menu-dark .navigation > li.level1.open > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 4px;
    }
     .second-menu.menu-dark .navigation > li .active {
      background: #090d22;
    }
    .second-menu.menu-dark .navigation > li .active > a {
      color: #114A9F;
    }
     .second-menu.menu-dark .navigation > li .active > a {
      margin-bottom: 0;
    }
     .second-menu.menu-dark .navigation > li .active .hover > a,  .second-menu.menu-dark .navigation > li .active :hover > a {
      background: #0c102a;
    }
     .second-menu.menu-dark .navigation > li ul {
      padding: 0;
      margin: 0;
    }
    .second-menu.menu-dark .navigation > li ul li {
      color: #dcdcdc;
    }
     .second-menu.menu-dark .navigation > li ul li {
      background: transparent;
    }
    [dir=ltr] .second-menu.menu-dark .navigation > li ul li > a {
      padding: 10px 15px 10px 20px;
    }
    [dir=rtl] .second-menu.menu-dark .navigation > li ul li > a {
      padding: 10px 20px 10px 15px;
    }
    [dir=ltr] .second-menu.menu-dark .navigation > li ul li ul a {
      padding: 10px 15px 10px 53px;
    }
    [dir=rtl] .second-menu.menu-dark .navigation > li ul li ul a {
      padding: 10px 53px 10px 15px;
    }
    .second-menu.menu-dark .navigation > li ul .has-sub:not(.open) > ul {
      display: none;
    }
     .second-menu.menu-dark .navigation > li ul .has-sub:not(.open) > ul .active {
      background: transparent;
      box-shadow: none;
    }
    .second-menu.menu-dark .navigation > li ul .open > a,
    .second-menu.menu-dark .navigation > li ul .sidebar-group-active > a {
      color: #114A9F;
    }
     .second-menu.menu-dark .navigation > li ul .open > a,  .second-menu.menu-dark .navigation > li ul .sidebar-group-active > a {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 6px;
    }
    .second-menu.menu-dark .navigation > li ul .open > ul,
    .second-menu.menu-dark .navigation > li ul .sidebar-group-active > ul {
      display: block;
    }
    .second-menu.menu-dark .navigation > li ul .open > ul .open > ul,
    .second-menu.menu-dark .navigation > li ul .sidebar-group-active > ul .open > ul {
      display: block;
    }
    .second-menu.menu-dark .navigation > li ul .hover > a, .second-menu.menu-dark .navigation > li ul:hover > a {
      color: #e6e6e6;
    }
    .second-menu.menu-dark .navigation > li ul .active {
      z-index: 1;
    }
     .second-menu.menu-dark .navigation > li ul .active {
      border-radius: 4px;
    }
    .second-menu.menu-dark .navigation > li ul .active > a {
      color: #114A9F;
    }
     .second-menu.menu-dark .navigation > li ul .active > a {
      background: rgba(17, 74, 159, 0.12);
    }
    .second-menu.menu-fixed {
      position: fixed;
    }
    .second-menu.menu-static {
      height: 100%;
    }
     .second-menu.menu-static {
      padding-bottom: calc(100% - 20rem);
    }
    .second-menu.menu-static .main-menu-content {
      height: unset !important;
    }
     .second-menu.menu-shadow {
      box-shadow: 0 0 15px 0 rgba(34, 41, 47, 0.05);
    }
    [dir=ltr] .second-menu.menu-border {
      border-right: 1px solid #ebe9f1;
    }
    [dir=rtl] .second-menu.menu-border {
      border-left: 1px solid #ebe9f1;
    }
    .second-menu .shadow-bottom {
      display: none;
      position: absolute;
      z-index: 2;
      height: 50px;
      width: 100%;
      pointer-events: none;
      filter: blur(5px);
    }
     .second-menu .shadow-bottom {
      margin-top: -0.7rem;
      background: linear-gradient(#fff 41%, rgba(255, 255, 255, 0.11) 95%, rgba(255, 255, 255, 0));
    }
     .bordered-layout .second-menu .shadow-bottom {
      background: linear-gradient(#f8f8f8 41%, rgba(255, 255, 255, 0.11) 95%, rgba(255, 255, 255, 0));
    }
    .second-menu.menu-native-scroll .main-menu-content {
      overflow-y: scroll !important;
    }
    .second-menu .main-menu-content {
      height: calc(100% - 4rem) !important;
      position: relative;
    }
    [dir=ltr] .second-menu .main-menu-content {
      border-left: 1px solid #ebe9f1;
    }
    [dir=rtl] .second-menu .main-menu-content {
      border-right: 1px solid #ebe9f1;
    }
    .second-menu .main-menu-content .ps__rail-y {
      z-index: 3;
    }
    .second-menu ul {
      list-style: none;
    }
     .second-menu ul {
      margin: 0;
      padding: 0;
    }
    .second-menu ul.navigation-main {
      overflow-x: hidden;
      font-weight: 400;
    }
     .second-menu ul.navigation-main {
      padding-bottom: 0.75rem;
    }
     .second-menu ul.navigation-main > li:first-child {
      margin-top: 0.5rem;
    }
    .second-menu ul.navigation-main > li.active > a > span {
      font-weight: 500;
    }
    .second-menu a {
      outline: none;
    }
    .second-menu a:hover, .second-menu a:focus {
      text-decoration: none;
    }
    
    .navigation {
      font-size: 1.1rem;
      font-family: "Roboto", Helvetica, Arial, serif;
      font-weight: 400;
      overflow-y: hidden;
    }
    
     .navigation {
      padding-bottom: 20px;
    }
    .navigation .navigation-header {
      font-family: "Roboto", Helvetica, Arial, serif;
      font-weight: 500;
      line-height: 1.2;
      font-size: 0.9rem;
      text-transform: uppercase;
    }
     .navigation .navigation-header {
      padding: 12px 22px;
    }
    .navigation li {
      position: relative;
      white-space: nowrap;
    }
    .navigation li a {
      display: block;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .navigation li a i,
    .navigation li a svg {
      height: 11px;
      width: 11px;
      font-size: 11px;
    }
    [dir=ltr] .navigation li a i, [dir=ltr] .navigation li a svg {
      margin-right: 1.38rem;
    }
    [dir=rtl] .navigation li a i, [dir=rtl] .navigation li a svg {
      margin-left: 1.38rem;
    }
    .navigation li.menu-item-animating {
      transition: height 0.25s ease-in-out;
    }
    .navigation li.disabled a {
      opacity: 0.65;
      pointer-events: none;
    }
     .navigation li.disabled a {
      cursor: not-allowed;
    }
    
    @media (min-width: 992px) {
      .main-menu {
        z-index: 98;
      }
    }
    @media (max-width: 767.98px) {
      .menu-hide .main-menu,
    .menu-open .main-menu {
        transition: transform 0.25s, top 0.35s, height 0.35s;
      }
    
      .main-menu {
        backface-visibility: hidden;
        perspective: 1000;
      }
    
      [dir=ltr] .main-menu {
        transform: translate3d(-240px, 0, 0);
      }
    
      [dir=rtl] .main-menu {
        transform: translate3d(240px, 0, 0);
      }
    
       .menu-open .main-menu {
        transform: translate3d(0, 0, 0);
      }
    }
    @media (min-width: 768px) {
      .drag-target {
        z-index: 0;
      }
    }
    .avatar {
      white-space: nowrap;
      position: relative;
      color: #fff;
      display: inline-flex;
      font-size: 1rem;
      vertical-align: middle;
      font-weight: 600;
    }
     .avatar {
      background-color: #c3c3c3;
      border-radius: 50%;
      cursor: pointer;
      text-align: center;
    }
    .avatar .avatar-content {
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.857rem;
    }
     .avatar .avatar-content {
      border-radius: 50%;
    }
    .avatar .avatar-content .avatar-icon {
      height: 1rem;
      width: 1rem;
    }
    .avatar [class*=avatar-status-] {
      width: 11px;
      height: 11px;
      position: absolute;
      bottom: 0;
    }
     .avatar [class*=avatar-status-] {
      border-radius: 50%;
      border: 1px solid #fff;
    }
    [dir=ltr] .avatar [class*=avatar-status-] {
      right: 0;
    }
    [dir=rtl] .avatar [class*=avatar-status-] {
      left: 0;
    }
    .avatar [class*=avatar-status-].avatar-status-lg, .avatar [class*=avatar-status-].avatar-status-xl {
      width: 17px;
      height: 17px;
    }
     .avatar [class*=avatar-status-].avatar-status-lg,  .avatar [class*=avatar-status-].avatar-status-xl {
      border-width: 2px;
    }
     .avatar .avatar-status-online {
      background-color: #17B75E;
    }
     .avatar .avatar-status-busy {
      background-color: #EA5455;
    }
     .avatar .avatar-status-away {
      background-color: #FDB913;
    }
     .avatar .avatar-status-offline {
      background-color: #9C9EA4;
    }
    .avatar.avatar-tag {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 42px;
      width: 42px;
    }
     .avatar.avatar-tag {
      border-radius: 0.357rem;
    }
     .avatar img {
      border-radius: 50%;
    }
    .avatar.avatar-xl {
      font-size: 1.5rem;
    }
    .avatar.avatar-xl img {
      width: 70px;
      height: 70px;
    }
    .avatar.avatar-xl .avatar-content {
      height: 70px;
      width: 70px;
      font-size: 2.57rem;
    }
    .avatar.avatar-xl .avatar-content .avatar-icon,
    .avatar.avatar-xl .avatar-content i,
    .avatar.avatar-xl .avatar-content svg {
      height: 3rem;
      width: 3rem;
      font-size: 3rem;
    }
    .avatar.avatar-xl [class*=avatar-status-] {
      bottom: 0;
    }
    [dir=ltr] .avatar.avatar-xl [class*=avatar-status-] {
      right: 3px;
    }
    [dir=rtl] .avatar.avatar-xl [class*=avatar-status-] {
      left: 3px;
    }
    .avatar.avatar-lg {
      font-size: 1.2rem;
    }
    .avatar.avatar-lg img {
      width: 50px;
      height: 50px;
    }
    .avatar.avatar-lg .avatar-content {
      width: 50px;
      height: 50px;
      font-size: 1.714rem;
    }
    .avatar.avatar-lg .avatar-content .avatar-icon,
    .avatar.avatar-lg .avatar-content i,
    .avatar.avatar-lg .avatar-content svg {
      height: 2rem;
      width: 2rem;
      font-size: 2rem;
    }
    .avatar.avatar-lg [class*=avatar-status-] {
      bottom: 1px;
    }
    [dir=ltr] .avatar.avatar-lg [class*=avatar-status-] {
      right: 3px;
    }
    [dir=rtl] .avatar.avatar-lg [class*=avatar-status-] {
      left: 3px;
    }
    .avatar.avatar-sm .avatar-content {
      width: 24px;
      height: 24px;
    }
    .avatar.avatar-sm .avatar-content .avatar-icon,
    .avatar.avatar-sm .avatar-content i,
    .avatar.avatar-sm .avatar-content svg {
      height: 1rem;
      width: 1rem;
      font-size: 1rem;
    }
    .avatar.avatar-sm img {
      width: 24px;
      height: 24px;
    }
    .avatar.avatar-sm [class*=avatar-status-] {
      bottom: -2px;
    }
    [dir=ltr] .avatar.avatar-sm [class*=avatar-status-] {
      right: -3px;
    }
    [dir=rtl] .avatar.avatar-sm [class*=avatar-status-] {
      left: -3px;
    }
    
    .avatar-group {
      display: flex;
      justify-content: flex-start;
    }
    .avatar-group .avatar {
      transition: all 0.25s ease;
    }
     .avatar-group .avatar img,  .avatar-group .avatar .avatar-content {
      box-shadow: 0 0 0 2px #fff, inset 0 0 0 1px rgba(34, 41, 47, 0.07);
    }
     .avatar-group .avatar .avatar-content {
      background-color: #d1d2d5 !important;
    }
    .avatar-group .avatar:hover {
      transition: all 0.25s ease;
    }
     .avatar-group .avatar.pull-up:hover {
      transform: translateY(-4px) scale(1.07);
    }
    [dir=ltr] .avatar-group .avatar:not(:first-child) {
      margin-left: -0.55rem;
    }
    [dir=rtl] .avatar-group .avatar:not(:first-child) {
      margin-right: -0.55rem;
    }
    [dir=ltr] .avatar-group .avatar-sm:not(:first-child) {
      margin-left: -0.4rem;
    }
    [dir=rtl] .avatar-group .avatar-sm:not(:first-child) {
      margin-right: -0.4rem;
    }
    [dir=ltr] .avatar-group .avatar-lg:not(:first-child) {
      margin-left: -1rem;
    }
    [dir=rtl] .avatar-group .avatar-lg:not(:first-child) {
      margin-right: -1rem;
    }
    [dir=ltr] .avatar-group .avatar-xl:not(:first-child) {
      margin-left: -1.5rem;
    }
    [dir=rtl] .avatar-group .avatar-xl:not(:first-child) {
      margin-right: -1.5rem;
    }
    
    /*=========================================================================================
      File Name: search.scss
      Description: Search  functionality.
    
    ==========================================================================================*/
    [dir=ltr] .navbar-container a.nav-link-search {
      float: left;
    }
    [dir=rtl] .navbar-container a.nav-link-search {
      float: right;
    }
    .navbar-container .search-input {
      width: 0;
      display: none;
    }
    [dir=ltr] .navbar-container .search-input {
      float: left;
    }
    [dir=rtl] .navbar-container .search-input {
      float: right;
    }
    .navbar-container .search-input input {
      width: 0;
      transition: all 0.2s ease-out;
      line-height: 16px;
    }
     .navbar-container .search-input input {
      border: none;
      background: none;
    }
    .navbar-container .search-input.open {
      position: absolute;
      top: 11px;
      z-index: 1000;
      width: 20%;
      max-width: 445px;
      display: block;
      height: 32px;
    }
     .navbar-container .search-input.open {
      background: #fff;
      border-radius: 5px;
    }
    .navbar-container .search-input.open .search-input-close,
    .navbar-container .search-input.open .search-input-icon {
      display: block;
    }
    .navbar-container .search-input.open input.input-search {
      width: 100%;
      outline: none;
      transition: all 0.3s ease-out;
    }
     .navbar-container .search-input.open input.input-search {
      background: none;
      box-shadow: none;
      margin-top: -2px;
    }
    .navbar-container .search-input .search-list {
      max-height: 450px;
      height: auto;
      position: absolute;
      top: 100%;
      display: none;
    }
     .navbar-container .search-input .search-list {
      background: #fff;
      margin-top: 0.5rem;
      border-radius: 0.357rem;
    }
    [dir=ltr] .navbar-container .search-input .search-list {
      left: 0;
      padding-left: 0;
    }
    [dir=rtl] .navbar-container .search-input .search-list {
      right: 0;
      padding-right: 0;
    }
    @media only screen and (min-device-width: 320px) and (max-device-width: 875px) and (orientation: landscape) {
      .navbar-container .search-input .search-list {
        max-height: 250px;
      }
    }
    .navbar-container .search-input .search-list.search-list-bookmark {
      height: auto !important;
    }
    .navbar-container .search-input .search-list.search-list-bookmark i,
    .navbar-container .search-input .search-list.search-list-bookmark svg {
      font-size: 1.2rem;
      height: 1.2rem;
      width: 1.2rem;
    }
    .navbar-container .search-input .search-list.show {
      display: block;
      min-height: 3rem;
    }
    .navbar-container .search-input .search-list li a {
      color: #424244;
    }
     .navbar-container .search-input .search-list li a {
      padding: 0.9rem 1rem;
    }
    .navbar-container .search-input .search-list li a i,
    .navbar-container .search-input .search-list li a svg[class*="feather feather-"] {
      height: 1.25rem;
      width: 1.25rem;
      font-size: 1.25rem;
    }
    [dir=ltr] .navbar-container .search-input .search-list li:first-child {
      border-top-left-radius: 0.357rem;
      border-top-right-radius: 0.357rem;
    }
    [dir=rtl] .navbar-container .search-input .search-list li:first-child {
      border-top-right-radius: 0.357rem;
      border-top-left-radius: 0.357rem;
    }
    [dir=ltr] .navbar-container .search-input .search-list li:last-child {
      border-bottom-left-radius: 0.357rem;
      border-bottom-right-radius: 0.357rem;
    }
    [dir=rtl] .navbar-container .search-input .search-list li:last-child {
      border-bottom-right-radius: 0.357rem;
      border-bottom-left-radius: 0.357rem;
    }
    .navbar-container .search-input .search-list li.auto-suggestion {
      display: flex;
      align-items: center;
    }
     .navbar-container .search-input .search-list li.auto-suggestion {
      cursor: pointer;
    }
     .navbar-container .search-input .search-list li.auto-suggestion:hover,  .navbar-container .search-input .search-list li.auto-suggestion.current_item {
      background-color: #f8f8f8;
    }
    .navbar-container .search-input .search-input-icon {
      z-index: 2;
      display: none;
      position: absolute;
      top: 5px;
    }
     .navbar-container .search-input .search-input-icon {
      cursor: pointer;
    }
    [dir=ltr] .navbar-container .search-input .search-input-icon {
      right: 1rem;
    }
    [dir=rtl] .navbar-container .search-input .search-input-icon {
      left: 1rem;
    }
    .navbar-container .search-input .search-input-icon i,
    .navbar-container .search-input .search-input-icon svg {
      height: 1.25rem;
      width: 1.25rem;
      font-size: 1.25rem;
    }
    .navbar-container .search-input .search-input-close {
      z-index: 1;
      display: none;
      position: absolute;
      top: 32%;
    }
     .navbar-container .search-input .search-input-close {
      cursor: pointer;
    }
    [dir=ltr] .navbar-container .search-input .search-input-close {
      right: 2rem;
    }
    [dir=rtl] .navbar-container .search-input .search-input-close {
      left: 2rem;
    }
    .navbar-container .search-input .search-input-close i,
    .navbar-container .search-input .search-input-close svg {
      height: 1.25rem;
      width: 1.25rem;
      font-size: 1.25rem;
    }
    .navbar-container .bookmark-input {
      position: absolute;
      top: 102%;
      width: 25%;
      display: none;
    }
     .navbar-container .bookmark-input {
      background: #fff;
      border-radius: 0.357rem;
      box-shadow: 0 15px 30px 0 rgba(34, 41, 47, 0.11), 0 5px 15px 0 rgba(34, 41, 47, 0.08);
    }
    .navbar-container .bookmark-input.show {
      display: block;
    }
    .navbar-container .bookmark-input .bookmark-input-icon {
      position: absolute;
      z-index: 1;
      top: 20px;
    }
    [dir=ltr] .navbar-container .bookmark-input .bookmark-input-icon {
      left: 24px;
    }
    [dir=rtl] .navbar-container .bookmark-input .bookmark-input-icon {
      right: 24px;
    }
    .navbar-container .bookmark-input input {
      width: calc(100% - 24px);
    }
     .navbar-container .bookmark-input input {
      margin: 12px;
      background: #fff;
      border: 1px solid rgba(34, 41, 47, 0.2);
    }
    [dir=ltr] .navbar-container .bookmark-input input {
      padding: 0.7rem 0.7rem 0.7rem 2.5rem;
    }
    [dir=rtl] .navbar-container .bookmark-input input {
      padding: 0.7rem 2.5rem 0.7rem 0.7rem;
    }
     .navbar-container .bookmark-input input:focus {
      border: 1px solid #114A9F;
    }
    .navbar-container .bookmark-input .search-list {
      position: relative;
    }
     .navbar-container .bookmark-icon {
      cursor: pointer;
    }
     .navbar-container .dropdown.bookmark-dropdown {
      padding: 1.4rem 0.5rem 1.35rem;
    }
    .navbar-container .dropdown.bookmark-dropdown .dropdown-toggle:after {
      display: none;
    }
    .navbar-container .search-data-title {
      line-height: 1.25rem;
    }
    
    .navbar-dark .search-input .input {
      color: #f5f7fa;
    }
    
     .navbar-dark .search-input .input {
      border-radius: 0.5rem;
    }
    .navbar-dark .search-input.open .input {
      color: #f5f7fa;
    }
     .navbar-dark .search-input.open .input {
      border: 1px solid #f5f7fa;
    }
    
     .navbar-static .navbar-container .search-input.open {
      border-radius: 0;
    }
    
    .btn-social, .btn-social-icon {
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    [dir=ltr] .btn-social, [dir=ltr] .btn-social-icon {
      padding-left: 4.95rem;
      text-align: left;
    }
    
    [dir=rtl] .btn-social, [dir=rtl] .btn-social-icon {
      padding-right: 4.95rem;
      text-align: right;
    }
    .btn-social > :first-child, .btn-social-icon > :first-child {
      position: absolute;
      top: 2px;
      bottom: 0;
      width: 2.95rem;
      line-height: 2.7rem;
      font-size: 1rem;
    }
     .btn-social > :first-child,  .btn-social-icon > :first-child {
      text-align: center;
    }
    [dir=ltr] .btn-social > :first-child, [dir=ltr] .btn-social-icon > :first-child {
      left: 0;
      border-right: 1px solid rgba(34, 41, 47, 0.2);
    }
    [dir=rtl] .btn-social > :first-child, [dir=rtl] .btn-social-icon > :first-child {
      right: 0;
      border-left: 1px solid rgba(34, 41, 47, 0.2);
    }
    
    .btn-social-icon {
      height: 2.95rem;
      width: 2.95rem;
    }
    
     .btn-social-icon {
      padding: 0;
    }
    .btn-social-icon > :first-child {
      width: 100% !important;
    }
     .btn-social-icon > :first-child {
      border: none;
      text-align: center;
    }
    
    .btn-adn {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-adn {
      background-color: #d87a68;
      background-color: #d87a68;
      border-color: #fff;
      border: none;
    }
    .btn-adn:hover {
      color: #fff;
    }
     .btn-adn:hover {
      background-color: #d87a68;
      border-color: #d87a68;
    }
    .btn-adn:focus, .btn-adn.focus {
      color: #fff;
    }
     .btn-adn:focus,  .btn-adn.focus {
      background-color: #d87a68;
      border-color: #d87a68;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-adn.disabled, .btn-adn:disabled {
      color: #fff;
    }
     .btn-adn.disabled,  .btn-adn:disabled {
      background-color: #d87a68;
      border-color: #fff;
    }
    .btn-adn:not(:disabled):not(.disabled):active, .btn-adn:not(:disabled):not(.disabled).active, .show > .btn-adn.dropdown-toggle {
      color: #fff;
    }
     .btn-adn:not(:disabled):not(.disabled):active,  .btn-adn:not(:disabled):not(.disabled).active,  .show > .btn-adn.dropdown-toggle {
      background-color: #ce563f;
      border-color: #dfdfdf;
    }
     .btn-adn:not(:disabled):not(.disabled):active:focus,  .btn-adn:not(:disabled):not(.disabled).active:focus,  .show > .btn-adn.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-bitbucket {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-bitbucket {
      background-color: #205081;
      background-color: #205081;
      border-color: #fff;
      border: none;
    }
    .btn-bitbucket:hover {
      color: #fff;
    }
     .btn-bitbucket:hover {
      background-color: #205081;
      border-color: #205081;
    }
    .btn-bitbucket:focus, .btn-bitbucket.focus {
      color: #fff;
    }
     .btn-bitbucket:focus,  .btn-bitbucket.focus {
      background-color: #205081;
      border-color: #205081;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-bitbucket.disabled, .btn-bitbucket:disabled {
      color: #fff;
    }
     .btn-bitbucket.disabled,  .btn-bitbucket:disabled {
      background-color: #205081;
      border-color: #fff;
    }
    .btn-bitbucket:not(:disabled):not(.disabled):active, .btn-bitbucket:not(:disabled):not(.disabled).active, .show > .btn-bitbucket.dropdown-toggle {
      color: #fff;
    }
     .btn-bitbucket:not(:disabled):not(.disabled):active,  .btn-bitbucket:not(:disabled):not(.disabled).active,  .show > .btn-bitbucket.dropdown-toggle {
      background-color: #163758;
      border-color: #dfdfdf;
    }
     .btn-bitbucket:not(:disabled):not(.disabled):active:focus,  .btn-bitbucket:not(:disabled):not(.disabled).active:focus,  .show > .btn-bitbucket.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-dropbox {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-dropbox {
      background-color: #1087dd;
      background-color: #1087dd;
      border-color: #fff;
      border: none;
    }
    .btn-dropbox:hover {
      color: #fff;
    }
     .btn-dropbox:hover {
      background-color: #1087dd;
      border-color: #1087dd;
    }
    .btn-dropbox:focus, .btn-dropbox.focus {
      color: #fff;
    }
     .btn-dropbox:focus,  .btn-dropbox.focus {
      background-color: #1087dd;
      border-color: #1087dd;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-dropbox.disabled, .btn-dropbox:disabled {
      color: #fff;
    }
     .btn-dropbox.disabled,  .btn-dropbox:disabled {
      background-color: #1087dd;
      border-color: #fff;
    }
    .btn-dropbox:not(:disabled):not(.disabled):active, .btn-dropbox:not(:disabled):not(.disabled).active, .show > .btn-dropbox.dropdown-toggle {
      color: #fff;
    }
     .btn-dropbox:not(:disabled):not(.disabled):active,  .btn-dropbox:not(:disabled):not(.disabled).active,  .show > .btn-dropbox.dropdown-toggle {
      background-color: #0d6aad;
      border-color: #dfdfdf;
    }
     .btn-dropbox:not(:disabled):not(.disabled):active:focus,  .btn-dropbox:not(:disabled):not(.disabled).active:focus,  .show > .btn-dropbox.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-facebook {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-facebook {
      background-color: #3b5998;
      background-color: #3b5998;
      border-color: #fff;
      border: none;
    }
    .btn-facebook:hover {
      color: #fff;
    }
     .btn-facebook:hover {
      background-color: #3b5998;
      border-color: #3b5998;
    }
    .btn-facebook:focus, .btn-facebook.focus {
      color: #fff;
    }
     .btn-facebook:focus,  .btn-facebook.focus {
      background-color: #3b5998;
      border-color: #3b5998;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-facebook.disabled, .btn-facebook:disabled {
      color: #fff;
    }
     .btn-facebook.disabled,  .btn-facebook:disabled {
      background-color: #3b5998;
      border-color: #fff;
    }
    .btn-facebook:not(:disabled):not(.disabled):active, .btn-facebook:not(:disabled):not(.disabled).active, .show > .btn-facebook.dropdown-toggle {
      color: #fff;
    }
     .btn-facebook:not(:disabled):not(.disabled):active,  .btn-facebook:not(:disabled):not(.disabled).active,  .show > .btn-facebook.dropdown-toggle {
      background-color: #2d4373;
      border-color: #dfdfdf;
    }
     .btn-facebook:not(:disabled):not(.disabled):active:focus,  .btn-facebook:not(:disabled):not(.disabled).active:focus,  .show > .btn-facebook.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-flickr {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-flickr {
      background-color: #ff0084;
      background-color: #ff0084;
      border-color: #fff;
      border: none;
    }
    .btn-flickr:hover {
      color: #fff;
    }
     .btn-flickr:hover {
      background-color: #ff0084;
      border-color: #ff0084;
    }
    .btn-flickr:focus, .btn-flickr.focus {
      color: #fff;
    }
     .btn-flickr:focus,  .btn-flickr.focus {
      background-color: #ff0084;
      border-color: #ff0084;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-flickr.disabled, .btn-flickr:disabled {
      color: #fff;
    }
     .btn-flickr.disabled,  .btn-flickr:disabled {
      background-color: #ff0084;
      border-color: #fff;
    }
    .btn-flickr:not(:disabled):not(.disabled):active, .btn-flickr:not(:disabled):not(.disabled).active, .show > .btn-flickr.dropdown-toggle {
      color: #fff;
    }
     .btn-flickr:not(:disabled):not(.disabled):active,  .btn-flickr:not(:disabled):not(.disabled).active,  .show > .btn-flickr.dropdown-toggle {
      background-color: #cc006a;
      border-color: #dfdfdf;
    }
     .btn-flickr:not(:disabled):not(.disabled):active:focus,  .btn-flickr:not(:disabled):not(.disabled).active:focus,  .show > .btn-flickr.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-foursquare {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-foursquare {
      background-color: #f94877;
      background-color: #f94877;
      border-color: #fff;
      border: none;
    }
    .btn-foursquare:hover {
      color: #fff;
    }
     .btn-foursquare:hover {
      background-color: #f94877;
      border-color: #f94877;
    }
    .btn-foursquare:focus, .btn-foursquare.focus {
      color: #fff;
    }
     .btn-foursquare:focus,  .btn-foursquare.focus {
      background-color: #f94877;
      border-color: #f94877;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-foursquare.disabled, .btn-foursquare:disabled {
      color: #fff;
    }
     .btn-foursquare.disabled,  .btn-foursquare:disabled {
      background-color: #f94877;
      border-color: #fff;
    }
    .btn-foursquare:not(:disabled):not(.disabled):active, .btn-foursquare:not(:disabled):not(.disabled).active, .show > .btn-foursquare.dropdown-toggle {
      color: #fff;
    }
     .btn-foursquare:not(:disabled):not(.disabled):active,  .btn-foursquare:not(:disabled):not(.disabled).active,  .show > .btn-foursquare.dropdown-toggle {
      background-color: #f71752;
      border-color: #dfdfdf;
    }
     .btn-foursquare:not(:disabled):not(.disabled):active:focus,  .btn-foursquare:not(:disabled):not(.disabled).active:focus,  .show > .btn-foursquare.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-github {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-github {
      background-color: #444444;
      background-color: #444444;
      border-color: #fff;
      border: none;
    }
    .btn-github:hover {
      color: #fff;
    }
     .btn-github:hover {
      background-color: #444444;
      border-color: #444444;
    }
    .btn-github:focus, .btn-github.focus {
      color: #fff;
    }
     .btn-github:focus,  .btn-github.focus {
      background-color: #444444;
      border-color: #444444;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-github.disabled, .btn-github:disabled {
      color: #fff;
    }
     .btn-github.disabled,  .btn-github:disabled {
      background-color: #444444;
      border-color: #fff;
    }
    .btn-github:not(:disabled):not(.disabled):active, .btn-github:not(:disabled):not(.disabled).active, .show > .btn-github.dropdown-toggle {
      color: #fff;
    }
     .btn-github:not(:disabled):not(.disabled):active,  .btn-github:not(:disabled):not(.disabled).active,  .show > .btn-github.dropdown-toggle {
      background-color: #2b2b2b;
      border-color: #dfdfdf;
    }
     .btn-github:not(:disabled):not(.disabled):active:focus,  .btn-github:not(:disabled):not(.disabled).active:focus,  .show > .btn-github.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-google {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-google {
      background-color: #dd4b39;
      background-color: #dd4b39;
      border-color: #fff;
      border: none;
    }
    .btn-google:hover {
      color: #fff;
    }
     .btn-google:hover {
      background-color: #dd4b39;
      border-color: #dd4b39;
    }
    .btn-google:focus, .btn-google.focus {
      color: #fff;
    }
     .btn-google:focus,  .btn-google.focus {
      background-color: #dd4b39;
      border-color: #dd4b39;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-google.disabled, .btn-google:disabled {
      color: #fff;
    }
     .btn-google.disabled,  .btn-google:disabled {
      background-color: #dd4b39;
      border-color: #fff;
    }
    .btn-google:not(:disabled):not(.disabled):active, .btn-google:not(:disabled):not(.disabled).active, .show > .btn-google.dropdown-toggle {
      color: #fff;
    }
     .btn-google:not(:disabled):not(.disabled):active,  .btn-google:not(:disabled):not(.disabled).active,  .show > .btn-google.dropdown-toggle {
      background-color: #c23321;
      border-color: #dfdfdf;
    }
     .btn-google:not(:disabled):not(.disabled):active:focus,  .btn-google:not(:disabled):not(.disabled).active:focus,  .show > .btn-google.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-instagram {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-instagram {
      background-color: #3f729b;
      background-color: #3f729b;
      border-color: #fff;
      border: none;
    }
    .btn-instagram:hover {
      color: #fff;
    }
     .btn-instagram:hover {
      background-color: #3f729b;
      border-color: #3f729b;
    }
    .btn-instagram:focus, .btn-instagram.focus {
      color: #fff;
    }
     .btn-instagram:focus,  .btn-instagram.focus {
      background-color: #3f729b;
      border-color: #3f729b;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-instagram.disabled, .btn-instagram:disabled {
      color: #fff;
    }
     .btn-instagram.disabled,  .btn-instagram:disabled {
      background-color: #3f729b;
      border-color: #fff;
    }
    .btn-instagram:not(:disabled):not(.disabled):active, .btn-instagram:not(:disabled):not(.disabled).active, .show > .btn-instagram.dropdown-toggle {
      color: #fff;
    }
     .btn-instagram:not(:disabled):not(.disabled):active,  .btn-instagram:not(:disabled):not(.disabled).active,  .show > .btn-instagram.dropdown-toggle {
      background-color: #305777;
      border-color: #dfdfdf;
    }
     .btn-instagram:not(:disabled):not(.disabled):active:focus,  .btn-instagram:not(:disabled):not(.disabled).active:focus,  .show > .btn-instagram.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-linkedin {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-linkedin {
      background-color: #007bb6;
      background-color: #007bb6;
      border-color: #fff;
      border: none;
    }
    .btn-linkedin:hover {
      color: #fff;
    }
     .btn-linkedin:hover {
      background-color: #007bb6;
      border-color: #007bb6;
    }
    .btn-linkedin:focus, .btn-linkedin.focus {
      color: #fff;
    }
     .btn-linkedin:focus,  .btn-linkedin.focus {
      background-color: #007bb6;
      border-color: #007bb6;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-linkedin.disabled, .btn-linkedin:disabled {
      color: #fff;
    }
     .btn-linkedin.disabled,  .btn-linkedin:disabled {
      background-color: #007bb6;
      border-color: #fff;
    }
    .btn-linkedin:not(:disabled):not(.disabled):active, .btn-linkedin:not(:disabled):not(.disabled).active, .show > .btn-linkedin.dropdown-toggle {
      color: #fff;
    }
     .btn-linkedin:not(:disabled):not(.disabled):active,  .btn-linkedin:not(:disabled):not(.disabled).active,  .show > .btn-linkedin.dropdown-toggle {
      background-color: #005983;
      border-color: #dfdfdf;
    }
     .btn-linkedin:not(:disabled):not(.disabled):active:focus,  .btn-linkedin:not(:disabled):not(.disabled).active:focus,  .show > .btn-linkedin.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-microsoft {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-microsoft {
      background-color: #2672ec;
      background-color: #2672ec;
      border-color: #fff;
      border: none;
    }
    .btn-microsoft:hover {
      color: #fff;
    }
     .btn-microsoft:hover {
      background-color: #2672ec;
      border-color: #2672ec;
    }
    .btn-microsoft:focus, .btn-microsoft.focus {
      color: #fff;
    }
     .btn-microsoft:focus,  .btn-microsoft.focus {
      background-color: #2672ec;
      border-color: #2672ec;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-microsoft.disabled, .btn-microsoft:disabled {
      color: #fff;
    }
     .btn-microsoft.disabled,  .btn-microsoft:disabled {
      background-color: #2672ec;
      border-color: #fff;
    }
    .btn-microsoft:not(:disabled):not(.disabled):active, .btn-microsoft:not(:disabled):not(.disabled).active, .show > .btn-microsoft.dropdown-toggle {
      color: #fff;
    }
     .btn-microsoft:not(:disabled):not(.disabled):active,  .btn-microsoft:not(:disabled):not(.disabled).active,  .show > .btn-microsoft.dropdown-toggle {
      background-color: #125acd;
      border-color: #dfdfdf;
    }
     .btn-microsoft:not(:disabled):not(.disabled):active:focus,  .btn-microsoft:not(:disabled):not(.disabled).active:focus,  .show > .btn-microsoft.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-odnoklassniki {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-odnoklassniki {
      background-color: #f4731c;
      background-color: #f4731c;
      border-color: #fff;
      border: none;
    }
    .btn-odnoklassniki:hover {
      color: #fff;
    }
     .btn-odnoklassniki:hover {
      background-color: #f4731c;
      border-color: #f4731c;
    }
    .btn-odnoklassniki:focus, .btn-odnoklassniki.focus {
      color: #fff;
    }
     .btn-odnoklassniki:focus,  .btn-odnoklassniki.focus {
      background-color: #f4731c;
      border-color: #f4731c;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-odnoklassniki.disabled, .btn-odnoklassniki:disabled {
      color: #fff;
    }
     .btn-odnoklassniki.disabled,  .btn-odnoklassniki:disabled {
      background-color: #f4731c;
      border-color: #fff;
    }
    .btn-odnoklassniki:not(:disabled):not(.disabled):active, .btn-odnoklassniki:not(:disabled):not(.disabled).active, .show > .btn-odnoklassniki.dropdown-toggle {
      color: #fff;
    }
     .btn-odnoklassniki:not(:disabled):not(.disabled):active,  .btn-odnoklassniki:not(:disabled):not(.disabled).active,  .show > .btn-odnoklassniki.dropdown-toggle {
      background-color: #d35b0a;
      border-color: #dfdfdf;
    }
     .btn-odnoklassniki:not(:disabled):not(.disabled):active:focus,  .btn-odnoklassniki:not(:disabled):not(.disabled).active:focus,  .show > .btn-odnoklassniki.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-openid {
      color: #2a2e30;
      color: #fff !important;
    }
    
     .btn-openid {
      background-color: #f7931e;
      background-color: #f7931e;
      border-color: #fff;
      border: none;
    }
    .btn-openid:hover {
      color: #2a2e30;
    }
     .btn-openid:hover {
      background-color: #f7931e;
      border-color: #f7931e;
    }
    .btn-openid:focus, .btn-openid.focus {
      color: #2a2e30;
    }
     .btn-openid:focus,  .btn-openid.focus {
      background-color: #f7931e;
      border-color: #f7931e;
      box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);
    }
    .btn-openid.disabled, .btn-openid:disabled {
      color: #2a2e30;
    }
     .btn-openid.disabled,  .btn-openid:disabled {
      background-color: #f7931e;
      border-color: #fff;
    }
    .btn-openid:not(:disabled):not(.disabled):active, .btn-openid:not(:disabled):not(.disabled).active, .show > .btn-openid.dropdown-toggle {
      color: #fff;
    }
     .btn-openid:not(:disabled):not(.disabled):active,  .btn-openid:not(:disabled):not(.disabled).active,  .show > .btn-openid.dropdown-toggle {
      background-color: #da7908;
      border-color: #dfdfdf;
    }
     .btn-openid:not(:disabled):not(.disabled):active:focus,  .btn-openid:not(:disabled):not(.disabled).active:focus,  .show > .btn-openid.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);
    }
    
    .btn-pinterest {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-pinterest {
      background-color: #cb2027;
      background-color: #cb2027;
      border-color: #fff;
      border: none;
    }
    .btn-pinterest:hover {
      color: #fff;
    }
     .btn-pinterest:hover {
      background-color: #cb2027;
      border-color: #cb2027;
    }
    .btn-pinterest:focus, .btn-pinterest.focus {
      color: #fff;
    }
     .btn-pinterest:focus,  .btn-pinterest.focus {
      background-color: #cb2027;
      border-color: #cb2027;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-pinterest.disabled, .btn-pinterest:disabled {
      color: #fff;
    }
     .btn-pinterest.disabled,  .btn-pinterest:disabled {
      background-color: #cb2027;
      border-color: #fff;
    }
    .btn-pinterest:not(:disabled):not(.disabled):active, .btn-pinterest:not(:disabled):not(.disabled).active, .show > .btn-pinterest.dropdown-toggle {
      color: #fff;
    }
     .btn-pinterest:not(:disabled):not(.disabled):active,  .btn-pinterest:not(:disabled):not(.disabled).active,  .show > .btn-pinterest.dropdown-toggle {
      background-color: #9f191f;
      border-color: #dfdfdf;
    }
     .btn-pinterest:not(:disabled):not(.disabled):active:focus,  .btn-pinterest:not(:disabled):not(.disabled).active:focus,  .show > .btn-pinterest.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-reddit {
      color: #2a2e30;
      color: #fff !important;
    }
    
     .btn-reddit {
      background-color: #eff7ff;
      background-color: #eff7ff;
      border-color: #000;
      border: none;
    }
    .btn-reddit:hover {
      color: #fff;
    }
     .btn-reddit:hover {
      background-color: #000;
      border-color: #000;
    }
    .btn-reddit:focus, .btn-reddit.focus {
      color: #fff;
    }
     .btn-reddit:focus,  .btn-reddit.focus {
      background-color: #000;
      border-color: #000;
      box-shadow: 0 0 0 0.2rem rgba(6, 7, 7, 0.5);
    }
    .btn-reddit.disabled, .btn-reddit:disabled {
      color: #2a2e30;
    }
     .btn-reddit.disabled,  .btn-reddit:disabled {
      background-color: #eff7ff;
      border-color: #000;
    }
    .btn-reddit:not(:disabled):not(.disabled):active, .btn-reddit:not(:disabled):not(.disabled).active, .show > .btn-reddit.dropdown-toggle {
      color: #2a2e30;
    }
     .btn-reddit:not(:disabled):not(.disabled):active,  .btn-reddit:not(:disabled):not(.disabled).active,  .show > .btn-reddit.dropdown-toggle {
      background-color: #bcdeff;
      border-color: black;
    }
     .btn-reddit:not(:disabled):not(.disabled):active:focus,  .btn-reddit:not(:disabled):not(.disabled).active:focus,  .show > .btn-reddit.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(6, 7, 7, 0.5);
    }
    
    .btn-soundcloud {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-soundcloud {
      background-color: #ff5500;
      background-color: #ff5500;
      border-color: #fff;
      border: none;
    }
    .btn-soundcloud:hover {
      color: #fff;
    }
     .btn-soundcloud:hover {
      background-color: #ff5500;
      border-color: #ff5500;
    }
    .btn-soundcloud:focus, .btn-soundcloud.focus {
      color: #fff;
    }
     .btn-soundcloud:focus,  .btn-soundcloud.focus {
      background-color: #ff5500;
      border-color: #ff5500;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-soundcloud.disabled, .btn-soundcloud:disabled {
      color: #fff;
    }
     .btn-soundcloud.disabled,  .btn-soundcloud:disabled {
      background-color: #ff5500;
      border-color: #fff;
    }
    .btn-soundcloud:not(:disabled):not(.disabled):active, .btn-soundcloud:not(:disabled):not(.disabled).active, .show > .btn-soundcloud.dropdown-toggle {
      color: #fff;
    }
     .btn-soundcloud:not(:disabled):not(.disabled):active,  .btn-soundcloud:not(:disabled):not(.disabled).active,  .show > .btn-soundcloud.dropdown-toggle {
      background-color: #cc4400;
      border-color: #dfdfdf;
    }
     .btn-soundcloud:not(:disabled):not(.disabled):active:focus,  .btn-soundcloud:not(:disabled):not(.disabled).active:focus,  .show > .btn-soundcloud.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-tumblr {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-tumblr {
      background-color: #2c4762;
      background-color: #2c4762;
      border-color: #fff;
      border: none;
    }
    .btn-tumblr:hover {
      color: #fff;
    }
     .btn-tumblr:hover {
      background-color: #2c4762;
      border-color: #2c4762;
    }
    .btn-tumblr:focus, .btn-tumblr.focus {
      color: #fff;
    }
     .btn-tumblr:focus,  .btn-tumblr.focus {
      background-color: #2c4762;
      border-color: #2c4762;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-tumblr.disabled, .btn-tumblr:disabled {
      color: #fff;
    }
     .btn-tumblr.disabled,  .btn-tumblr:disabled {
      background-color: #2c4762;
      border-color: #fff;
    }
    .btn-tumblr:not(:disabled):not(.disabled):active, .btn-tumblr:not(:disabled):not(.disabled).active, .show > .btn-tumblr.dropdown-toggle {
      color: #fff;
    }
     .btn-tumblr:not(:disabled):not(.disabled):active,  .btn-tumblr:not(:disabled):not(.disabled).active,  .show > .btn-tumblr.dropdown-toggle {
      background-color: #1c2e3f;
      border-color: #dfdfdf;
    }
     .btn-tumblr:not(:disabled):not(.disabled):active:focus,  .btn-tumblr:not(:disabled):not(.disabled).active:focus,  .show > .btn-tumblr.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-twitter {
      color: #2a2e30;
      color: #fff !important;
    }
    
     .btn-twitter {
      background-color: #55acee;
      background-color: #55acee;
      border-color: #fff;
      border: none;
    }
    .btn-twitter:hover {
      color: #2a2e30;
    }
     .btn-twitter:hover {
      background-color: #55acee;
      border-color: #55acee;
    }
    .btn-twitter:focus, .btn-twitter.focus {
      color: #2a2e30;
    }
     .btn-twitter:focus,  .btn-twitter.focus {
      background-color: #55acee;
      border-color: #55acee;
      box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);
    }
    .btn-twitter.disabled, .btn-twitter:disabled {
      color: #2a2e30;
    }
     .btn-twitter.disabled,  .btn-twitter:disabled {
      background-color: #55acee;
      border-color: #fff;
    }
    .btn-twitter:not(:disabled):not(.disabled):active, .btn-twitter:not(:disabled):not(.disabled).active, .show > .btn-twitter.dropdown-toggle {
      color: #fff;
    }
     .btn-twitter:not(:disabled):not(.disabled):active,  .btn-twitter:not(:disabled):not(.disabled).active,  .show > .btn-twitter.dropdown-toggle {
      background-color: #2795e9;
      border-color: #dfdfdf;
    }
     .btn-twitter:not(:disabled):not(.disabled):active:focus,  .btn-twitter:not(:disabled):not(.disabled).active:focus,  .show > .btn-twitter.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);
    }
    
    .btn-vimeo {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-vimeo {
      background-color: #1ab7ea;
      background-color: #1ab7ea;
      border-color: #fff;
      border: none;
    }
    .btn-vimeo:hover {
      color: #fff;
    }
     .btn-vimeo:hover {
      background-color: #1ab7ea;
      border-color: #1ab7ea;
    }
    .btn-vimeo:focus, .btn-vimeo.focus {
      color: #fff;
    }
     .btn-vimeo:focus,  .btn-vimeo.focus {
      background-color: #1ab7ea;
      border-color: #1ab7ea;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-vimeo.disabled, .btn-vimeo:disabled {
      color: #fff;
    }
     .btn-vimeo.disabled,  .btn-vimeo:disabled {
      background-color: #1ab7ea;
      border-color: #fff;
    }
    .btn-vimeo:not(:disabled):not(.disabled):active, .btn-vimeo:not(:disabled):not(.disabled).active, .show > .btn-vimeo.dropdown-toggle {
      color: #fff;
    }
     .btn-vimeo:not(:disabled):not(.disabled):active,  .btn-vimeo:not(:disabled):not(.disabled).active,  .show > .btn-vimeo.dropdown-toggle {
      background-color: #1295bf;
      border-color: #dfdfdf;
    }
     .btn-vimeo:not(:disabled):not(.disabled):active:focus,  .btn-vimeo:not(:disabled):not(.disabled).active:focus,  .show > .btn-vimeo.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-vk {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-vk {
      background-color: #587ea3;
      background-color: #587ea3;
      border-color: #fff;
      border: none;
    }
    .btn-vk:hover {
      color: #fff;
    }
     .btn-vk:hover {
      background-color: #587ea3;
      border-color: #587ea3;
    }
    .btn-vk:focus, .btn-vk.focus {
      color: #fff;
    }
     .btn-vk:focus,  .btn-vk.focus {
      background-color: #587ea3;
      border-color: #587ea3;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-vk.disabled, .btn-vk:disabled {
      color: #fff;
    }
     .btn-vk.disabled,  .btn-vk:disabled {
      background-color: #587ea3;
      border-color: #fff;
    }
    .btn-vk:not(:disabled):not(.disabled):active, .btn-vk:not(:disabled):not(.disabled).active, .show > .btn-vk.dropdown-toggle {
      color: #fff;
    }
     .btn-vk:not(:disabled):not(.disabled):active,  .btn-vk:not(:disabled):not(.disabled).active,  .show > .btn-vk.dropdown-toggle {
      background-color: #466482;
      border-color: #dfdfdf;
    }
     .btn-vk:not(:disabled):not(.disabled):active:focus,  .btn-vk:not(:disabled):not(.disabled).active:focus,  .show > .btn-vk.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-yahoo {
      color: #fff;
      color: #fff !important;
    }
    
     .btn-yahoo {
      background-color: #720e9e;
      background-color: #720e9e;
      border-color: #fff;
      border: none;
    }
    .btn-yahoo:hover {
      color: #fff;
    }
     .btn-yahoo:hover {
      background-color: #720e9e;
      border-color: #720e9e;
    }
    .btn-yahoo:focus, .btn-yahoo.focus {
      color: #fff;
    }
     .btn-yahoo:focus,  .btn-yahoo.focus {
      background-color: #720e9e;
      border-color: #720e9e;
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    .btn-yahoo.disabled, .btn-yahoo:disabled {
      color: #fff;
    }
     .btn-yahoo.disabled,  .btn-yahoo:disabled {
      background-color: #720e9e;
      border-color: #fff;
    }
    .btn-yahoo:not(:disabled):not(.disabled):active, .btn-yahoo:not(:disabled):not(.disabled).active, .show > .btn-yahoo.dropdown-toggle {
      color: #fff;
    }
     .btn-yahoo:not(:disabled):not(.disabled):active,  .btn-yahoo:not(:disabled):not(.disabled).active,  .show > .btn-yahoo.dropdown-toggle {
      background-color: #500a6f;
      border-color: #dfdfdf;
    }
     .btn-yahoo:not(:disabled):not(.disabled):active:focus,  .btn-yahoo:not(:disabled):not(.disabled).active:focus,  .show > .btn-yahoo.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
    }
    
    .btn-outline-adn {
      color: #d87a68;
    }
    
     .btn-outline-adn {
      border: 1px solid #d87a68 !important;
    }
    
    .btn-outline-bitbucket {
      color: #205081;
    }
    
     .btn-outline-bitbucket {
      border: 1px solid #205081 !important;
    }
    
    .btn-outline-dropbox {
      color: #1087dd;
    }
    
     .btn-outline-dropbox {
      border: 1px solid #1087dd !important;
    }
    
    .btn-outline-facebook {
      color: #3b5998;
    }
    
     .btn-outline-facebook {
      border: 1px solid #3b5998 !important;
    }
    
    .btn-outline-flickr {
      color: #ff0084;
    }
    
     .btn-outline-flickr {
      border: 1px solid #ff0084 !important;
    }
    
    .btn-outline-foursquare {
      color: #f94877;
    }
    
     .btn-outline-foursquare {
      border: 1px solid #f94877 !important;
    }
    
    .btn-outline-github {
      color: #444444;
    }
    
     .btn-outline-github {
      border: 1px solid #444444 !important;
    }
    
    .btn-outline-google {
      color: #dd4b39;
    }
    
     .btn-outline-google {
      border: 1px solid #dd4b39 !important;
    }
    
    .btn-outline-instagram {
      color: #3f729b;
    }
    
     .btn-outline-instagram {
      border: 1px solid #3f729b !important;
    }
    
    .btn-outline-linkedin {
      color: #007bb6;
    }
    
     .btn-outline-linkedin {
      border: 1px solid #007bb6 !important;
    }
    
    .btn-outline-microsoft {
      color: #2672ec;
    }
    
     .btn-outline-microsoft {
      border: 1px solid #2672ec !important;
    }
    
    .btn-outline-odnoklassniki {
      color: #f4731c;
    }
    
     .btn-outline-odnoklassniki {
      border: 1px solid #f4731c !important;
    }
    
    .btn-outline-openid {
      color: #f7931e;
    }
    
     .btn-outline-openid {
      border: 1px solid #f7931e !important;
    }
    
    .btn-outline-pinterest {
      color: #cb2027;
    }
    
     .btn-outline-pinterest {
      border: 1px solid #cb2027 !important;
    }
    
    .btn-outline-reddit {
      color: #ff4500;
    }
    
     .btn-outline-reddit {
      border: 1px solid #ff4500 !important;
    }
    
    .btn-outline-soundcloud {
      color: #ff5500;
    }
    
     .btn-outline-soundcloud {
      border: 1px solid #ff5500 !important;
    }
    
    .btn-outline-tumblr {
      color: #2c4762;
    }
    
     .btn-outline-tumblr {
      border: 1px solid #2c4762 !important;
    }
    
    .btn-outline-twitter {
      color: #55acee;
    }
    
     .btn-outline-twitter {
      border: 1px solid #55acee !important;
    }
    
    .btn-outline-vimeo {
      color: #1ab7ea;
    }
    
     .btn-outline-vimeo {
      border: 1px solid #1ab7ea !important;
    }
    
    .btn-outline-vk {
      color: #587ea3;
    }
    
     .btn-outline-vk {
      border: 1px solid #587ea3 !important;
    }
    
    .btn-outline-yahoo {
      color: #720e9e;
    }
    
     .btn-outline-yahoo {
      border: 1px solid #720e9e !important;
    }
    
    .btn-outline-adn:hover {
      color: #ad412d;
    }
    
     .btn-outline-adn:hover {
      border: 1px solid #ad412d !important;
    }
    
    .btn-outline-bitbucket:hover {
      color: #0c1d2f;
    }
    
     .btn-outline-bitbucket:hover {
      border: 1px solid #0c1d2f !important;
    }
    
    .btn-outline-dropbox:hover {
      color: #094d7e;
    }
    
     .btn-outline-dropbox:hover {
      border: 1px solid #094d7e !important;
    }
    
    .btn-outline-facebook:hover {
      color: #1e2e4f;
    }
    
     .btn-outline-facebook:hover {
      border: 1px solid #1e2e4f !important;
    }
    
    .btn-outline-flickr:hover {
      color: #99004f;
    }
    
     .btn-outline-flickr:hover {
      border: 1px solid #99004f !important;
    }
    
    .btn-outline-foursquare:hover {
      color: #d4073d;
    }
    
     .btn-outline-foursquare:hover {
      border: 1px solid #d4073d !important;
    }
    
    .btn-outline-github:hover {
      color: #111111;
    }
    
     .btn-outline-github:hover {
      border: 1px solid #111111 !important;
    }
    
    .btn-outline-google:hover {
      color: #96271a;
    }
    
     .btn-outline-google:hover {
      border: 1px solid #96271a !important;
    }
    
    .btn-outline-instagram:hover {
      color: #223d52;
    }
    
     .btn-outline-instagram:hover {
      border: 1px solid #223d52 !important;
    }
    
    .btn-outline-linkedin:hover {
      color: #003650;
    }
    
     .btn-outline-linkedin:hover {
      border: 1px solid #003650 !important;
    }
    
    .btn-outline-microsoft:hover {
      color: #0e459e;
    }
    
     .btn-outline-microsoft:hover {
      border: 1px solid #0e459e !important;
    }
    
    .btn-outline-odnoklassniki:hover {
      color: #a24608;
    }
    
     .btn-outline-odnoklassniki:hover {
      border: 1px solid #a24608 !important;
    }
    
    .btn-outline-openid:hover {
      color: #a95e06;
    }
    
     .btn-outline-openid:hover {
      border: 1px solid #a95e06 !important;
    }
    
    .btn-outline-pinterest:hover {
      color: #731216;
    }
    
     .btn-outline-pinterest:hover {
      border: 1px solid #731216 !important;
    }
    
    .btn-outline-reddit:hover {
      color: #992900;
    }
    
     .btn-outline-reddit:hover {
      border: 1px solid #992900 !important;
    }
    
    .btn-outline-soundcloud:hover {
      color: #993300;
    }
    
     .btn-outline-soundcloud:hover {
      border: 1px solid #993300 !important;
    }
    
    .btn-outline-tumblr:hover {
      color: #0c141c;
    }
    
     .btn-outline-tumblr:hover {
      border: 1px solid #0c141c !important;
    }
    
    .btn-outline-twitter:hover {
      color: #147bc9;
    }
    
     .btn-outline-twitter:hover {
      border: 1px solid #147bc9 !important;
    }
    
    .btn-outline-vimeo:hover {
      color: #0d7091;
    }
    
     .btn-outline-vimeo:hover {
      border: 1px solid #0d7091 !important;
    }
    
    .btn-outline-vk:hover {
      color: #344b61;
    }
    
     .btn-outline-vk:hover {
      border: 1px solid #344b61 !important;
    }
    
    .btn-outline-yahoo:hover {
      color: #2e0640;
    }
    
     .btn-outline-yahoo:hover {
      border: 1px solid #2e0640 !important;
    }
    
     .bg-adn {
      background-color: #d87a68;
    }
    
     .bg-bitbucket {
      background-color: #205081;
    }
    
     .bg-dropbox {
      background-color: #1087dd;
    }
    
     .bg-facebook {
      background-color: #3b5998;
    }
    
     .bg-flickr {
      background-color: #ff0084;
    }
    
     .bg-foursquare {
      background-color: #f94877;
    }
    
     .bg-github {
      background-color: #444444;
    }
    
     .bg-google {
      background-color: #dd4b39;
    }
    
     .bg-instagram {
      background-color: #3f729b;
    }
    
     .bg-linkedin {
      background-color: #007bb6;
    }
    
     .bg-microsoft {
      background-color: #2672ec;
    }
    
     .bg-odnoklassniki {
      background-color: #f4731c;
    }
    
     .bg-openid {
      background-color: #f7931e;
    }
    
     .bg-pinterest {
      background-color: #cb2027;
    }
    
     .bg-reddit {
      background-color: #ff4500;
    }
    
     .bg-soundcloud {
      background-color: #ff5500;
    }
    
     .bg-tumblr {
      background-color: #2c4762;
    }
    
     .bg-twitter {
      background-color: #55acee;
    }
    
     .bg-vimeo {
      background-color: #1ab7ea;
    }
    
     .bg-vk {
      background-color: #587ea3;
    }
    
     .bg-yahoo {
      background-color: #720e9e;
    }
    
    /*=========================================================================================
        File Name: demo.scss
        Description: CSS used for demo purpose only. Remove this css from your project.
    
    ==========================================================================================*/
    .demo-inline-spacing {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
    }
     .demo-inline-spacing > * {
      margin-top: 1.5rem;
    }
    [dir=ltr] .demo-inline-spacing > * {
      margin-right: 1.5rem;
    }
    [dir=rtl] .demo-inline-spacing > * {
      margin-left: 1.5rem;
    }
    
     .demo-vertical-spacing > * {
      margin: 0;
      margin-bottom: 1.5rem;
    }
     .demo-vertical-spacing > *:last-child {
      margin: 0;
    }
    
     .demo-spacing-0 > *:last-child {
      margin: 0;
    }
    
    .icon-wrapper .feather {
      height: 24px;
      width: 24px;
    }
    
    .scroll-example {
      position: relative;
      overflow: auto;
    }
    
     .scroll-example {
      padding: 0.5rem;
      border: 2px solid #dfdfdf;
    }
    .scroll-example .horz-scroll-content {
      width: 1200px;
    }
    
    .browser {
      width: 100%;
      height: 12rem;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
    
     .browser {
      background: #e0e0e0;
      border: 4px solid #e0e0e0;
      padding-top: 20px;
      margin: 0 0 10px;
    }
    
    .browser iframe {
      height: 100%;
      width: 100%;
    }
    
     .browser iframe {
      border: 0;
      background: #fff;
    }
    
    .loader-wrapper {
      height: 8em;
    }
    
    .maintenance-icon {
      font-size: 4rem;
    }
    
    .animationIcon {
      bottom: 10px;
    }
    
    [dir=ltr] .animationIcon {
      right: 30px;
    }
    
    [dir=rtl] .animationIcon {
      left: 30px;
    }
    
     #component-breadcrumbs .breadcrumb:not(last-child) {
      margin-bottom: 0.5rem;
    }
    
     #breadcrumb-alignment .breadcrumb-wrapper {
      padding: 1px;
      border-radius: 0.357rem;
    }
    
    [dir=ltr] #breadcrumb-alignment .breadcrumb-wrapper {
      box-shadow: 1px 1px 10px rgba(34, 41, 47, 0.1);
    }
    
    [dir=rtl] #breadcrumb-alignment .breadcrumb-wrapper {
      box-shadow: -1px 1px 10px rgba(34, 41, 47, 0.1);
    }
     #breadcrumb-alignment .breadcrumb-wrapper .breadcrumb {
      margin-top: 0.8rem;
      margin-bottom: 0.8rem;
    }
    
    [dir=ltr] .dark-layout #breadcrumb-alignment .breadcrumb-wrapper {
      box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.24);
    }
    
    [dir=rtl] .dark-layout #breadcrumb-alignment .breadcrumb-wrapper {
      box-shadow: -1px 1px 10px rgba(0, 0, 0, 0.24);
    }
    
    .buy-now {
      position: fixed;
      bottom: 5%;
      z-index: 1031;
    }
    
    [dir=ltr] .buy-now {
      right: 79px;
    }
    
    [dir=rtl] .buy-now {
      left: 79px;
    }
     .buy-now .btn {
      box-shadow: 0 1px 20px 1px #EA5455 !important;
    }
     .buy-now .btn:hover {
      box-shadow: none !important;
    }
    
    /*=========================================================================================
      File Name: customizer.scss
      Description: CSS used for demo purpose only. Remove this css from your project.
    
    ==========================================================================================*/
    .customizer {
      width: 400px;
      z-index: 1051;
      position: fixed;
      top: 0;
      bottom: 0;
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
      backface-visibility: hidden;
    }
     .customizer {
      padding: 0;
      background-color: #fff;
    }
    [dir=ltr] .customizer {
      right: -400px;
      transition: right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);
      border-left: 1px solid rgba(34, 41, 47, 0.05);
    }
    [dir=rtl] .customizer {
      left: -400px;
      transition: left 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);
      border-right: 1px solid rgba(34, 41, 47, 0.05);
    }
     .customizer.open {
      box-shadow: 0 15px 30px 0 rgba(34, 41, 47, 0.11), 0 5px 15px 0 rgba(34, 41, 47, 0.08);
    }
    [dir=ltr] .customizer.open {
      right: 0;
    }
    [dir=rtl] .customizer.open {
      left: 0;
    }
    .customizer .customizer-content {
      position: relative;
      height: 100%;
    }
    .customizer .customizer-close {
      position: absolute;
      top: 0.6rem;
      width: auto;
      z-index: 10;
      color: #424244;
    }
     .customizer .customizer-close {
      padding: 7px;
    }
    [dir=ltr] .customizer .customizer-close {
      right: 0.6rem;
    }
    [dir=rtl] .customizer .customizer-close {
      left: 0.6rem;
    }
    .customizer .customizer-close i,
    .customizer .customizer-close svg {
      font-size: 1.5rem;
      height: 1.5rem;
      width: 1.5rem;
    }
    .customizer .customizer-toggle {
      color: #fff !important;
      display: block;
      position: absolute;
      top: 50%;
      width: 38px;
      height: 38px;
      line-height: 40px;
    }
     .customizer .customizer-toggle {
      background: #114A9F;
      text-align: center;
      cursor: pointer;
    }
    [dir=ltr] .customizer .customizer-toggle {
      box-shadow: -3px 0px 8px rgba(34, 41, 47, 0.1);
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      left: -39px;
    }
    [dir=rtl] .customizer .customizer-toggle {
      box-shadow: 3px 0px 8px rgba(34, 41, 47, 0.1);
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
      right: -39px;
    }
    .customizer .color-box {
      height: 24px;
      width: 24px;
      position: relative;
    }
     .customizer .color-box {
      margin: 0.5rem;
      border-radius: 0.5rem;
      cursor: pointer;
    }
    .customizer .color-box.selected:after {
      content: "";
      height: 30px;
      width: 30px;
      top: -3px;
      position: absolute;
    }
     .customizer .color-box.selected:after {
      border: 1px solid #114A9F;
      border-radius: 0.5rem;
    }
    [dir=ltr] .customizer .color-box.selected:after {
      left: -3px;
    }
    [dir=rtl] .customizer .color-box.selected:after {
      right: -3px;
    }
    .customizer .color-box.selected.border:after {
      top: -4px;
    }
    [dir=ltr] .customizer .color-box.selected.border:after {
      left: -4px;
    }
    [dir=rtl] .customizer .color-box.selected.border:after {
      right: -4px;
    }
    
    .divider {
      display: block;
      overflow: hidden;
      white-space: nowrap;
    }
    
     .divider {
      text-align: center;
      margin: 1rem 0;
    }
    .divider .divider-text {
      position: relative;
      display: inline-block;
      font-size: 0.9375rem;
    }
     .divider .divider-text {
      padding: 0 1rem;
    }
    .divider .divider-text i,
    .divider .divider-text svg {
      height: 1rem;
      width: 1rem;
      font-size: 1rem;
    }
    .divider .divider-text:before, .divider .divider-text:after {
      content: "";
      position: absolute;
      top: 50%;
      width: 9999px;
    }
     .divider .divider-text:before,  .divider .divider-text:after {
      border-top: 1px solid #ebe9f1;
    }
    [dir=ltr] .divider .divider-text:before {
      right: 100%;
    }
    [dir=rtl] .divider .divider-text:before {
      left: 100%;
    }
    [dir=ltr] .divider .divider-text:after {
      left: 100%;
    }
    [dir=rtl] .divider .divider-text:after {
      right: 100%;
    }
    [dir=ltr] .divider.divider-left .divider-text {
      float: left;
      padding-left: 0;
    }
    [dir=rtl] .divider.divider-left .divider-text {
      float: right;
      padding-right: 0;
    }
    .divider.divider-left .divider-text:before {
      display: none;
    }
    [dir=ltr] .divider.divider-left-center .divider-text {
      left: -25%;
    }
    [dir=rtl] .divider.divider-left-center .divider-text {
      right: -25%;
    }
    [dir=ltr] .divider.divider-right .divider-text {
      float: right;
      padding-right: 0;
    }
    [dir=rtl] .divider.divider-right .divider-text {
      float: left;
      padding-left: 0;
    }
    .divider.divider-right .divider-text:after {
      display: none;
    }
    [dir=ltr] .divider.divider-right-center .divider-text {
      right: -25%;
    }
    [dir=rtl] .divider.divider-right-center .divider-text {
      left: -25%;
    }
     .divider.divider-dotted .divider-text:before,  .divider.divider-dotted .divider-text:after {
      border-style: dotted;
      border-width: 1px;
      border-top-width: 0;
      border-color: #ebe9f1;
    }
     .divider.divider-dashed .divider-text:before,  .divider.divider-dashed .divider-text:after {
      border-style: dashed;
      border-width: 1px;
      border-top-width: 0;
      border-color: #ebe9f1;
    }
    
    .timeline {
      list-style: none;
    }
    
     .timeline {
      padding: 0;
      margin-bottom: 0;
    }
    
    [dir=ltr] .timeline {
      margin-left: 1rem;
    }
    
    [dir=rtl] .timeline {
      margin-right: 1rem;
    }
    .timeline .timeline-item {
      position: relative;
    }
    [dir=ltr] .timeline .timeline-item {
      padding-left: 2.5rem;
      border-left: 1px solid #ebe9f1;
    }
    [dir=rtl] .timeline .timeline-item {
      padding-right: 2.5rem;
      border-right: 1px solid #ebe9f1;
    }
     .timeline .timeline-item:not(:last-child) {
      padding-bottom: 1.8rem;
    }
    .timeline .timeline-item .timeline-point {
      position: absolute;
      top: 0;
      z-index: 2;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 1.75rem;
      width: 1.75rem;
    }
     .timeline .timeline-item .timeline-point {
      text-align: center;
      border-radius: 50%;
      border: 1px solid #114A9F;
      background-color: #fff;
    }
    [dir=ltr] .timeline .timeline-item .timeline-point {
      left: -0.85rem;
    }
    [dir=rtl] .timeline .timeline-item .timeline-point {
      right: -0.85rem;
    }
    .timeline .timeline-item .timeline-point.timeline-point-indicator {
      top: 0.07rem;
      height: 12px;
      width: 12px;
    }
     .timeline .timeline-item .timeline-point.timeline-point-indicator {
      border: 0;
      background-color: #114A9F;
    }
    [dir=ltr] .timeline .timeline-item .timeline-point.timeline-point-indicator {
      left: -0.412rem;
    }
    [dir=rtl] .timeline .timeline-item .timeline-point.timeline-point-indicator {
      right: -0.412rem;
    }
    .timeline .timeline-item .timeline-point.timeline-point-indicator:before {
      content: "";
      height: 20px;
      width: 20px;
      display: block;
      position: absolute;
      top: -0.285rem;
    }
     .timeline .timeline-item .timeline-point.timeline-point-indicator:before {
      background: rgba(17, 74, 159, 0.12);
      border-radius: 50%;
    }
    [dir=ltr] .timeline .timeline-item .timeline-point.timeline-point-indicator:before {
      left: -0.285rem;
    }
    [dir=rtl] .timeline .timeline-item .timeline-point.timeline-point-indicator:before {
      right: -0.285rem;
    }
    .timeline .timeline-item .timeline-point i,
    .timeline .timeline-item .timeline-point svg {
      color: #114A9F;
      font-size: 0.85rem;
      vertical-align: baseline;
    }
    .timeline .timeline-item .timeline-event {
      position: relative;
      width: 100%;
      min-height: 4rem;
    }
    .timeline .timeline-item .timeline-event .timeline-event-time {
      font-size: 0.85rem;
      color: #b9b9c3;
    }
    [dir=ltr] .timeline .timeline-item:last-of-type {
      border-left-color: transparent !important;
    }
    [dir=rtl] .timeline .timeline-item:last-of-type {
      border-right-color: transparent !important;
    }
    .timeline .timeline-item:last-of-type:after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 1px;
      height: 100%;
    }
     .timeline .timeline-item:last-of-type:after {
      background: linear-gradient(#ebe9f1, transparent);
    }
    [dir=ltr] .timeline .timeline-item:last-of-type:after {
      left: -1px;
    }
    [dir=rtl] .timeline .timeline-item:last-of-type:after {
      right: -1px;
    }
    
    @media screen and (min-width: 0px) {
      head {
        font-family: "xs 0px";
      }
    
      body:after {
        content: "xs - min-width: 0px";
      }
    }
    @media screen and (min-width: 544px) {
      head {
        font-family: "sm 544px";
      }
    
      body:after {
        content: "sm - min-width: 544px";
      }
    }
    @media screen and (min-width: 768px) {
      head {
        font-family: "md 768px";
      }
    
      body:after {
        content: "md - min-width: 768px";
      }
    }
    @media screen and (min-width: 992px) {
      head {
        font-family: "lg 992px";
      }
    
      body:after {
        content: "lg - min-width: 992px";
      }
    }
    @media screen and (min-width: 1200px) {
      head {
        font-family: "xl 1200px";
      }
    
      body:after {
        content: "xl - min-width: 1200px";
      }
    }
     head {
      clear: both;
    }
    head title {
      font-family: "xs 0px, sm 544px, md 768px, lg 992px, xl 1200px";
    }
    
    body:after {
      display: none;
    }
    
    *[data-usn-if] {
      display: none;
    }
    
    .select2-container {
      width: 100% !important;
      display: inline-block;
      position: relative;
      vertical-align: middle;
      box-sizing: border-box;
    }
    
     .select2-container {
      margin: 0;
    }
    
    .select2-container--classic:focus,
    .select2-container--default:focus {
      outline: none;
    }
    .select2-container--classic .select2-selection__choice,
    .select2-container--default .select2-selection__choice {
      font-size: 0.9rem;
    }
     .select2-container--classic .select2-selection__choice,  .select2-container--default .select2-selection__choice {
      margin-top: 6px !important;
    }
    .select2-container--classic .select2-selection--single,
    .select2-container--default .select2-selection--single {
      min-height: 2.714rem;
    }
     .select2-container--classic .select2-selection--single,  .select2-container--default .select2-selection--single {
      padding: 5px;
      border: 1px solid #D6D9E1;
    }
    .select2-container--classic .select2-selection--single:focus,
    .select2-container--default .select2-selection--single:focus {
      outline: 0;
    }
     .select2-container--classic .select2-selection--single:focus,  .select2-container--default .select2-selection--single:focus {
      border-color: #114A9F !important;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1) !important;
    }
    .select2-container--classic .select2-selection--single .select2-selection__rendered i,
    .select2-container--classic .select2-selection--single .select2-selection__rendered svg,
    .select2-container--default .select2-selection--single .select2-selection__rendered i,
    .select2-container--default .select2-selection--single .select2-selection__rendered svg {
      font-size: 1.15rem;
      height: 1.15rem;
      width: 1.15rem;
    }
    [dir=ltr] .select2-container--classic .select2-selection--single .select2-selection__rendered i, [dir=ltr] .select2-container--classic .select2-selection--single .select2-selection__rendered svg, [dir=ltr] .select2-container--default .select2-selection--single .select2-selection__rendered i, [dir=ltr] .select2-container--default .select2-selection--single .select2-selection__rendered svg {
      margin-right: 0.5rem;
    }
    [dir=rtl] .select2-container--classic .select2-selection--single .select2-selection__rendered i, [dir=rtl] .select2-container--classic .select2-selection--single .select2-selection__rendered svg, [dir=rtl] .select2-container--default .select2-selection--single .select2-selection__rendered i, [dir=rtl] .select2-container--default .select2-selection--single .select2-selection__rendered svg {
      margin-left: 0.5rem;
    }
    .select2-container--classic .select2-selection--single .select2-selection__arrow b,
    .select2-container--default .select2-selection--single .select2-selection__arrow b {
      height: 1rem;
    }
     .select2-container--classic .select2-selection--single .select2-selection__arrow b,  .select2-container--default .select2-selection--single .select2-selection__arrow b {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23D6D9E1' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
      background-size: 18px 14px, 18px 14px;
      background-repeat: no-repeat;
      margin-top: 0;
      border-style: none;
    }
    [dir=ltr] .select2-container--classic .select2-selection--single .select2-selection__arrow b, [dir=ltr] .select2-container--default .select2-selection--single .select2-selection__arrow b {
      padding-right: 1.5rem;
      margin-left: 0;
      left: -8px;
    }
    [dir=rtl] .select2-container--classic .select2-selection--single .select2-selection__arrow b, [dir=rtl] .select2-container--default .select2-selection--single .select2-selection__arrow b {
      padding-left: 1.5rem;
      margin-right: 0;
      right: -8px;
    }
     .select2-container--classic.select2-container--open,  .select2-container--default.select2-container--open {
      box-shadow: 0 5px 25px rgba(34, 41, 47, 0.1);
    }
    .select2-container--classic.select2-container--open .select2-selection--single,
    .select2-container--default.select2-container--open .select2-selection--single {
      outline: 0;
    }
     .select2-container--classic.select2-container--open .select2-selection--single,  .select2-container--default.select2-container--open .select2-selection--single {
      border-color: #114A9F !important;
    }
    .select2-container--classic.select2-container--focus,
    .select2-container--default.select2-container--focus {
      outline: 0;
    }
    .select2-container--classic.select2-container--focus .select2-selection--multiple,
    .select2-container--default.select2-container--focus .select2-selection--multiple {
      outline: 0;
    }
     .select2-container--classic.select2-container--focus .select2-selection--multiple,  .select2-container--default.select2-container--focus .select2-selection--multiple {
      border-color: #114A9F !important;
    }
     .select2-container--classic .select2-dropdown,  .select2-container--default .select2-dropdown {
      border-color: #D6D9E1;
    }
     .select2-container--classic .select2-search--dropdown,  .select2-container--default .select2-search--dropdown {
      padding: 0.5rem;
    }
    .select2-container--classic .select2-search--dropdown .select2-search__field,
    .select2-container--default .select2-search--dropdown .select2-search__field {
      outline: none !important;
    }
     .select2-container--classic .select2-search--dropdown .select2-search__field,  .select2-container--default .select2-search--dropdown .select2-search__field {
      border-radius: 0.357rem;
      border-color: #D6D9E1;
      padding: 0.438rem 1rem;
    }
    .select2-container--classic .select2-selection--multiple,
    .select2-container--default .select2-selection--multiple {
      min-height: 38px !important;
    }
     .select2-container--classic .select2-selection--multiple,  .select2-container--default .select2-selection--multiple {
      border: 1px solid #D6D9E1;
    }
    .select2-container--classic .select2-selection--multiple:focus,
    .select2-container--default .select2-selection--multiple:focus {
      outline: 0;
    }
     .select2-container--classic .select2-selection--multiple:focus,  .select2-container--default .select2-selection--multiple:focus {
      border-color: #114A9F !important;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1) !important;
    }
    .select2-container--classic .select2-selection--multiple .select2-selection__choice,
    .select2-container--default .select2-selection--multiple .select2-selection__choice {
      color: #fff;
    }
     .select2-container--classic .select2-selection--multiple .select2-selection__choice,  .select2-container--default .select2-selection--multiple .select2-selection__choice {
      background-color: #114A9F !important;
      border-color: #114A9F !important;
      padding: 2px 5px;
    }
     .select2-container--classic .select2-selection--multiple .select2-selection__rendered,  .select2-container--default .select2-selection--multiple .select2-selection__rendered {
      padding: 0 6px;
    }
     .select2-container--classic .select2-selection--multiple .select2-selection__rendered li .select2-search__field,  .select2-container--default .select2-selection--multiple .select2-selection__rendered li .select2-search__field {
      margin-top: 7px;
    }
    .select2-container--classic .select2-selection--multiple .select2-selection__choice__remove,
    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
      font-size: 0px;
      display: inline-block;
      position: relative;
      line-height: 1rem;
    }
    [dir=ltr] .select2-container--classic .select2-selection--multiple .select2-selection__choice__remove, [dir=ltr] .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
      float: right;
      margin-left: 0.7rem;
      margin-right: 0.5rem;
    }
    [dir=rtl] .select2-container--classic .select2-selection--multiple .select2-selection__choice__remove, [dir=rtl] .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
      float: left;
      margin-right: 0.7rem;
      margin-left: 0.5rem;
    }
    .select2-container--classic .select2-selection--multiple .select2-selection__choice__remove:before,
    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:before {
      content: "";
      height: 0.85rem;
      width: 0.85rem;
      position: absolute;
      top: 22%;
    }
     .select2-container--classic .select2-selection--multiple .select2-selection__choice__remove:before,  .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-x'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E");
      background-size: 0.85rem;
    }
    [dir=ltr] .select2-container--classic .select2-selection--multiple .select2-selection__choice__remove:before, [dir=ltr] .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:before {
      left: -4px;
    }
    [dir=rtl] .select2-container--classic .select2-selection--multiple .select2-selection__choice__remove:before, [dir=rtl] .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:before {
      right: -4px;
    }
    .select2-container--classic .select2-selection--multiple i,
    .select2-container--classic .select2-selection--multiple svg,
    .select2-container--default .select2-selection--multiple i,
    .select2-container--default .select2-selection--multiple svg {
      position: relative;
      top: 1px;
      height: 1.15rem;
      width: 1.15rem;
      font-size: 1.15rem;
    }
    [dir=ltr] .select2-container--classic .select2-selection--multiple i, [dir=ltr] .select2-container--classic .select2-selection--multiple svg, [dir=ltr] .select2-container--default .select2-selection--multiple i, [dir=ltr] .select2-container--default .select2-selection--multiple svg {
      margin-right: 0.5rem;
      padding-left: 1px;
    }
    [dir=rtl] .select2-container--classic .select2-selection--multiple i, [dir=rtl] .select2-container--classic .select2-selection--multiple svg, [dir=rtl] .select2-container--default .select2-selection--multiple i, [dir=rtl] .select2-container--default .select2-selection--multiple svg {
      margin-left: 0.5rem;
      padding-right: 1px;
    }
    .select2-container--classic .select2-results__group,
    .select2-container--default .select2-results__group {
      font-weight: 600;
    }
     .select2-container--classic .select2-results__group,  .select2-container--default .select2-results__group {
      padding: 6px 9px;
    }
     .select2-container--classic .select2-results__option,  .select2-container--default .select2-results__option {
      padding: 0.428rem 1rem;
    }
     .select2-container--classic .select2-results__option[role=group],  .select2-container--default .select2-results__option[role=group] {
      padding: 0;
    }
    .select2-container--classic .select2-results__option[aria-selected=true],
    .select2-container--default .select2-results__option[aria-selected=true] {
      color: white !important;
    }
     .select2-container--classic .select2-results__option[aria-selected=true],  .select2-container--default .select2-results__option[aria-selected=true] {
      background-color: #114A9F !important;
    }
    .select2-container--classic .select2-results__option i,
    .select2-container--classic .select2-results__option svg,
    .select2-container--default .select2-results__option i,
    .select2-container--default .select2-results__option svg {
      height: 1.15rem;
      width: 1.15rem;
      font-size: 1.15rem;
    }
    [dir=ltr] .select2-container--classic .select2-results__option i, [dir=ltr] .select2-container--classic .select2-results__option svg, [dir=ltr] .select2-container--default .select2-results__option i, [dir=ltr] .select2-container--default .select2-results__option svg {
      margin-right: 0.5rem;
    }
    [dir=rtl] .select2-container--classic .select2-results__option i, [dir=rtl] .select2-container--classic .select2-results__option svg, [dir=rtl] .select2-container--default .select2-results__option i, [dir=rtl] .select2-container--default .select2-results__option svg {
      margin-left: 0.5rem;
    }
    .select2-container--classic .select2-results__option--highlighted,
    .select2-container--default .select2-results__option--highlighted {
      color: #114A9F !important;
    }
     .select2-container--classic .select2-results__option--highlighted,  .select2-container--default .select2-results__option--highlighted {
      background-color: rgba(17, 74, 159, 0.12) !important;
    }
    .select2-container--classic .select2-result-repository__avatar img,
    .select2-container--default .select2-result-repository__avatar img {
      width: 50px;
    }
    .select2-container--classic .select-lg,
    .select2-container--default .select-lg {
      min-height: 2.6666666667rem !important;
      font-size: 1.2rem;
    }
     .select2-container--classic .select-lg,  .select2-container--default .select-lg {
      margin-bottom: 0 !important;
      padding: 0.3rem 0.7rem;
    }
     .select2-container--classic .select-lg.select2-selection--single .select2-selection__rendered,  .select2-container--default .select-lg.select2-selection--single .select2-selection__rendered {
      padding-top: -0.1rem;
    }
    .select2-container--classic .select-lg.select2-selection--single .select2-selection__arrow,
    .select2-container--default .select-lg.select2-selection--single .select2-selection__arrow {
      top: 0rem !important;
    }
     .select2-container--classic .select-lg.select2-selection--multiple,  .select2-container--default .select-lg.select2-selection--multiple {
      padding: 0 0.2rem;
    }
     .select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered,  .select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered {
      padding-top: 0 !important;
    }
    .select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered li,
    .select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered li {
      font-size: 1.2rem;
    }
     .select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered li .select2-search__field,  .select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered li .select2-search__field {
      margin-top: 10px;
    }
     .select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice,  .select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice {
      padding: 5px;
    }
    .select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice .select2-selection__choice__remove:before,
    .select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice .select2-selection__choice__remove:before {
      top: 46%;
    }
    .select2-container--classic .select-sm,
    .select2-container--default .select-sm {
      min-height: 2.142rem !important;
      font-size: 0.75rem;
      line-height: 1.5;
    }
     .select2-container--classic .select-sm,  .select2-container--default .select-sm {
      padding: 0 0.2rem;
      margin-bottom: 0 !important;
    }
    .select2-container--classic .select-sm.select2-selection--single .select2-selection__arrow,
    .select2-container--default .select-sm.select2-selection--single .select2-selection__arrow {
      top: -0.3rem !important;
    }
    .select2-container--classic .select-sm.select2-selection--multiple,
    .select2-container--default .select-sm.select2-selection--multiple {
      line-height: 1.3;
    }
     .select2-container--classic .select-sm.select2-selection--multiple .select2-selection__rendered,  .select2-container--default .select-sm.select2-selection--multiple .select2-selection__rendered {
      padding: 3px;
    }
    .select2-container--classic .select-sm.select2-selection--multiple .select2-selection__rendered li,
    .select2-container--default .select-sm.select2-selection--multiple .select2-selection__rendered li {
      font-size: 0.75rem;
    }
     .select2-container--classic .select-sm.select2-selection--multiple .select2-selection__rendered li,  .select2-container--default .select-sm.select2-selection--multiple .select2-selection__rendered li {
      margin-top: 2px;
    }
     .select2-container--classic .select-sm.select2-selection--multiple .select2-selection__rendered li .select2-search__field,  .select2-container--default .select-sm.select2-selection--multiple .select2-selection__rendered li .select2-search__field {
      margin-top: 4px;
    }
     .select2-container--classic .select-sm.select2-selection--multiple .select2-selection__choice,  .select2-container--default .select-sm.select2-selection--multiple .select2-selection__choice {
      padding: 0 0.2rem;
    }
    .select2-container--classic .select-sm.select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove:before,
    .select2-container--default .select-sm.select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove:before {
      top: 5%;
    }
     .select2-container--classic .select-sm.select2-selection--multiple .select2-search--inline .select2-search__field,  .select2-container--default .select-sm.select2-selection--multiple .select2-search--inline .select2-search__field {
      margin-top: 0;
    }
    
    .dark-layout .select2-container .select2-selection,
    .dark-layout .select2-container .select2-search__field,
    .dark-layout .select2-container .select2-selection__placeholder {
      color: #b4b7bd;
    }
    
     .dark-layout .select2-container .select2-selection,  .dark-layout .select2-container .select2-search__field,  .dark-layout .select2-container .select2-selection__placeholder {
      background: #283046;
      border-color: #3b4253;
    }
    .dark-layout .select2-container .select2-selection__rendered {
      color: #b4b7bd;
    }
     .dark-layout .select2-container .select2-dropdown {
      background-color: #283046;
      border-color: #3b4253;
    }
    .dark-layout .select2-container .select2-selection--multiple .select2-selection__choice {
      color: #114A9F !important;
    }
     .dark-layout .select2-container .select2-selection--multiple .select2-selection__choice {
      background: rgba(17, 74, 159, 0.12) !important;
      border: none;
    }
    .dark-layout .select2-container .select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove {
      color: #114A9F !important;
    }
     .dark-layout .select2-container .select2-selection--multiple .select2-selection__choice__remove:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23114A9F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-x'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E");
    }
    .dark-layout .select2-container .select2-results__option[aria-disabled=true] {
      color: #676d7d;
    }
     .dark-layout .select2-container .select2-selection__arrow b {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .dark-layout .select2-container--disabled .select2-selection {
      opacity: 0.5;
    }
    
    table.dataTable {
      width: 100% !important;
      border-collapse: collapse !important;
    }
    table.dataTable td,
    table.dataTable th {
      vertical-align: middle;
    }
     table.dataTable td,  table.dataTable th {
      padding: 0.72rem 1.5rem;
    }
    [dir=ltr] table.dataTable thead .sorting, [dir=ltr] table.dataTable thead .sorting_asc, [dir=ltr] table.dataTable thead .sorting_desc {
      padding-right: inherit;
    }
    [dir=rtl] table.dataTable thead .sorting, [dir=rtl] table.dataTable thead .sorting_asc, [dir=rtl] table.dataTable thead .sorting_desc {
      padding-left: inherit;
    }
    table.dataTable thead .sorting:before,
    table.dataTable thead .sorting_asc:before,
    table.dataTable thead .sorting_desc:before {
      color: #424244;
      width: 14px;
      height: 14px;
      content: "";
      top: 0.5rem;
    }
     table.dataTable thead .sorting:before,  table.dataTable thead .sorting_asc:before,  table.dataTable thead .sorting_desc:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 12px;
    }
    [dir=ltr] table.dataTable thead .sorting:before, [dir=ltr] table.dataTable thead .sorting_asc:before, [dir=ltr] table.dataTable thead .sorting_desc:before {
      right: 0.3rem;
    }
    [dir=rtl] table.dataTable thead .sorting:before, [dir=rtl] table.dataTable thead .sorting_asc:before, [dir=rtl] table.dataTable thead .sorting_desc:before {
      left: 0.3rem;
    }
    table.dataTable thead .sorting:after,
    table.dataTable thead .sorting_asc:after,
    table.dataTable thead .sorting_desc:after {
      color: #424244;
      width: 14px;
      height: 14px;
      content: "";
      top: 1.3rem;
    }
     table.dataTable thead .sorting:after,  table.dataTable thead .sorting_asc:after,  table.dataTable thead .sorting_desc:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 12px;
    }
    [dir=ltr] table.dataTable thead .sorting:after, [dir=ltr] table.dataTable thead .sorting_asc:after, [dir=ltr] table.dataTable thead .sorting_desc:after {
      right: 0.3rem;
    }
    [dir=rtl] table.dataTable thead .sorting:after, [dir=rtl] table.dataTable thead .sorting_asc:after, [dir=rtl] table.dataTable thead .sorting_desc:after {
      left: 0.3rem;
    }
    [dir=ltr] table.dataTable .dt-checkboxes-cell .custom-control {
      padding-left: 0;
      padding-right: 1.25rem;
    }
    [dir=rtl] table.dataTable .dt-checkboxes-cell .custom-control {
      padding-right: 0;
      padding-left: 1.25rem;
    }
    
     div.dataTables_wrapper .dt-button-collection {
      background-color: #fff;
    }
    div.dataTables_wrapper .dt-button-collection > div[role=menu] {
      min-width: 8rem;
    }
     div.dataTables_wrapper .dt-button-collection > div[role=menu] {
      box-shadow: 0px 5px 16px -8px;
    }
    [dir=ltr] div.dataTables_wrapper .dt-button-collection > div[role=menu] {
      text-align: left;
    }
    [dir=rtl] div.dataTables_wrapper .dt-button-collection > div[role=menu] {
      text-align: right;
    }
    div.dataTables_wrapper .dt-button-collection [class*=buttons-]:focus {
      outline: 0;
    }
    
    table.dataTable.dtr-column > tbody > tr > td.control:before,
    table.dataTable.dtr-column > tbody > tr > th.control:before {
      line-height: 16px;
    }
    
     div.dataTables_wrapper div.dataTables_filter label,  div.dataTables_wrapper div.dataTables_length label {
      margin-top: 1rem;
      margin-bottom: 0.5rem;
    }
    div.dataTables_wrapper div.dataTables_filter select,
    div.dataTables_wrapper div.dataTables_length select {
      width: 5rem;
    }
     div.dataTables_wrapper div.dataTables_filter select,  div.dataTables_wrapper div.dataTables_length select {
      padding: 0 0.8rem;
      margin: 0 0.5rem;
    }
    [dir=ltr] div.dataTables_wrapper div.dataTables_filter select, [dir=ltr] div.dataTables_wrapper div.dataTables_length select {
      background-position: calc(100% - 3px) 11px, calc(100% - 20px) 13px, 100% 0;
    }
    [dir=rtl] div.dataTables_wrapper div.dataTables_filter select, [dir=rtl] div.dataTables_wrapper div.dataTables_length select {
      background-position: calc(100% - (100% - 3px)) 11px, calc(100% - (100% - 20px)) 13px, 0% 0;
    }
    [dir=ltr] div.dataTables_wrapper div.dataTables_filter input {
      margin-left: 0.75rem;
    }
    [dir=rtl] div.dataTables_wrapper div.dataTables_filter input {
      margin-right: 0.75rem;
    }
     div.dataTables_wrapper div.dataTables_paginate ul.pagination {
      margin-top: 1rem;
      margin-bottom: 1.5rem;
    }
    div.dataTables_wrapper .dataTables_info {
      color: #b9b9c3;
    }
     div.dataTables_wrapper .dataTables_info {
      padding-top: 1.25rem !important;
    }
    
     tr.group {
      background-color: #fafafc;
    }
    
    @media only screen and (max-width: 768px) {
      div.dataTables_wrapper div.dataTables_paginate ul.pagination {
        justify-content: center;
      }
    
      div.dataTables_wrapper div.dataTables_info {
        white-space: inherit;
      }
    
      div.dt-buttons {
        justify-content: center;
      }
    
       div.dt-buttons {
        margin-top: 1rem;
      }
       div.dt-buttons button {
        margin-bottom: 0.5rem;
      }
    }
    @media (max-width: 575.98px) {
      .dtr-bs-modal .modal-body {
        overflow-x: scroll;
      }
      [dir=ltr] .dtr-bs-modal .modal-body {
        padding-left: 0;
        padding-right: 0;
      }
      [dir=rtl] .dtr-bs-modal .modal-body {
        padding-right: 0;
        padding-left: 0;
      }
       .dtr-bs-modal .table.dtr-details {
        margin: 0 auto 1rem;
      }
      [dir=ltr] .dtr-bs-modal .table.dtr-details td {
        padding-left: 0;
        padding-right: 0;
      }
      [dir=rtl] .dtr-bs-modal .table.dtr-details td {
        padding-right: 0;
        padding-left: 0;
      }
      [dir=ltr] .dtr-bs-modal .table.dtr-details tr td:first-child {
        padding-left: 0.75rem;
      }
      [dir=rtl] .dtr-bs-modal .table.dtr-details tr td:first-child {
        padding-right: 0.75rem;
      }
    
      div.dataTables_wrapper {
        overflow: scroll;
      }
    }
    /* Bootstrap Touchspin */
    .bootstrap-touchspin.input-group {
      width: 8.4rem;
      align-items: center;
    }
    .bootstrap-touchspin.input-group .form-control {
      height: auto;
      font-weight: 500;
    }
     .bootstrap-touchspin.input-group .form-control {
      padding: 5px;
      border: 0;
      background-color: #f8f8f8;
      border-radius: 0.357rem !important;
      text-align: center;
    }
    .bootstrap-touchspin.input-group .form-control:focus {
      z-index: 1;
    }
     .bootstrap-touchspin.input-group .form-control:focus {
      box-shadow: none;
    }
     .bootstrap-touchspin .bootstrap-touchspin-injected {
      margin: 0 !important;
    }
    .bootstrap-touchspin .bootstrap-touchspin-injected.input-group-prepend {
      position: relative;
    }
    [dir=ltr] .bootstrap-touchspin .bootstrap-touchspin-injected.input-group-prepend {
      left: 12px;
    }
    [dir=rtl] .bootstrap-touchspin .bootstrap-touchspin-injected.input-group-prepend {
      right: 12px;
    }
    .bootstrap-touchspin .bootstrap-touchspin-injected.input-group-append {
      position: relative;
    }
    [dir=ltr] .bootstrap-touchspin .bootstrap-touchspin-injected.input-group-append {
      right: 12px;
    }
    [dir=rtl] .bootstrap-touchspin .bootstrap-touchspin-injected.input-group-append {
      left: 12px;
    }
    .bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down,
    .bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up {
      min-width: 20px;
      min-height: 20px;
    }
     .bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down,  .bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up {
      padding: 0;
      border-radius: 0.357rem !important;
    }
    .bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down i,
    .bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down svg,
    .bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up i,
    .bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up svg {
      height: 0.8rem;
      width: 0.8rem;
      font-size: 0.8rem;
      position: relative;
      top: -1px;
    }
    .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-down,
    .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-up {
      opacity: 0.5;
    }
     .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-down,  .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-up {
      background-color: rgba(34, 41, 47, 0.5) !important;
      cursor: default;
    }
    .bootstrap-touchspin.input-group-lg {
      width: 9.375rem;
    }
    .bootstrap-touchspin.input-group-lg .touchspin.form-control {
      height: auto !important;
    }
    .bootstrap-touchspin.input-group-lg .bootstrap-touchspin-down,
    .bootstrap-touchspin.input-group-lg .bootstrap-touchspin-up {
      min-width: 24px;
      min-height: 24px;
    }
    .bootstrap-touchspin.input-group-lg .bootstrap-touchspin-down i,
    .bootstrap-touchspin.input-group-lg .bootstrap-touchspin-down svg,
    .bootstrap-touchspin.input-group-lg .bootstrap-touchspin-up i,
    .bootstrap-touchspin.input-group-lg .bootstrap-touchspin-up svg {
      height: 1rem;
      width: 1rem;
      font-size: 1rem;
      top: -3px;
    }
    .bootstrap-touchspin.input-group-sm {
      width: 6.25rem;
    }
    .bootstrap-touchspin.input-group-sm .touchspin.form-control {
      height: auto !important;
    }
    .bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-down,
    .bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-up {
      min-width: 16px;
      min-height: 16px;
    }
    .bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-down i,
    .bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-down svg,
    .bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-up i,
    .bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-up svg {
      height: 0.6rem;
      width: 0.6rem;
      font-size: 0.6rem;
    }
    
    /* Number Type Input Box Scss for Touchspin - Remove arrow for firefox */
    .bootstrap-touchspin.input-group input[type=number] {
      -moz-appearance: textfield;
    }
    
     .dark-layout .bootstrap-touchspin.input-group .form-control {
      background-color: #161d31;
    }
    .dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down,
    .dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up,
    .dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .disabled-max-min {
      opacity: 1;
    }
     .dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down,  .dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up,  .dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .disabled-max-min {
      background-color: #b8c2cc !important;
    }
    .dark-layout .bootstrap-touchspin .bootstrap-touchspin-injected .disabled-max-min {
      opacity: 1;
    }
     .dark-layout .bootstrap-touchspin .bootstrap-touchspin-injected .disabled-max-min {
      background-color: #b8c2cc !important;
    }
    
    .dark-layout {
      /********* COMPONENTS *********/
      /********** FORMS **********/
      /********** TABLE **********/
      /********** PAGES **********/
      /********** APPLICATIONS **********/
      /********** CUSTOMIZER **********/
      /********** HORIZONTAL LAYOUT **********/
    }
    body.dark-layout {
      color: #b4b7bd;
    }
     body.dark-layout {
      background-color: #161d31;
    }
    
    .dark-layout body {
      color: #b4b7bd;
    }
    
     .dark-layout body {
      background-color: #161d31;
    }
    .dark-layout h1,
    .dark-layout h2,
    .dark-layout h3,
    .dark-layout h4,
    .dark-layout h5,
    .dark-layout h6 {
      color: #d0d2d6;
    }
     .dark-layout .border,  .dark-layout .border-top,  .dark-layout .border-right,  .dark-layout .border-bottom,  .dark-layout .border-left {
      border-color: #3b4253 !important;
    }
    .dark-layout a:hover {
      color: #114A9F;
    }
    .dark-layout label {
      color: #d0d2d6;
    }
    .dark-layout .btn span {
      color: inherit;
    }
     .dark-layout hr {
      border-color: #3b4253;
    }
     .dark-layout pre {
      background-color: #161d31 !important;
      border: 0;
    }
     .dark-layout pre code {
      background-color: inherit;
      text-shadow: none;
    }
     .dark-layout pre code .url {
      background-color: #161d31;
    }
     .dark-layout code {
      background-color: #161d31;
    }
     .dark-layout kbd {
      background-color: #161d31;
    }
    .dark-layout .text-dark {
      color: #b8c2cc !important;
    }
    .dark-layout .text-muted {
      color: #676d7d !important;
    }
    .dark-layout .text-body {
      color: #b4b7bd !important;
    }
    .dark-layout .text-body-heading {
      color: #d0d2d6;
    }
    .dark-layout .section-label {
      color: #676d7d;
    }
     .dark-layout .shadow {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.24) !important;
    }
    .dark-layout .blockquote-footer {
      color: #676d7d;
    }
    [dir=ltr] .dark-layout .header-navbar-shadow {
      background: linear-gradient(180deg, rgba(22, 29, 49, 0.9) 44%, rgba(22, 29, 49, 0.43) 73%, rgba(22, 29, 49, 0));
    }
    [dir=rtl] .dark-layout .header-navbar-shadow {
      background: linear-gradient(-180deg, rgba(22, 29, 49, 0.9) 44%, rgba(22, 29, 49, 0.43) 73%, rgba(22, 29, 49, 0));
    }
     .dark-layout .horizontal-layout .header-navbar {
      background-color: #283046;
    }
     .dark-layout .horizontal-layout.navbar-sticky .header-navbar,  .dark-layout .horizontal-layout.navbar-static .header-navbar {
      background-color: #161d31;
    }
     .dark-layout .navbar-sticky .header-navbar.navbar-shadow {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.75);
    }
     .dark-layout .header-navbar {
      background-color: #283046;
    }
    .dark-layout .header-navbar .navbar-container .nav .nav-item .nav-link {
      color: #d0d2d6;
    }
     .dark-layout .header-navbar .navbar-container .nav .nav-item .nav-link {
      background-color: transparent;
    }
    .dark-layout .header-navbar .navbar-container .nav .nav-item .nav-link i,
    .dark-layout .header-navbar .navbar-container .nav .nav-item .nav-link svg {
      color: #d0d2d6;
    }
    .dark-layout .header-navbar .navbar-container .nav .nav-item .nav-link.bookmark-star i,
    .dark-layout .header-navbar .navbar-container .nav .nav-item .nav-link.bookmark-star svg {
      color: #fff !important;
    }
     .dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open {
      background-color: #283046;
    }
     .dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .input {
      border-color: #3b4253;
    }
    .dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .input,
    .dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .input::placeholder,
    .dark-layout .header-navbar .navbar-container .nav .nav-item.nav-search .search-input.open .search-input-close {
      color: #b4b7bd;
    }
     .dark-layout .header-navbar .navbar-container .nav .nav-item .bookmark-input {
      background-color: #283046;
    }
     .dark-layout .header-navbar .navbar-container .nav .nav-item .bookmark-input .form-control {
      background-color: #283046;
    }
     .dark-layout .header-navbar .navbar-container .nav .nav-item .search-list {
      background-color: #283046;
    }
    .dark-layout .header-navbar .navbar-container .nav .nav-item .search-list li a {
      color: #b4b7bd;
    }
     .dark-layout .header-navbar .navbar-container .nav .nav-item .search-list .auto-suggestion.current_item {
      background-color: #161d31;
    }
    .dark-layout .header-navbar .navbar-container .nav li i.ficon,
    .dark-layout .header-navbar .navbar-container .nav li svg.ficon {
      color: #b4b7bd;
    }
    .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .dropdown-menu.dropdown-menu-media,
    .dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media {
      overflow: hidden;
    }
     .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .dropdown-menu.dropdown-menu-media .media,  .dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media {
      border-color: #3b4253;
    }
    .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .dropdown-menu.dropdown-menu-media .media .media-meta,
    .dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media .media-meta {
      color: #b4b7bd;
    }
     .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .dropdown-menu.dropdown-menu-media .media:hover,  .dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .media:hover {
      background-color: #161d31;
    }
     .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .dropdown-menu.dropdown-menu-media .dropdown-menu-header,  .dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-header {
      border-bottom: 1px solid #3b4253;
    }
     .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .dropdown-menu.dropdown-menu-media .dropdown-menu-footer,  .dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer {
      background-color: #283046;
      border-top: 1px solid #3b4253;
    }
     .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item,  .dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item {
      border-color: #3b4253;
    }
     .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item:hover,  .dark-layout .header-navbar .navbar-container .nav .dropdown-notification .dropdown-menu.dropdown-menu-media .dropdown-menu-footer .dropdown-item:hover {
      background-color: #283046;
    }
     .dark-layout .header-navbar .navbar-container .nav .dropdown-cart.empty-cart:before {
      background-color: #161d31;
    }
    .dark-layout .header-navbar .navbar-container .nav .dropdown-cart li {
      color: #fff;
    }
    .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .cart-item {
      color: #b4b7bd;
    }
    .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .dropdown-header span {
      color: #fff;
    }
     .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .media img {
      background-color: #161d31;
    }
    .dark-layout .header-navbar .navbar-container .nav .dropdown-cart .media-heading .cart-item-by {
      color: #676d7d;
    }
    .dark-layout .header-navbar .navbar-container .nav .dropdown-notification .media-body .media-heading {
      color: #d0d2d6;
    }
    .dark-layout .header-navbar .navbar-container .nav .dropdown-notification .notification-text {
      color: #676d7d;
    }
     .dark-layout .header-navbar.navbar-static-top {
      background-color: transparent !important;
    }
     .dark-layout .header-navbar[class*=bg-] .navbar-nav .nav-item .nav-link {
      background-color: inherit;
    }
    .dark-layout .blank-page .card.bg-transparent h1,
    .dark-layout .blank-page .card.bg-transparent h2,
    .dark-layout .blank-page .card.bg-transparent h3,
    .dark-layout .blank-page .card.bg-transparent h4,
    .dark-layout .blank-page .card.bg-transparent h5,
    .dark-layout .blank-page .card.bg-transparent h6 {
      color: #283046;
    }
    .dark-layout .blank-page .card.bg-transparent p {
      color: #161d31;
    }
     .dark-layout .main-menu {
      background-color: #283046;
    }
    [dir=ltr] .dark-layout .main-menu .shadow-bottom {
      background: linear-gradient(180deg, #283046 44%, rgba(40, 48, 70, 0.51) 73%, rgba(40, 48, 70, 0));
    }
    [dir=rtl] .dark-layout .main-menu .shadow-bottom {
      background: linear-gradient(-180deg, #283046 44%, rgba(40, 48, 70, 0.51) 73%, rgba(40, 48, 70, 0));
    }
     .dark-layout .main-menu:not(.expanded) .navigation .sidebar-group-active > a {
      background-color: #161d31;
    }
     .dark-layout .main-menu.menu-dark .navigation > li.open:not(.menu-item-closing) > a {
      background-color: #161d31;
    }
     .dark-layout .main-menu.menu-dark .navigation > li.sidebar-group-active > a {
      background-color: #161d31;
    }
    .dark-layout .main-menu .collapse-toggle-icon {
      color: #114A9F !important;
    }
     .dark-layout .ps__thumb-x,  .dark-layout .ps__thumb-y {
      background-color: #b4b7bd;
    }
     .dark-layout .ps .ps__rail-x.ps--clicking,  .dark-layout .ps .ps__rail-x:focus,  .dark-layout .ps .ps__rail-x:hover,  .dark-layout .ps .ps__rail-y.ps--clicking,  .dark-layout .ps .ps__rail-y:focus,  .dark-layout .ps .ps__rail-y:hover {
      background-color: #3b4253;
    }
     .dark-layout .ps__rail-y.ps--clicking .ps__thumb-y,  .dark-layout .ps__rail-y:focus > .ps__thumb-y,  .dark-layout .ps__rail-y:hover > .ps__thumb-y {
      background-color: #b4b7bd;
    }
     .dark-layout .main-menu-content .navigation-main {
      background-color: #283046;
    }
    .dark-layout .main-menu-content .navigation-main .navigation-header {
      color: #676d7d;
    }
    .dark-layout .main-menu-content .navigation-main li a {
      color: #d0d2d6 !important;
    }
     .dark-layout .main-menu-content .navigation-main li ul .open > a,  .dark-layout .main-menu-content .navigation-main li ul .sidebar-group-active > a {
      background-color: #161d31;
    }
    .dark-layout .main-menu-content .navigation-main .nav-item i,
    .dark-layout .main-menu-content .navigation-main .nav-item svg {
      color: #d0d2d6;
    }
     .dark-layout .main-menu-content .navigation-main .nav-item.open > a {
      background-color: #161d31 !important;
    }
    .dark-layout .main-menu-content .navigation-main .nav-item a:after {
      color: #d0d2d6;
    }
     .dark-layout .main-menu-content .navigation-main .nav-item .menu-content {
      background-color: #283046;
    }
    .dark-layout .main-menu-content .navigation-main .nav-item .menu-content .active .menu-item {
      color: #fff;
    }
    .dark-layout .main-menu-content .navigation-main .active .menu-title,
    .dark-layout .main-menu-content .navigation-main .active i,
    .dark-layout .main-menu-content .navigation-main .active svg {
      color: #fff;
    }
     .dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content {
      background-color: #283046;
    }
    .dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active {
      z-index: 1;
    }
     .dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active a {
      background-color: transparent;
    }
     .dark-layout .menu-collapsed .main-menu:not(.expanded) .navigation-main li.active > a {
      background: #161d31 !important;
    }
    .dark-layout .alert .alert-heading,
    .dark-layout .alert p {
      color: inherit;
    }
     .dark-layout .alert .close {
      text-shadow: none;
    }
    .dark-layout .alert.alert-dark .alert-heading,
    .dark-layout .alert.alert-dark .alert-body,
    .dark-layout .alert.alert-dark p {
      color: #b8c2cc;
    }
    .dark-layout .alert.alert-dark.alert-dismissible .close {
      color: #b8c2cc !important;
    }
    .dark-layout .content-header-left .breadcrumbs-top .content-header-title {
      color: #d0d2d6;
    }
     .dark-layout .content-header-left .breadcrumbs-top .content-header-title {
      border-color: #3b4253;
    }
    .dark-layout .breadcrumb .breadcrumb-item {
      color: #b4b7bd;
    }
    .dark-layout .breadcrumb .breadcrumb-item + .breadcrumb-item::before {
      color: #b4b7bd;
    }
     .dark-layout .breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout .breadcrumb-chevron.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout [class*=collapse-] .card:not(:last-of-type) {
      border-color: #3b4253;
    }
     .dark-layout .collapse-border .card {
      border-color: #3b4253;
    }
    [dir=ltr] .dark-layout .collapse-shadow {
      box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.24);
    }
    [dir=rtl] .dark-layout .collapse-shadow {
      box-shadow: -1px 1px 10px rgba(0, 0, 0, 0.24);
    }
    [dir=ltr] .dark-layout .collapse-margin .card {
      box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.24) !important;
    }
    [dir=rtl] .dark-layout .collapse-margin .card {
      box-shadow: -1px 1px 10px rgba(0, 0, 0, 0.24) !important;
    }
    .dark-layout .collapse-icon .card-header a {
      color: #b4b7bd;
    }
     .dark-layout .collapse-icon [data-toggle=collapse]:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout .collapse-icon [data-toggle=collapse]:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .dark-layout .btn:not([class*=btn-]) {
      color: #b4b7bd;
    }
    .dark-layout .btn.btn-dark, .dark-layout .btn.btn-outline-dark, .dark-layout .btn.btn-flat-dark {
      color: #b8c2cc;
    }
     .dark-layout .btn.btn-dark {
      background-color: #4B4B4B !important;
    }
    .dark-layout .btn.btn-outline-dark {
      color: #b8c2cc;
    }
     .dark-layout .btn.btn-outline-dark {
      border-color: #4B4B4B;
    }
    .dark-layout .btn.btn-outline-dark:hover:not(.disabled):not(:disabled) {
      color: #b8c2cc;
    }
     .dark-layout .btn.btn-flat-dark:active,  .dark-layout .btn.btn-flat-dark:focus {
      background: #4B4B4B;
    }
    .dark-layout .btn-group-toggle label[class*=btn-outline-] {
      color: #114A9F !important;
    }
     .dark-layout .dropdown-menu {
      background-color: #283046;
      box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.24);
    }
    .dark-layout .dropdown-menu .dropdown-header {
      color: #d0d2d6;
    }
    .dark-layout .dropdown-menu .dropdown-item {
      color: #b4b7bd;
    }
    .dark-layout .dropdown-menu .dropdown-item:hover, .dark-layout .dropdown-menu .dropdown-item:focus {
      color: #114A9F;
    }
     .dark-layout .dropdown-menu .dropdown-item:hover,  .dark-layout .dropdown-menu .dropdown-item:focus {
      background: rgba(17, 74, 159, 0.12);
    }
    .dark-layout .dropdown-menu .dropdown-item:active, .dark-layout .dropdown-menu .dropdown-item.active {
      color: #fff;
    }
     .dark-layout .dropdown-menu .dropdown-item:active,  .dark-layout .dropdown-menu .dropdown-item.active {
      background-color: #114A9F;
    }
    .dark-layout .dropdown-menu .dropdown-item.disabled, .dark-layout .dropdown-menu .dropdown-item:disabled {
      color: #676d7d;
    }
     .dark-layout .dropdown-divider {
      border-color: #3b4253;
    }
     .dark-layout .modal .modal-header,  .dark-layout .modal .modal-header[class*=bg-] {
      background-color: #161d31;
    }
    .dark-layout .modal .modal-header .close {
      color: #b4b7bd;
    }
     .dark-layout .modal .modal-header .close {
      text-shadow: none;
      background-color: #283046 !important;
      box-shadow: 0 3px 8px 0 rgba(11, 10, 25, 0.49) !important;
    }
     .dark-layout .modal .modal-content,  .dark-layout .modal .modal-body,  .dark-layout .modal .modal-footer {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout .pagination:not([class*=pagination-]) .page-item.active {
      background-color: #242b3d;
    }
     .dark-layout .pagination:not([class*=pagination-]) .page-item.active .page-link {
      background-color: #114A9F;
    }
    .dark-layout .pagination:not([class*=pagination-]) .page-item.active .page-link:hover {
      color: #fff;
    }
    .dark-layout .pagination:not([class*=pagination-]) .page-item .page-link {
      color: #b4b7bd;
    }
     .dark-layout .pagination:not([class*=pagination-]) .page-item .page-link {
      background-color: #242b3d;
    }
    .dark-layout .pagination:not([class*=pagination-]) .page-item .page-link:hover {
      color: #114A9F;
    }
    .dark-layout .pagination:not([class*=pagination-]) .page-item.prev-item .page-link:hover, .dark-layout .pagination:not([class*=pagination-]) .page-item.next-item .page-link:hover {
      color: #fff;
    }
     .dark-layout .pagination[class*=pagination-] .page-item:not(.active) .page-link {
      background-color: #242b3d;
    }
    .dark-layout .pagination[class*=pagination-] .page-item:not(.active):not(:hover) .page-link {
      color: #fff;
    }
     .dark-layout .pagination[class*=pagination-] .page-item:not(.active) .page-link:hover {
      background-color: #242b3d;
    }
     .dark-layout .pagination[class*=pagination-] .page-item.active {
      background-color: #242b3d;
    }
     .dark-layout .pagination .page-item.prev-item .page-link:before,  .dark-layout .pagination .page-item.prev .page-link:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout .pagination .page-item.prev-item.disabled .page-link:before,  .dark-layout .pagination .page-item.prev.disabled .page-link:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23676d7d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout .pagination .page-item.next-item .page-link::after,  .dark-layout .pagination .page-item.next .page-link::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout .pagination .page-item.next-item.disabled .page-link:after,  .dark-layout .pagination .page-item.next.disabled .page-link:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23676d7d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .dark-layout .pagination .page-item.disabled .page-link {
      color: #676d7d;
    }
    .dark-layout .nav-tabs .nav-item .nav-link,
    .dark-layout .nav-pills .nav-item .nav-link,
    .dark-layout .nav-tabs.nav-justified .nav-item .nav-link {
      color: #d0d2d6;
    }
    .dark-layout .nav-tabs .nav-item .nav-link.active,
    .dark-layout .nav-pills .nav-item .nav-link.active,
    .dark-layout .nav-tabs.nav-justified .nav-item .nav-link.active {
      color: #114A9F;
    }
     .dark-layout .nav-tabs .nav-item .nav-link.active,  .dark-layout .nav-pills .nav-item .nav-link.active,  .dark-layout .nav-tabs.nav-justified .nav-item .nav-link.active {
      background-color: #283046;
    }
    .dark-layout .nav-tabs .nav-item .nav-link.disabled,
    .dark-layout .nav-pills .nav-item .nav-link.disabled,
    .dark-layout .nav-tabs.nav-justified .nav-item .nav-link.disabled {
      color: #676d7d;
    }
     .dark-layout .nav.wrap-border {
      border-color: #3b4253;
    }
    .dark-layout .nav-pills .nav-item .nav-link.active {
      color: #fff;
    }
     .dark-layout .nav-pills .nav-item .nav-link.active {
      background-color: #114A9F;
    }
     .dark-layout .media-bordered .media:not(:first-child) {
      border-color: #3b4253;
    }
     .dark-layout .popover[x-placement=top] .arrow:before {
      border-top-color: #3b4253;
    }
     .dark-layout .popover[x-placement=top] .arrow:after {
      border-top-color: #283046;
    }
    [dir=ltr] .dark-layout .popover[x-placement=left] .arrow:before {
      border-left-color: #3b4253;
    }
    [dir=rtl] .dark-layout .popover[x-placement=left] .arrow:before {
      border-right-color: #3b4253;
    }
    [dir=ltr] .dark-layout .popover[x-placement=left] .arrow:after {
      border-left-color: #283046;
    }
    [dir=rtl] .dark-layout .popover[x-placement=left] .arrow:after {
      border-right-color: #283046;
    }
    [dir=ltr] .dark-layout .popover[x-placement=right] .arrow:before {
      border-right-color: #3b4253;
    }
    [dir=rtl] .dark-layout .popover[x-placement=right] .arrow:before {
      border-left-color: #3b4253;
    }
    [dir=ltr] .dark-layout .popover[x-placement=right] .arrow:after {
      border-right-color: #283046;
    }
    [dir=rtl] .dark-layout .popover[x-placement=right] .arrow:after {
      border-left-color: #283046;
    }
    .dark-layout .popover .popover-header {
      color: #fff;
    }
    .dark-layout .popover .popover-body {
      color: #b4b7bd;
    }
     .dark-layout .popover .popover-body {
      background-color: #283046;
      border-color: #3b4253 !important;
    }
    .dark-layout .toast {
      color: #b4b7bd;
    }
     .dark-layout .toast {
      background-color: rgba(40, 48, 70, 0.85);
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.24);
    }
    .dark-layout .toast .toast-header {
      color: #b4b7bd;
    }
     .dark-layout .toast .toast-header {
      background-color: #283046;
    }
     .dark-layout .toast .toast-header .close {
      background-color: transparent !important;
      box-shadow: none !important;
      text-shadow: none;
    }
    .dark-layout .list-group .list-group-item:not([class*=list-group-item-]), .dark-layout .list-group .list-group-item.list-group-item-action {
      color: #b4b7bd;
    }
     .dark-layout .list-group .list-group-item:not([class*=list-group-item-]),  .dark-layout .list-group .list-group-item.list-group-item-action {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout .list-group .list-group-item:not([class*=list-group-item-]):hover,  .dark-layout .list-group .list-group-item:not([class*=list-group-item-]):focus,  .dark-layout .list-group .list-group-item.list-group-item-action:hover,  .dark-layout .list-group .list-group-item.list-group-item-action:focus {
      background-color: #161d31;
    }
    .dark-layout .list-group .list-group-item:not([class*=list-group-item-]).active, .dark-layout .list-group .list-group-item:not([class*=list-group-item-]):active, .dark-layout .list-group .list-group-item.list-group-item-action.active, .dark-layout .list-group .list-group-item.list-group-item-action:active {
      color: #fff;
    }
     .dark-layout .list-group .list-group-item:not([class*=list-group-item-]).active,  .dark-layout .list-group .list-group-item:not([class*=list-group-item-]):active,  .dark-layout .list-group .list-group-item.list-group-item-action.active,  .dark-layout .list-group .list-group-item.list-group-item-action:active {
      background-color: #114A9F;
    }
    .dark-layout .list-group .list-group-item.active p,
    .dark-layout .list-group .list-group-item.active small {
      color: #fff;
    }
    .dark-layout .list-group .list-group-item.disabled {
      color: #676d7d;
    }
     .dark-layout .list-group.list-group-circle .list-group-item:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3C/svg%3E");
    }
     .dark-layout .spinner-border {
      border-color: currentColor !important;
    }
    [dir=ltr] .dark-layout .spinner-border {
      border-right-color: transparent !important;
    }
    [dir=rtl] .dark-layout .spinner-border {
      border-left-color: transparent !important;
    }
     .dark-layout .avatar {
      background-color: #161d31;
    }
     .dark-layout .avatar [class*=avatar-status-] {
      border-color: #283046;
    }
     .dark-layout .avatar-group .avatar img,  .dark-layout .avatar-group .avatar .avatar-content {
      box-shadow: 0 0 0 2px #283046, inset 0 0 0 1px rgba(40, 48, 70, 0.07);
    }
    .dark-layout .divider .divider-text {
      color: #b4b7bd;
    }
     .dark-layout .divider .divider-text::before,  .dark-layout .divider .divider-text::after {
      border-color: #3b4253;
    }
     .dark-layout .divider.divider-dark .divider-text::before,  .dark-layout .divider.divider-dark .divider-text::after {
      border-color: #3b4253 !important;
    }
     .dark-layout .timeline .timeline-item {
      border-color: #3b4253;
    }
     .dark-layout .timeline .timeline-item .timeline-point:not(.timeline-point-indicator) {
      background-color: #283046;
    }
    .dark-layout .timeline .timeline-item .timeline-event .timeline-event-time {
      color: #676d7d;
    }
     .dark-layout .timeline .timeline-item:last-of-type:after {
      background: linear-gradient(#3b4253, transparent);
    }
     .dark-layout .card {
      background-color: #283046;
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.24);
    }
     .dark-layout .card .card-footer {
      border-color: #3b4253;
    }
    .dark-layout .card.overlay-img-card .card-img-overlay span,
    .dark-layout .card.overlay-img-card .card-img-overlay p,
    .dark-layout .card.overlay-img-card .card-img-overlay .card-body {
      color: #fff;
    }
    [dir=ltr] .dark-layout .card-developer-meetup .meetup-header .meetup-day {
      border-right-color: #404656;
    }
    [dir=rtl] .dark-layout .card-developer-meetup .meetup-header .meetup-day {
      border-left-color: #404656;
    }
     .dark-layout .card-profile .profile-image-wrapper .profile-image {
      background-color: #161d31;
    }
     .dark-layout .business-card .business-items .business-item {
      border-color: #3b4253;
    }
     .dark-layout .card-app-design .design-planning-wrapper .design-planning {
      background-color: #161d31;
    }
    .dark-layout .card-tiny-line-stats .apexcharts-series-markers .apexcharts-marker {
      stroke: #00CFE8;
    }
    .dark-layout .card-tiny-line-stats .apexcharts-series-markers:last-child .apexcharts-marker {
      fill: #283046;
    }
    [dir=ltr] .dark-layout .card-revenue-budget .revenue-report-wrapper {
      border-right-color: #3b4253;
    }
    [dir=rtl] .dark-layout .card-revenue-budget .revenue-report-wrapper {
      border-left-color: #3b4253;
    }
    .dark-layout .card-revenue-budget .budget-wrapper .apexcharts-series:not(:first-child) path {
      stroke: #b4b7bd;
    }
    .dark-layout .earnings-card .apexcharts-canvas .apexcharts-pie .apexcharts-datalabel-label {
      fill: #b4b7bd !important;
    }
    .dark-layout .earnings-card .apexcharts-canvas .apexcharts-pie .apexcharts-datalabel-value {
      fill: #d0d2d6;
    }
     .dark-layout .card-company-table .avatar {
      background-color: #161d31;
    }
    .dark-layout input.form-control,
    .dark-layout .custom-file-label,
    .dark-layout textarea.form-control {
      color: #b4b7bd;
    }
     .dark-layout input.form-control,  .dark-layout .custom-file-label,  .dark-layout textarea.form-control {
      background-color: #283046;
    }
     .dark-layout input.form-control:not(:focus),  .dark-layout .custom-file-label:not(:focus),  .dark-layout textarea.form-control:not(:focus) {
      border-color: #404656;
    }
    .dark-layout input.form-control::placeholder,
    .dark-layout .custom-file-label::placeholder,
    .dark-layout textarea.form-control::placeholder {
      color: #676d7d;
    }
    .dark-layout input.form-control:disabled, .dark-layout input.form-control[readonly=readonly],
    .dark-layout .custom-file-label:disabled,
    .dark-layout .custom-file-label[readonly=readonly],
    .dark-layout textarea.form-control:disabled,
    .dark-layout textarea.form-control[readonly=readonly] {
      opacity: 0.5;
    }
    .dark-layout .char-textarea.active {
      color: #b4b7bd !important;
    }
    .dark-layout .char-textarea.max-limit {
      color: #EA5455 !important;
    }
    .dark-layout .custom-file-label:after {
      color: #b4b7bd;
    }
     .dark-layout .custom-file-label:after {
      background-color: #161d31;
    }
    [dir=ltr] .dark-layout .custom-file-label:after {
      border-left: 1px solid #3b4253;
    }
    [dir=rtl] .dark-layout .custom-file-label:after {
      border-right: 1px solid #3b4253;
    }
     .dark-layout .custom-control-input:not(:checked) ~ .custom-control-label:before {
      background-color: #283046;
      border-color: #404656;
    }
     .dark-layout .custom-control-input:disabled ~ .custom-control-label:before {
      background-color: #444b60;
      border-color: #444b60;
    }
     .dark-layout .custom-switch .custom-control-input:not(:checked) ~ .custom-control-label:before {
      background-color: #545a6a;
    }
     .dark-layout .custom-switch .custom-control-input:disabled ~ .custom-control-label:before {
      background-color: #1b2337;
    }
    .dark-layout select.form-control,
    .dark-layout .custom-select {
      color: #b4b7bd;
    }
     .dark-layout select.form-control,  .dark-layout .custom-select {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout select.form-control option:checked,  .dark-layout .custom-select option:checked {
      background-color: #283046;
    }
    .dark-layout select.form-control:disabled,
    .dark-layout .custom-select:disabled {
      opacity: 0.5;
    }
     .dark-layout select.form-control:focus,  .dark-layout .custom-select:focus {
      border-color: #114A9F;
    }
     .dark-layout select.form-control:not([multiple=multiple]) {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout .was-validated .form-control:invalid,  .dark-layout .form-control.is-invalid {
      border-color: #EA5455 !important;
    }
     .dark-layout .was-validated .form-control:valid,  .dark-layout .form-control.is-valid {
      border-color: #17B75E !important;
    }
    .dark-layout .wizard .steps ul .disabled a,
    .dark-layout .wizard .steps ul .done a {
      color: #b4b7bd !important;
    }
    .dark-layout .wizard .steps ul .disabled a:hover,
    .dark-layout .wizard .steps ul .done a:hover {
      color: #b4b7bd;
    }
    .dark-layout .wizard .steps ul .disabled a .step,
    .dark-layout .wizard .steps ul .done a .step {
      color: #fff !important;
    }
     .dark-layout .wizard .steps ul .disabled a .step,  .dark-layout .wizard .steps ul .done a .step {
      background-color: #161d31 !important;
    }
    .dark-layout .input-group .input-group-text {
      color: #b4b7bd;
    }
     .dark-layout .input-group .input-group-text {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout .input-group:focus-within .form-control,  .dark-layout .input-group:focus-within .input-group-text {
      border-color: #114A9F;
      box-shadow: none;
    }
    .dark-layout .form-label-group > input:not(:focus):not(:placeholder-shown) ~ label, .dark-layout .form-label-group > textarea:not(:focus):not(:placeholder-shown) ~ label {
      color: #b4b7bd !important;
    }
    .dark-layout .counter-value {
      color: white;
    }
     .dark-layout .table {
      background-color: #283046;
    }
    .dark-layout .table td,
    .dark-layout .table th {
      color: #b4b7bd;
    }
     .dark-layout .table td,  .dark-layout .table th {
      border-color: #3b4253 !important;
    }
    .dark-layout .table .thead tr:not([class*=table-]) th,
    .dark-layout .table .thead tr:not([class*=table-]) td,
    .dark-layout .table tbody tr:not([class*=table-]) th,
    .dark-layout .table tbody tr:not([class*=table-]) td {
      color: #b4b7bd;
    }
     .dark-layout .table .thead tr:not([class*=table-]) th,  .dark-layout .table .thead tr:not([class*=table-]) td,  .dark-layout .table tbody tr:not([class*=table-]) th,  .dark-layout .table tbody tr:not([class*=table-]) td {
      border-color: #3b4253;
    }
     .dark-layout .table .thead tr:not([class*=table-]) th code,  .dark-layout .table .thead tr:not([class*=table-]) td code,  .dark-layout .table tbody tr:not([class*=table-]) th code,  .dark-layout .table tbody tr:not([class*=table-]) td code {
      background-color: #283046;
    }
    .dark-layout .table thead tr th,
    .dark-layout .table tfoot tr th {
      color: #d0d2d6;
    }
     .dark-layout .table thead tr th,  .dark-layout .table tfoot tr th {
      border-color: #3b4253;
      background-color: #343d55;
    }
    .dark-layout .table thead.thead-dark th,
    .dark-layout .table tfoot.thead-dark th {
      color: #4B4B4B !important;
    }
     .dark-layout .table thead.thead-dark th,  .dark-layout .table tfoot.thead-dark th {
      background-color: #fff;
    }
     .dark-layout .table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th,  .dark-layout .table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {
      background-color: #343d55;
    }
     .dark-layout .table.table-dark {
      background-color: #fff;
    }
     .dark-layout .table.table-dark.table-striped tbody tr:nth-of-type(odd) {
      background-color: rgba(75, 75, 75, 0.05);
    }
     .dark-layout .table.table-dark.table-striped tbody tr:nth-of-type(odd) td {
      background-color: inherit;
    }
    .dark-layout .table.table-dark td,
    .dark-layout .table.table-dark th {
      color: #4B4B4B !important;
    }
     .dark-layout .table.table-dark td,  .dark-layout .table.table-dark th {
      border-color: #f8f9fa !important;
      background-color: #fff;
    }
    .dark-layout .table.table-dark td .text-white,
    .dark-layout .table.table-dark th .text-white {
      color: #4B4B4B !important;
    }
     .dark-layout .table tbody tr[class*=table-] td,  .dark-layout .table tbody tr[class*=table-] th {
      background-color: unset;
    }
    .dark-layout .table tbody tr.table-dark td,
    .dark-layout .table tbody tr.table-dark th {
      color: #fff;
    }
    .dark-layout .table tbody tr.table-active td,
    .dark-layout .table tbody tr.table-active th {
      color: #b4b7bd;
    }
     .dark-layout .table.table-bordered {
      border-color: #3b4253;
    }
     .dark-layout .table.table-hover tbody tr:hover {
      background-color: #242b3d;
    }
     .dark-layout .table.table-hover tbody tr th,  .dark-layout .table.table-hover tbody tr td {
      background-color: unset;
    }
     .dark-layout .table.table-hover-animation tbody tr {
      background-color: #283046;
    }
     .dark-layout .table.table-hover-animation tbody tr:hover {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.24);
    }
     .dark-layout .table.table-striped tbody tr:nth-of-type(odd) {
      background-color: #242b3d;
    }
     .dark-layout .dataTables_wrapper .dt-buttons .buttons-copy,  .dark-layout .dataTables_wrapper .dt-buttons .buttons-excel,  .dark-layout .dataTables_wrapper .dt-buttons .buttons-pdf,  .dark-layout .dataTables_wrapper .dt-buttons .buttons-print,  .dark-layout .dataTables_wrapper .dt-buttons .btn-secondary,  .dark-layout .dataTables_wrapper .dt-buttons [class*=buttons-] {
      background-color: #161d31 !important;
    }
    .dark-layout .dataTables_wrapper .dt-buttons .buttons-copy:active,
    .dark-layout .dataTables_wrapper .dt-buttons .buttons-excel:active,
    .dark-layout .dataTables_wrapper .dt-buttons .buttons-pdf:active,
    .dark-layout .dataTables_wrapper .dt-buttons .buttons-print:active,
    .dark-layout .dataTables_wrapper .dt-buttons .btn-secondary:active,
    .dark-layout .dataTables_wrapper .dt-buttons [class*=buttons-]:active {
      color: #fff;
    }
     .dark-layout .dataTables_wrapper .dt-buttons .buttons-copy:active,  .dark-layout .dataTables_wrapper .dt-buttons .buttons-excel:active,  .dark-layout .dataTables_wrapper .dt-buttons .buttons-pdf:active,  .dark-layout .dataTables_wrapper .dt-buttons .buttons-print:active,  .dark-layout .dataTables_wrapper .dt-buttons .btn-secondary:active,  .dark-layout .dataTables_wrapper .dt-buttons [class*=buttons-]:active {
      background-color: #114A9F !important;
    }
     .dark-layout .dataTables_wrapper .dt-button-collection > div[role=menu] {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.24);
    }
    .dark-layout .dataTables_wrapper .table.dataTable tr.group td {
      color: #d0d2d6;
    }
     .dark-layout .dataTables_wrapper .table.dataTable tr.group td {
      background-color: #242b3d;
    }
     .dark-layout .dataTables_wrapper .table.dataTable thead .sorting:before,  .dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:before,  .dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout .dataTables_wrapper .table.dataTable thead .sorting:after,  .dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:after,  .dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .dark-layout .dataTables_wrapper .table.dataTable thead .sorting:before, .dark-layout .dataTables_wrapper .table.dataTable thead .sorting:after {
      opacity: 0.5;
    }
    .dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:before {
      opacity: 1;
    }
    .dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:after {
      opacity: 0.5;
    }
    .dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:after {
      opacity: 1;
    }
    .dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:before {
      opacity: 0.5;
    }
     .dark-layout .ag-grid-btns .filter-btn {
      background-color: transparent !important;
    }
    .dark-layout .aggrid .ag-input-wrapper input {
      color: #b4b7bd;
    }
    .dark-layout .aggrid,
    .dark-layout .ag-header {
      color: #b4b7bd;
    }
     .dark-layout .aggrid,  .dark-layout .ag-header {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout .aggrid .ag-row-hover,  .dark-layout .aggrid .ag-row-selected,  .dark-layout .ag-header .ag-row-hover,  .dark-layout .ag-header .ag-row-selected {
      background-color: #242b3d !important;
    }
    .dark-layout .aggrid .ag-icon,
    .dark-layout .ag-header .ag-icon {
      color: #404656;
    }
     .dark-layout .aggrid .ag-header-cell.ag-column-hover,  .dark-layout .ag-header .ag-header-cell.ag-column-hover {
      background: transparent !important;
    }
    .dark-layout .aggrid .ag-header-cell,
    .dark-layout .aggrid .ag-cell,
    .dark-layout .aggrid .ag-row,
    .dark-layout .aggrid .ag-pinned-left-header,
    .dark-layout .aggrid .ag-pinned-left-cols-container,
    .dark-layout .aggrid .ag-horizontal-left-spacer,
    .dark-layout .aggrid .ag-paging-panel,
    .dark-layout .aggrid .ag-floating-filter-input,
    .dark-layout .ag-header .ag-header-cell,
    .dark-layout .ag-header .ag-cell,
    .dark-layout .ag-header .ag-row,
    .dark-layout .ag-header .ag-pinned-left-header,
    .dark-layout .ag-header .ag-pinned-left-cols-container,
    .dark-layout .ag-header .ag-horizontal-left-spacer,
    .dark-layout .ag-header .ag-paging-panel,
    .dark-layout .ag-header .ag-floating-filter-input {
      color: #b4b7bd;
    }
     .dark-layout .aggrid .ag-header-cell,  .dark-layout .aggrid .ag-cell,  .dark-layout .aggrid .ag-row,  .dark-layout .aggrid .ag-pinned-left-header,  .dark-layout .aggrid .ag-pinned-left-cols-container,  .dark-layout .aggrid .ag-horizontal-left-spacer,  .dark-layout .aggrid .ag-paging-panel,  .dark-layout .aggrid .ag-floating-filter-input,  .dark-layout .ag-header .ag-header-cell,  .dark-layout .ag-header .ag-cell,  .dark-layout .ag-header .ag-row,  .dark-layout .ag-header .ag-pinned-left-header,  .dark-layout .ag-header .ag-pinned-left-cols-container,  .dark-layout .ag-header .ag-horizontal-left-spacer,  .dark-layout .ag-header .ag-paging-panel,  .dark-layout .ag-header .ag-floating-filter-input {
      border-color: #3b4253 !important;
    }
    .dark-layout .aggrid .ag-cell.ag-cell-inline-editing,
    .dark-layout .ag-header .ag-cell.ag-cell-inline-editing {
      height: auto;
    }
     .dark-layout .aggrid .ag-cell.ag-cell-inline-editing,  .dark-layout .ag-header .ag-cell.ag-cell-inline-editing {
      border-color: #3b4253;
      background: #161d31;
      padding-top: 0;
    }
     .dark-layout .aggrid .ag-paging-panel .ag-paging-button,  .dark-layout .ag-header .ag-paging-panel .ag-paging-button {
      background-color: #161d31;
    }
     .dark-layout .aggrid .ag-paging-panel .ag-disabled,  .dark-layout .ag-header .ag-paging-panel .ag-disabled {
      background: #283046;
    }
    .dark-layout .aggrid .ag-paging-panel span[ref=lbTotal],
    .dark-layout .ag-header .ag-paging-panel span[ref=lbTotal] {
      color: #b4b7bd !important;
    }
     .dark-layout .aggrid .ag-paging-panel span[ref=lbTotal],  .dark-layout .ag-header .ag-paging-panel span[ref=lbTotal] {
      background-color: #242b3d;
    }
     .dark-layout .aggrid ::-webkit-scrollbar-track,  .dark-layout .ag-header ::-webkit-scrollbar-track {
      background: #161d31;
    }
     .dark-layout .aggrid ::-webkit-scrollbar-thumb,  .dark-layout .ag-header ::-webkit-scrollbar-thumb {
      background: #114A9F;
    }
    .dark-layout .getting-started .clockCard p {
      color: #b4b7bd !important;
    }
     .dark-layout #user-profile .profile-header .navbar {
      background-color: #283046;
    }
    .dark-layout #user-profile .profile-header .navbar .navbar-toggler {
      color: #b4b7bd;
    }
     .dark-layout #user-profile .profile-header .navbar .navbar-toggler {
      border-color: #3b4253;
    }
     .dark-layout .search-bar .form-control {
      background-color: #283046;
    }
     .dark-layout .blog-edit-wrapper .border {
      border-color: #3b4253 !important;
    }
     .dark-layout .kb-search-content-info .kb-search-content .card-img-top {
      background-color: #3f4860;
    }
     .dark-layout .list-group-circle .list-group-item:not([class*=list-group-item-]):hover,  .dark-layout .list-group-circle .list-group-item:not([class*=list-group-item-]):focus,  .dark-layout .list-group-circle .list-group-item:not([class*=list-group-item-]):active,  .dark-layout .list-group-circle .list-group-item-action:hover,  .dark-layout .list-group-circle .list-group-item-action:focus,  .dark-layout .list-group-circle .list-group-item-action:active {
      background-color: transparent !important;
    }
     .dark-layout .content-area-wrapper {
      border-color: #3b4253 !important;
    }
     .dark-layout .content-area-wrapper .sidebar .sidebar-content {
      background-color: #283046 !important;
    }
     .dark-layout .content-area-wrapper .app-fixed-search {
      background-color: #283046 !important;
      border-color: #3b4253 !important;
    }
     .dark-layout .content-area-wrapper .content-right {
      border-color: #3b4253 !important;
    }
     .dark-layout .email-application .content-area-wrapper .email-app-list .app-action {
      border-color: #3b4253;
      background-color: #283046;
    }
    .dark-layout .email-application .content-area-wrapper .email-app-list .app-action .action-right .list-inline-item .dropdown-toggle {
      color: #b4b7bd;
    }
     .dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media {
      border-color: #3b4253;
      background-color: #283046;
    }
     .dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media:hover {
      box-shadow: 0 3px 10px 0 #283046;
    }
     .dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media.selected-row-bg {
      background-color: rgba(17, 74, 159, 0.06);
      border-color: #3b4253;
    }
    .dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .user-details p,
    .dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .user-details .mail-date,
    .dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .mail-message p,
    .dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .mail-message .mail-date {
      color: #676d7d;
    }
     .dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .mail-read {
      background-color: #242b3d;
    }
     .dark-layout .email-application .content-area-wrapper .email-app-details {
      border-color: #3b4253;
    }
     .dark-layout .email-application .content-area-wrapper .email-app-details .email-scroll-area {
      background-color: #161d31;
    }
     .dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-header {
      background-color: #283046;
      border-color: #3b4253;
    }
    .dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-header .email-header-right .list-inline-item .dropdown-toggle,
    .dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-header .email-header-right .list-inline-item .action-icon {
      color: #b4b7bd;
    }
     .dark-layout .email-application .content-area-wrapper .email-app-details .email-info-dropup .dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23676d7d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout .email-application .content-area-wrapper .email-app-details .mail-message-wrapper,  .dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-head {
      border-color: #3b4253 !important;
    }
     .dark-layout .email-application .content-area-wrapper #compose-mail .compose-mail-form-field,  .dark-layout .email-application .content-area-wrapper #compose-mail .ql-toolbar,  .dark-layout .email-application .content-area-wrapper #compose-mail .ql-container {
      border-color: #3b4253;
    }
    .dark-layout .email-application .content-area-wrapper #compose-mail label {
      color: #b4b7bd;
    }
    [dir=ltr] .dark-layout .email-application .content-area-wrapper #compose-mail .modal-body {
      border-bottom-left-radius: 0.358rem;
      border-bottom-right-radius: 0.358rem;
    }
    [dir=rtl] .dark-layout .email-application .content-area-wrapper #compose-mail .modal-body {
      border-bottom-right-radius: 0.358rem;
      border-bottom-left-radius: 0.358rem;
    }
     .dark-layout .chat-application .content-area-wrapper {
      border-color: #3b4253;
    }
     .dark-layout .chat-application .sidebar .chat-profile-sidebar {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout .chat-application .sidebar .sidebar-content {
      border-color: #3b4253;
    }
     .dark-layout .chat-application .sidebar .sidebar-content .chat-fixed-search {
      border-color: #3b4253;
    }
     .dark-layout .chat-application .sidebar .sidebar-content .chat-user-list-wrapper .chat-users-list li:not(.active):hover {
      background: #161d31;
    }
    .dark-layout .chat-application .sidebar .sidebar-content .chat-user-list-wrapper .chat-users-list li .chat-info .card-text,
    .dark-layout .chat-application .sidebar .sidebar-content .chat-user-list-wrapper .chat-users-list li .chat-time {
      color: #676d7d;
    }
    .dark-layout .chat-application .sidebar .sidebar-content .chat-user-list-wrapper .chat-users-list li.active .chat-info .card-text,
    .dark-layout .chat-application .sidebar .sidebar-content .chat-user-list-wrapper .chat-users-list li.active .chat-time {
      color: #fff;
    }
     .dark-layout .chat-application .sidebar .sidebar-content .chat-user-list-wrapper .chat-users-list li img {
      border-color: #3b4253;
    }
     .dark-layout .chat-application .avatar-border img {
      border-color: #3b4253;
    }
     .dark-layout .chat-application .content-right .chat-app-window .start-chat-area {
      background-color: #283046;
    }
    .dark-layout .chat-application .content-right .chat-app-window .start-chat-area .start-chat-icon,
    .dark-layout .chat-application .content-right .chat-app-window .start-chat-area .start-chat-text {
      color: #b4b7bd;
    }
     .dark-layout .chat-application .content-right .chat-app-window .start-chat-area .start-chat-icon,  .dark-layout .chat-application .content-right .chat-app-window .start-chat-area .start-chat-text {
      background: #283046;
    }
     .dark-layout .chat-application .content-right .chat-app-window .start-chat-area,  .dark-layout .chat-application .content-right .chat-app-window .user-chats {
      background-image: url("data:image/svg+xml;base64,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");
      background-color: #1e232f;
    }
     .dark-layout .chat-application .content-right .chat-app-window .user-chats .divider .divider-text {
      background: #283046;
    }
     .dark-layout .chat-application .content-right .chat-app-window .user-chats .divider .divider-text:before,  .dark-layout .chat-application .content-right .chat-app-window .user-chats .divider .divider-text:after {
      border-color: #3b4253;
    }
     .dark-layout .chat-application .content-right .chat-app-window .user-chats .avatar img {
      border-color: #3b4253;
    }
     .dark-layout .chat-application .content-right .chat-app-window .active-chat .chat-left .chat-content {
      background-color: #283046;
    }
    .dark-layout .chat-application .content-right .chat-app-window .active-chat .chat-left .chat-content p {
      color: #b4b7bd;
    }
    .dark-layout .chat-application .content-right .chat-app-window .active-chat .chat-content p {
      color: #fff;
    }
    .dark-layout .chat-application .content-right .chat-app-window .active-chat .chat-header .dropdown-toggle {
      color: #b4b7bd;
    }
     .dark-layout .chat-application .content-right .chat-app-window .active-chat .chat-header,  .dark-layout .chat-application .content-right .chat-app-window .active-chat .chat-app-form {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout .chat-application .content-right .user-profile-sidebar {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout .chat-widget .user-chats {
      background-color: #384056 !important;
    }
     .dark-layout .chat-widget .card-header,  .dark-layout .chat-widget .chat-app-form {
      background-color: #283046;
    }
    .dark-layout .chat-widget .chat-app-window .user-chats .chat-left .chat-content {
      color: #b4b7bd !important;
    }
     .dark-layout .chat-widget .chat-app-window .user-chats .chat-left .chat-content {
      background-color: #283046 !important;
    }
     .dark-layout .chat-widget .chat-app-window .user-chats .avatar img {
      border-color: #161d31;
    }
    .dark-layout .kanban-application .kanban-wrapper .kanban-container .kanban-board .kanban-board-header .kanban-title-board {
      color: #fff;
    }
     .dark-layout .kanban-application .kanban-wrapper .kanban-container .kanban-board .kanban-board-header .kanban-title-board:hover,  .dark-layout .kanban-application .kanban-wrapper .kanban-container .kanban-board .kanban-board-header .kanban-title-board:focus {
      background-color: #283046;
    }
     .dark-layout .kanban-application .kanban-wrapper .kanban-container .kanban-board .kanban-item {
      background-color: #283046;
    }
    .dark-layout .kanban-application .kanban-wrapper .kanban-container .kanban-board .kanban-item .item-dropdown i.dropdown-toggle,
    .dark-layout .kanban-application .kanban-wrapper .kanban-container .kanban-board .kanban-item .item-dropdown svg.dropdown-toggle {
      stroke: #fff;
    }
    .dark-layout .kanban-application .kanban-wrapper .kanban-container .kanban-board .kanban-item .kanban-title-button {
      color: #b4b7bd;
    }
    .dark-layout .kanban-application .kanban-wrapper .kanban-container .kanban-board .kanban-item i,
    .dark-layout .kanban-application .kanban-wrapper .kanban-container .kanban-board .kanban-item svg {
      stroke: #b4b7bd;
    }
     .dark-layout .kanban-application .update-item-sidebar .nav-tabs .nav-item .nav-link,  .dark-layout .kanban-application .update-item-sidebar .tab-content .tab-pane {
      background-color: transparent;
    }
     .dark-layout .kanban-item.gu-mirror {
      background-color: #283046;
    }
    .dark-layout .todo-application .content-area-wrapper .sidebar .todo-form .todo-item-action {
      color: #b4b7bd;
    }
     .dark-layout .todo-application .content-area-wrapper .content-right .todo-task-list-wrapper {
      background-color: #283046 !important;
      border-color: #3b4253;
    }
     .dark-layout .todo-application .content-area-wrapper .content-right .todo-task-list .todo-item:not(:first-child) {
      border-color: #3b4253;
    }
    .dark-layout .todo-application .content-area-wrapper .content-right .todo-task-list .todo-item.completed .todo-title {
      color: #676d7d;
    }
     .dark-layout .todo-application .content-area-wrapper .content-right .todo-task-list .todo-item:hover {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.24);
    }
    .dark-layout .todo-application .content-area-wrapper .content-right .todo-task-list .todo-item .todo-item-action .todo-item-favorite:not(.text-warning) i,
    .dark-layout .todo-application .content-area-wrapper .content-right .todo-task-list .todo-item .todo-item-action .todo-item-favorite:not(.text-warning) svg {
      color: #b4b7bd;
    }
     .dark-layout .todo-application .todo-item-action .close {
      background-color: transparent !important;
    }
     .dark-layout .todo-item.gu-mirror {
      background-color: #283046;
      border-color: #3b4253;
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.24);
    }
    .dark-layout .todo-item.gu-mirror.completed .todo-title {
      color: #676d7d;
    }
    .dark-layout .ecommerce-application .ecommerce-card .btn-light {
      color: #fff;
    }
     .dark-layout .ecommerce-application .ecommerce-card .btn-light {
      background-color: #161d31 !important;
      border-color: transparent;
    }
    .dark-layout .ecommerce-application .content-right .ecommerce-header-items .result-toggler .search-results,
    .dark-layout .ecommerce-application .content-body .ecommerce-header-items .result-toggler .search-results {
      color: #d0d2d6;
    }
    .dark-layout .ecommerce-application .content-right .ecommerce-header-items .result-toggler .shop-sidebar-toggler i,
    .dark-layout .ecommerce-application .content-right .ecommerce-header-items .result-toggler .shop-sidebar-toggler svg,
    .dark-layout .ecommerce-application .content-body .ecommerce-header-items .result-toggler .shop-sidebar-toggler i,
    .dark-layout .ecommerce-application .content-body .ecommerce-header-items .result-toggler .shop-sidebar-toggler svg {
      color: #d0d2d6;
    }
     .dark-layout .ecommerce-application .content-right .grid-view .ecommerce-card .card-body,  .dark-layout .ecommerce-application .content-right .list-view .ecommerce-card .card-body,  .dark-layout .ecommerce-application .content-body .grid-view .ecommerce-card .card-body,  .dark-layout .ecommerce-application .content-body .list-view .ecommerce-card .card-body {
      border-color: #3b4253;
    }
    .dark-layout .ecommerce-application .content-right .grid-view .ecommerce-card .item-options .wishlist span,
    .dark-layout .ecommerce-application .content-right .list-view .ecommerce-card .item-options .wishlist span,
    .dark-layout .ecommerce-application .content-body .grid-view .ecommerce-card .item-options .wishlist span,
    .dark-layout .ecommerce-application .content-body .list-view .ecommerce-card .item-options .wishlist span {
      color: #424244;
    }
    .dark-layout .ecommerce-application .content-right .grid-view .ecommerce-card .item-options .cart span,
    .dark-layout .ecommerce-application .content-right .list-view .ecommerce-card .item-options .cart span,
    .dark-layout .ecommerce-application .content-body .grid-view .ecommerce-card .item-options .cart span,
    .dark-layout .ecommerce-application .content-body .list-view .ecommerce-card .item-options .cart span {
      color: #fff;
    }
    .dark-layout .ecommerce-application .grid-view .item-name a,
    .dark-layout .ecommerce-application .grid-view .item-price {
      color: #b4b7bd;
    }
    .dark-layout .ecommerce-application .wishlist-items .ecommerce-card .move-cart .move-to-cart {
      color: #fff;
    }
    .dark-layout .ecommerce-application .product-checkout .checkout-options .coupons input {
      color: #b4b7bd;
    }
    .dark-layout .ecommerce-application .product-checkout .checkout-options .coupons input::placeholder {
      color: #b4b7bd;
    }
     .dark-layout .ecommerce-application .app-ecommerce-details .item-features,  .dark-layout .ecommerce-application .app-ecommerce-details .swiper-responsive-breakpoints.swiper-container .swiper-slide {
      background-color: #161d31;
    }
     .dark-layout .file-manager-application .sidebar-file-manager {
      background-color: #283046 !important;
    }
    .dark-layout .file-manager-application .sidebar-file-manager .jstree .jstree-container-ul .jstree-anchor {
      color: #b4b7bd;
    }
    .dark-layout .file-manager-application .sidebar-file-manager .storage-status i,
    .dark-layout .file-manager-application .sidebar-file-manager .storage-status svg {
      color: #b4b7bd !important;
    }
    .dark-layout .file-manager-application .sidebar-file-manager .file-manager-title {
      color: #d0d2d6;
    }
     .dark-layout .file-manager-application .sidebar-file-manager.show {
      border: 1px solid #3b4253 !important;
    }
     .dark-layout .file-manager-application .content-area-wrapper {
      border: 1px solid #3b4253 !important;
    }
     .dark-layout .file-manager-application .file-manager-main-content {
      border: 1px solid #3b4253 !important;
    }
     .dark-layout .file-manager-application .file-manager-main-content .file-manager-app-searchbar {
      background-color: transparent !important;
      border-bottom: 1px solid #3b4253 !important;
    }
    .dark-layout .file-manager-application .file-manager-main-content .file-manager-app-searchbar .file-manager-toggler {
      color: #b4b7bd !important;
    }
     .dark-layout .file-manager-application .file-manager-main-content .file-manager-content-header,  .dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body {
      background-color: #283046 !important;
    }
     .dark-layout .file-manager-application .file-manager-main-content .file-manager-content-header {
      border-color: #3b4253 !important;
    }
     .dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .drives .card {
      background-color: #283046;
    }
     .dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container .file-manager-item .file-logo-wrapper {
      background-color: #161d31 !important;
    }
     .dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container .file-manager-item:not(.selected) {
      border-color: #3b4253 !important;
    }
    .dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container:not(.list-view) .file-manager-item .file-size,
    .dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container:not(.list-view) .file-manager-item .file-accessed {
      color: #676d7d !important;
    }
     .dark-layout .file-manager-application #app-file-manager-info-sidebar .nav-tabs .nav-link,  .dark-layout .file-manager-application #app-file-manager-info-sidebar .tab-content .tab-pane {
      background-color: transparent;
    }
    .dark-layout .file-manager-application #app-file-manager-info-sidebar .nav-tabs .nav-item:not(.active) .nav-link {
      color: #b4b7bd;
    }
     .dark-layout .app-calendar .app-calendar-sidebar {
      background-color: #283046;
      border-color: #3b4253;
    }
    .dark-layout .app-calendar .app-calendar-sidebar .sidebar-content-title {
      color: #d0d2d6;
    }
    .dark-layout .app-calendar .app-calendar-sidebar .select-all ~ label,
    .dark-layout .app-calendar .app-calendar-sidebar .input-filter ~ label {
      color: #d0d2d6;
    }
     .dark-layout .app-calendar .fc .fc-day-today {
      background: #161d31 !important;
      background-color: #161d31 !important;
    }
     .dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-col-header-cell,  .dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-timegrid-axis,  .dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-daygrid-day {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-day-today {
      background-color: rgba(186, 191, 199, 0.12) !important;
    }
     .dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-day-today.fc-col-header-cell {
      background-color: #283046 !important;
    }
     .dark-layout .app-calendar .fc .fc-popover {
      background: #283046;
      border-color: #3b4253;
    }
    .dark-layout .app-calendar .fc .fc-popover-header .fc-popover-title,
    .dark-layout .app-calendar .fc .fc-popover-header .fc-popover-close {
      color: #b4b7bd;
    }
     .dark-layout .app-calendar .fc tbody td,  .dark-layout .app-calendar .fc thead th {
      border-color: #3b4253;
    }
     .dark-layout .app-calendar .fc .fc-scrollgrid {
      border-color: #3b4253;
    }
     .dark-layout .app-calendar .fc .fc-list,  .dark-layout .app-calendar .fc th {
      border-color: #3b4253;
    }
     .dark-layout .app-calendar .fc .fc-list .fc-list-day-cushion,  .dark-layout .app-calendar .fc th .fc-list-day-cushion {
      background: #161d31;
    }
     .dark-layout .app-calendar .fc .fc-list .fc-list-event:hover td,  .dark-layout .app-calendar .fc th .fc-list-event:hover td {
      background-color: #161d31;
    }
    .dark-layout .app-calendar .fc .fc-list .fc-list-event-time,
    .dark-layout .app-calendar .fc th .fc-list-event-time {
      color: #b4b7bd;
    }
     .dark-layout .app-calendar .fc .fc-list .fc-list-event td,  .dark-layout .app-calendar .fc th .fc-list-event td {
      border-color: #3b4253;
    }
     .dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-list-dataTable-header {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-data-table {
      background-color: #283046;
    }
     .dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-data-table tbody .selected-row-bg {
      background-color: #3b4253;
    }
     .dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-data-table td {
      background-color: inherit;
    }
     .dark-layout .invoice-edit .invoice-preview-card .invoice-product-details,  .dark-layout .invoice-add .invoice-preview-card .invoice-product-details {
      background-color: #161d31;
    }
     .dark-layout .invoice-edit .invoice-preview-card .invoice-product-details .product-details-border,  .dark-layout .invoice-add .invoice-preview-card .invoice-product-details .product-details-border {
      background-color: #283046;
      border-color: #3b4253;
    }
     .dark-layout .invoice-print .form-control {
      background-color: #283046;
    }
     .dark-layout .app-user-view .plan-card {
      border-color: #114A9F !important;
    }
     .dark-layout .app-user-edit .form-control.error {
      border-color: #EA5455 !important;
    }
     .dark-layout .customizer {
      background-color: #283046;
    }
    .dark-layout .customizer .customizer-close i,
    .dark-layout .customizer .customizer-close svg {
      color: #b4b7bd;
    }
     .dark-layout .footer-fixed .footer {
      background-color: #283046;
    }
     .dark-layout .horizontal-layout.navbar-sticky .horizontal-menu-wrapper .navbar-horizontal.header-navbar.fixed-top {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.75) !important;
    }
     .dark-layout .horizontal-layout .horizontal-menu-wrapper {
      background: linear-gradient(to bottom, rgba(37, 43, 71, 0.76) 44%, rgba(56, 53, 53, 0.46) 73%, rgba(255, 255, 255, 0) 100%) !important;
    }
     .dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar {
      background: #283046 !important;
    }
     .dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar.navbar-shadow {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.75);
    }
     .dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation > li:hover:not(.active) > a {
      background: #161d31;
    }
     .dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar.navbar-horizontal .active .nav-link.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar.navbar-horizontal .nav-link.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .dark-layout .horizontal-layout .main-menu-content .navbar-nav .dropdown-submenu.show {
      color: #b4b7bd;
    }
     .dark-layout .horizontal-layout .main-menu-content .navbar-nav .dropdown-submenu.show {
      background-color: #283046 !important;
    }
    .dark-layout .horizontal-layout .main-menu-content .navbar-nav .dropdown-menu a:hover {
      color: #d0d2d6 !important;
    }
    .dark-layout .horizontal-layout .main-menu-content .navbar-nav .dropdown-menu .disabled a {
      color: #676d7d;
    }
    .dark-layout .horizontal-layout .main-menu-content .navbar-nav .dropdown-menu .dropdown-item {
      color: #d0d2d6;
    }
     .dark-layout .horizontal-layout .main-menu-content .navbar-nav .dropdown-menu .dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
     .dark-layout .horizontal-layout .main-menu-content .navbar-nav .dropdown-menu .dropdown-toggle:hover::after,  .dark-layout .horizontal-layout .main-menu-content .navbar-nav .dropdown-menu .dropdown-toggle:active::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .dark-layout .horizontal-layout .main-menu-content .navbar-nav > li.active > a > i,
    .dark-layout .horizontal-layout .main-menu-content .navbar-nav > li.active > a > svg {
      color: #fff !important;
    }
    .dark-layout .horizontal-layout .main-menu-content .navbar-nav > li.active .dropdown-menu li.active > a {
      color: #b4b7bd;
    }
     .dark-layout .horizontal-layout .main-menu-content .navbar-nav > li.active .dropdown-menu li.active > a {
      background: #161d31 !important;
    }
    .dark-layout .horizontal-layout .main-menu-content .navbar-nav > li.active .dropdown-menu li.active > a:hover {
      color: #114A9F !important;
    }
    .dark-layout .horizontal-layout .main-menu-content .navbar-nav > li.active .dropdown-menu li.open.active > a {
      color: #b4b7bd !important;
    }
    
    .semi-dark-layout {
      /************ Main Menu **************/
    }
     .semi-dark-layout .main-menu {
      background-color: #283046;
    }
    [dir=ltr] .semi-dark-layout .main-menu .shadow-bottom {
      background: linear-gradient(180deg, #283046 44%, rgba(40, 48, 70, 0.51) 73%, rgba(40, 48, 70, 0));
    }
    [dir=rtl] .semi-dark-layout .main-menu .shadow-bottom {
      background: linear-gradient(-180deg, #283046 44%, rgba(40, 48, 70, 0.51) 73%, rgba(40, 48, 70, 0));
    }
     .semi-dark-layout .main-menu:not(.expanded) .navigation .sidebar-group-active a {
      background-color: #161d31;
    }
     .semi-dark-layout .main-menu-content .navigation-main {
      background-color: #283046;
    }
    .semi-dark-layout .main-menu-content .navigation-main .navigation-header {
      color: #676d7d;
    }
    .semi-dark-layout .main-menu-content .navigation-main .nav-item a {
      color: #b4b7bd;
    }
     .semi-dark-layout .main-menu-content .navigation-main .nav-item.open a {
      background-color: #161d31;
    }
    .semi-dark-layout .main-menu-content .navigation-main .nav-item a:after,
    .semi-dark-layout .main-menu-content .navigation-main .nav-item a {
      color: #b4b7bd;
    }
     .semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content {
      background-color: #283046;
    }
    .semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content .active .menu-item {
      color: #fff;
    }
     .semi-dark-layout .main-menu-content .navigation-main .nav-item .menu-content li:not(.active) a {
      background-color: #283046;
    }
    .semi-dark-layout .main-menu-content .navigation-main .active .menu-title,
    .semi-dark-layout .main-menu-content .navigation-main .active i {
      color: #fff;
    }
     .semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active a {
      background: #283046;
      border-radius: 4px;
    }
     .semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content {
      background-color: #283046;
    }
    .semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active {
      z-index: 1;
    }
     .semi-dark-layout .main-menu-content .navigation-main .sidebar-group-active .menu-content .active a {
      background-color: transparent;
    }
    .semi-dark-layout .menu-collapsed .main-menu:not(.expanded) .navigation-main li.active > a {
      color: #fff !important;
    }
     .semi-dark-layout .menu-collapsed .main-menu:not(.expanded) .navigation-main li.active > a {
      background: #161d31 !important;
    }
    
    .bv-no-focus-ring:focus {
      outline: none;
    }
    
    @media (max-width: 575.98px) {
      .bv-d-xs-down-none {
        display: none !important;
      }
    }
    @media (max-width: 767.98px) {
      .bv-d-sm-down-none {
        display: none !important;
      }
    }
    @media (max-width: 991.98px) {
      .bv-d-md-down-none {
        display: none !important;
      }
    }
    @media (max-width: 1199.98px) {
      .bv-d-lg-down-none {
        display: none !important;
      }
    }
    .bv-d-xl-down-none {
      display: none !important;
    }
    
    .form-control.focus {
      color: #424244;
      outline: 0;
    }
    
     .form-control.focus {
      background-color: #fff;
      border-color: #114A9F;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
     .form-control.focus.is-valid {
      border-color: #17B75E;
      box-shadow: 0 0 0 0.2rem rgba(23, 183, 94, 0.25);
    }
     .form-control.focus.is-invalid {
      border-color: #EA5455;
      box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.25);
    }
    
    .b-avatar {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      flex-shrink: 0;
      width: 2.5rem;
      height: 2.5rem;
      font-size: inherit;
      font-weight: 400;
      line-height: 1;
      max-width: 100%;
      max-height: auto;
      overflow: visible;
      position: relative;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    
     .b-avatar {
      text-align: center;
    }
    .b-avatar:focus {
      outline: 0;
    }
     .b-avatar.btn,  .b-avatar[href] {
      padding: 0;
      border: 0;
    }
    .b-avatar.btn .b-avatar-img img, .b-avatar[href] .b-avatar-img img {
      transition: transform 0.15s ease-in-out;
    }
     .b-avatar.btn:not(:disabled):not(.disabled),  .b-avatar[href]:not(:disabled):not(.disabled) {
      cursor: pointer;
    }
     .b-avatar.btn:not(:disabled):not(.disabled):hover .b-avatar-img img,  .b-avatar[href]:not(:disabled):not(.disabled):hover .b-avatar-img img {
      transform: scale(1.15);
    }
    .b-avatar.disabled, .b-avatar:disabled, .b-avatar[disabled] {
      opacity: 0.65;
      pointer-events: none;
    }
    .b-avatar .b-avatar-custom,
    .b-avatar .b-avatar-text,
    .b-avatar .b-avatar-img {
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      mask-image: radial-gradient(white, black);
    }
     .b-avatar .b-avatar-custom,  .b-avatar .b-avatar-text,  .b-avatar .b-avatar-img {
      border-radius: inherit;
    }
    .b-avatar .b-avatar-text {
      text-transform: uppercase;
      white-space: nowrap;
    }
    .b-avatar[href] {
      text-decoration: none;
    }
    .b-avatar > .b-icon {
      width: 60%;
      height: auto;
      max-width: 100%;
    }
    .b-avatar .b-avatar-img img {
      width: 100%;
      height: 100%;
      max-height: auto;
      object-fit: cover;
    }
     .b-avatar .b-avatar-img img {
      border-radius: inherit;
    }
    .b-avatar .b-avatar-badge {
      position: absolute;
      min-height: 1.5em;
      min-width: 1.5em;
      line-height: 1;
      font-size: 70%;
      font-weight: 700;
      z-index: 1;
    }
     .b-avatar .b-avatar-badge {
      padding: 0.25em;
      border-radius: 10em;
    }
    
    .b-avatar-sm {
      width: 1.5rem;
      height: 1.5rem;
    }
    .b-avatar-sm .b-avatar-text {
      font-size: calc(0.6rem);
    }
    .b-avatar-sm .b-avatar-badge {
      font-size: calc(0.42rem);
    }
    
    .b-avatar-lg {
      width: 3.5rem;
      height: 3.5rem;
    }
    .b-avatar-lg .b-avatar-text {
      font-size: calc(1.4rem);
    }
    .b-avatar-lg .b-avatar-badge {
      font-size: calc(0.98rem);
    }
    
    .b-avatar-group .b-avatar-group-inner {
      display: flex;
      flex-wrap: wrap;
    }
     .b-avatar-group .b-avatar {
      border: 1px solid #ebe9f1;
    }
    .b-avatar-group a.b-avatar:hover:not(.disabled):not(disabled),
    .b-avatar-group .btn.b-avatar:hover:not(.disabled):not(disabled) {
      z-index: 1;
    }
    
    .b-calendar {
      display: inline-flex;
    }
    .b-calendar .b-calendar-inner {
      min-width: 250px;
    }
     .b-calendar .b-calendar-header,  .b-calendar .b-calendar-nav {
      margin-bottom: 0.25rem;
    }
     .b-calendar .b-calendar-nav .btn {
      padding: 0.25rem;
    }
    .b-calendar output {
      font-size: 80%;
    }
     .b-calendar output {
      padding: 0.25rem;
    }
    .b-calendar output.readonly {
      opacity: 1;
    }
     .b-calendar output.readonly {
      background-color: #efefef;
    }
     .b-calendar .b-calendar-footer {
      margin-top: 0.5rem;
    }
    .b-calendar .b-calendar-grid {
      overflow: hidden;
    }
     .b-calendar .b-calendar-grid {
      padding: 0;
      margin: 0;
    }
    .b-calendar .b-calendar-grid .row {
      flex-wrap: nowrap;
    }
     .b-calendar .b-calendar-grid-caption {
      padding: 0.25rem;
    }
    .b-calendar .b-calendar-grid-body .col[data-date] .btn {
      width: 32px;
      height: 32px;
      font-size: 14px;
      line-height: 1;
    }
     .b-calendar .b-calendar-grid-body .col[data-date] .btn {
      margin: 3px auto;
      padding: 9px 0;
    }
    .b-calendar .btn:disabled, .b-calendar .btn.disabled, .b-calendar .btn[aria-disabled=true] {
      pointer-events: none;
    }
     .b-calendar .btn:disabled,  .b-calendar .btn.disabled,  .b-calendar .btn[aria-disabled=true] {
      cursor: default;
    }
    
    [dir=ltr] .card-img-left {
      border-top-left-radius: calc(0.428rem - 1px);
      border-bottom-left-radius: calc(0.428rem - 1px);
    }
    
    [dir=rtl] .card-img-left {
      border-top-right-radius: calc(0.428rem - 1px);
      border-bottom-right-radius: calc(0.428rem - 1px);
    }
    
    [dir=ltr] .card-img-right {
      border-top-right-radius: calc(0.428rem - 1px);
      border-bottom-right-radius: calc(0.428rem - 1px);
    }
    
    [dir=rtl] .card-img-right {
      border-top-left-radius: calc(0.428rem - 1px);
      border-bottom-left-radius: calc(0.428rem - 1px);
    }
    
    .dropdown:not(.dropleft) .dropdown-toggle.dropdown-toggle-no-caret::after {
      display: none !important;
    }
    .dropdown.dropleft .dropdown-toggle.dropdown-toggle-no-caret::before {
      display: none !important;
    }
    .dropdown .dropdown-menu:focus {
      outline: none;
    }
    
    .b-dropdown-form {
      display: inline-block;
      width: 100%;
      font-weight: 400;
    }
    
     .b-dropdown-form {
      padding: 0.65rem 1.28rem;
      clear: both;
    }
    .b-dropdown-form:focus {
      outline: 1px dotted !important;
      outline: 5px auto -webkit-focus-ring-color !important;
    }
    .b-dropdown-form.disabled, .b-dropdown-form:disabled {
      outline: 0 !important;
      color: #b9b9c3;
      pointer-events: none;
    }
    
    .b-dropdown-text {
      display: inline-block;
      width: 100%;
      font-weight: lighter;
    }
    
     .b-dropdown-text {
      padding: 0.65rem 1.28rem;
      margin-bottom: 0;
      clear: both;
    }
    
    .custom-checkbox.b-custom-control-lg,
    .input-group-lg .custom-checkbox {
      font-size: 2rem;
      line-height: 1.25;
    }
    
    [dir=ltr] .custom-checkbox.b-custom-control-lg, [dir=ltr] .input-group-lg .custom-checkbox {
      padding-left: 1.875rem;
    }
    
    [dir=rtl] .custom-checkbox.b-custom-control-lg, [dir=rtl] .input-group-lg .custom-checkbox {
      padding-right: 1.875rem;
    }
    .custom-checkbox.b-custom-control-lg .custom-control-label::before,
    .input-group-lg .custom-checkbox .custom-control-label::before {
      top: 0.625rem;
      width: 1.25rem;
      height: 1.25rem;
    }
     .custom-checkbox.b-custom-control-lg .custom-control-label::before,  .input-group-lg .custom-checkbox .custom-control-label::before {
      border-radius: 0.6rem;
    }
    [dir=ltr] .custom-checkbox.b-custom-control-lg .custom-control-label::before, [dir=ltr] .input-group-lg .custom-checkbox .custom-control-label::before {
      left: -1.875rem;
    }
    [dir=rtl] .custom-checkbox.b-custom-control-lg .custom-control-label::before, [dir=rtl] .input-group-lg .custom-checkbox .custom-control-label::before {
      right: -1.875rem;
    }
    .custom-checkbox.b-custom-control-lg .custom-control-label::after,
    .input-group-lg .custom-checkbox .custom-control-label::after {
      top: 0.625rem;
      width: 1.25rem;
      height: 1.25rem;
    }
     .custom-checkbox.b-custom-control-lg .custom-control-label::after,  .input-group-lg .custom-checkbox .custom-control-label::after {
      background-size: 50% 50%;
    }
    [dir=ltr] .custom-checkbox.b-custom-control-lg .custom-control-label::after, [dir=ltr] .input-group-lg .custom-checkbox .custom-control-label::after {
      left: -1.875rem;
    }
    [dir=rtl] .custom-checkbox.b-custom-control-lg .custom-control-label::after, [dir=rtl] .input-group-lg .custom-checkbox .custom-control-label::after {
      right: -1.875rem;
    }
    
    .custom-checkbox.b-custom-control-sm,
    .input-group-sm .custom-checkbox {
      font-size: 1rem;
      line-height: 1;
    }
    
    [dir=ltr] .custom-checkbox.b-custom-control-sm, [dir=ltr] .input-group-sm .custom-checkbox {
      padding-left: 1.3125rem;
    }
    
    [dir=rtl] .custom-checkbox.b-custom-control-sm, [dir=rtl] .input-group-sm .custom-checkbox {
      padding-right: 1.3125rem;
    }
    .custom-checkbox.b-custom-control-sm .custom-control-label::before,
    .input-group-sm .custom-checkbox .custom-control-label::before {
      top: 0.0625rem;
      width: 0.875rem;
      height: 0.875rem;
    }
     .custom-checkbox.b-custom-control-sm .custom-control-label::before,  .input-group-sm .custom-checkbox .custom-control-label::before {
      border-radius: 0.25rem;
    }
    [dir=ltr] .custom-checkbox.b-custom-control-sm .custom-control-label::before, [dir=ltr] .input-group-sm .custom-checkbox .custom-control-label::before {
      left: -1.3125rem;
    }
    [dir=rtl] .custom-checkbox.b-custom-control-sm .custom-control-label::before, [dir=rtl] .input-group-sm .custom-checkbox .custom-control-label::before {
      right: -1.3125rem;
    }
    .custom-checkbox.b-custom-control-sm .custom-control-label::after,
    .input-group-sm .custom-checkbox .custom-control-label::after {
      top: 0.0625rem;
      width: 0.875rem;
      height: 0.875rem;
    }
     .custom-checkbox.b-custom-control-sm .custom-control-label::after,  .input-group-sm .custom-checkbox .custom-control-label::after {
      background-size: 50% 50%;
    }
    [dir=ltr] .custom-checkbox.b-custom-control-sm .custom-control-label::after, [dir=ltr] .input-group-sm .custom-checkbox .custom-control-label::after {
      left: -1.3125rem;
    }
    [dir=rtl] .custom-checkbox.b-custom-control-sm .custom-control-label::after, [dir=rtl] .input-group-sm .custom-checkbox .custom-control-label::after {
      right: -1.3125rem;
    }
    
    [dir=ltr] .custom-switch.b-custom-control-lg, [dir=ltr] .input-group-lg .custom-switch {
      padding-left: 2.8125rem;
    }
    
    [dir=rtl] .custom-switch.b-custom-control-lg, [dir=rtl] .input-group-lg .custom-switch {
      padding-right: 2.8125rem;
    }
    .custom-switch.b-custom-control-lg .custom-control-label,
    .input-group-lg .custom-switch .custom-control-label {
      font-size: 2rem;
      line-height: 1.25;
    }
    .custom-switch.b-custom-control-lg .custom-control-label::before,
    .input-group-lg .custom-switch .custom-control-label::before {
      top: 0.625rem;
      height: 1.25rem;
      width: 2.1875rem;
    }
     .custom-switch.b-custom-control-lg .custom-control-label::before,  .input-group-lg .custom-switch .custom-control-label::before {
      border-radius: 0.625rem;
    }
    [dir=ltr] .custom-switch.b-custom-control-lg .custom-control-label::before, [dir=ltr] .input-group-lg .custom-switch .custom-control-label::before {
      left: -2.8125rem;
    }
    [dir=rtl] .custom-switch.b-custom-control-lg .custom-control-label::before, [dir=rtl] .input-group-lg .custom-switch .custom-control-label::before {
      right: -2.8125rem;
    }
    .custom-switch.b-custom-control-lg .custom-control-label::after,
    .input-group-lg .custom-switch .custom-control-label::after {
      top: calc( 0.625rem + 2px );
      width: calc( 1.25rem - 4px );
      height: calc( 1.25rem - 4px );
    }
     .custom-switch.b-custom-control-lg .custom-control-label::after,  .input-group-lg .custom-switch .custom-control-label::after {
      border-radius: 0.625rem;
      background-size: 50% 50%;
    }
    [dir=ltr] .custom-switch.b-custom-control-lg .custom-control-label::after, [dir=ltr] .input-group-lg .custom-switch .custom-control-label::after {
      left: calc( -2.8125rem + 2px );
    }
    [dir=rtl] .custom-switch.b-custom-control-lg .custom-control-label::after, [dir=rtl] .input-group-lg .custom-switch .custom-control-label::after {
      right: calc( -2.8125rem + 2px );
    }
    [dir=ltr] .custom-switch.b-custom-control-lg .custom-control-input:checked ~ .custom-control-label::after, [dir=ltr] .input-group-lg .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      transform: translateX(0.9375rem);
    }
    [dir=rtl] .custom-switch.b-custom-control-lg .custom-control-input:checked ~ .custom-control-label::after, [dir=rtl] .input-group-lg .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      transform: translateX(-0.9375rem);
    }
    
    [dir=ltr] .custom-switch.b-custom-control-sm, [dir=ltr] .input-group-sm .custom-switch {
      padding-left: 1.96875rem;
    }
    
    [dir=rtl] .custom-switch.b-custom-control-sm, [dir=rtl] .input-group-sm .custom-switch {
      padding-right: 1.96875rem;
    }
    .custom-switch.b-custom-control-sm .custom-control-label,
    .input-group-sm .custom-switch .custom-control-label {
      font-size: 1rem;
      line-height: 1;
    }
    .custom-switch.b-custom-control-sm .custom-control-label::before,
    .input-group-sm .custom-switch .custom-control-label::before {
      top: 0.0625rem;
      width: 1.53125rem;
      height: 0.875rem;
    }
     .custom-switch.b-custom-control-sm .custom-control-label::before,  .input-group-sm .custom-switch .custom-control-label::before {
      border-radius: 0.4375rem;
    }
    [dir=ltr] .custom-switch.b-custom-control-sm .custom-control-label::before, [dir=ltr] .input-group-sm .custom-switch .custom-control-label::before {
      left: -1.96875rem;
    }
    [dir=rtl] .custom-switch.b-custom-control-sm .custom-control-label::before, [dir=rtl] .input-group-sm .custom-switch .custom-control-label::before {
      right: -1.96875rem;
    }
    .custom-switch.b-custom-control-sm .custom-control-label::after,
    .input-group-sm .custom-switch .custom-control-label::after {
      top: calc( 0.0625rem + 2px );
      width: calc( 0.875rem - 4px );
      height: calc( 0.875rem - 4px );
    }
     .custom-switch.b-custom-control-sm .custom-control-label::after,  .input-group-sm .custom-switch .custom-control-label::after {
      border-radius: 0.4375rem;
      background-size: 50% 50%;
    }
    [dir=ltr] .custom-switch.b-custom-control-sm .custom-control-label::after, [dir=ltr] .input-group-sm .custom-switch .custom-control-label::after {
      left: calc( -1.96875rem + 2px );
    }
    [dir=rtl] .custom-switch.b-custom-control-sm .custom-control-label::after, [dir=rtl] .input-group-sm .custom-switch .custom-control-label::after {
      right: calc( -1.96875rem + 2px );
    }
    [dir=ltr] .custom-switch.b-custom-control-sm .custom-control-input:checked ~ .custom-control-label::after, [dir=ltr] .input-group-sm .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      transform: translateX(0.65625rem);
    }
    [dir=rtl] .custom-switch.b-custom-control-sm .custom-control-input:checked ~ .custom-control-label::after, [dir=rtl] .input-group-sm .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      transform: translateX(-0.65625rem);
    }
    
    [dir=ltr] .input-group > .input-group-prepend > .btn-group > .btn, [dir=ltr] .input-group > .input-group-append:not(:last-child) > .btn-group > .btn, [dir=ltr] .input-group > .input-group-append:last-child > .btn-group:not(:last-child):not(.dropdown-toggle) > .btn {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    [dir=rtl] .input-group > .input-group-prepend > .btn-group > .btn, [dir=rtl] .input-group > .input-group-append:not(:last-child) > .btn-group > .btn, [dir=rtl] .input-group > .input-group-append:last-child > .btn-group:not(:last-child):not(.dropdown-toggle) > .btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=ltr] .input-group > .input-group-append > .btn-group > .btn, [dir=ltr] .input-group > .input-group-prepend:not(:first-child) > .btn-group > .btn, [dir=ltr] .input-group > .input-group-prepend:first-child > .btn-group:not(:first-child) > .btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .input-group > .input-group-append > .btn-group > .btn, [dir=rtl] .input-group > .input-group-prepend:not(:first-child) > .btn-group > .btn, [dir=rtl] .input-group > .input-group-prepend:first-child > .btn-group:not(:first-child) > .btn {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    
     .b-form-btn-label-control.form-control {
      background-image: none;
      padding: 0;
    }
     .input-group .b-form-btn-label-control.form-control {
      padding: 0;
    }
    
    [dir=rtl] .b-form-btn-label-control.form-control, .b-form-btn-label-control.form-control[dir=rtl] {
      flex-direction: row-reverse;
    }
    [dir=rtl] .b-form-btn-label-control.form-control > label, .b-form-btn-label-control.form-control[dir=rtl] > label {
      text-align: right;
    }
    
    .b-form-btn-label-control.form-control > .btn {
      line-height: 1;
      font-size: inherit;
    }
    
     .b-form-btn-label-control.form-control > .btn {
      box-shadow: none !important;
      border: 0;
    }
    .b-form-btn-label-control.form-control > .btn:disabled {
      pointer-events: none;
    }
    .b-form-btn-label-control.form-control.is-valid > .btn {
      color: #17B75E;
    }
    .b-form-btn-label-control.form-control.is-invalid > .btn {
      color: #EA5455;
    }
     .b-form-btn-label-control.form-control > .dropdown-menu {
      padding: 0.5rem;
    }
    .b-form-btn-label-control.form-control > label {
      outline: 0;
      font-size: inherit;
      min-height: calc(2.6666666667rem - 2px);
    }
     .b-form-btn-label-control.form-control > label {
      margin: 0;
      border: 0;
      cursor: pointer;
    }
    [dir=ltr] .b-form-btn-label-control.form-control > label {
      padding-left: 0.25rem;
    }
    [dir=rtl] .b-form-btn-label-control.form-control > label {
      padding-right: 0.25rem;
    }
    .b-form-btn-label-control.form-control > label.form-control-sm {
      min-height: calc(2.142rem - 2px);
    }
    .b-form-btn-label-control.form-control > label.form-control-lg {
      min-height: calc(3.2857rem - 2px);
    }
    .input-group.input-group-sm .b-form-btn-label-control.form-control > label {
      min-height: calc(2.142rem - 2px);
    }
     .input-group.input-group-sm .b-form-btn-label-control.form-control > label {
      padding-top: 0.188rem;
      padding-bottom: 0.188rem;
    }
    
    .input-group.input-group-lg .b-form-btn-label-control.form-control > label {
      min-height: calc(3.2857rem - 2px);
    }
    
     .input-group.input-group-lg .b-form-btn-label-control.form-control > label {
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }
    
    .b-form-btn-label-control.form-control[aria-disabled=true], .b-form-btn-label-control.form-control[aria-readonly=true] {
      opacity: 1;
    }
    
     .b-form-btn-label-control.form-control[aria-disabled=true],  .b-form-btn-label-control.form-control[aria-readonly=true] {
      background-color: #efefef;
    }
    .b-form-btn-label-control.form-control[aria-disabled=true] {
      pointer-events: none;
    }
     .b-form-btn-label-control.form-control[aria-disabled=true] > label {
      cursor: default;
    }
    
     .b-form-btn-label-control.btn-group > .dropdown-menu {
      padding: 0.5rem;
    }
    
    .custom-file-label {
      white-space: nowrap;
      overflow-x: hidden;
    }
    
    .b-custom-control-lg.custom-file,
    .b-custom-control-lg .custom-file-input,
    .b-custom-control-lg .custom-file-label,
    .input-group-lg.custom-file,
    .input-group-lg .custom-file-input,
    .input-group-lg .custom-file-label {
      font-size: 1.143rem;
      height: 3.2857rem;
    }
    .b-custom-control-lg .custom-file-label,
    .b-custom-control-lg .custom-file-label:after,
    .input-group-lg .custom-file-label,
    .input-group-lg .custom-file-label:after {
      line-height: 1.25;
    }
     .b-custom-control-lg .custom-file-label,  .b-custom-control-lg .custom-file-label:after,  .input-group-lg .custom-file-label,  .input-group-lg .custom-file-label:after {
      padding: 0.75rem 1.143rem;
    }
     .b-custom-control-lg .custom-file-label,  .input-group-lg .custom-file-label {
      border-radius: 0.357rem;
    }
    .b-custom-control-lg .custom-file-label::after,
    .input-group-lg .custom-file-label::after {
      font-size: inherit;
      height: calc( 1.25em + 1.5rem );
    }
    [dir=ltr] .b-custom-control-lg .custom-file-label::after, [dir=ltr] .input-group-lg .custom-file-label::after {
      border-radius: 0 0.357rem 0.357rem 0;
    }
    [dir=rtl] .b-custom-control-lg .custom-file-label::after, [dir=rtl] .input-group-lg .custom-file-label::after {
      border-radius: 0.357rem 0 0 0.357rem;
    }
    
    .b-custom-control-sm.custom-file,
    .b-custom-control-sm .custom-file-input,
    .b-custom-control-sm .custom-file-label,
    .input-group-sm.custom-file,
    .input-group-sm .custom-file-input,
    .input-group-sm .custom-file-label {
      font-size: 0.857rem;
      height: 2.142rem;
    }
    .b-custom-control-sm .custom-file-label,
    .b-custom-control-sm .custom-file-label:after,
    .input-group-sm .custom-file-label,
    .input-group-sm .custom-file-label:after {
      line-height: 1;
    }
     .b-custom-control-sm .custom-file-label,  .b-custom-control-sm .custom-file-label:after,  .input-group-sm .custom-file-label,  .input-group-sm .custom-file-label:after {
      padding: 0.188rem 0.857rem;
    }
     .b-custom-control-sm .custom-file-label,  .input-group-sm .custom-file-label {
      border-radius: 0.357rem;
    }
    .b-custom-control-sm .custom-file-label::after,
    .input-group-sm .custom-file-label::after {
      font-size: inherit;
      height: calc( 1em + 0.376rem );
    }
    [dir=ltr] .b-custom-control-sm .custom-file-label::after, [dir=ltr] .input-group-sm .custom-file-label::after {
      border-radius: 0 0.357rem 0.357rem 0;
    }
    [dir=rtl] .b-custom-control-sm .custom-file-label::after, [dir=rtl] .input-group-sm .custom-file-label::after {
      border-radius: 0.357rem 0 0 0.357rem;
    }
    
    [dir=ltr] .was-validated .form-control:invalid, [dir=ltr] .was-validated .form-control:valid, [dir=ltr] .form-control.is-invalid, [dir=ltr] .form-control.is-valid {
      background-position: right calc(0.3625em + 0.219rem) center;
    }
    
    [dir=rtl] .was-validated .form-control:invalid, [dir=rtl] .was-validated .form-control:valid, [dir=rtl] .form-control.is-invalid, [dir=rtl] .form-control.is-valid {
      background-position: left calc(0.3625em + 0.219rem) center;
    }
    
    input[type=color].form-control {
      height: 2.6666666667rem;
    }
    
     input[type=color].form-control {
      padding: 0.094rem 0.4285rem;
    }
    
    input[type=color].form-control.form-control-sm,
    .input-group-sm input[type=color].form-control {
      height: 2.142rem;
    }
    
     input[type=color].form-control.form-control-sm,  .input-group-sm input[type=color].form-control {
      padding: 0.094rem 0.4285rem;
    }
    
    input[type=color].form-control.form-control-lg,
    .input-group-lg input[type=color].form-control {
      height: 3.2857rem;
    }
    
     input[type=color].form-control.form-control-lg,  .input-group-lg input[type=color].form-control {
      padding: 0.094rem 0.4285rem;
    }
    
    input[type=color].form-control:disabled {
      opacity: 0.65;
    }
    
     input[type=color].form-control:disabled {
      background-color: #adb5bd;
    }
    
    .input-group > .custom-range {
      position: relative;
      flex: 1 1 auto;
      width: 1%;
    }
    
     .input-group > .custom-range {
      margin-bottom: 0;
    }
    [dir=ltr] .input-group > .custom-range + .form-control, [dir=ltr] .input-group > .custom-range + .form-control-plaintext, [dir=ltr] .input-group > .custom-range + .custom-select, [dir=ltr] .input-group > .custom-range + .custom-range, [dir=ltr] .input-group > .custom-range + .custom-file {
      margin-left: -1px;
    }
    [dir=rtl] .input-group > .custom-range + .form-control, [dir=rtl] .input-group > .custom-range + .form-control-plaintext, [dir=rtl] .input-group > .custom-range + .custom-select, [dir=rtl] .input-group > .custom-range + .custom-range, [dir=rtl] .input-group > .custom-range + .custom-file {
      margin-right: -1px;
    }
    [dir=ltr] .input-group > .form-control + .custom-range, [dir=ltr] .input-group > .form-control-plaintext + .custom-range, [dir=ltr] .input-group > .custom-select + .custom-range, [dir=ltr] .input-group > .custom-range + .custom-range, [dir=ltr] .input-group > .custom-file + .custom-range {
      margin-left: -1px;
    }
    [dir=rtl] .input-group > .form-control + .custom-range, [dir=rtl] .input-group > .form-control-plaintext + .custom-range, [dir=rtl] .input-group > .custom-select + .custom-range, [dir=rtl] .input-group > .custom-range + .custom-range, [dir=rtl] .input-group > .custom-file + .custom-range {
      margin-right: -1px;
    }
    .input-group > .custom-range:focus {
      z-index: 3;
    }
    [dir=ltr] .input-group > .custom-range:not(:last-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=rtl] .input-group > .custom-range:not(:last-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=ltr] .input-group > .custom-range:not(:first-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .input-group > .custom-range:not(:first-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .input-group > .custom-range {
      height: 2.6666666667rem;
      height: 2.6666666667rem;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
     .input-group > .custom-range {
      padding: 0 1rem;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #D6D9E1;
      border-radius: 0.357rem;
    }
    @media (prefers-reduced-motion: reduce) {
      .input-group > .custom-range {
        transition: none;
      }
    }
    .input-group > .custom-range:focus {
      color: #424244;
      outline: 0;
    }
     .input-group > .custom-range:focus {
      background-color: #fff;
      border-color: #114A9F;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
     .input-group > .custom-range:disabled,  .input-group > .custom-range[readonly] {
      background-color: #efefef;
    }
    
    .input-group-lg > .custom-range {
      height: 3.2857rem;
    }
    
     .input-group-lg > .custom-range {
      padding: 0 1.143rem;
      border-radius: 0.357rem;
    }
    
    .input-group-sm > .custom-range {
      height: 2.142rem;
    }
    
     .input-group-sm > .custom-range {
      padding: 0 0.857rem;
      border-radius: 0.357rem;
    }
    
     .was-validated .input-group .custom-range:valid,  .input-group .custom-range.is-valid {
      border-color: #17B75E;
    }
     .was-validated .input-group .custom-range:valid:focus,  .input-group .custom-range.is-valid:focus {
      border-color: #17B75E;
      box-shadow: 0 0 0 0.2rem rgba(23, 183, 94, 0.25);
    }
    
     .was-validated .custom-range:valid:focus::-webkit-slider-thumb,  .custom-range.is-valid:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #f8f8f8, 0 0 0 0.2rem #90f1bb;
    }
     .was-validated .custom-range:valid:focus::-moz-range-thumb,  .custom-range.is-valid:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #f8f8f8, 0 0 0 0.2rem #90f1bb;
    }
     .was-validated .custom-range:valid:focus::-ms-thumb,  .custom-range.is-valid:focus::-ms-thumb {
      box-shadow: 0 0 0 1px #f8f8f8, 0 0 0 0.2rem #90f1bb;
    }
     .was-validated .custom-range:valid::-webkit-slider-thumb,  .custom-range.is-valid::-webkit-slider-thumb {
      background-color: #17B75E;
      background-image: none;
    }
     .was-validated .custom-range:valid::-webkit-slider-thumb:active,  .custom-range.is-valid::-webkit-slider-thumb:active {
      background-color: #90f1bb;
      background-image: none;
    }
     .was-validated .custom-range:valid::-webkit-slider-runnable-track,  .custom-range.is-valid::-webkit-slider-runnable-track {
      background-color: rgba(23, 183, 94, 0.35);
    }
     .was-validated .custom-range:valid::-moz-range-thumb,  .custom-range.is-valid::-moz-range-thumb {
      background-color: #17B75E;
      background-image: none;
    }
     .was-validated .custom-range:valid::-moz-range-thumb:active,  .custom-range.is-valid::-moz-range-thumb:active {
      background-color: #90f1bb;
      background-image: none;
    }
     .was-validated .custom-range:valid::-moz-range-track,  .custom-range.is-valid::-moz-range-track {
      background: rgba(23, 183, 94, 0.35);
    }
    .was-validated .custom-range:valid ~ .valid-feedback,
    .was-validated .custom-range:valid ~ .valid-tooltip, .custom-range.is-valid ~ .valid-feedback,
    .custom-range.is-valid ~ .valid-tooltip {
      display: block;
    }
     .was-validated .custom-range:valid::-ms-thumb,  .custom-range.is-valid::-ms-thumb {
      background-color: #17B75E;
      background-image: none;
    }
     .was-validated .custom-range:valid::-ms-thumb:active,  .custom-range.is-valid::-ms-thumb:active {
      background-color: #90f1bb;
      background-image: none;
    }
     .was-validated .custom-range:valid::-ms-track-lower,  .custom-range.is-valid::-ms-track-lower {
      background: rgba(23, 183, 94, 0.35);
    }
     .was-validated .custom-range:valid::-ms-track-upper,  .custom-range.is-valid::-ms-track-upper {
      background: rgba(23, 183, 94, 0.35);
    }
    
     .was-validated .input-group .custom-range:invalid,  .input-group .custom-range.is-invalid {
      border-color: #EA5455;
    }
     .was-validated .input-group .custom-range:invalid:focus,  .input-group .custom-range.is-invalid:focus {
      border-color: #EA5455;
      box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.25);
    }
    
     .was-validated .custom-range:invalid:focus::-webkit-slider-thumb,  .custom-range.is-invalid:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #f8f8f8, 0 0 0 0.2rem #fef3f3;
    }
     .was-validated .custom-range:invalid:focus::-moz-range-thumb,  .custom-range.is-invalid:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #f8f8f8, 0 0 0 0.2rem #fef3f3;
    }
     .was-validated .custom-range:invalid:focus::-ms-thumb,  .custom-range.is-invalid:focus::-ms-thumb {
      box-shadow: 0 0 0 1px #f8f8f8, 0 0 0 0.2rem #fef3f3;
    }
     .was-validated .custom-range:invalid::-webkit-slider-thumb,  .custom-range.is-invalid::-webkit-slider-thumb {
      background-color: #EA5455;
      background-image: none;
    }
     .was-validated .custom-range:invalid::-webkit-slider-thumb:active,  .custom-range.is-invalid::-webkit-slider-thumb:active {
      background-color: #fef3f3;
      background-image: none;
    }
     .was-validated .custom-range:invalid::-webkit-slider-runnable-track,  .custom-range.is-invalid::-webkit-slider-runnable-track {
      background-color: rgba(234, 84, 85, 0.35);
    }
     .was-validated .custom-range:invalid::-moz-range-thumb,  .custom-range.is-invalid::-moz-range-thumb {
      background-color: #EA5455;
      background-image: none;
    }
     .was-validated .custom-range:invalid::-moz-range-thumb:active,  .custom-range.is-invalid::-moz-range-thumb:active {
      background-color: #fef3f3;
      background-image: none;
    }
     .was-validated .custom-range:invalid::-moz-range-track,  .custom-range.is-invalid::-moz-range-track {
      background: rgba(234, 84, 85, 0.35);
    }
    .was-validated .custom-range:invalid ~ .invalid-feedback,
    .was-validated .custom-range:invalid ~ .invalid-tooltip, .custom-range.is-invalid ~ .invalid-feedback,
    .custom-range.is-invalid ~ .invalid-tooltip {
      display: block;
    }
     .was-validated .custom-range:invalid::-ms-thumb,  .custom-range.is-invalid::-ms-thumb {
      background-color: #EA5455;
      background-image: none;
    }
     .was-validated .custom-range:invalid::-ms-thumb:active,  .custom-range.is-invalid::-ms-thumb:active {
      background-color: #fef3f3;
      background-image: none;
    }
     .was-validated .custom-range:invalid::-ms-track-lower,  .custom-range.is-invalid::-ms-track-lower {
      background: rgba(234, 84, 85, 0.35);
    }
     .was-validated .custom-range:invalid::-ms-track-upper,  .custom-range.is-invalid::-ms-track-upper {
      background: rgba(234, 84, 85, 0.35);
    }
    
    .custom-radio.b-custom-control-lg,
    .input-group-lg .custom-radio {
      font-size: 2rem;
      line-height: 1.25;
    }
    
    [dir=ltr] .custom-radio.b-custom-control-lg, [dir=ltr] .input-group-lg .custom-radio {
      padding-left: 1.875rem;
    }
    
    [dir=rtl] .custom-radio.b-custom-control-lg, [dir=rtl] .input-group-lg .custom-radio {
      padding-right: 1.875rem;
    }
    .custom-radio.b-custom-control-lg .custom-control-label::before,
    .input-group-lg .custom-radio .custom-control-label::before {
      top: 0.625rem;
      width: 1.25rem;
      height: 1.25rem;
    }
     .custom-radio.b-custom-control-lg .custom-control-label::before,  .input-group-lg .custom-radio .custom-control-label::before {
      border-radius: 50%;
    }
    [dir=ltr] .custom-radio.b-custom-control-lg .custom-control-label::before, [dir=ltr] .input-group-lg .custom-radio .custom-control-label::before {
      left: -1.875rem;
    }
    [dir=rtl] .custom-radio.b-custom-control-lg .custom-control-label::before, [dir=rtl] .input-group-lg .custom-radio .custom-control-label::before {
      right: -1.875rem;
    }
    .custom-radio.b-custom-control-lg .custom-control-label::after,
    .input-group-lg .custom-radio .custom-control-label::after {
      top: 0.625rem;
      width: 1.25rem;
      height: 1.25rem;
    }
     .custom-radio.b-custom-control-lg .custom-control-label::after,  .input-group-lg .custom-radio .custom-control-label::after {
      background: no-repeat 50%/50% 50%;
    }
    [dir=ltr] .custom-radio.b-custom-control-lg .custom-control-label::after, [dir=ltr] .input-group-lg .custom-radio .custom-control-label::after {
      left: -1.875rem;
    }
    [dir=rtl] .custom-radio.b-custom-control-lg .custom-control-label::after, [dir=rtl] .input-group-lg .custom-radio .custom-control-label::after {
      right: -1.875rem;
    }
    
    .custom-radio.b-custom-control-sm,
    .input-group-sm .custom-radio {
      font-size: 1rem;
      line-height: 1;
    }
    
    [dir=ltr] .custom-radio.b-custom-control-sm, [dir=ltr] .input-group-sm .custom-radio {
      padding-left: 1.3125rem;
    }
    
    [dir=rtl] .custom-radio.b-custom-control-sm, [dir=rtl] .input-group-sm .custom-radio {
      padding-right: 1.3125rem;
    }
    .custom-radio.b-custom-control-sm .custom-control-label::before,
    .input-group-sm .custom-radio .custom-control-label::before {
      top: 0.0625rem;
      width: 0.875rem;
      height: 0.875rem;
    }
     .custom-radio.b-custom-control-sm .custom-control-label::before,  .input-group-sm .custom-radio .custom-control-label::before {
      border-radius: 50%;
    }
    [dir=ltr] .custom-radio.b-custom-control-sm .custom-control-label::before, [dir=ltr] .input-group-sm .custom-radio .custom-control-label::before {
      left: -1.3125rem;
    }
    [dir=rtl] .custom-radio.b-custom-control-sm .custom-control-label::before, [dir=rtl] .input-group-sm .custom-radio .custom-control-label::before {
      right: -1.3125rem;
    }
    .custom-radio.b-custom-control-sm .custom-control-label::after,
    .input-group-sm .custom-radio .custom-control-label::after {
      top: 0.0625rem;
      width: 0.875rem;
      height: 0.875rem;
    }
     .custom-radio.b-custom-control-sm .custom-control-label::after,  .input-group-sm .custom-radio .custom-control-label::after {
      background: no-repeat 50%/50% 50%;
    }
    [dir=ltr] .custom-radio.b-custom-control-sm .custom-control-label::after, [dir=ltr] .input-group-sm .custom-radio .custom-control-label::after {
      left: -1.3125rem;
    }
    [dir=rtl] .custom-radio.b-custom-control-sm .custom-control-label::after, [dir=rtl] .input-group-sm .custom-radio .custom-control-label::after {
      right: -1.3125rem;
    }
    
     .b-rating {
      text-align: center;
    }
    .b-rating.d-inline-flex {
      width: auto;
    }
     .b-rating .b-rating-star,  .b-rating .b-rating-value {
      padding: 0 0.25em;
    }
    .b-rating .b-rating-value {
      min-width: 2.5em;
    }
    .b-rating .b-rating-star {
      display: inline-flex;
      justify-content: center;
      outline: 0;
    }
    .b-rating .b-rating-star .b-rating-icon {
      display: inline-flex;
      transition: all 0.15s ease-in-out;
    }
    .b-rating.disabled, .b-rating:disabled {
      color: #b9b9c3;
    }
     .b-rating.disabled,  .b-rating:disabled {
      background-color: #efefef;
    }
     .b-rating:not(.disabled):not(.readonly) .b-rating-star {
      cursor: pointer;
    }
     .b-rating:not(.disabled):not(.readonly):focus:not(:hover) .b-rating-star.focused .b-rating-icon,  .b-rating:not(.disabled):not(.readonly) .b-rating-star:hover .b-rating-icon {
      transform: scale(1.5);
    }
    .b-rating[dir=rtl] .b-rating-star-half {
      transform: scale(-1, 1);
    }
    
    .b-form-spinbutton {
      overflow: hidden;
    }
    
     .b-form-spinbutton {
      text-align: center;
      background-image: none;
      padding: 0;
    }
    [dir=rtl] .b-form-spinbutton:not(.flex-column), .b-form-spinbutton[dir=rtl]:not(.flex-column) {
      flex-direction: row-reverse;
    }
    
    .b-form-spinbutton output {
      font-size: inherit;
      outline: 0;
      width: auto;
    }
    
     .b-form-spinbutton output {
      border: 0;
      background-color: transparent;
      margin: 0;
      padding: 0 0.25rem;
    }
    .b-form-spinbutton output > div,
    .b-form-spinbutton output > bdi {
      display: block;
      min-width: 2.25em;
      height: 1.45em;
    }
    .b-form-spinbutton.flex-column {
      height: auto;
      width: auto;
    }
     .b-form-spinbutton.flex-column output {
      margin: 0 0.25rem;
      padding: 0.25rem 0;
    }
    .b-form-spinbutton:not(.d-inline-flex):not(.flex-column) {
      output-width: 100%;
    }
    .b-form-spinbutton.d-inline-flex:not(.flex-column) {
      width: auto;
    }
    .b-form-spinbutton .btn {
      line-height: 1;
    }
     .b-form-spinbutton .btn {
      box-shadow: none !important;
    }
    .b-form-spinbutton .btn:disabled {
      pointer-events: none;
    }
     .b-form-spinbutton .btn:hover:not(:disabled) > div > .b-icon {
      transform: scale(1.25);
    }
     .b-form-spinbutton.disabled,  .b-form-spinbutton.readonly {
      background-color: #efefef;
    }
    .b-form-spinbutton.disabled {
      pointer-events: none;
    }
    
     .b-form-tags .b-form-tags-list {
      margin-top: -0.25rem;
    }
     .b-form-tags .b-form-tags-list .b-from-tags-field,  .b-form-tags .b-form-tags-list .b-form-tag {
      margin-top: 0.25rem;
    }
    .b-form-tags.focus {
      color: #424244;
      outline: 0;
    }
     .b-form-tags.focus {
      background-color: #fff;
      border-color: #114A9F;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
     .b-form-tags.focus.is-valid {
      border-color: #17B75E;
      box-shadow: 0 0 0 0.2rem rgba(23, 183, 94, 0.25);
    }
     .b-form-tags.focus.is-invalid {
      border-color: #EA5455;
      box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.25);
    }
     .b-form-tags.disabled {
      background-color: #efefef;
    }
    
    .b-form-tag {
      font-size: 75%;
      font-weight: normal;
      line-height: 1.45;
    }
    
    [dir=ltr] .b-form-tag {
      margin-right: 0.25rem;
    }
    
    [dir=rtl] .b-form-tag {
      margin-left: 0.25rem;
    }
    .b-form-tag.disabled {
      opacity: 0.75;
    }
    .b-form-tag > button.b-form-tag-remove {
      color: inherit;
      font-size: 125%;
      line-height: 1;
    }
     .b-form-tag > button.b-form-tag-remove {
      float: none;
    }
    [dir=ltr] .b-form-tag > button.b-form-tag-remove {
      margin-left: 0.25rem;
    }
    [dir=rtl] .b-form-tag > button.b-form-tag-remove {
      margin-right: 0.25rem;
    }
    
    .form-control-sm .b-form-tag {
      line-height: 1;
    }
    
    .form-control-lg .b-form-tag {
      line-height: 1.25;
    }
    
    .media-aside {
      display: flex;
    }
    
    [dir=ltr] .media-aside {
      margin-right: 1rem;
    }
    
    [dir=rtl] .media-aside {
      margin-left: 1rem;
    }
    
    [dir=ltr] .media-aside-right {
      margin-right: 0;
      margin-left: 1rem;
    }
    
    [dir=rtl] .media-aside-right {
      margin-left: 0;
      margin-right: 1rem;
    }
    
    .modal-backdrop {
      opacity: 0.5;
    }
    
    .b-pagination-pills .page-item .page-link {
      line-height: 1;
    }
    
     .b-pagination-pills .page-item .page-link {
      border-radius: 50rem !important;
    }
    
    [dir=ltr] .b-pagination-pills .page-item .page-link {
      margin-left: 0.25rem;
    }
    
    [dir=rtl] .b-pagination-pills .page-item .page-link {
      margin-right: 0.25rem;
    }
    [dir=ltr] .b-pagination-pills .page-item:first-child .page-link {
      margin-left: 0;
    }
    [dir=rtl] .b-pagination-pills .page-item:first-child .page-link {
      margin-right: 0;
    }
    
    .popover.b-popover {
      display: block;
      opacity: 1;
      outline: 0;
    }
    .popover.b-popover.fade:not(.show) {
      opacity: 0;
    }
    .popover.b-popover.show {
      opacity: 1;
    }
    
     .b-popover-primary.popover {
      background-color: #cfdbec;
      border-color: #bccce4;
    }
     .b-popover-primary.bs-popover-top > .arrow::before,  .b-popover-primary.bs-popover-auto[x-placement^=top] > .arrow::before {
      border-top-color: #bccce4;
    }
     .b-popover-primary.bs-popover-top > .arrow::after,  .b-popover-primary.bs-popover-auto[x-placement^=top] > .arrow::after {
      border-top-color: #cfdbec;
    }
    [dir=ltr] .b-popover-primary.bs-popover-right > .arrow::before, [dir=ltr] .b-popover-primary.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-right-color: #bccce4;
    }
    [dir=rtl] .b-popover-primary.bs-popover-right > .arrow::before, [dir=rtl] .b-popover-primary.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-left-color: #bccce4;
    }
    [dir=ltr] .b-popover-primary.bs-popover-right > .arrow::after, [dir=ltr] .b-popover-primary.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-right-color: #cfdbec;
    }
    [dir=rtl] .b-popover-primary.bs-popover-right > .arrow::after, [dir=rtl] .b-popover-primary.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-left-color: #cfdbec;
    }
     .b-popover-primary.bs-popover-bottom > .arrow::before,  .b-popover-primary.bs-popover-auto[x-placement^=bottom] > .arrow::before {
      border-bottom-color: #bccce4;
    }
     .b-popover-primary.bs-popover-bottom > .arrow::after,  .b-popover-primary.bs-popover-auto[x-placement^=bottom] > .arrow::after {
      border-bottom-color: #c4d3e8;
    }
     .b-popover-primary.bs-popover-bottom .popover-header::before,  .b-popover-primary.bs-popover-auto[x-placement^=bottom] .popover-header::before {
      border-bottom-color: #c4d3e8;
    }
    [dir=ltr] .b-popover-primary.bs-popover-left > .arrow::before, [dir=ltr] .b-popover-primary.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-left-color: #bccce4;
    }
    [dir=rtl] .b-popover-primary.bs-popover-left > .arrow::before, [dir=rtl] .b-popover-primary.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-right-color: #bccce4;
    }
    [dir=ltr] .b-popover-primary.bs-popover-left > .arrow::after, [dir=ltr] .b-popover-primary.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-left-color: #cfdbec;
    }
    [dir=rtl] .b-popover-primary.bs-popover-left > .arrow::after, [dir=rtl] .b-popover-primary.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-right-color: #cfdbec;
    }
    .b-popover-primary .popover-header {
      color: #2a2e30;
    }
     .b-popover-primary .popover-header {
      background-color: #c4d3e8;
      border-bottom-color: #b2c5e0;
    }
    .b-popover-primary .popover-body {
      color: #193a69;
    }
    
     .b-popover-secondary.popover {
      background-color: #ebeced;
      border-color: #e3e4e6;
    }
     .b-popover-secondary.bs-popover-top > .arrow::before,  .b-popover-secondary.bs-popover-auto[x-placement^=top] > .arrow::before {
      border-top-color: #e3e4e6;
    }
     .b-popover-secondary.bs-popover-top > .arrow::after,  .b-popover-secondary.bs-popover-auto[x-placement^=top] > .arrow::after {
      border-top-color: #ebeced;
    }
    [dir=ltr] .b-popover-secondary.bs-popover-right > .arrow::before, [dir=ltr] .b-popover-secondary.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-right-color: #e3e4e6;
    }
    [dir=rtl] .b-popover-secondary.bs-popover-right > .arrow::before, [dir=rtl] .b-popover-secondary.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-left-color: #e3e4e6;
    }
    [dir=ltr] .b-popover-secondary.bs-popover-right > .arrow::after, [dir=ltr] .b-popover-secondary.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-right-color: #ebeced;
    }
    [dir=rtl] .b-popover-secondary.bs-popover-right > .arrow::after, [dir=rtl] .b-popover-secondary.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-left-color: #ebeced;
    }
     .b-popover-secondary.bs-popover-bottom > .arrow::before,  .b-popover-secondary.bs-popover-auto[x-placement^=bottom] > .arrow::before {
      border-bottom-color: #e3e4e6;
    }
     .b-popover-secondary.bs-popover-bottom > .arrow::after,  .b-popover-secondary.bs-popover-auto[x-placement^=bottom] > .arrow::after {
      border-bottom-color: #e3e4e6;
    }
     .b-popover-secondary.bs-popover-bottom .popover-header::before,  .b-popover-secondary.bs-popover-auto[x-placement^=bottom] .popover-header::before {
      border-bottom-color: #e3e4e6;
    }
    [dir=ltr] .b-popover-secondary.bs-popover-left > .arrow::before, [dir=ltr] .b-popover-secondary.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-left-color: #e3e4e6;
    }
    [dir=rtl] .b-popover-secondary.bs-popover-left > .arrow::before, [dir=rtl] .b-popover-secondary.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-right-color: #e3e4e6;
    }
    [dir=ltr] .b-popover-secondary.bs-popover-left > .arrow::after, [dir=ltr] .b-popover-secondary.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-left-color: #ebeced;
    }
    [dir=rtl] .b-popover-secondary.bs-popover-left > .arrow::after, [dir=rtl] .b-popover-secondary.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-right-color: #ebeced;
    }
    .b-popover-secondary .popover-header {
      color: #2a2e30;
    }
     .b-popover-secondary .popover-header {
      background-color: #e3e4e6;
      border-bottom-color: #d6d8da;
    }
    .b-popover-secondary .popover-body {
      color: #61666c;
    }
    
     .b-popover-success.popover {
      background-color: #d1f1df;
      border-color: #beebd2;
    }
     .b-popover-success.bs-popover-top > .arrow::before,  .b-popover-success.bs-popover-auto[x-placement^=top] > .arrow::before {
      border-top-color: #beebd2;
    }
     .b-popover-success.bs-popover-top > .arrow::after,  .b-popover-success.bs-popover-auto[x-placement^=top] > .arrow::after {
      border-top-color: #d1f1df;
    }
    [dir=ltr] .b-popover-success.bs-popover-right > .arrow::before, [dir=ltr] .b-popover-success.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-right-color: #beebd2;
    }
    [dir=rtl] .b-popover-success.bs-popover-right > .arrow::before, [dir=rtl] .b-popover-success.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-left-color: #beebd2;
    }
    [dir=ltr] .b-popover-success.bs-popover-right > .arrow::after, [dir=ltr] .b-popover-success.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-right-color: #d1f1df;
    }
    [dir=rtl] .b-popover-success.bs-popover-right > .arrow::after, [dir=rtl] .b-popover-success.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-left-color: #d1f1df;
    }
     .b-popover-success.bs-popover-bottom > .arrow::before,  .b-popover-success.bs-popover-auto[x-placement^=bottom] > .arrow::before {
      border-bottom-color: #beebd2;
    }
     .b-popover-success.bs-popover-bottom > .arrow::after,  .b-popover-success.bs-popover-auto[x-placement^=bottom] > .arrow::after {
      border-bottom-color: #c5edd7;
    }
     .b-popover-success.bs-popover-bottom .popover-header::before,  .b-popover-success.bs-popover-auto[x-placement^=bottom] .popover-header::before {
      border-bottom-color: #c5edd7;
    }
    [dir=ltr] .b-popover-success.bs-popover-left > .arrow::before, [dir=ltr] .b-popover-success.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-left-color: #beebd2;
    }
    [dir=rtl] .b-popover-success.bs-popover-left > .arrow::before, [dir=rtl] .b-popover-success.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-right-color: #beebd2;
    }
    [dir=ltr] .b-popover-success.bs-popover-left > .arrow::after, [dir=ltr] .b-popover-success.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-left-color: #d1f1df;
    }
    [dir=rtl] .b-popover-success.bs-popover-left > .arrow::after, [dir=rtl] .b-popover-success.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-right-color: #d1f1df;
    }
    .b-popover-success .popover-header {
      color: #2a2e30;
    }
     .b-popover-success .popover-header {
      background-color: #c5edd7;
      border-bottom-color: #b2e7c9;
    }
    .b-popover-success .popover-body {
      color: #1c7347;
    }
    
     .b-popover-info.popover {
      background-color: #ccf5fa;
      border-color: #b8f2f9;
    }
     .b-popover-info.bs-popover-top > .arrow::before,  .b-popover-info.bs-popover-auto[x-placement^=top] > .arrow::before {
      border-top-color: #b8f2f9;
    }
     .b-popover-info.bs-popover-top > .arrow::after,  .b-popover-info.bs-popover-auto[x-placement^=top] > .arrow::after {
      border-top-color: #ccf5fa;
    }
    [dir=ltr] .b-popover-info.bs-popover-right > .arrow::before, [dir=ltr] .b-popover-info.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-right-color: #b8f2f9;
    }
    [dir=rtl] .b-popover-info.bs-popover-right > .arrow::before, [dir=rtl] .b-popover-info.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-left-color: #b8f2f9;
    }
    [dir=ltr] .b-popover-info.bs-popover-right > .arrow::after, [dir=ltr] .b-popover-info.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-right-color: #ccf5fa;
    }
    [dir=rtl] .b-popover-info.bs-popover-right > .arrow::after, [dir=rtl] .b-popover-info.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-left-color: #ccf5fa;
    }
     .b-popover-info.bs-popover-bottom > .arrow::before,  .b-popover-info.bs-popover-auto[x-placement^=bottom] > .arrow::before {
      border-bottom-color: #b8f2f9;
    }
     .b-popover-info.bs-popover-bottom > .arrow::after,  .b-popover-info.bs-popover-auto[x-placement^=bottom] > .arrow::after {
      border-bottom-color: #bef2f9;
    }
     .b-popover-info.bs-popover-bottom .popover-header::before,  .b-popover-info.bs-popover-auto[x-placement^=bottom] .popover-header::before {
      border-bottom-color: #bef2f9;
    }
    [dir=ltr] .b-popover-info.bs-popover-left > .arrow::before, [dir=ltr] .b-popover-info.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-left-color: #b8f2f9;
    }
    [dir=rtl] .b-popover-info.bs-popover-left > .arrow::before, [dir=rtl] .b-popover-info.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-right-color: #b8f2f9;
    }
    [dir=ltr] .b-popover-info.bs-popover-left > .arrow::after, [dir=ltr] .b-popover-info.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-left-color: #ccf5fa;
    }
    [dir=rtl] .b-popover-info.bs-popover-left > .arrow::after, [dir=rtl] .b-popover-info.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-right-color: #ccf5fa;
    }
    .b-popover-info .popover-header {
      color: #2a2e30;
    }
     .b-popover-info .popover-header {
      background-color: #bef2f9;
      border-bottom-color: #a7eef6;
    }
    .b-popover-info .popover-body {
      color: #107f8f;
    }
    
     .b-popover-warning.popover {
      background-color: #fff1d0;
      border-color: #feebbd;
    }
     .b-popover-warning.bs-popover-top > .arrow::before,  .b-popover-warning.bs-popover-auto[x-placement^=top] > .arrow::before {
      border-top-color: #feebbd;
    }
     .b-popover-warning.bs-popover-top > .arrow::after,  .b-popover-warning.bs-popover-auto[x-placement^=top] > .arrow::after {
      border-top-color: #fff1d0;
    }
    [dir=ltr] .b-popover-warning.bs-popover-right > .arrow::before, [dir=ltr] .b-popover-warning.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-right-color: #feebbd;
    }
    [dir=rtl] .b-popover-warning.bs-popover-right > .arrow::before, [dir=rtl] .b-popover-warning.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-left-color: #feebbd;
    }
    [dir=ltr] .b-popover-warning.bs-popover-right > .arrow::after, [dir=ltr] .b-popover-warning.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-right-color: #fff1d0;
    }
    [dir=rtl] .b-popover-warning.bs-popover-right > .arrow::after, [dir=rtl] .b-popover-warning.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-left-color: #fff1d0;
    }
     .b-popover-warning.bs-popover-bottom > .arrow::before,  .b-popover-warning.bs-popover-auto[x-placement^=bottom] > .arrow::before {
      border-bottom-color: #feebbd;
    }
     .b-popover-warning.bs-popover-bottom > .arrow::after,  .b-popover-warning.bs-popover-auto[x-placement^=bottom] > .arrow::after {
      border-bottom-color: #ffecc1;
    }
     .b-popover-warning.bs-popover-bottom .popover-header::before,  .b-popover-warning.bs-popover-auto[x-placement^=bottom] .popover-header::before {
      border-bottom-color: #ffecc1;
    }
    [dir=ltr] .b-popover-warning.bs-popover-left > .arrow::before, [dir=ltr] .b-popover-warning.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-left-color: #feebbd;
    }
    [dir=rtl] .b-popover-warning.bs-popover-left > .arrow::before, [dir=rtl] .b-popover-warning.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-right-color: #feebbd;
    }
    [dir=ltr] .b-popover-warning.bs-popover-left > .arrow::after, [dir=ltr] .b-popover-warning.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-left-color: #fff1d0;
    }
    [dir=rtl] .b-popover-warning.bs-popover-left > .arrow::after, [dir=rtl] .b-popover-warning.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-right-color: #fff1d0;
    }
    .b-popover-warning .popover-header {
      color: #2a2e30;
    }
     .b-popover-warning .popover-header {
      background-color: #ffecc1;
      border-bottom-color: #ffe5a7;
    }
    .b-popover-warning .popover-body {
      color: #947420;
    }
    
     .b-popover-danger.popover {
      background-color: #fbdddd;
      border-color: #f9cfcf;
    }
     .b-popover-danger.bs-popover-top > .arrow::before,  .b-popover-danger.bs-popover-auto[x-placement^=top] > .arrow::before {
      border-top-color: #f9cfcf;
    }
     .b-popover-danger.bs-popover-top > .arrow::after,  .b-popover-danger.bs-popover-auto[x-placement^=top] > .arrow::after {
      border-top-color: #fbdddd;
    }
    [dir=ltr] .b-popover-danger.bs-popover-right > .arrow::before, [dir=ltr] .b-popover-danger.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-right-color: #f9cfcf;
    }
    [dir=rtl] .b-popover-danger.bs-popover-right > .arrow::before, [dir=rtl] .b-popover-danger.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-left-color: #f9cfcf;
    }
    [dir=ltr] .b-popover-danger.bs-popover-right > .arrow::after, [dir=ltr] .b-popover-danger.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-right-color: #fbdddd;
    }
    [dir=rtl] .b-popover-danger.bs-popover-right > .arrow::after, [dir=rtl] .b-popover-danger.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-left-color: #fbdddd;
    }
     .b-popover-danger.bs-popover-bottom > .arrow::before,  .b-popover-danger.bs-popover-auto[x-placement^=bottom] > .arrow::before {
      border-bottom-color: #f9cfcf;
    }
     .b-popover-danger.bs-popover-bottom > .arrow::after,  .b-popover-danger.bs-popover-auto[x-placement^=bottom] > .arrow::after {
      border-bottom-color: #f9cfcf;
    }
     .b-popover-danger.bs-popover-bottom .popover-header::before,  .b-popover-danger.bs-popover-auto[x-placement^=bottom] .popover-header::before {
      border-bottom-color: #f9cfcf;
    }
    [dir=ltr] .b-popover-danger.bs-popover-left > .arrow::before, [dir=ltr] .b-popover-danger.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-left-color: #f9cfcf;
    }
    [dir=rtl] .b-popover-danger.bs-popover-left > .arrow::before, [dir=rtl] .b-popover-danger.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-right-color: #f9cfcf;
    }
    [dir=ltr] .b-popover-danger.bs-popover-left > .arrow::after, [dir=ltr] .b-popover-danger.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-left-color: #fbdddd;
    }
    [dir=rtl] .b-popover-danger.bs-popover-left > .arrow::after, [dir=rtl] .b-popover-danger.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-right-color: #fbdddd;
    }
    .b-popover-danger .popover-header {
      color: #2a2e30;
    }
     .b-popover-danger .popover-header {
      background-color: #f9cfcf;
      border-bottom-color: #f7b8b8;
    }
    .b-popover-danger .popover-body {
      color: #8a3f43;
    }
    
     .b-popover-light.popover {
      background-color: #f3f3f3;
      border-color: #eeeeee;
    }
     .b-popover-light.bs-popover-top > .arrow::before,  .b-popover-light.bs-popover-auto[x-placement^=top] > .arrow::before {
      border-top-color: #eeeeee;
    }
     .b-popover-light.bs-popover-top > .arrow::after,  .b-popover-light.bs-popover-auto[x-placement^=top] > .arrow::after {
      border-top-color: #f3f3f3;
    }
    [dir=ltr] .b-popover-light.bs-popover-right > .arrow::before, [dir=ltr] .b-popover-light.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-right-color: #eeeeee;
    }
    [dir=rtl] .b-popover-light.bs-popover-right > .arrow::before, [dir=rtl] .b-popover-light.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-left-color: #eeeeee;
    }
    [dir=ltr] .b-popover-light.bs-popover-right > .arrow::after, [dir=ltr] .b-popover-light.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-right-color: #f3f3f3;
    }
    [dir=rtl] .b-popover-light.bs-popover-right > .arrow::after, [dir=rtl] .b-popover-light.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-left-color: #f3f3f3;
    }
     .b-popover-light.bs-popover-bottom > .arrow::before,  .b-popover-light.bs-popover-auto[x-placement^=bottom] > .arrow::before {
      border-bottom-color: #eeeeee;
    }
     .b-popover-light.bs-popover-bottom > .arrow::after,  .b-popover-light.bs-popover-auto[x-placement^=bottom] > .arrow::after {
      border-bottom-color: #ebebeb;
    }
     .b-popover-light.bs-popover-bottom .popover-header::before,  .b-popover-light.bs-popover-auto[x-placement^=bottom] .popover-header::before {
      border-bottom-color: #ebebeb;
    }
    [dir=ltr] .b-popover-light.bs-popover-left > .arrow::before, [dir=ltr] .b-popover-light.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-left-color: #eeeeee;
    }
    [dir=rtl] .b-popover-light.bs-popover-left > .arrow::before, [dir=rtl] .b-popover-light.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-right-color: #eeeeee;
    }
    [dir=ltr] .b-popover-light.bs-popover-left > .arrow::after, [dir=ltr] .b-popover-light.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-left-color: #f3f3f3;
    }
    [dir=rtl] .b-popover-light.bs-popover-left > .arrow::after, [dir=rtl] .b-popover-light.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-right-color: #f3f3f3;
    }
    .b-popover-light .popover-header {
      color: #2a2e30;
    }
     .b-popover-light .popover-header {
      background-color: #ebebeb;
      border-bottom-color: #dfdfdf;
    }
    .b-popover-light .popover-body {
      color: #75787b;
    }
    
     .b-popover-dark.popover {
      background-color: #dbdbdb;
      border-color: #cdcdcd;
    }
     .b-popover-dark.bs-popover-top > .arrow::before,  .b-popover-dark.bs-popover-auto[x-placement^=top] > .arrow::before {
      border-top-color: #cdcdcd;
    }
     .b-popover-dark.bs-popover-top > .arrow::after,  .b-popover-dark.bs-popover-auto[x-placement^=top] > .arrow::after {
      border-top-color: #dbdbdb;
    }
    [dir=ltr] .b-popover-dark.bs-popover-right > .arrow::before, [dir=ltr] .b-popover-dark.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-right-color: #cdcdcd;
    }
    [dir=rtl] .b-popover-dark.bs-popover-right > .arrow::before, [dir=rtl] .b-popover-dark.bs-popover-auto[x-placement^=right] > .arrow::before {
      border-left-color: #cdcdcd;
    }
    [dir=ltr] .b-popover-dark.bs-popover-right > .arrow::after, [dir=ltr] .b-popover-dark.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-right-color: #dbdbdb;
    }
    [dir=rtl] .b-popover-dark.bs-popover-right > .arrow::after, [dir=rtl] .b-popover-dark.bs-popover-auto[x-placement^=right] > .arrow::after {
      border-left-color: #dbdbdb;
    }
     .b-popover-dark.bs-popover-bottom > .arrow::before,  .b-popover-dark.bs-popover-auto[x-placement^=bottom] > .arrow::before {
      border-bottom-color: #cdcdcd;
    }
     .b-popover-dark.bs-popover-bottom > .arrow::after,  .b-popover-dark.bs-popover-auto[x-placement^=bottom] > .arrow::after {
      border-bottom-color: lightgray;
    }
     .b-popover-dark.bs-popover-bottom .popover-header::before,  .b-popover-dark.bs-popover-auto[x-placement^=bottom] .popover-header::before {
      border-bottom-color: lightgray;
    }
    [dir=ltr] .b-popover-dark.bs-popover-left > .arrow::before, [dir=ltr] .b-popover-dark.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-left-color: #cdcdcd;
    }
    [dir=rtl] .b-popover-dark.bs-popover-left > .arrow::before, [dir=rtl] .b-popover-dark.bs-popover-auto[x-placement^=left] > .arrow::before {
      border-right-color: #cdcdcd;
    }
    [dir=ltr] .b-popover-dark.bs-popover-left > .arrow::after, [dir=ltr] .b-popover-dark.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-left-color: #dbdbdb;
    }
    [dir=rtl] .b-popover-dark.bs-popover-left > .arrow::after, [dir=rtl] .b-popover-dark.bs-popover-auto[x-placement^=left] > .arrow::after {
      border-right-color: #dbdbdb;
    }
    .b-popover-dark .popover-header {
      color: #2a2e30;
    }
     .b-popover-dark .popover-header {
      background-color: lightgray;
      border-bottom-color: #c7c7c7;
    }
    .b-popover-dark .popover-body {
      color: #373b3e;
    }
    
    .b-sidebar-outer {
      position: fixed !important;
      top: 0;
      height: 0;
      overflow: visible;
      z-index: calc(1030 + 5);
    }
    
    [dir=ltr] .b-sidebar-outer {
      left: 0;
      right: 0;
    }
    
    [dir=rtl] .b-sidebar-outer {
      right: 0;
      left: 0;
    }
    
    .b-sidebar-backdrop {
      position: fixed !important;
      top: 0;
      z-index: -1;
      width: 100vw;
      height: 100vh;
      opacity: 0.6;
    }
    
    [dir=ltr] .b-sidebar-backdrop {
      left: 0;
    }
    
    [dir=rtl] .b-sidebar-backdrop {
      right: 0;
    }
    
    .b-sidebar {
      display: flex;
      flex-direction: column;
      position: fixed !important;
      top: 0;
      height: 100vh;
      width: 320px;
      max-width: 100% !important;
      outline: 0;
    }
    
     .b-sidebar {
      margin: 0 !important;
      transform: translateX(0);
    }
    .b-sidebar.slide {
      transition: transform 0.3s ease-in-out;
    }
    @media (prefers-reduced-motion: reduce) {
      .b-sidebar.slide {
        transition: none;
      }
    }
    [dir=ltr] .b-sidebar:not(.b-sidebar-right) {
      left: 0;
      right: auto;
    }
    [dir=rtl] .b-sidebar:not(.b-sidebar-right) {
      right: 0;
      left: auto;
    }
    [dir=ltr] .b-sidebar:not(.b-sidebar-right).slide:not(.show) {
      transform: translateX(-100%);
    }
    [dir=rtl] .b-sidebar:not(.b-sidebar-right).slide:not(.show) {
      transform: translateX(100%);
    }
    [dir=ltr] .b-sidebar:not(.b-sidebar-right) > .b-sidebar-header .close {
      margin-left: auto;
    }
    [dir=rtl] .b-sidebar:not(.b-sidebar-right) > .b-sidebar-header .close {
      margin-right: auto;
    }
    [dir=ltr] .b-sidebar.b-sidebar-right {
      left: auto;
      right: 0;
    }
    [dir=rtl] .b-sidebar.b-sidebar-right {
      right: auto;
      left: 0;
    }
    [dir=ltr] .b-sidebar.b-sidebar-right.slide:not(.show) {
      transform: translateX(100%);
    }
    [dir=rtl] .b-sidebar.b-sidebar-right.slide:not(.show) {
      transform: translateX(-100%);
    }
    [dir=ltr] .b-sidebar.b-sidebar-right > .b-sidebar-header .close {
      margin-right: auto;
    }
    [dir=rtl] .b-sidebar.b-sidebar-right > .b-sidebar-header .close {
      margin-left: auto;
    }
    .b-sidebar > .b-sidebar-header {
      font-size: 1.5rem;
      display: flex;
      flex-direction: row;
      flex-grow: 0;
      align-items: center;
    }
     .b-sidebar > .b-sidebar-header {
      padding: 0.5rem 1rem;
    }
    [dir=rtl] .b-sidebar > .b-sidebar-header {
      flex-direction: row-reverse;
    }
    
    .b-sidebar > .b-sidebar-header .close {
      font-size: 1.5rem;
    }
    
     .b-sidebar > .b-sidebar-header .close {
      float: none;
    }
    .b-sidebar > .b-sidebar-body {
      flex-grow: 1;
      height: 100%;
      overflow-y: auto;
    }
    .b-sidebar > .b-sidebar-footer {
      flex-grow: 0;
    }
    
     .b-skeleton-wrapper {
      cursor: wait;
    }
    
    .b-skeleton {
      position: relative;
      overflow: hidden;
      mask-image: radial-gradient(white, black);
    }
    
     .b-skeleton {
      background-color: rgba(0, 0, 0, 0.12);
      cursor: wait;
    }
    .b-skeleton::before {
      content: "&nbsp;";
    }
    
    .b-skeleton-text {
      height: 1rem;
    }
    
     .b-skeleton-text {
      margin-bottom: 1rem;
      border-radius: 0.25rem;
    }
    
    .b-skeleton-button {
      width: 75px;
      font-size: 1rem;
      line-height: 1;
    }
    
     .b-skeleton-button {
      padding: 0.72rem 1.5rem;
      border-radius: 0.358rem;
    }
    
    .b-skeleton-avatar {
      width: 2.5em;
      height: 2.5em;
    }
    
     .b-skeleton-avatar {
      border-radius: 50%;
    }
    
    .b-skeleton-input {
      height: 2.6666666667rem;
      line-height: 1.45;
    }
    
     .b-skeleton-input {
      padding: 0.438rem 1rem;
      border: #D6D9E1 solid 1px;
      border-radius: 0.357rem;
    }
    
    .b-skeleton-icon-wrapper svg {
      color: rgba(0, 0, 0, 0.12);
    }
    
    .b-skeleton-img {
      height: 100%;
      width: 100%;
    }
    
    .b-skeleton-animate-wave::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      z-index: 0;
    }
    
    [dir=ltr] .b-skeleton-animate-wave::after {
      right: 0;
      left: 0;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
      animation:  b-skeleton-animate-wave-ltr 1.75s linear infinite;
    }
    
    [dir=rtl] .b-skeleton-animate-wave::after {
      left: 0;
      right: 0;
      background: linear-gradient(-90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
      animation:  b-skeleton-animate-wave-rtl 1.75s linear infinite;
    }
    @media (prefers-reduced-motion: reduce) {
       .b-skeleton-animate-wave::after {
        background: none;
      }
      [dir=ltr] .b-skeleton-animate-wave::after {
        animation: none;
      }
      [dir=rtl] .b-skeleton-animate-wave::after {
        animation: none;
      }
    }
    
    @keyframes b-skeleton-animate-wave-ltr {
      from {
        transform: translateX(-100%);
      }
      to {
        transform: translateX(100%);
      }
    }
    
    @keyframes b-skeleton-animate-wave-rtl {
      from {
        transform: translateX(100%);
      }
      to {
        transform: translateX(-100%);
      }
    }
    [dir=ltr] .b-skeleton-animate-fade {
      animation: b-skeleton-animate-fade 0.875s ease-in-out alternate infinite;
    }
    [dir=rtl] .b-skeleton-animate-fade {
      animation: b-skeleton-animate-fade 0.875s ease-in-out alternate infinite;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .b-skeleton-animate-fade {
        animation: none;
      }
      [dir=rtl] .b-skeleton-animate-fade {
        animation: none;
      }
    }
    
    @keyframes b-skeleton-animate-fade {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0.4;
      }
    }
    [dir=ltr] .b-skeleton-animate-throb {
      animation: b-skeleton-animate-throb 0.875s ease-in alternate infinite;
    }
    [dir=rtl] .b-skeleton-animate-throb {
      animation: b-skeleton-animate-throb 0.875s ease-in alternate infinite;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .b-skeleton-animate-throb {
        animation: none;
      }
      [dir=rtl] .b-skeleton-animate-throb {
        animation: none;
      }
    }
    
    @keyframes b-skeleton-animate-throb {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(0.975);
      }
    }
    .table.b-table.b-table-fixed {
      table-layout: fixed;
    }
    .table.b-table.b-table-no-border-collapse {
      border-collapse: separate;
      border-spacing: 0;
    }
    .table.b-table[aria-busy=true] {
      opacity: 0.55;
    }
     .table.b-table > tbody > tr.b-table-details > td {
      border-top: none !important;
    }
    .table.b-table > caption {
      caption-side: bottom;
    }
    .table.b-table.b-table-caption-top > caption {
      caption-side: top !important;
    }
     .table.b-table > tbody > .table-active,  .table.b-table > tbody > .table-active > th,  .table.b-table > tbody > .table-active > td {
      background-color: #f6f6f9;
    }
    .table.b-table.table-hover > tbody > tr.table-active:hover td,
    .table.b-table.table-hover > tbody > tr.table-active:hover th {
      color: #424244;
    }
     .table.b-table.table-hover > tbody > tr.table-active:hover td,  .table.b-table.table-hover > tbody > tr.table-active:hover th {
      background-image: linear-gradient(#f6f6f9, #f6f6f9);
      background-repeat: no-repeat;
    }
     .table.b-table > tbody > .bg-active,  .table.b-table > tbody > .bg-active > th,  .table.b-table > tbody > .bg-active > td {
      background-color: rgba(255, 255, 255, 0.075) !important;
    }
    .table.b-table.table-hover.table-dark > tbody > tr.bg-active:hover td,
    .table.b-table.table-hover.table-dark > tbody > tr.bg-active:hover th {
      color: #fff;
    }
     .table.b-table.table-hover.table-dark > tbody > tr.bg-active:hover td,  .table.b-table.table-hover.table-dark > tbody > tr.bg-active:hover th {
      background-image: linear-gradient(rgba(255, 255, 255, 0.075), rgba(255, 255, 255, 0.075));
      background-repeat: no-repeat;
    }
    
     .b-table-sticky-header,  .table-responsive,  [class*=table-responsive-] {
      margin-bottom: 1rem;
    }
     .b-table-sticky-header > .table,  .table-responsive > .table,  [class*=table-responsive-] > .table {
      margin-bottom: 0;
    }
    
    .b-table-sticky-header {
      overflow-y: auto;
      max-height: 300px;
    }
    @supports (position: sticky) {
      .b-table-sticky-header > .table.b-table > thead > tr > th {
        position: sticky;
        top: 0;
        z-index: 2;
      }
    
      .b-table-sticky-header > .table.b-table > thead > tr > .b-table-sticky-column,
    .b-table-sticky-header > .table.b-table > tbody > tr > .b-table-sticky-column,
    .b-table-sticky-header > .table.b-table > tfoot > tr > .b-table-sticky-column,
    .table-responsive > .table.b-table > thead > tr > .b-table-sticky-column,
    .table-responsive > .table.b-table > tbody > tr > .b-table-sticky-column,
    .table-responsive > .table.b-table > tfoot > tr > .b-table-sticky-column,
    [class*=table-responsive-] > .table.b-table > thead > tr > .b-table-sticky-column,
    [class*=table-responsive-] > .table.b-table > tbody > tr > .b-table-sticky-column,
    [class*=table-responsive-] > .table.b-table > tfoot > tr > .b-table-sticky-column {
        position: sticky;
      }
    
      [dir=ltr] .b-table-sticky-header > .table.b-table > thead > tr > .b-table-sticky-column, [dir=ltr] .b-table-sticky-header > .table.b-table > tbody > tr > .b-table-sticky-column, [dir=ltr] .b-table-sticky-header > .table.b-table > tfoot > tr > .b-table-sticky-column, [dir=ltr] .table-responsive > .table.b-table > thead > tr > .b-table-sticky-column, [dir=ltr] .table-responsive > .table.b-table > tbody > tr > .b-table-sticky-column, [dir=ltr] .table-responsive > .table.b-table > tfoot > tr > .b-table-sticky-column, [dir=ltr] [class*=table-responsive-] > .table.b-table > thead > tr > .b-table-sticky-column, [dir=ltr] [class*=table-responsive-] > .table.b-table > tbody > tr > .b-table-sticky-column, [dir=ltr] [class*=table-responsive-] > .table.b-table > tfoot > tr > .b-table-sticky-column {
        left: 0;
      }
    
      [dir=rtl] .b-table-sticky-header > .table.b-table > thead > tr > .b-table-sticky-column, [dir=rtl] .b-table-sticky-header > .table.b-table > tbody > tr > .b-table-sticky-column, [dir=rtl] .b-table-sticky-header > .table.b-table > tfoot > tr > .b-table-sticky-column, [dir=rtl] .table-responsive > .table.b-table > thead > tr > .b-table-sticky-column, [dir=rtl] .table-responsive > .table.b-table > tbody > tr > .b-table-sticky-column, [dir=rtl] .table-responsive > .table.b-table > tfoot > tr > .b-table-sticky-column, [dir=rtl] [class*=table-responsive-] > .table.b-table > thead > tr > .b-table-sticky-column, [dir=rtl] [class*=table-responsive-] > .table.b-table > tbody > tr > .b-table-sticky-column, [dir=rtl] [class*=table-responsive-] > .table.b-table > tfoot > tr > .b-table-sticky-column {
        right: 0;
      }
      .b-table-sticky-header > .table.b-table > thead > tr > .b-table-sticky-column,
    .table-responsive > .table.b-table > thead > tr > .b-table-sticky-column,
    [class*=table-responsive-] > .table.b-table > thead > tr > .b-table-sticky-column {
        z-index: 5;
      }
      .b-table-sticky-header > .table.b-table > tbody > tr > .b-table-sticky-column,
    .b-table-sticky-header > .table.b-table > tfoot > tr > .b-table-sticky-column,
    .table-responsive > .table.b-table > tbody > tr > .b-table-sticky-column,
    .table-responsive > .table.b-table > tfoot > tr > .b-table-sticky-column,
    [class*=table-responsive-] > .table.b-table > tbody > tr > .b-table-sticky-column,
    [class*=table-responsive-] > .table.b-table > tfoot > tr > .b-table-sticky-column {
        z-index: 2;
      }
    
      .table.b-table > thead > tr > .table-b-table-default,
    .table.b-table > tbody > tr > .table-b-table-default,
    .table.b-table > tfoot > tr > .table-b-table-default {
        color: #424244;
      }
    
       .table.b-table > thead > tr > .table-b-table-default,  .table.b-table > tbody > tr > .table-b-table-default,  .table.b-table > tfoot > tr > .table-b-table-default {
        background-color: #f8f8f8;
      }
      .table.b-table.table-dark > thead > tr > .bg-b-table-default,
    .table.b-table.table-dark > tbody > tr > .bg-b-table-default,
    .table.b-table.table-dark > tfoot > tr > .bg-b-table-default {
        color: #fff;
      }
       .table.b-table.table-dark > thead > tr > .bg-b-table-default,  .table.b-table.table-dark > tbody > tr > .bg-b-table-default,  .table.b-table.table-dark > tfoot > tr > .bg-b-table-default {
        background-color: #4B4B4B;
      }
       .table.b-table.table-striped > tbody > tr:nth-of-type(odd) > .table-b-table-default {
        background-image: linear-gradient(#fafafc, #fafafc);
        background-repeat: no-repeat;
      }
       .table.b-table.table-striped.table-dark > tbody > tr:nth-of-type(odd) > .bg-b-table-default {
        background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05));
        background-repeat: no-repeat;
      }
      .table.b-table.table-hover > tbody > tr:hover > .table-b-table-default {
        color: #424244;
      }
       .table.b-table.table-hover > tbody > tr:hover > .table-b-table-default {
        background-image: linear-gradient(#f6f6f9, #f6f6f9);
        background-repeat: no-repeat;
      }
      .table.b-table.table-hover.table-dark > tbody > tr:hover > .bg-b-table-default {
        color: #fff;
      }
       .table.b-table.table-hover.table-dark > tbody > tr:hover > .bg-b-table-default {
        background-image: linear-gradient(rgba(255, 255, 255, 0.075), rgba(255, 255, 255, 0.075));
        background-repeat: no-repeat;
      }
    }
     .table.b-table > thead > tr > [aria-sort],  .table.b-table > tfoot > tr > [aria-sort] {
      cursor: pointer;
      background-image: none;
      background-repeat: no-repeat;
      background-size: 0.65em 1em;
    }
    [dir=ltr] .table.b-table > thead > tr > [aria-sort]:not(.b-table-sort-icon-left), [dir=ltr] .table.b-table > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
      background-position: right calc(0.72rem / 2) center;
      padding-right: calc(0.72rem + 0.65em);
    }
    [dir=rtl] .table.b-table > thead > tr > [aria-sort]:not(.b-table-sort-icon-left), [dir=rtl] .table.b-table > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
      background-position: left calc(0.72rem / 2) center;
      padding-left: calc(0.72rem + 0.65em);
    }
    [dir=ltr] .table.b-table > thead > tr > [aria-sort].b-table-sort-icon-left, [dir=ltr] .table.b-table > tfoot > tr > [aria-sort].b-table-sort-icon-left {
      background-position: left calc(0.72rem / 2) center;
      padding-left: calc(0.72rem + 0.65em);
    }
    [dir=rtl] .table.b-table > thead > tr > [aria-sort].b-table-sort-icon-left, [dir=rtl] .table.b-table > tfoot > tr > [aria-sort].b-table-sort-icon-left {
      background-position: right calc(0.72rem / 2) center;
      padding-right: calc(0.72rem + 0.65em);
    }
     .table.b-table > thead > tr > [aria-sort=none],  .table.b-table > tfoot > tr > [aria-sort=none] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Earrows%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-257.000000, -561.000000)' stroke='%23C6C4D0' stroke-width='2'%3E%3Cg id='arrows' transform='translate(258.000000, 562.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
     .table.b-table > thead > tr > [aria-sort=ascending],  .table.b-table > tfoot > tr > [aria-sort=ascending] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Eactive-up%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-197.000000, -561.000000)' stroke-width='2'%3E%3Cg id='active-up' transform='translate(198.000000, 562.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)' stroke='%23C6C4D0'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up' stroke='%235E5873'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
     .table.b-table > thead > tr > [aria-sort=descending],  .table.b-table > tfoot > tr > [aria-sort=descending] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Eactive-down%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-227.000000, -561.000000)' stroke-width='2'%3E%3Cg id='active-down' transform='translate(228.000000, 562.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)' stroke='%235E5873'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up' stroke='%23C6C4D0'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
     .table.b-table.table-dark > thead > tr > [aria-sort=none],  .table.b-table.table-dark > tfoot > tr > [aria-sort=none],  .table.b-table > .thead-dark > tr > [aria-sort=none] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Earrow-dark%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-259.000000, -621.000000)' stroke='%23747A88' stroke-width='2'%3E%3Cg id='arrow-dark' transform='translate(260.000000, 622.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
     .table.b-table.table-dark > thead > tr > [aria-sort=ascending],  .table.b-table.table-dark > tfoot > tr > [aria-sort=ascending],  .table.b-table > .thead-dark > tr > [aria-sort=ascending] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Eactive-up-dark%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-199.000000, -621.000000)' stroke-width='2'%3E%3Cg id='active-up-dark' transform='translate(200.000000, 622.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)' stroke='%23747A88'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up' stroke='%23B4B7BC'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
     .table.b-table.table-dark > thead > tr > [aria-sort=descending],  .table.b-table.table-dark > tfoot > tr > [aria-sort=descending],  .table.b-table > .thead-dark > tr > [aria-sort=descending] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Eactive-dow-dark%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-229.000000, -621.000000)' stroke-width='2'%3E%3Cg id='active-dow-dark' transform='translate(230.000000, 622.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)' stroke='%23B4B7BC'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up' stroke='%23747A88'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
     .table.b-table > thead > tr > .table-dark[aria-sort=none],  .table.b-table > tfoot > tr > .table-dark[aria-sort=none] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Earrow-dark%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-259.000000, -621.000000)' stroke='%23747A88' stroke-width='2'%3E%3Cg id='arrow-dark' transform='translate(260.000000, 622.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
     .table.b-table > thead > tr > .table-dark[aria-sort=ascending],  .table.b-table > tfoot > tr > .table-dark[aria-sort=ascending] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Eactive-up-dark%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-199.000000, -621.000000)' stroke-width='2'%3E%3Cg id='active-up-dark' transform='translate(200.000000, 622.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)' stroke='%23747A88'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up' stroke='%23B4B7BC'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
     .table.b-table > thead > tr > .table-dark[aria-sort=descending],  .table.b-table > tfoot > tr > .table-dark[aria-sort=descending] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Eactive-dow-dark%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-229.000000, -621.000000)' stroke-width='2'%3E%3Cg id='active-dow-dark' transform='translate(230.000000, 622.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)' stroke='%23B4B7BC'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up' stroke='%23747A88'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
    [dir=ltr] .table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left), [dir=ltr] .table.b-table.table-sm > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
      background-position: right calc(0.3rem / 2) center;
      padding-right: calc(0.3rem + 0.65em);
    }
    [dir=rtl] .table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left), [dir=rtl] .table.b-table.table-sm > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
      background-position: left calc(0.3rem / 2) center;
      padding-left: calc(0.3rem + 0.65em);
    }
    [dir=ltr] .table.b-table.table-sm > thead > tr > [aria-sort].b-table-sort-icon-left, [dir=ltr] .table.b-table.table-sm > tfoot > tr > [aria-sort].b-table-sort-icon-left {
      background-position: left calc(0.3rem / 2) center;
      padding-left: calc(0.3rem + 0.65em);
    }
    [dir=rtl] .table.b-table.table-sm > thead > tr > [aria-sort].b-table-sort-icon-left, [dir=rtl] .table.b-table.table-sm > tfoot > tr > [aria-sort].b-table-sort-icon-left {
      background-position: right calc(0.3rem / 2) center;
      padding-right: calc(0.3rem + 0.65em);
    }
    
     .table.b-table.b-table-selectable:not(.b-table-selectable-no-click) > tbody > tr {
      cursor: pointer;
    }
    .table.b-table.b-table-selectable:not(.b-table-selectable-no-click).b-table-selecting.b-table-select-range > tbody > tr {
      user-select: none;
    }
    
    @media (max-width: 575.98px) {
      .table.b-table.b-table-stacked-sm {
        display: block;
        width: 100%;
      }
      .table.b-table.b-table-stacked-sm > caption,
    .table.b-table.b-table-stacked-sm > tbody,
    .table.b-table.b-table-stacked-sm > tbody > tr,
    .table.b-table.b-table-stacked-sm > tbody > tr > td,
    .table.b-table.b-table-stacked-sm > tbody > tr > th {
        display: block;
      }
      .table.b-table.b-table-stacked-sm > thead,
    .table.b-table.b-table-stacked-sm > tfoot {
        display: none;
      }
      .table.b-table.b-table-stacked-sm > thead > tr.b-table-top-row,
    .table.b-table.b-table-stacked-sm > thead > tr.b-table-bottom-row,
    .table.b-table.b-table-stacked-sm > tfoot > tr.b-table-top-row,
    .table.b-table.b-table-stacked-sm > tfoot > tr.b-table-bottom-row {
        display: none;
      }
      .table.b-table.b-table-stacked-sm > caption {
        caption-side: top !important;
      }
      .table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::before {
        content: attr(data-label);
        width: 40%;
        overflow-wrap: break-word;
        font-weight: bold;
        font-style: normal;
      }
       .table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::before {
        margin: 0;
      }
      [dir=ltr] .table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::before {
        float: left;
        text-align: right;
        padding: 0 calc(1rem / 2) 0 0;
      }
      [dir=rtl] .table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::before {
        float: right;
        text-align: left;
        padding: 0 0 0 calc(1rem / 2);
      }
      .table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::after {
        display: block;
        content: "";
      }
       .table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::after {
        clear: both;
      }
      .table.b-table.b-table-stacked-sm > tbody > tr > [data-label] > div {
        display: inline-block;
        width: calc(100% - 40%);
      }
       .table.b-table.b-table-stacked-sm > tbody > tr > [data-label] > div {
        margin: 0;
      }
      [dir=ltr] .table.b-table.b-table-stacked-sm > tbody > tr > [data-label] > div {
        padding: 0 0 0 calc(1rem / 2);
      }
      [dir=rtl] .table.b-table.b-table-stacked-sm > tbody > tr > [data-label] > div {
        padding: 0 calc(1rem / 2) 0 0;
      }
      .table.b-table.b-table-stacked-sm > tbody > tr.top-row, .table.b-table.b-table-stacked-sm > tbody > tr.bottom-row {
        display: none;
      }
       .table.b-table.b-table-stacked-sm > tbody > tr > :first-child {
        border-top-width: 3px;
      }
       .table.b-table.b-table-stacked-sm > tbody > tr > [rowspan] + td,  .table.b-table.b-table-stacked-sm > tbody > tr > [rowspan] + th {
        border-top-width: 3px;
      }
    }
    @media (max-width: 767.98px) {
      .table.b-table.b-table-stacked-md {
        display: block;
        width: 100%;
      }
      .table.b-table.b-table-stacked-md > caption,
    .table.b-table.b-table-stacked-md > tbody,
    .table.b-table.b-table-stacked-md > tbody > tr,
    .table.b-table.b-table-stacked-md > tbody > tr > td,
    .table.b-table.b-table-stacked-md > tbody > tr > th {
        display: block;
      }
      .table.b-table.b-table-stacked-md > thead,
    .table.b-table.b-table-stacked-md > tfoot {
        display: none;
      }
      .table.b-table.b-table-stacked-md > thead > tr.b-table-top-row,
    .table.b-table.b-table-stacked-md > thead > tr.b-table-bottom-row,
    .table.b-table.b-table-stacked-md > tfoot > tr.b-table-top-row,
    .table.b-table.b-table-stacked-md > tfoot > tr.b-table-bottom-row {
        display: none;
      }
      .table.b-table.b-table-stacked-md > caption {
        caption-side: top !important;
      }
      .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
        content: attr(data-label);
        width: 40%;
        overflow-wrap: break-word;
        font-weight: bold;
        font-style: normal;
      }
       .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
        margin: 0;
      }
      [dir=ltr] .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
        float: left;
        text-align: right;
        padding: 0 calc(1rem / 2) 0 0;
      }
      [dir=rtl] .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
        float: right;
        text-align: left;
        padding: 0 0 0 calc(1rem / 2);
      }
      .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::after {
        display: block;
        content: "";
      }
       .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::after {
        clear: both;
      }
      .table.b-table.b-table-stacked-md > tbody > tr > [data-label] > div {
        display: inline-block;
        width: calc(100% - 40%);
      }
       .table.b-table.b-table-stacked-md > tbody > tr > [data-label] > div {
        margin: 0;
      }
      [dir=ltr] .table.b-table.b-table-stacked-md > tbody > tr > [data-label] > div {
        padding: 0 0 0 calc(1rem / 2);
      }
      [dir=rtl] .table.b-table.b-table-stacked-md > tbody > tr > [data-label] > div {
        padding: 0 calc(1rem / 2) 0 0;
      }
      .table.b-table.b-table-stacked-md > tbody > tr.top-row, .table.b-table.b-table-stacked-md > tbody > tr.bottom-row {
        display: none;
      }
       .table.b-table.b-table-stacked-md > tbody > tr > :first-child {
        border-top-width: 3px;
      }
       .table.b-table.b-table-stacked-md > tbody > tr > [rowspan] + td,  .table.b-table.b-table-stacked-md > tbody > tr > [rowspan] + th {
        border-top-width: 3px;
      }
    }
    @media (max-width: 991.98px) {
      .table.b-table.b-table-stacked-lg {
        display: block;
        width: 100%;
      }
      .table.b-table.b-table-stacked-lg > caption,
    .table.b-table.b-table-stacked-lg > tbody,
    .table.b-table.b-table-stacked-lg > tbody > tr,
    .table.b-table.b-table-stacked-lg > tbody > tr > td,
    .table.b-table.b-table-stacked-lg > tbody > tr > th {
        display: block;
      }
      .table.b-table.b-table-stacked-lg > thead,
    .table.b-table.b-table-stacked-lg > tfoot {
        display: none;
      }
      .table.b-table.b-table-stacked-lg > thead > tr.b-table-top-row,
    .table.b-table.b-table-stacked-lg > thead > tr.b-table-bottom-row,
    .table.b-table.b-table-stacked-lg > tfoot > tr.b-table-top-row,
    .table.b-table.b-table-stacked-lg > tfoot > tr.b-table-bottom-row {
        display: none;
      }
      .table.b-table.b-table-stacked-lg > caption {
        caption-side: top !important;
      }
      .table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::before {
        content: attr(data-label);
        width: 40%;
        overflow-wrap: break-word;
        font-weight: bold;
        font-style: normal;
      }
       .table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::before {
        margin: 0;
      }
      [dir=ltr] .table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::before {
        float: left;
        text-align: right;
        padding: 0 calc(1rem / 2) 0 0;
      }
      [dir=rtl] .table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::before {
        float: right;
        text-align: left;
        padding: 0 0 0 calc(1rem / 2);
      }
      .table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::after {
        display: block;
        content: "";
      }
       .table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::after {
        clear: both;
      }
      .table.b-table.b-table-stacked-lg > tbody > tr > [data-label] > div {
        display: inline-block;
        width: calc(100% - 40%);
      }
       .table.b-table.b-table-stacked-lg > tbody > tr > [data-label] > div {
        margin: 0;
      }
      [dir=ltr] .table.b-table.b-table-stacked-lg > tbody > tr > [data-label] > div {
        padding: 0 0 0 calc(1rem / 2);
      }
      [dir=rtl] .table.b-table.b-table-stacked-lg > tbody > tr > [data-label] > div {
        padding: 0 calc(1rem / 2) 0 0;
      }
      .table.b-table.b-table-stacked-lg > tbody > tr.top-row, .table.b-table.b-table-stacked-lg > tbody > tr.bottom-row {
        display: none;
      }
       .table.b-table.b-table-stacked-lg > tbody > tr > :first-child {
        border-top-width: 3px;
      }
       .table.b-table.b-table-stacked-lg > tbody > tr > [rowspan] + td,  .table.b-table.b-table-stacked-lg > tbody > tr > [rowspan] + th {
        border-top-width: 3px;
      }
    }
    @media (max-width: 1199.98px) {
      .table.b-table.b-table-stacked-xl {
        display: block;
        width: 100%;
      }
      .table.b-table.b-table-stacked-xl > caption,
    .table.b-table.b-table-stacked-xl > tbody,
    .table.b-table.b-table-stacked-xl > tbody > tr,
    .table.b-table.b-table-stacked-xl > tbody > tr > td,
    .table.b-table.b-table-stacked-xl > tbody > tr > th {
        display: block;
      }
      .table.b-table.b-table-stacked-xl > thead,
    .table.b-table.b-table-stacked-xl > tfoot {
        display: none;
      }
      .table.b-table.b-table-stacked-xl > thead > tr.b-table-top-row,
    .table.b-table.b-table-stacked-xl > thead > tr.b-table-bottom-row,
    .table.b-table.b-table-stacked-xl > tfoot > tr.b-table-top-row,
    .table.b-table.b-table-stacked-xl > tfoot > tr.b-table-bottom-row {
        display: none;
      }
      .table.b-table.b-table-stacked-xl > caption {
        caption-side: top !important;
      }
      .table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::before {
        content: attr(data-label);
        width: 40%;
        overflow-wrap: break-word;
        font-weight: bold;
        font-style: normal;
      }
       .table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::before {
        margin: 0;
      }
      [dir=ltr] .table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::before {
        float: left;
        text-align: right;
        padding: 0 calc(1rem / 2) 0 0;
      }
      [dir=rtl] .table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::before {
        float: right;
        text-align: left;
        padding: 0 0 0 calc(1rem / 2);
      }
      .table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::after {
        display: block;
        content: "";
      }
       .table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::after {
        clear: both;
      }
      .table.b-table.b-table-stacked-xl > tbody > tr > [data-label] > div {
        display: inline-block;
        width: calc(100% - 40%);
      }
       .table.b-table.b-table-stacked-xl > tbody > tr > [data-label] > div {
        margin: 0;
      }
      [dir=ltr] .table.b-table.b-table-stacked-xl > tbody > tr > [data-label] > div {
        padding: 0 0 0 calc(1rem / 2);
      }
      [dir=rtl] .table.b-table.b-table-stacked-xl > tbody > tr > [data-label] > div {
        padding: 0 calc(1rem / 2) 0 0;
      }
      .table.b-table.b-table-stacked-xl > tbody > tr.top-row, .table.b-table.b-table-stacked-xl > tbody > tr.bottom-row {
        display: none;
      }
       .table.b-table.b-table-stacked-xl > tbody > tr > :first-child {
        border-top-width: 3px;
      }
       .table.b-table.b-table-stacked-xl > tbody > tr > [rowspan] + td,  .table.b-table.b-table-stacked-xl > tbody > tr > [rowspan] + th {
        border-top-width: 3px;
      }
    }
    .table.b-table.b-table-stacked {
      display: block;
      width: 100%;
    }
    .table.b-table.b-table-stacked > caption,
    .table.b-table.b-table-stacked > tbody,
    .table.b-table.b-table-stacked > tbody > tr,
    .table.b-table.b-table-stacked > tbody > tr > td,
    .table.b-table.b-table-stacked > tbody > tr > th {
      display: block;
    }
    .table.b-table.b-table-stacked > thead,
    .table.b-table.b-table-stacked > tfoot {
      display: none;
    }
    .table.b-table.b-table-stacked > thead > tr.b-table-top-row,
    .table.b-table.b-table-stacked > thead > tr.b-table-bottom-row,
    .table.b-table.b-table-stacked > tfoot > tr.b-table-top-row,
    .table.b-table.b-table-stacked > tfoot > tr.b-table-bottom-row {
      display: none;
    }
    .table.b-table.b-table-stacked > caption {
      caption-side: top !important;
    }
    .table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
      content: attr(data-label);
      width: 40%;
      overflow-wrap: break-word;
      font-weight: bold;
      font-style: normal;
    }
     .table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
      margin: 0;
    }
    [dir=ltr] .table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
      float: left;
      text-align: right;
      padding: 0 calc(1rem / 2) 0 0;
    }
    [dir=rtl] .table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
      float: right;
      text-align: left;
      padding: 0 0 0 calc(1rem / 2);
    }
    .table.b-table.b-table-stacked > tbody > tr > [data-label]::after {
      display: block;
      content: "";
    }
     .table.b-table.b-table-stacked > tbody > tr > [data-label]::after {
      clear: both;
    }
    .table.b-table.b-table-stacked > tbody > tr > [data-label] > div {
      display: inline-block;
      width: calc(100% - 40%);
    }
     .table.b-table.b-table-stacked > tbody > tr > [data-label] > div {
      margin: 0;
    }
    [dir=ltr] .table.b-table.b-table-stacked > tbody > tr > [data-label] > div {
      padding: 0 0 0 calc(1rem / 2);
    }
    [dir=rtl] .table.b-table.b-table-stacked > tbody > tr > [data-label] > div {
      padding: 0 calc(1rem / 2) 0 0;
    }
    .table.b-table.b-table-stacked > tbody > tr.top-row, .table.b-table.b-table-stacked > tbody > tr.bottom-row {
      display: none;
    }
     .table.b-table.b-table-stacked > tbody > tr > :first-child {
      border-top-width: 3px;
    }
     .table.b-table.b-table-stacked > tbody > tr > [rowspan] + td,  .table.b-table.b-table-stacked > tbody > tr > [rowspan] + th {
      border-top-width: 3px;
    }
    
    .b-time {
      min-width: 150px;
    }
    .b-time[aria-disabled=true] output, .b-time[aria-readonly=true] output,
    .b-time output.disabled {
      opacity: 1;
    }
     .b-time[aria-disabled=true] output,  .b-time[aria-readonly=true] output,  .b-time output.disabled {
      background-color: #efefef;
    }
    .b-time[aria-disabled=true] output {
      pointer-events: none;
    }
    [dir=rtl] .b-time > .d-flex:not(.flex-column) {
      flex-direction: row-reverse;
    }
    
     .b-time .b-time-header {
      margin-bottom: 0.5rem;
    }
    .b-time .b-time-header output {
      font-size: 80%;
    }
     .b-time .b-time-header output {
      padding: 0.25rem;
    }
     .b-time .b-time-footer {
      margin-top: 0.5rem;
    }
    [dir=ltr] .b-time .b-time-ampm {
      margin-left: 0.5rem;
    }
    [dir=rtl] .b-time .b-time-ampm {
      margin-right: 0.5rem;
    }
    
    .b-toast {
      display: block;
      position: relative;
      max-width: 380px;
      backface-visibility: hidden;
      z-index: 1;
    }
    
     .b-toast {
      background-clip: padding-box;
      border-radius: 0.286rem;
    }
     .b-toast .toast {
      background-color: rgba(255, 255, 255, 0.85);
    }
     .b-toast:not(:last-child) {
      margin-bottom: 1.14rem;
    }
     .b-toast.b-toast-solid .toast {
      background-color: white;
    }
    .b-toast .toast {
      opacity: 1;
    }
    .b-toast .toast.fade:not(.show) {
      opacity: 0;
    }
    .b-toast .toast .toast-body {
      display: block;
    }
    
    .b-toast-primary .toast {
      color: #193a69;
    }
    
     .b-toast-primary .toast {
      background-color: rgba(225, 233, 243, 0.85);
      border-color: rgba(188, 204, 228, 0.85);
    }
    .b-toast-primary .toast .toast-header {
      color: #193a69;
    }
     .b-toast-primary .toast .toast-header {
      background-color: rgba(207, 219, 236, 0.85);
      border-bottom-color: rgba(188, 204, 228, 0.85);
    }
     .b-toast-primary.b-toast-solid .toast {
      background-color: #e1e9f3;
    }
    
    .b-toast-secondary .toast {
      color: #61666c;
    }
    
     .b-toast-secondary .toast {
      background-color: rgba(248, 249, 249, 0.85);
      border-color: rgba(227, 228, 230, 0.85);
    }
    .b-toast-secondary .toast .toast-header {
      color: #61666c;
    }
     .b-toast-secondary .toast .toast-header {
      background-color: rgba(235, 236, 237, 0.85);
      border-bottom-color: rgba(227, 228, 230, 0.85);
    }
     .b-toast-secondary.b-toast-solid .toast {
      background-color: #f8f9f9;
    }
    
    .b-toast-success .toast {
      color: #1c7347;
    }
    
     .b-toast-success .toast {
      background-color: rgba(229, 247, 237, 0.85);
      border-color: rgba(190, 235, 210, 0.85);
    }
    .b-toast-success .toast .toast-header {
      color: #1c7347;
    }
     .b-toast-success .toast .toast-header {
      background-color: rgba(209, 241, 223, 0.85);
      border-bottom-color: rgba(190, 235, 210, 0.85);
    }
     .b-toast-success.b-toast-solid .toast {
      background-color: #e5f7ed;
    }
    
    .b-toast-info .toast {
      color: #107f8f;
    }
    
     .b-toast-info .toast {
      background-color: rgba(227, 250, 252, 0.85);
      border-color: rgba(184, 242, 249, 0.85);
    }
    .b-toast-info .toast .toast-header {
      color: #107f8f;
    }
     .b-toast-info .toast .toast-header {
      background-color: rgba(204, 245, 250, 0.85);
      border-bottom-color: rgba(184, 242, 249, 0.85);
    }
     .b-toast-info.b-toast-solid .toast {
      background-color: #e3fafc;
    }
    
    .b-toast-warning .toast {
      color: #947420;
    }
    
     .b-toast-warning .toast {
      background-color: rgba(255, 249, 234, 0.85);
      border-color: rgba(254, 235, 189, 0.85);
    }
    .b-toast-warning .toast .toast-header {
      color: #947420;
    }
     .b-toast-warning .toast .toast-header {
      background-color: rgba(255, 241, 208, 0.85);
      border-bottom-color: rgba(254, 235, 189, 0.85);
    }
     .b-toast-warning.b-toast-solid .toast {
      background-color: #fff9ea;
    }
    
    .b-toast-danger .toast {
      color: #8a3f43;
    }
    
     .b-toast-danger .toast {
      background-color: rgba(254, 244, 244, 0.85);
      border-color: rgba(249, 207, 207, 0.85);
    }
    .b-toast-danger .toast .toast-header {
      color: #8a3f43;
    }
     .b-toast-danger .toast .toast-header {
      background-color: rgba(251, 221, 221, 0.85);
      border-bottom-color: rgba(249, 207, 207, 0.85);
    }
     .b-toast-danger.b-toast-solid .toast {
      background-color: #fef4f4;
    }
    
    .b-toast-light .toast {
      color: #75787b;
    }
    
     .b-toast-light .toast {
      background-color: rgba(255, 255, 255, 0.85);
      border-color: rgba(238, 238, 238, 0.85);
    }
    .b-toast-light .toast .toast-header {
      color: #75787b;
    }
     .b-toast-light .toast .toast-header {
      background-color: rgba(243, 243, 243, 0.85);
      border-bottom-color: rgba(238, 238, 238, 0.85);
    }
     .b-toast-light.b-toast-solid .toast {
      background-color: white;
    }
    
    .b-toast-dark .toast {
      color: #373b3e;
    }
    
     .b-toast-dark .toast {
      background-color: rgba(232, 232, 232, 0.85);
      border-color: rgba(205, 205, 205, 0.85);
    }
    .b-toast-dark .toast .toast-header {
      color: #373b3e;
    }
     .b-toast-dark .toast .toast-header {
      background-color: rgba(219, 219, 219, 0.85);
      border-bottom-color: rgba(205, 205, 205, 0.85);
    }
     .b-toast-dark.b-toast-solid .toast {
      background-color: #e8e8e8;
    }
    
    .b-toaster {
      z-index: 1100;
    }
    .b-toaster .b-toaster-slot {
      position: relative;
      display: block;
    }
    .b-toaster .b-toaster-slot:empty {
      display: none !important;
    }
    
    .b-toaster.b-toaster-top-right, .b-toaster.b-toaster-top-left, .b-toaster.b-toaster-top-center, .b-toaster.b-toaster-top-full, .b-toaster.b-toaster-bottom-right, .b-toaster.b-toaster-bottom-left, .b-toaster.b-toaster-bottom-center, .b-toaster.b-toaster-bottom-full {
      position: fixed;
      height: 0;
      overflow: visible;
    }
    
     .b-toaster.b-toaster-top-right,  .b-toaster.b-toaster-top-left,  .b-toaster.b-toaster-top-center,  .b-toaster.b-toaster-top-full,  .b-toaster.b-toaster-bottom-right,  .b-toaster.b-toaster-bottom-left,  .b-toaster.b-toaster-bottom-center,  .b-toaster.b-toaster-bottom-full {
      margin: 0;
      padding: 0;
    }
    
    [dir=ltr] .b-toaster.b-toaster-top-right, [dir=ltr] .b-toaster.b-toaster-top-left, [dir=ltr] .b-toaster.b-toaster-top-center, [dir=ltr] .b-toaster.b-toaster-top-full, [dir=ltr] .b-toaster.b-toaster-bottom-right, [dir=ltr] .b-toaster.b-toaster-bottom-left, [dir=ltr] .b-toaster.b-toaster-bottom-center, [dir=ltr] .b-toaster.b-toaster-bottom-full {
      left: 0.5rem;
      right: 0.5rem;
    }
    
    [dir=rtl] .b-toaster.b-toaster-top-right, [dir=rtl] .b-toaster.b-toaster-top-left, [dir=rtl] .b-toaster.b-toaster-top-center, [dir=rtl] .b-toaster.b-toaster-top-full, [dir=rtl] .b-toaster.b-toaster-bottom-right, [dir=rtl] .b-toaster.b-toaster-bottom-left, [dir=rtl] .b-toaster.b-toaster-bottom-center, [dir=rtl] .b-toaster.b-toaster-bottom-full {
      right: 0.5rem;
      left: 0.5rem;
    }
    .b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-top-full .b-toaster-slot, .b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {
      position: absolute;
      max-width: 380px;
      width: 100%;
      /* IE 11 fix */
    }
     .b-toaster.b-toaster-top-right .b-toaster-slot,  .b-toaster.b-toaster-top-left .b-toaster-slot,  .b-toaster.b-toaster-top-center .b-toaster-slot,  .b-toaster.b-toaster-top-full .b-toaster-slot,  .b-toaster.b-toaster-bottom-right .b-toaster-slot,  .b-toaster.b-toaster-bottom-left .b-toaster-slot,  .b-toaster.b-toaster-bottom-center .b-toaster-slot,  .b-toaster.b-toaster-bottom-full .b-toaster-slot {
      padding: 0;
      margin: 0;
    }
    [dir=ltr] .b-toaster.b-toaster-top-right .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-top-left .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-top-center .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-top-full .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-bottom-right .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-bottom-left .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-bottom-center .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-bottom-full .b-toaster-slot {
      left: 0;
      right: 0;
    }
    [dir=rtl] .b-toaster.b-toaster-top-right .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-top-left .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-top-center .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-top-full .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-bottom-right .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-bottom-left .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-bottom-center .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-bottom-full .b-toaster-slot {
      right: 0;
      left: 0;
    }
    .b-toaster.b-toaster-top-full .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {
      width: 100%;
      max-width: 100%;
    }
    .b-toaster.b-toaster-top-full .b-toaster-slot .b-toast,
    .b-toaster.b-toaster-top-full .b-toaster-slot .toast, .b-toaster.b-toaster-bottom-full .b-toaster-slot .b-toast,
    .b-toaster.b-toaster-bottom-full .b-toaster-slot .toast {
      width: 100%;
      max-width: 100%;
    }
    .b-toaster.b-toaster-top-right, .b-toaster.b-toaster-top-left, .b-toaster.b-toaster-top-center, .b-toaster.b-toaster-top-full {
      top: 0;
    }
    .b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-top-full .b-toaster-slot {
      top: 0.5rem;
    }
    .b-toaster.b-toaster-bottom-right, .b-toaster.b-toaster-bottom-left, .b-toaster.b-toaster-bottom-center, .b-toaster.b-toaster-bottom-full {
      bottom: 0;
    }
    .b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {
      bottom: 0.5rem;
    }
    [dir=ltr] .b-toaster.b-toaster-top-right .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-bottom-right .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-top-center .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-bottom-center .b-toaster-slot {
      margin-left: auto;
    }
    [dir=rtl] .b-toaster.b-toaster-top-right .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-bottom-right .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-top-center .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-bottom-center .b-toaster-slot {
      margin-right: auto;
    }
    [dir=ltr] .b-toaster.b-toaster-top-left .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-bottom-left .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-top-center .b-toaster-slot, [dir=ltr] .b-toaster.b-toaster-bottom-center .b-toaster-slot {
      margin-right: auto;
    }
    [dir=rtl] .b-toaster.b-toaster-top-left .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-bottom-left .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-top-center .b-toaster-slot, [dir=rtl] .b-toaster.b-toaster-bottom-center .b-toaster-slot {
      margin-left: auto;
    }
    
    .b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-right .b-toast.b-toaster-move, .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-move, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-move, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-move {
      transition: transform 0.175s;
    }
     .b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-to .toast.fade,  .b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-active .toast.fade,  .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-to .toast.fade,  .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-active .toast.fade,  .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-to .toast.fade,  .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-active .toast.fade,  .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-to .toast.fade,  .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-active .toast.fade {
      transition-delay: 0.175s;
    }
    .b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active {
      position: absolute;
    }
     .b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active,  .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active,  .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active,  .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active {
      transition-delay: 0.175s;
    }
     .b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active .toast.fade,  .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active .toast.fade,  .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active .toast.fade,  .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active .toast.fade {
      transition-delay: 0s;
    }
    .tooltip.b-tooltip {
      display: block;
      opacity: 1;
      outline: 0;
    }
    .tooltip.b-tooltip.fade:not(.show) {
      opacity: 0;
    }
    .tooltip.b-tooltip.show {
      opacity: 1;
    }
    .tooltip.b-tooltip.noninteractive {
      pointer-events: none;
    }
     .tooltip.b-tooltip .arrow {
      margin: 0 0.358rem;
    }
     .tooltip.b-tooltip.bs-tooltip-right .arrow,  .tooltip.b-tooltip.bs-tooltip-auto[x-placement^=right] .arrow,  .tooltip.b-tooltip.bs-tooltip-left .arrow,  .tooltip.b-tooltip.bs-tooltip-auto[x-placement^=left] .arrow {
      margin: 0.358rem 0;
    }
    
     .tooltip.b-tooltip-primary.bs-tooltip-top .arrow::before,  .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=top] .arrow::before {
      border-top-color: #114a9f;
    }
    [dir=ltr] .tooltip.b-tooltip-primary.bs-tooltip-right .arrow::before, [dir=ltr] .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-right-color: #114a9f;
    }
    [dir=rtl] .tooltip.b-tooltip-primary.bs-tooltip-right .arrow::before, [dir=rtl] .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-left-color: #114a9f;
    }
     .tooltip.b-tooltip-primary.bs-tooltip-bottom .arrow::before,  .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #114a9f;
    }
    [dir=ltr] .tooltip.b-tooltip-primary.bs-tooltip-left .arrow::before, [dir=ltr] .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-left-color: #114a9f;
    }
    [dir=rtl] .tooltip.b-tooltip-primary.bs-tooltip-left .arrow::before, [dir=rtl] .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-right-color: #114a9f;
    }
    .tooltip.b-tooltip-primary .tooltip-inner {
      color: #fff;
    }
     .tooltip.b-tooltip-primary .tooltip-inner {
      background-color: #114a9f;
    }
    
     .tooltip.b-tooltip-secondary.bs-tooltip-top .arrow::before,  .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=top] .arrow::before {
      border-top-color: #9c9ea4;
    }
    [dir=ltr] .tooltip.b-tooltip-secondary.bs-tooltip-right .arrow::before, [dir=ltr] .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-right-color: #9c9ea4;
    }
    [dir=rtl] .tooltip.b-tooltip-secondary.bs-tooltip-right .arrow::before, [dir=rtl] .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-left-color: #9c9ea4;
    }
     .tooltip.b-tooltip-secondary.bs-tooltip-bottom .arrow::before,  .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #9c9ea4;
    }
    [dir=ltr] .tooltip.b-tooltip-secondary.bs-tooltip-left .arrow::before, [dir=ltr] .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-left-color: #9c9ea4;
    }
    [dir=rtl] .tooltip.b-tooltip-secondary.bs-tooltip-left .arrow::before, [dir=rtl] .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-right-color: #9c9ea4;
    }
    .tooltip.b-tooltip-secondary .tooltip-inner {
      color: #2a2e30;
    }
     .tooltip.b-tooltip-secondary .tooltip-inner {
      background-color: #9c9ea4;
    }
    
     .tooltip.b-tooltip-success.bs-tooltip-top .arrow::before,  .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=top] .arrow::before {
      border-top-color: #17b75e;
    }
    [dir=ltr] .tooltip.b-tooltip-success.bs-tooltip-right .arrow::before, [dir=ltr] .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-right-color: #17b75e;
    }
    [dir=rtl] .tooltip.b-tooltip-success.bs-tooltip-right .arrow::before, [dir=rtl] .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-left-color: #17b75e;
    }
     .tooltip.b-tooltip-success.bs-tooltip-bottom .arrow::before,  .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #17b75e;
    }
    [dir=ltr] .tooltip.b-tooltip-success.bs-tooltip-left .arrow::before, [dir=ltr] .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-left-color: #17b75e;
    }
    [dir=rtl] .tooltip.b-tooltip-success.bs-tooltip-left .arrow::before, [dir=rtl] .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-right-color: #17b75e;
    }
    .tooltip.b-tooltip-success .tooltip-inner {
      color: #fff;
    }
     .tooltip.b-tooltip-success .tooltip-inner {
      background-color: #17b75e;
    }
    
     .tooltip.b-tooltip-info.bs-tooltip-top .arrow::before,  .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=top] .arrow::before {
      border-top-color: #00cfe8;
    }
    [dir=ltr] .tooltip.b-tooltip-info.bs-tooltip-right .arrow::before, [dir=ltr] .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-right-color: #00cfe8;
    }
    [dir=rtl] .tooltip.b-tooltip-info.bs-tooltip-right .arrow::before, [dir=rtl] .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-left-color: #00cfe8;
    }
     .tooltip.b-tooltip-info.bs-tooltip-bottom .arrow::before,  .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #00cfe8;
    }
    [dir=ltr] .tooltip.b-tooltip-info.bs-tooltip-left .arrow::before, [dir=ltr] .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-left-color: #00cfe8;
    }
    [dir=rtl] .tooltip.b-tooltip-info.bs-tooltip-left .arrow::before, [dir=rtl] .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-right-color: #00cfe8;
    }
    .tooltip.b-tooltip-info .tooltip-inner {
      color: #fff;
    }
     .tooltip.b-tooltip-info .tooltip-inner {
      background-color: #00cfe8;
    }
    
     .tooltip.b-tooltip-warning.bs-tooltip-top .arrow::before,  .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=top] .arrow::before {
      border-top-color: #fdb913;
    }
    [dir=ltr] .tooltip.b-tooltip-warning.bs-tooltip-right .arrow::before, [dir=ltr] .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-right-color: #fdb913;
    }
    [dir=rtl] .tooltip.b-tooltip-warning.bs-tooltip-right .arrow::before, [dir=rtl] .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-left-color: #fdb913;
    }
     .tooltip.b-tooltip-warning.bs-tooltip-bottom .arrow::before,  .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #fdb913;
    }
    [dir=ltr] .tooltip.b-tooltip-warning.bs-tooltip-left .arrow::before, [dir=ltr] .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-left-color: #fdb913;
    }
    [dir=rtl] .tooltip.b-tooltip-warning.bs-tooltip-left .arrow::before, [dir=rtl] .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-right-color: #fdb913;
    }
    .tooltip.b-tooltip-warning .tooltip-inner {
      color: #2a2e30;
    }
     .tooltip.b-tooltip-warning .tooltip-inner {
      background-color: #fdb913;
    }
    
     .tooltip.b-tooltip-danger.bs-tooltip-top .arrow::before,  .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=top] .arrow::before {
      border-top-color: #ea5455;
    }
    [dir=ltr] .tooltip.b-tooltip-danger.bs-tooltip-right .arrow::before, [dir=ltr] .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-right-color: #ea5455;
    }
    [dir=rtl] .tooltip.b-tooltip-danger.bs-tooltip-right .arrow::before, [dir=rtl] .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-left-color: #ea5455;
    }
     .tooltip.b-tooltip-danger.bs-tooltip-bottom .arrow::before,  .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #ea5455;
    }
    [dir=ltr] .tooltip.b-tooltip-danger.bs-tooltip-left .arrow::before, [dir=ltr] .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-left-color: #ea5455;
    }
    [dir=rtl] .tooltip.b-tooltip-danger.bs-tooltip-left .arrow::before, [dir=rtl] .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-right-color: #ea5455;
    }
    .tooltip.b-tooltip-danger .tooltip-inner {
      color: #fff;
    }
     .tooltip.b-tooltip-danger .tooltip-inner {
      background-color: #ea5455;
    }
    
     .tooltip.b-tooltip-light.bs-tooltip-top .arrow::before,  .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=top] .arrow::before {
      border-top-color: #c1c1c1;
    }
    [dir=ltr] .tooltip.b-tooltip-light.bs-tooltip-right .arrow::before, [dir=ltr] .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-right-color: #c1c1c1;
    }
    [dir=rtl] .tooltip.b-tooltip-light.bs-tooltip-right .arrow::before, [dir=rtl] .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-left-color: #c1c1c1;
    }
     .tooltip.b-tooltip-light.bs-tooltip-bottom .arrow::before,  .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #c1c1c1;
    }
    [dir=ltr] .tooltip.b-tooltip-light.bs-tooltip-left .arrow::before, [dir=ltr] .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-left-color: #c1c1c1;
    }
    [dir=rtl] .tooltip.b-tooltip-light.bs-tooltip-left .arrow::before, [dir=rtl] .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-right-color: #c1c1c1;
    }
    .tooltip.b-tooltip-light .tooltip-inner {
      color: #2a2e30;
    }
     .tooltip.b-tooltip-light .tooltip-inner {
      background-color: #c1c1c1;
    }
    
     .tooltip.b-tooltip-dark.bs-tooltip-top .arrow::before,  .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=top] .arrow::before {
      border-top-color: #4b4b4b;
    }
    [dir=ltr] .tooltip.b-tooltip-dark.bs-tooltip-right .arrow::before, [dir=ltr] .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-right-color: #4b4b4b;
    }
    [dir=rtl] .tooltip.b-tooltip-dark.bs-tooltip-right .arrow::before, [dir=rtl] .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=right] .arrow::before {
      border-left-color: #4b4b4b;
    }
     .tooltip.b-tooltip-dark.bs-tooltip-bottom .arrow::before,  .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #4b4b4b;
    }
    [dir=ltr] .tooltip.b-tooltip-dark.bs-tooltip-left .arrow::before, [dir=ltr] .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-left-color: #4b4b4b;
    }
    [dir=rtl] .tooltip.b-tooltip-dark.bs-tooltip-left .arrow::before, [dir=rtl] .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=left] .arrow::before {
      border-right-color: #4b4b4b;
    }
    .tooltip.b-tooltip-dark .tooltip-inner {
      color: #fff;
    }
     .tooltip.b-tooltip-dark .tooltip-inner {
      background-color: #4b4b4b;
    }
    
    .b-icon.bi {
      display: inline-block;
      overflow: visible;
      vertical-align: -0.15em;
    }
     .b-icon.b-icon-animation-cylon,  .b-icon.b-iconstack .b-icon-animation-cylon > g {
      transform-origin: center;
    }
    [dir=ltr] .b-icon.b-icon-animation-cylon, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-cylon > g {
      animation: 0.75s infinite ease-in-out alternate b-icon-animation-cylon-ltr ;
    }
    [dir=rtl] .b-icon.b-icon-animation-cylon, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-cylon > g {
      animation: 0.75s infinite ease-in-out alternate b-icon-animation-cylon-rtl ;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .b-icon.b-icon-animation-cylon, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-cylon > g {
        animation: none;
      }
      [dir=rtl] .b-icon.b-icon-animation-cylon, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-cylon > g {
        animation: none;
      }
    }
     .b-icon.b-icon-animation-cylon-vertical,  .b-icon.b-iconstack .b-icon-animation-cylon-vertical > g {
      transform-origin: center;
    }
    [dir=ltr] .b-icon.b-icon-animation-cylon-vertical, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-cylon-vertical > g {
      animation: 0.75s infinite ease-in-out alternate b-icon-animation-cylon-vertical;
    }
    [dir=rtl] .b-icon.b-icon-animation-cylon-vertical, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-cylon-vertical > g {
      animation: 0.75s infinite ease-in-out alternate b-icon-animation-cylon-vertical;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .b-icon.b-icon-animation-cylon-vertical, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-cylon-vertical > g {
        animation: none;
      }
      [dir=rtl] .b-icon.b-icon-animation-cylon-vertical, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-cylon-vertical > g {
        animation: none;
      }
    }
     .b-icon.b-icon-animation-fade,  .b-icon.b-iconstack .b-icon-animation-fade > g {
      transform-origin: center;
    }
    [dir=ltr] .b-icon.b-icon-animation-fade, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-fade > g {
      animation: 0.75s infinite ease-in-out alternate b-icon-animation-fade;
    }
    [dir=rtl] .b-icon.b-icon-animation-fade, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-fade > g {
      animation: 0.75s infinite ease-in-out alternate b-icon-animation-fade;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .b-icon.b-icon-animation-fade, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-fade > g {
        animation: none;
      }
      [dir=rtl] .b-icon.b-icon-animation-fade, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-fade > g {
        animation: none;
      }
    }
     .b-icon.b-icon-animation-spin,  .b-icon.b-iconstack .b-icon-animation-spin > g {
      transform-origin: center;
    }
    [dir=ltr] .b-icon.b-icon-animation-spin, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-spin > g {
      animation: 2s infinite linear normal b-icon-animation-spin-ltr ;
    }
    [dir=rtl] .b-icon.b-icon-animation-spin, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-spin > g {
      animation: 2s infinite linear normal b-icon-animation-spin-rtl ;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .b-icon.b-icon-animation-spin, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-spin > g {
        animation: none;
      }
      [dir=rtl] .b-icon.b-icon-animation-spin, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-spin > g {
        animation: none;
      }
    }
     .b-icon.b-icon-animation-spin-reverse,  .b-icon.b-iconstack .b-icon-animation-spin-reverse > g {
      transform-origin: center;
    }
    [dir=ltr] .b-icon.b-icon-animation-spin-reverse, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-spin-reverse > g {
      animation: 2s infinite linear reverse b-icon-animation-spin-ltr ;
    }
    [dir=rtl] .b-icon.b-icon-animation-spin-reverse, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-spin-reverse > g {
      animation: 2s infinite linear reverse b-icon-animation-spin-rtl ;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .b-icon.b-icon-animation-spin-reverse, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-spin-reverse > g {
        animation: none;
      }
      [dir=rtl] .b-icon.b-icon-animation-spin-reverse, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-spin-reverse > g {
        animation: none;
      }
    }
     .b-icon.b-icon-animation-spin-pulse,  .b-icon.b-iconstack .b-icon-animation-spin-pulse > g {
      transform-origin: center;
    }
    [dir=ltr] .b-icon.b-icon-animation-spin-pulse, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-spin-pulse > g {
      animation: 1s infinite steps(8) normal b-icon-animation-spin-ltr ;
    }
    [dir=rtl] .b-icon.b-icon-animation-spin-pulse, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-spin-pulse > g {
      animation: 1s infinite steps(8) normal b-icon-animation-spin-rtl ;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .b-icon.b-icon-animation-spin-pulse, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-spin-pulse > g {
        animation: none;
      }
      [dir=rtl] .b-icon.b-icon-animation-spin-pulse, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-spin-pulse > g {
        animation: none;
      }
    }
     .b-icon.b-icon-animation-spin-reverse-pulse,  .b-icon.b-iconstack .b-icon-animation-spin-reverse-pulse > g {
      transform-origin: center;
    }
    [dir=ltr] .b-icon.b-icon-animation-spin-reverse-pulse, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-spin-reverse-pulse > g {
      animation: 1s infinite steps(8) reverse b-icon-animation-spin-ltr ;
    }
    [dir=rtl] .b-icon.b-icon-animation-spin-reverse-pulse, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-spin-reverse-pulse > g {
      animation: 1s infinite steps(8) reverse b-icon-animation-spin-rtl ;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .b-icon.b-icon-animation-spin-reverse-pulse, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-spin-reverse-pulse > g {
        animation: none;
      }
      [dir=rtl] .b-icon.b-icon-animation-spin-reverse-pulse, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-spin-reverse-pulse > g {
        animation: none;
      }
    }
     .b-icon.b-icon-animation-throb,  .b-icon.b-iconstack .b-icon-animation-throb > g {
      transform-origin: center;
    }
    [dir=ltr] .b-icon.b-icon-animation-throb, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-throb > g {
      animation: 0.75s infinite ease-in-out alternate b-icon-animation-throb;
    }
    [dir=rtl] .b-icon.b-icon-animation-throb, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-throb > g {
      animation: 0.75s infinite ease-in-out alternate b-icon-animation-throb;
    }
    @media (prefers-reduced-motion: reduce) {
      [dir=ltr] .b-icon.b-icon-animation-throb, [dir=ltr] .b-icon.b-iconstack .b-icon-animation-throb > g {
        animation: none;
      }
      [dir=rtl] .b-icon.b-icon-animation-throb, [dir=rtl] .b-icon.b-iconstack .b-icon-animation-throb > g {
        animation: none;
      }
    }
    
    @keyframes b-icon-animation-cylon-ltr {
      0% {
        transform: translateX(-25%);
      }
      100% {
        transform: translateX(25%);
      }
    }
    
    @keyframes b-icon-animation-cylon-rtl {
      0% {
        transform: translateX(25%);
      }
      100% {
        transform: translateX(-25%);
      }
    }
    @keyframes b-icon-animation-cylon-vertical {
      0% {
        transform: translateY(25%);
      }
      100% {
        transform: translateY(-25%);
      }
    }
    @keyframes b-icon-animation-fade {
      0% {
        opacity: 0.1;
      }
      100% {
        opacity: 1;
      }
    }
    @keyframes b-icon-animation-spin-ltr {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(359deg);
      }
    }
    @keyframes b-icon-animation-spin-rtl {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-359deg);
      }
    }
    @keyframes b-icon-animation-throb {
      0% {
        opacity: 0.5;
        transform: scale(0.5);
      }
      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
    .btn .b-icon.bi,
    .nav-link .b-icon.bi,
    .dropdown-toggle .b-icon.bi,
    .dropdown-item .b-icon.bi,
    .input-group-text .b-icon.bi {
      font-size: 125%;
      vertical-align: text-bottom;
    }
    
    @keyframes tab-panel-slide-in-ltr {
      0% {
        opacity: 0;
        transform: translateX(100%);
      }
      100% {
        opacity: 1;
        transform: translateX(0%);
      }
    }
    
    @keyframes tab-panel-slide-in-rtl {
      0% {
        opacity: 0;
        transform: translateX(-100%);
      }
      100% {
        opacity: 1;
        transform: translateX(0%);
      }
    }
    @keyframes tab-panel-slide-up {
      0% {
        opacity: 0;
        transform: translateY(100%);
      }
      100% {
        opacity: 1;
        transform: translateY(0%);
      }
    }
    @keyframes rubberBand {
      from {
        transform: scale3d(1, 1, 1);
      }
      30% {
        transform: scale3d(1.25, 0.75, 1);
      }
      50% {
        transform: scale3d(1.15, 0.85, 1);
      }
      75% {
        transform: scale3d(1.05, 0.95, 1);
      }
      to {
        transform: scale3d(1, 1, 1);
      }
    }
    body {
      overflow-x: hidden;
    }
    
    .nav-item.has-sub .nav-item.has-sub li svg {
      display: none;
    }
    
    [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .badge.badge-up, [dir=ltr] .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .badge.badge-up {
      right: -9px;
    }
    
    [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .badge.badge-up, [dir=rtl] .header-navbar .navbar-container ul.navbar-nav li.dropdown-notification .badge.badge-up {
      left: -9px;
    }
    
    .horizontal-menu .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
     .horizontal-menu .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-thumb {
      background: #adb5bd;
      border-radius: 20px;
    }
     .horizontal-menu .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-track {
      background: #dae1e7;
      border-radius: 30px;
    }
    
     .dark-layout .horizontal-layout.navbar-sticky .navbar.header-navbar {
      box-shadow: none;
    }
    
     body.dark-layout .b-avatar.badge-secondary {
      background-color: #161d31;
    }
    body.dark-layout .b-avatar .b-avatar-text span {
      color: #fff;
    }
    body.dark-layout .b-avatar .avatar-icon {
      color: #fff;
    }
     body.dark-layout .b-avatar.avatar-border-2 img {
      border-color: #3b4253;
    }
     body.dark-layout .b-avatar-group .b-avatar-group-inner .b-avatar {
      box-shadow: 0 0 0 2px #283046, inset 0 0 0 1px rgba(40, 48, 70, 0.07);
    }
    body.dark-layout .badge {
      color: #fff;
    }
    body.dark-layout .header-navbar.navbar-light .navbar-brand {
      color: #fff;
    }
     body.dark-layout .b-aspect {
      border-color: #3b4253;
    }
     body.dark-layout .popover.b-popover.bs-popover-top .arrow::before,  body.dark-layout .popover.b-popover.bs-popover-auto[x-placement^=top] .arrow::before {
      border-top-color: #3b4253;
    }
     body.dark-layout .popover.b-popover.bs-popover-top .arrow::after,  body.dark-layout .popover.b-popover.bs-popover-auto[x-placement^=top] .arrow::after {
      border-top-color: #283046;
    }
    [dir=ltr] body.dark-layout .popover.b-popover.bs-popover-left .arrow::before, [dir=ltr] body.dark-layout .popover.b-popover.bs-popover-auto[x-placement^=left] .arrow::before {
      border-left-color: #3b4253;
    }
    [dir=rtl] body.dark-layout .popover.b-popover.bs-popover-left .arrow::before, [dir=rtl] body.dark-layout .popover.b-popover.bs-popover-auto[x-placement^=left] .arrow::before {
      border-right-color: #3b4253;
    }
    [dir=ltr] body.dark-layout .popover.b-popover.bs-popover-left .arrow::after, [dir=ltr] body.dark-layout .popover.b-popover.bs-popover-auto[x-placement^=left] .arrow::after {
      border-left-color: #283046;
    }
    [dir=rtl] body.dark-layout .popover.b-popover.bs-popover-left .arrow::after, [dir=rtl] body.dark-layout .popover.b-popover.bs-popover-auto[x-placement^=left] .arrow::after {
      border-right-color: #283046;
    }
    [dir=ltr] body.dark-layout .popover.b-popover.bs-popover-right .arrow::before, [dir=ltr] body.dark-layout .popover.b-popover.bs-popover-auto[x-placement^=right] .arrow::before {
      border-right-color: #3b4253;
    }
    [dir=rtl] body.dark-layout .popover.b-popover.bs-popover-right .arrow::before, [dir=rtl] body.dark-layout .popover.b-popover.bs-popover-auto[x-placement^=right] .arrow::before {
      border-left-color: #3b4253;
    }
    [dir=ltr] body.dark-layout .popover.b-popover.bs-popover-right .arrow::after, [dir=ltr] body.dark-layout .popover.b-popover.bs-popover-auto[x-placement^=right] .arrow::after {
      border-right-color: #283046;
    }
    [dir=rtl] body.dark-layout .popover.b-popover.bs-popover-right .arrow::after, [dir=rtl] body.dark-layout .popover.b-popover.bs-popover-auto[x-placement^=right] .arrow::after {
      border-left-color: #283046;
    }
     body.dark-layout .custom-range {
      background-color: #283046;
      border-color: #3b4253;
    }
     body.dark-layout .custom-range:focus {
      background-color: #283046;
      border-color: #114A9F;
    }
    body.dark-layout .modal-content .modal-header .close {
      color: #fff;
    }
    body.dark-layout .modal-content .modal-body {
      color: #fff;
    }
     body.dark-layout .custom-switch.switch-lg .custom-control-label::before,  body.dark-layout .custom-switch.switch-md .custom-control-label::before {
      background-color: #161d31;
    }
    body.dark-layout .pagination .page-item.disabled .page-link {
      color: #676d7d !important;
    }
    body.dark-layout .b-toast .toast {
      color: #b4b7bd;
    }
     body.dark-layout .b-toast .toast {
      background-color: rgba(22, 29, 49, 0.85);
    }
    body.dark-layout .b-calendar-header output {
      color: #b4b7bd;
    }
     body.dark-layout .b-calendar-header output {
      background: #161d31;
      border-color: #3b4253;
    }
     body.dark-layout .b-calendar-grid.form-control {
      background: #161d31;
      border-color: #3b4253;
    }
    body.dark-layout .b-calendar-grid.form-control .b-calendar-grid-caption {
      color: #b4b7bd;
    }
     body.dark-layout .b-calendar-grid.form-control .small {
      background: #161d31;
    }
     body.dark-layout .b-calendar-grid.form-control .bg-light {
      background-color: #3b4253 !important;
    }
    body.dark-layout .b-calendar-grid.form-control .table-info span {
      color: #22292f !important;
    }
     body.dark-layout .b-calendar-grid .b-calendar-grid-body .col:not(.table-info) span.btn.rounded-circle:hover {
      background-color: #283046;
    }
    body.dark-layout .b-calendar-grid .btn-light {
      color: #b4b7bd;
    }
     body.dark-layout .b-calendar-grid .btn-light {
      background-color: #283046;
      border-color: #3b4253;
    }
     body.dark-layout .b-calendar-grid .table-primary .btn-outline-light:hover,  body.dark-layout .b-calendar-grid .table-primary > th .btn-outline-light:hover,  body.dark-layout .b-calendar-grid .table-primary > td .btn-outline-light:hover {
      background-color: #161d31 !important;
    }
     .dark-layout body.dark-layout .b-calendar-grid .table.b-table thead > tr > [aria-sort=none],  .dark-layout body.dark-layout .b-calendar-grid .table.b-table tfoot > tr > [aria-sort=none] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Earrow-dark%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-259.000000, -621.000000)' stroke='%23747A88' stroke-width='2'%3E%3Cg id='arrow-dark' transform='translate(260.000000, 622.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
     body.dark-layout .b-calendar-grid .table.b-table thead > tr > [aria-sort=ascending],  body.dark-layout .b-calendar-grid .table.b-table tfoot > tr > [aria-sort=ascending] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Eactive-up-dark%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-199.000000, -621.000000)' stroke-width='2'%3E%3Cg id='active-up-dark' transform='translate(200.000000, 622.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)' stroke='%23747A88'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up' stroke='%23B4B7BC'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
     body.dark-layout .b-calendar-grid .table.b-table thead > tr > [aria-sort=descending],  body.dark-layout .b-calendar-grid .table.b-table tfoot > tr > [aria-sort=descending] {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14px' height='26px' viewBox='0 0 14 26' version='1.1'%3E%3Ctitle%3Eactive-dow-dark%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cg id='Artboard' transform='translate(-229.000000, -621.000000)' stroke-width='2'%3E%3Cg id='active-dow-dark' transform='translate(230.000000, 622.000000)'%3E%3Cg id='chevron-down' transform='translate(0.000000, 18.000000)' stroke='%23B4B7BC'%3E%3Cpolyline id='Path' points='0 0 6 6 12 0'/%3E%3C/g%3E%3Cg id='chevron-up' stroke='%23747A88'%3E%3Cpolyline id='Path' points='12 6 6 0 0 6'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }
    body.dark-layout .b-calendar-grid .b-table .table-white {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table .table-white td {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-white, body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-white {
      color: #fff !important;
    }
     body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-white,  body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-white {
      background-color: rgba(255, 255, 255, 0.3);
    }
    body.dark-layout .b-calendar-grid .b-table .table-black {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table .table-black td {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-black, body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-black {
      color: #fff !important;
    }
     body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-black,  body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-black {
      background-color: rgba(0, 0, 0, 0.3);
    }
    body.dark-layout .b-calendar-grid .b-table .table-dark {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table .table-dark td {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-dark, body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-dark {
      color: #fff !important;
    }
     body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-dark,  body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-dark {
      background-color: rgba(75, 75, 75, 0.3);
    }
    body.dark-layout .b-calendar-grid .b-table .table-light {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table .table-light td {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-light, body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-light {
      color: #fff !important;
    }
     body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-light,  body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-light {
      background-color: rgba(193, 193, 193, 0.3);
    }
    body.dark-layout .b-calendar-grid .b-table .table-primary {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table .table-primary td {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-primary, body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-primary {
      color: #fff !important;
    }
     body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-primary,  body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-primary {
      background-color: rgba(17, 74, 159, 0.3);
    }
    body.dark-layout .b-calendar-grid .b-table .table-secondary {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table .table-secondary td {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-secondary, body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-secondary {
      color: #fff !important;
    }
     body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-secondary,  body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-secondary {
      background-color: rgba(156, 158, 164, 0.3);
    }
    body.dark-layout .b-calendar-grid .b-table .table-success {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table .table-success td {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-success, body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-success {
      color: #fff !important;
    }
     body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-success,  body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-success {
      background-color: rgba(23, 183, 94, 0.3);
    }
    body.dark-layout .b-calendar-grid .b-table .table-info {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table .table-info td {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-info, body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-info {
      color: #fff !important;
    }
     body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-info,  body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-info {
      background-color: rgba(0, 207, 232, 0.3);
    }
    body.dark-layout .b-calendar-grid .b-table .table-warning {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table .table-warning td {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-warning, body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-warning {
      color: #fff !important;
    }
     body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-warning,  body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-warning {
      background-color: rgba(253, 185, 19, 0.3);
    }
    body.dark-layout .b-calendar-grid .b-table .table-danger {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table .table-danger td {
      color: #424244 !important;
    }
    body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-danger, body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-danger {
      color: #fff !important;
    }
     body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr th.table-danger,  body.dark-layout .b-calendar-grid .b-table.table-hover tbody tr td.table-danger {
      background-color: rgba(234, 84, 85, 0.3);
    }
     body.dark-layout .b-time .b-time-header .form-control {
      background-color: #283046;
    }
     body.dark-layout .b-time[aria-disabled=true] output,  body.dark-layout .b-time[aria-readonly=true] output,  body.dark-layout .b-time output.disabled {
      background-color: #283046;
    }
    body.dark-layout .b-form-spinbutton.form-control {
      color: #b4b7bd;
    }
     body.dark-layout .b-form-spinbutton.form-control {
      background-color: #283046;
      border-color: #404656;
    }
    body.dark-layout .b-form-spinbutton.form-control svg {
      color: #b4b7bd;
    }
    body.dark-layout .b-rating.form-control {
      color: #b4b7bd;
    }
     body.dark-layout .b-rating.form-control {
      background-color: #283046;
      border-color: #404656;
    }
     body.dark-layout .b-rating.disabled,  body.dark-layout .b-rating:disabled {
      background-color: #24233a;
    }
     body.dark-layout .b-form-datepicker.form-control,  body.dark-layout .b-form-timepicker.form-control {
      background-color: #283046;
      border-color: #404656;
    }
     body.dark-layout .b-form-datepicker.is-valid,  body.dark-layout .b-form-timepicker.is-valid {
      border-color: #17B75E;
    }
     body.dark-layout .b-form-datepicker.is-invalid,  body.dark-layout .b-form-timepicker.is-invalid {
      border-color: #EA5455;
    }
     body.dark-layout .b-time-header output {
      border-color: #3b4253;
    }
    body.dark-layout .b-time-header output bdi {
      color: #b4b7bd;
    }
    body.dark-layout .b-form-tags.form-control {
      color: #b4b7bd;
    }
     body.dark-layout .b-form-tags.form-control {
      background-color: #283046;
      border-color: #404656;
      box-shadow: none;
    }
     body.dark-layout .b-form-tags.form-control .b-form-tags-list .b-form-tag .b-form-tag-remove {
      background-color: transparent !important;
      box-shadow: none !important;
    }
    body.dark-layout .b-form-tags-input {
      color: #b4b7bd;
    }
     body.dark-layout .was-validated .custom-control-input:invalid ~ .custom-control-label::before,  body.dark-layout .custom-control-input.is-invalid ~ .custom-control-label::before {
      border-color: #EA5455 !important;
    }
     body.dark-layout .was-validated .custom-control-input:valid ~ .custom-control-label::before,  body.dark-layout .custom-control-input.is-valid ~ .custom-control-label::before {
      border-color: #17B75E !important;
    }
     body.dark-layout .was-validated .custom-select:valid,  body.dark-layout .custom-select.is-valid {
      border-color: #17B75E;
    }
     body.dark-layout .was-validated .custom-select:invalid,  body.dark-layout .custom-select.is-invalid {
      border-color: #EA5455;
    }
    body.dark-layout pre {
      color: #b4b7bd;
    }
     body.dark-layout .b-sidebar.bg-white {
      background-color: #283046 !important;
    }
     body.dark-layout .b-sidebar .b-sidebar-body .content-sidebar-header {
      background-color: #161d31;
    }
     body.dark-layout .horizontal-menu .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-thumb {
      background: #161d31;
    }
     body.dark-layout .horizontal-menu .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-track {
      background: #3b4253;
    }
    
     .form-group.is-invalid .v-select .vs__dropdown-toggle {
      border-color: #EA5455;
    }
     .form-group.is-invalid .flatpickr-input {
      border-color: #EA5455;
    }
    
    .tooltip {
      top: 0;
    }
    [dir=rtl] body .ps__rail-y {
      right: auto !important;
      left: 1px !important;
    }
    [dir=rtl] .flatpickr-prev-month svg,
    [dir=rtl] .flatpickr-next-month svg {
      transform: rotate(180deg);
    }
    [dir=rtl] .faq-navigation .pricing-trial-img,
    [dir=rtl] .faq-navigation img,
    [dir=rtl] .pricing-free-trial .pricing-trial-img,
    [dir=rtl] .pricing-free-trial img {
      transform: scaleX(-1);
    }
    [dir=rtl] .b-aspect .b-aspect-sizer {
      flex-grow: 0 !important;
    }
    [dir=rtl] .carousel-control-prev-icon,
    [dir=rtl] .carousel-control-next-icon {
      transform: rotate(180deg);
    }
    [dir=rtl] .swiper-container-cube.swiper-container-rtl .swiper-slide {
      transform-origin: 100% 0 !important;
    }
    [dir=rtl] .swiper-container-rtl .swiper-button-prev {
      right: 10px !important;
      left: auto !important;
    }
    [dir=rtl] .swiper-container-rtl .swiper-button-next {
      left: 10px !important;
      right: auto !important;
    }
    [dir=rtl] .dropdown .btn-block + .dropdown-menu,
    [dir=rtl] .dropdown .btn-block + .dropdown-toggle-split + .dropdown-menu {
      left: 0 !important;
    }
    [dir=rtl] .pagination .page-item.next-item .page-link svg,
    [dir=rtl] .pagination .page-item .page-link svg {
      transform: rotate(180deg);
    }
    [dir=rtl] .popover {
      right: auto !important;
    }
    [dir=rtl] .progress-bar-animated {
      animation: progress-bar-stripes-rtl 40s linear infinite;
    }
    [dir=rtl] .b-time .b-time-ampm {
      margin-left: 0.5rem;
      margin-right: 0;
    }
    [dir=rtl] .b-form-timepicker .dropdown-menu {
      right: 100%;
    }
    [dir=rtl] .b-form-timepicker .dropdown-menu .b-time .b-time-ampm {
      margin-right: 0.5rem;
      margin-left: 0;
    }
    [dir=rtl] .input-group .input-group-append .b-form-timepicker .dropdown-menu {
      left: 100% !important;
      right: auto;
    }
    [dir=rtl] textarea {
      overflow-x: hidden;
    }
    [dir=rtl] .app-calendar .fc-header-toolbar .fc-prev-button,
    [dir=rtl] .app-calendar .fc-header-toolbar .fc-next-button {
      transform: rotate(180deg);
    }
    [dir=rtl] .fc-direction-rtl .fc-scroller-harness > .fc-scroller {
      direction: rtl !important;
    }
    [dir=rtl] .fc .fc-toolbar .fc-button-group .fc-dayGridMonth-button:first-child {
      border-top-left-radius: 0.357rem !important;
      border-bottom-left-radius: 0.357rem !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
    [dir=rtl] .fc .fc-toolbar .fc-button-group .fc-listMonth-button:last-child {
      border-top-right-radius: 0.357rem !important;
      border-bottom-right-radius: 0.357rem !important;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }
    .zoom-fade-enter-active,
    .zoom-fade-leave-active {
      transition: transform 0.35s, opacity 0.28s ease-in-out;
    }
    
    .zoom-fade-enter {
      opacity: 0;
    }
    
     .zoom-fade-enter {
      transform: scale(0.97);
    }
    
    .zoom-fade-leave-to {
      opacity: 0;
    }
    
     .zoom-fade-leave-to {
      transform: scale(1.03);
    }
    
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.28s ease-in-out;
    }
    
    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
    
    .slide-fade-enter-active,
    .slide-fade-leave-active {
      transition: opacity 0.35s, transform 0.4s;
    }
    
    .slide-fade-enter {
      opacity: 0;
    }
    
    [dir=ltr] .slide-fade-enter {
      transform: translateX(-30%);
    }
    
    [dir=rtl] .slide-fade-enter {
      transform: translateX(30%);
    }
    
    .slide-fade-leave-to {
      opacity: 0;
    }
    
    [dir=ltr] .slide-fade-leave-to {
      transform: translateX(30%);
    }
    
    [dir=rtl] .slide-fade-leave-to {
      transform: translateX(-30%);
    }
    
    .zoom-out-enter-active,
    .zoom-out-leave-active {
      transition: opacity 0.35s ease-in-out, transform 0.45s ease-out;
    }
    
    .zoom-out-enter,
    .zoom-out-leave-to {
      opacity: 0;
    }
    
     .zoom-out-enter,  .zoom-out-leave-to {
      transform: scale(0);
    }
    
    .fade-bottom-enter-active,
    .fade-bottom-leave-active {
      transition: opacity 0.3s, transform 0.35s;
    }
    
    .fade-bottom-enter {
      opacity: 0;
    }
    
     .fade-bottom-enter {
      transform: translateY(-8%);
    }
    
    .fade-bottom-leave-to {
      opacity: 0;
    }
    
     .fade-bottom-leave-to {
      transform: translateY(8%);
    }
    
    .fade-bottom-2x-enter-active,
    .fade-bottom-2x-leave-active {
      transition: opacity 0.2s, transform 0.25s;
    }
    
    .fade-bottom-2x-enter {
      opacity: 0;
    }
    
     .fade-bottom-2x-enter {
      transform: translateY(-4%);
    }
    
    .fade-bottom-2x-leave-to {
      opacity: 0;
    }
    
     .fade-bottom-2x-leave-to {
      transform: translateY(4%);
    }
    
    .fade-top-enter-active,
    .fade-top-leave-active {
      transition: opacity 0.3s, transform 0.35s;
    }
    
    .fade-top-enter {
      opacity: 0;
    }
    
     .fade-top-enter {
      transform: translateY(8%);
    }
    
    .fade-top-leave-to {
      opacity: 0;
    }
    
     .fade-top-leave-to {
      transform: translateY(-8%);
    }
    
    .fade-top-2x-enter-active,
    .fade-top-2x-leave-active {
      transition: opacity 0.2s, transform 0.25s;
    }
    
    .fade-top-2x-enter {
      opacity: 0;
    }
    
     .fade-top-2x-enter {
      transform: translateY(4%);
    }
    
    .fade-top-2x-leave-to {
      opacity: 0;
    }
    
     .fade-top-2x-leave-to {
      transform: translateY(-4%);
    }
    
    .list-leave-active {
      position: absolute;
    }
    
    .list-enter,
    .list-leave-to {
      opacity: 0;
    }
    
    [dir=ltr] .list-enter, [dir=ltr] .list-leave-to {
      transform: translateX(30px);
    }
    
    [dir=rtl] .list-enter, [dir=rtl] .list-leave-to {
      transform: translateX(-30px);
    }
    
    .list-enter-up-leave-active {
      transition: none !important;
    }
    
    .list-enter-up-enter {
      opacity: 0;
    }
    
     .list-enter-up-enter {
      transform: translateY(30px);
    }
    
    .alert {
      transition: all 0.25s ease;
    }
    
    .b-avatar {
      font-size: 0.857rem;
      font-weight: 600;
      color: #fff;
    }
    .b-avatar.badge-minimal .b-avatar-badge {
      min-height: 11px;
      min-width: 11px;
    }
     .b-avatar.badge-minimal .b-avatar-badge {
      border: 1px solid #fff;
    }
     .b-avatar.avatar-border-2 img {
      border: 2px solid #fff;
    }
    
     .b-avatar.btn:not(:disabled):not(.disabled):hover .b-avatar-img img,  .b-avatar[href]:not(:disabled):not(.disabled):hover .b-avatar-img img {
      transform: scale(1);
    }
    
    .b-avatar-group .b-avatar-group-inner .b-avatar {
      transition: all 0.25s ease 0s;
    }
    
     .b-avatar-group .b-avatar-group-inner .b-avatar {
      border-width: 0;
      box-shadow: 0 0 0 2px #fff, inset 0 0 0 1px rgba(34, 41, 47, 0.07);
      cursor: pointer;
    }
    .b-avatar-group .b-avatar-group-inner .b-avatar.pull-up:hover {
      transition: all 0.25s ease 0s;
    }
     .b-avatar-group .b-avatar-group-inner .b-avatar.pull-up:hover {
      transform: translateY(-4px) scale(1.07);
    }
    
    .b-avatar.badge-light-white {
      color: #ffffff;
    }
    
     .b-avatar.badge-light-white {
      background-color: rgba(255, 255, 255, 0.12);
    }
    
    .b-avatar.badge-light-black {
      color: #000000;
    }
    
     .b-avatar.badge-light-black {
      background-color: rgba(0, 0, 0, 0.12);
    }
    
    .b-avatar.badge-light-dark {
      color: #4B4B4B;
    }
    
     .b-avatar.badge-light-dark {
      background-color: rgba(75, 75, 75, 0.12);
    }
    
    .b-avatar.badge-light-light {
      color: #C1C1C1;
    }
    
     .b-avatar.badge-light-light {
      background-color: rgba(193, 193, 193, 0.12);
    }
    
    .b-avatar.badge-light-primary {
      color: #114A9F;
    }
    
     .b-avatar.badge-light-primary {
      background-color: rgba(17, 74, 159, 0.12);
    }
    
    .b-avatar.badge-light-secondary {
      color: #9C9EA4;
    }
    
     .b-avatar.badge-light-secondary {
      background-color: rgba(156, 158, 164, 0.12);
    }
    
    .b-avatar.badge-light-success {
      color: #17B75E;
    }
    
     .b-avatar.badge-light-success {
      background-color: rgba(23, 183, 94, 0.12);
    }
    
    .b-avatar.badge-light-info {
      color: #00CFE8;
    }
    
     .b-avatar.badge-light-info {
      background-color: rgba(0, 207, 232, 0.12);
    }
    
    .b-avatar.badge-light-warning {
      color: #FDB913;
    }
    
     .b-avatar.badge-light-warning {
      background-color: rgba(253, 185, 19, 0.12);
    }
    
    .b-avatar.badge-light-danger {
      color: #EA5455;
    }
    
     .b-avatar.badge-light-danger {
      background-color: rgba(234, 84, 85, 0.12);
    }
    
     .btn-group-toggle :not([class*=btn-outline-]).active,  .btn-group-toggle :not([class*=btn-outline-]):active,  .btn-group-toggle :not([class*=btn-outline-]).active,  .btn-group-toggle :not([class*=btn-outline-]):active {
      box-shadow: none;
    }
    
     a.badge-white:focus,  a.badge-white.focus {
      box-shadow: none;
    }
    
     a.badge-black:focus,  a.badge-black.focus {
      box-shadow: none;
    }
    
     a.badge-dark:focus,  a.badge-dark.focus {
      box-shadow: none;
    }
    
     a.badge-light:focus,  a.badge-light.focus {
      box-shadow: none;
    }
    
     a.badge-primary:focus,  a.badge-primary.focus {
      box-shadow: none;
    }
    
     a.badge-secondary:focus,  a.badge-secondary.focus {
      box-shadow: none;
    }
    
     a.badge-success:focus,  a.badge-success.focus {
      box-shadow: none;
    }
    
     a.badge-info:focus,  a.badge-info.focus {
      box-shadow: none;
    }
    
     a.badge-warning:focus,  a.badge-warning.focus {
      box-shadow: none;
    }
    
     a.badge-danger:focus,  a.badge-danger.focus {
      box-shadow: none;
    }
    
    .b-calendar .b-calendar-grid-help {
      color: #424244 !important;
    }
    .b-calendar .b-calendar-header .form-control {
      line-height: 1.85;
    }
     .b-calendar .b-calendar-inner .b-calendar-nav button {
      border: 0 !important;
    }
     .b-calendar .btn-outline-light:hover {
      background-color: #ededed;
      border-color: #ededed;
    }
     .b-calendar .table-primary,  .b-calendar .table-primary > th,  .b-calendar .table-primary > td {
      background-color: rgba(17, 74, 159, 0.2);
    }
    
    .b-form-datepicker label,
    .b-form-timepicker label {
      line-height: 200%;
    }
     .b-form-datepicker .btn.h-auto,  .b-form-timepicker .btn.h-auto {
      padding: 0.375rem 0.75rem !important;
    }
     .b-form-datepicker .btn svg,  .b-form-timepicker .btn svg {
      margin: 0 !important;
    }
    .b-form-datepicker .form-control,
    .b-form-timepicker .form-control {
      min-height: auto !important;
    }
    .b-form-datepicker.form-control-sm .form-control-sm,
    .b-form-timepicker.form-control-sm .form-control-sm {
      line-height: 1.65;
    }
    
     .dropdown.b-dropdown {
      border-radius: 0.357rem;
    }
    
    .b-form-file .custom-file-label {
      height: 100% !important;
    }
    .b-form-file.b-custom-control-sm .custom-file-label,
    .b-form-file.b-custom-control-sm .custom-file-label::after {
      line-height: 22px;
    }
    .b-form-file.b-custom-control-sm .custom-file-label::after {
      height: 28px;
    }
    .b-form-file.b-custom-control-lg .custom-file-label,
    .b-form-file.b-custom-control-lg .custom-file-label::after {
      line-height: 23px;
    }
    .b-form-file.b-custom-control-lg .custom-file-label::after {
      height: 44px;
    }
    
    [dir=ltr] .modal .modal-footer > .btn {
      margin-left: 0.75rem;
    }
    
    [dir=rtl] .modal .modal-footer > .btn {
      margin-right: 0.75rem;
    }
    
     .b-nav-dropdown .dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
    }
    
     .page-item.prev-item .page-link,  .page-item.next-item .page-link {
      padding: 0.5rem 0;
    }
    .page-item.prev-item .page-link:hover, .page-item.next-item .page-link:hover {
      color: #fff;
    }
    
     .pagination.b-pagination-pills .page-item.active {
      background-color: transparent;
    }
    
    .page-item.prev-item .page-link:before {
      display: none;
    }
    [dir=ltr] .page-item.prev-item .page-link svg {
      transform: translateX(-1px);
    }
    [dir=rtl] .page-item.prev-item .page-link svg {
      transform: translateX(1px);
    }
    
    .page-item.next-item .page-link:after {
      display: none;
    }
    [dir=ltr] .page-item.next-item .page-link svg {
      transform: translateX(1px);
    }
    [dir=rtl] .page-item.next-item .page-link svg {
      transform: translateX(-1px);
    }
    
     .popover.b-popover.bs-popover-top .arrow::before,  .popover.b-popover.bs-popover-auto[x-placement^=top] .arrow::before {
      border-top-color: #ebe9f1;
    }
     .popover.b-popover.bs-popover-top .arrow::after,  .popover.b-popover.bs-popover-auto[x-placement^=top] .arrow::after {
      border-top-color: #fff;
    }
    [dir=ltr] .popover.b-popover.bs-popover-left .arrow::before, [dir=ltr] .popover.b-popover.bs-popover-auto[x-placement^=left] .arrow::before {
      border-left-color: #ebe9f1;
    }
    [dir=rtl] .popover.b-popover.bs-popover-left .arrow::before, [dir=rtl] .popover.b-popover.bs-popover-auto[x-placement^=left] .arrow::before {
      border-right-color: #ebe9f1;
    }
    [dir=ltr] .popover.b-popover.bs-popover-left .arrow::after, [dir=ltr] .popover.b-popover.bs-popover-auto[x-placement^=left] .arrow::after {
      border-left-color: #fff;
    }
    [dir=rtl] .popover.b-popover.bs-popover-left .arrow::after, [dir=rtl] .popover.b-popover.bs-popover-auto[x-placement^=left] .arrow::after {
      border-right-color: #fff;
    }
    [dir=ltr] .popover.b-popover.bs-popover-right .arrow::before, [dir=ltr] .popover.b-popover.bs-popover-auto[x-placement^=right] .arrow::before {
      border-right-color: #ebe9f1;
    }
    [dir=rtl] .popover.b-popover.bs-popover-right .arrow::before, [dir=rtl] .popover.b-popover.bs-popover-auto[x-placement^=right] .arrow::before {
      border-left-color: #ebe9f1;
    }
    [dir=ltr] .popover.b-popover.bs-popover-right .arrow::after, [dir=ltr] .popover.b-popover.bs-popover-auto[x-placement^=right] .arrow::after {
      border-right-color: #fff;
    }
    [dir=rtl] .popover.b-popover.bs-popover-right .arrow::after, [dir=rtl] .popover.b-popover.bs-popover-auto[x-placement^=right] .arrow::after {
      border-left-color: #fff;
    }
    
    .popover.b-popover.b-popover-white {
      z-index: 9999;
      position: relative;
    }
    
     .popover.b-popover.b-popover-white {
      background-color: #fff;
      border-color: #ebe9f1;
    }
    .popover.b-popover.b-popover-white .popover-header {
      color: #fff;
    }
     .popover.b-popover.b-popover-white .popover-header {
      background-color: #ffffff;
      border-color: #ffffff;
    }
     .popover.b-popover.b-popover-white.bs-popover-bottom .arrow::before,  .popover.b-popover.b-popover-white.bs-popover-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #ffffff;
    }
     .popover.b-popover.b-popover-white.bs-popover-bottom .arrow::after,  .popover.b-popover.b-popover-white.bs-popover-auto[x-placement^=bottom] .arrow::after {
      border-bottom-color: #ffffff;
    }
    
    .popover.b-popover.b-popover-black {
      z-index: 9999;
      position: relative;
    }
    
     .popover.b-popover.b-popover-black {
      background-color: #fff;
      border-color: #ebe9f1;
    }
    .popover.b-popover.b-popover-black .popover-header {
      color: #fff;
    }
     .popover.b-popover.b-popover-black .popover-header {
      background-color: #000000;
      border-color: #000000;
    }
     .popover.b-popover.b-popover-black.bs-popover-bottom .arrow::before,  .popover.b-popover.b-popover-black.bs-popover-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #000000;
    }
     .popover.b-popover.b-popover-black.bs-popover-bottom .arrow::after,  .popover.b-popover.b-popover-black.bs-popover-auto[x-placement^=bottom] .arrow::after {
      border-bottom-color: #000000;
    }
    
    .popover.b-popover.b-popover-dark {
      z-index: 9999;
      position: relative;
    }
    
     .popover.b-popover.b-popover-dark {
      background-color: #fff;
      border-color: #ebe9f1;
    }
    .popover.b-popover.b-popover-dark .popover-header {
      color: #fff;
    }
     .popover.b-popover.b-popover-dark .popover-header {
      background-color: #4B4B4B;
      border-color: #4B4B4B;
    }
     .popover.b-popover.b-popover-dark.bs-popover-bottom .arrow::before,  .popover.b-popover.b-popover-dark.bs-popover-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #4B4B4B;
    }
     .popover.b-popover.b-popover-dark.bs-popover-bottom .arrow::after,  .popover.b-popover.b-popover-dark.bs-popover-auto[x-placement^=bottom] .arrow::after {
      border-bottom-color: #4B4B4B;
    }
    
    .popover.b-popover.b-popover-light {
      z-index: 9999;
      position: relative;
    }
    
     .popover.b-popover.b-popover-light {
      background-color: #fff;
      border-color: #ebe9f1;
    }
    .popover.b-popover.b-popover-light .popover-header {
      color: #fff;
    }
     .popover.b-popover.b-popover-light .popover-header {
      background-color: #C1C1C1;
      border-color: #C1C1C1;
    }
     .popover.b-popover.b-popover-light.bs-popover-bottom .arrow::before,  .popover.b-popover.b-popover-light.bs-popover-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #C1C1C1;
    }
     .popover.b-popover.b-popover-light.bs-popover-bottom .arrow::after,  .popover.b-popover.b-popover-light.bs-popover-auto[x-placement^=bottom] .arrow::after {
      border-bottom-color: #C1C1C1;
    }
    
    .popover.b-popover.b-popover-primary {
      z-index: 9999;
      position: relative;
    }
    
     .popover.b-popover.b-popover-primary {
      background-color: #fff;
      border-color: #ebe9f1;
    }
    .popover.b-popover.b-popover-primary .popover-header {
      color: #fff;
    }
     .popover.b-popover.b-popover-primary .popover-header {
      background-color: #114A9F;
      border-color: #114A9F;
    }
     .popover.b-popover.b-popover-primary.bs-popover-bottom .arrow::before,  .popover.b-popover.b-popover-primary.bs-popover-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #114A9F;
    }
     .popover.b-popover.b-popover-primary.bs-popover-bottom .arrow::after,  .popover.b-popover.b-popover-primary.bs-popover-auto[x-placement^=bottom] .arrow::after {
      border-bottom-color: #114A9F;
    }
    
    .popover.b-popover.b-popover-secondary {
      z-index: 9999;
      position: relative;
    }
    
     .popover.b-popover.b-popover-secondary {
      background-color: #fff;
      border-color: #ebe9f1;
    }
    .popover.b-popover.b-popover-secondary .popover-header {
      color: #fff;
    }
     .popover.b-popover.b-popover-secondary .popover-header {
      background-color: #9C9EA4;
      border-color: #9C9EA4;
    }
     .popover.b-popover.b-popover-secondary.bs-popover-bottom .arrow::before,  .popover.b-popover.b-popover-secondary.bs-popover-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #9C9EA4;
    }
     .popover.b-popover.b-popover-secondary.bs-popover-bottom .arrow::after,  .popover.b-popover.b-popover-secondary.bs-popover-auto[x-placement^=bottom] .arrow::after {
      border-bottom-color: #9C9EA4;
    }
    
    .popover.b-popover.b-popover-success {
      z-index: 9999;
      position: relative;
    }
    
     .popover.b-popover.b-popover-success {
      background-color: #fff;
      border-color: #ebe9f1;
    }
    .popover.b-popover.b-popover-success .popover-header {
      color: #fff;
    }
     .popover.b-popover.b-popover-success .popover-header {
      background-color: #17B75E;
      border-color: #17B75E;
    }
     .popover.b-popover.b-popover-success.bs-popover-bottom .arrow::before,  .popover.b-popover.b-popover-success.bs-popover-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #17B75E;
    }
     .popover.b-popover.b-popover-success.bs-popover-bottom .arrow::after,  .popover.b-popover.b-popover-success.bs-popover-auto[x-placement^=bottom] .arrow::after {
      border-bottom-color: #17B75E;
    }
    
    .popover.b-popover.b-popover-info {
      z-index: 9999;
      position: relative;
    }
    
     .popover.b-popover.b-popover-info {
      background-color: #fff;
      border-color: #ebe9f1;
    }
    .popover.b-popover.b-popover-info .popover-header {
      color: #fff;
    }
     .popover.b-popover.b-popover-info .popover-header {
      background-color: #00CFE8;
      border-color: #00CFE8;
    }
     .popover.b-popover.b-popover-info.bs-popover-bottom .arrow::before,  .popover.b-popover.b-popover-info.bs-popover-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #00CFE8;
    }
     .popover.b-popover.b-popover-info.bs-popover-bottom .arrow::after,  .popover.b-popover.b-popover-info.bs-popover-auto[x-placement^=bottom] .arrow::after {
      border-bottom-color: #00CFE8;
    }
    
    .popover.b-popover.b-popover-warning {
      z-index: 9999;
      position: relative;
    }
    
     .popover.b-popover.b-popover-warning {
      background-color: #fff;
      border-color: #ebe9f1;
    }
    .popover.b-popover.b-popover-warning .popover-header {
      color: #fff;
    }
     .popover.b-popover.b-popover-warning .popover-header {
      background-color: #FDB913;
      border-color: #FDB913;
    }
     .popover.b-popover.b-popover-warning.bs-popover-bottom .arrow::before,  .popover.b-popover.b-popover-warning.bs-popover-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #FDB913;
    }
     .popover.b-popover.b-popover-warning.bs-popover-bottom .arrow::after,  .popover.b-popover.b-popover-warning.bs-popover-auto[x-placement^=bottom] .arrow::after {
      border-bottom-color: #FDB913;
    }
    
    .popover.b-popover.b-popover-danger {
      z-index: 9999;
      position: relative;
    }
    
     .popover.b-popover.b-popover-danger {
      background-color: #fff;
      border-color: #ebe9f1;
    }
    .popover.b-popover.b-popover-danger .popover-header {
      color: #fff;
    }
     .popover.b-popover.b-popover-danger .popover-header {
      background-color: #EA5455;
      border-color: #EA5455;
    }
     .popover.b-popover.b-popover-danger.bs-popover-bottom .arrow::before,  .popover.b-popover.b-popover-danger.bs-popover-auto[x-placement^=bottom] .arrow::before {
      border-bottom-color: #EA5455;
    }
     .popover.b-popover.b-popover-danger.bs-popover-bottom .arrow::after,  .popover.b-popover.b-popover-danger.bs-popover-auto[x-placement^=bottom] .arrow::after {
      border-bottom-color: #EA5455;
    }
    
     output.b-rating.form-control:focus {
      box-shadow: none;
    }
    
    .b-sidebar.sidebar-lg {
      width: 30rem;
    }
    @media (max-width: 575.98px) {
      .b-sidebar.sidebar-lg {
        width: 20rem;
      }
    }
    .b-sidebar .b-sidebar-header .close {
      outline: none;
    }
     .b-sidebar .b-sidebar-body .content-sidebar-header {
      background-color: #C1C1C1;
    }
    
     .b-sidebar-backdrop {
      background-color: rgba(34, 41, 47, 0.75) !important;
    }
    
     .b-form-spinbutton.form-control {
      padding: 0;
    }
     .b-form-spinbutton.form-control:focus,  .b-form-spinbutton.form-control.focus {
      border-color: #114A9F;
      box-shadow: none;
    }
    [dir=ltr] .b-form-spinbutton.form-control.is-valid, [dir=ltr] .b-form-spinbutton.form-control.is-invalid {
      padding-right: calc(1.5em + 0.75rem);
    }
    [dir=rtl] .b-form-spinbutton.form-control.is-valid, [dir=rtl] .b-form-spinbutton.form-control.is-invalid {
      padding-left: calc(1.5em + 0.75rem);
    }
     .b-form-spinbutton.form-control .btn-sm,  .b-form-spinbutton.form-control .btn-group-sm > .btn {
      padding: 0.25rem 0.5rem;
    }
    .b-form-spinbutton.form-control-sm output > bdi {
      height: 0.9rem;
    }
    
     .custom-switch:not(.custom-control-inline) .custom-control-label {
      margin-bottom: 0.5rem;
    }
    
    .table.b-table.b-table-selectable tr {
      outline: none;
    }
     .table.b-table > tbody .b-table-row-selected.table-active td {
      background-color: #f6f6f9;
    }
    .table.b-table th {
      outline: none;
    }
    
     .b-form-tag {
      background-color: #114A9F;
    }
    
    [dir=ltr] .b-form-tag {
      margin-right: 0.8rem;
    }
    
    [dir=rtl] .b-form-tag {
      margin-left: 0.8rem;
    }
    .b-form-tag .close {
      opacity: 1;
      vertical-align: middle;
      display: flex;
      align-self: center;
    }
     .b-form-tag .close {
      text-shadow: none;
    }
    
    .b-time-header output > bdi {
      line-height: 1.85;
    }
    
    .b-time .bi-circle-fill {
      height: 10px;
      width: 10px;
      fill: #9C9EA4;
    }
    .b-time .bi-chevron-up {
      height: 10px;
      width: 10px;
    }
    [dir=ltr] .b-time .b-form-spinbutton + .flex-column:not(.b-time-ampm) {
      margin-left: 0.4rem;
      margin-right: 0.4rem;
    }
    [dir=rtl] .b-time .b-form-spinbutton + .flex-column:not(.b-time-ampm) {
      margin-right: 0.4rem;
      margin-left: 0.4rem;
    }
     .b-time .b-form-spinbutton output.border-bottom.border-top {
      border: none !important;
    }
     .b-time .b-form-spinbutton .btn:hover:not(:disabled) > div > .b-icon {
      transform: scale(1);
    }
    
    /* Generate:
    *  Border color according to event class
    */
    .b-toast-white .toast-header {
      color: #fff !important;
    }
     .b-toast-white .toast-header {
      background-color: #ffffff !important;
    }
    .b-toast-white .toast-header .close {
      color: #fff;
    }
     .b-toast-white .toast-header .close {
      text-shadow: none;
    }
    
    .b-toast-black .toast-header {
      color: #fff !important;
    }
    
     .b-toast-black .toast-header {
      background-color: #000000 !important;
    }
    .b-toast-black .toast-header .close {
      color: #fff;
    }
     .b-toast-black .toast-header .close {
      text-shadow: none;
    }
    
    .b-toast-dark .toast-header {
      color: #fff !important;
    }
    
     .b-toast-dark .toast-header {
      background-color: #4B4B4B !important;
    }
    .b-toast-dark .toast-header .close {
      color: #fff;
    }
     .b-toast-dark .toast-header .close {
      text-shadow: none;
    }
    
    .b-toast-light .toast-header {
      color: #fff !important;
    }
    
     .b-toast-light .toast-header {
      background-color: #C1C1C1 !important;
    }
    .b-toast-light .toast-header .close {
      color: #fff;
    }
     .b-toast-light .toast-header .close {
      text-shadow: none;
    }
    
    .b-toast-primary .toast-header {
      color: #fff !important;
    }
    
     .b-toast-primary .toast-header {
      background-color: #114A9F !important;
    }
    .b-toast-primary .toast-header .close {
      color: #fff;
    }
     .b-toast-primary .toast-header .close {
      text-shadow: none;
    }
    
    .b-toast-secondary .toast-header {
      color: #fff !important;
    }
    
     .b-toast-secondary .toast-header {
      background-color: #9C9EA4 !important;
    }
    .b-toast-secondary .toast-header .close {
      color: #fff;
    }
     .b-toast-secondary .toast-header .close {
      text-shadow: none;
    }
    
    .b-toast-success .toast-header {
      color: #fff !important;
    }
    
     .b-toast-success .toast-header {
      background-color: #17B75E !important;
    }
    .b-toast-success .toast-header .close {
      color: #fff;
    }
     .b-toast-success .toast-header .close {
      text-shadow: none;
    }
    
    .b-toast-info .toast-header {
      color: #fff !important;
    }
    
     .b-toast-info .toast-header {
      background-color: #00CFE8 !important;
    }
    .b-toast-info .toast-header .close {
      color: #fff;
    }
     .b-toast-info .toast-header .close {
      text-shadow: none;
    }
    
    .b-toast-warning .toast-header {
      color: #fff !important;
    }
    
     .b-toast-warning .toast-header {
      background-color: #FDB913 !important;
    }
    .b-toast-warning .toast-header .close {
      color: #fff;
    }
     .b-toast-warning .toast-header .close {
      text-shadow: none;
    }
    
    .b-toast-danger .toast-header {
      color: #fff !important;
    }
    
     .b-toast-danger .toast-header {
      background-color: #EA5455 !important;
    }
    .b-toast-danger .toast-header .close {
      color: #fff;
    }
     .b-toast-danger .toast-header .close {
      text-shadow: none;
    }
    
    .b-toast.b-toast-solid .toast {
      color: #424244;
    }
    
     .b-toast.b-toast-solid .toast {
      background-color: #fff;
    }
    
     .toast-header .close {
      margin-bottom: 2px !important;
    }
    
    .tooltip.b-tooltip-warning .tooltip-inner {
      color: #fff;
    }
    
     .custom-control-input.is-valid:not(:disabled):active ~ .custom-control-label::before {
      background-color: #17B75E;
      border-color: #17B75E;
    }
    
     .custom-control-input.is-invalid:not(:disabled):active ~ .custom-control-label::before {
      background-color: #EA5455;
      border-color: #EA5455;
    }
    
    .input-group-prepend .input-group-text .form-check,
    .input-group-append .input-group-text .form-check {
      line-height: 0;
    }
    
    .custom-file-label {
      height: calc(1.65em + 1.4rem + 1px);
    }
    
    body {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    
    .body-lead {
      font-weight: 400;
      font-size: 16px;
    }
    
    .body-semi-bold {
      font-size: 12px;
      font-weight: 500;
    }
    
    .body-bold {
      font-weight: 700;
      font-size: 12px;
    }
    
    .body-small {
      font-weight: 400;
      font-size: 12px;
    }
    
    .body-small-semi-bold {
      font-weight: 500;
      font-size: 12px;
    }
    
    .body-small-bold {
      font-weight: 700;
      font-size: 12px;
    }
    
     .v-select.v-select-error .vs__dropdown-toggle {
      border-color: #EA5455 !important;
    }
    
     .cleave-error {
      border-color: #EA5455 !important;
    }
    
    .color-heading {
      color: #424244;
    }
    
    .vue-swatches {
      width: 100%;
    }
    .vue-swatches .vue-swatches__trigger__wrapper {
      width: 100%;
    }
     .vue-swatches .vue-swatches__trigger__wrapper {
      border: 1px solid #D6D9E1;
      border-radius: 4px;
      padding: 5px 5px 5px 5px;
    }
    .vue-swatches .vue-swatches__trigger__wrapper .vue-swatches__trigger {
      width: 20px !important;
      height: 20px !important;
    }
    
     .group-item-list {
      box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.06);
      background: #FFFFFF;
      border-radius: 3px;
      padding: 11px;
    }
     .group-item-list:hover {
      box-shadow: 0px 4px 6px rgba(161, 164, 156, 0.38);
    }
    .group-item-list:hover .media-body > div > ul {
      opacity: 1;
    }
     .group-item-list .nav-link {
      padding: 0;
    }
    .group-item-list .b-nav-dropdown .dropdown-toggle::after {
      display: none;
    }
    .group-item-list .media-body > div > ul {
      opacity: 0;
    }
    .group-item-list.disable {
      color: #9C9EA4;
    }
     .group-item-list.disable {
      background: rgba(193, 193, 193, 0.12);
    }
    .group-item-list.disable .media-body h6 {
      color: #9C9EA4;
    }
    
    .b-sidebar .header-sidebar {
      height: 48px;
    }
    
     .b-sidebar .header-sidebar {
      background: linear-gradient(0deg, rgba(17, 74, 159, 0.12), rgba(17, 74, 159, 0.12)), #FFFFFF;
    }
    
     .dot-size-10 {
      padding: 5px;
    }
    
    [dir=ltr] .dot-size-10 {
      margin-right: 5px;
    }
    
    [dir=rtl] .dot-size-10 {
      margin-left: 5px;
    }
    
    .modal-dialog .modal-header {
      align-items: center;
      height: 48px;
    }
    
     .modal-dialog .modal-header {
      background-color: rgba(17, 74, 159, 0.12) !important;
    }
     .modal-dialog .modal-body {
      padding: 0;
    }
    
    .label-requires legend::after {
      content: "*";
      color: red;
      /* position: relative; */
    }
    
    [dir=ltr] .label-requires legend::after {
      margin-left: 4px;
    }
    
    [dir=rtl] .label-requires legend::after {
      margin-right: 4px;
    }
    
     .golf-class-item {
      cursor: pointer;
    }
    
     .golf-class-item:hover {
      background-color: rgba(193, 193, 193, 0.12);
    }
    
     .p-15 {
      padding: 15px !important;
    }
    
     .flatpickr-input.is-invalid + input {
      border-color: #EA5455;
      background-repeat: no-repeat;
      background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);
    }
    
    .form-control .h-auto, .form-control.h-auto {
      height: inherit !important;
    }
    
     .btn-h28 {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
    
    .custom-vue-tree.vue-treeselect--has-value .vue-treeselect__multi-value {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    
     .pointer {
      cursor: pointer;
    }
    
     .modal .modal-header .close {
      background: transparent !important;
      transform: none !important;
      box-shadow: none !important;
    }
    
    [dir=ltr] .modal .modal-header .close {
      margin-right: -8px !important;
    }
    
    [dir=rtl] .modal .modal-header .close {
      margin-left: -8px !important;
    }
    
     #modal-danger .modal-header {
      background: rgba(234, 84, 85, 0.12) !important;
    }
    
    .dropdown-menu .delete .dropdown-item {
      color: #EA5455;
    }
     .dropdown-menu .delete .dropdown-item:hover {
      background: rgba(234, 84, 85, 0.12);
    }
    
     .vue-treeselect__checkbox--checked {
      border-color: #114a9f !important;
      background: #114a9f !important;
    }
    
     .vue-treeselect__multi-value-item {
      background: #114a9f !important;
    }
    
    .vue-treeselect__multi-value-item {
      color: #fff !important;
    }
    .vue-treeselect__multi-value-item i {
      position: relative;
      top: -1px;
    }
    
     .custom-radio .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #ffffff !important;
      border: #114A9F solid 5px !important;
    }
    
    .vue-treeselect__control {
      height: 32px !important;
    }
    
     .vue-treeselect--has-value .vue-treeselect__multi-value {
      margin-bottom: 3px !important;
    }
    
    .payment-type-td:hover {
      color: #114a9f;
    }
    
     .payment-type-td:hover {
      background-color: #e2e9f3;
      cursor: pointer;
    }
    
     .payment-type-tr {
      border: 0;
    }
    
     .payment-type-th {
      background-color: #ffffff !important;
    }
    
    .w-20 {
      width: 20% !important;
    }
    
    .w-28 {
      width: 28% !important;
    }
    
    .w-38 {
      width: 38% !important;
    }
    
    .w-30 {
      width: 30% !important;
    }
    
    .w-60 {
      width: 60% !important;
    }
    
     .select-no-border .vs__dropdown-toggle {
      border-color: transparent;
    }
     .select-no-border:hover .vs__dropdown-toggle {
      border-color: #D6D9E1;
    }
    
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    
    /* Track */
     ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    
    /* Handle */
     ::-webkit-scrollbar-thumb {
      background: #b4b4b4;
      border-radius: 5px;
    }
    
    /* Handle on hover */
     ::-webkit-scrollbar-thumb:hover {
      background: #626262;
    }
    
     .pointer {
      cursor: pointer;
    }
    
    .vs__selected {
      word-break: break-all;
    }
    
    [dir=ltr] .dropdown-menu {
      right: 0 !important;
    }
    
    [dir=rtl] .dropdown-menu {
      left: 0 !important;
    }
    
     .mx-calendar-content .cell.active {
      background-color: #114a9f !important;
    }
    
    .tbl-package th {
      white-space: nowrap;
    }
    .tbl-package td {
      white-space: nowrap;
    }
    
    .hover-editable  .vs__dropdown-toggle {
      border: none !important;
    }
    .hover-editable  .vs__selected {
      margin: 0;
      padding: 0;
    }
    
    #modal-update-package .modal-dialog {
      max-width: 1080px !important;
    }
    #modal-update-package .modal-dialog .modal-content {
      width: 1080px;
    }
    
    #modal-update-caddy .modal-dialog {
      max-width: 900px !important;
    }
    #modal-update-caddy .modal-dialog .modal-content {
      width: 100% !important;
    }
    #modal-update-caddy .modal-dialog .modal-content .bg-status .btn {
      position: relative;
      text-transform: capitalize;
      min-width: 200px;
    }
     #modal-update-caddy .modal-dialog .modal-content .bg-status .btn {
      padding: 4px 3px !important;
      border: none !important;
    }
    [dir=ltr] #modal-update-caddy .modal-dialog .modal-content .bg-status .btn {
      text-align: left;
    }
    [dir=rtl] #modal-update-caddy .modal-dialog .modal-content .bg-status .btn {
      text-align: right;
    }
     #modal-update-caddy .modal-dialog .modal-content .bg-status .btn span {
      padding: 4px;
      border-radius: 4px;
    }
    #modal-update-caddy .modal-dialog .modal-content .bg-status-A .btn span {
      color: #114a9f;
    }
     #modal-update-caddy .modal-dialog .modal-content .bg-status-A .btn span {
      background: #87b0ec;
    }
    #modal-update-caddy .modal-dialog .modal-content .bg-status-O .btn span {
      color: #282828;
    }
     #modal-update-caddy .modal-dialog .modal-content .bg-status-O .btn span {
      background: #dfe1e4;
    }
    #modal-update-caddy .modal-dialog .modal-content .bg-status-B .btn span {
      color: #cc8e06;
    }
     #modal-update-caddy .modal-dialog .modal-content .bg-status-B .btn span {
      background: #ffffa7;
    }
    #modal-update-caddy .modal-dialog .modal-content .bg-status-W .btn span {
      color: #a80404;
    }
     #modal-update-caddy .modal-dialog .modal-content .bg-status-W .btn span {
      background: #ffa8a8;
    }
    #modal-update-caddy .modal-dialog .modal-content .dropdown-toggle::after {
      position: absolute !important;
      top: 5px;
    }
    [dir=ltr] #modal-update-caddy .modal-dialog .modal-content .dropdown-toggle::after {
      right: 2px;
      left: auto;
    }
    [dir=rtl] #modal-update-caddy .modal-dialog .modal-content .dropdown-toggle::after {
      left: 2px;
      right: auto;
    }
    #modal-update-caddy .modal-dialog .modal-content .vs__clear {
      display: none;
    }
    .ps{overflow:hidden!important;overflow-anchor:none;-ms-overflow-style:none;touch-action:auto;-ms-touch-action:auto}.ps__rail-x{height:15px;bottom:0}.ps__rail-x,.ps__rail-y{display:none;opacity:0;transition:background-color .2s linear,opacity .2s linear;-webkit-transition:background-color .2s linear,opacity .2s linear;position:absolute}.ps__rail-y{width:15px;right:0}.ps--active-x>.ps__rail-x,.ps--active-y>.ps__rail-y{display:block;background-color:transparent}.ps--focus>.ps__rail-x,.ps--focus>.ps__rail-y,.ps--scrolling-x>.ps__rail-x,.ps--scrolling-y>.ps__rail-y,.ps:hover>.ps__rail-x,.ps:hover>.ps__rail-y{opacity:.6}.ps .ps__rail-x.ps--clicking,.ps .ps__rail-x:focus,.ps .ps__rail-x:hover,.ps .ps__rail-y.ps--clicking,.ps .ps__rail-y:focus,.ps .ps__rail-y:hover{background-color:#eee;opacity:.9}.ps__thumb-x{transition:background-color .2s linear,height .2s ease-in-out;-webkit-transition:background-color .2s linear,height .2s ease-in-out;height:6px;bottom:2px}.ps__thumb-x,.ps__thumb-y{background-color:#aaa;border-radius:6px;position:absolute}.ps__thumb-y{transition:background-color .2s linear,width .2s ease-in-out;-webkit-transition:background-color .2s linear,width .2s ease-in-out;width:6px;right:2px}.ps__rail-x.ps--clicking .ps__thumb-x,.ps__rail-x:focus>.ps__thumb-x,.ps__rail-x:hover>.ps__thumb-x{background-color:#999;height:11px}.ps__rail-y.ps--clicking .ps__thumb-y,.ps__rail-y:focus>.ps__thumb-y,.ps__rail-y:hover>.ps__thumb-y{background-color:#999;width:11px}@supports (-ms-overflow-style:none){.ps{overflow:auto!important}}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.ps{overflow:auto!important}}
    .ps-container{position:relative}
    ul[data-v-d8488326] {
      list-style: none;
    } ul[data-v-d8488326] {
      padding: 0;
      margin: 0;
    }
     p[data-v-d8488326] {
      margin: 0;
    }
    .nav-bookmar-content-overlay[data-v-d8488326] {
      position: fixed;
      opacity: 0;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      transition: all 0.7s;
      z-index: -1;
    }
     .nav-bookmar-content-overlay[data-v-d8488326] {
      background-color: rgba(0, 0, 0, 0.5);
      -webkit-transition: all 0.7s;
    }
    [dir=ltr] .nav-bookmar-content-overlay[data-v-d8488326] {
      left: 0;
      right: 0;
    }
    [dir=rtl] .nav-bookmar-content-overlay[data-v-d8488326] {
      right: 0;
      left: 0;
    }
    .nav-bookmar-content-overlay[data-v-d8488326]:not(.show) {
      pointer-events: none;
    }
    .nav-bookmar-content-overlay.show[data-v-d8488326] {
      z-index: 10;
      opacity: 1;
    }
     .nav-bookmar-content-overlay.show[data-v-d8488326] {
      cursor: pointer;
    }
    ul[data-v-915d7a8a] {
      list-style: none;
    } ul[data-v-915d7a8a] {
      padding: 0;
      margin: 0;
    }
     p[data-v-915d7a8a] {
      margin: 0;
    }
    
    /* .app-auto-suggest {
      position: relative;
    }
    
    .auto-suggest-suggestions-list {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
      border-radius: 6px;
      position: absolute;
      top: calc(100% + 1rem);
      background-color: white;
      width: 100%;
    } */
    .suggestion-group-title[data-v-915d7a8a] {
      font-weight: 500;
    }
     .suggestion-group-title[data-v-915d7a8a] {
      padding: 0.75rem 1rem 0.25rem;
    }
     .suggestion-group-suggestion[data-v-915d7a8a] {
      padding: 0.75rem 1rem;
    }
     .suggestion-current-selected[data-v-915d7a8a] {
      background-color: #f8f8f8;
    }
     .dark-layout .suggestion-current-selected[data-v-915d7a8a] {
      background-color: #161d31;
    }
    .navbar-container .search-input.open[data-v-915d7a8a] {
      top: 16px;
    }
    [dir=ltr] .navbar-container .search-input.open[data-v-915d7a8a] {
      left: 110px;
    }
    [dir=rtl] .navbar-container .search-input.open[data-v-915d7a8a] {
      right: 110px;
    }
    .navbar-container .search-input input[data-v-915d7a8a] {
      width: 100%;
      height: 32px;
    }
    [dir=ltr] .navbar-container .search-input input[data-v-915d7a8a] {
      padding: 0 0px 0 10px;
    }
    [dir=rtl] .navbar-container .search-input input[data-v-915d7a8a] {
      padding: 0 10px 0 0px;
    }
    .navbar-container .search-input .search-input-icon[data-v-915d7a8a] {
      top: 6px;
    }
    [dir=ltr] .navbar-container .search-input .search-input-icon[data-v-915d7a8a] {
      right: 10px;
    }
    [dir=rtl] .navbar-container .search-input .search-input-icon[data-v-915d7a8a] {
      left: 10px;
    }
    .dropdown-cart .media .media-aside[data-v-7a505611] {
      align-items: center;
    }
    .vertical-layout.vertical-menu-modern .main-menu, .vertical-layout.vertical-menu-modern .second-menu {
      transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), background 0s;
      backface-visibility: hidden;
    }
     .vertical-layout.vertical-menu-modern .main-menu,  .vertical-layout.vertical-menu-modern .second-menu {
      transform: translate3d(0, 0, 0);
    }
     .vertical-layout.vertical-menu-modern .main-menu .navigation,  .vertical-layout.vertical-menu-modern .second-menu .navigation {
      padding-bottom: 25px;
    }
    .vertical-layout.vertical-menu-modern .main-menu .navigation li a, .vertical-layout.vertical-menu-modern .second-menu .navigation li a {
      align-items: center;
    }
    .vertical-layout.vertical-menu-modern .main-menu .navigation > li > a svg,
    .vertical-layout.vertical-menu-modern .main-menu .navigation > li > a i, .vertical-layout.vertical-menu-modern .second-menu .navigation > li > a svg,
    .vertical-layout.vertical-menu-modern .second-menu .navigation > li > a i {
      height: 20px;
      width: 20px;
      font-size: 1.45rem;
      flex-shrink: 0;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern .main-menu .navigation > li > a svg, [dir=ltr] .vertical-layout.vertical-menu-modern .main-menu .navigation > li > a i, [dir=ltr] .vertical-layout.vertical-menu-modern .second-menu .navigation > li > a svg, [dir=ltr] .vertical-layout.vertical-menu-modern .second-menu .navigation > li > a i {
      margin-right: 1.1rem;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern .main-menu .navigation > li > a svg, [dir=rtl] .vertical-layout.vertical-menu-modern .main-menu .navigation > li > a i, [dir=rtl] .vertical-layout.vertical-menu-modern .second-menu .navigation > li > a svg, [dir=rtl] .vertical-layout.vertical-menu-modern .second-menu .navigation > li > a i {
      margin-left: 1.1rem;
    }
    .vertical-layout.vertical-menu-modern .main-menu .navigation .menu-content > li > a svg,
    .vertical-layout.vertical-menu-modern .main-menu .navigation .menu-content > li > a i, .vertical-layout.vertical-menu-modern .second-menu .navigation .menu-content > li > a svg,
    .vertical-layout.vertical-menu-modern .second-menu .navigation .menu-content > li > a i {
      font-size: 11px;
      height: 11px;
      width: 11px;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern .main-menu .navigation .menu-content > li > a svg, [dir=ltr] .vertical-layout.vertical-menu-modern .main-menu .navigation .menu-content > li > a i, [dir=ltr] .vertical-layout.vertical-menu-modern .second-menu .navigation .menu-content > li > a svg, [dir=ltr] .vertical-layout.vertical-menu-modern .second-menu .navigation .menu-content > li > a i {
      margin-right: 1.45rem;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern .main-menu .navigation .menu-content > li > a svg, [dir=rtl] .vertical-layout.vertical-menu-modern .main-menu .navigation .menu-content > li > a i, [dir=rtl] .vertical-layout.vertical-menu-modern .second-menu .navigation .menu-content > li > a svg, [dir=rtl] .vertical-layout.vertical-menu-modern .second-menu .navigation .menu-content > li > a i {
      margin-left: 1.45rem;
    }
    .vertical-layout.vertical-menu-modern.menu-expanded .main-menu, .vertical-layout.vertical-menu-modern.menu-expanded .second-menu {
      width: 260px;
    }
    .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation .navigation-header .feather-more-horizontal, .vertical-layout.vertical-menu-modern.menu-expanded .second-menu .navigation .navigation-header .feather-more-horizontal {
      display: none;
    }
    .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation > li > a > i:before,
    .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation > li > a > svg:before, .vertical-layout.vertical-menu-modern.menu-expanded .second-menu .navigation > li > a > i:before,
    .vertical-layout.vertical-menu-modern.menu-expanded .second-menu .navigation > li > a > svg:before {
      height: 20px;
      width: 20px;
      font-size: 24px;
    }
    .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation li.has-sub > a:after {
      content: "";
      height: 1.1rem;
      width: 1.1rem;
      display: inline-block;
      position: absolute;
      top: 14px;
      transition: all 0.2s ease-out;
    }
     .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation li.has-sub > a:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 1.1rem;
      transform: rotate(0deg);
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation li.has-sub > a:after {
      right: 20px;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation li.has-sub > a:after {
      left: 20px;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation li.has-sub.open:not(.menu-item-closing) > a:after {
      transform: rotate(90deg);
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation li.has-sub.open:not(.menu-item-closing) > a:after {
      transform: rotate(-90deg);
    }
    .vertical-layout.vertical-menu-modern.menu-expanded .second-menu .navigation li:not(.level1).has-sub > a:after {
      content: "";
      height: 1.1rem;
      width: 1.1rem;
      display: inline-block;
      position: absolute;
      top: 14px;
      transition: all 0.2s ease-out;
    }
     .vertical-layout.vertical-menu-modern.menu-expanded .second-menu .navigation li:not(.level1).has-sub > a:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 1.1rem;
      transform: rotate(0deg);
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-expanded .second-menu .navigation li:not(.level1).has-sub > a:after {
      right: 20px;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-expanded .second-menu .navigation li:not(.level1).has-sub > a:after {
      left: 20px;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-expanded .second-menu .navigation li:not(.level1).has-sub.open:not(.menu-item-closing) > a:after {
      transform: rotate(90deg);
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-expanded .second-menu .navigation li:not(.level1).has-sub.open:not(.menu-item-closing) > a:after {
      transform: rotate(-90deg);
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-expanded .footer {
      margin-left: 260px;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-expanded .footer {
      margin-right: 260px;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .navbar .navbar-header {
      width: 50px;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-collapsed .navbar .navbar-header {
      float: left;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-collapsed .navbar .navbar-header {
      float: right;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .navbar .navbar-header .modern-nav-toggle {
      display: none;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .navbar .navbar-header.expanded {
      width: 260px;
      z-index: 1000;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .navbar .navbar-header.expanded .modern-nav-toggle {
      display: block;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-collapsed .navbar.fixed-top {
      left: 50px;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-collapsed .navbar.fixed-top {
      right: 50px;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-collapsed .second-menu {
      margin-left: 50px;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-collapsed .second-menu {
      margin-right: 50px;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .second-menu .navigation li:not(.level1).has-sub > a:after {
      content: "";
      height: 1.1rem;
      width: 1.1rem;
      display: inline-block;
      position: absolute;
      top: 14px;
      transition: all 0.2s ease-out;
    }
     .vertical-layout.vertical-menu-modern.menu-collapsed .second-menu .navigation li:not(.level1).has-sub > a:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 1.1rem;
      transform: rotate(0deg);
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-collapsed .second-menu .navigation li:not(.level1).has-sub > a:after {
      right: 20px;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-collapsed .second-menu .navigation li:not(.level1).has-sub > a:after {
      left: 20px;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-collapsed .second-menu .navigation li:not(.level1).has-sub.open:not(.menu-item-closing) > a:after {
      transform: rotate(90deg);
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-collapsed .second-menu .navigation li:not(.level1).has-sub.open:not(.menu-item-closing) > a:after {
      transform: rotate(-90deg);
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu {
      width: 50px;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu .navbar-header .brand-text,
    .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu .modern-nav-toggle {
      display: none;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu:not(.expanded) .navigation-header span {
      display: none;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu:not(.expanded) .navigation-header .feather-more-horizontal {
      display: block;
      font-size: 1.285rem;
      width: 18px;
      height: 18px;
    }
     .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu:not(.expanded) .navigation li:last-child {
      margin-bottom: 1.25rem !important;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu:not(.expanded) .navigation li.active a {
      color: #114A9F;
    }
     .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu:not(.expanded) .navigation li.active a {
      background: whitesmoke;
      box-shadow: none;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu .navigation {
      overflow: visible;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu .navigation > li.navigation-header span {
      display: none;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu .navigation > li > a {
      text-overflow: inherit;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-collapsed .app-content, [dir=ltr] .vertical-layout.vertical-menu-modern.menu-collapsed .footer {
      margin-left: 50px;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-collapsed .app-content, [dir=rtl] .vertical-layout.vertical-menu-modern.menu-collapsed .footer {
      margin-right: 50px;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .header-navbar.floating-nav {
      width: calc(100vw - (100vw - 100%) - 4.4rem - 74px);
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .header-navbar.navbar-static-top {
      width: calc(100vw - (100vw - 100%) - 74px);
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-collapsed .header-navbar.navbar-static-top {
      left: 74px;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-collapsed .header-navbar.navbar-static-top {
      right: 74px;
    }
    .vertical-layout.vertical-menu-modern .toggle-icon,
    .vertical-layout.vertical-menu-modern .collapse-toggle-icon {
      font-weight: 500;
      color: #424244;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern .toggle-icon, [dir=ltr] .vertical-layout.vertical-menu-modern .collapse-toggle-icon {
      margin-right: 0.425rem;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern .toggle-icon, [dir=rtl] .vertical-layout.vertical-menu-modern .collapse-toggle-icon {
      margin-left: 0.425rem;
    }
    .vertical-layout.vertical-menu-modern .toggle-icon:focus,
    .vertical-layout.vertical-menu-modern .collapse-toggle-icon:focus {
      outline: none;
    }
    .vertical-layout.vertical-menu-modern .ez-fixed-toggle-menu {
      position: fixed;
      bottom: 50px;
      width: 100%;
    }
     .vertical-layout.vertical-menu-modern .ez-fixed-toggle-menu {
      background: #fff;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern .ez-fixed-toggle-menu {
      padding-left: 8px;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern .ez-fixed-toggle-menu {
      padding-right: 8px;
    }
    @media (min-width: 992px) {
    .vertical-layout.vertical-menu-modern .main-menu {
        width: 260px;
    }
    }
    @media (max-width: 1199.98px) {
    .vertical-layout.vertical-menu-modern .main-menu {
        width: 0;
    }
    .vertical-layout.vertical-menu-modern .navbar .navbar-header {
        width: 0;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern .content, [dir=ltr] .vertical-layout.vertical-menu-modern .footer {
        margin-left: 0;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern .content, [dir=rtl] .vertical-layout.vertical-menu-modern .footer {
        margin-right: 0;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern.menu-collapsed .app-content, [dir=ltr] .vertical-layout.vertical-menu-modern.menu-collapsed .footer {
        margin-left: 0;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern.menu-collapsed .app-content, [dir=rtl] .vertical-layout.vertical-menu-modern.menu-collapsed .footer {
        margin-right: 0;
    }
    .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu {
        width: 0;
    }
    }
    @media (max-width: 767.98px) {
    .vertical-layout.vertical-menu-modern .main-menu {
        width: 0;
    }
    .vertical-layout.vertical-menu-modern .navbar .navbar-header {
        width: 0;
    }
    [dir=ltr] .vertical-layout.vertical-menu-modern .content, [dir=ltr] .vertical-layout.vertical-menu-modern .footer {
        margin-left: 0;
    }
    [dir=rtl] .vertical-layout.vertical-menu-modern .content, [dir=rtl] .vertical-layout.vertical-menu-modern .footer {
        margin-right: 0;
    }
    }
    @keyframes fadein {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
    }
    @keyframes fadeout {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
    }
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    [dir=ltr] .vertical-menu-modern.vertical-layout .main-menu .navigation > li > a > span {
        animation: none;
    }
    [dir=rtl] .vertical-menu-modern.vertical-layout .main-menu .navigation > li > a > span {
        animation: none;
    }
    }
    /*=========================================================================================
        File Name: vertical-overlay-menu.scss
        Description: A overlay style vertical menu with show and hide support. It support
        light & dark version, filpped layout, right side icons, native scroll and borders menu
        item seperation.
    
    ==========================================================================================*/
    [dir=ltr] .vertical-overlay-menu .content {
      margin-left: 0;
    }
    [dir=rtl] .vertical-overlay-menu .content {
      margin-right: 0;
    }
    .vertical-overlay-menu .navbar .navbar-header {
      width: 260px;
    }
    [dir=ltr] .vertical-overlay-menu .navbar .navbar-header {
      float: left;
    }
    [dir=rtl] .vertical-overlay-menu .navbar .navbar-header {
      float: right;
    }
    .vertical-overlay-menu .main-menu, .vertical-overlay-menu.menu-hide .main-menu {
      opacity: 0;
      transition: width 0.25s, opacity 0.25s, transform 0.25s;
      width: 260px;
    }
     .vertical-overlay-menu .main-menu,  .vertical-overlay-menu.menu-hide .main-menu {
      transform: translate3d(0, 0, 0);
    }
    [dir=ltr] .vertical-overlay-menu .main-menu, [dir=ltr] .vertical-overlay-menu.menu-hide .main-menu {
      left: -260px;
    }
    [dir=rtl] .vertical-overlay-menu .main-menu, [dir=rtl] .vertical-overlay-menu.menu-hide .main-menu {
      right: -260px;
    }
    .vertical-overlay-menu .main-menu .navigation > li > a > svg,
    .vertical-overlay-menu .main-menu .navigation > li > a > i {
      transition: 200ms ease all;
      height: 20px;
      width: 20px;
    }
    [dir=ltr] .vertical-overlay-menu .main-menu .navigation > li > a > svg, [dir=ltr] .vertical-overlay-menu .main-menu .navigation > li > a > i {
      margin-right: 14px;
      float: left;
    }
    [dir=rtl] .vertical-overlay-menu .main-menu .navigation > li > a > svg, [dir=rtl] .vertical-overlay-menu .main-menu .navigation > li > a > i {
      margin-left: 14px;
      float: right;
    }
    .vertical-overlay-menu .main-menu .navigation > li > a > svg:before,
    .vertical-overlay-menu .main-menu .navigation > li > a > i:before {
      transition: 200ms ease all;
      font-size: 1.429rem;
    }
    .vertical-overlay-menu .main-menu .navigation li.has-sub > a:after {
      content: "";
      height: 1rem;
      width: 1rem;
      display: inline-block;
      position: absolute;
      top: 14px;
      transition: all 0.2s ease-out;
    }
     .vertical-overlay-menu .main-menu .navigation li.has-sub > a:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 1rem;
      transform: rotate(0deg);
    }
    [dir=ltr] .vertical-overlay-menu .main-menu .navigation li.has-sub > a:after {
      right: 20px;
    }
    [dir=rtl] .vertical-overlay-menu .main-menu .navigation li.has-sub > a:after {
      left: 20px;
    }
    [dir=ltr] .vertical-overlay-menu .main-menu .navigation li.has-sub.open:not(.menu-item-closing) > a:after {
      transform: rotate(90deg);
    }
    [dir=rtl] .vertical-overlay-menu .main-menu .navigation li.has-sub.open:not(.menu-item-closing) > a:after {
      transform: rotate(-90deg);
    }
    .vertical-overlay-menu .main-menu .navigation .navigation-header .feather-more-horizontal {
      display: none;
    }
    .vertical-overlay-menu.menu-open .main-menu {
      opacity: 1;
      transition: width 0.25s, opacity 0.25s, transform 0.25s;
    }
    [dir=ltr] .vertical-overlay-menu.menu-open .main-menu {
      transform: translate3d(260px, 0, 0);
    }
    [dir=rtl] .vertical-overlay-menu.menu-open .main-menu {
      transform: translate3d(-260px, 0, 0);
    }
    [dir=ltr] .vertical-overlay-menu.menu-open .second-menu {
      transform: translate3d(520px, 0, 0);
    }
    [dir=rtl] .vertical-overlay-menu.menu-open .second-menu {
      transform: translate3d(-520px, 0, 0);
    }
    [dir=ltr] .vertical-overlay-menu .second-menu {
      left: -520px;
    }
    [dir=rtl] .vertical-overlay-menu .second-menu {
      right: -520px;
    }
    [dir=ltr] .horizontal-menu .content {
      margin-left: 0;
    }
    [dir=rtl] .horizontal-menu .content {
      margin-right: 0;
    }
    .horizontal-menu .content.show-overlay .content-overlay {
      z-index: 998 !important;
    }
     .horizontal-menu .navbar.header-navbar .navbar-container {
      padding: 0 1rem;
    }
    .horizontal-menu .horizontal-menu-wrapper .header-navbar {
      min-height: 4.45rem;
    }
    .horizontal-menu footer {
      position: static;
    }
    .horizontal-menu .horizontal-menu-wrapper {
      position: fixed;
      top: 62px;
      z-index: 990;
      width: 100%;
    }
    .horizontal-menu .horizontal-menu-wrapper .header-navbar .navbar-container {
      width: 100%;
    }
     .horizontal-menu .horizontal-menu-wrapper .header-navbar .navbar-container {
      padding: 0 1rem;
    }
    .horizontal-menu .horizontal-menu-wrapper .header-navbar .navbar-header {
      display: none;
    }
    .horizontal-menu .header-navbar {
      z-index: 999 !important;
      line-height: 1;
      min-height: auto;
    }
     .horizontal-menu .header-navbar {
      background: #fff;
    }
    .horizontal-menu .header-navbar.navbar-horizontal.floating-nav {
      width: calc(100vw - (100vw - 100%) - calc(1rem * 2));
    }
     .horizontal-menu .header-navbar.navbar-horizontal.floating-nav {
      background: #fff;
    }
     .horizontal-menu .header-navbar .navbar-container {
      border-radius: 0.357rem;
    }
    .horizontal-menu .header-navbar.navbar-fixed {
      position: fixed;
      width: 100%;
    }
    .horizontal-menu .header-navbar.navbar-brand-center .navbar-header {
      position: absolute;
      z-index: 1000;
    }
     .horizontal-menu .header-navbar.navbar-brand-center .navbar-header {
      padding: 0;
    }
    [dir=ltr] .horizontal-menu .header-navbar.navbar-brand-center .navbar-header {
      left: calc(50% - 56px);
    }
    [dir=rtl] .horizontal-menu .header-navbar.navbar-brand-center .navbar-header {
      right: calc(50% - 56px);
    }
    .horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand {
      display: flex;
      align-items: center;
      font-size: inherit;
    }
    [dir=ltr] .horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand {
      margin-right: 0;
    }
    [dir=rtl] .horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand {
      margin-left: 0;
    }
    .horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand .brand-logo img {
      max-width: 36px;
    }
    .horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand .brand-text {
      color: #114A9F;
      font-weight: 600;
      letter-spacing: 0.01rem;
      font-size: 1.45rem;
    }
     .horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand .brand-text {
      margin-bottom: 0;
    }
    [dir=ltr] .horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand .brand-text {
      padding-left: 1rem;
    }
    [dir=rtl] .horizontal-menu .header-navbar.navbar-brand-center .navbar-header .navbar-brand .brand-text {
      padding-right: 1rem;
    }
     .horizontal-menu .header-navbar.navbar-horizontal .nav-link.dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    [dir=ltr] .horizontal-menu .header-navbar.navbar-horizontal .nav-link.dropdown-toggle::after {
      left: 0.4rem;
    }
    [dir=rtl] .horizontal-menu .header-navbar.navbar-horizontal .nav-link.dropdown-toggle::after {
      right: 0.4rem;
    }
     .horizontal-menu .header-navbar.navbar-horizontal .sidebar-group-active .dropdown-toggle::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23114A9F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    }
    .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu::before {
      display: none;
    }
    .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu {
      min-width: 215px;
      min-height: 40px;
    }
     .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu {
      border: none;
      margin-top: 0;
    }
    .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .disabled {
      pointer-events: none !important;
    }
    .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .disabled a {
      color: #b8c2cc;
    }
    .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {
      position: absolute;
      top: 50%;
    }
     .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {
      margin-top: -7px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    }
    [dir=ltr] .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {
      left: auto;
      right: 1rem;
    }
    [dir=rtl] .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {
      right: auto;
      left: 1rem;
    }
    .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-item {
      font-size: 1rem;
      display: flex;
      align-items: center;
    }
     .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-item {
      padding-top: 0.68rem;
      padding-bottom: 0.68rem;
    }
    .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu {
      position: relative;
    }
    [dir=ltr] .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu.openLeft .dropdown-menu {
      left: auto !important;
      right: 100% !important;
    }
    [dir=rtl] .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu.openLeft .dropdown-menu {
      right: auto !important;
      left: 100% !important;
    }
     .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu.sidebar-group-active {
      background: #f8f8f8;
    }
    .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu > .dropdown-menu {
      position: absolute;
      top: 0 !important;
    }
    [dir=ltr] .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu > .dropdown-menu {
      left: 100% !important;
    }
    [dir=rtl] .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu > .dropdown-menu {
      right: 100% !important;
    }
    .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu > .dropdown-menu i,
    .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-submenu > .dropdown-menu svg {
      height: 11px !important;
      width: 11px !important;
      font-size: 11px !important;
    }
     .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li {
      padding-top: 0.857rem;
      padding-bottom: 0.857rem;
    }
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > .dropdown-menu a > * {
      transition: all 0.2s ease;
    }
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > .dropdown-menu a:hover {
      color: #424244;
    }
     .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > .dropdown-menu a:hover {
      background-color: transparent;
    }
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > .dropdown-menu a:hover > * {
      transition: transform 0.2s ease;
    }
    [dir=ltr] .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > .dropdown-menu a:hover > * {
      transform: translateX(5px);
    }
    [dir=rtl] .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > .dropdown-menu a:hover > * {
      transform: translateX(-5px);
    }
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > .dropdown-menu .active > a {
      color: #114A9F;
      font-weight: 500;
    }
     .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > .dropdown-menu .active > a {
      background: #f8f8f8;
    }
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > .dropdown-menu .open.active > a {
      color: #114A9F;
      font-weight: 500;
    }
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li i,
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li svg {
      height: 17px;
      width: 17px;
      font-size: 1.2rem;
    }
    [dir=ltr] .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li i, [dir=ltr] .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li svg {
      margin-right: 0.5rem;
    }
    [dir=rtl] .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li i, [dir=rtl] .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li svg {
      margin-left: 0.5rem;
    }
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > a {
      display: flex;
      color: #fff;
    }
     .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > a {
      padding: 0.715rem 0.7rem;
    }
    [dir=ltr] .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > a {
      margin-right: 0.715rem;
    }
    [dir=rtl] .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > a {
      margin-left: 0.715rem;
    }
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li > a::after {
      color: #fff;
      display: none;
    }
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li:hover > a {
      color: #114A9F;
    }
     .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li:hover > a {
      background: #f8f8f8;
      border-radius: 4px;
    }
    .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li.active > a {
      color: #114A9F;
    }
     .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation > li.active > a {
      background: #f8f8f8;
      box-shadow: 0px 0px 6px 1px rgba(17, 74, 159, 0.6);
      border-radius: 4px;
    }
    .horizontal-menu .navigation-header {
      font-family: inherit;
      color: #929292;
      font-size: 1rem;
      text-transform: uppercase;
    }
     .horizontal-menu .navigation-header {
      padding: 8px 20px;
    }
     .horizontal-menu .navbar-dark .nav-item.active > a {
      border-bottom: 2px solid #114A9F;
      background-color: #313c50;
    }
    .horizontal-layout.navbar-floating .header-navbar-shadow {
      height: 80px;
    }
    @media (min-width: 1200px) {
    .horizontal-layout.navbar-floating .header-navbar-shadow {
        top: 45px;
    }
    }
     .horizontal-layout.navbar-floating:not(.blank-page) .app-content {
      padding: calc(1rem + 4rem* 2 + 1.3rem) 1rem 0 1rem;
    }
     .horizontal-layout.navbar-floating .horizontal-menu-wrapper {
      background: linear-gradient(to bottom, rgba(248, 248, 248, 0.95) 44%, rgba(248, 248, 248, 0.46) 73%, rgba(255, 255, 255, 0) 100%);
      background-repeat: repeat-x;
    }
     .horizontal-layout.navbar-floating .horizontal-menu-wrapper .navbar-horizontal.floating-nav {
      margin: 1.3rem 1rem 0;
    }
    .horizontal-layout.navbar-floating.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-floating.footer-static .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 1) + 4rem + 3.35rem + 1.3rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 1) + 4rem + 3.35rem + 1.3rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-floating.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-floating.footer-static .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 1) + 4rem + 3.35rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 1) + 4rem + 3.35rem) );
    }
    }
    .horizontal-layout.navbar-floating.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-floating.footer-hidden .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 0rem + 1.3rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 0rem + 1.3rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-floating.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-floating.footer-hidden .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 0rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 0rem) );
    }
    }
    .horizontal-layout.navbar-floating.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-floating.footer-fixed .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 3.35rem + 1.3rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 3.35rem + 1.3rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-floating.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-floating.footer-fixed .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 3.35rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 3.35rem) );
    }
    }
     .horizontal-layout.navbar-sticky .app-content {
      padding: calc(1rem + 4rem* 1.2) 1rem 0 1rem;
    }
     .horizontal-layout.navbar-sticky .header-navbar {
      background-color: #114A9F;
      box-shadow: none;
    }
     .horizontal-layout.navbar-sticky .horizontal-menu-wrapper .navbar-horizontal.header-navbar.fixed-top {
      background-color: #114A9F;
      box-shadow: 0px 4px 24px rgba(34, 41, 47, 0.06);
    }
    [dir=ltr] .horizontal-layout.navbar-sticky .horizontal-menu-wrapper .navbar-horizontal.header-navbar.fixed-top {
      left: 0;
    }
    [dir=rtl] .horizontal-layout.navbar-sticky .horizontal-menu-wrapper .navbar-horizontal.header-navbar.fixed-top {
      right: 0;
    }
    .horizontal-layout.navbar-sticky.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-sticky.footer-static .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 1) + 4rem + 3.35rem + 0rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 1) + 4rem + 3.35rem + 0rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-sticky.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-sticky.footer-static .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 1) + 4rem + 3.35rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 1) + 4rem + 3.35rem) );
    }
    }
    .horizontal-layout.navbar-sticky.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-sticky.footer-hidden .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 0rem + 0rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 0rem + 0rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-sticky.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-sticky.footer-hidden .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 0rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 0rem) );
    }
    }
    .horizontal-layout.navbar-sticky.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-sticky.footer-fixed .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 3.35rem + 0rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 3.35rem + 0rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-sticky.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-sticky.footer-fixed .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 3.35rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 3.35rem) );
    }
    }
     .horizontal-layout.navbar-static .app-content {
      padding: calc(1rem + 4.45rem) 1rem 0 1rem;
    }
    .horizontal-layout.navbar-static .content {
      min-height: calc(100% - calc(4.45rem + calc(3.35rem + 0.2rem)));
    }
     .horizontal-layout.navbar-static .header-navbar {
      background-color: #f8f8f8;
      box-shadow: none;
    }
    .horizontal-layout.navbar-static .horizontal-menu-wrapper {
      position: relative;
    }
     .horizontal-layout.navbar-static .horizontal-menu-wrapper .navbar-horizontal.header-navbar {
      background: #fff;
    }
    .horizontal-layout.navbar-static .horizontal-menu-wrapper .navbar-horizontal.header-navbar.navbar-static-top {
      width: 100%;
    }
    [dir=ltr] .horizontal-layout.navbar-static .horizontal-menu-wrapper .navbar-horizontal.header-navbar.navbar-static-top {
      left: 0;
    }
    [dir=rtl] .horizontal-layout.navbar-static .horizontal-menu-wrapper .navbar-horizontal.header-navbar.navbar-static-top {
      right: 0;
    }
    .horizontal-layout.navbar-static.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-static.footer-static .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 1) + 4rem + calc(3.35rem + 0.2rem) + 0rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 1) + 4rem + calc(3.35rem + 0.2rem) + 0rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-static.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-static.footer-static .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 1) + 4rem + calc(3.35rem + 0.2rem)) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 1) + 4rem + calc(3.35rem + 0.2rem)) );
    }
    }
    .horizontal-layout.navbar-static.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-static.footer-hidden .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 0rem + 0rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 0rem + 0rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-static.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-static.footer-hidden .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 0rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 0rem) );
    }
    }
    .horizontal-layout.navbar-static.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-static.footer-fixed .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 4rem + 3.35rem + 0rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 4rem + 3.35rem + 0rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-static.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-static.footer-fixed .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 3.35rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 2) + 4rem + 3.35rem) );
    }
    }
    .horizontal-layout.navbar-hidden.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-hidden.footer-static .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 1) + 0rem + 3.35rem + 0rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 1) + 0rem + 3.35rem + 0rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-hidden.footer-static .app-content .content-area-wrapper,
    .horizontal-layout.navbar-hidden.footer-static .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 1) + 0rem + 3.35rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 1) + 0rem + 3.35rem) );
    }
    }
    .horizontal-layout.navbar-hidden.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-hidden.footer-hidden .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 0rem + 0rem + 0rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 0rem + 0rem + 0rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-hidden.footer-hidden .app-content .content-area-wrapper,
    .horizontal-layout.navbar-hidden.footer-hidden .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 2) + 0rem + 0rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 2) + 0rem + 0rem) );
    }
    }
    .horizontal-layout.navbar-hidden.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-hidden.footer-fixed .app-content .kanban-wrapper {
      height: calc( 100vh - calc( calc(1rem * 2) + 0rem + 3.35rem + 0rem + 4.45rem ) );
      height: calc( var(--vh, 1vh) * 100 - calc( calc(1rem * 2) + 0rem + 3.35rem + 0rem + 4.45rem ) );
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.navbar-hidden.footer-fixed .app-content .content-area-wrapper,
    .horizontal-layout.navbar-hidden.footer-fixed .app-content .kanban-wrapper {
        height: calc( 100vh - calc(calc(calc(1rem - 0.8rem) * 2) + 0rem + 3.35rem) );
        height: calc( var(--vh, 1vh) * 100 - calc(calc(calc(1rem - 0.8rem) * 2) + 0rem + 3.35rem) );
    }
    }
    .horizontal-layout.vertical-overlay-menu #main-menu-navigation > li > ul > li > a i,
    .horizontal-layout.vertical-overlay-menu #main-menu-navigation > li > ul > li > a svg {
      height: 1rem;
      width: 1rem;
      font-size: 1rem;
    }
    @media (max-width: 1199.98px) {
    .horizontal-layout.horizontal-menu .horizontal-menu-wrapper .header-navbar {
        display: none;
    }
     .horizontal-layout .header-navbar {
        background: #fff;
    }
     .horizontal-layout .app-content {
        padding: calc(4rem + calc(1rem - 0.8rem)) calc(1rem - 0.8rem) 0 calc(1rem - 0.8rem) !important;
    }
    }
    @media (max-width: 575.98px) {
    html body.horizontal-layout.navbar-static .app-content {
        padding: calc(1rem - 0.8rem + 4rem) calc(1rem - 0.8rem) 0 calc(1rem - 0.8rem) !important;
    }
    }
    /*=========================================================================================
        File Name: vertical-overlay-menu.scss
        Description: A overlay style vertical menu with show and hide support. It support
        light & dark version, filpped layout, right side icons, native scroll and borders menu
        item seperation.
    
    ==========================================================================================*/
    [dir=ltr] .vertical-overlay-menu .content {
      margin-left: 0;
    }
    [dir=rtl] .vertical-overlay-menu .content {
      margin-right: 0;
    }
    .vertical-overlay-menu .navbar .navbar-header {
      width: 260px;
    }
    [dir=ltr] .vertical-overlay-menu .navbar .navbar-header {
      float: left;
    }
    [dir=rtl] .vertical-overlay-menu .navbar .navbar-header {
      float: right;
    }
    .vertical-overlay-menu .main-menu, .vertical-overlay-menu.menu-hide .main-menu {
      opacity: 0;
      transition: width 0.25s, opacity 0.25s, transform 0.25s;
      width: 260px;
    }
     .vertical-overlay-menu .main-menu,  .vertical-overlay-menu.menu-hide .main-menu {
      transform: translate3d(0, 0, 0);
    }
    [dir=ltr] .vertical-overlay-menu .main-menu, [dir=ltr] .vertical-overlay-menu.menu-hide .main-menu {
      left: -260px;
    }
    [dir=rtl] .vertical-overlay-menu .main-menu, [dir=rtl] .vertical-overlay-menu.menu-hide .main-menu {
      right: -260px;
    }
    .vertical-overlay-menu .main-menu .navigation > li > a > svg,
    .vertical-overlay-menu .main-menu .navigation > li > a > i {
      transition: 200ms ease all;
      height: 20px;
      width: 20px;
    }
    [dir=ltr] .vertical-overlay-menu .main-menu .navigation > li > a > svg, [dir=ltr] .vertical-overlay-menu .main-menu .navigation > li > a > i {
      margin-right: 14px;
      float: left;
    }
    [dir=rtl] .vertical-overlay-menu .main-menu .navigation > li > a > svg, [dir=rtl] .vertical-overlay-menu .main-menu .navigation > li > a > i {
      margin-left: 14px;
      float: right;
    }
    .vertical-overlay-menu .main-menu .navigation > li > a > svg:before,
    .vertical-overlay-menu .main-menu .navigation > li > a > i:before {
      transition: 200ms ease all;
      font-size: 1.429rem;
    }
    .vertical-overlay-menu .main-menu .navigation li.has-sub > a:after {
      content: "";
      height: 1rem;
      width: 1rem;
      display: inline-block;
      position: absolute;
      top: 14px;
      transition: all 0.2s ease-out;
    }
     .vertical-overlay-menu .main-menu .navigation li.has-sub > a:after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23424244' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 1rem;
      transform: rotate(0deg);
    }
    [dir=ltr] .vertical-overlay-menu .main-menu .navigation li.has-sub > a:after {
      right: 20px;
    }
    [dir=rtl] .vertical-overlay-menu .main-menu .navigation li.has-sub > a:after {
      left: 20px;
    }
    [dir=ltr] .vertical-overlay-menu .main-menu .navigation li.has-sub.open:not(.menu-item-closing) > a:after {
      transform: rotate(90deg);
    }
    [dir=rtl] .vertical-overlay-menu .main-menu .navigation li.has-sub.open:not(.menu-item-closing) > a:after {
      transform: rotate(-90deg);
    }
    .vertical-overlay-menu .main-menu .navigation .navigation-header .feather-more-horizontal {
      display: none;
    }
    .vertical-overlay-menu.menu-open .main-menu {
      opacity: 1;
      transition: width 0.25s, opacity 0.25s, transform 0.25s;
    }
    [dir=ltr] .vertical-overlay-menu.menu-open .main-menu {
      transform: translate3d(260px, 0, 0);
    }
    [dir=rtl] .vertical-overlay-menu.menu-open .main-menu {
      transform: translate3d(-260px, 0, 0);
    }
    [dir=ltr] .vertical-overlay-menu.menu-open .second-menu {
      transform: translate3d(520px, 0, 0);
    }
    [dir=rtl] .vertical-overlay-menu.menu-open .second-menu {
      transform: translate3d(-520px, 0, 0);
    }
    [dir=ltr] .vertical-overlay-menu .second-menu {
      left: -520px;
    }
    [dir=rtl] .vertical-overlay-menu .second-menu {
      right: -520px;
    }
    .bordered-layout .header-navbar {
      box-shadow: none;
    }
     .bordered-layout .header-navbar.floating-nav {
      border: 1px solid #ebe9f1;
    }
     .bordered-layout .header-navbar.fixed-top {
      border-bottom: 1px solid #ebe9f1;
      background: #f8f8f8;
    }
     .bordered-layout .main-menu {
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
    }
     .bordered-layout .main-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a,  .bordered-layout .main-menu.menu-light .navigation > li.sidebar-group-active > a {
      background: #ededed;
    }
     .bordered-layout .dropdown-menu {
      border: 1px solid #ebe9f1 !important;
      box-shadow: none;
    }
     .bordered-layout .main-menu .navigation,  .bordered-layout .main-menu {
      background: #fff;
    }
     .bordered-layout .card,  .bordered-layout .bs-stepper:not(.wizard-modern):not(.checkout-tab-steps),  .bordered-layout .bs-stepper.wizard-modern .bs-stepper-content {
      border: 1px solid #ebe9f1;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
    }
     .bordered-layout .footer {
      box-shadow: none !important;
    }
     .bordered-layout .footer-fixed .footer {
      border-top: 1px solid #ebe9f1;
    }
    .v-select {
      position: relative;
      font-family: inherit;
    }
    .v-select,
    .v-select * {
      box-sizing: border-box;
    }
    
    @-webkit-keyframes vSelectSpinner-ltr {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    }
    @-webkit-keyframes vSelectSpinner-rtl {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(-360deg);
    }
    }
    @keyframes vSelectSpinner-ltr {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    }
    @keyframes vSelectSpinner-rtl {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(-360deg);
    }
    }
    /* Dropdown Default Transition */
    .vs__fade-enter-active,
    .vs__fade-leave-active {
      pointer-events: none;
      transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .vs__fade-enter,
    .vs__fade-leave-to {
      opacity: 0;
    }
    
    /** Component States */
    /*
     * Disabled
     *
     * When the component is disabled, all interaction
     * should be prevented. Here we modify the bg color,
     * and change the cursor displayed on the interactive
     * components.
     */
     .vs--disabled .vs__dropdown-toggle,  .vs--disabled .vs__clear,  .vs--disabled .vs__search,  .vs--disabled .vs__selected,  .vs--disabled .vs__open-indicator {
      cursor: not-allowed;
      background-color: #f8f8f8;
    }
    .v-select[dir=rtl] .vs__actions {
      padding: 0 3px 0 6px;
    }
    .v-select[dir=rtl] .vs__clear {
      margin-left: 6px;
      margin-right: 0;
    }
    .v-select[dir=rtl] .vs__deselect {
      margin-left: 0;
      margin-right: 2px;
    }
    .v-select[dir=rtl] .vs__dropdown-menu {
      text-align: right;
    }
    .vs__dropdown-toggle {
      appearance: none;
      display: flex;
      white-space: normal;
    }
     .vs__dropdown-toggle {
      padding: 0 0 4px 0;
      background: none;
      border: 1px solid #D6D9E1;
      border-radius: 0.357rem;
    }
    .vs__selected-options {
      display: flex;
      flex-basis: 100%;
      flex-grow: 1;
      flex-wrap: wrap;
      position: relative;
    }
     .vs__selected-options {
      padding: 0 2px;
    }
    .vs__actions {
      display: flex;
      align-items: center;
    }
    [dir=ltr] .vs__actions {
      padding: 4px 6px 0 3px;
    }
    [dir=rtl] .vs__actions {
      padding: 4px 3px 0 6px;
    }
    
    /* Dropdown Toggle States */
     .vs--searchable .vs__dropdown-toggle {
      cursor: text;
    }
     .vs--unsearchable .vs__dropdown-toggle {
      cursor: pointer;
    }
     .vs--open .vs__dropdown-toggle {
      border-bottom-color: transparent;
    }
    [dir=ltr] .vs--open .vs__dropdown-toggle {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=rtl] .vs--open .vs__dropdown-toggle {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    .vs__open-indicator {
      fill: rgba(60, 60, 60, 0.5);
      transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    }
     .vs__open-indicator {
      transform: scale(1);
      transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
    }
    [dir=ltr] .vs--open .vs__open-indicator {
      transform: rotate(180deg) scale(1);
    }
    [dir=rtl] .vs--open .vs__open-indicator {
      transform: rotate(-180deg) scale(1);
    }
    .vs--loading .vs__open-indicator {
      opacity: 0;
    }
    
    /* Clear Button */
    .vs__clear {
      fill: rgba(60, 60, 60, 0.5);
    }
     .vs__clear {
      padding: 0;
      border: 0;
      background-color: transparent;
      cursor: pointer;
    }
    [dir=ltr] .vs__clear {
      margin-right: 8px;
    }
    [dir=rtl] .vs__clear {
      margin-left: 8px;
    }
    
    /* Dropdown Menu */
    .vs__dropdown-menu {
      display: block;
      box-sizing: border-box;
      position: absolute;
      top: calc(100% - 1px);
      z-index: 1000;
      width: 100%;
      max-height: 350px;
      min-width: 160px;
      overflow-y: auto;
      list-style: none;
    }
     .vs__dropdown-menu {
      padding: 5px 0;
      margin: 0;
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
      border: 1px solid #D6D9E1;
      border-top-style: none;
      border-radius: 0 0 0.357rem 0.357rem;
      background: #fff;
    }
    [dir=ltr] .vs__dropdown-menu {
      left: 0;
      text-align: left;
    }
    [dir=rtl] .vs__dropdown-menu {
      right: 0;
      text-align: right;
    }
     .vs__no-options {
      text-align: center;
    }
    
    /* List Items */
    .vs__dropdown-option {
      line-height: 1.42857143;
      /* Normalize line height */
      display: block;
      color: #333;
      /* Overrides most CSS frameworks */
      white-space: nowrap;
    }
     .vs__dropdown-option {
      padding: 3px 20px;
      clear: both;
    }
     .vs__dropdown-option:hover {
      cursor: pointer;
    }
    .vs__dropdown-option--highlight {
      color: #114A9F !important;
    }
     .vs__dropdown-option--highlight {
      background: rgba(17, 74, 159, 0.12);
    }
    .vs__dropdown-option--disabled {
      color: rgba(60, 60, 60, 0.5);
    }
     .vs__dropdown-option--disabled {
      background: inherit;
    }
     .vs__dropdown-option--disabled:hover {
      cursor: inherit;
    }
    
    /* Selected Tags */
    .vs__selected {
      display: flex;
      align-items: center;
      color: #333;
      line-height: 1.8;
      z-index: 0;
    }
     .vs__selected {
      background-color: #114A9F;
      border: 0 solid rgba(60, 60, 60, 0.26);
      border-radius: 0.357rem;
      margin: 4px 2px 0px 2px;
      padding: 0 0.25em;
    }
    .vs__deselect {
      display: inline-flex;
      appearance: none;
      fill: rgba(60, 60, 60, 0.5);
    }
     .vs__deselect {
      padding: 0;
      border: 0;
      cursor: pointer;
      background: none;
      text-shadow: 0 1px 0 #fff;
    }
    [dir=ltr] .vs__deselect {
      margin-left: 4px;
    }
    [dir=rtl] .vs__deselect {
      margin-right: 4px;
    }
    
    /* States */
     .vs--single .vs__selected {
      background-color: transparent;
      border-color: transparent;
    }
    .vs--single.vs--open .vs__selected {
      position: absolute;
      opacity: 0.4;
    }
    .vs--single.vs--searching .vs__selected {
      display: none;
    }
    
    /* Search Input */
    /**
     * Super weird bug... If this declaration is grouped
     * below, the cancel button will still appear in chrome.
     * If it's up here on it's own, it'll hide it.
     */
    .vs__search::-webkit-search-cancel-button {
      display: none;
    }
    .vs__search::-webkit-search-decoration,
    .vs__search::-webkit-search-results-button,
    .vs__search::-webkit-search-results-decoration,
    .vs__search::-ms-clear {
      display: none;
    }
    .vs__search,
    .vs__search:focus {
      appearance: none;
      line-height: 1.8;
      font-size: 1em;
      outline: none;
      width: 0;
      max-width: 100%;
      flex-grow: 1;
      z-index: 1;
    }
     .vs__search,  .vs__search:focus {
      border: 1px solid transparent;
      margin: 4px 0 0 0;
      padding: 0 7px;
      background: none;
      box-shadow: none;
    }
    [dir=ltr] .vs__search, [dir=ltr] .vs__search:focus {
      border-left: none;
    }
    [dir=rtl] .vs__search, [dir=rtl] .vs__search:focus {
      border-right: none;
    }
    .vs__search::placeholder {
      color: #424244;
    }
    
    /**
        States
     */
    .vs--unsearchable .vs__search {
      opacity: 1;
    }
     .vs--unsearchable:not(.vs--disabled) .vs__search:hover {
      cursor: pointer;
    }
    .vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {
      opacity: 0.2;
    }
    
    /* Loading Spinner */
    .vs__spinner {
      align-self: center;
      opacity: 0;
      font-size: 5px;
      text-indent: -9999em;
      overflow: hidden;
      transition: opacity 0.1s;
    }
     .vs__spinner {
      border-top: 0.9em solid rgba(100, 100, 100, 0.1);
      border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);
      transform: translateZ(0);
    }
    [dir=ltr] .vs__spinner {
      border-right: 0.9em solid rgba(100, 100, 100, 0.1);
      border-left: 0.9em solid rgba(60, 60, 60, 0.45);
      animation:  vSelectSpinner-ltr 1.1s infinite linear;
    }
    [dir=rtl] .vs__spinner {
      border-left: 0.9em solid rgba(100, 100, 100, 0.1);
      border-right: 0.9em solid rgba(60, 60, 60, 0.45);
      animation:  vSelectSpinner-rtl 1.1s infinite linear;
    }
    .vs__spinner,
    .vs__spinner:after {
      width: 5em;
      height: 5em;
    }
     .vs__spinner,  .vs__spinner:after {
      border-radius: 50%;
    }
    
    /* Loading Spinner States */
    .vs--loading .vs__spinner {
      opacity: 1;
    }
    .vs__open-indicator {
      fill: none;
    }
     .vs__open-indicator {
      margin-top: 0.15rem;
    }
    .vs__dropdown-toggle {
      transition: all 0.25s ease-in-out;
    }
     .vs__dropdown-toggle {
      padding: 0.59px 0 2px 0;
    }
    [dir=ltr] .vs--single .vs__dropdown-toggle {
      padding-left: 6px;
    }
    [dir=rtl] .vs--single .vs__dropdown-toggle {
      padding-right: 6px;
    }
    .vs__dropdown-option--disabled {
      opacity: 0.5;
    }
     .vs__dropdown-option--disabled.vs__dropdown-option--selected {
      background: #114A9F !important;
    }
    .vs__dropdown-option {
      color: #424244;
    }
     .vs__dropdown-option,  .vs__no-options {
      padding: 7px 20px;
    }
    .vs__dropdown-option--selected {
      background-color: #114A9F;
      color: #fff;
      position: relative;
    }
    .vs__dropdown-option--selected::after {
      content: "";
      height: 1.1rem;
      width: 1.1rem;
      display: inline-block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 1.1rem;
    }
    [dir=rtl] .vs__dropdown-option--selected::after {
      left: 20px;
      right: unset;
    }
    .vs__dropdown-option--selected.vs__dropdown-option--highlight {
      color: #fff !important;
      background-color: #114A9F !important;
    }
    .vs__clear svg {
      color: #424244;
    }
    .vs__selected {
      color: #fff;
    }
    .v-select.vs--single .vs__selected {
      color: #424244;
      transition: transform 0.2s ease;
    }
     .v-select.vs--single .vs__selected {
      margin-top: 5px;
    }
    [dir=ltr] .v-select.vs--single .vs__selected input {
      padding-left: 0;
    }
    [dir=rtl] .v-select.vs--single .vs__selected input {
      padding-right: 0;
    }
    [dir=ltr] .vs--single.vs--open .vs__selected {
      transform: translateX(5px);
    }
    [dir=rtl] .vs--single.vs--open .vs__selected {
      transform: translateX(-5px);
    }
    .vs__selected .vs__deselect {
      color: inherit;
    }
    .v-select:not(.vs--single) .vs__selected {
      font-size: 0.9rem;
    }
     .v-select:not(.vs--single) .vs__selected {
      border-radius: 3px;
      padding: 0 0.6em;
    }
    [dir=ltr] .v-select:not(.vs--single) .vs__selected {
      margin: 5px 2px 2px 5px;
    }
    [dir=rtl] .v-select:not(.vs--single) .vs__selected {
      margin: 5px 5px 2px 2px;
    }
    .v-select:not(.vs--single) .vs__deselect svg {
      vertical-align: text-top;
    }
     .v-select:not(.vs--single) .vs__deselect svg {
      transform: scale(0.8);
    }
    .vs__dropdown-menu {
      top: calc(100% + 0.5rem);
    }
     .vs__dropdown-menu {
      border: none;
      border-radius: 6px;
      padding: 0;
    }
     .vs--open .vs__dropdown-toggle {
      border-color: #114A9F;
      border-bottom-color: #114A9F;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
    [dir=ltr] .vs--open .vs__dropdown-toggle {
      border-bottom-left-radius: 0.357rem;
      border-bottom-right-radius: 0.357rem;
    }
    [dir=rtl] .vs--open .vs__dropdown-toggle {
      border-bottom-right-radius: 0.357rem;
      border-bottom-left-radius: 0.357rem;
    }
    .select-size-lg .vs__selected {
      font-size: 1rem !important;
    }
     .select-size-lg.vs--single.vs--open .vs__selected {
      margin-top: 6px;
    }
    .select-size-lg .vs__dropdown-toggle,
    .select-size-lg .vs__selected {
      font-size: 1.25rem;
    }
     .select-size-lg .vs__dropdown-toggle {
      padding: 5px;
    }
     .select-size-lg .vs__dropdown-toggle input {
      margin-top: 0;
    }
    .select-size-lg .vs__deselect svg {
      vertical-align: middle !important;
    }
     .select-size-lg .vs__deselect svg {
      transform: scale(1) !important;
    }
     .select-size-sm .vs__dropdown-toggle {
      padding-bottom: 0;
      padding: 1px;
    }
     .select-size-sm.vs--single .vs__dropdown-toggle {
      padding: 2px;
    }
    .select-size-sm .vs__dropdown-toggle,
    .select-size-sm .vs__selected {
      font-size: 0.9rem;
    }
     .select-size-sm .vs__actions {
      padding-top: 2px;
      padding-bottom: 2px;
    }
    .select-size-sm .vs__deselect svg {
      vertical-align: middle !important;
    }
     .select-size-sm .vs__search {
      margin-top: 0;
    }
    .select-size-sm.v-select .vs__selected {
      font-size: 0.75rem;
    }
     .select-size-sm.v-select .vs__selected {
      padding: 0 0.3rem;
    }
     .select-size-sm.v-select:not(.vs--single) .vs__selected {
      margin: 4px 5px;
    }
     .select-size-sm.v-select.vs--single .vs__selected {
      margin-top: 1px;
    }
     .select-size-sm.vs--single.vs--open .vs__selected {
      margin-top: 4px;
    }
    .dark-layout .vs__dropdown-toggle {
      color: #b4b7bd;
    }
     .dark-layout .vs__dropdown-toggle {
      background: #283046;
      border-color: #404656;
    }
    .dark-layout .vs__selected-options input {
      color: #b4b7bd;
    }
    .dark-layout .vs__selected-options input::placeholder {
      color: #676d7d;
    }
    .dark-layout .vs__actions svg {
      fill: #404656;
    }
     .dark-layout .vs__dropdown-menu {
      background: #283046;
    }
    .dark-layout .vs__dropdown-menu li {
      color: #b4b7bd;
    }
    .dark-layout .v-select:not(.vs--single) .vs__selected {
      color: #114A9F;
    }
     .dark-layout .v-select:not(.vs--single) .vs__selected {
      background-color: rgba(17, 74, 159, 0.12);
    }
    .dark-layout .v-select.vs--single .vs__selected {
      color: #b4b7bd !important;
    }
    .dark-layout .vs--disabled .vs__dropdown-toggle,
    .dark-layout .vs--disabled .vs__clear,
    .dark-layout .vs--disabled .vs__search,
    .dark-layout .vs--disabled .vs__selected,
    .dark-layout .vs--disabled .vs__open-indicator {
      opacity: 0.5;
      color: inherit !important;
    }
     .dark-layout .vs--disabled .vs__dropdown-toggle,  .dark-layout .vs--disabled .vs__clear,  .dark-layout .vs--disabled .vs__search,  .dark-layout .vs--disabled .vs__selected,  .dark-layout .vs--disabled .vs__open-indicator {
      background-color: #283046;
    }
    .vs--disabled .vs__selected {
      color: inherit !important;
    }
    .vs--disabled .vs__selected button {
      display: none;
    }
    .customizer-section[data-v-52667d36] {
      padding: 1.5rem;
      border-bottom: 1px solid #ebe9f1;
    }
     .dark-layout .customizer-section[data-v-52667d36] {
      border-color: #3b4253;
    }
    [dir=ltr] .customizer-section #skin-radio-group[data-v-52667d36]  .custom-control-inline {
      margin-right: 0.7rem;
    }
    [dir=rtl] .customizer-section #skin-radio-group[data-v-52667d36]  .custom-control-inline {
      margin-left: 0.7rem;
    }
     .customizer-section .form-group[data-v-52667d36] {
      margin-bottom: 1.5rem;
    }
     .customizer-section .form-group[data-v-52667d36]:last-of-type {
      margin-bottom: 0;
    }
    .customizer-section .form-group[data-v-52667d36]  legend {
      font-weight: 500;
    }
     .mark-active[data-v-52667d36] {
      box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    }
    .ps-customizer-area[data-v-52667d36] {
      height: calc(100% - 83px);
    }
    @font-face {
      font-weight: 400;
      font-style:  normal;
      font-family: 'Circular-Loom';
    
      src: url('https://cdn.loom.com/assets/fonts/circular/CircularXXWeb-Book-cd7d2bcec649b1243839a15d5eb8f0a3.woff2') format('woff2');
    }
    
    @font-face {
      font-weight: 500;
      font-style:  normal;
      font-family: 'Circular-Loom';
    
      src: url('https://cdn.loom.com/assets/fonts/circular/CircularXXWeb-Medium-d74eac43c78bd5852478998ce63dceb3.woff2') format('woff2');
    }
    
    @font-face {
      font-weight: 700;
      font-style:  normal;
      font-family: 'Circular-Loom';
    
      src: url('https://cdn.loom.com/assets/fonts/circular/CircularXXWeb-Bold-83b8ceaf77f49c7cffa44107561909e4.woff2') format('woff2');
    }
    
    @font-face {
      font-weight: 900;
      font-style:  normal;
      font-family: 'Circular-Loom';
    
      src: url('https://cdn.loom.com/assets/fonts/circular/CircularXXWeb-Black-bf067ecb8aa777ceb6df7d72226febca.woff2') format('woff2');
    }
    #modal-payment .list-paid {
      height: calc( 100vh - 515px);
    }
    #modal-payment .list-paid .item-detail {
      line-height: 18px;
    }
     #modal-payment .list-paid .item-detail {
      padding: 8px 1.5rem;
    }
     #modal-payment .list-paid .item-detail:hover {
      background: rgba(193, 193, 193, 0.12);
    }
    #modal-payment .list-paid .item-detail .payment-method {
      display: flex;
      justify-content: space-between;
      font-weight: 500;
    }
    #modal-payment .list-paid .item-detail .note {
      display: flex;
      justify-content: space-between;
    }
    #modal-payment .header {
      display: flex;
      justify-content: space-between;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
     #modal-payment .header {
      padding-bottom: 1rem;
    }
    #modal-payment .header .header-amount {
      color: #114A9F;
    }
    #modal-payment .footer {
      display: flex;
      justify-content: space-between;
    }
     #modal-payment .footer {
      padding: 1.5rem;
      border-top: 1px solid #D6D9E1;
    }
    #modal-payment .footer .footer-left {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
    #modal-payment .footer .footer-right {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #EA5455;
    }
     #modal-payment .paymentType {
      padding: 10px 20px;
    }
    #modal-payment .paymentType-header {
      display: flex;
      font-weight: bold;
    }
     #modal-payment .paymentType-header-item {
      padding: 5px 0;
    }
     #modal-payment .paymentType-select-item {
      padding: 5px 0;
      cursor: pointer;
    }
    #modal-payment .paymentType-select-method:hover {
      color: #114a9f;
    }
     #modal-payment .paymentType-select-method:hover {
      background-color: #e2e9f3;
      cursor: pointer;
    }
    #modal-payment .hWbsMd {
      white-space: nowrap;
      display: flex;
      flex-direction: column;
    }
    #modal-payment .fQQQgg {
      display: block;
      width: auto;
      min-width: 520px;
      z-index: 15;
      list-style: none;
      position: absolute;
      top: 49px;
    }
     #modal-payment .fQQQgg {
      border: 1px solid #efefef;
      background: white;
      margin: 0;
      padding: 10px 0px;
      border-radius: 0px 0px 3px 3px;
      box-shadow: rgba(0, 0, 0, 0.18) 0px 6px 12px 0px;
    }
    [dir=ltr] #modal-payment .fQQQgg {
      left: calc(50% + 142px);
      transform: translateX(-50%);
    }
    [dir=rtl] #modal-payment .fQQQgg {
      right: calc(50% + 142px);
      transform: translateX(50%);
    }
    ::v-deep .modal-content {
      width: 400px;
    } ::v-deep .modal-content {
      background: #FFFFFF;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
    .color-red {
      color: red;
    }
    .color-warning {
      color: #114A9F;
    }
    .title-modal {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #114A9F;
      line-height: 21px;
    }
    .card-body p {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #5D5F65;
    }
    .content-body-modal {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    ::v-deep .modal-content {
      width: 400px;
    } ::v-deep .modal-content {
      background: #FFFFFF;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
    .color-red {
      color: red;
    }
    .color-warning {
      color: #114A9F;
    }
    .title-modal {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #114A9F;
      line-height: 21px;
    }
    .card-body p {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #5D5F65;
    }
    .content-body-modal {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    #modal-update-booking .selected-background-color[data-v-752544c5] {
      background: rgba(17, 74, 159, 0.04);
    }
     #modal-update-booking .blocked-background-color[data-v-752544c5] {
      background: rgba(193, 193, 193, 0.12);
    }
     .bg-linear-blue[data-v-752544c5] {
      background: linear-gradient(0deg, rgba(17, 74, 159, 0.12), rgba(17, 74, 159, 0.12)), #FFFFFF;
    }
     .bg-primary[data-v-752544c5] {
      background-color: #114A9F;
    }
     .bg-light-gray[data-v-752544c5] {
      background-color: #ADAFB6;
    }
     .bg-grey[data-v-752544c5] {
      background-color: #F8F8F8;
    }
    .color-primary[data-v-752544c5] {
      color: #114A9F;
    }
    .color-gray[data-v-752544c5] {
      color: #ADAFB6;
    }
    .header-sidebar-custom[data-v-752544c5] {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .header-sidebar-custom .header-text[data-v-752544c5] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
      color: #114A9F;
    }
     .block[data-v-752544c5] {
      background: #FFFFFF;
      border-radius: 5px;
      padding: 16px;
    }
    .player-info[data-v-752544c5] {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
     .player-info[data-v-752544c5] {
      margin-bottom: 0;
    }
    .wrapper .text[data-v-752544c5] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    .wrapper .block-item[data-v-752544c5] {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
     .wrapper .block-item[data-v-752544c5] {
      margin: 6px 0;
    }
    .text-checkbox[data-v-752544c5] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
     .text-checkbox[data-v-752544c5] {
      margin-bottom: 0;
    }
    [data-v-752544c5] .vs__selected-options {
      flex-wrap: inherit !important;
      max-width: 100%;
      overflow: hidden;
    }
    [data-v-752544c5] .vs__selected-options .vs__selected {
      overflow: hidden;
      max-width: 100%;
      white-space: nowrap;
    }
    [data-v-752544c5] .b-table-sticky-header {
      overflow: auto;
      max-height: 429px;
    }
    [data-v-752544c5]  .b-table-sticky-header {
      text-align: center;
    }
    [data-v-752544c5]  tbody > tr > td {
      text-align: center;
    }
    .scroll-area[data-v-752544c5] {
      position: relative;
      height: 50vh;
    }
     .scroll-area[data-v-752544c5] {
      margin: auto;
    }
    .color-warning[data-v-2054fb80] {
      color: #114A9F;
    }
    .error[data-v-2054fb80] {
      color: red;
    }
     .pd15[data-v-2054fb80] {
      padding: 15px;
    }
    [data-v-2054fb80] .modal-content {
      width: 400px;
    }
    [data-v-2054fb80]  .modal-content {
      background: #FFFFFF;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
    .title-modal[data-v-2054fb80] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #114A9F;
      line-height: 21px;
    }
    .content-body-modal[data-v-2054fb80] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    .spacing[data-v-62c1855a] {
      margin: 4px 0;
    }
    [data-v-62c1855a] .modal-content {
      width: 400px;
    }
    [data-v-62c1855a]  .modal-content {
      background: #FFFFFF;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
    .color-warning[data-v-62c1855a] {
      color: #114A9F;
    }
    .title-modal[data-v-62c1855a] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #114A9F;
      line-height: 21px;
    }
    .card-body p[data-v-62c1855a] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #5D5F65;
    }
    .content-body-modal[data-v-62c1855a] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    .vue-slider-disabled .vue-slider-process {
      background-color: #a7a7a7;
    }
     .vue-slider-disabled .vue-slider-dot-handle {
      border-color: #a7a7a7;
    }
     .vue-slider-disabled .vue-slider-mark-step-active {
      box-shadow: 0 0 0 2px #a7a7a7;
    }
    
    /* rail style */
    .vue-slider-rail {
      transition: background-color 0.3s;
    }
     .vue-slider-rail {
      background-color: whitesmoke;
      border-radius: 15px;
    }
     .vue-slider:hover .vue-slider-rail {
      background-color: #e1e1e1;
    }
    
    /* process style */
    .vue-slider-process {
      transition: background-color 0.3s;
    }
     .vue-slider-process {
      background-color: #9cd5ff;
      border-radius: 15px;
    }
     .vue-slider:hover .vue-slider-process {
      background-color: #69c0ff;
    }
    
    /* mark style */
    .vue-slider-mark-step {
      width: 100%;
      height: 100%;
    }
     .vue-slider-mark-step {
      border-radius: 50%;
      box-shadow: 0 0 0 2px #e8e8e8;
      background-color: #fff;
    }
     .vue-slider-mark-step-active {
      box-shadow: 0 0 0 2px #9cd5ff;
    }
     .vue-slider:hover .vue-slider-mark-step-active {
      box-shadow: 0 0 0 2px #69c0ff;
    }
    
    .vue-slider-mark-label {
      font-size: 12px;
      white-space: nowrap;
    }
    /* dot style */
    .vue-slider-dot-handle {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      transition: box-shadow 0.3s, border-color 0.3s;
    }
     .vue-slider-dot-handle {
      cursor: pointer;
      border-radius: 50%;
      background-color: #fff;
      border: 2px solid #9cd5ff;
    }
     .vue-slider:hover .vue-slider-dot-handle {
      border-color: #69c0ff;
    }
    
     .vue-slider-dot-handle-focus {
      border-color: #36abff;
      box-shadow: 0 0 0 5px rgba(54, 171, 255, 0.2);
    }
     .vue-slider:hover .vue-slider-dot-handle-focus {
      border-color: #36abff;
    }
    
     .vue-slider-dot-handle:hover {
      border-color: #36abff;
    }
     .vue-slider:hover .vue-slider-dot-handle:hover {
      border-color: #36abff;
    }
    
     .vue-slider-dot-handle-disabled {
      cursor: not-allowed;
      border-color: #ddd !important;
    }
    
    .vue-slider-dot-tooltip {
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s;
    }
    .vue-slider-dot-tooltip-inner {
      font-size: 14px;
      white-space: nowrap;
      color: #fff;
      transition: transform 0.3s;
    }
     .vue-slider-dot-tooltip-inner {
      padding: 6px 8px;
      border-radius: 5px;
      border-color: rgba(0, 0, 0, 0.75);
      background-color: rgba(0, 0, 0, 0.75);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      transform: scale(0.9);
    }
    .vue-slider-dot-tooltip-inner::after {
      content: "";
      position: absolute;
    }
    .vue-slider-dot-tooltip-inner-top::after {
      top: 100%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-top::after {
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
      border-top-color: inherit;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-top::after {
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-top::after {
      right: 50%;
      transform: translate(50%, 0);
    }
    .vue-slider-dot-tooltip-inner-bottom::after {
      bottom: 100%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-bottom::after {
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
      border-bottom-color: inherit;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-bottom::after {
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-bottom::after {
      right: 50%;
      transform: translate(50%, 0);
    }
    .vue-slider-dot-tooltip-inner-left::after {
      top: 50%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-left::after {
      transform: translate(0, -50%);
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-left::after {
      left: 100%;
      border-left-color: inherit;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-left::after {
      right: 100%;
      border-right-color: inherit;
    }
    .vue-slider-dot-tooltip-inner-right::after {
      top: 50%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-right::after {
      transform: translate(0, -50%);
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-right::after {
      right: 100%;
      border-right-color: inherit;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-right::after {
      left: 100%;
      border-left-color: inherit;
    }
     .vue-slider-dot-tooltip-inner-top {
      transform-origin: 50% 100%;
    }
     .vue-slider-dot-tooltip-inner-bottom {
      transform-origin: 50% 0;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-left {
      transform-origin: 100% 50%;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-left {
      transform-origin: 0% 50%;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-right {
      transform-origin: 0% 50%;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-right {
      transform-origin: 100% 50%;
    }
    
    .vue-slider-dot:hover .vue-slider-dot-tooltip, .vue-slider-dot-tooltip-show {
      opacity: 1;
      visibility: visible;
    }
     .vue-slider-dot:hover .vue-slider-dot-tooltip .vue-slider-dot-tooltip-inner,  .vue-slider-dot-tooltip-show .vue-slider-dot-tooltip-inner {
      transform: scale(1);
    }
    .vue-treeselect-helper-hide {
      display: none;
    }
    .vue-treeselect-helper-zoom-effect-off {
      -ms-transform: none !important;
    }
     .vue-treeselect-helper-zoom-effect-off {
          transform: none !important;
    }

    @keyframes vue-treeselect-animation-fade-in {
      0% {
        opacity: 0;
      }
    }
    @keyframes vue-treeselect-animation-bounce {
      0%,
      100% {
        transform: scale(0);
      }
      50% {
        transform: scale(1);
      }
    }
    @keyframes vue-treeselect-animation-rotate-ltr {
      100% {
        transform: rotate(360deg);
      }
    }
    @keyframes vue-treeselect-animation-rotate-rtl {
      100% {
        transform: rotate(-360deg);
      }
    }

    .vue-treeselect__multi-value-item--transition-enter-active,  .vue-treeselect__multi-value-item--transition-leave-active {
      transition-duration: 200ms;
      transition-property: transform, opacity;
    }
     .vue-treeselect__multi-value-item--transition-enter-active {
      transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
    }
    .vue-treeselect__multi-value-item--transition-leave-active {
      position: absolute;
    }
     .vue-treeselect__multi-value-item--transition-leave-active {
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    .vue-treeselect__multi-value-item--transition-enter,
    .vue-treeselect__multi-value-item--transition-leave-to {
      -ms-transform: scale(0.7);
      opacity: 0;
    }
     .vue-treeselect__multi-value-item--transition-enter,  .vue-treeselect__multi-value-item--transition-leave-to {
          transform: scale(0.7);
    }
    .vue-treeselect__multi-value-item--transition-move {
      transition: 200ms transform cubic-bezier(0.165, 0.84, 0.44, 1);
    }
    .vue-treeselect {
      position: relative;
    }
    [dir=ltr] .vue-treeselect {
      text-align: left;
    }
    [dir=rtl] .vue-treeselect {
      text-align: right;
    }
    [dir="rtl"] .vue-treeselect {
      text-align: right;
    }
    .vue-treeselect div,
    .vue-treeselect span {
      box-sizing: border-box;
    }
    .vue-treeselect svg {
      fill: currentColor;
    }
    /**
     * Control
     */
    .vue-treeselect__control {
      display: table;
      table-layout: fixed;
      width: 100%;
      height: 36px;
    }
     .vue-treeselect__control {
      border: 1px solid #ddd;
      border-radius: 5px;
      background: #fff;
      transition-duration: 200ms;
      transition-property: border-color, box-shadow, width, height, background-color, opacity;
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    [dir=ltr] .vue-treeselect__control {
      padding-left: 5px;
      padding-right: 5px;
    }
    [dir=rtl] .vue-treeselect__control {
      padding-right: 5px;
      padding-left: 5px;
    }
     .vue-treeselect:not(.vue-treeselect--disabled):not(.vue-treeselect--focused) .vue-treeselect__control:hover {
      border-color: #cfcfcf;
    }
     .vue-treeselect--focused:not(.vue-treeselect--open) .vue-treeselect__control {
      border-color: #039be5;
      box-shadow: 0 0 0 3px rgba(3, 155, 229, 0.1);
    }
     .vue-treeselect--disabled .vue-treeselect__control {
      background-color: #f9f9f9;
    }
     .vue-treeselect--open .vue-treeselect__control {
      border-color: #cfcfcf;
    }
    [dir=ltr] .vue-treeselect--open.vue-treeselect--open-below .vue-treeselect__control {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=rtl] .vue-treeselect--open.vue-treeselect--open-below .vue-treeselect__control {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=ltr] .vue-treeselect--open.vue-treeselect--open-above .vue-treeselect__control {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    [dir=rtl] .vue-treeselect--open.vue-treeselect--open-above .vue-treeselect__control {
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }
    .vue-treeselect__value-container,
    .vue-treeselect__multi-value {
      width: 100%;
      vertical-align: middle;
    }
    .vue-treeselect__value-container {
      display: table-cell;
      position: relative;
    }
     .vue-treeselect--searchable:not(.vue-treeselect--disabled) .vue-treeselect__value-container {
      cursor: text;
    }
    .vue-treeselect__multi-value {
      display: inline-block;
    }
     .vue-treeselect--has-value .vue-treeselect__multi-value {
      margin-bottom: 5px;
    }
    .vue-treeselect__placeholder,
    .vue-treeselect__single-value {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: absolute;
      top: 0;
      bottom: 0;
      line-height: 34px;
      -webkit-user-select: none;
         -moz-user-select: none;
          -ms-user-select: none;
              user-select: none;
      pointer-events: none;
    }
    [dir=ltr] .vue-treeselect__placeholder, [dir=ltr] .vue-treeselect__single-value {
      padding-left: 5px;
      padding-right: 5px;
      right: 0;
      left: 0;
    }
    [dir=rtl] .vue-treeselect__placeholder, [dir=rtl] .vue-treeselect__single-value {
      padding-right: 5px;
      padding-left: 5px;
      left: 0;
      right: 0;
    }
    .vue-treeselect__placeholder {
      color: #bdbdbd;
    }
    .vue-treeselect__single-value {
      color: #333;
    }
    .vue-treeselect--focused.vue-treeselect--searchable .vue-treeselect__single-value {
      color: #bdbdbd;
    }
    .vue-treeselect--disabled .vue-treeselect__single-value {
      position: static;
    }
    .vue-treeselect__multi-value-item-container {
      display: inline-block;
      vertical-align: top;
    }
     .vue-treeselect__multi-value-item-container {
      padding-top: 5px;
    }
    [dir=ltr] .vue-treeselect__multi-value-item-container {
      padding-right: 5px;
    }
    [dir=rtl] .vue-treeselect__multi-value-item-container {
      padding-left: 5px;
    }
    [dir="rtl"] .vue-treeselect__multi-value-item-container {
      padding-right: 0;
      padding-left: 5px;
    }
    .vue-treeselect__multi-value-item {
      display: inline-table;
      color: #039be5;
      font-size: 12px;
      vertical-align: top;
    }
     .vue-treeselect__multi-value-item {
      cursor: pointer;
      background: #e3f2fd;
      padding: 2px 0;
      border: 1px solid transparent;
      border-radius: 2px;
    }
    .vue-treeselect:not(.vue-treeselect--disabled) .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-disabled):hover .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-new) .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-new):hover {
      color: #039be5;
    }
     .vue-treeselect:not(.vue-treeselect--disabled) .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-disabled):hover .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-new) .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-new):hover {
      cursor: pointer;
      background: #e3f2fd;
    }
    .vue-treeselect__multi-value-item.vue-treeselect__multi-value-item-disabled {
      color: #757575;
    }
     .vue-treeselect__multi-value-item.vue-treeselect__multi-value-item-disabled {
      cursor: default;
      background: #f5f5f5;
    }
    .vue-treeselect--disabled .vue-treeselect__multi-value-item {
      color: #555;
    }
     .vue-treeselect--disabled .vue-treeselect__multi-value-item {
      cursor: default;
      background: #fff;
      border-color: #e5e5e5;
    }
     .vue-treeselect__multi-value-item.vue-treeselect__multi-value-item-new {
      background: #e8f5e9;
    }
     .vue-treeselect__multi-value-item.vue-treeselect__multi-value-item-new:hover {
      background: #e8f5e9;
    }
    .vue-treeselect__value-remove,
    .vue-treeselect__multi-value-label {
      display: table-cell;
      vertical-align: middle;
    }
     .vue-treeselect__value-remove,  .vue-treeselect__multi-value-label {
      padding: 0 5px;
    }
    .vue-treeselect__value-remove {
      color: #039be5;
      line-height: 0;
    }
    [dir=ltr] .vue-treeselect__value-remove {
      padding-left: 5px;
      border-left: 1px solid #fff;
    }
    [dir=rtl] .vue-treeselect__value-remove {
      padding-right: 5px;
      border-right: 1px solid #fff;
    }
    [dir="rtl"] .vue-treeselect__value-remove {
      border-left: 0 none;
      border-right: 1px solid #fff;
    }
    .vue-treeselect__multi-value-item:hover .vue-treeselect__value-remove {
      color: #e53935;
    }
    .vue-treeselect--disabled .vue-treeselect__value-remove,
    .vue-treeselect__multi-value-item-disabled .vue-treeselect__value-remove {
      display: none;
    }
    .vue-treeselect__value-remove > svg {
      width: 6px;
      height: 6px;
    }
    .vue-treeselect__multi-value-label {
      white-space: pre-line;
      -webkit-user-select: none;
         -moz-user-select: none;
          -ms-user-select: none;
              user-select: none;
    }
    [dir=ltr] .vue-treeselect__multi-value-label {
      padding-right: 5px;
    }
    [dir=rtl] .vue-treeselect__multi-value-label {
      padding-left: 5px;
    }
    .vue-treeselect__limit-tip {
      display: inline-block;
      vertical-align: top;
    }
     .vue-treeselect__limit-tip {
      padding-top: 5px;
    }
    [dir=ltr] .vue-treeselect__limit-tip {
      padding-right: 5px;
    }
    [dir=rtl] .vue-treeselect__limit-tip {
      padding-left: 5px;
    }
    [dir="rtl"] .vue-treeselect__limit-tip {
      padding-right: 0;
      padding-left: 5px;
    }
    .vue-treeselect__limit-tip-text {
      display: block;
      color: #bdbdbd;
      font-size: 12px;
      font-weight: 600;
    }
     .vue-treeselect__limit-tip-text {
      cursor: default;
      margin: 2px 0;
      padding: 1px 0;
    }
    .vue-treeselect__input-container {
      display: block;
      max-width: 100%;
      outline: none;
    }
    .vue-treeselect--single .vue-treeselect__input-container {
      font-size: inherit;
      height: 100%;
    }
    .vue-treeselect--multi .vue-treeselect__input-container {
      display: inline-block;
      font-size: 12px;
      vertical-align: top;
    }
    [dir=ltr] .vue-treeselect--searchable .vue-treeselect__input-container {
      padding-left: 5px;
      padding-right: 5px;
    }
    [dir=rtl] .vue-treeselect--searchable .vue-treeselect__input-container {
      padding-right: 5px;
      padding-left: 5px;
    }
     .vue-treeselect--searchable.vue-treeselect--multi.vue-treeselect--has-value .vue-treeselect__input-container {
      padding-top: 5px;
    }
    [dir=ltr] .vue-treeselect--searchable.vue-treeselect--multi.vue-treeselect--has-value .vue-treeselect__input-container {
      padding-left: 0;
    }
    [dir=rtl] .vue-treeselect--searchable.vue-treeselect--multi.vue-treeselect--has-value .vue-treeselect__input-container {
      padding-right: 0;
    }
    [dir="rtl"] .vue-treeselect--searchable.vue-treeselect--multi.vue-treeselect--has-value .vue-treeselect__input-container {
      padding-left: 5px;
      padding-right: 0;
    }
    .vue-treeselect--disabled .vue-treeselect__input-container {
      display: none;
    }
    .vue-treeselect__input,
    .vue-treeselect__sizer {
      line-height: inherit;
      font-family: inherit;
      font-size: inherit;
    }
     .vue-treeselect__input,  .vue-treeselect__sizer {
      margin: 0;
    }
    .vue-treeselect__input {
      max-width: 100%;
      outline: none;
      box-sizing: content-box;
      line-height: 1;
      vertical-align: middle;
    }
     .vue-treeselect__input {
      margin: 0;
      padding: 0;
      border: 0;
      box-shadow: none;
      background: none transparent;
    }
    .vue-treeselect__input::-ms-clear {
      display: none;
    }
    .vue-treeselect--single .vue-treeselect__input {
      width: 100%;
      height: 100%;
    }
     .vue-treeselect--multi .vue-treeselect__input {
      padding-top: 3px;
      padding-bottom: 3px;
    }
    .vue-treeselect--has-value .vue-treeselect__input {
      line-height: inherit;
      vertical-align: top;
    }
    .vue-treeselect__sizer {
      position: absolute;
      top: 0;
      visibility: hidden;
      height: 0;
      overflow: scroll;
      white-space: pre;
    }
    [dir=ltr] .vue-treeselect__sizer {
      left: 0;
    }
    [dir=rtl] .vue-treeselect__sizer {
      right: 0;
    }
    .vue-treeselect__x-container {
      display: table-cell;
      vertical-align: middle;
      width: 20px;
      line-height: 0;
      color: #ccc;
    }
     .vue-treeselect__x-container {
      text-align: center;
      cursor: pointer;
    }
    [dir=ltr] .vue-treeselect__x-container {
      animation: 200ms vue-treeselect-animation-fade-in cubic-bezier(0.075, 0.82, 0.165, 1);
    }
    [dir=rtl] .vue-treeselect__x-container {
      animation: 200ms vue-treeselect-animation-fade-in cubic-bezier(0.075, 0.82, 0.165, 1);
    }
    .vue-treeselect__x-container:hover {
      color: #e53935;
    }
    .vue-treeselect__x {
      width: 8px;
      height: 8px;
    }
    .vue-treeselect__control-arrow-container {
      display: table-cell;
      vertical-align: middle;
      width: 20px;
      line-height: 0;
    }
     .vue-treeselect__control-arrow-container {
      text-align: center;
      cursor: pointer;
    }
     .vue-treeselect--disabled .vue-treeselect__control-arrow-container {
      cursor: default;
    }
    .vue-treeselect__control-arrow {
      width: 9px;
      height: 9px;
      color: #ccc;
    }
    .vue-treeselect:not(.vue-treeselect--disabled) .vue-treeselect__control-arrow-container:hover .vue-treeselect__control-arrow {
      color: #616161;
    }
    .vue-treeselect--disabled .vue-treeselect__control-arrow {
      opacity: 0.35;
    }
    [dir=ltr] .vue-treeselect__control-arrow--rotated {
      -ms-transform: rotate(180deg);
      transform: rotateZ(180deg);
    }
    [dir=rtl] .vue-treeselect__control-arrow--rotated {
      -ms-transform: rotate(-180deg);
          transform: rotateZ(-180deg);
    }
    /**
     * Menu
     */
    .vue-treeselect__menu-container {
      position: absolute;
      width: 100%;
      overflow: visible;
      transition: 0s;
    }
    [dir=ltr] .vue-treeselect__menu-container {
      left: 0;
    }
    [dir=rtl] .vue-treeselect__menu-container {
      right: 0;
    }
    .vue-treeselect--open-below:not(.vue-treeselect--append-to-body) .vue-treeselect__menu-container {
      top: 100%;
    }
    .vue-treeselect--open-above:not(.vue-treeselect--append-to-body) .vue-treeselect__menu-container {
      bottom: 100%;
    }
    .vue-treeselect__menu {
      display: block;
      position: absolute;
      overflow-x: hidden;
      overflow-y: auto;
      width: auto;
      line-height: 180%;
      -webkit-overflow-scrolling: touch;
    }
     .vue-treeselect__menu {
      cursor: default;
      padding-top: 5px;
      padding-bottom: 5px;
      border: 1px solid #cfcfcf;
      background: #fff;
    }
    .vue-treeselect--open-below .vue-treeselect__menu {
      top: 0;
    }
     .vue-treeselect--open-below .vue-treeselect__menu {
      margin-top: -1px;
      border-top-color: #f2f2f2;
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
    }
    [dir=ltr] .vue-treeselect--open-below .vue-treeselect__menu {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    [dir=rtl] .vue-treeselect--open-below .vue-treeselect__menu {
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    .vue-treeselect--open-above .vue-treeselect__menu {
      bottom: 0;
    }
     .vue-treeselect--open-above .vue-treeselect__menu {
      margin-bottom: -1px;
      border-bottom-color: #f2f2f2;
    }
    [dir=ltr] .vue-treeselect--open-above .vue-treeselect__menu {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    [dir=rtl] .vue-treeselect--open-above .vue-treeselect__menu {
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
    }
    [dir=ltr] .vue-treeselect__indent-level-0 .vue-treeselect__option {
      padding-left: 5px;
    }
    [dir=rtl] .vue-treeselect__indent-level-0 .vue-treeselect__option {
      padding-right: 5px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-0 .vue-treeselect__option {
      padding-left: 5px;
      padding-right: 5px;
    }
    [dir=ltr] .vue-treeselect__indent-level-0 .vue-treeselect__tip {
      padding-left: 25px;
    }
    [dir=rtl] .vue-treeselect__indent-level-0 .vue-treeselect__tip {
      padding-right: 25px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-0 .vue-treeselect__tip {
      padding-left: 5px;
      padding-right: 25px;
    }
    [dir=ltr] .vue-treeselect__indent-level-1 .vue-treeselect__option {
      padding-left: 25px;
    }
    [dir=rtl] .vue-treeselect__indent-level-1 .vue-treeselect__option {
      padding-right: 25px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-1 .vue-treeselect__option {
      padding-left: 5px;
      padding-right: 25px;
    }
    [dir=ltr] .vue-treeselect__indent-level-1 .vue-treeselect__tip {
      padding-left: 45px;
    }
    [dir=rtl] .vue-treeselect__indent-level-1 .vue-treeselect__tip {
      padding-right: 45px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-1 .vue-treeselect__tip {
      padding-left: 5px;
      padding-right: 45px;
    }
    [dir=ltr] .vue-treeselect__indent-level-2 .vue-treeselect__option {
      padding-left: 45px;
    }
    [dir=rtl] .vue-treeselect__indent-level-2 .vue-treeselect__option {
      padding-right: 45px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-2 .vue-treeselect__option {
      padding-left: 5px;
      padding-right: 45px;
    }
    [dir=ltr] .vue-treeselect__indent-level-2 .vue-treeselect__tip {
      padding-left: 65px;
    }
    [dir=rtl] .vue-treeselect__indent-level-2 .vue-treeselect__tip {
      padding-right: 65px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-2 .vue-treeselect__tip {
      padding-left: 5px;
      padding-right: 65px;
    }
    [dir=ltr] .vue-treeselect__indent-level-3 .vue-treeselect__option {
      padding-left: 65px;
    }
    [dir=rtl] .vue-treeselect__indent-level-3 .vue-treeselect__option {
      padding-right: 65px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-3 .vue-treeselect__option {
      padding-left: 5px;
      padding-right: 65px;
    }
    [dir=ltr] .vue-treeselect__indent-level-3 .vue-treeselect__tip {
      padding-left: 85px;
    }
    [dir=rtl] .vue-treeselect__indent-level-3 .vue-treeselect__tip {
      padding-right: 85px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-3 .vue-treeselect__tip {
      padding-left: 5px;
      padding-right: 85px;
    }
    [dir=ltr] .vue-treeselect__indent-level-4 .vue-treeselect__option {
      padding-left: 85px;
    }
    [dir=rtl] .vue-treeselect__indent-level-4 .vue-treeselect__option {
      padding-right: 85px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-4 .vue-treeselect__option {
      padding-left: 5px;
      padding-right: 85px;
    }
    [dir=ltr] .vue-treeselect__indent-level-4 .vue-treeselect__tip {
      padding-left: 105px;
    }
    [dir=rtl] .vue-treeselect__indent-level-4 .vue-treeselect__tip {
      padding-right: 105px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-4 .vue-treeselect__tip {
      padding-left: 5px;
      padding-right: 105px;
    }
    [dir=ltr] .vue-treeselect__indent-level-5 .vue-treeselect__option {
      padding-left: 105px;
    }
    [dir=rtl] .vue-treeselect__indent-level-5 .vue-treeselect__option {
      padding-right: 105px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-5 .vue-treeselect__option {
      padding-left: 5px;
      padding-right: 105px;
    }
    [dir=ltr] .vue-treeselect__indent-level-5 .vue-treeselect__tip {
      padding-left: 125px;
    }
    [dir=rtl] .vue-treeselect__indent-level-5 .vue-treeselect__tip {
      padding-right: 125px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-5 .vue-treeselect__tip {
      padding-left: 5px;
      padding-right: 125px;
    }
    [dir=ltr] .vue-treeselect__indent-level-6 .vue-treeselect__option {
      padding-left: 125px;
    }
    [dir=rtl] .vue-treeselect__indent-level-6 .vue-treeselect__option {
      padding-right: 125px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-6 .vue-treeselect__option {
      padding-left: 5px;
      padding-right: 125px;
    }
    [dir=ltr] .vue-treeselect__indent-level-6 .vue-treeselect__tip {
      padding-left: 145px;
    }
    [dir=rtl] .vue-treeselect__indent-level-6 .vue-treeselect__tip {
      padding-right: 145px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-6 .vue-treeselect__tip {
      padding-left: 5px;
      padding-right: 145px;
    }
    [dir=ltr] .vue-treeselect__indent-level-7 .vue-treeselect__option {
      padding-left: 145px;
    }
    [dir=rtl] .vue-treeselect__indent-level-7 .vue-treeselect__option {
      padding-right: 145px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-7 .vue-treeselect__option {
      padding-left: 5px;
      padding-right: 145px;
    }
    [dir=ltr] .vue-treeselect__indent-level-7 .vue-treeselect__tip {
      padding-left: 165px;
    }
    [dir=rtl] .vue-treeselect__indent-level-7 .vue-treeselect__tip {
      padding-right: 165px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-7 .vue-treeselect__tip {
      padding-left: 5px;
      padding-right: 165px;
    }
    [dir=ltr] .vue-treeselect__indent-level-8 .vue-treeselect__option {
      padding-left: 165px;
    }
    [dir=rtl] .vue-treeselect__indent-level-8 .vue-treeselect__option {
      padding-right: 165px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-8 .vue-treeselect__option {
      padding-left: 5px;
      padding-right: 165px;
    }
    [dir=ltr] .vue-treeselect__indent-level-8 .vue-treeselect__tip {
      padding-left: 185px;
    }
    [dir=rtl] .vue-treeselect__indent-level-8 .vue-treeselect__tip {
      padding-right: 185px;
    }
    [dir="rtl"] .vue-treeselect__indent-level-8 .vue-treeselect__tip {
      padding-left: 5px;
      padding-right: 185px;
    }
    .vue-treeselect__option {
      display: table;
      table-layout: fixed;
      width: 100%;
    }
    [dir=ltr] .vue-treeselect__option {
      padding-left: 5px;
      padding-right: 5px;
    }
    [dir=rtl] .vue-treeselect__option {
      padding-right: 5px;
      padding-left: 5px;
    }
     .vue-treeselect__option--highlight {
      background: #f5f5f5;
    }
    .vue-treeselect--single .vue-treeselect__option--selected {
      font-weight: 600;
    }
     .vue-treeselect--single .vue-treeselect__option--selected {
      background: #e3f2fd;
    }
     .vue-treeselect--single .vue-treeselect__option--selected:hover {
      background: #e3f2fd;
    }
    .vue-treeselect__option--hide {
      display: none;
    }
    .vue-treeselect__option-arrow-container,
    .vue-treeselect__option-arrow-placeholder {
      display: table-cell;
      vertical-align: middle;
      width: 20px;
      line-height: 0;
    }
     .vue-treeselect__option-arrow-container,  .vue-treeselect__option-arrow-placeholder {
      text-align: center;
    }
     .vue-treeselect__option-arrow-container {
      cursor: pointer;
    }
    .vue-treeselect__option-arrow {
      display: inline-block;
      width: 9px;
      height: 9px;
      color: #ccc;
      vertical-align: middle;
      transition: 200ms transform cubic-bezier(0.19, 1, 0.22, 1);
    }
    [dir=ltr] .vue-treeselect__option-arrow {
      -ms-transform: rotate(-90deg);
      transform: rotateZ(-90deg);
    }
    [dir=rtl] .vue-treeselect__option-arrow {
      -ms-transform: rotate(90deg);
          transform: rotateZ(90deg);
    }
    [dir="rtl"] .vue-treeselect__option-arrow {
      -ms-transform: rotate(90deg);
          transform: rotateZ(90deg);
    }
    .vue-treeselect__option-arrow-container:hover .vue-treeselect__option-arrow,
    .vue-treeselect--branch-nodes-disabled .vue-treeselect__option:hover .vue-treeselect__option-arrow {
      color: #616161;
    }
    .vue-treeselect__option-arrow--rotated {
      -ms-transform: rotate(0);
    }
     .vue-treeselect__option-arrow--rotated {
          transform: rotateZ(0);
    }
    [dir="rtl"] .vue-treeselect__option-arrow--rotated {
      -ms-transform: rotate(0);
          transform: rotateZ(0);
    }
    [dir=ltr] .vue-treeselect__option-arrow--rotated.vue-treeselect__option-arrow--prepare-enter {
      -ms-transform: rotate(-90deg) !important;
      transform: rotateZ(-90deg) !important;
    }
    [dir=rtl] .vue-treeselect__option-arrow--rotated.vue-treeselect__option-arrow--prepare-enter {
      -ms-transform: rotate(90deg) !important;
          transform: rotateZ(90deg) !important;
    }
    [dir="rtl"] .vue-treeselect__option-arrow--rotated.vue-treeselect__option-arrow--prepare-enter {
      -ms-transform: rotate(90deg) !important;
          transform: rotateZ(90deg) !important;
    }
    .vue-treeselect__label-container {
      display: table-cell;
      vertical-align: middle;
      display: table;
      width: 100%;
      table-layout: fixed;
      color: inherit;
    }
     .vue-treeselect__label-container {
      cursor: pointer;
    }
    .vue-treeselect__option--disabled .vue-treeselect__label-container {
      color: rgba(0, 0, 0, 0.25);
    }
     .vue-treeselect__option--disabled .vue-treeselect__label-container {
      cursor: not-allowed;
    }
    .vue-treeselect__checkbox-container {
      display: table-cell;
      width: 20px;
      min-width: 20px;
      height: 100%;
      vertical-align: middle;
    }
     .vue-treeselect__checkbox-container {
      text-align: center;
    }
    .vue-treeselect__checkbox {
      display: block;
      width: 12px;
      height: 12px;
      position: relative;
      transition: 200ms all cubic-bezier(0.075, 0.82, 0.165, 1);
    }
     .vue-treeselect__checkbox {
      margin: auto;
      border-width: 1px;
      border-style: solid;
      border-radius: 2px;
    }
    .vue-treeselect__check-mark,
    .vue-treeselect__minus-mark {
      display: block;
      position: absolute;
      top: 1px;
      opacity: 0;
      transition: 200ms all ease;
    }
     .vue-treeselect__check-mark,  .vue-treeselect__minus-mark {
      background-repeat: no-repeat;
    }
    [dir=ltr] .vue-treeselect__check-mark, [dir=ltr] .vue-treeselect__minus-mark {
      left: 1px;
    }
    [dir=rtl] .vue-treeselect__check-mark, [dir=rtl] .vue-treeselect__minus-mark {
      right: 1px;
    }
    .vue-treeselect__minus-mark {
      width: 8px;
      height: 8px;
    }
     .vue-treeselect__minus-mark {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIAgMAAAC5YVYYAAAACVBMVEUAAAD///////9zeKVjAAAAAnRSTlMAuLMp9oYAAAAPSURBVAjXY4CDrJUgBAMAGaECJ9dz3BAAAAAASUVORK5CYII=);
      background-size: 8px 8px;
    }
    @media (-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 1.5dppx) {
       .vue-treeselect__minus-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAyTzPIdReAAAAGUlEQVQI12PAD+b///+Nof7//79gAsLFCwAx/w4blADeeQAAAABJRU5ErkJggg==);
      }
    }
    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
       .vue-treeselect__minus-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAyTzPIdReAAAAGUlEQVQI12PAD+b///+Nof7//79gAsLFCwAx/w4blADeeQAAAABJRU5ErkJggg==);
      }
    }
    @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 288dpi) {
       .vue-treeselect__minus-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAD1BMVEUAAAD///////////////+PQt5oAAAABHRSTlMAy2EFIuWxUgAAACRJREFUGNNjGBBgJOICBY7KDCoucODEAJSAS6FwUJShGjAQAADBPRGrK2/FhgAAAABJRU5ErkJggg==);
      }
    }
    .vue-treeselect__checkbox--indeterminate > .vue-treeselect__minus-mark {
      opacity: 1;
    }
     .vue-treeselect__checkbox--disabled .vue-treeselect__minus-mark {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIAgMAAAC5YVYYAAAACVBMVEUAAADi4uLh4eHOxeSRAAAAAnRSTlMAuLMp9oYAAAAPSURBVAjXY4CDrJUgBAMAGaECJ9dz3BAAAAAASUVORK5CYII=);
    }
    @media (-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 1.5dppx) {
       .vue-treeselect__checkbox--disabled .vue-treeselect__minus-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAADFBMVEUAAADi4uLi4uLh4eE5RQaIAAAAA3RSTlMAyTzPIdReAAAAGUlEQVQI12PAD+b///+Nof7//79gAsLFCwAx/w4blADeeQAAAABJRU5ErkJggg==);
      }
    }
    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
       .vue-treeselect__checkbox--disabled .vue-treeselect__minus-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAADFBMVEUAAADi4uLi4uLh4eE5RQaIAAAAA3RSTlMAyTzPIdReAAAAGUlEQVQI12PAD+b///+Nof7//79gAsLFCwAx/w4blADeeQAAAABJRU5ErkJggg==);
      }
    }
    @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 288dpi) {
       .vue-treeselect__checkbox--disabled .vue-treeselect__minus-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAD1BMVEUAAADh4eHg4ODNzc3h4eEYfw2wAAAABHRSTlMAy2EFIuWxUgAAACRJREFUGNNjGBBgJOICBY7KDCoucODEAJSAS6FwUJShGjAQAADBPRGrK2/FhgAAAABJRU5ErkJggg==);
      }
    }
    .vue-treeselect__check-mark {
      width: 8px;
      height: 8px;
      -ms-transform: scaleY(0.125);
    }
     .vue-treeselect__check-mark {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAQlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////8IX9KGAAAAFXRSTlMA8u24NxILB+Tawb6jiH1zRz0xIQIIP3GUAAAAMklEQVQI1y3FtQEAMQDDQD+EGbz/qkEVOpyEOP6PudKjZNSXn4Jm2CKRdBKzSLsFWl8fMG0Bl6Jk1rMAAAAASUVORK5CYII=);
      background-size: 8px 8px;
          transform: scaleY(0.125);
    }
    @media (-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 1.5dppx) {
       .vue-treeselect__check-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAYFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////98JRy6AAAAH3RSTlMAzu4sDenl38fBvo1OMyIdEQrj1cSihX5hYFpHNycIcQOASAAAAF9JREFUGNN9zEcOgDAMRFHTS0LvNfe/JRmHKAIJ/mqeLJn+k9uDtaeUeFnFziGsBucUTirrprfe81RqZ3Bb6hPWeuZwDFOHyf+ig9CCzQ7INBn7bG5kF+QSt13BHNJnF7AaCT4Y+CW7AAAAAElFTkSuQmCC);
      }
    }
    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
       .vue-treeselect__check-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAYFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////98JRy6AAAAH3RSTlMAzu4sDenl38fBvo1OMyIdEQrj1cSihX5hYFpHNycIcQOASAAAAF9JREFUGNN9zEcOgDAMRFHTS0LvNfe/JRmHKAIJ/mqeLJn+k9uDtaeUeFnFziGsBucUTirrprfe81RqZ3Bb6hPWeuZwDFOHyf+ig9CCzQ7INBn7bG5kF+QSt13BHNJnF7AaCT4Y+CW7AAAAAElFTkSuQmCC);
      }
    }
    @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 288dpi) {
       .vue-treeselect__check-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAWlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////9ZMre9AAAAHXRSTlMA/PiJhGNI9XlEHJB/b2ldV08+Oibk49vPp6QhAYgGBuwAAACCSURBVCjPrdHdDoIwDAXgTWAqCigo/+f9X5OwnoUwtis4V92XNWladUl+rzQPeQJAN2EHxoOnsPn7/oYk8fxBv08Rr/deOH/aZ2Nm8ZJ+s573QGfWKnNuZGzWm3+lv2V3pcU1XQ385/yjmBoM3Z+dXvlbYLLD3ujhTaOM3KaIXvNkFkuSEvYy1LqOAAAAAElFTkSuQmCC);
      }
    }
    .vue-treeselect__checkbox--checked > .vue-treeselect__check-mark {
      opacity: 1;
      -ms-transform: scaleY(1);
    }
     .vue-treeselect__checkbox--checked > .vue-treeselect__check-mark {
          transform: scaleY(1);
    }
     .vue-treeselect__checkbox--disabled .vue-treeselect__check-mark {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEUAAADj4+Pf39/h4eHh4eHh4eHk5OTh4eHg4ODi4uLh4eHh4eHg4ODh4eHh4eHg4ODh4eHh4eHp6en////h4eFqcyvUAAAAFHRSTlMAOQfy7bgS5NrBvqOIfXNHMSELAgQ/iFsAAAA2SURBVAjXY4AANjYIzcjMAaVFuBkY+RkEWERYmRjYRXjANAOfiIgIFxNIAa8IpxBEi6AwiAQAK2MBd7xY8csAAAAASUVORK5CYII=);
    }
    @media (-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 1.5dppx) {
       .vue-treeselect__checkbox--disabled .vue-treeselect__check-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAXVBMVEUAAADh4eHh4eHh4eHi4uLb29vh4eHh4eHh4eHh4eHh4eHh4eHh4eHi4uLi4uLj4+Pi4uLk5OTo6Ojh4eHh4eHi4uLg4ODg4ODh4eHg4ODh4eHf39/g4OD////h4eEzIk+wAAAAHnRSTlMAzu6/LA3p5eLZx8ONTjYiHRIKooV+YWBaRzEnCANnm5rnAAAAZElEQVQY033P2wqAIAyA4VWaaWrnc/n+j5mbhBjUf7WPoTD47TJb4i5zTr/sRDRHuyFaoWX7uK/RlbctlPEuyI1f4WY9yQINEkf6rzzo8YIzmUFoCs7J1EjeIaa9bXIEmzl8dgOZEAj/+2IvzAAAAABJRU5ErkJggg==);
      }
    }
    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
       .vue-treeselect__checkbox--disabled .vue-treeselect__check-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAXVBMVEUAAADh4eHh4eHh4eHi4uLb29vh4eHh4eHh4eHh4eHh4eHh4eHh4eHi4uLi4uLj4+Pi4uLk5OTo6Ojh4eHh4eHi4uLg4ODg4ODh4eHg4ODh4eHf39/g4OD////h4eEzIk+wAAAAHnRSTlMAzu6/LA3p5eLZx8ONTjYiHRIKooV+YWBaRzEnCANnm5rnAAAAZElEQVQY033P2wqAIAyA4VWaaWrnc/n+j5mbhBjUf7WPoTD47TJb4i5zTr/sRDRHuyFaoWX7uK/RlbctlPEuyI1f4WY9yQINEkf6rzzo8YIzmUFoCs7J1EjeIaa9bXIEmzl8dgOZEAj/+2IvzAAAAABJRU5ErkJggg==);
      }
    }
    @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 288dpi) {
       .vue-treeselect__checkbox--disabled .vue-treeselect__check-mark {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAUVBMVEUAAADh4eHh4eHh4eHh4eHi4uLi4uLh4eHh4eHh4eHf39/j4+Ph4eHh4eHh4eHg4ODi4uLh4eHh4eHi4uLh4eHh4eHh4eHh4eHh4eH////h4eF3FMFTAAAAGnRSTlMA+/eJhGhfSHE9JBzz5KaQf3pXT0Xbz0I5AYDw8F0AAAB+SURBVCjPrdHbDoMgEEVRKAii1dZe9fz/hxplTiKIT7qfYCWTEEZdUvOwbckNAD2WHeh3brHW5f5EzGQ+iN+b1Gt6KPvtv16Dn6JX9M9ya3/A1yfu5dlyduL6Hec7mXY6ddXLPP2lpABGZ8PWXfYLTJxZekVhhl7eTX24zZPNKXoRC7zQLjUAAAAASUVORK5CYII=);
      }
    }
     .vue-treeselect__checkbox--unchecked {
      border-color: #e0e0e0;
      background: #fff;
    }
     .vue-treeselect__label-container:hover .vue-treeselect__checkbox--unchecked {
      border-color: #039be5;
      background: #fff;
    }
     .vue-treeselect__checkbox--indeterminate {
      border-color: #039be5;
      background: #039be5;
    }
     .vue-treeselect__label-container:hover .vue-treeselect__checkbox--indeterminate {
      border-color: #039be5;
      background: #039be5;
    }
     .vue-treeselect__checkbox--checked {
      border-color: #039be5;
      background: #039be5;
    }
     .vue-treeselect__label-container:hover .vue-treeselect__checkbox--checked {
      border-color: #039be5;
      background: #039be5;
    }
     .vue-treeselect__checkbox--disabled {
      border-color: #e0e0e0;
      background-color: #f7f7f7;
    }
     .vue-treeselect__label-container:hover .vue-treeselect__checkbox--disabled {
      border-color: #e0e0e0;
      background-color: #f7f7f7;
    }
    .vue-treeselect__label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: table-cell;
      max-width: 100%;
      vertical-align: middle;
    }
     .vue-treeselect__label {
      cursor: inherit;
    }
    [dir=ltr] .vue-treeselect__label {
      padding-left: 5px;
    }
    [dir=rtl] .vue-treeselect__label {
      padding-right: 5px;
    }
    [dir="rtl"] .vue-treeselect__label {
      padding-left: 0;
      padding-right: 5px;
    }
    .vue-treeselect__count {
      font-weight: 400;
      opacity: 0.6;
    }
    [dir=ltr] .vue-treeselect__count {
      margin-left: 5px;
    }
    [dir=rtl] .vue-treeselect__count {
      margin-right: 5px;
    }
    [dir="rtl"] .vue-treeselect__count {
      margin-left: 0;
      margin-right: 5px;
    }
    .vue-treeselect__tip {
      display: table;
      table-layout: fixed;
      width: 100%;
      color: #757575;
    }
    [dir=ltr] .vue-treeselect__tip {
      padding-left: 5px;
      padding-right: 5px;
    }
    [dir=rtl] .vue-treeselect__tip {
      padding-right: 5px;
      padding-left: 5px;
    }
    .vue-treeselect__tip-text {
      display: table-cell;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      font-size: 12px;
    }
    [dir=ltr] .vue-treeselect__tip-text {
      padding-left: 5px;
      padding-right: 5px;
    }
    [dir=rtl] .vue-treeselect__tip-text {
      padding-right: 5px;
      padding-left: 5px;
    }
    .vue-treeselect__error-tip .vue-treeselect__retry {
      font-style: normal;
      font-weight: 600;
      text-decoration: none;
      color: #039be5;
    }
     .vue-treeselect__error-tip .vue-treeselect__retry {
      cursor: pointer;
    }
    [dir=ltr] .vue-treeselect__error-tip .vue-treeselect__retry {
      margin-left: 5px;
    }
    [dir=rtl] .vue-treeselect__error-tip .vue-treeselect__retry {
      margin-right: 5px;
    }
    [dir="rtl"] .vue-treeselect__error-tip .vue-treeselect__retry {
      margin-left: 0;
      margin-right: 5px;
    }
    .vue-treeselect__icon-container {
      display: table-cell;
      vertical-align: middle;
      width: 20px;
      line-height: 0;
    }
     .vue-treeselect__icon-container {
      text-align: center;
    }
    [dir=ltr] .vue-treeselect--single .vue-treeselect__icon-container {
      padding-left: 5px;
    }
    [dir=rtl] .vue-treeselect--single .vue-treeselect__icon-container {
      padding-right: 5px;
    }
    [dir="rtl"] .vue-treeselect--single .vue-treeselect__icon-container {
      padding-left: 0;
      padding-right: 5px;
    }
    .vue-treeselect__icon-warning {
      display: block;
      position: relative;
      width: 12px;
      height: 12px;
    }
     .vue-treeselect__icon-warning {
      margin: auto;
      border-radius: 50%;
      background: #fb8c00;
    }
    .vue-treeselect__icon-warning::after {
      display: block;
      position: absolute;
      content: "";
      top: 2.5px;
      width: 2px;
      height: 1px;
    }
     .vue-treeselect__icon-warning::after {
      border: 0 solid #fff;
      border-top-width: 5px;
      border-bottom-width: 1px;
    }
    [dir=ltr] .vue-treeselect__icon-warning::after {
      left: 5px;
    }
    [dir=rtl] .vue-treeselect__icon-warning::after {
      right: 5px;
    }
    .vue-treeselect__icon-error {
      display: block;
      position: relative;
      width: 12px;
      height: 12px;
    }
     .vue-treeselect__icon-error {
      margin: auto;
      border-radius: 50%;
      background: #e53935;
    }
    .vue-treeselect__icon-error::before,
    .vue-treeselect__icon-error::after {
      display: block;
      position: absolute;
      content: "";
    }
     .vue-treeselect__icon-error::before,  .vue-treeselect__icon-error::after {
      background: #fff;
    }
    [dir=ltr] .vue-treeselect__icon-error::before, [dir=ltr] .vue-treeselect__icon-error::after {
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
    [dir=rtl] .vue-treeselect__icon-error::before, [dir=rtl] .vue-treeselect__icon-error::after {
      -ms-transform: rotate(-45deg);
          transform: rotate(-45deg);
    }
    .vue-treeselect__icon-error::before {
      width: 6px;
      height: 2px;
      top: 5px;
    }
    [dir=ltr] .vue-treeselect__icon-error::before {
      left: 3px;
    }
    [dir=rtl] .vue-treeselect__icon-error::before {
      right: 3px;
    }
    .vue-treeselect__icon-error::after {
      width: 2px;
      height: 6px;
      top: 3px;
    }
    [dir=ltr] .vue-treeselect__icon-error::after {
      left: 5px;
    }
    [dir=rtl] .vue-treeselect__icon-error::after {
      right: 5px;
    }
    .vue-treeselect__icon-loader {
      display: block;
      position: relative;
      width: 12px;
      height: 12px;
    }
     .vue-treeselect__icon-loader {
      margin: auto;
      text-align: center;
    }
    [dir=ltr] .vue-treeselect__icon-loader {
      animation: 1.6s vue-treeselect-animation-rotate-ltr linear infinite;
    }
    [dir=rtl] .vue-treeselect__icon-loader {
      animation: 1.6s vue-treeselect-animation-rotate-rtl linear infinite;
    }
    .vue-treeselect__icon-loader::before,
    .vue-treeselect__icon-loader::after {
      position: absolute;
      content: "";
      top: 0;
      display: block;
      width: 100%;
      height: 100%;
      opacity: 0.6;
    }
     .vue-treeselect__icon-loader::before,  .vue-treeselect__icon-loader::after {
      border-radius: 50%;
    }
    [dir=ltr] .vue-treeselect__icon-loader::before, [dir=ltr] .vue-treeselect__icon-loader::after {
      left: 0;
      animation: 1.6s vue-treeselect-animation-bounce ease-in-out infinite;
    }
    [dir=rtl] .vue-treeselect__icon-loader::before, [dir=rtl] .vue-treeselect__icon-loader::after {
      right: 0;
      animation: 1.6s vue-treeselect-animation-bounce ease-in-out infinite;
    }
     .vue-treeselect__icon-loader::before {
      background: #039be5;
    }
     .vue-treeselect__icon-loader::after {
      background: #b3e5fc;
    }
    [dir=ltr] .vue-treeselect__icon-loader::after {
      animation-delay: -0.8s;
    }
    [dir=rtl] .vue-treeselect__icon-loader::after {
      animation-delay: -0.8s;
    }
    /**
     * Menu Portal
     */
    .vue-treeselect__menu-placeholder {
      display: none;
    }
    .vue-treeselect__portal-target {
      position: absolute;
      display: block;
      top: 0;
      height: 0;
      width: 0;
      overflow: visible;
      box-sizing: border-box;
    }
     .vue-treeselect__portal-target {
      padding: 0;
      margin: 0;
      border: 0;
    }
    [dir=ltr] .vue-treeselect__portal-target {
      left: 0;
    }
    [dir=rtl] .vue-treeselect__portal-target {
      right: 0;
    }
    .vue-slider-disabled[data-v-46ad63fa] {
      opacity: 0.5;
    }
     .vue-slider-disabled[data-v-46ad63fa] {
      cursor: not-allowed;
    }
    
    /* rail style */
     .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(17, 74, 159, 0.12);
      border-radius: 15px;
    }
    
    /* process style */
     .vue-slider-process[data-v-46ad63fa] {
      background-color: #114A9F;
      border-radius: 15px;
    }
    
    /* mark style */
    .vue-slider-mark[data-v-46ad63fa] {
      z-index: 4;
    }
    .vue-slider-mark:first-child .vue-slider-mark-step[data-v-46ad63fa], .vue-slider-mark:last-child .vue-slider-mark-step[data-v-46ad63fa] {
      display: none;
    }
    .vue-slider-mark-step[data-v-46ad63fa] {
      width: 100%;
      height: 100%;
    }
     .vue-slider-mark-step[data-v-46ad63fa] {
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.16);
    }
    .vue-slider-mark-label[data-v-46ad63fa] {
      font-size: 14px;
      white-space: nowrap;
    }
    /* dot style */
    .vue-slider-dot-handle[data-v-46ad63fa] {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
     .vue-slider-dot-handle[data-v-46ad63fa] {
      cursor: pointer;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: none;
    }
     .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(17, 74, 159, 0.36);
    }
     .vue-slider-dot-handle-disabled[data-v-46ad63fa] {
      cursor: not-allowed;
      background-color: #ccc;
    }
    .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      font-size: 14px;
      white-space: nowrap;
      min-width: 20px;
      color: #fff;
      box-sizing: content-box;
    }
     .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      padding: 2px 5px;
      text-align: center;
      border-radius: 5px;
      border-color: #114A9F;
      background-color: #114A9F;
    }
    .vue-slider-dot-tooltip-inner[data-v-46ad63fa]::after {
      content: "";
      position: absolute;
    }
    .vue-slider-dot-tooltip-inner-top[data-v-46ad63fa]::after {
      top: 100%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-top[data-v-46ad63fa]::after {
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
      border-top-color: inherit;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-top[data-v-46ad63fa]::after {
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-top[data-v-46ad63fa]::after {
      right: 50%;
      transform: translate(50%, 0);
    }
    .vue-slider-dot-tooltip-inner-bottom[data-v-46ad63fa]::after {
      bottom: 100%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-bottom[data-v-46ad63fa]::after {
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
      border-bottom-color: inherit;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-bottom[data-v-46ad63fa]::after {
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-bottom[data-v-46ad63fa]::after {
      right: 50%;
      transform: translate(50%, 0);
    }
    .vue-slider-dot-tooltip-inner-left[data-v-46ad63fa]::after {
      top: 50%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-left[data-v-46ad63fa]::after {
      transform: translate(0, -50%);
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-left[data-v-46ad63fa]::after {
      left: 100%;
      border-left-color: inherit;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-left[data-v-46ad63fa]::after {
      right: 100%;
      border-right-color: inherit;
    }
    .vue-slider-dot-tooltip-inner-right[data-v-46ad63fa]::after {
      top: 50%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-right[data-v-46ad63fa]::after {
      transform: translate(0, -50%);
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-right[data-v-46ad63fa]::after {
      right: 100%;
      border-right-color: inherit;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-right[data-v-46ad63fa]::after {
      left: 100%;
      border-left-color: inherit;
    }
    .vue-slider-dot-tooltip-wrapper[data-v-46ad63fa] {
      opacity: 0;
      transition: all 0.3s;
    }
    .vue-slider-dot-tooltip-wrapper-show[data-v-46ad63fa] {
      opacity: 1;
    }
     .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #114A9F;
    }
     .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #114A9F;
      border-color: #114A9F;
    }
    
    /* Generate:
    *  Border color according to event class
    */
     .vue-slider-white .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #ffffff;
    }
     .vue-slider-white .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(255, 255, 255, 0.36);
    }
     .vue-slider-white .vue-slider-process[data-v-46ad63fa] {
      background-color: #ffffff;
    }
     .vue-slider-white .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(255, 255, 255, 0.12);
    }
     .vue-slider-white .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #ffffff;
      border-color: #ffffff;
    }
     .vue-slider-black .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #000000;
    }
     .vue-slider-black .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(0, 0, 0, 0.36);
    }
     .vue-slider-black .vue-slider-process[data-v-46ad63fa] {
      background-color: #000000;
    }
     .vue-slider-black .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(0, 0, 0, 0.12);
    }
     .vue-slider-black .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #000000;
      border-color: #000000;
    }
     .vue-slider-dark .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #4B4B4B;
    }
     .vue-slider-dark .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(75, 75, 75, 0.36);
    }
     .vue-slider-dark .vue-slider-process[data-v-46ad63fa] {
      background-color: #4B4B4B;
    }
     .vue-slider-dark .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(75, 75, 75, 0.12);
    }
     .vue-slider-dark .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #4B4B4B;
      border-color: #4B4B4B;
    }
     .vue-slider-light .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #C1C1C1;
    }
     .vue-slider-light .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(193, 193, 193, 0.36);
    }
     .vue-slider-light .vue-slider-process[data-v-46ad63fa] {
      background-color: #C1C1C1;
    }
     .vue-slider-light .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(193, 193, 193, 0.12);
    }
     .vue-slider-light .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #C1C1C1;
      border-color: #C1C1C1;
    }
     .vue-slider-primary .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #114A9F;
    }
     .vue-slider-primary .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(17, 74, 159, 0.36);
    }
     .vue-slider-primary .vue-slider-process[data-v-46ad63fa] {
      background-color: #114A9F;
    }
     .vue-slider-primary .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(17, 74, 159, 0.12);
    }
     .vue-slider-primary .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #114A9F;
      border-color: #114A9F;
    }
     .vue-slider-secondary .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #9C9EA4;
    }
     .vue-slider-secondary .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(156, 158, 164, 0.36);
    }
     .vue-slider-secondary .vue-slider-process[data-v-46ad63fa] {
      background-color: #9C9EA4;
    }
     .vue-slider-secondary .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(156, 158, 164, 0.12);
    }
     .vue-slider-secondary .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #9C9EA4;
      border-color: #9C9EA4;
    }
     .vue-slider-success .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #17B75E;
    }
     .vue-slider-success .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(23, 183, 94, 0.36);
    }
     .vue-slider-success .vue-slider-process[data-v-46ad63fa] {
      background-color: #17B75E;
    }
     .vue-slider-success .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(23, 183, 94, 0.12);
    }
     .vue-slider-success .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #17B75E;
      border-color: #17B75E;
    }
     .vue-slider-info .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #00CFE8;
    }
     .vue-slider-info .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(0, 207, 232, 0.36);
    }
     .vue-slider-info .vue-slider-process[data-v-46ad63fa] {
      background-color: #00CFE8;
    }
     .vue-slider-info .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(0, 207, 232, 0.12);
    }
     .vue-slider-info .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #00CFE8;
      border-color: #00CFE8;
    }
     .vue-slider-warning .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #FDB913;
    }
     .vue-slider-warning .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(253, 185, 19, 0.36);
    }
     .vue-slider-warning .vue-slider-process[data-v-46ad63fa] {
      background-color: #FDB913;
    }
     .vue-slider-warning .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(253, 185, 19, 0.12);
    }
     .vue-slider-warning .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #FDB913;
      border-color: #FDB913;
    }
     .vue-slider-danger .vue-slider-dot-handle[data-v-46ad63fa] {
      border: 2px solid #EA5455;
    }
     .vue-slider-danger .vue-slider-dot-handle-focus[data-v-46ad63fa] {
      box-shadow: 0px 0px 1px 2px rgba(234, 84, 85, 0.36);
    }
     .vue-slider-danger .vue-slider-process[data-v-46ad63fa] {
      background-color: #EA5455;
    }
     .vue-slider-danger .vue-slider-rail[data-v-46ad63fa] {
      background-color: rgba(234, 84, 85, 0.12);
    }
     .vue-slider-danger .vue-slider-dot-tooltip-inner[data-v-46ad63fa] {
      background-color: #EA5455;
      border-color: #EA5455;
    }
     body.dark-layout .vue-slider-dot-handle[data-v-46ad63fa] {
      background-color: #161d31;
    }
    [data-v-46ad63fa] .modal-content {
      width: 650px;
    }
    [data-v-46ad63fa]  .modal-content {
      background: #FFFFFF;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
     .banned-background-color-primary[data-v-46ad63fa] {
      background: rgba(17, 74, 159, 0.12);
    }
    .title-modal[data-v-46ad63fa] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #114A9F;
      line-height: 21px;
    }
    .content-body-modal[data-v-46ad63fa] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    .color-primary[data-v-46ad63fa] {
      color: #114A9F;
    }
     .intro-wrapper[data-v-46ad63fa] {
      margin-bottom: 18px;
    }
    .intro-wrapper .text-intro[data-v-46ad63fa] {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #424244;
    }
     .box[data-v-46ad63fa] {
      background: #FFFFFF;
      border-radius: 6px;
      box-shadow: 0 4px 6px rgba(17, 74, 159, 0.38);
    }
    .box .header[data-v-46ad63fa] {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     .box .header[data-v-46ad63fa] {
      background: rgba(17, 74, 159, 0.2);
      padding: 10px 14px;
      border-radius: 6px 6px 0 0;
    }
    .box .header .user-name-wrapper[data-v-46ad63fa] {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .box .header .user-name-wrapper .dot[data-v-46ad63fa] {
      width: 15px;
      height: 15px;
    }
     .box .header .user-name-wrapper .dot[data-v-46ad63fa] {
      background-color: #114A9F;
      border-radius: 100%;
    }
    [dir=ltr] .box .header .user-name-wrapper .dot[data-v-46ad63fa] {
      margin-right: 5px;
    }
    [dir=rtl] .box .header .user-name-wrapper .dot[data-v-46ad63fa] {
      margin-left: 5px;
    }
    .box .header .user-name-wrapper .user-name[data-v-46ad63fa] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
     .box .header .user-name-wrapper .user-name[data-v-46ad63fa] {
      margin-bottom: 0;
    }
    .box .header .info-tee[data-v-46ad63fa] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
     .box .header .info-tee[data-v-46ad63fa] {
      margin-bottom: 0;
    }
     .box .body[data-v-46ad63fa] {
      padding: 14px;
    }
     .box .body .spacing-4[data-v-46ad63fa] {
      margin: 4px 0;
    }
     .box .body .spacing-4 .block[data-v-46ad63fa] {
      margin: 5px 0;
    }
    .box .body .spacing-4 .play-line-block[data-v-46ad63fa] {
      width: 34px;
      height: 28px;
      box-sizing: border-box;
    }
     .box .body .spacing-4 .play-line-block[data-v-46ad63fa] {
      background: #FFFFFF;
      border-radius: 5px;
      border: 1px solid #D6D9E1;
      cursor: pointer;
    }
    .box .body .spacing-4 .play-line-block p[data-v-46ad63fa] {
      color: #114A9F;
      display: flex;
      justify-content: center;
      align-items: center;
    }
     .box .btn-tee[data-v-46ad63fa] {
      padding: 6px;
    }
    .box .d-select-hole[data-v-46ad63fa] {
      width: 92px;
    }
    .vue-slider-disabled[data-v-6c782c30] {
      opacity: 0.5;
    }
     .vue-slider-disabled[data-v-6c782c30] {
      cursor: not-allowed;
    }
    
    /* rail style */
     .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(17, 74, 159, 0.12);
      border-radius: 15px;
    }
    
    /* process style */
     .vue-slider-process[data-v-6c782c30] {
      background-color: #114A9F;
      border-radius: 15px;
    }
    
    /* mark style */
    .vue-slider-mark[data-v-6c782c30] {
      z-index: 4;
    }
    .vue-slider-mark:first-child .vue-slider-mark-step[data-v-6c782c30], .vue-slider-mark:last-child .vue-slider-mark-step[data-v-6c782c30] {
      display: none;
    }
    .vue-slider-mark-step[data-v-6c782c30] {
      width: 100%;
      height: 100%;
    }
     .vue-slider-mark-step[data-v-6c782c30] {
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.16);
    }
    .vue-slider-mark-label[data-v-6c782c30] {
      font-size: 14px;
      white-space: nowrap;
    }
    /* dot style */
    .vue-slider-dot-handle[data-v-6c782c30] {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
     .vue-slider-dot-handle[data-v-6c782c30] {
      cursor: pointer;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: none;
    }
     .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(17, 74, 159, 0.36);
    }
     .vue-slider-dot-handle-disabled[data-v-6c782c30] {
      cursor: not-allowed;
      background-color: #ccc;
    }
    .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      font-size: 14px;
      white-space: nowrap;
      min-width: 20px;
      color: #fff;
      box-sizing: content-box;
    }
     .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      padding: 2px 5px;
      text-align: center;
      border-radius: 5px;
      border-color: #114A9F;
      background-color: #114A9F;
    }
    .vue-slider-dot-tooltip-inner[data-v-6c782c30]::after {
      content: "";
      position: absolute;
    }
    .vue-slider-dot-tooltip-inner-top[data-v-6c782c30]::after {
      top: 100%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-top[data-v-6c782c30]::after {
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
      border-top-color: inherit;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-top[data-v-6c782c30]::after {
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-top[data-v-6c782c30]::after {
      right: 50%;
      transform: translate(50%, 0);
    }
    .vue-slider-dot-tooltip-inner-bottom[data-v-6c782c30]::after {
      bottom: 100%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-bottom[data-v-6c782c30]::after {
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
      border-bottom-color: inherit;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-bottom[data-v-6c782c30]::after {
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-bottom[data-v-6c782c30]::after {
      right: 50%;
      transform: translate(50%, 0);
    }
    .vue-slider-dot-tooltip-inner-left[data-v-6c782c30]::after {
      top: 50%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-left[data-v-6c782c30]::after {
      transform: translate(0, -50%);
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-left[data-v-6c782c30]::after {
      left: 100%;
      border-left-color: inherit;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-left[data-v-6c782c30]::after {
      right: 100%;
      border-right-color: inherit;
    }
    .vue-slider-dot-tooltip-inner-right[data-v-6c782c30]::after {
      top: 50%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-right[data-v-6c782c30]::after {
      transform: translate(0, -50%);
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-right[data-v-6c782c30]::after {
      right: 100%;
      border-right-color: inherit;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-right[data-v-6c782c30]::after {
      left: 100%;
      border-left-color: inherit;
    }
    .vue-slider-dot-tooltip-wrapper[data-v-6c782c30] {
      opacity: 0;
      transition: all 0.3s;
    }
    .vue-slider-dot-tooltip-wrapper-show[data-v-6c782c30] {
      opacity: 1;
    }
     .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #114A9F;
    }
     .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #114A9F;
      border-color: #114A9F;
    }
    
    /* Generate:
    *  Border color according to event class
    */
     .vue-slider-white .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #ffffff;
    }
     .vue-slider-white .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(255, 255, 255, 0.36);
    }
     .vue-slider-white .vue-slider-process[data-v-6c782c30] {
      background-color: #ffffff;
    }
     .vue-slider-white .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(255, 255, 255, 0.12);
    }
     .vue-slider-white .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #ffffff;
      border-color: #ffffff;
    }
     .vue-slider-black .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #000000;
    }
     .vue-slider-black .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(0, 0, 0, 0.36);
    }
     .vue-slider-black .vue-slider-process[data-v-6c782c30] {
      background-color: #000000;
    }
     .vue-slider-black .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(0, 0, 0, 0.12);
    }
     .vue-slider-black .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #000000;
      border-color: #000000;
    }
     .vue-slider-dark .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #4B4B4B;
    }
     .vue-slider-dark .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(75, 75, 75, 0.36);
    }
     .vue-slider-dark .vue-slider-process[data-v-6c782c30] {
      background-color: #4B4B4B;
    }
     .vue-slider-dark .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(75, 75, 75, 0.12);
    }
     .vue-slider-dark .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #4B4B4B;
      border-color: #4B4B4B;
    }
     .vue-slider-light .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #C1C1C1;
    }
     .vue-slider-light .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(193, 193, 193, 0.36);
    }
     .vue-slider-light .vue-slider-process[data-v-6c782c30] {
      background-color: #C1C1C1;
    }
     .vue-slider-light .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(193, 193, 193, 0.12);
    }
     .vue-slider-light .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #C1C1C1;
      border-color: #C1C1C1;
    }
     .vue-slider-primary .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #114A9F;
    }
     .vue-slider-primary .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(17, 74, 159, 0.36);
    }
     .vue-slider-primary .vue-slider-process[data-v-6c782c30] {
      background-color: #114A9F;
    }
     .vue-slider-primary .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(17, 74, 159, 0.12);
    }
     .vue-slider-primary .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #114A9F;
      border-color: #114A9F;
    }
     .vue-slider-secondary .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #9C9EA4;
    }
     .vue-slider-secondary .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(156, 158, 164, 0.36);
    }
     .vue-slider-secondary .vue-slider-process[data-v-6c782c30] {
      background-color: #9C9EA4;
    }
     .vue-slider-secondary .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(156, 158, 164, 0.12);
    }
     .vue-slider-secondary .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #9C9EA4;
      border-color: #9C9EA4;
    }
     .vue-slider-success .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #17B75E;
    }
     .vue-slider-success .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(23, 183, 94, 0.36);
    }
     .vue-slider-success .vue-slider-process[data-v-6c782c30] {
      background-color: #17B75E;
    }
     .vue-slider-success .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(23, 183, 94, 0.12);
    }
     .vue-slider-success .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #17B75E;
      border-color: #17B75E;
    }
     .vue-slider-info .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #00CFE8;
    }
     .vue-slider-info .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(0, 207, 232, 0.36);
    }
     .vue-slider-info .vue-slider-process[data-v-6c782c30] {
      background-color: #00CFE8;
    }
     .vue-slider-info .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(0, 207, 232, 0.12);
    }
     .vue-slider-info .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #00CFE8;
      border-color: #00CFE8;
    }
     .vue-slider-warning .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #FDB913;
    }
     .vue-slider-warning .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(253, 185, 19, 0.36);
    }
     .vue-slider-warning .vue-slider-process[data-v-6c782c30] {
      background-color: #FDB913;
    }
     .vue-slider-warning .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(253, 185, 19, 0.12);
    }
     .vue-slider-warning .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #FDB913;
      border-color: #FDB913;
    }
     .vue-slider-danger .vue-slider-dot-handle[data-v-6c782c30] {
      border: 2px solid #EA5455;
    }
     .vue-slider-danger .vue-slider-dot-handle-focus[data-v-6c782c30] {
      box-shadow: 0px 0px 1px 2px rgba(234, 84, 85, 0.36);
    }
     .vue-slider-danger .vue-slider-process[data-v-6c782c30] {
      background-color: #EA5455;
    }
     .vue-slider-danger .vue-slider-rail[data-v-6c782c30] {
      background-color: rgba(234, 84, 85, 0.12);
    }
     .vue-slider-danger .vue-slider-dot-tooltip-inner[data-v-6c782c30] {
      background-color: #EA5455;
      border-color: #EA5455;
    }
     body.dark-layout .vue-slider-dot-handle[data-v-6c782c30] {
      background-color: #161d31;
    }
    [data-v-6c782c30] .modal-content {
      width: 900px;
    }
    [data-v-6c782c30]  .modal-content {
      background: #FFFFFF;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
    [data-v-6c782c30] .vs__selected-options {
      flex-wrap: inherit !important;
      max-width: 100%;
      overflow: hidden;
    }
    [data-v-6c782c30] .vs__selected-options .vs__selected {
      overflow: hidden;
      max-width: 100%;
      white-space: nowrap;
    }
    [data-v-6c782c30]  .form-group {
      margin-bottom: 0 !important;
    }
     .banned-background-color-primary[data-v-6c782c30] {
      background: rgba(17, 74, 159, 0.12);
    }
    .title-modal[data-v-6c782c30] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #114A9F;
      line-height: 21px;
    }
    .content-body-modal[data-v-6c782c30] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    .color-primary[data-v-6c782c30] {
      color: #114A9F;
    }
    .header-table-custom th[data-v-6c782c30] {
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
     .header-table-custom th[data-v-6c782c30] {
      background: #F2F3F7;
      border-bottom: unset;
      padding: 10px;
    }
    .body-table-custom .header-board td[data-v-6c782c30] {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      color: #5D5F65;
    }
     .body-table-custom .header-board td[data-v-6c782c30] {
      padding: 10px;
    }
     .disabled[data-v-6c782c30] {
      background: rgba(193, 193, 193, 0.12);
    }
    .vue-slider-disabled[data-v-e50b6d5a] {
      opacity: 0.5;
    }
     .vue-slider-disabled[data-v-e50b6d5a] {
      cursor: not-allowed;
    }
    
    /* rail style */
     .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(17, 74, 159, 0.12);
      border-radius: 15px;
    }
    
    /* process style */
     .vue-slider-process[data-v-e50b6d5a] {
      background-color: #114A9F;
      border-radius: 15px;
    }
    
    /* mark style */
    .vue-slider-mark[data-v-e50b6d5a] {
      z-index: 4;
    }
    .vue-slider-mark:first-child .vue-slider-mark-step[data-v-e50b6d5a], .vue-slider-mark:last-child .vue-slider-mark-step[data-v-e50b6d5a] {
      display: none;
    }
    .vue-slider-mark-step[data-v-e50b6d5a] {
      width: 100%;
      height: 100%;
    }
     .vue-slider-mark-step[data-v-e50b6d5a] {
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.16);
    }
    .vue-slider-mark-label[data-v-e50b6d5a] {
      font-size: 14px;
      white-space: nowrap;
    }
    /* dot style */
    .vue-slider-dot-handle[data-v-e50b6d5a] {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
     .vue-slider-dot-handle[data-v-e50b6d5a] {
      cursor: pointer;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: none;
    }
     .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(17, 74, 159, 0.36);
    }
     .vue-slider-dot-handle-disabled[data-v-e50b6d5a] {
      cursor: not-allowed;
      background-color: #ccc;
    }
    .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      font-size: 14px;
      white-space: nowrap;
      min-width: 20px;
      color: #fff;
      box-sizing: content-box;
    }
     .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      padding: 2px 5px;
      text-align: center;
      border-radius: 5px;
      border-color: #114A9F;
      background-color: #114A9F;
    }
    .vue-slider-dot-tooltip-inner[data-v-e50b6d5a]::after {
      content: "";
      position: absolute;
    }
    .vue-slider-dot-tooltip-inner-top[data-v-e50b6d5a]::after {
      top: 100%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-top[data-v-e50b6d5a]::after {
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
      border-top-color: inherit;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-top[data-v-e50b6d5a]::after {
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-top[data-v-e50b6d5a]::after {
      right: 50%;
      transform: translate(50%, 0);
    }
    .vue-slider-dot-tooltip-inner-bottom[data-v-e50b6d5a]::after {
      bottom: 100%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-bottom[data-v-e50b6d5a]::after {
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
      border-bottom-color: inherit;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-bottom[data-v-e50b6d5a]::after {
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-bottom[data-v-e50b6d5a]::after {
      right: 50%;
      transform: translate(50%, 0);
    }
    .vue-slider-dot-tooltip-inner-left[data-v-e50b6d5a]::after {
      top: 50%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-left[data-v-e50b6d5a]::after {
      transform: translate(0, -50%);
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-left[data-v-e50b6d5a]::after {
      left: 100%;
      border-left-color: inherit;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-left[data-v-e50b6d5a]::after {
      right: 100%;
      border-right-color: inherit;
    }
    .vue-slider-dot-tooltip-inner-right[data-v-e50b6d5a]::after {
      top: 50%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-right[data-v-e50b6d5a]::after {
      transform: translate(0, -50%);
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-right[data-v-e50b6d5a]::after {
      right: 100%;
      border-right-color: inherit;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-right[data-v-e50b6d5a]::after {
      left: 100%;
      border-left-color: inherit;
    }
    .vue-slider-dot-tooltip-wrapper[data-v-e50b6d5a] {
      opacity: 0;
      transition: all 0.3s;
    }
    .vue-slider-dot-tooltip-wrapper-show[data-v-e50b6d5a] {
      opacity: 1;
    }
     .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #114A9F;
    }
     .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #114A9F;
      border-color: #114A9F;
    }
    
    /* Generate:
    *  Border color according to event class
    */
     .vue-slider-white .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #ffffff;
    }
     .vue-slider-white .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(255, 255, 255, 0.36);
    }
     .vue-slider-white .vue-slider-process[data-v-e50b6d5a] {
      background-color: #ffffff;
    }
     .vue-slider-white .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(255, 255, 255, 0.12);
    }
     .vue-slider-white .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #ffffff;
      border-color: #ffffff;
    }
     .vue-slider-black .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #000000;
    }
     .vue-slider-black .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(0, 0, 0, 0.36);
    }
     .vue-slider-black .vue-slider-process[data-v-e50b6d5a] {
      background-color: #000000;
    }
     .vue-slider-black .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(0, 0, 0, 0.12);
    }
     .vue-slider-black .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #000000;
      border-color: #000000;
    }
     .vue-slider-dark .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #4B4B4B;
    }
     .vue-slider-dark .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(75, 75, 75, 0.36);
    }
     .vue-slider-dark .vue-slider-process[data-v-e50b6d5a] {
      background-color: #4B4B4B;
    }
     .vue-slider-dark .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(75, 75, 75, 0.12);
    }
     .vue-slider-dark .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #4B4B4B;
      border-color: #4B4B4B;
    }
     .vue-slider-light .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #C1C1C1;
    }
     .vue-slider-light .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(193, 193, 193, 0.36);
    }
     .vue-slider-light .vue-slider-process[data-v-e50b6d5a] {
      background-color: #C1C1C1;
    }
     .vue-slider-light .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(193, 193, 193, 0.12);
    }
     .vue-slider-light .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #C1C1C1;
      border-color: #C1C1C1;
    }
     .vue-slider-primary .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #114A9F;
    }
     .vue-slider-primary .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(17, 74, 159, 0.36);
    }
     .vue-slider-primary .vue-slider-process[data-v-e50b6d5a] {
      background-color: #114A9F;
    }
     .vue-slider-primary .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(17, 74, 159, 0.12);
    }
     .vue-slider-primary .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #114A9F;
      border-color: #114A9F;
    }
     .vue-slider-secondary .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #9C9EA4;
    }
     .vue-slider-secondary .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(156, 158, 164, 0.36);
    }
     .vue-slider-secondary .vue-slider-process[data-v-e50b6d5a] {
      background-color: #9C9EA4;
    }
     .vue-slider-secondary .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(156, 158, 164, 0.12);
    }
     .vue-slider-secondary .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #9C9EA4;
      border-color: #9C9EA4;
    }
     .vue-slider-success .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #17B75E;
    }
     .vue-slider-success .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(23, 183, 94, 0.36);
    }
     .vue-slider-success .vue-slider-process[data-v-e50b6d5a] {
      background-color: #17B75E;
    }
     .vue-slider-success .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(23, 183, 94, 0.12);
    }
     .vue-slider-success .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #17B75E;
      border-color: #17B75E;
    }
     .vue-slider-info .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #00CFE8;
    }
     .vue-slider-info .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(0, 207, 232, 0.36);
    }
     .vue-slider-info .vue-slider-process[data-v-e50b6d5a] {
      background-color: #00CFE8;
    }
     .vue-slider-info .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(0, 207, 232, 0.12);
    }
     .vue-slider-info .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #00CFE8;
      border-color: #00CFE8;
    }
     .vue-slider-warning .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #FDB913;
    }
     .vue-slider-warning .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(253, 185, 19, 0.36);
    }
     .vue-slider-warning .vue-slider-process[data-v-e50b6d5a] {
      background-color: #FDB913;
    }
     .vue-slider-warning .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(253, 185, 19, 0.12);
    }
     .vue-slider-warning .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #FDB913;
      border-color: #FDB913;
    }
     .vue-slider-danger .vue-slider-dot-handle[data-v-e50b6d5a] {
      border: 2px solid #EA5455;
    }
     .vue-slider-danger .vue-slider-dot-handle-focus[data-v-e50b6d5a] {
      box-shadow: 0px 0px 1px 2px rgba(234, 84, 85, 0.36);
    }
     .vue-slider-danger .vue-slider-process[data-v-e50b6d5a] {
      background-color: #EA5455;
    }
     .vue-slider-danger .vue-slider-rail[data-v-e50b6d5a] {
      background-color: rgba(234, 84, 85, 0.12);
    }
     .vue-slider-danger .vue-slider-dot-tooltip-inner[data-v-e50b6d5a] {
      background-color: #EA5455;
      border-color: #EA5455;
    }
     body.dark-layout .vue-slider-dot-handle[data-v-e50b6d5a] {
      background-color: #161d31;
    }
    [data-v-e50b6d5a] .modal-content {
      width: 900px;
    }
    [data-v-e50b6d5a]  .modal-content {
      background: #FFFFFF;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
    [data-v-e50b6d5a] .b-table-sticky-header {
      overflow-y: auto !important;
      max-height: 85% !important;
    }
     .banned-background-color-primary[data-v-e50b6d5a] {
      background: rgba(17, 74, 159, 0.12);
    }
    .title-modal[data-v-e50b6d5a] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #114A9F;
      line-height: 21px;
    }
    .content-body-modal[data-v-e50b6d5a] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    .color-primary[data-v-e50b6d5a] {
      color: #114A9F;
    }
    .header-table-custom th[data-v-e50b6d5a] {
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
     .header-table-custom th[data-v-e50b6d5a] {
      background: #F2F3F7;
      border-bottom: unset;
      padding: 10px;
    }
    .body-table-custom .header-board td[data-v-e50b6d5a] {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      color: #5D5F65;
    }
     .body-table-custom .header-board td[data-v-e50b6d5a] {
      padding: 10px;
    }
     .disabled[data-v-e50b6d5a] {
      background: rgba(193, 193, 193, 0.12);
    }
    .modal-content {
      width: 400px;
    }[data-v-7ff34ea8]  .modal-content {
      background: #FFFFFF;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
    [data-v-7ff34ea8] .vs__selected-options {
      flex-wrap: inherit !important;
      max-width: 100%;
      overflow: hidden;
    }
    [data-v-7ff34ea8] .vs__selected-options .vs__selected {
      overflow: hidden;
      max-width: 100%;
      white-space: nowrap;
    }
     .banned-background-color-primary[data-v-7ff34ea8] {
      background: rgba(17, 74, 159, 0.12);
    }
    .title-modal[data-v-7ff34ea8] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #114A9F;
      line-height: 21px;
    }
    .content-body-modal[data-v-7ff34ea8] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    .color-primary[data-v-7ff34ea8] {
      color: #114A9F;
    }
    .header-table-custom th[data-v-7ff34ea8] {
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
     .header-table-custom th[data-v-7ff34ea8] {
      background: #F2F3F7;
      border-bottom: unset;
      padding: 10px;
    }
    .body-table-custom .header-board td[data-v-7ff34ea8] {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      color: #5D5F65;
    }
     .body-table-custom .header-board td[data-v-7ff34ea8] {
      padding: 10px;
    }
     .disabled[data-v-7ff34ea8] {
      background: rgba(193, 193, 193, 0.12);
    }
    #modal-checkin .block-header .title-modal[data-v-bb89d63a] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
    }
    #modal-checkin .color-primary[data-v-bb89d63a] {
      color: #114A9F;
    }
    #modal-checkin .w-50[data-v-bb89d63a] {
      width: 65px !important;
    }
    #modal-checkin .color-warning[data-v-bb89d63a] {
      color: #FF9F43;
    }
    #modal-checkin .content-body-modal[data-v-bb89d63a] {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
    #modal-checkin .fullname[data-v-bb89d63a] {
      width: 160px;
    }
    #modal-checkin .block[data-v-bb89d63a] {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
     #modal-checkin .block[data-v-bb89d63a] {
      margin-top: 20px;
    }
    #modal-checkin .block .dot[data-v-bb89d63a] {
      width: 10px;
      height: 10px;
    }
     #modal-checkin .block .dot[data-v-bb89d63a] {
      border-radius: 100%;
      padding: 0;
    }
     #modal-checkin .block p[data-v-bb89d63a] {
      margin-bottom: 0;
    }
    [dir=ltr] #modal-checkin .block p[data-v-bb89d63a] {
      margin-left: 10px;
    }
    [dir=rtl] #modal-checkin .block p[data-v-bb89d63a] {
      margin-right: 10px;
    }
    .card-header.banned-background-color {
      height: 48px !important;
    } .card-header.banned-background-color {
      background: rgba(234, 84, 85, 0.12) !important;
      border-radius: 6px 6px 0px 0px;
    }
    .card-header.banned-background-color .color-red {
      color: #EA5455;
    }
    .card-header.banned-background-color .title-modal {
      font-size: 18px;
      line-height: 21px;
      font-weight: 500;
    }
     .card-header.banned-background-color .title-modal {
      padding: 10px 0;
    }
    .card-header.banned-background-color .text {
      color: #5D5F65;
      font-size: 12px;
      line-height: 18px;
    }
    .block-header {
      height: 48px !important;
    }
     .card-header {
      padding: 0 1.5rem;
    }
    .app-timeline[data-v-538cb940] {
      list-style: none;
      position: relative;
    } .app-timeline[data-v-538cb940] {
      padding: 0;
      margin: 0;
    }[dir=ltr] .app-timeline[data-v-538cb940] {
      margin-left: 1rem;
    }[dir=rtl] .app-timeline[data-v-538cb940] {
      margin-right: 1rem;
    }
    .timeline-variant-white.timeline-item-fill-border-white[data-v-ffb3c5da] {
      border-color: #ffffff !important;
    }
     .timeline-variant-white.timeline-item-fill-border-white[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#ffffff, #fff);
    }
     .timeline-variant-white .timeline-item-point[data-v-ffb3c5da] {
      background-color: #ffffff;
    }
     .timeline-variant-white .timeline-item-point[data-v-ffb3c5da]:before {
      background-color: rgba(255, 255, 255, 0.12);
    }
    .timeline-variant-white .timeline-item-icon[data-v-ffb3c5da] {
      color: #ffffff;
    }
     .timeline-variant-white .timeline-item-icon[data-v-ffb3c5da] {
      border: 1px solid #ffffff;
    }
     .timeline-variant-black.timeline-item-fill-border-black[data-v-ffb3c5da] {
      border-color: #000000 !important;
    }
     .timeline-variant-black.timeline-item-fill-border-black[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#000000, #fff);
    }
     .timeline-variant-black .timeline-item-point[data-v-ffb3c5da] {
      background-color: #000000;
    }
     .timeline-variant-black .timeline-item-point[data-v-ffb3c5da]:before {
      background-color: rgba(0, 0, 0, 0.12);
    }
    .timeline-variant-black .timeline-item-icon[data-v-ffb3c5da] {
      color: #000000;
    }
     .timeline-variant-black .timeline-item-icon[data-v-ffb3c5da] {
      border: 1px solid #000000;
    }
     .timeline-variant-dark.timeline-item-fill-border-dark[data-v-ffb3c5da] {
      border-color: #4B4B4B !important;
    }
     .timeline-variant-dark.timeline-item-fill-border-dark[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#4B4B4B, #fff);
    }
     .timeline-variant-dark .timeline-item-point[data-v-ffb3c5da] {
      background-color: #4B4B4B;
    }
     .timeline-variant-dark .timeline-item-point[data-v-ffb3c5da]:before {
      background-color: rgba(75, 75, 75, 0.12);
    }
    .timeline-variant-dark .timeline-item-icon[data-v-ffb3c5da] {
      color: #4B4B4B;
    }
     .timeline-variant-dark .timeline-item-icon[data-v-ffb3c5da] {
      border: 1px solid #4B4B4B;
    }
     .timeline-variant-light.timeline-item-fill-border-light[data-v-ffb3c5da] {
      border-color: #C1C1C1 !important;
    }
     .timeline-variant-light.timeline-item-fill-border-light[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#C1C1C1, #fff);
    }
     .timeline-variant-light .timeline-item-point[data-v-ffb3c5da] {
      background-color: #C1C1C1;
    }
     .timeline-variant-light .timeline-item-point[data-v-ffb3c5da]:before {
      background-color: rgba(193, 193, 193, 0.12);
    }
    .timeline-variant-light .timeline-item-icon[data-v-ffb3c5da] {
      color: #C1C1C1;
    }
     .timeline-variant-light .timeline-item-icon[data-v-ffb3c5da] {
      border: 1px solid #C1C1C1;
    }
     .timeline-variant-primary.timeline-item-fill-border-primary[data-v-ffb3c5da] {
      border-color: #114A9F !important;
    }
     .timeline-variant-primary.timeline-item-fill-border-primary[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#114A9F, #fff);
    }
     .timeline-variant-primary .timeline-item-point[data-v-ffb3c5da] {
      background-color: #114A9F;
    }
     .timeline-variant-primary .timeline-item-point[data-v-ffb3c5da]:before {
      background-color: rgba(17, 74, 159, 0.12);
    }
    .timeline-variant-primary .timeline-item-icon[data-v-ffb3c5da] {
      color: #114A9F;
    }
     .timeline-variant-primary .timeline-item-icon[data-v-ffb3c5da] {
      border: 1px solid #114A9F;
    }
     .timeline-variant-secondary.timeline-item-fill-border-secondary[data-v-ffb3c5da] {
      border-color: #9C9EA4 !important;
    }
     .timeline-variant-secondary.timeline-item-fill-border-secondary[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#9C9EA4, #fff);
    }
     .timeline-variant-secondary .timeline-item-point[data-v-ffb3c5da] {
      background-color: #9C9EA4;
    }
     .timeline-variant-secondary .timeline-item-point[data-v-ffb3c5da]:before {
      background-color: rgba(156, 158, 164, 0.12);
    }
    .timeline-variant-secondary .timeline-item-icon[data-v-ffb3c5da] {
      color: #9C9EA4;
    }
     .timeline-variant-secondary .timeline-item-icon[data-v-ffb3c5da] {
      border: 1px solid #9C9EA4;
    }
     .timeline-variant-success.timeline-item-fill-border-success[data-v-ffb3c5da] {
      border-color: #17B75E !important;
    }
     .timeline-variant-success.timeline-item-fill-border-success[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#17B75E, #fff);
    }
     .timeline-variant-success .timeline-item-point[data-v-ffb3c5da] {
      background-color: #17B75E;
    }
     .timeline-variant-success .timeline-item-point[data-v-ffb3c5da]:before {
      background-color: rgba(23, 183, 94, 0.12);
    }
    .timeline-variant-success .timeline-item-icon[data-v-ffb3c5da] {
      color: #17B75E;
    }
     .timeline-variant-success .timeline-item-icon[data-v-ffb3c5da] {
      border: 1px solid #17B75E;
    }
     .timeline-variant-info.timeline-item-fill-border-info[data-v-ffb3c5da] {
      border-color: #00CFE8 !important;
    }
     .timeline-variant-info.timeline-item-fill-border-info[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#00CFE8, #fff);
    }
     .timeline-variant-info .timeline-item-point[data-v-ffb3c5da] {
      background-color: #00CFE8;
    }
     .timeline-variant-info .timeline-item-point[data-v-ffb3c5da]:before {
      background-color: rgba(0, 207, 232, 0.12);
    }
    .timeline-variant-info .timeline-item-icon[data-v-ffb3c5da] {
      color: #00CFE8;
    }
     .timeline-variant-info .timeline-item-icon[data-v-ffb3c5da] {
      border: 1px solid #00CFE8;
    }
     .timeline-variant-warning.timeline-item-fill-border-warning[data-v-ffb3c5da] {
      border-color: #FDB913 !important;
    }
     .timeline-variant-warning.timeline-item-fill-border-warning[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#FDB913, #fff);
    }
     .timeline-variant-warning .timeline-item-point[data-v-ffb3c5da] {
      background-color: #FDB913;
    }
     .timeline-variant-warning .timeline-item-point[data-v-ffb3c5da]:before {
      background-color: rgba(253, 185, 19, 0.12);
    }
    .timeline-variant-warning .timeline-item-icon[data-v-ffb3c5da] {
      color: #FDB913;
    }
     .timeline-variant-warning .timeline-item-icon[data-v-ffb3c5da] {
      border: 1px solid #FDB913;
    }
     .timeline-variant-danger.timeline-item-fill-border-danger[data-v-ffb3c5da] {
      border-color: #EA5455 !important;
    }
     .timeline-variant-danger.timeline-item-fill-border-danger[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#EA5455, #fff);
    }
     .timeline-variant-danger .timeline-item-point[data-v-ffb3c5da] {
      background-color: #EA5455;
    }
     .timeline-variant-danger .timeline-item-point[data-v-ffb3c5da]:before {
      background-color: rgba(234, 84, 85, 0.12);
    }
    .timeline-variant-danger .timeline-item-icon[data-v-ffb3c5da] {
      color: #EA5455;
    }
     .timeline-variant-danger .timeline-item-icon[data-v-ffb3c5da] {
      border: 1px solid #EA5455;
    }
    .timeline-item[data-v-ffb3c5da] {
      position: relative;
    }
    [dir=ltr] .timeline-item[data-v-ffb3c5da] {
      padding-left: 2.5rem;
    }
    [dir=rtl] .timeline-item[data-v-ffb3c5da] {
      padding-right: 2.5rem;
    }
     .timeline-item[data-v-ffb3c5da]:not(:last-of-type) {
      padding-bottom: 2rem;
    }
    [dir=ltr] .timeline-item[data-v-ffb3c5da]:not(:last-of-type) {
      border-left: 1px solid #ebe9f1;
    }
    [dir=rtl] .timeline-item[data-v-ffb3c5da]:not(:last-of-type) {
      border-right: 1px solid #ebe9f1;
    }
    .timeline-item[data-v-ffb3c5da]:last-of-type:after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 1px;
      height: 100%;
    }
     .timeline-item[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#ebe9f1, #fff);
    }
    [dir=ltr] .timeline-item[data-v-ffb3c5da]:last-of-type:after {
      left: 0;
    }
    [dir=rtl] .timeline-item[data-v-ffb3c5da]:last-of-type:after {
      right: 0;
    }
    .timeline-item .timeline-item-point[data-v-ffb3c5da] {
      position: absolute;
      width: 12px;
      height: 12px;
      top: 0;
      z-index: 1;
    }
     .timeline-item .timeline-item-point[data-v-ffb3c5da] {
      border-radius: 50%;
    }
    [dir=ltr] .timeline-item .timeline-item-point[data-v-ffb3c5da] {
      left: -6px;
    }
    [dir=rtl] .timeline-item .timeline-item-point[data-v-ffb3c5da] {
      right: -6px;
    }
    .timeline-item .timeline-item-point[data-v-ffb3c5da]:before {
      content: "";
      z-index: 1;
      width: 20px;
      height: 20px;
      position: absolute;
      top: -4px;
      bottom: 0;
    }
     .timeline-item .timeline-item-point[data-v-ffb3c5da]:before {
      border-radius: 50%;
    }
    [dir=ltr] .timeline-item .timeline-item-point[data-v-ffb3c5da]:before {
      left: -4px;
      right: 0;
    }
    [dir=rtl] .timeline-item .timeline-item-point[data-v-ffb3c5da]:before {
      right: -4px;
      left: 0;
    }
    .timeline-item .timeline-item-icon[data-v-ffb3c5da] {
      position: absolute;
      top: 0;
      width: 24px;
      height: 24px;
      z-index: 1;
    }
     .timeline-item .timeline-item-icon[data-v-ffb3c5da] {
      background-color: #fff;
    }
    [dir=ltr] .timeline-item .timeline-item-icon[data-v-ffb3c5da] {
      left: -12px;
    }
    [dir=rtl] .timeline-item .timeline-item-icon[data-v-ffb3c5da] {
      right: -12px;
    }
     .dark-layout .timeline-item[data-v-ffb3c5da]:last-of-type:after {
      background: linear-gradient(#3b4253, #283046);
    }
    [dir=ltr] .dark-layout .timeline-item[data-v-ffb3c5da]:not(:last-of-type) {
      border-left-color: #3b4253;
    }
    [dir=rtl] .dark-layout .timeline-item[data-v-ffb3c5da]:not(:last-of-type) {
      border-right-color: #3b4253;
    }
     .dark-layout .timeline-item .timeline-item-icon[data-v-ffb3c5da] {
      background-color: #283046;
    }
    .flatpickr-calendar {
      opacity: 0;
      display: none;
      visibility: hidden;
      font-size: 14px;
      line-height: 24px;
      position: absolute;
      width: 307.875px;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      -ms-touch-action: manipulation;
          touch-action: manipulation;
    } .flatpickr-calendar {
      background: transparent;
      text-align: center;
      padding: 0;
      border: 0;
      border-radius: 5px;
      background: #fff;
    }[dir=ltr] .flatpickr-calendar {
      -webkit-animation: none;
      animation: none;
      direction: ltr;
      -webkit-box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0,0,0,0.08);
      box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0,0,0,0.08);
    }[dir=rtl] .flatpickr-calendar {
      -webkit-animation: none;
              animation: none;
      direction: rtl;
      -webkit-box-shadow: -1px 0 0 #e6e6e6, 1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0,0,0,0.08);
              box-shadow: -1px 0 0 #e6e6e6, 1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0,0,0,0.08);
    }
    .flatpickr-calendar.open,
    .flatpickr-calendar.inline {
      opacity: 1;
      max-height: 640px;
      visibility: visible;
    }
    .flatpickr-calendar.open {
      display: inline-block;
      z-index: 99999;
    }
    [dir=ltr] .flatpickr-calendar.animate.open {
      -webkit-animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
      animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    [dir=rtl] .flatpickr-calendar.animate.open {
      -webkit-animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
              animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    .flatpickr-calendar.inline {
      display: block;
      position: relative;
      top: 2px;
    }
    .flatpickr-calendar.static {
      position: absolute;
      top: calc(100% + 2px);
    }
    .flatpickr-calendar.static.open {
      z-index: 999;
      display: block;
    }
    .flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {
      -webkit-box-shadow: none !important;
    }
     .flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {
              box-shadow: none !important;
    }
    [dir=ltr] .flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {
      -webkit-box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
      box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
    }
    [dir=rtl] .flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {
      -webkit-box-shadow: 2px 0 0 #e6e6e6, -5px 0 0 #e6e6e6;
              box-shadow: 2px 0 0 #e6e6e6, -5px 0 0 #e6e6e6;
    }
     .flatpickr-calendar .hasWeeks .dayContainer,  .flatpickr-calendar .hasTime .dayContainer {
      border-bottom: 0;
    }
    [dir=ltr] .flatpickr-calendar .hasWeeks .dayContainer, [dir=ltr] .flatpickr-calendar .hasTime .dayContainer {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    [dir=rtl] .flatpickr-calendar .hasWeeks .dayContainer, [dir=rtl] .flatpickr-calendar .hasTime .dayContainer {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=ltr] .flatpickr-calendar .hasWeeks .dayContainer {
      border-left: 0;
    }
    [dir=rtl] .flatpickr-calendar .hasWeeks .dayContainer {
      border-right: 0;
    }
    .flatpickr-calendar.hasTime .flatpickr-time {
      height: 40px;
    }
     .flatpickr-calendar.hasTime .flatpickr-time {
      border-top: 1px solid #e6e6e6;
    }
    .flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
      height: auto;
    }
    .flatpickr-calendar:before,
    .flatpickr-calendar:after {
      position: absolute;
      display: block;
      pointer-events: none;
      content: '';
      height: 0;
      width: 0;
    }
     .flatpickr-calendar:before,  .flatpickr-calendar:after {
      border: solid transparent;
    }
    [dir=ltr] .flatpickr-calendar:before, [dir=ltr] .flatpickr-calendar:after {
      left: 22px;
    }
    [dir=rtl] .flatpickr-calendar:before, [dir=rtl] .flatpickr-calendar:after {
      right: 22px;
    }
    [dir=ltr] .flatpickr-calendar.rightMost:before, [dir=ltr] .flatpickr-calendar.arrowRight:before, [dir=ltr] .flatpickr-calendar.rightMost:after, [dir=ltr] .flatpickr-calendar.arrowRight:after {
      left: auto;
      right: 22px;
    }
    [dir=rtl] .flatpickr-calendar.rightMost:before, [dir=rtl] .flatpickr-calendar.arrowRight:before, [dir=rtl] .flatpickr-calendar.rightMost:after, [dir=rtl] .flatpickr-calendar.arrowRight:after {
      right: auto;
      left: 22px;
    }
    [dir=ltr] .flatpickr-calendar.arrowCenter:before, [dir=ltr] .flatpickr-calendar.arrowCenter:after {
      left: 50%;
      right: 50%;
    }
    [dir=rtl] .flatpickr-calendar.arrowCenter:before, [dir=rtl] .flatpickr-calendar.arrowCenter:after {
      right: 50%;
      left: 50%;
    }
     .flatpickr-calendar:before {
      border-width: 5px;
      margin: 0 -5px;
    }
     .flatpickr-calendar:after {
      border-width: 4px;
      margin: 0 -4px;
    }
    .flatpickr-calendar.arrowTop:before,
    .flatpickr-calendar.arrowTop:after {
      bottom: 100%;
    }
     .flatpickr-calendar.arrowTop:before {
      border-bottom-color: #e6e6e6;
    }
     .flatpickr-calendar.arrowTop:after {
      border-bottom-color: #fff;
    }
    .flatpickr-calendar.arrowBottom:before,
    .flatpickr-calendar.arrowBottom:after {
      top: 100%;
    }
     .flatpickr-calendar.arrowBottom:before {
      border-top-color: #e6e6e6;
    }
     .flatpickr-calendar.arrowBottom:after {
      border-top-color: #fff;
    }
    .flatpickr-calendar:focus {
      outline: 0;
    }
    .flatpickr-wrapper {
      position: relative;
      display: inline-block;
    }
    .flatpickr-months {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
    }
    .flatpickr-months .flatpickr-month {
      color: rgba(0,0,0,0.9);
      fill: rgba(0,0,0,0.9);
      height: 34px;
      line-height: 1;
      position: relative;
      -webkit-user-select: none;
         -moz-user-select: none;
          -ms-user-select: none;
              user-select: none;
      overflow: hidden;
      -webkit-box-flex: 1;
      -webkit-flex: 1;
          -ms-flex: 1;
              flex: 1;
    }
     .flatpickr-months .flatpickr-month {
      background: transparent;
      text-align: center;
    }
    .flatpickr-months .flatpickr-prev-month,
    .flatpickr-months .flatpickr-next-month {
      -webkit-user-select: none;
         -moz-user-select: none;
          -ms-user-select: none;
              user-select: none;
      text-decoration: none;
      position: absolute;
      top: 0;
      height: 34px;
      z-index: 3;
      color: rgba(0,0,0,0.9);
      fill: rgba(0,0,0,0.9);
    }
     .flatpickr-months .flatpickr-prev-month,  .flatpickr-months .flatpickr-next-month {
      cursor: pointer;
      padding: 10px;
    }
    .flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
    .flatpickr-months .flatpickr-next-month.flatpickr-disabled {
      display: none;
    }
    .flatpickr-months .flatpickr-prev-month i,
    .flatpickr-months .flatpickr-next-month i {
      position: relative;
    }
    .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
    .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
    /*
          /*rtl:begin:ignore*/
    /*
          */
    /*
          /*rtl:end:ignore*/
    /*
          */
    }
    [dir=ltr] .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month, [dir=ltr] .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
      left: 0;
    }
    [dir=rtl] .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month, [dir=rtl] .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
      right: 0;
    }
    /*
          /*rtl:begin:ignore*/
    /*
          /*rtl:end:ignore*/
    .flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
    .flatpickr-months .flatpickr-next-month.flatpickr-next-month {
    /*
          /*rtl:begin:ignore*/
    /*
          */
    /*
          /*rtl:end:ignore*/
    /*
          */
    }
    [dir=ltr] .flatpickr-months .flatpickr-prev-month.flatpickr-next-month, [dir=ltr] .flatpickr-months .flatpickr-next-month.flatpickr-next-month {
      right: 0;
    }
    [dir=rtl] .flatpickr-months .flatpickr-prev-month.flatpickr-next-month, [dir=rtl] .flatpickr-months .flatpickr-next-month.flatpickr-next-month {
      left: 0;
    }
    /*
          /*rtl:begin:ignore*/
    /*
          /*rtl:end:ignore*/
    .flatpickr-months .flatpickr-prev-month:hover,
    .flatpickr-months .flatpickr-next-month:hover {
      color: #959ea9;
    }
    .flatpickr-months .flatpickr-prev-month:hover svg,
    .flatpickr-months .flatpickr-next-month:hover svg {
      fill: #f64747;
    }
    .flatpickr-months .flatpickr-prev-month svg,
    .flatpickr-months .flatpickr-next-month svg {
      width: 14px;
      height: 14px;
    }
    .flatpickr-months .flatpickr-prev-month svg path,
    .flatpickr-months .flatpickr-next-month svg path {
      transition: fill 0.1s;
      fill: inherit;
    }
     .flatpickr-months .flatpickr-prev-month svg path,  .flatpickr-months .flatpickr-next-month svg path {
      -webkit-transition: fill 0.1s;
    }
    .numInputWrapper {
      position: relative;
      height: auto;
    }
    .numInputWrapper input,
    .numInputWrapper span {
      display: inline-block;
    }
    .numInputWrapper input {
      width: 100%;
    }
    .numInputWrapper input::-ms-clear {
      display: none;
    }
    .numInputWrapper input::-webkit-outer-spin-button,
    .numInputWrapper input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
     .numInputWrapper input::-webkit-outer-spin-button,  .numInputWrapper input::-webkit-inner-spin-button {
      margin: 0;
    }
    .numInputWrapper span {
      position: absolute;
      width: 14px;
      height: 50%;
      line-height: 50%;
      opacity: 0;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
    }
     .numInputWrapper span {
      cursor: pointer;
      border: 1px solid rgba(57,57,57,0.15);
    }
    [dir=ltr] .numInputWrapper span {
      right: 0;
      padding: 0 4px 0 2px;
    }
    [dir=rtl] .numInputWrapper span {
      left: 0;
      padding: 0 2px 0 4px;
    }
     .numInputWrapper span:hover {
      background: rgba(0,0,0,0.1);
    }
     .numInputWrapper span:active {
      background: rgba(0,0,0,0.2);
    }
    .numInputWrapper span:after {
      display: block;
      content: "";
      position: absolute;
    }
    .numInputWrapper span.arrowUp {
      top: 0;
    }
     .numInputWrapper span.arrowUp {
      border-bottom: 0;
    }
    .numInputWrapper span.arrowUp:after {
      top: 26%;
    }
     .numInputWrapper span.arrowUp:after {
      border-bottom: 4px solid rgba(57,57,57,0.6);
    }
    [dir=ltr] .numInputWrapper span.arrowUp:after {
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
    }
    [dir=rtl] .numInputWrapper span.arrowUp:after {
      border-right: 4px solid transparent;
      border-left: 4px solid transparent;
    }
    .numInputWrapper span.arrowDown {
      top: 50%;
    }
    .numInputWrapper span.arrowDown:after {
      top: 40%;
    }
     .numInputWrapper span.arrowDown:after {
      border-top: 4px solid rgba(57,57,57,0.6);
    }
    [dir=ltr] .numInputWrapper span.arrowDown:after {
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
    }
    [dir=rtl] .numInputWrapper span.arrowDown:after {
      border-right: 4px solid transparent;
      border-left: 4px solid transparent;
    }
    .numInputWrapper span svg {
      width: inherit;
      height: auto;
    }
    .numInputWrapper span svg path {
      fill: rgba(0,0,0,0.5);
    }
     .numInputWrapper:hover {
      background: rgba(0,0,0,0.05);
    }
    .numInputWrapper:hover span {
      opacity: 1;
    }
    .flatpickr-current-month {
      font-size: 135%;
      line-height: inherit;
      font-weight: 300;
      color: inherit;
      position: absolute;
      width: 75%;
      line-height: 1;
      height: 34px;
      display: inline-block;
      -webkit-transform: translate3d(0px, 0px, 0px);
    }
     .flatpickr-current-month {
      padding: 7.48px 0 0 0;
      text-align: center;
              transform: translate3d(0px, 0px, 0px);
    }
    [dir=ltr] .flatpickr-current-month {
      left: 12.5%;
    }
    [dir=rtl] .flatpickr-current-month {
      right: 12.5%;
    }
    .flatpickr-current-month span.cur-month {
      font-family: inherit;
      font-weight: 700;
      color: inherit;
      display: inline-block;
    }
     .flatpickr-current-month span.cur-month {
      padding: 0;
    }
    [dir=ltr] .flatpickr-current-month span.cur-month {
      margin-left: 0.5ch;
    }
    [dir=rtl] .flatpickr-current-month span.cur-month {
      margin-right: 0.5ch;
    }
     .flatpickr-current-month span.cur-month:hover {
      background: rgba(0,0,0,0.05);
    }
    .flatpickr-current-month .numInputWrapper {
      width: 6ch;
      width: 7ch\0;
      display: inline-block;
    }
     .flatpickr-current-month .numInputWrapper span.arrowUp:after {
      border-bottom-color: rgba(0,0,0,0.9);
    }
     .flatpickr-current-month .numInputWrapper span.arrowDown:after {
      border-top-color: rgba(0,0,0,0.9);
    }
    .flatpickr-current-month input.cur-year {
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      color: inherit;
      display: inline-block;
      font-size: inherit;
      font-family: inherit;
      font-weight: 300;
      line-height: inherit;
      height: auto;
      vertical-align: initial;
      -webkit-appearance: textfield;
      -moz-appearance: textfield;
      appearance: textfield;
    }
     .flatpickr-current-month input.cur-year {
      background: transparent;
      cursor: text;
      margin: 0;
      border: 0;
      border-radius: 0;
    }
    [dir=ltr] .flatpickr-current-month input.cur-year {
      padding: 0 0 0 0.5ch;
    }
    [dir=rtl] .flatpickr-current-month input.cur-year {
      padding: 0 0.5ch 0 0;
    }
    .flatpickr-current-month input.cur-year:focus {
      outline: 0;
    }
    .flatpickr-current-month input.cur-year[disabled],
    .flatpickr-current-month input.cur-year[disabled]:hover {
      font-size: 100%;
      color: rgba(0,0,0,0.5);
      pointer-events: none;
    }
     .flatpickr-current-month input.cur-year[disabled],  .flatpickr-current-month input.cur-year[disabled]:hover {
      background: transparent;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months {
      appearance: menulist;
      box-sizing: border-box;
      color: inherit;
      font-size: inherit;
      font-family: inherit;
      font-weight: 300;
      height: auto;
      line-height: inherit;
      outline: none;
      position: relative;
      vertical-align: initial;
      -webkit-box-sizing: border-box;
      -webkit-appearance: menulist;
      -moz-appearance: menulist;
      width: auto;
    }
     .flatpickr-current-month .flatpickr-monthDropdown-months {
      background: transparent;
      border: none;
      border-radius: 0;
      cursor: pointer;
      margin: -1px 0 0 0;
    }
    [dir=ltr] .flatpickr-current-month .flatpickr-monthDropdown-months {
      padding: 0 0 0 0.5ch;
    }
    [dir=rtl] .flatpickr-current-month .flatpickr-monthDropdown-months {
      padding: 0 0.5ch 0 0;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months:focus,
    .flatpickr-current-month .flatpickr-monthDropdown-months:active {
      outline: none;
    }
     .flatpickr-current-month .flatpickr-monthDropdown-months:hover {
      background: rgba(0,0,0,0.05);
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
      outline: none;
    }
     .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
      background-color: transparent;
      padding: 0;
    }
    .flatpickr-weekdays {
      overflow: hidden;
      width: 100%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
          -ms-flex-align: center;
              align-items: center;
      height: 28px;
    }
     .flatpickr-weekdays {
      background: transparent;
      text-align: center;
    }
    .flatpickr-weekdays .flatpickr-weekdaycontainer {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-flex: 1;
      -webkit-flex: 1;
          -ms-flex: 1;
              flex: 1;
    }
    span.flatpickr-weekday {
      font-size: 90%;
      color: rgba(0,0,0,0.54);
      line-height: 1;
      display: block;
      -webkit-box-flex: 1;
      -webkit-flex: 1;
          -ms-flex: 1;
              flex: 1;
      font-weight: bolder;
    }
     span.flatpickr-weekday {
      cursor: default;
      background: transparent;
      margin: 0;
      text-align: center;
    }
     .dayContainer,  .flatpickr-weeks {
      padding: 1px 0 0 0;
    }
    .flatpickr-days {
      position: relative;
      overflow: hidden;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: start;
      -webkit-align-items: flex-start;
          -ms-flex-align: start;
              align-items: flex-start;
      width: 307.875px;
    }
    .flatpickr-days:focus {
      outline: 0;
    }
    .dayContainer {
      outline: 0;
      width: 307.875px;
      min-width: 307.875px;
      max-width: 307.875px;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      display: inline-block;
      display: -ms-flexbox;
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      -webkit-flex-wrap: wrap;
              flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      -ms-flex-pack: justify;
      -webkit-justify-content: space-around;
              justify-content: space-around;
      -webkit-transform: translate3d(0px, 0px, 0px);
      opacity: 1;
    }
     .dayContainer {
      padding: 0;
              transform: translate3d(0px, 0px, 0px);
    }
    [dir=ltr] .dayContainer {
      text-align: left;
    }
    [dir=rtl] .dayContainer {
      text-align: right;
    }
    [dir=ltr] .dayContainer + .dayContainer {
      -webkit-box-shadow: -1px 0 0 #e6e6e6;
      box-shadow: -1px 0 0 #e6e6e6;
    }
    [dir=rtl] .dayContainer + .dayContainer {
      -webkit-box-shadow: 1px 0 0 #e6e6e6;
              box-shadow: 1px 0 0 #e6e6e6;
    }
    .flatpickr-day {
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      color: #393939;
      font-weight: 400;
      width: 14.2857143%;
      -webkit-flex-basis: 14.2857143%;
          -ms-flex-preferred-size: 14.2857143%;
              flex-basis: 14.2857143%;
      max-width: 39px;
      height: 39px;
      line-height: 39px;
      display: inline-block;
      position: relative;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
          -ms-flex-pack: center;
              justify-content: center;
    }
     .flatpickr-day {
      background: none;
      border: 1px solid transparent;
      border-radius: 150px;
      cursor: pointer;
      margin: 0;
      text-align: center;
    }
    .flatpickr-day.inRange,
    .flatpickr-day.prevMonthDay.inRange,
    .flatpickr-day.nextMonthDay.inRange,
    .flatpickr-day.today.inRange,
    .flatpickr-day.prevMonthDay.today.inRange,
    .flatpickr-day.nextMonthDay.today.inRange,
    .flatpickr-day:hover,
    .flatpickr-day.prevMonthDay:hover,
    .flatpickr-day.nextMonthDay:hover,
    .flatpickr-day:focus,
    .flatpickr-day.prevMonthDay:focus,
    .flatpickr-day.nextMonthDay:focus {
      outline: 0;
    }
     .flatpickr-day.inRange,  .flatpickr-day.prevMonthDay.inRange,  .flatpickr-day.nextMonthDay.inRange,  .flatpickr-day.today.inRange,  .flatpickr-day.prevMonthDay.today.inRange,  .flatpickr-day.nextMonthDay.today.inRange,  .flatpickr-day:hover,  .flatpickr-day.prevMonthDay:hover,  .flatpickr-day.nextMonthDay:hover,  .flatpickr-day:focus,  .flatpickr-day.prevMonthDay:focus,  .flatpickr-day.nextMonthDay:focus {
      cursor: pointer;
      background: #e6e6e6;
      border-color: #e6e6e6;
    }
     .flatpickr-day.today {
      border-color: #959ea9;
    }
    .flatpickr-day.today:hover,
    .flatpickr-day.today:focus {
      color: #fff;
    }
     .flatpickr-day.today:hover,  .flatpickr-day.today:focus {
      border-color: #959ea9;
      background: #959ea9;
    }
    .flatpickr-day.selected,
    .flatpickr-day.startRange,
    .flatpickr-day.endRange,
    .flatpickr-day.selected.inRange,
    .flatpickr-day.startRange.inRange,
    .flatpickr-day.endRange.inRange,
    .flatpickr-day.selected:focus,
    .flatpickr-day.startRange:focus,
    .flatpickr-day.endRange:focus,
    .flatpickr-day.selected:hover,
    .flatpickr-day.startRange:hover,
    .flatpickr-day.endRange:hover,
    .flatpickr-day.selected.prevMonthDay,
    .flatpickr-day.startRange.prevMonthDay,
    .flatpickr-day.endRange.prevMonthDay,
    .flatpickr-day.selected.nextMonthDay,
    .flatpickr-day.startRange.nextMonthDay,
    .flatpickr-day.endRange.nextMonthDay {
      -webkit-box-shadow: none;
      color: #fff;
    }
     .flatpickr-day.selected,  .flatpickr-day.startRange,  .flatpickr-day.endRange,  .flatpickr-day.selected.inRange,  .flatpickr-day.startRange.inRange,  .flatpickr-day.endRange.inRange,  .flatpickr-day.selected:focus,  .flatpickr-day.startRange:focus,  .flatpickr-day.endRange:focus,  .flatpickr-day.selected:hover,  .flatpickr-day.startRange:hover,  .flatpickr-day.endRange:hover,  .flatpickr-day.selected.prevMonthDay,  .flatpickr-day.startRange.prevMonthDay,  .flatpickr-day.endRange.prevMonthDay,  .flatpickr-day.selected.nextMonthDay,  .flatpickr-day.startRange.nextMonthDay,  .flatpickr-day.endRange.nextMonthDay {
      background: #569ff7;
              box-shadow: none;
      border-color: #569ff7;
    }
    [dir=ltr] .flatpickr-day.selected.startRange, [dir=ltr] .flatpickr-day.startRange.startRange, [dir=ltr] .flatpickr-day.endRange.startRange {
      border-radius: 50px 0 0 50px;
    }
    [dir=rtl] .flatpickr-day.selected.startRange, [dir=rtl] .flatpickr-day.startRange.startRange, [dir=rtl] .flatpickr-day.endRange.startRange {
      border-radius: 0 50px 50px 0;
    }
    [dir=ltr] .flatpickr-day.selected.endRange, [dir=ltr] .flatpickr-day.startRange.endRange, [dir=ltr] .flatpickr-day.endRange.endRange {
      border-radius: 0 50px 50px 0;
    }
    [dir=rtl] .flatpickr-day.selected.endRange, [dir=rtl] .flatpickr-day.startRange.endRange, [dir=rtl] .flatpickr-day.endRange.endRange {
      border-radius: 50px 0 0 50px;
    }
    [dir=ltr] .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), [dir=ltr] .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), [dir=ltr] .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
      -webkit-box-shadow: -10px 0 0 #569ff7;
      box-shadow: -10px 0 0 #569ff7;
    }
    [dir=rtl] .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), [dir=rtl] .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), [dir=rtl] .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
      -webkit-box-shadow: 10px 0 0 #569ff7;
              box-shadow: 10px 0 0 #569ff7;
    }
     .flatpickr-day.selected.startRange.endRange,  .flatpickr-day.startRange.startRange.endRange,  .flatpickr-day.endRange.startRange.endRange {
      border-radius: 50px;
    }
     .flatpickr-day.inRange {
      border-radius: 0;
    }
    [dir=ltr] .flatpickr-day.inRange {
      -webkit-box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
      box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
    }
    [dir=rtl] .flatpickr-day.inRange {
      -webkit-box-shadow: 5px 0 0 #e6e6e6, -5px 0 0 #e6e6e6;
              box-shadow: 5px 0 0 #e6e6e6, -5px 0 0 #e6e6e6;
    }
    .flatpickr-day.flatpickr-disabled,
    .flatpickr-day.flatpickr-disabled:hover,
    .flatpickr-day.prevMonthDay,
    .flatpickr-day.nextMonthDay,
    .flatpickr-day.notAllowed,
    .flatpickr-day.notAllowed.prevMonthDay,
    .flatpickr-day.notAllowed.nextMonthDay {
      color: rgba(57,57,57,0.3);
    }
     .flatpickr-day.flatpickr-disabled,  .flatpickr-day.flatpickr-disabled:hover,  .flatpickr-day.prevMonthDay,  .flatpickr-day.nextMonthDay,  .flatpickr-day.notAllowed,  .flatpickr-day.notAllowed.prevMonthDay,  .flatpickr-day.notAllowed.nextMonthDay {
      background: transparent;
      border-color: transparent;
      cursor: default;
    }
    .flatpickr-day.flatpickr-disabled,
    .flatpickr-day.flatpickr-disabled:hover {
      color: rgba(57,57,57,0.1);
    }
     .flatpickr-day.flatpickr-disabled,  .flatpickr-day.flatpickr-disabled:hover {
      cursor: not-allowed;
    }
     .flatpickr-day.week.selected {
      border-radius: 0;
    }
    [dir=ltr] .flatpickr-day.week.selected {
      -webkit-box-shadow: -5px 0 0 #569ff7, 5px 0 0 #569ff7;
      box-shadow: -5px 0 0 #569ff7, 5px 0 0 #569ff7;
    }
    [dir=rtl] .flatpickr-day.week.selected {
      -webkit-box-shadow: 5px 0 0 #569ff7, -5px 0 0 #569ff7;
              box-shadow: 5px 0 0 #569ff7, -5px 0 0 #569ff7;
    }
    .flatpickr-day.hidden {
      visibility: hidden;
    }
     .rangeMode .flatpickr-day {
      margin-top: 1px;
    }
    [dir=ltr] .flatpickr-weekwrapper {
      float: left;
    }
    [dir=rtl] .flatpickr-weekwrapper {
      float: right;
    }
     .flatpickr-weekwrapper .flatpickr-weeks {
      padding: 0 12px;
    }
    [dir=ltr] .flatpickr-weekwrapper .flatpickr-weeks {
      -webkit-box-shadow: 1px 0 0 #e6e6e6;
      box-shadow: 1px 0 0 #e6e6e6;
    }
    [dir=rtl] .flatpickr-weekwrapper .flatpickr-weeks {
      -webkit-box-shadow: -1px 0 0 #e6e6e6;
              box-shadow: -1px 0 0 #e6e6e6;
    }
    .flatpickr-weekwrapper .flatpickr-weekday {
      width: 100%;
      line-height: 28px;
    }
     .flatpickr-weekwrapper .flatpickr-weekday {
      float: none;
    }
    .flatpickr-weekwrapper span.flatpickr-day,
    .flatpickr-weekwrapper span.flatpickr-day:hover {
      display: block;
      width: 100%;
      max-width: none;
      color: rgba(57,57,57,0.3);
    }
     .flatpickr-weekwrapper span.flatpickr-day,  .flatpickr-weekwrapper span.flatpickr-day:hover {
      background: transparent;
      cursor: default;
      border: none;
    }
    .flatpickr-innerContainer {
      display: block;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      overflow: hidden;
    }
    .flatpickr-rContainer {
      display: inline-block;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
    }
     .flatpickr-rContainer {
      padding: 0;
    }
    .flatpickr-time {
      outline: 0;
      display: block;
      height: 0;
      line-height: 40px;
      max-height: 40px;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      overflow: hidden;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
    }
     .flatpickr-time {
      text-align: center;
    }
    .flatpickr-time:after {
      content: "";
      display: table;
    }
     .flatpickr-time:after {
      clear: both;
    }
    .flatpickr-time .numInputWrapper {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
          -ms-flex: 1;
              flex: 1;
      width: 40%;
      height: 40px;
    }
    [dir=ltr] .flatpickr-time .numInputWrapper {
      float: left;
    }
    [dir=rtl] .flatpickr-time .numInputWrapper {
      float: right;
    }
     .flatpickr-time .numInputWrapper span.arrowUp:after {
      border-bottom-color: #393939;
    }
     .flatpickr-time .numInputWrapper span.arrowDown:after {
      border-top-color: #393939;
    }
    .flatpickr-time.hasSeconds .numInputWrapper {
      width: 26%;
    }
    .flatpickr-time.time24hr .numInputWrapper {
      width: 49%;
    }
    .flatpickr-time input {
      -webkit-box-shadow: none;
      height: inherit;
      line-height: inherit;
      color: #393939;
      font-size: 14px;
      position: relative;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      -webkit-appearance: textfield;
      -moz-appearance: textfield;
      appearance: textfield;
    }
     .flatpickr-time input {
      background: transparent;
              box-shadow: none;
      border: 0;
      border-radius: 0;
      text-align: center;
      margin: 0;
      padding: 0;
    }
    .flatpickr-time input.flatpickr-hour {
      font-weight: bold;
    }
    .flatpickr-time input.flatpickr-minute,
    .flatpickr-time input.flatpickr-second {
      font-weight: 400;
    }
    .flatpickr-time input:focus {
      outline: 0;
    }
     .flatpickr-time input:focus {
      border: 0;
    }
    .flatpickr-time .flatpickr-time-separator,
    .flatpickr-time .flatpickr-am-pm {
      height: inherit;
      line-height: inherit;
      color: #393939;
      font-weight: bold;
      width: 2%;
      -webkit-user-select: none;
         -moz-user-select: none;
          -ms-user-select: none;
              user-select: none;
      -webkit-align-self: center;
          -ms-flex-item-align: center;
              align-self: center;
    }
    [dir=ltr] .flatpickr-time .flatpickr-time-separator, [dir=ltr] .flatpickr-time .flatpickr-am-pm {
      float: left;
    }
    [dir=rtl] .flatpickr-time .flatpickr-time-separator, [dir=rtl] .flatpickr-time .flatpickr-am-pm {
      float: right;
    }
    .flatpickr-time .flatpickr-am-pm {
      outline: 0;
      width: 18%;
      font-weight: 400;
    }
     .flatpickr-time .flatpickr-am-pm {
      cursor: pointer;
      text-align: center;
    }
     .flatpickr-time input:hover,  .flatpickr-time .flatpickr-am-pm:hover,  .flatpickr-time input:focus,  .flatpickr-time .flatpickr-am-pm:focus {
      background: #eee;
    }
     .flatpickr-input[readonly] {
      cursor: pointer;
    }
    @-webkit-keyframes fpFadeInDown {
    from {
        opacity: 0;
        -webkit-transform: translate3d(0, -20px, 0);
                transform: translate3d(0, -20px, 0);
    }
    to {
        opacity: 1;
        -webkit-transform: translate3d(0, 0, 0);
                transform: translate3d(0, 0, 0);
    }
    }
    @keyframes fpFadeInDown {
    from {
        opacity: 0;
        -webkit-transform: translate3d(0, -20px, 0);
                transform: translate3d(0, -20px, 0);
    }
    to {
        opacity: 1;
        -webkit-transform: translate3d(0, 0, 0);
                transform: translate3d(0, 0, 0);
    }
    }
    .flatpickr-calendar .flatpickr-day {
      color: #424244;
    }
     .flatpickr-calendar .flatpickr-day.today {
      border-color: #114A9F;
    }
    .flatpickr-calendar .flatpickr-day.today:hover {
      color: #424244;
    }
     .flatpickr-calendar .flatpickr-day.today:hover {
      background: transparent;
    }
    .flatpickr-calendar .flatpickr-day.selected, .flatpickr-calendar .flatpickr-day.selected:hover {
      color: #fff;
    }
     .flatpickr-calendar .flatpickr-day.selected,  .flatpickr-calendar .flatpickr-day.selected:hover {
      background: #114A9F;
      border-color: #114A9F;
    }
     .flatpickr-calendar .flatpickr-day.inRange,  .flatpickr-calendar .flatpickr-day.inRange:hover {
      background: #5b96ee;
      border-color: #5b96ee;
    }
    [dir=ltr] .flatpickr-calendar .flatpickr-day.inRange, [dir=ltr] .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: -5px 0 0 #5b96ee, 5px 0 0 #5b96ee;
    }
    [dir=rtl] .flatpickr-calendar .flatpickr-day.inRange, [dir=rtl] .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: 5px 0 0 #5b96ee, -5px 0 0 #5b96ee;
    }
    .flatpickr-calendar .flatpickr-day.startRange, .flatpickr-calendar .flatpickr-day.endRange, .flatpickr-calendar .flatpickr-day.startRange:hover, .flatpickr-calendar .flatpickr-day.endRange:hover {
      color: #fff;
    }
     .flatpickr-calendar .flatpickr-day.startRange,  .flatpickr-calendar .flatpickr-day.endRange,  .flatpickr-calendar .flatpickr-day.startRange:hover,  .flatpickr-calendar .flatpickr-day.endRange:hover {
      background: #114A9F;
      border-color: #114A9F;
    }
    [dir=ltr] .flatpickr-calendar .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), [dir=ltr] .flatpickr-calendar .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), [dir=ltr] .flatpickr-calendar .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
      box-shadow: -10px 0 0 #114A9F;
    }
    [dir=rtl] .flatpickr-calendar .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), [dir=rtl] .flatpickr-calendar .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), [dir=rtl] .flatpickr-calendar .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
      box-shadow: 10px 0 0 #114A9F;
    }
    .flatpickr-calendar .flatpickr-day.flatpickr-disabled, .flatpickr-calendar .flatpickr-day.prevMonthDay, .flatpickr-calendar .flatpickr-day.nextMonthDay {
      color: #dae1e7;
    }
     .flatpickr-calendar .flatpickr-day:hover {
      background: #f6f6f6;
    }
    .flatpickr-calendar:after, .flatpickr-calendar:before {
      display: none;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-prev-month,
    .flatpickr-calendar .flatpickr-months .flatpickr-next-month {
      top: -5px;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-prev-month:hover i, .flatpickr-calendar .flatpickr-months .flatpickr-prev-month:hover svg,
    .flatpickr-calendar .flatpickr-months .flatpickr-next-month:hover i,
    .flatpickr-calendar .flatpickr-months .flatpickr-next-month:hover svg {
      fill: #114A9F;
    }
    .flatpickr-calendar .flatpickr-current-month span.cur-month {
      font-weight: 300;
    }
     .flatpickr-time input:hover,  .flatpickr-time .flatpickr-am-pm:hover,  .flatpickr-time input:focus,  .flatpickr-time .flatpickr-am-pm:focus {
      background: #fff;
    }
     .dark-layout .flatpickr-calendar {
      background: #161d31;
      border-color: #161d31;
      box-shadow: none;
    }
    .dark-layout .flatpickr-calendar .flatpickr-months i,
    .dark-layout .flatpickr-calendar .flatpickr-months svg {
      fill: #b4b7bd;
    }
    .dark-layout .flatpickr-calendar .flatpickr-month {
      color: #b4b7bd;
    }
    [dir=ltr] .dark-layout .flatpickr-calendar .flatpickr-weekwrapper .flatpickr-weeks {
      box-shadow: 1px 0 0 #3b4253;
    }
    [dir=rtl] .dark-layout .flatpickr-calendar .flatpickr-weekwrapper .flatpickr-weeks {
      box-shadow: -1px 0 0 #3b4253;
    }
    .dark-layout .flatpickr-calendar .flatpickr-weekday {
      color: #b4b7bd;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day, .dark-layout .flatpickr-calendar .flatpickr-day.today:hover {
      color: #b4b7bd;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day.selected {
      color: #fff;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day.prevMonthDay, .dark-layout .flatpickr-calendar .flatpickr-day.nextMonthDay, .dark-layout .flatpickr-calendar .flatpickr-day.flatpickr-disabled {
      color: #4e5154 !important;
    }
     .dark-layout .flatpickr-calendar .flatpickr-day.inRange,  .dark-layout .flatpickr-calendar .flatpickr-day.inRange:hover {
      background: #283046;
      border-color: #283046;
    }
    [dir=ltr] .dark-layout .flatpickr-calendar .flatpickr-day.inRange, [dir=ltr] .dark-layout .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: -5px 0 0 #283046, 5px 0 0 #283046;
    }
    [dir=rtl] .dark-layout .flatpickr-calendar .flatpickr-day.inRange, [dir=rtl] .dark-layout .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: 5px 0 0 #283046, -5px 0 0 #283046;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      color: #b4b7bd;
    }
     .dark-layout .flatpickr-calendar .flatpickr-day:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      border-color: #283046;
    }
     .dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      background: #283046;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time {
      border-color: #161d31 !important;
    }
    .dark-layout .flatpickr-calendar .flatpickr-time .numInput,
    .dark-layout .flatpickr-calendar .flatpickr-time .flatpickr-am-pm {
      color: #b4b7bd;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time .numInput:hover,  .dark-layout .flatpickr-calendar .flatpickr-time .flatpickr-am-pm:hover {
      background: #161d31;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time .arrowUp:after {
      border-bottom-color: #b4b7bd;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time .arrowDown:after {
      border-top-color: #b4b7bd;
    }
     .dark-layout .flatpickr-time input:hover,  .dark-layout .flatpickr-time .flatpickr-am-pm:hover,  .dark-layout .flatpickr-time input:focus,  .dark-layout .flatpickr-time .flatpickr-am-pm:focus {
      background: #161d31;
    }
    .flatpickr-input[readonly],
    .flatpickr-input ~ .form-control[readonly],
    .flatpickr-human-friendly[readonly] {
      opacity: 1 !important;
    }
     .flatpickr-input[readonly],  .flatpickr-input ~ .form-control[readonly],  .flatpickr-human-friendly[readonly] {
      background-color: inherit;
    }
     .flatpickr-weekdays {
      margin-top: 8px;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months {
      -webkit-appearance: none;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months,
    .flatpickr-current-month .numInputWrapper {
      font-size: 1.1rem;
      transition: all 0.15s ease-out;
    }
     .flatpickr-current-month .flatpickr-monthDropdown-months,  .flatpickr-current-month .numInputWrapper {
      border-radius: 4px;
      padding: 2px;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months span,
    .flatpickr-current-month .numInputWrapper span {
      display: none;
    }
    html[dir=rtl] .flatpickr-calendar .flatpickr-prev-month svg,
    html[dir=rtl] .flatpickr-calendar .flatpickr-next-month svg {
      transform: rotate(180deg);
    }
    .flatpickr-calendar {
      width: 280px;
    }
     .flatpickr-calendar {
      padding: 3px 7px 5px 7px;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-prev-month, .flatpickr-calendar .flatpickr-months .flatpickr-next-month {
      top: -2px;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-current-month select, .flatpickr-calendar .flatpickr-months .flatpickr-current-month input {
      font-weight: 500;
      font-size: 14px;
    }
    .flatpickr-calendar .flatpickr-months span {
      font-weight: 500;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-weekdays .flatpickr-weekday {
      font-size: 12px;
      font-weight: 400;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days {
      width: 266px;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer {
      width: 266px;
      min-width: 266px;
      max-width: 266px;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day {
      font-size: 12px;
      max-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      color: #114A9F;
    }
     .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      border: none;
      background: rgba(17, 74, 159, 0.12);
      border-color: rgba(17, 74, 159, 0.12);
    }
    [dir=ltr] .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      box-shadow: -1px 0 0 rgba(17, 74, 159, 0.12), 1px 0 0 rgba(17, 74, 159, 0.12);
    }
    [dir=rtl] .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      box-shadow: 1px 0 0 rgba(17, 74, 159, 0.12), -1px 0 0 rgba(17, 74, 159, 0.12);
    }
    .avatar {
      height: 60px;
      width: 60px;
    }
     .avatar {
      background-color: #ccc;
      border-radius: 50%;
    }
    .title {
      font-size: 14px;
      color: #424242;
      font-weight: 500;
    }
     .title {
      padding-bottom: 10px;
    }
    .banned-background-color.bans {
      width: 100%;
      height: 40px;
    }
     .banned-background-color.bans {
      padding: 0 18px;
      background: rgba(234, 84, 85, 0.12) !important;
      border-radius: 6px 6px 0px 0px;
    }
    .banned-background-color.bans .title-modal {
      font-size: 18px;
      line-height: 40px;
      font-weight: 500;
      color: red;
    }
    .header-modal {
      height: 48px;
    }
    .flatpickr-calendar .flatpickr-day {
      color: #424244;
    }
     .flatpickr-calendar .flatpickr-day.today {
      border-color: #114A9F;
    }
    .flatpickr-calendar .flatpickr-day.today:hover {
      color: #424244;
    }
     .flatpickr-calendar .flatpickr-day.today:hover {
      background: transparent;
    }
    .flatpickr-calendar .flatpickr-day.selected, .flatpickr-calendar .flatpickr-day.selected:hover {
      color: #fff;
    }
     .flatpickr-calendar .flatpickr-day.selected,  .flatpickr-calendar .flatpickr-day.selected:hover {
      background: #114A9F;
      border-color: #114A9F;
    }
     .flatpickr-calendar .flatpickr-day.inRange,  .flatpickr-calendar .flatpickr-day.inRange:hover {
      background: #5b96ee;
      border-color: #5b96ee;
    }
    [dir=ltr] .flatpickr-calendar .flatpickr-day.inRange, [dir=ltr] .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: -5px 0 0 #5b96ee, 5px 0 0 #5b96ee;
    }
    [dir=rtl] .flatpickr-calendar .flatpickr-day.inRange, [dir=rtl] .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: 5px 0 0 #5b96ee, -5px 0 0 #5b96ee;
    }
    .flatpickr-calendar .flatpickr-day.startRange, .flatpickr-calendar .flatpickr-day.endRange, .flatpickr-calendar .flatpickr-day.startRange:hover, .flatpickr-calendar .flatpickr-day.endRange:hover {
      color: #fff;
    }
     .flatpickr-calendar .flatpickr-day.startRange,  .flatpickr-calendar .flatpickr-day.endRange,  .flatpickr-calendar .flatpickr-day.startRange:hover,  .flatpickr-calendar .flatpickr-day.endRange:hover {
      background: #114A9F;
      border-color: #114A9F;
    }
    [dir=ltr] .flatpickr-calendar .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), [dir=ltr] .flatpickr-calendar .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), [dir=ltr] .flatpickr-calendar .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
      box-shadow: -10px 0 0 #114A9F;
    }
    [dir=rtl] .flatpickr-calendar .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), [dir=rtl] .flatpickr-calendar .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), [dir=rtl] .flatpickr-calendar .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
      box-shadow: 10px 0 0 #114A9F;
    }
    .flatpickr-calendar .flatpickr-day.flatpickr-disabled, .flatpickr-calendar .flatpickr-day.prevMonthDay, .flatpickr-calendar .flatpickr-day.nextMonthDay {
      color: #dae1e7;
    }
     .flatpickr-calendar .flatpickr-day:hover {
      background: #f6f6f6;
    }
    .flatpickr-calendar:after, .flatpickr-calendar:before {
      display: none;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-prev-month,
    .flatpickr-calendar .flatpickr-months .flatpickr-next-month {
      top: -5px;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-prev-month:hover i, .flatpickr-calendar .flatpickr-months .flatpickr-prev-month:hover svg,
    .flatpickr-calendar .flatpickr-months .flatpickr-next-month:hover i,
    .flatpickr-calendar .flatpickr-months .flatpickr-next-month:hover svg {
      fill: #114A9F;
    }
    .flatpickr-calendar .flatpickr-current-month span.cur-month {
      font-weight: 300;
    }
     .flatpickr-time input:hover,  .flatpickr-time .flatpickr-am-pm:hover,  .flatpickr-time input:focus,  .flatpickr-time .flatpickr-am-pm:focus {
      background: #fff;
    }
     .dark-layout .flatpickr-calendar {
      background: #161d31;
      border-color: #161d31;
      box-shadow: none;
    }
    .dark-layout .flatpickr-calendar .flatpickr-months i,
    .dark-layout .flatpickr-calendar .flatpickr-months svg {
      fill: #b4b7bd;
    }
    .dark-layout .flatpickr-calendar .flatpickr-month {
      color: #b4b7bd;
    }
    [dir=ltr] .dark-layout .flatpickr-calendar .flatpickr-weekwrapper .flatpickr-weeks {
      box-shadow: 1px 0 0 #3b4253;
    }
    [dir=rtl] .dark-layout .flatpickr-calendar .flatpickr-weekwrapper .flatpickr-weeks {
      box-shadow: -1px 0 0 #3b4253;
    }
    .dark-layout .flatpickr-calendar .flatpickr-weekday {
      color: #b4b7bd;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day, .dark-layout .flatpickr-calendar .flatpickr-day.today:hover {
      color: #b4b7bd;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day.selected {
      color: #fff;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day.prevMonthDay, .dark-layout .flatpickr-calendar .flatpickr-day.nextMonthDay, .dark-layout .flatpickr-calendar .flatpickr-day.flatpickr-disabled {
      color: #4e5154 !important;
    }
     .dark-layout .flatpickr-calendar .flatpickr-day.inRange,  .dark-layout .flatpickr-calendar .flatpickr-day.inRange:hover {
      background: #283046;
      border-color: #283046;
    }
    [dir=ltr] .dark-layout .flatpickr-calendar .flatpickr-day.inRange, [dir=ltr] .dark-layout .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: -5px 0 0 #283046, 5px 0 0 #283046;
    }
    [dir=rtl] .dark-layout .flatpickr-calendar .flatpickr-day.inRange, [dir=rtl] .dark-layout .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: 5px 0 0 #283046, -5px 0 0 #283046;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      color: #b4b7bd;
    }
     .dark-layout .flatpickr-calendar .flatpickr-day:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      border-color: #283046;
    }
     .dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      background: #283046;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time {
      border-color: #161d31 !important;
    }
    .dark-layout .flatpickr-calendar .flatpickr-time .numInput,
    .dark-layout .flatpickr-calendar .flatpickr-time .flatpickr-am-pm {
      color: #b4b7bd;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time .numInput:hover,  .dark-layout .flatpickr-calendar .flatpickr-time .flatpickr-am-pm:hover {
      background: #161d31;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time .arrowUp:after {
      border-bottom-color: #b4b7bd;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time .arrowDown:after {
      border-top-color: #b4b7bd;
    }
     .dark-layout .flatpickr-time input:hover,  .dark-layout .flatpickr-time .flatpickr-am-pm:hover,  .dark-layout .flatpickr-time input:focus,  .dark-layout .flatpickr-time .flatpickr-am-pm:focus {
      background: #161d31;
    }
    .flatpickr-input[readonly],
    .flatpickr-input ~ .form-control[readonly],
    .flatpickr-human-friendly[readonly] {
      opacity: 1 !important;
    }
     .flatpickr-input[readonly],  .flatpickr-input ~ .form-control[readonly],  .flatpickr-human-friendly[readonly] {
      background-color: inherit;
    }
     .flatpickr-weekdays {
      margin-top: 8px;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months {
      -webkit-appearance: none;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months,
    .flatpickr-current-month .numInputWrapper {
      font-size: 1.1rem;
      transition: all 0.15s ease-out;
    }
     .flatpickr-current-month .flatpickr-monthDropdown-months,  .flatpickr-current-month .numInputWrapper {
      border-radius: 4px;
      padding: 2px;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months span,
    .flatpickr-current-month .numInputWrapper span {
      display: none;
    }
    html[dir=rtl] .flatpickr-calendar .flatpickr-prev-month svg,
    html[dir=rtl] .flatpickr-calendar .flatpickr-next-month svg {
      transform: rotate(180deg);
    }
    .flatpickr-calendar {
      width: 280px;
    }
     .flatpickr-calendar {
      padding: 3px 7px 5px 7px;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-prev-month, .flatpickr-calendar .flatpickr-months .flatpickr-next-month {
      top: -2px;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-current-month select, .flatpickr-calendar .flatpickr-months .flatpickr-current-month input {
      font-weight: 500;
      font-size: 14px;
    }
    .flatpickr-calendar .flatpickr-months span {
      font-weight: 500;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-weekdays .flatpickr-weekday {
      font-size: 12px;
      font-weight: 400;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days {
      width: 266px;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer {
      width: 266px;
      min-width: 266px;
      max-width: 266px;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day {
      font-size: 12px;
      max-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      color: #114A9F;
    }
     .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      border: none;
      background: rgba(17, 74, 159, 0.12);
      border-color: rgba(17, 74, 159, 0.12);
    }
    [dir=ltr] .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      box-shadow: -1px 0 0 rgba(17, 74, 159, 0.12), 1px 0 0 rgba(17, 74, 159, 0.12);
    }
    [dir=rtl] .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      box-shadow: 1px 0 0 rgba(17, 74, 159, 0.12), -1px 0 0 rgba(17, 74, 159, 0.12);
    }
    .avatar {
      height: 60px;
      width: 60px;
    }
     .avatar {
      background-color: #ccc;
      border-radius: 50%;
    }
    .title {
      font-size: 14px;
      color: #424242;
      font-weight: 500;
    }
     .title {
      padding-bottom: 10px;
    }
    .banned-background-color.unbans {
      width: 100%;
      height: 40px;
    }
     .banned-background-color.unbans {
      padding: 0 18px;
      background: rgba(41, 184, 105, 0.12) !important;
      border-radius: 6px 6px 0px 0px;
    }
    .title-modal {
      font-size: 18px;
      line-height: 40px;
      font-weight: 500;
      color: #29B869;
    }
    .unbans-modal {
      height: 48px;
    }
    .avatar {
      height: 60px;
      width: 60px;
    } .avatar {
      background-color: #ccc;
      border-radius: 50%;
    }
    .title {
      font-size: 14px;
      color: #424242;
      font-weight: 500;
    }
     .title {
      padding-bottom: 10px;
    }
    .banned-background-color.transfer {
      width: 100%;
      height: 40px;
    }
     .banned-background-color.transfer {
      padding: 0 18px;
      background: linear-gradient(0deg, rgba(17, 74, 159, 0.12), rgba(17, 74, 159, 0.12)), #FFFFFF !important;
      border-radius: 6px 6px 0px 0px;
    }
    .transfer {
      height: 48px;
    }
    .title-modal {
      font-size: 18px;
      line-height: 48px;
      font-weight: 500;
      color: #114A9F;
    }
    #subscription-detail {
    @import '~flatpickr/dist/flatpickr.css';
    }
    #subscription-detail .flatpickr-calendar .flatpickr-day {
      color: #424244;
    }
     #subscription-detail .flatpickr-calendar .flatpickr-day.today {
      border-color: #114A9F;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-day.today:hover {
      color: #424244;
    }
     #subscription-detail .flatpickr-calendar .flatpickr-day.today:hover {
      background: transparent;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-day.selected, #subscription-detail .flatpickr-calendar .flatpickr-day.selected:hover {
      color: #fff;
    }
     #subscription-detail .flatpickr-calendar .flatpickr-day.selected,  #subscription-detail .flatpickr-calendar .flatpickr-day.selected:hover {
      background: #114A9F;
      border-color: #114A9F;
    }
     #subscription-detail .flatpickr-calendar .flatpickr-day.inRange,  #subscription-detail .flatpickr-calendar .flatpickr-day.inRange:hover {
      background: #5b96ee;
      border-color: #5b96ee;
    }
    [dir=ltr] #subscription-detail .flatpickr-calendar .flatpickr-day.inRange, [dir=ltr] #subscription-detail .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: -5px 0 0 #5b96ee, 5px 0 0 #5b96ee;
    }
    [dir=rtl] #subscription-detail .flatpickr-calendar .flatpickr-day.inRange, [dir=rtl] #subscription-detail .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: 5px 0 0 #5b96ee, -5px 0 0 #5b96ee;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-day.startRange, #subscription-detail .flatpickr-calendar .flatpickr-day.endRange, #subscription-detail .flatpickr-calendar .flatpickr-day.startRange:hover, #subscription-detail .flatpickr-calendar .flatpickr-day.endRange:hover {
      color: #fff;
    }
     #subscription-detail .flatpickr-calendar .flatpickr-day.startRange,  #subscription-detail .flatpickr-calendar .flatpickr-day.endRange,  #subscription-detail .flatpickr-calendar .flatpickr-day.startRange:hover,  #subscription-detail .flatpickr-calendar .flatpickr-day.endRange:hover {
      background: #114A9F;
      border-color: #114A9F;
    }
    [dir=ltr] #subscription-detail .flatpickr-calendar .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), [dir=ltr] #subscription-detail .flatpickr-calendar .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), [dir=ltr] #subscription-detail .flatpickr-calendar .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
      box-shadow: -10px 0 0 #114A9F;
    }
    [dir=rtl] #subscription-detail .flatpickr-calendar .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), [dir=rtl] #subscription-detail .flatpickr-calendar .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), [dir=rtl] #subscription-detail .flatpickr-calendar .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
      box-shadow: 10px 0 0 #114A9F;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-day.flatpickr-disabled, #subscription-detail .flatpickr-calendar .flatpickr-day.prevMonthDay, #subscription-detail .flatpickr-calendar .flatpickr-day.nextMonthDay {
      color: #dae1e7;
    }
     #subscription-detail .flatpickr-calendar .flatpickr-day:hover {
      background: #f6f6f6;
    }
    #subscription-detail .flatpickr-calendar:after, #subscription-detail .flatpickr-calendar:before {
      display: none;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-months .flatpickr-prev-month,
    #subscription-detail .flatpickr-calendar .flatpickr-months .flatpickr-next-month {
      top: -5px;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-months .flatpickr-prev-month:hover i, #subscription-detail .flatpickr-calendar .flatpickr-months .flatpickr-prev-month:hover svg,
    #subscription-detail .flatpickr-calendar .flatpickr-months .flatpickr-next-month:hover i,
    #subscription-detail .flatpickr-calendar .flatpickr-months .flatpickr-next-month:hover svg {
      fill: #114A9F;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-current-month span.cur-month {
      font-weight: 300;
    }
     #subscription-detail .flatpickr-time input:hover,  #subscription-detail .flatpickr-time .flatpickr-am-pm:hover,  #subscription-detail .flatpickr-time input:focus,  #subscription-detail .flatpickr-time .flatpickr-am-pm:focus {
      background: #fff;
    }
     #subscription-detail .dark-layout .flatpickr-calendar {
      background: #161d31;
      border-color: #161d31;
      box-shadow: none;
    }
    #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-months i,
    #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-months svg {
      fill: #b4b7bd;
    }
    #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-month {
      color: #b4b7bd;
    }
    [dir=ltr] #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-weekwrapper .flatpickr-weeks {
      box-shadow: 1px 0 0 #3b4253;
    }
    [dir=rtl] #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-weekwrapper .flatpickr-weeks {
      box-shadow: -1px 0 0 #3b4253;
    }
    #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-weekday {
      color: #b4b7bd;
    }
    #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day, #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.today:hover {
      color: #b4b7bd;
    }
    #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.selected {
      color: #fff;
    }
    #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.prevMonthDay, #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.nextMonthDay, #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.flatpickr-disabled {
      color: #4e5154 !important;
    }
     #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.inRange,  #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.inRange:hover {
      background: #283046;
      border-color: #283046;
    }
    [dir=ltr] #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.inRange, [dir=ltr] #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: -5px 0 0 #283046, 5px 0 0 #283046;
    }
    [dir=rtl] #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.inRange, [dir=rtl] #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day.inRange:hover {
      box-shadow: 5px 0 0 #283046, -5px 0 0 #283046;
    }
    #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      color: #b4b7bd;
    }
     #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-day:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      border-color: #283046;
    }
     #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      background: #283046;
    }
     #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-time {
      border-color: #161d31 !important;
    }
    #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-time .numInput,
    #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-time .flatpickr-am-pm {
      color: #b4b7bd;
    }
     #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-time .numInput:hover,  #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-time .flatpickr-am-pm:hover {
      background: #161d31;
    }
     #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-time .arrowUp:after {
      border-bottom-color: #b4b7bd;
    }
     #subscription-detail .dark-layout .flatpickr-calendar .flatpickr-time .arrowDown:after {
      border-top-color: #b4b7bd;
    }
     #subscription-detail .dark-layout .flatpickr-time input:hover,  #subscription-detail .dark-layout .flatpickr-time .flatpickr-am-pm:hover,  #subscription-detail .dark-layout .flatpickr-time input:focus,  #subscription-detail .dark-layout .flatpickr-time .flatpickr-am-pm:focus {
      background: #161d31;
    }
    #subscription-detail .flatpickr-input[readonly],
    #subscription-detail .flatpickr-input ~ .form-control[readonly],
    #subscription-detail .flatpickr-human-friendly[readonly] {
      opacity: 1 !important;
    }
     #subscription-detail .flatpickr-input[readonly],  #subscription-detail .flatpickr-input ~ .form-control[readonly],  #subscription-detail .flatpickr-human-friendly[readonly] {
      background-color: inherit;
    }
     #subscription-detail .flatpickr-weekdays {
      margin-top: 8px;
    }
    #subscription-detail .flatpickr-current-month .flatpickr-monthDropdown-months {
      -webkit-appearance: none;
    }
    #subscription-detail .flatpickr-current-month .flatpickr-monthDropdown-months,
    #subscription-detail .flatpickr-current-month .numInputWrapper {
      font-size: 1.1rem;
      transition: all 0.15s ease-out;
    }
     #subscription-detail .flatpickr-current-month .flatpickr-monthDropdown-months,  #subscription-detail .flatpickr-current-month .numInputWrapper {
      border-radius: 4px;
      padding: 2px;
    }
    #subscription-detail .flatpickr-current-month .flatpickr-monthDropdown-months span,
    #subscription-detail .flatpickr-current-month .numInputWrapper span {
      display: none;
    }
    #subscription-detail html[dir=rtl] .flatpickr-calendar .flatpickr-prev-month svg,
    #subscription-detail html[dir=rtl] .flatpickr-calendar .flatpickr-next-month svg {
      transform: rotate(180deg);
    }
    #subscription-detail .flatpickr-calendar {
      width: 280px;
    }
     #subscription-detail .flatpickr-calendar {
      padding: 3px 7px 5px 7px;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-months .flatpickr-prev-month, #subscription-detail .flatpickr-calendar .flatpickr-months .flatpickr-next-month {
      top: -2px;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-months .flatpickr-current-month select, #subscription-detail .flatpickr-calendar .flatpickr-months .flatpickr-current-month input {
      font-weight: 500;
      font-size: 14px;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-months span {
      font-weight: 500;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-innerContainer .flatpickr-weekdays .flatpickr-weekday {
      font-size: 12px;
      font-weight: 400;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days {
      width: 266px;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer {
      width: 266px;
      min-width: 266px;
      max-width: 266px;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day {
      font-size: 12px;
      max-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    #subscription-detail .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      color: #114A9F;
    }
     #subscription-detail .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      border: none;
      background: rgba(17, 74, 159, 0.12);
      border-color: rgba(17, 74, 159, 0.12);
    }
    [dir=ltr] #subscription-detail .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      box-shadow: -1px 0 0 rgba(17, 74, 159, 0.12), 1px 0 0 rgba(17, 74, 159, 0.12);
    }
    [dir=rtl] #subscription-detail .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange {
      box-shadow: 1px 0 0 rgba(17, 74, 159, 0.12), -1px 0 0 rgba(17, 74, 159, 0.12);
    }
    #subscription-detail .modal-body, #subscription-detail .modal-content {
      width: 750px;
    }
    #subscription-detail .banned-background-color.detail {
      width: 100%;
      height: 40px;
    }
     #subscription-detail .banned-background-color.detail {
      padding: 0 18px;
      background: linear-gradient(0deg, rgba(17, 74, 159, 0.12), rgba(17, 74, 159, 0.12)), #FFFFFF !important;
      border-radius: 6px 6px 0px 0px;
    }
    #subscription-detail .title-modal {
      font-size: 18px;
      line-height: 40px;
      font-weight: 500;
      color: #114A9F;
    }
    #subscription-detail .color-red {
      color: red;
    }
    #subscription-detail .text {
      font-size: 12px;
      line-height: 18px;
    }
     #subscription-detail .custom_input {
      background-color: white;
    }
    #subscription-detail ._button-no-bg {
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
    }
     #subscription-detail ._button-no-bg {
      border-radius: 5px;
      padding: 5px 10px;
      cursor: pointer;
    }
    #subscription-detail .primary {
      color: #114A9F;
    }
     #subscription-detail .primary {
      border: 1px solid #114A9F;
    }
    #subscription-detail .warning {
      color: red;
    }
     #subscription-detail .warning {
      border: 1px solid red;
    }
    #subscription-detail .detail-subscription {
      height: 48px !important;
    }
    #subscription-detail .detail-subscription svg {
      color: #114A9F;
    }
    #subscription-detail .inactive input, #subscription-detail .inactive .custom_input, #subscription-detail .inactive select, #subscription-detail .inactive textarea {
      pointer-events: none;
    }
     #subscription-detail .inactive input,  #subscription-detail .inactive .custom_input,  #subscription-detail .inactive select,  #subscription-detail .inactive textarea {
      background-color: #efefef;
    }
    #subscription-detail .history, #subscription-detail .information {
      min-height: 420px;
    }
     #subscription-detail .history,  #subscription-detail .information {
      padding: 16px;
    }
    #subscription-detail .nav.nav-tabs {
      height: 44px;
    }
     #subscription-detail .nav.nav-tabs {
      background: rgba(193, 193, 193, 0.12);
      padding: 0 18px;
      margin: 0;
    }
    #subscription-detail .nav.nav-tabs .nav-link {
      height: 44px;
      font-size: 12px;
      font-weight: 500;
    }
    #subscription-detail .nav.nav-tabs .nav-link.active {
      color: #114a9f;
    }
     #subscription-detail .nav.nav-tabs .nav-link.active::after {
      background: #114a9f !important;
    }
    #subscription-detail .removeTabs ul.nav.nav-tabs {
      display: none !important;
    }
    #subscription-detail .upload {
      display: inline-block;
      width: 100%;
      height: auto;
    }
     #subscription-detail .upload {
      border: 1px dashed #D6D9E1;
      border-radius: 5px;
    }
    #subscription-detail .upload label {
      width: 100%;
      font-weight: 400;
      font-size: 12px;
      color: #A7A9AC;
      line-height: 32px;
    }
     #subscription-detail .upload label {
      text-align: center;
    }
    #subscription-detail .upload label span {
      color: #114A9F;
    }
     #subscription-detail .upload ul {
      padding: 0 10px;
    }
    #subscription-detail .upload ul li {
      display: inline;
      font-size: 12px;
      line-height: 24px;
      color: #114A9F;
      flex: none;
      order: 0;
      flex-grow: 1;
      list-style: none;
    }
     #subscription-detail .upload ul li {
      border: 1px solid #D6D9E1;
      border-radius: 5px;
      padding: 5px 10px;
    }
    [dir=ltr] #subscription-detail .upload ul li {
      margin-right: 10px;
    }
    [dir=rtl] #subscription-detail .upload ul li {
      margin-left: 10px;
    }
    .history-playing ._button-no-bg {
      color: #114A9F;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
    } .history-playing ._button-no-bg {
      border-radius: 5px;
      border: 1px solid #114A9F;
      padding: 5px 10px;
      cursor: pointer;
    }
    .history-playing .item {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #5d5f65;
      font-weight: 500;
    }
    .history-playing .item span {
      display: inline-flex;
      align-items: center;
      font-size: 12px;
      font-weight: 500;
      justify-content: center;
      height: 20px;
      min-width: 20px;
      color: #FFFFFF;
    }
     .history-playing .item span {
      padding: 0 6px;
      border-radius: 4px;
    }
    [dir=ltr] .history-playing .item span {
      margin-left: 8px;
      margin-right: 22px;
    }
    [dir=rtl] .history-playing .item span {
      margin-right: 8px;
      margin-left: 22px;
    }
    .history-playing th.table-b-table-default {
      min-width: 100px;
    }
    .history-playing .action-icon {
      color: black;
    }
    .history-playing .table-dropdown ul {
      width: 160px;
    }
     .history-playing .table-dropdown ul {
      padding: 0;
    }
     .history-playing .table-dropdown ul li {
      margin: 0;
    }
    .history-playing .table-dropdown ul li button {
      width: 100%;
    }
     .delete {
      border-top: 1px solid #ccc;
    }
    [dir=ltr] .item:first-child {
      margin-left: 16px;
    }
    [dir=rtl] .item:first-child {
      margin-right: 16px;
    }
     tbody {
      border-bottom: 1px solid #eae8e8;
    }
    .b-table-sticky-header {
      overflow-y: unset;
    }
    #modal-payment .list-paid {
      height: calc( 100vh - 515px);
    }
    #modal-payment .list-paid .item-detail {
      line-height: 18px;
    }
     #modal-payment .list-paid .item-detail {
      padding: 8px 1.5rem;
    }
     #modal-payment .list-paid .item-detail:hover {
      background: rgba(193, 193, 193, 0.12);
    }
    #modal-payment .list-paid .item-detail .payment-method {
      display: flex;
      justify-content: space-between;
      font-weight: 500;
    }
    #modal-payment .list-paid .item-detail .note {
      display: flex;
      justify-content: space-between;
    }
    #modal-payment .header {
      display: flex;
      justify-content: space-between;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
     #modal-payment .header {
      padding-bottom: 1rem;
    }
    #modal-payment .header .header-amount {
      color: #114A9F;
    }
    #modal-payment .footer {
      display: flex;
      justify-content: space-between;
    }
     #modal-payment .footer {
      padding: 1.5rem;
      border-top: 1px solid #D6D9E1;
    }
    #modal-payment .footer .footer-left {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
    #modal-payment .footer .footer-right {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #EA5455;
    }
     #modal-payment .paymentType {
      padding: 10px 20px;
    }
    #modal-payment .paymentType-header {
      display: flex;
      font-weight: bold;
    }
    #modal-payment .paymentType-header-item {
      width: 33%;
    }
     #modal-payment .paymentType-header-item {
      padding: 5px 0;
    }
    #modal-payment .paymentType-select {
      display: flex;
    }
    #modal-payment .paymentType-select-item {
      width: 33%;
    }
     #modal-payment .paymentType-select-item {
      padding: 5px 0;
      cursor: pointer;
    }
    #modal-payment .paymentType-select-method:hover {
      color: #114a9f;
    }
     #modal-payment .paymentType-select-method:hover {
      background-color: #e2e9f3;
      cursor: pointer;
    }
    #modal-payment .input-payment-method {
      white-space: nowrap;
      display: flex;
      flex-direction: column;
      vertical-align: middle;
    }
     #modal-payment .input-payment-method {
      cursor: pointer;
    }
    #modal-payment .dropdown-payment-method {
      display: block;
      width: auto;
      min-width: 520px;
      z-index: 15;
      list-style: none;
      position: absolute;
      top: 49px;
    }
     #modal-payment .dropdown-payment-method {
      border: 1px solid #efefef;
      background: white;
      margin: 0;
      padding: 10px 0px;
      border-radius: 0px 0px 3px 3px;
      box-shadow: rgba(0, 0, 0, 0.18) 0px 6px 12px 0px;
    }
    [dir=ltr] #modal-payment .dropdown-payment-method {
      left: calc(50% + 142px);
      transform: translateX(-50%);
    }
    [dir=rtl] #modal-payment .dropdown-payment-method {
      right: calc(50% + 142px);
      transform: translateX(50%);
    }
    #modal-payment .money-exchange {
      color: #114A9F;
    }
    #modal-payment .input-debit-account {
      vertical-align: middle;
    }
    #modal-payment .show-debit-account, #modal-payment .note-payment-display {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
     #modal-payment .ezGolf-icon-external-link {
      cursor: pointer;
    }
    .color-warning[data-v-0a8c8c5e] {
      color: #114A9F;
    }
    .error[data-v-0a8c8c5e] {
      color: red;
    }
     .pd15[data-v-0a8c8c5e] {
      padding: 15px;
    }
    [data-v-0a8c8c5e] .modal-content {
      width: 400px;
    }
    [data-v-0a8c8c5e]  .modal-content {
      background: #FFFFFF;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
    .title-modal[data-v-0a8c8c5e] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
    }
    .content-body-modal[data-v-0a8c8c5e] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    #add-service-item-retail {
      max-width: inherit !important;
    }
     #add-service-item-retail .btn-payment {
      background-color: #FDB913 !important;
      border-color: #FDB913 !important;
    }
    #add-service-item-retail .body-main {
      display: flex;
      height: calc(100vh - 48px);
    }
    #add-service-item-retail .body-main .col-left {
      min-width: 885px;
    }
     #add-service-item-retail .body-main .col-left {
      padding: 18px 16px;
      background-color: #F8F8F8;
    }
    [dir=ltr] #add-service-item-retail .body-main .col-left {
      border-right: 1px solid #E9EBF1;
    }
    [dir=rtl] #add-service-item-retail .body-main .col-left {
      border-left: 1px solid #E9EBF1;
    }
     #add-service-item-retail .body-main .col-left .service-tabs ul {
      margin: 15px 5px 15px 5px;
    }
    #add-service-item-retail .body-main .col-left .service-tabs ul > li > a {
      font-weight: 500;
      font-size: 12px;
      letter-spacing: 0.4px;
      color: #424244;
    }
    #add-service-item-retail .body-main .col-left .service-tabs ul > li > a.active {
      color: #FFFFFF;
    }
     #add-service-item-retail .body-main .col-left .service-tabs ul > li > a.active {
      box-shadow: none;
    }
    #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content {
      height: calc(100vh - 230px);
      overflow: hidden;
    }
    #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list {
      display: flex;
      flex-wrap: wrap;
    }
    #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item {
      height: 72px;
      flex-grow: 1;
      width: 160px;
      max-width: 160px;
      position: relative;
    }
     #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item {
      background: #FFFFFF;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      margin: 5px;
      padding: 8px 10px;
    }
    [dir=ltr] #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .body-semi-bold {
      padding-right: 15px;
    }
    [dir=rtl] #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .body-semi-bold {
      padding-left: 15px;
    }
    #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .tag {
      position: absolute;
      top: 0;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
     #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .tag {
      background-color: #FDB913;
    }
    [dir=ltr] #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .tag {
      right: 0;
      border-radius: 0 6px 0 6px;
    }
    [dir=rtl] #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .tag {
      left: 0;
      border-radius: 6px 0 6px 0;
    }
    #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .price {
      position: absolute;
      bottom: 8px;
      font-weight: 400;
      font-size: 14px;
      color: #5D5F65;
    }
    [dir=ltr] #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .price {
      right: 10px;
    }
    [dir=rtl] #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .price {
      left: 10px;
    }
    #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .price del {
      color: #ADAFB6;
    }
     #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item:hover,  #add-service-item-retail .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item.active {
      cursor: pointer;
      box-shadow: 0px 0px 10px rgba(17, 74, 159, 0.3);
    }
    #add-service-item-retail .body-main .col-right {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    #add-service-item-retail .body-main .col-right .golfer-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     #add-service-item-retail .body-main .col-right .golfer-info {
      padding: 26px 14px 14px 14px;
    }
    #add-service-item-retail .body-main .col-right .golfer-info .text-golfer-info {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-service {
      font-weight: bold;
      display: flex;
      text-transform: uppercase;
      height: 36px;
      align-items: center;
    }
     #add-service-item-retail .body-main .col-right .golfer-info-service {
      background-color: #F2F3F7;
      padding: 12px;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-service-name {
      width: 34%;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-service-item {
      width: 23%;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-service-quantity {
      width: 20%;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-list {
      min-height: 100px;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-list-item {
      display: flex;
      align-items: center;
    }
     #add-service-item-retail .body-main .col-right .golfer-info-list-item {
      padding: 5px 12px;
    }
     #add-service-item-retail .body-main .col-right .golfer-info-list-item .item {
      padding: 5px 8px;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-list-item .item-name {
      width: 34%;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-list-item .item-other {
      width: 23%;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-list-item .item-quantity {
      width: 20%;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-list-item .item-quantity input {
      width: 42px;
      height: 26px;
    }
     #add-service-item-retail .body-main .col-right .golfer-info-list-item .item-quantity input {
      border: 1px solid #D6D9E1;
      border-radius: 5px;
      padding: 10px;
    }
    [dir=ltr] #add-service-item-retail .body-main .col-right .golfer-info-list-item .item-quantity input {
      text-align: right;
    }
    [dir=rtl] #add-service-item-retail .body-main .col-right .golfer-info-list-item .item-quantity input {
      text-align: left;
    }
    #add-service-item-retail .body-main .col-right .golfer-info-total {
      font-weight: bold;
      font-size: 15px;
    }
     #add-service-item-retail .body-main .col-right .golfer-info-total {
      border-top: 1px solid #E9EBF1;
      padding: 16px;
    }
    [dir=ltr] #add-service-item-retail .body-main .col-right .golfer-info-total {
      text-align: right;
    }
    [dir=rtl] #add-service-item-retail .body-main .col-right .golfer-info-total {
      text-align: left;
    }
     #add-service-item-retail .body-main .col-right .golfer-info-total-name {
      margin: 0 30px;
    }
    #combo-detail ._button {
      color: #FFFFFF;
      outline: none;
      height: 32px;
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      letter-spacing: 0.4px;
    } #combo-detail ._button {
      background-color: #114A9F;
      border-radius: 5px;
      padding: 9px 18px;
      border: none;
    }
     #combo-detail .mt-6 {
      margin-top: 6px;
    }
     #combo-detail .mt-4px {
      margin-top: 4px;
    }
     #combo-detail .banned-background-color {
      background: rgba(17, 74, 159, 0.12) !important;
      border-radius: 6px 6px 0px 0px;
    }
    #combo-detail .banned-background-color .color-primary {
      color: #114A9F;
    }
    #combo-detail .banned-background-color .title-modal {
      font-size: 18px;
      line-height: 21px;
      font-weight: 500;
    }
     #combo-detail .banned-background-color .title-modal {
      padding: 10px 0;
    }
    #combo-detail .text {
      color: #5D5F65;
      font-size: 12px;
      line-height: 18px;
    }
     #combo-detail .card-body {
      padding: 10px 18px;
    }
    #combo-detail .heading {
      font-size: 14px;
      font-weight: 500;
      color: #424242;
      user-select: none;
    }
    #combo-detail .heading svg {
      width: 18px;
      height: 18px;
      color: #114A9F;
    }
     #combo-detail .heading svg {
      cursor: pointer;
    }
     #combo-detail .toggle-form {
      background: rgba(193, 193, 193, 0.12);
      padding: 10px 18px;
    }
    [dir=ltr] #combo-detail .toggle-form {
      margin-left: -18px;
      margin-right: -18px;
    }
    [dir=rtl] #combo-detail .toggle-form {
      margin-right: -18px;
      margin-left: -18px;
    }
    #combo-detail .toggle-form .sex {
      display: inline-flex;
      align-items: center;
    }
    #combo-detail .toggle-form .sex .day {
      height: 32px;
      width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #5d5f65;
      user-select: none;
    }
     #combo-detail .toggle-form .sex .day {
      border: 1px solid #ccc;
      cursor: pointer;
    }
    [dir=ltr] #combo-detail .toggle-form .sex .day:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      border-right-color: transparent;
    }
    [dir=rtl] #combo-detail .toggle-form .sex .day:first-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-left-color: transparent;
    }
    [dir=ltr] #combo-detail .toggle-form .sex .day:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-left-color: transparent;
    }
    [dir=rtl] #combo-detail .toggle-form .sex .day:last-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      border-right-color: transparent;
    }
    #combo-detail .toggle-form .sex .day.active {
      color: #114a9f;
    }
     #combo-detail .toggle-form .sex .day.active {
      border: 1px solid #114a9f;
      background: rgba(17, 74, 159, 0.2);
    }
    #combo-detail .person-list {
      overflow-y: scroll;
      max-height: 200px;
      overflow-x: hidden;
    }
     #combo-detail .person-list {
      margin-top: 8px;
    }
     #combo-detail .person-list .person-item {
      padding: 8px 0;
    }
    #combo-detail .person-list .person-item .avatar {
      height: 54px;
      width: 54px;
    }
     #combo-detail .person-list .person-item .avatar {
      background: #114A9F;
      border-radius: 50%;
    }
    #combo-detail .person-list .person-item .name {
      font-weight: 500;
      font-size: 14px;
      white-space: nowrap;
    }
    #combo-detail .person-list .person-item .status .dot {
      width: 10px;
      height: 10px;
    }
     #combo-detail .person-list .person-item .status .dot {
      border-radius: 50%;
    }
    [dir=ltr] #combo-detail .person-list .person-item .status .dot {
      margin-right: 6px;
    }
    [dir=rtl] #combo-detail .person-list .person-item .status .dot {
      margin-left: 6px;
    }
     #combo-detail .person-list .person-item:hover {
      background: rgba(193, 193, 193, 0.12);
    }
    .history-playing ._button-no-bg {
      color: #114A9F;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
    } .history-playing ._button-no-bg {
      border-radius: 5px;
      border: 1px solid #114A9F;
      padding: 5px 10px;
      cursor: pointer;
    }
    .history-playing .item {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #5d5f65;
      font-weight: 500;
    }
    .history-playing .item span {
      display: inline-flex;
      align-items: center;
      font-size: 12px;
      font-weight: 500;
      justify-content: center;
      height: 20px;
      min-width: 20px;
      color: #FFFFFF;
    }
     .history-playing .item span {
      padding: 0 6px;
      border-radius: 4px;
    }
    [dir=ltr] .history-playing .item span {
      margin-left: 8px;
      margin-right: 22px;
    }
    [dir=rtl] .history-playing .item span {
      margin-right: 8px;
      margin-left: 22px;
    }
    [dir=ltr] .history-playing .item:first-child {
      margin-left: 16px;
    }
    [dir=rtl] .history-playing .item:first-child {
      margin-right: 16px;
    }
    #history-playing ._button-no-bg {
      color: #114A9F;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
    } #history-playing ._button-no-bg {
      border-radius: 5px;
      border: 1px solid #114A9F;
      padding: 5px 10px;
      cursor: pointer;
    }
    #history-playing .item {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #5d5f65;
      font-weight: 500;
    }
    #history-playing .item span {
      display: inline-flex;
      align-items: center;
      font-size: 12px;
      font-weight: 500;
      justify-content: center;
      height: 20px;
      min-width: 20px;
      color: #FFFFFF;
    }
     #history-playing .item span {
      padding: 0 6px;
      border-radius: 4px;
    }
    [dir=ltr] #history-playing .item span {
      margin-left: 8px;
      margin-right: 22px;
    }
    [dir=rtl] #history-playing .item span {
      margin-right: 8px;
      margin-left: 22px;
    }
    [dir=ltr] #history-playing .item:first-child {
      margin-left: 16px;
    }
    [dir=rtl] #history-playing .item:first-child {
      margin-right: 16px;
    }
    .w-90 {
      width: 90% !important;
    }
    .require {
      color: red;
    }
    .inActive input, .inActive .custom_input, .inActive textarea, .inActive.sex {
      pointer-events: none;
    }
     .inActive input,  .inActive .custom_input,  .inActive textarea,  .inActive.sex {
      background-color: #ebebeb;
    }
     .inActive .flatpickr-input {
      background-color: #ebebeb !important;
    }
     .cursor {
      cursor: pointer;
    }
    #member-sidebar .side-bar-header {
      height: 48px;
      font-size: 18px;
      font-weight: 500;
      color: #114a9f;
    }
     #member-sidebar .side-bar-header {
      padding: 0 16px;
      background-color: rgba(17, 74, 159, 0.12);
    }
    [dir=ltr] #member-sidebar .side-bar-header .side-bar-options button {
      margin-right: 12px;
    }
    [dir=rtl] #member-sidebar .side-bar-header .side-bar-options button {
      margin-left: 12px;
    }
     #member-sidebar .side-bar-header .side-bar-options svg {
      cursor: pointer;
    }
    #member-sidebar .side-bar-wrapper {
      height: 100%;
      width: 100%;
    }
     #member-sidebar .side-bar-wrapper {
      background-color: white;
    }
    #member-sidebar .side-bar-wrapper input[type=checkbox] {
      width: 16px;
      height: 16px;
    }
    #member-sidebar .side-bar-wrapper .side-bar-header {
      font-size: 18px;
      font-weight: 500;
      color: #114a9f;
    }
     #member-sidebar .side-bar-wrapper .side-bar-header {
      padding: 14px 18px;
      background: linear-gradient(0deg, rgba(17, 74, 159, 0.12), rgba(17, 74, 159, 0.12)), #ffffff;
    }
     #member-sidebar .side-bar-wrapper .side-bar-header svg {
      cursor: pointer;
    }
    [dir=ltr] #member-sidebar .side-bar-wrapper .side-bar-header svg {
      margin-left: 10px;
      margin-right: unset;
    }
    [dir=rtl] #member-sidebar .side-bar-wrapper .side-bar-header svg {
      margin-right: 10px;
      margin-left: unset;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body {
      background-color: #f8f8f8;
      border-radius: 5px;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block {
      margin-bottom: 16px;
      background: white;
    }
    #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side {
      width: 50%;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side {
      margin: 16px 0;
      padding: 0 16px;
    }
    #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .input-wrapper {
      user-select: none;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .input-wrapper {
      margin-bottom: 10px;
    }
    #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .no-border {
      outline: none;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .no-border {
      border: none;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .padding-two-side-10 {
      padding: 0 10px;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .checkbox-wrapper > span {
      margin-top: 2px;
    }
    [dir=ltr] #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .checkbox-wrapper > span {
      margin-left: 10px;
    }
    [dir=rtl] #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .checkbox-wrapper > span {
      margin-right: 10px;
    }
    #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side label {
      font-size: 12px;
      line-height: 18px;
      font-weight: 400;
      color: #424244;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side label {
      margin-bottom: 8px;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .tabs {
      border-radius: 5px;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .tabs .tab {
      padding: 6px;
      border: 1px solid #ccc;
    }
    [dir=ltr] #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .tabs .tab-1 {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    [dir=rtl] #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .tabs .tab-1 {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    [dir=ltr] #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .tabs .tab-2 {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    [dir=rtl] #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .tabs .tab-2 {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .tabs .tab.active {
      color: #114a9f;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .tabs .tab.active {
      border-color: #114a9f;
      background: rgba(17, 74, 159, 0.2);
    }
    #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .days {
      display: flex;
      align-items: center;
    }
    #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .days .day {
      height: 32px;
      width: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #5d5f65;
      user-select: none;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .days .day {
      border: 1px solid #ccc;
      cursor: pointer;
    }
    [dir=ltr] #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .days .day:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    [dir=rtl] #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .days .day:first-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    [dir=ltr] #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .days .day:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    [dir=rtl] #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .days .day:last-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
     #member-sidebar .side-bar-wrapper .side-bar-body .side-bar-block .side .days .day.active {
      border: 1px solid #114a9f;
      background: rgba(17, 74, 159, 0.2);
    }
     #member-sidebar .information-tab {
      padding: 16px;
    }
    #member-sidebar .information-tab .avatar {
      width: 140px;
      height: 140px;
    }
     #member-sidebar .information-tab .avatar {
      background-color: greenyellow;
    }
    #member-sidebar .information-tab .title {
      font-size: 14px;
      line-height: 17px;
      font-weight: 500;
      color: #424244;
    }
     #member-sidebar .information-tab .title {
      margin-bottom: 4px;
    }
    #member-sidebar .information-tab label {
      font-size: 12px;
      line-height: 18px;
      font-weight: 400;
      color: #424242;
      display: block;
    }
     #member-sidebar .information-tab label {
      margin-bottom: 2px;
    }
    #member-sidebar .information-tab .sex {
      display: inline-flex;
      align-items: center;
    }
    #member-sidebar .information-tab .sex .day {
      height: 32px;
      width: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #5d5f65;
      user-select: none;
    }
     #member-sidebar .information-tab .sex .day {
      border: 1px solid #ccc;
      cursor: pointer;
    }
    [dir=ltr] #member-sidebar .information-tab .sex .day:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      border-right-color: transparent;
    }
    [dir=rtl] #member-sidebar .information-tab .sex .day:first-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-left-color: transparent;
    }
    [dir=ltr] #member-sidebar .information-tab .sex .day:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-left-color: transparent;
    }
    [dir=rtl] #member-sidebar .information-tab .sex .day:last-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      border-right-color: transparent;
    }
    #member-sidebar .information-tab .sex .day.active {
      color: #114a9f;
    }
     #member-sidebar .information-tab .sex .day.active {
      border: 1px solid #114a9f;
      background: rgba(17, 74, 159, 0.2);
    }
    #member-sidebar ._button {
      color: #FFFFFF;
      outline: none;
      height: 32px;
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      letter-spacing: 0.4px;
    }
     #member-sidebar ._button {
      background-color: #114A9F;
      border-radius: 5px;
      padding: 9px 18px;
      border: none;
    }
     #member-sidebar .flatpickr-input[readonly] {
      background-color: white;
    }
    #member-sidebar .nav.nav-tabs {
      height: 44px;
      align-items: center;
    }
     #member-sidebar .nav.nav-tabs {
      background: rgba(193, 193, 193, 0.12);
      margin-bottom: 0;
    }
    [dir=ltr] #member-sidebar .nav.nav-tabs {
      padding-left: 16px;
    }
    [dir=rtl] #member-sidebar .nav.nav-tabs {
      padding-right: 16px;
    }
    #member-sidebar .nav.nav-tabs .nav-link {
      height: 44px;
    }
    #member-sidebar .removeTabs ul.nav.nav-tabs {
      display: none !important;
    }
    .vue-slider-disabled[data-v-ca4e9cac] {
      opacity: 0.5;
    }
     .vue-slider-disabled[data-v-ca4e9cac] {
      cursor: not-allowed;
    }
    
    /* rail style */
     .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(17, 74, 159, 0.12);
      border-radius: 15px;
    }
    
    /* process style */
     .vue-slider-process[data-v-ca4e9cac] {
      background-color: #114A9F;
      border-radius: 15px;
    }
    
    /* mark style */
    .vue-slider-mark[data-v-ca4e9cac] {
      z-index: 4;
    }
    .vue-slider-mark:first-child .vue-slider-mark-step[data-v-ca4e9cac], .vue-slider-mark:last-child .vue-slider-mark-step[data-v-ca4e9cac] {
      display: none;
    }
    .vue-slider-mark-step[data-v-ca4e9cac] {
      width: 100%;
      height: 100%;
    }
     .vue-slider-mark-step[data-v-ca4e9cac] {
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.16);
    }
    .vue-slider-mark-label[data-v-ca4e9cac] {
      font-size: 14px;
      white-space: nowrap;
    }
    /* dot style */
    .vue-slider-dot-handle[data-v-ca4e9cac] {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
     .vue-slider-dot-handle[data-v-ca4e9cac] {
      cursor: pointer;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: none;
    }
     .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(17, 74, 159, 0.36);
    }
     .vue-slider-dot-handle-disabled[data-v-ca4e9cac] {
      cursor: not-allowed;
      background-color: #ccc;
    }
    .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      font-size: 14px;
      white-space: nowrap;
      min-width: 20px;
      color: #fff;
      box-sizing: content-box;
    }
     .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      padding: 2px 5px;
      text-align: center;
      border-radius: 5px;
      border-color: #114A9F;
      background-color: #114A9F;
    }
    .vue-slider-dot-tooltip-inner[data-v-ca4e9cac]::after {
      content: "";
      position: absolute;
    }
    .vue-slider-dot-tooltip-inner-top[data-v-ca4e9cac]::after {
      top: 100%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-top[data-v-ca4e9cac]::after {
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
      border-top-color: inherit;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-top[data-v-ca4e9cac]::after {
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-top[data-v-ca4e9cac]::after {
      right: 50%;
      transform: translate(50%, 0);
    }
    .vue-slider-dot-tooltip-inner-bottom[data-v-ca4e9cac]::after {
      bottom: 100%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-bottom[data-v-ca4e9cac]::after {
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
      border-bottom-color: inherit;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-bottom[data-v-ca4e9cac]::after {
      left: 50%;
      transform: translate(-50%, 0);
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-bottom[data-v-ca4e9cac]::after {
      right: 50%;
      transform: translate(50%, 0);
    }
    .vue-slider-dot-tooltip-inner-left[data-v-ca4e9cac]::after {
      top: 50%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-left[data-v-ca4e9cac]::after {
      transform: translate(0, -50%);
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-left[data-v-ca4e9cac]::after {
      left: 100%;
      border-left-color: inherit;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-left[data-v-ca4e9cac]::after {
      right: 100%;
      border-right-color: inherit;
    }
    .vue-slider-dot-tooltip-inner-right[data-v-ca4e9cac]::after {
      top: 50%;
      height: 0;
      width: 0;
    }
     .vue-slider-dot-tooltip-inner-right[data-v-ca4e9cac]::after {
      transform: translate(0, -50%);
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
    [dir=ltr] .vue-slider-dot-tooltip-inner-right[data-v-ca4e9cac]::after {
      right: 100%;
      border-right-color: inherit;
    }
    [dir=rtl] .vue-slider-dot-tooltip-inner-right[data-v-ca4e9cac]::after {
      left: 100%;
      border-left-color: inherit;
    }
    .vue-slider-dot-tooltip-wrapper[data-v-ca4e9cac] {
      opacity: 0;
      transition: all 0.3s;
    }
    .vue-slider-dot-tooltip-wrapper-show[data-v-ca4e9cac] {
      opacity: 1;
    }
     .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #114A9F;
    }
     .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #114A9F;
      border-color: #114A9F;
    }
    
    /* Generate:
    *  Border color according to event class
    */
     .vue-slider-white .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #ffffff;
    }
     .vue-slider-white .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(255, 255, 255, 0.36);
    }
     .vue-slider-white .vue-slider-process[data-v-ca4e9cac] {
      background-color: #ffffff;
    }
     .vue-slider-white .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(255, 255, 255, 0.12);
    }
     .vue-slider-white .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #ffffff;
      border-color: #ffffff;
    }
     .vue-slider-black .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #000000;
    }
     .vue-slider-black .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(0, 0, 0, 0.36);
    }
     .vue-slider-black .vue-slider-process[data-v-ca4e9cac] {
      background-color: #000000;
    }
     .vue-slider-black .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(0, 0, 0, 0.12);
    }
     .vue-slider-black .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #000000;
      border-color: #000000;
    }
     .vue-slider-dark .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #4B4B4B;
    }
     .vue-slider-dark .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(75, 75, 75, 0.36);
    }
     .vue-slider-dark .vue-slider-process[data-v-ca4e9cac] {
      background-color: #4B4B4B;
    }
     .vue-slider-dark .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(75, 75, 75, 0.12);
    }
     .vue-slider-dark .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #4B4B4B;
      border-color: #4B4B4B;
    }
     .vue-slider-light .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #C1C1C1;
    }
     .vue-slider-light .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(193, 193, 193, 0.36);
    }
     .vue-slider-light .vue-slider-process[data-v-ca4e9cac] {
      background-color: #C1C1C1;
    }
     .vue-slider-light .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(193, 193, 193, 0.12);
    }
     .vue-slider-light .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #C1C1C1;
      border-color: #C1C1C1;
    }
     .vue-slider-primary .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #114A9F;
    }
     .vue-slider-primary .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(17, 74, 159, 0.36);
    }
     .vue-slider-primary .vue-slider-process[data-v-ca4e9cac] {
      background-color: #114A9F;
    }
     .vue-slider-primary .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(17, 74, 159, 0.12);
    }
     .vue-slider-primary .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #114A9F;
      border-color: #114A9F;
    }
     .vue-slider-secondary .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #9C9EA4;
    }
     .vue-slider-secondary .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(156, 158, 164, 0.36);
    }
     .vue-slider-secondary .vue-slider-process[data-v-ca4e9cac] {
      background-color: #9C9EA4;
    }
     .vue-slider-secondary .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(156, 158, 164, 0.12);
    }
     .vue-slider-secondary .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #9C9EA4;
      border-color: #9C9EA4;
    }
     .vue-slider-success .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #17B75E;
    }
     .vue-slider-success .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(23, 183, 94, 0.36);
    }
     .vue-slider-success .vue-slider-process[data-v-ca4e9cac] {
      background-color: #17B75E;
    }
     .vue-slider-success .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(23, 183, 94, 0.12);
    }
     .vue-slider-success .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #17B75E;
      border-color: #17B75E;
    }
     .vue-slider-info .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #00CFE8;
    }
     .vue-slider-info .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(0, 207, 232, 0.36);
    }
     .vue-slider-info .vue-slider-process[data-v-ca4e9cac] {
      background-color: #00CFE8;
    }
     .vue-slider-info .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(0, 207, 232, 0.12);
    }
     .vue-slider-info .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #00CFE8;
      border-color: #00CFE8;
    }
     .vue-slider-warning .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #FDB913;
    }
     .vue-slider-warning .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(253, 185, 19, 0.36);
    }
     .vue-slider-warning .vue-slider-process[data-v-ca4e9cac] {
      background-color: #FDB913;
    }
     .vue-slider-warning .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(253, 185, 19, 0.12);
    }
     .vue-slider-warning .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #FDB913;
      border-color: #FDB913;
    }
     .vue-slider-danger .vue-slider-dot-handle[data-v-ca4e9cac] {
      border: 2px solid #EA5455;
    }
     .vue-slider-danger .vue-slider-dot-handle-focus[data-v-ca4e9cac] {
      box-shadow: 0px 0px 1px 2px rgba(234, 84, 85, 0.36);
    }
     .vue-slider-danger .vue-slider-process[data-v-ca4e9cac] {
      background-color: #EA5455;
    }
     .vue-slider-danger .vue-slider-rail[data-v-ca4e9cac] {
      background-color: rgba(234, 84, 85, 0.12);
    }
     .vue-slider-danger .vue-slider-dot-tooltip-inner[data-v-ca4e9cac] {
      background-color: #EA5455;
      border-color: #EA5455;
    }
     body.dark-layout .vue-slider-dot-handle[data-v-ca4e9cac] {
      background-color: #161d31;
    }
    [data-v-ca4e9cac] .modal-content {
      width: 650px;
    }
    [data-v-ca4e9cac]  .modal-content {
      background: #FFFFFF;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
     .banned-background-color-primary[data-v-ca4e9cac] {
      background: rgba(17, 74, 159, 0.12);
    }
    .title-modal[data-v-ca4e9cac] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      color: #114A9F;
      line-height: 21px;
    }
    .content-body-modal[data-v-ca4e9cac] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    .color-primary[data-v-ca4e9cac] {
      color: #114A9F;
    }
     .intro-wrapper[data-v-ca4e9cac] {
      margin-bottom: 18px;
    }
    .intro-wrapper .text-intro[data-v-ca4e9cac] {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #424244;
    }
     .box[data-v-ca4e9cac] {
      background: #FFFFFF;
      border-radius: 6px;
      box-shadow: 0 4px 6px rgba(17, 74, 159, 0.38);
    }
    .box .header[data-v-ca4e9cac] {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     .box .header[data-v-ca4e9cac] {
      background: rgba(17, 74, 159, 0.2);
      padding: 10px 14px;
      border-radius: 6px 6px 0 0;
    }
    .box .header .user-name-wrapper[data-v-ca4e9cac] {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .box .header .user-name-wrapper .dot[data-v-ca4e9cac] {
      width: 15px;
      height: 15px;
    }
     .box .header .user-name-wrapper .dot[data-v-ca4e9cac] {
      background-color: #114A9F;
      border-radius: 100%;
    }
    [dir=ltr] .box .header .user-name-wrapper .dot[data-v-ca4e9cac] {
      margin-right: 5px;
    }
    [dir=rtl] .box .header .user-name-wrapper .dot[data-v-ca4e9cac] {
      margin-left: 5px;
    }
    .box .header .user-name-wrapper .user-name[data-v-ca4e9cac] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
     .box .header .user-name-wrapper .user-name[data-v-ca4e9cac] {
      margin-bottom: 0;
    }
    .box .header .info-tee[data-v-ca4e9cac] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
     .box .header .info-tee[data-v-ca4e9cac] {
      margin-bottom: 0;
    }
     .box .body[data-v-ca4e9cac] {
      padding: 14px;
    }
     .box .body .spacing-4[data-v-ca4e9cac] {
      margin: 4px 0;
    }
     .box .body .spacing-4 .block[data-v-ca4e9cac] {
      margin: 5px 0;
    }
    .box .body .spacing-4 .play-line-block[data-v-ca4e9cac] {
      width: 34px;
      height: 28px;
      box-sizing: border-box;
    }
     .box .body .spacing-4 .play-line-block[data-v-ca4e9cac] {
      background: #FFFFFF;
      border-radius: 5px;
      border: 1px solid #D6D9E1;
      cursor: pointer;
    }
    .box .body .spacing-4 .play-line-block p[data-v-ca4e9cac] {
      color: #114A9F;
      display: flex;
      justify-content: center;
      align-items: center;
    }
     .box .btn-tee[data-v-ca4e9cac] {
      padding: 6px;
    }
    .box .d-select-hole[data-v-ca4e9cac] {
      width: 92px;
    }
    .time-line-history[data-v-ca4e9cac] {
      height: 400px;
      overflow-y: auto;
    }
     .time-line-history[data-v-ca4e9cac] {
      padding: 0 10px;
    }
    .color-warning[data-v-1c895de6] {
      color: #114A9F;
    }
    .error[data-v-1c895de6] {
      color: red;
    }
     .pd15[data-v-1c895de6] {
      padding: 15px;
    }
    [data-v-1c895de6] .modal-content {
      width: 400px;
    }
    [data-v-1c895de6]  .modal-content {
      background: #FFFFFF;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
    .title-modal[data-v-1c895de6] {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
    }
    .content-body-modal[data-v-1c895de6] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    #add-service-item {
      max-width: inherit !important;
    }
    #add-service-item .body-main {
      display: flex;
      height: calc(100vh - 48px);
    }
    #add-service-item .body-main .col-left {
      min-width: 885px;
      width: 885px;
    }
     #add-service-item .body-main .col-left {
      padding: 18px 16px;
      background-color: #F8F8F8;
    }
    [dir=ltr] #add-service-item .body-main .col-left {
      border-right: 1px solid #E9EBF1;
    }
    [dir=rtl] #add-service-item .body-main .col-left {
      border-left: 1px solid #E9EBF1;
    }
     #add-service-item .body-main .col-left .service-tabs ul {
      margin: 15px 5px 15px 5px;
    }
    #add-service-item .body-main .col-left .service-tabs ul > li > a {
      font-weight: 500;
      font-size: 12px;
      letter-spacing: 0.4px;
      color: #424244;
    }
    #add-service-item .body-main .col-left .service-tabs ul > li > a.active {
      color: #FFFFFF;
    }
     #add-service-item .body-main .col-left .service-tabs ul > li > a.active {
      box-shadow: none;
    }
    #add-service-item .body-main .col-left .service-tabs .service-group .tab-content {
      height: calc(100vh - 230px);
      overflow: hidden;
    }
    #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list {
      display: flex;
      flex-wrap: wrap;
    }
    #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item {
      height: 72px;
      flex-grow: 1;
      width: 160px;
      max-width: 160px;
      position: relative;
    }
     #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item {
      background: #FFFFFF;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      margin: 5px;
      padding: 8px 10px;
    }
    [dir=ltr] #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .body-semi-bold {
      padding-right: 15px;
    }
    [dir=rtl] #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .body-semi-bold {
      padding-left: 15px;
    }
    #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .tag {
      position: absolute;
      top: 0;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
     #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .tag {
      background-color: #FDB913;
    }
    [dir=ltr] #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .tag {
      right: 0;
      border-radius: 0 6px 0 6px;
    }
    [dir=rtl] #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .tag {
      left: 0;
      border-radius: 6px 0 6px 0;
    }
    #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .price {
      position: absolute;
      bottom: 8px;
      font-weight: 400;
      font-size: 14px;
      color: #5D5F65;
    }
    [dir=ltr] #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .price {
      right: 10px;
    }
    [dir=rtl] #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .price {
      left: 10px;
    }
    #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item .price del {
      color: #ADAFB6;
    }
     #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item:hover,  #add-service-item .body-main .col-left .service-tabs .service-group .tab-content .service-list .service-item.active {
      cursor: pointer;
      box-shadow: 0px 0px 10px rgba(17, 74, 159, 0.3);
    }
    #add-service-item .body-main .col-right {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    #add-service-item .body-main .col-right table .item-other-Quantity {
      width: 42px;
      height: 26px;
    }
     #add-service-item .body-main .col-right table .item-other-Quantity {
      border: 1px solid #D6D9E1;
      border-radius: 5px;
      padding: 10px;
    }
    [dir=ltr] #add-service-item .body-main .col-right table .item-other-Quantity {
      text-align: right;
    }
    [dir=rtl] #add-service-item .body-main .col-right table .item-other-Quantity {
      text-align: left;
    }
     #add-service-item .body-main .col-right table .input-number {
      border: 1px solid #D6D9E1;
      border-radius: 5px;
    }
    [dir=ltr] #add-service-item .body-main .col-right table .input-number {
      padding-right: 10px;
    }
    [dir=rtl] #add-service-item .body-main .col-right table .input-number {
      padding-left: 10px;
    }
    #add-service-item .body-main .col-right .golfer-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     #add-service-item .body-main .col-right .golfer-info {
      padding: 26px 14px 14px 14px;
    }
    #add-service-item .body-main .col-right .golfer-info .text-golfer-info {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
    #add-service-item .body-main .col-right .golfer-info-service {
      font-weight: bold;
      display: flex;
      text-transform: uppercase;
      height: 36px;
      align-items: center;
    }
     #add-service-item .body-main .col-right .golfer-info-service {
      background-color: #F2F3F7;
      padding: 12px;
    }
    #add-service-item .body-main .col-right .golfer-info-service-name {
      width: 34%;
    }
    #add-service-item .body-main .col-right .golfer-info-service-item {
      width: 23%;
    }
    #add-service-item .body-main .col-right .golfer-info-service-quantity {
      width: 20%;
    }
    #add-service-item .body-main .col-right .golfer-info-list-item {
      display: flex;
      align-items: center;
    }
     #add-service-item .body-main .col-right .golfer-info-list-item .item {
      padding: 5px 8px;
    }
    #add-service-item .body-main .col-right .golfer-info-list-item .item-name {
      width: 34%;
    }
    #add-service-item .body-main .col-right .golfer-info-list-item .item-other {
      width: 23%;
    }
    #add-service-item .body-main .col-right .golfer-info-list-item .item-quantity {
      width: 20%;
    }
    #add-service-item .body-main .col-right .golfer-info-list-item .item-quantity input {
      width: 42px;
      height: 26px;
    }
     #add-service-item .body-main .col-right .golfer-info-list-item .item-quantity input {
      border: 1px solid #D6D9E1;
      border-radius: 5px;
      padding: 10px;
    }
    [dir=ltr] #add-service-item .body-main .col-right .golfer-info-list-item .item-quantity input {
      text-align: right;
    }
    [dir=rtl] #add-service-item .body-main .col-right .golfer-info-list-item .item-quantity input {
      text-align: left;
    }
    #add-service-item .body-main .col-right .golfer-info-total {
      font-weight: bold;
      font-size: 15px;
    }
     #add-service-item .body-main .col-right .golfer-info-total {
      border-top: 1px solid #E9EBF1;
      padding: 16px;
    }
    [dir=ltr] #add-service-item .body-main .col-right .golfer-info-total {
      text-align: right;
    }
    [dir=rtl] #add-service-item .body-main .col-right .golfer-info-total {
      text-align: left;
    }
     #add-service-item .body-main .col-right .golfer-info-total-name {
      margin: 0 30px;
    }
    .v-select {
      position: relative;
      font-family: inherit;
    }
    .v-select,
    .v-select * {
      box-sizing: border-box;
    }
    
    /* KeyFrames */
    @-webkit-keyframes vSelectSpinner-ltr {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    }
    @-webkit-keyframes vSelectSpinner-rtl {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(-360deg);
    }
    }
    @keyframes vSelectSpinner-ltr {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    }
    @keyframes vSelectSpinner-rtl {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(-360deg);
    }
    }
    /* Dropdown Default Transition */
    .vs__fade-enter-active,
    .vs__fade-leave-active {
      pointer-events: none;
      transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .vs__fade-enter,
    .vs__fade-leave-to {
      opacity: 0;
    }
    
    /** Component States */
    /*
     * Disabled
     *
     * When the component is disabled, all interaction
     * should be prevented. Here we modify the bg color,
     * and change the cursor displayed on the interactive
     * components.
     */
     .vs--disabled .vs__dropdown-toggle,  .vs--disabled .vs__clear,  .vs--disabled .vs__search,  .vs--disabled .vs__selected,  .vs--disabled .vs__open-indicator {
      cursor: not-allowed;
      background-color: #f8f8f8;
    }
    .v-select[dir=rtl] .vs__actions {
      padding: 0 3px 0 6px;
    }
    .v-select[dir=rtl] .vs__clear {
      margin-left: 6px;
      margin-right: 0;
    }
    .v-select[dir=rtl] .vs__deselect {
      margin-left: 0;
      margin-right: 2px;
    }
    .v-select[dir=rtl] .vs__dropdown-menu {
      text-align: right;
    }
    .vs__dropdown-toggle {
      appearance: none;
      display: flex;
      white-space: normal;
    }
     .vs__dropdown-toggle {
      padding: 0 0 4px 0;
      background: none;
      border: 1px solid #D6D9E1;
      border-radius: 0.357rem;
    }
    .vs__selected-options {
      display: flex;
      flex-basis: 100%;
      flex-grow: 1;
      flex-wrap: wrap;
      position: relative;
    }
     .vs__selected-options {
      padding: 0 2px;
    }
    .vs__actions {
      display: flex;
      align-items: center;
    }
    [dir=ltr] .vs__actions {
      padding: 4px 6px 0 3px;
    }
    [dir=rtl] .vs__actions {
      padding: 4px 3px 0 6px;
    }
    
    /* Dropdown Toggle States */
     .vs--searchable .vs__dropdown-toggle {
      cursor: text;
    }
     .vs--unsearchable .vs__dropdown-toggle {
      cursor: pointer;
    }
     .vs--open .vs__dropdown-toggle {
      border-bottom-color: transparent;
    }
    [dir=ltr] .vs--open .vs__dropdown-toggle {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=rtl] .vs--open .vs__dropdown-toggle {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    .vs__open-indicator {
      fill: rgba(60, 60, 60, 0.5);
      transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    }
     .vs__open-indicator {
      transform: scale(1);
      transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
    }
    [dir=ltr] .vs--open .vs__open-indicator {
      transform: rotate(180deg) scale(1);
    }
    [dir=rtl] .vs--open .vs__open-indicator {
      transform: rotate(-180deg) scale(1);
    }
    .vs--loading .vs__open-indicator {
      opacity: 0;
    }
    
    /* Clear Button */
    .vs__clear {
      fill: rgba(60, 60, 60, 0.5);
    }
     .vs__clear {
      padding: 0;
      border: 0;
      background-color: transparent;
      cursor: pointer;
    }
    [dir=ltr] .vs__clear {
      margin-right: 8px;
    }
    [dir=rtl] .vs__clear {
      margin-left: 8px;
    }
    
    /* Dropdown Menu */
    .vs__dropdown-menu {
      display: block;
      box-sizing: border-box;
      position: absolute;
      top: calc(100% - 1px);
      z-index: 1000;
      width: 100%;
      max-height: 350px;
      min-width: 160px;
      overflow-y: auto;
      list-style: none;
    }
     .vs__dropdown-menu {
      padding: 5px 0;
      margin: 0;
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
      border: 1px solid #D6D9E1;
      border-top-style: none;
      border-radius: 0 0 0.357rem 0.357rem;
      background: #fff;
    }
    [dir=ltr] .vs__dropdown-menu {
      left: 0;
      text-align: left;
    }
    [dir=rtl] .vs__dropdown-menu {
      right: 0;
      text-align: right;
    }
     .vs__no-options {
      text-align: center;
    }
    
    /* List Items */
    .vs__dropdown-option {
      line-height: 1.42857143;
      /* Normalize line height */
      display: block;
      color: #333;
      /* Overrides most CSS frameworks */
      white-space: nowrap;
    }
     .vs__dropdown-option {
      padding: 3px 20px;
      clear: both;
    }
     .vs__dropdown-option:hover {
      cursor: pointer;
    }
    .vs__dropdown-option--highlight {
      color: #114A9F !important;
    }
     .vs__dropdown-option--highlight {
      background: rgba(17, 74, 159, 0.12);
    }
    .vs__dropdown-option--disabled {
      color: rgba(60, 60, 60, 0.5);
    }
     .vs__dropdown-option--disabled {
      background: inherit;
    }
     .vs__dropdown-option--disabled:hover {
      cursor: inherit;
    }
    
    /* Selected Tags */
    .vs__selected {
      display: flex;
      align-items: center;
      color: #333;
      line-height: 1.8;
      z-index: 0;
    }
     .vs__selected {
      background-color: #114A9F;
      border: 0 solid rgba(60, 60, 60, 0.26);
      border-radius: 0.357rem;
      margin: 4px 2px 0px 2px;
      padding: 0 0.25em;
    }
    .vs__deselect {
      display: inline-flex;
      appearance: none;
      fill: rgba(60, 60, 60, 0.5);
    }
     .vs__deselect {
      padding: 0;
      border: 0;
      cursor: pointer;
      background: none;
      text-shadow: 0 1px 0 #fff;
    }
    [dir=ltr] .vs__deselect {
      margin-left: 4px;
    }
    [dir=rtl] .vs__deselect {
      margin-right: 4px;
    }
    
    /* States */
     .vs--single .vs__selected {
      background-color: transparent;
      border-color: transparent;
    }
    .vs--single.vs--open .vs__selected {
      position: absolute;
      opacity: 0.4;
    }
    .vs--single.vs--searching .vs__selected {
      display: none;
    }
    
    /* Search Input */
    /**
     * Super weird bug... If this declaration is grouped
     * below, the cancel button will still appear in chrome.
     * If it's up here on it's own, it'll hide it.
     */
    .vs__search::-webkit-search-cancel-button {
      display: none;
    }
    .vs__search::-webkit-search-decoration,
    .vs__search::-webkit-search-results-button,
    .vs__search::-webkit-search-results-decoration,
    .vs__search::-ms-clear {
      display: none;
    }
    .vs__search,
    .vs__search:focus {
      appearance: none;
      line-height: 1.8;
      font-size: 1em;
      outline: none;
      width: 0;
      max-width: 100%;
      flex-grow: 1;
      z-index: 1;
    }
     .vs__search,  .vs__search:focus {
      border: 1px solid transparent;
      margin: 4px 0 0 0;
      padding: 0 7px;
      background: none;
      box-shadow: none;
    }
    [dir=ltr] .vs__search, [dir=ltr] .vs__search:focus {
      border-left: none;
    }
    [dir=rtl] .vs__search, [dir=rtl] .vs__search:focus {
      border-right: none;
    }
    .vs__search::placeholder {
      color: #424244;
    }
    
    /**
        States
     */
    .vs--unsearchable .vs__search {
      opacity: 1;
    }
     .vs--unsearchable:not(.vs--disabled) .vs__search:hover {
      cursor: pointer;
    }
    .vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {
      opacity: 0.2;
    }
    
    /* Loading Spinner */
    .vs__spinner {
      align-self: center;
      opacity: 0;
      font-size: 5px;
      text-indent: -9999em;
      overflow: hidden;
      transition: opacity 0.1s;
    }
     .vs__spinner {
      border-top: 0.9em solid rgba(100, 100, 100, 0.1);
      border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);
      transform: translateZ(0);
    }
    [dir=ltr] .vs__spinner {
      border-right: 0.9em solid rgba(100, 100, 100, 0.1);
      border-left: 0.9em solid rgba(60, 60, 60, 0.45);
      animation:  vSelectSpinner-ltr 1.1s infinite linear;
    }
    [dir=rtl] .vs__spinner {
      border-left: 0.9em solid rgba(100, 100, 100, 0.1);
      border-right: 0.9em solid rgba(60, 60, 60, 0.45);
      animation:  vSelectSpinner-rtl 1.1s infinite linear;
    }
    .vs__spinner,
    .vs__spinner:after {
      width: 5em;
      height: 5em;
    }
     .vs__spinner,  .vs__spinner:after {
      border-radius: 50%;
    }
    
    /* Loading Spinner States */
    .vs--loading .vs__spinner {
      opacity: 1;
    }
    .vs__open-indicator {
      fill: none;
    }
     .vs__open-indicator {
      margin-top: 0.15rem;
    }
    .vs__dropdown-toggle {
      transition: all 0.25s ease-in-out;
    }
     .vs__dropdown-toggle {
      padding: 0.59px 0 2px 0;
    }
    [dir=ltr] .vs--single .vs__dropdown-toggle {
      padding-left: 6px;
    }
    [dir=rtl] .vs--single .vs__dropdown-toggle {
      padding-right: 6px;
    }
    .vs__dropdown-option--disabled {
      opacity: 0.5;
    }
     .vs__dropdown-option--disabled.vs__dropdown-option--selected {
      background: #114A9F !important;
    }
    .vs__dropdown-option {
      color: #424244;
    }
     .vs__dropdown-option,  .vs__no-options {
      padding: 7px 20px;
    }
    .vs__dropdown-option--selected {
      background-color: #114A9F;
      color: #fff;
      position: relative;
    }
    .vs__dropdown-option--selected::after {
      content: "";
      height: 1.1rem;
      width: 1.1rem;
      display: inline-block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 1.1rem;
    }
    [dir=rtl] .vs__dropdown-option--selected::after {
      left: 20px;
      right: unset;
    }
    .vs__dropdown-option--selected.vs__dropdown-option--highlight {
      color: #fff !important;
      background-color: #114A9F !important;
    }
    .vs__clear svg {
      color: #424244;
    }
    .vs__selected {
      color: #fff;
    }
    .v-select.vs--single .vs__selected {
      color: #424244;
      transition: transform 0.2s ease;
    }
     .v-select.vs--single .vs__selected {
      margin-top: 5px;
    }
    [dir=ltr] .v-select.vs--single .vs__selected input {
      padding-left: 0;
    }
    [dir=rtl] .v-select.vs--single .vs__selected input {
      padding-right: 0;
    }
    [dir=ltr] .vs--single.vs--open .vs__selected {
      transform: translateX(5px);
    }
    [dir=rtl] .vs--single.vs--open .vs__selected {
      transform: translateX(-5px);
    }
    .vs__selected .vs__deselect {
      color: inherit;
    }
    .v-select:not(.vs--single) .vs__selected {
      font-size: 0.9rem;
    }
     .v-select:not(.vs--single) .vs__selected {
      border-radius: 3px;
      padding: 0 0.6em;
    }
    [dir=ltr] .v-select:not(.vs--single) .vs__selected {
      margin: 5px 2px 2px 5px;
    }
    [dir=rtl] .v-select:not(.vs--single) .vs__selected {
      margin: 5px 5px 2px 2px;
    }
    .v-select:not(.vs--single) .vs__deselect svg {
      vertical-align: text-top;
    }
     .v-select:not(.vs--single) .vs__deselect svg {
      transform: scale(0.8);
    }
    .vs__dropdown-menu {
      top: calc(100% + 0.5rem);
    }
     .vs__dropdown-menu {
      border: none;
      border-radius: 6px;
      padding: 0;
    }
     .vs--open .vs__dropdown-toggle {
      border-color: #114A9F;
      border-bottom-color: #114A9F;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
    [dir=ltr] .vs--open .vs__dropdown-toggle {
      border-bottom-left-radius: 0.357rem;
      border-bottom-right-radius: 0.357rem;
    }
    [dir=rtl] .vs--open .vs__dropdown-toggle {
      border-bottom-right-radius: 0.357rem;
      border-bottom-left-radius: 0.357rem;
    }
    .select-size-lg .vs__selected {
      font-size: 1rem !important;
    }
     .select-size-lg.vs--single.vs--open .vs__selected {
      margin-top: 6px;
    }
    .select-size-lg .vs__dropdown-toggle,
    .select-size-lg .vs__selected {
      font-size: 1.25rem;
    }
     .select-size-lg .vs__dropdown-toggle {
      padding: 5px;
    }
     .select-size-lg .vs__dropdown-toggle input {
      margin-top: 0;
    }
    .select-size-lg .vs__deselect svg {
      vertical-align: middle !important;
    }
     .select-size-lg .vs__deselect svg {
      transform: scale(1) !important;
    }
     .select-size-sm .vs__dropdown-toggle {
      padding-bottom: 0;
      padding: 1px;
    }
     .select-size-sm.vs--single .vs__dropdown-toggle {
      padding: 2px;
    }
    .select-size-sm .vs__dropdown-toggle,
    .select-size-sm .vs__selected {
      font-size: 0.9rem;
    }
     .select-size-sm .vs__actions {
      padding-top: 2px;
      padding-bottom: 2px;
    }
    .select-size-sm .vs__deselect svg {
      vertical-align: middle !important;
    }
     .select-size-sm .vs__search {
      margin-top: 0;
    }
    .select-size-sm.v-select .vs__selected {
      font-size: 0.75rem;
    }
     .select-size-sm.v-select .vs__selected {
      padding: 0 0.3rem;
    }
     .select-size-sm.v-select:not(.vs--single) .vs__selected {
      margin: 4px 5px;
    }
     .select-size-sm.v-select.vs--single .vs__selected {
      margin-top: 1px;
    }
     .select-size-sm.vs--single.vs--open .vs__selected {
      margin-top: 4px;
    }
    .dark-layout .vs__dropdown-toggle {
      color: #b4b7bd;
    }
     .dark-layout .vs__dropdown-toggle {
      background: #283046;
      border-color: #404656;
    }
    .dark-layout .vs__selected-options input {
      color: #b4b7bd;
    }
    .dark-layout .vs__selected-options input::placeholder {
      color: #676d7d;
    }
    .dark-layout .vs__actions svg {
      fill: #404656;
    }
     .dark-layout .vs__dropdown-menu {
      background: #283046;
    }
    .dark-layout .vs__dropdown-menu li {
      color: #b4b7bd;
    }
    .dark-layout .v-select:not(.vs--single) .vs__selected {
      color: #114A9F;
    }
     .dark-layout .v-select:not(.vs--single) .vs__selected {
      background-color: rgba(17, 74, 159, 0.12);
    }
    .dark-layout .v-select.vs--single .vs__selected {
      color: #b4b7bd !important;
    }
    .dark-layout .vs--disabled .vs__dropdown-toggle,
    .dark-layout .vs--disabled .vs__clear,
    .dark-layout .vs--disabled .vs__search,
    .dark-layout .vs--disabled .vs__selected,
    .dark-layout .vs--disabled .vs__open-indicator {
      opacity: 0.5;
      color: inherit !important;
    }
     .dark-layout .vs--disabled .vs__dropdown-toggle,  .dark-layout .vs--disabled .vs__clear,  .dark-layout .vs--disabled .vs__search,  .dark-layout .vs--disabled .vs__selected,  .dark-layout .vs--disabled .vs__open-indicator {
      background-color: #283046;
    }
    .vs--disabled .vs__selected {
      color: inherit !important;
    }
    .vs--disabled .vs__selected button {
      display: none;
    }
    .hover-editable {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 32px;
    }
     .hover-editable {
      border: 1px solid #ccc;
      padding: 0 8px;
      border-radius: 4px;
      cursor: pointer;
    }
     .tee-block {
      padding-bottom: 10px;
      border-bottom: 1px solid #D6D9E1;
    }
    .tee-block .tee-head {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
     .tee-block .tee-head {
      margin-bottom: 0;
    }
    .tee-block .tee-body {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
     .tee-block .tee-body {
      margin-bottom: 0;
    }
    .tee-block .tee-body .combo {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    .tee-block .tee-body .old-price {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      text-decoration-line: line-through;
      color: #ADAFB6;
    }
     .tee-block .tee-body .old-price {
      margin: 0 15px;
    }
    [dir=ltr] .tee-block .tee-body .old-price {
      text-align: right;
    }
    [dir=rtl] .tee-block .tee-body .old-price {
      text-align: left;
    }
    .tee-block .tee-body .discount {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      color: #FDB913;
    }
    .tee-block .tee-body .price {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    [dir=ltr] .tee-block .tee-body .price {
      text-align: right;
    }
    [dir=rtl] .tee-block .tee-body .price {
      text-align: left;
    }
    #sidebar-detail-booking {
      width: 880px !important;
    }
    #sidebar-detail-booking .custom-body-sidebar {
      display: flex;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left {
      flex-basis: 400px;
    }
    [dir=ltr] #sidebar-detail-booking .custom-body-sidebar .col-left {
      border-right: 1px solid #E9EBF1;
    }
    [dir=rtl] #sidebar-detail-booking .custom-body-sidebar .col-left {
      border-left: 1px solid #E9EBF1;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .button-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .button-wrapper {
      margin-bottom: 10px;
    }
    [dir=ltr] #sidebar-detail-booking .custom-body-sidebar .col-left .button-wrapper {
      padding-left: 18px;
      padding-right: 18px;
    }
    [dir=rtl] #sidebar-detail-booking .custom-body-sidebar .col-left .button-wrapper {
      padding-right: 18px;
      padding-left: 18px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .button-wrapper .text-all {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      letter-spacing: 0.4px;
    }
    [dir=ltr] #sidebar-detail-booking .custom-body-sidebar .col-left .button-wrapper .text-all {
      margin-left: 4px;
    }
    [dir=rtl] #sidebar-detail-booking .custom-body-sidebar .col-left .button-wrapper .text-all {
      margin-right: 4px;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .button-wrapper button {
      padding: 5px 8px;
      border-color: #4B4B4B !important;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .button-wrapper button.text-danger {
      border-color: #ea5455 !important;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area {
      position: relative;
      height: calc(100vh - 210px);
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area {
      margin: auto;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list {
      max-width: 400px;
      overflow: hidden;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list {
      margin-bottom: 0;
    }
    [dir=ltr] #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr th {
      padding-left: 18px;
      padding-right: 18px;
    }
    [dir=rtl] #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr th {
      padding-right: 18px;
      padding-left: 18px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr th .table-booking-list-header {
      display: flex;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr th .table-booking-list-header .text-name-header {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td {
      padding: 0;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item {
      display: flex;
      align-items: center;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item {
      cursor: pointer;
      padding: 0 18px;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item.active {
      background: linear-gradient(0deg, rgba(17, 74, 159, 0.12), rgba(17, 74, 159, 0.12)), #FFFFFF;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section {
      padding: 10px 0;
    }
    [dir=ltr] #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .user-info {
      margin-left: 10px;
    }
    [dir=rtl] #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .user-info {
      margin-right: 10px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .user-info .user-name {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .user-info .user-tee-info {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .status {
      border-radius: 4px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .status div {
      flex: none;
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .status div {
      margin: 0px 4px;
    }
    [dir=ltr] #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .status div {
      text-align: right;
    }
    [dir=rtl] #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .status div {
      text-align: left;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .CHECK_IN {
      background: rgba(234, 84, 85, 0.12);
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .CHECK_IN div {
      color: #EA5455;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .BOOKED {
      background: rgba(0, 207, 232, 0.12);
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .BOOKED div {
      color: #00CFE8;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .CHECK_OUT {
      background: rgba(136, 91, 234, 0.12);
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .CHECK_OUT div {
      color: #885BEA;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .CANCELLED {
      background: rgba(161, 164, 156, 0.12);
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .CANCELLED div {
      color: #9C9EA4;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .NO_SHOW {
      background: rgba(161, 164, 156, 0.12);
    }
    #sidebar-detail-booking .custom-body-sidebar .col-left .scroll-area .table-booking-list tr td .table-booking-list-body .table-booking-list-item .user-info-section .NO_SHOW div {
      color: #FDB913;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right {
      flex-basis: 480px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap {
      height: calc(100vh - 48px);
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .section-tabs {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .section-tabs {
      border-radius: unset;
      border-bottom: unset;
      background-color: rgba(193, 193, 193, 0.12);
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .section-tabs .tab-wrapper {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .section-tabs .tab-wrapper .header-tab {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      letter-spacing: 0.4px;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .section-tabs .tab-wrapper .header-tab {
      cursor: pointer;
      padding: 13px 15px;
      border-bottom: 2px solid transparent;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .section-tabs .tab-wrapper .active {
      border-bottom: 2px solid #114A9F;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info {
      padding-bottom: 15px;
      border-bottom: 1px solid #E9EBF1;
      margin-bottom: 15px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-header {
      padding-bottom: 15px;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-header button {
      padding: 5px 8px;
      border-color: #4B4B4B !important;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-header button.text-danger {
      border-color: #ea5455 !important;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-header-title {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-header-action {
      display: flex;
      align-items: center;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-detail-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-detail-item {
      margin: 4px 0;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-detail-item .image-icon {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-detail-item .image-icon {
      background: rgba(161, 164, 156, 0.12);
      border-radius: 5px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-detail-item .text-icon {
      font-weight: 400;
      font-size: 12px;
      line-height: 24px;
    }
    [dir=ltr] #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-detail-item .text-icon {
      margin-left: 8px;
    }
    [dir=rtl] #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .booking-info-detail-item .text-icon {
      margin-right: 8px;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info {
      padding-bottom: 15px;
      border-bottom: 1px solid #E9EBF1;
      margin-bottom: 15px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info .sex-list label {
      font-weight: 400;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info .sex-list label {
      padding: 6px 10px;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info .sex-list label.btn-outline-primary {
      border: 1px solid #D6D9E1 !important;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info .sex-list label.btn-outline-primary.active {
      border: 1px solid #114A9F !important;
      background-color: rgba(17, 74, 159, 0.2);
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-header {
      padding-bottom: 15px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-header-title {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-header-action {
      display: flex;
      align-items: center;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-content {
      display: flex;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-content > div {
      flex-basis: 150px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-content > div:first-child {
      flex-grow: 1;
    }
    [dir=ltr] #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-content > div:first-child {
      padding-right: 10px;
    }
    [dir=rtl] #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-content > div:first-child {
      padding-left: 10px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-content > div .media-body h6 {
      font-size: 12px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-content .remove {
      flex-basis: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .golfer-info-content .remove {
      background-color: rgba(193, 193, 193, 0.12);
      cursor: pointer;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .play-info-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .play-info-header {
      margin-bottom: 15px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .play-info-header-title {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .play-info-header-action button {
      padding: 5px 8px;
      border-color: #4B4B4B !important;
    }
     #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .play-info-header-action button.text-danger {
      border-color: #ea5455 !important;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .play-info-detail-item {
      display: flex;
      line-height: 30px;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .play-info-detail-item > span {
      flex-grow: 1;
    }
    #sidebar-detail-booking .custom-body-sidebar .col-right .b-overlay-wrap .play-info-detail-item > span.label {
      flex-basis: 100px;
      max-width: 100px;
    }
    .suggest-guest {
      position: fixed;
      top: 30%;
      width: 320px;
      height: 390px;
      z-index: 99;
      bottom: 0;
      overflow-y: auto;
    }
     .suggest-guest {
      background: #FFFFFF;
      border-radius: 5px;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.5);
    }
    [dir=ltr] .suggest-guest {
      left: 10%;
      right: 0;
    }
    [dir=rtl] .suggest-guest {
      right: 10%;
      left: 0;
    }
     .suggest-guest-title {
      padding: 10px 15px;
    }
     .suggest-guest-item {
      padding: 8px 15px;
      cursor: pointer;
    }
     .suggest-guest-item:nth-child(2n) {
      background: linear-gradient(0deg, rgba(17, 74, 159, 0.05), rgba(17, 74, 159, 0.05)), #FFFFFF;
    }
     .suggest-guest-item:hover {
      background: linear-gradient(0deg, rgba(17, 74, 159, 0.12), rgba(17, 74, 159, 0.12)), #FFFFFF;
    }
    .suggest-guest-item .media-aside {
      align-self: center !important;
    }
    .suggest-guest-item .media-body .phone-email {
      max-width: 220px;
      display: flex;
      justify-content: space-between;
    }
    .suggest-guest-item .media-body .phone-email span:first-child {
      flex-basis: 100px;
    }
    .suggest-guest-item .media-body .card-type {
      display: flex;
      justify-content: space-between;
    }
    .suggest-guest-item .media-body .card-type .card-code {
      color: #29B869;
      font-weight: 500;
      font-size: 12px;
    }
     .suggest-guest .pointer {
      padding: 12px;
    }
     .suggest-guest .pointer:hover {
      background: #f5f5f5;
    }
     .suggest-guest .d-title {
      padding: 12px 12px 0 12px;
    }
    .no-record-found[data-v-278bda36] {
      width: 175px;
      height: 195px;
    } .no-record-found[data-v-278bda36] {
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
      margin-bottom: 20px;
    }
    .text[data-v-278bda36] {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
     .text[data-v-278bda36] {
      text-align: center;
    }
    .flatpickr-calendar .flatpickr-day[data-v-086bceda] {
      color: #424244;
    }
     .flatpickr-calendar .flatpickr-day.today[data-v-086bceda] {
      border-color: #114A9F;
    }
    .flatpickr-calendar .flatpickr-day.today[data-v-086bceda]:hover {
      color: #424244;
    }
     .flatpickr-calendar .flatpickr-day.today[data-v-086bceda]:hover {
      background: transparent;
    }
    .flatpickr-calendar .flatpickr-day.selected[data-v-086bceda], .flatpickr-calendar .flatpickr-day.selected[data-v-086bceda]:hover {
      color: #fff;
    }
     .flatpickr-calendar .flatpickr-day.selected[data-v-086bceda],  .flatpickr-calendar .flatpickr-day.selected[data-v-086bceda]:hover {
      background: #114A9F;
      border-color: #114A9F;
    }
     .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda],  .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda]:hover {
      background: #5b96ee;
      border-color: #5b96ee;
    }
    [dir=ltr] .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda], [dir=ltr] .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda]:hover {
      box-shadow: -5px 0 0 #5b96ee, 5px 0 0 #5b96ee;
    }
    [dir=rtl] .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda], [dir=rtl] .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda]:hover {
      box-shadow: 5px 0 0 #5b96ee, -5px 0 0 #5b96ee;
    }
    .flatpickr-calendar .flatpickr-day.startRange[data-v-086bceda], .flatpickr-calendar .flatpickr-day.endRange[data-v-086bceda], .flatpickr-calendar .flatpickr-day.startRange[data-v-086bceda]:hover, .flatpickr-calendar .flatpickr-day.endRange[data-v-086bceda]:hover {
      color: #fff;
    }
     .flatpickr-calendar .flatpickr-day.startRange[data-v-086bceda],  .flatpickr-calendar .flatpickr-day.endRange[data-v-086bceda],  .flatpickr-calendar .flatpickr-day.startRange[data-v-086bceda]:hover,  .flatpickr-calendar .flatpickr-day.endRange[data-v-086bceda]:hover {
      background: #114A9F;
      border-color: #114A9F;
    }
    [dir=ltr] .flatpickr-calendar .flatpickr-day.selected.startRange + .endRange[data-v-086bceda]:not(:nth-child(7n+1)), [dir=ltr] .flatpickr-calendar .flatpickr-day.startRange.startRange + .endRange[data-v-086bceda]:not(:nth-child(7n+1)), [dir=ltr] .flatpickr-calendar .flatpickr-day.endRange.startRange + .endRange[data-v-086bceda]:not(:nth-child(7n+1)) {
      box-shadow: -10px 0 0 #114A9F;
    }
    [dir=rtl] .flatpickr-calendar .flatpickr-day.selected.startRange + .endRange[data-v-086bceda]:not(:nth-child(7n+1)), [dir=rtl] .flatpickr-calendar .flatpickr-day.startRange.startRange + .endRange[data-v-086bceda]:not(:nth-child(7n+1)), [dir=rtl] .flatpickr-calendar .flatpickr-day.endRange.startRange + .endRange[data-v-086bceda]:not(:nth-child(7n+1)) {
      box-shadow: 10px 0 0 #114A9F;
    }
    .flatpickr-calendar .flatpickr-day.flatpickr-disabled[data-v-086bceda], .flatpickr-calendar .flatpickr-day.prevMonthDay[data-v-086bceda], .flatpickr-calendar .flatpickr-day.nextMonthDay[data-v-086bceda] {
      color: #dae1e7;
    }
     .flatpickr-calendar .flatpickr-day[data-v-086bceda]:hover {
      background: #f6f6f6;
    }
    .flatpickr-calendar[data-v-086bceda]:after, .flatpickr-calendar[data-v-086bceda]:before {
      display: none;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-prev-month[data-v-086bceda],
    .flatpickr-calendar .flatpickr-months .flatpickr-next-month[data-v-086bceda] {
      top: -5px;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-prev-month:hover i[data-v-086bceda], .flatpickr-calendar .flatpickr-months .flatpickr-prev-month:hover svg[data-v-086bceda],
    .flatpickr-calendar .flatpickr-months .flatpickr-next-month:hover i[data-v-086bceda],
    .flatpickr-calendar .flatpickr-months .flatpickr-next-month:hover svg[data-v-086bceda] {
      fill: #114A9F;
    }
    .flatpickr-calendar .flatpickr-current-month span.cur-month[data-v-086bceda] {
      font-weight: 300;
    }
     .flatpickr-time input[data-v-086bceda]:hover,  .flatpickr-time .flatpickr-am-pm[data-v-086bceda]:hover,  .flatpickr-time input[data-v-086bceda]:focus,  .flatpickr-time .flatpickr-am-pm[data-v-086bceda]:focus {
      background: #fff;
    }
     .dark-layout .flatpickr-calendar[data-v-086bceda] {
      background: #161d31;
      border-color: #161d31;
      box-shadow: none;
    }
    .dark-layout .flatpickr-calendar .flatpickr-months i[data-v-086bceda],
    .dark-layout .flatpickr-calendar .flatpickr-months svg[data-v-086bceda] {
      fill: #b4b7bd;
    }
    .dark-layout .flatpickr-calendar .flatpickr-month[data-v-086bceda] {
      color: #b4b7bd;
    }
    [dir=ltr] .dark-layout .flatpickr-calendar .flatpickr-weekwrapper .flatpickr-weeks[data-v-086bceda] {
      box-shadow: 1px 0 0 #3b4253;
    }
    [dir=rtl] .dark-layout .flatpickr-calendar .flatpickr-weekwrapper .flatpickr-weeks[data-v-086bceda] {
      box-shadow: -1px 0 0 #3b4253;
    }
    .dark-layout .flatpickr-calendar .flatpickr-weekday[data-v-086bceda] {
      color: #b4b7bd;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day[data-v-086bceda], .dark-layout .flatpickr-calendar .flatpickr-day.today[data-v-086bceda]:hover {
      color: #b4b7bd;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day.selected[data-v-086bceda] {
      color: #fff;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day.prevMonthDay[data-v-086bceda], .dark-layout .flatpickr-calendar .flatpickr-day.nextMonthDay[data-v-086bceda], .dark-layout .flatpickr-calendar .flatpickr-day.flatpickr-disabled[data-v-086bceda] {
      color: #4e5154 !important;
    }
     .dark-layout .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda],  .dark-layout .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda]:hover {
      background: #283046;
      border-color: #283046;
    }
    [dir=ltr] .dark-layout .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda], [dir=ltr] .dark-layout .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda]:hover {
      box-shadow: -5px 0 0 #283046, 5px 0 0 #283046;
    }
    [dir=rtl] .dark-layout .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda], [dir=rtl] .dark-layout .flatpickr-calendar .flatpickr-day.inRange[data-v-086bceda]:hover {
      box-shadow: 5px 0 0 #283046, -5px 0 0 #283046;
    }
    .dark-layout .flatpickr-calendar .flatpickr-day[data-v-086bceda]:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      color: #b4b7bd;
    }
     .dark-layout .flatpickr-calendar .flatpickr-day[data-v-086bceda]:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      border-color: #283046;
    }
     .dark-layout .flatpickr-calendar .flatpickr-days .flatpickr-day[data-v-086bceda]:hover:not(.selected):not(.today):not(.startRange):not(.endRange) {
      background: #283046;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time[data-v-086bceda] {
      border-color: #161d31 !important;
    }
    .dark-layout .flatpickr-calendar .flatpickr-time .numInput[data-v-086bceda],
    .dark-layout .flatpickr-calendar .flatpickr-time .flatpickr-am-pm[data-v-086bceda] {
      color: #b4b7bd;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time .numInput[data-v-086bceda]:hover,  .dark-layout .flatpickr-calendar .flatpickr-time .flatpickr-am-pm[data-v-086bceda]:hover {
      background: #161d31;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time .arrowUp[data-v-086bceda]:after {
      border-bottom-color: #b4b7bd;
    }
     .dark-layout .flatpickr-calendar .flatpickr-time .arrowDown[data-v-086bceda]:after {
      border-top-color: #b4b7bd;
    }
     .dark-layout .flatpickr-time input[data-v-086bceda]:hover,  .dark-layout .flatpickr-time .flatpickr-am-pm[data-v-086bceda]:hover,  .dark-layout .flatpickr-time input[data-v-086bceda]:focus,  .dark-layout .flatpickr-time .flatpickr-am-pm[data-v-086bceda]:focus {
      background: #161d31;
    }
    .flatpickr-input[readonly][data-v-086bceda],
    .flatpickr-input ~ .form-control[readonly][data-v-086bceda],
    .flatpickr-human-friendly[readonly][data-v-086bceda] {
      opacity: 1 !important;
    }
     .flatpickr-input[readonly][data-v-086bceda],  .flatpickr-input ~ .form-control[readonly][data-v-086bceda],  .flatpickr-human-friendly[readonly][data-v-086bceda] {
      background-color: inherit;
    }
     .flatpickr-weekdays[data-v-086bceda] {
      margin-top: 8px;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months[data-v-086bceda] {
      -webkit-appearance: none;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months[data-v-086bceda],
    .flatpickr-current-month .numInputWrapper[data-v-086bceda] {
      font-size: 1.1rem;
      transition: all 0.15s ease-out;
    }
     .flatpickr-current-month .flatpickr-monthDropdown-months[data-v-086bceda],  .flatpickr-current-month .numInputWrapper[data-v-086bceda] {
      border-radius: 4px;
      padding: 2px;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months span[data-v-086bceda],
    .flatpickr-current-month .numInputWrapper span[data-v-086bceda] {
      display: none;
    }
    html[dir=rtl] .flatpickr-calendar .flatpickr-prev-month svg[data-v-086bceda],
    html[dir=rtl] .flatpickr-calendar .flatpickr-next-month svg[data-v-086bceda] {
      transform: rotate(180deg);
    }
    .flatpickr-calendar[data-v-086bceda] {
      width: 280px;
    }
     .flatpickr-calendar[data-v-086bceda] {
      padding: 3px 7px 5px 7px;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-prev-month[data-v-086bceda], .flatpickr-calendar .flatpickr-months .flatpickr-next-month[data-v-086bceda] {
      top: -2px;
    }
    .flatpickr-calendar .flatpickr-months .flatpickr-current-month select[data-v-086bceda], .flatpickr-calendar .flatpickr-months .flatpickr-current-month input[data-v-086bceda] {
      font-weight: 500;
      font-size: 14px;
    }
    .flatpickr-calendar .flatpickr-months span[data-v-086bceda] {
      font-weight: 500;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-weekdays .flatpickr-weekday[data-v-086bceda] {
      font-size: 12px;
      font-weight: 400;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days[data-v-086bceda] {
      width: 266px;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer[data-v-086bceda] {
      width: 266px;
      min-width: 266px;
      max-width: 266px;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day[data-v-086bceda] {
      font-size: 12px;
      max-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange[data-v-086bceda] {
      color: #114A9F;
    }
     .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange[data-v-086bceda] {
      border: none;
      background: rgba(17, 74, 159, 0.12);
      border-color: rgba(17, 74, 159, 0.12);
    }
    [dir=ltr] .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange[data-v-086bceda] {
      box-shadow: -1px 0 0 rgba(17, 74, 159, 0.12), 1px 0 0 rgba(17, 74, 159, 0.12);
    }
    [dir=rtl] .flatpickr-calendar .flatpickr-innerContainer .flatpickr-days .dayContainer .flatpickr-day.inRange[data-v-086bceda] {
      box-shadow: 1px 0 0 rgba(17, 74, 159, 0.12), -1px 0 0 rgba(17, 74, 159, 0.12);
    }
    .v-select[data-v-086bceda] {
      position: relative;
      font-family: inherit;
    }
    .v-select[data-v-086bceda],
    .v-select *[data-v-086bceda] {
      box-sizing: border-box;
    }
    
    /* KeyFrames */
    @-webkit-keyframes vSelectSpinner-ltr-data-v-086bceda {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    }
    @-webkit-keyframes vSelectSpinner-rtl-data-v-086bceda {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(-360deg);
    }
    }
    @keyframes vSelectSpinner-ltr-data-v-086bceda {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    }
    @keyframes vSelectSpinner-rtl-data-v-086bceda {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(-360deg);
    }
    }
    /* Dropdown Default Transition */
    .vs__fade-enter-active[data-v-086bceda],
    .vs__fade-leave-active[data-v-086bceda] {
      pointer-events: none;
      transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .vs__fade-enter[data-v-086bceda],
    .vs__fade-leave-to[data-v-086bceda] {
      opacity: 0;
    }
    
    /** Component States */
    /*
     * Disabled
     *
     * When the component is disabled, all interaction
     * should be prevented. Here we modify the bg color,
     * and change the cursor displayed on the interactive
     * components.
     */
     .vs--disabled .vs__dropdown-toggle[data-v-086bceda],  .vs--disabled .vs__clear[data-v-086bceda],  .vs--disabled .vs__search[data-v-086bceda],  .vs--disabled .vs__selected[data-v-086bceda],  .vs--disabled .vs__open-indicator[data-v-086bceda] {
      cursor: not-allowed;
      background-color: #f8f8f8;
    }
    .v-select[dir=rtl] .vs__actions[data-v-086bceda] {
      padding: 0 3px 0 6px;
    }
    .v-select[dir=rtl] .vs__clear[data-v-086bceda] {
      margin-left: 6px;
      margin-right: 0;
    }
    .v-select[dir=rtl] .vs__deselect[data-v-086bceda] {
      margin-left: 0;
      margin-right: 2px;
    }
    .v-select[dir=rtl] .vs__dropdown-menu[data-v-086bceda] {
      text-align: right;
    }
    
    .vs__dropdown-toggle[data-v-086bceda] {
      appearance: none;
      display: flex;
      white-space: normal;
    }
     .vs__dropdown-toggle[data-v-086bceda] {
      padding: 0 0 4px 0;
      background: none;
      border: 1px solid #D6D9E1;
      border-radius: 0.357rem;
    }
    .vs__selected-options[data-v-086bceda] {
      display: flex;
      flex-basis: 100%;
      flex-grow: 1;
      flex-wrap: wrap;
      position: relative;
    }
     .vs__selected-options[data-v-086bceda] {
      padding: 0 2px;
    }
    .vs__actions[data-v-086bceda] {
      display: flex;
      align-items: center;
    }
    [dir=ltr] .vs__actions[data-v-086bceda] {
      padding: 4px 6px 0 3px;
    }
    [dir=rtl] .vs__actions[data-v-086bceda] {
      padding: 4px 3px 0 6px;
    }
    
    /* Dropdown Toggle States */
     .vs--searchable .vs__dropdown-toggle[data-v-086bceda] {
      cursor: text;
    }
     .vs--unsearchable .vs__dropdown-toggle[data-v-086bceda] {
      cursor: pointer;
    }
     .vs--open .vs__dropdown-toggle[data-v-086bceda] {
      border-bottom-color: transparent;
    }
    [dir=ltr] .vs--open .vs__dropdown-toggle[data-v-086bceda] {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    [dir=rtl] .vs--open .vs__dropdown-toggle[data-v-086bceda] {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    .vs__open-indicator[data-v-086bceda] {
      fill: rgba(60, 60, 60, 0.5);
      transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    }
     .vs__open-indicator[data-v-086bceda] {
      transform: scale(1);
      transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
    }
    [dir=ltr] .vs--open .vs__open-indicator[data-v-086bceda] {
      transform: rotate(180deg) scale(1);
    }
    [dir=rtl] .vs--open .vs__open-indicator[data-v-086bceda] {
      transform: rotate(-180deg) scale(1);
    }
    .vs--loading .vs__open-indicator[data-v-086bceda] {
      opacity: 0;
    }
    
    /* Clear Button */
    .vs__clear[data-v-086bceda] {
      fill: rgba(60, 60, 60, 0.5);
    }
     .vs__clear[data-v-086bceda] {
      padding: 0;
      border: 0;
      background-color: transparent;
      cursor: pointer;
    }
    [dir=ltr] .vs__clear[data-v-086bceda] {
      margin-right: 8px;
    }
    [dir=rtl] .vs__clear[data-v-086bceda] {
      margin-left: 8px;
    }
    
    /* Dropdown Menu */
    .vs__dropdown-menu[data-v-086bceda] {
      display: block;
      box-sizing: border-box;
      position: absolute;
      top: calc(100% - 1px);
      z-index: 1000;
      width: 100%;
      max-height: 350px;
      min-width: 160px;
      overflow-y: auto;
      list-style: none;
    }
     .vs__dropdown-menu[data-v-086bceda] {
      padding: 5px 0;
      margin: 0;
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
      border: 1px solid #D6D9E1;
      border-top-style: none;
      border-radius: 0 0 0.357rem 0.357rem;
      background: #fff;
    }
    [dir=ltr] .vs__dropdown-menu[data-v-086bceda] {
      left: 0;
      text-align: left;
    }
    [dir=rtl] .vs__dropdown-menu[data-v-086bceda] {
      right: 0;
      text-align: right;
    }
     .vs__no-options[data-v-086bceda] {
      text-align: center;
    }
    
    /* List Items */
    .vs__dropdown-option[data-v-086bceda] {
      line-height: 1.42857143;
      /* Normalize line height */
      display: block;
      color: #333;
      /* Overrides most CSS frameworks */
      white-space: nowrap;
    }
     .vs__dropdown-option[data-v-086bceda] {
      padding: 3px 20px;
      clear: both;
    }
     .vs__dropdown-option[data-v-086bceda]:hover {
      cursor: pointer;
    }
    .vs__dropdown-option--highlight[data-v-086bceda] {
      color: #114A9F !important;
    }
     .vs__dropdown-option--highlight[data-v-086bceda] {
      background: rgba(17, 74, 159, 0.12);
    }
    .vs__dropdown-option--disabled[data-v-086bceda] {
      color: rgba(60, 60, 60, 0.5);
    }
     .vs__dropdown-option--disabled[data-v-086bceda] {
      background: inherit;
    }
     .vs__dropdown-option--disabled[data-v-086bceda]:hover {
      cursor: inherit;
    }
    
    /* Selected Tags */
    .vs__selected[data-v-086bceda] {
      display: flex;
      align-items: center;
      color: #333;
      line-height: 1.8;
      z-index: 0;
    }
     .vs__selected[data-v-086bceda] {
      background-color: #114A9F;
      border: 0 solid rgba(60, 60, 60, 0.26);
      border-radius: 0.357rem;
      margin: 4px 2px 0px 2px;
      padding: 0 0.25em;
    }
    .vs__deselect[data-v-086bceda] {
      display: inline-flex;
      appearance: none;
      fill: rgba(60, 60, 60, 0.5);
    }
     .vs__deselect[data-v-086bceda] {
      padding: 0;
      border: 0;
      cursor: pointer;
      background: none;
      text-shadow: 0 1px 0 #fff;
    }
    [dir=ltr] .vs__deselect[data-v-086bceda] {
      margin-left: 4px;
    }
    [dir=rtl] .vs__deselect[data-v-086bceda] {
      margin-right: 4px;
    }
    
    /* States */
     .vs--single .vs__selected[data-v-086bceda] {
      background-color: transparent;
      border-color: transparent;
    }
    .vs--single.vs--open .vs__selected[data-v-086bceda] {
      position: absolute;
      opacity: 0.4;
    }
    .vs--single.vs--searching .vs__selected[data-v-086bceda] {
      display: none;
    }
    
    /* Search Input */
    /**
     * Super weird bug... If this declaration is grouped
     * below, the cancel button will still appear in chrome.
     * If it's up here on it's own, it'll hide it.
     */
    .vs__search[data-v-086bceda]::-webkit-search-cancel-button {
      display: none;
    }
    .vs__search[data-v-086bceda]::-webkit-search-decoration,
    .vs__search[data-v-086bceda]::-webkit-search-results-button,
    .vs__search[data-v-086bceda]::-webkit-search-results-decoration,
    .vs__search[data-v-086bceda]::-ms-clear {
      display: none;
    }
    .vs__search[data-v-086bceda],
    .vs__search[data-v-086bceda]:focus {
      appearance: none;
      line-height: 1.8;
      font-size: 1em;
      outline: none;
      width: 0;
      max-width: 100%;
      flex-grow: 1;
      z-index: 1;
    }
     .vs__search[data-v-086bceda],  .vs__search[data-v-086bceda]:focus {
      border: 1px solid transparent;
      margin: 4px 0 0 0;
      padding: 0 7px;
      background: none;
      box-shadow: none;
    }
    [dir=ltr] .vs__search[data-v-086bceda], [dir=ltr] .vs__search[data-v-086bceda]:focus {
      border-left: none;
    }
    [dir=rtl] .vs__search[data-v-086bceda], [dir=rtl] .vs__search[data-v-086bceda]:focus {
      border-right: none;
    }
    .vs__search[data-v-086bceda]::placeholder {
      color: #424244;
    }
    
    /**
        States
     */
    .vs--unsearchable .vs__search[data-v-086bceda] {
      opacity: 1;
    }
     .vs--unsearchable:not(.vs--disabled) .vs__search[data-v-086bceda]:hover {
      cursor: pointer;
    }
    .vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search[data-v-086bceda] {
      opacity: 0.2;
    }
    
    /* Loading Spinner */
    .vs__spinner[data-v-086bceda] {
      align-self: center;
      opacity: 0;
      font-size: 5px;
      text-indent: -9999em;
      overflow: hidden;
      transition: opacity 0.1s;
    }
     .vs__spinner[data-v-086bceda] {
      border-top: 0.9em solid rgba(100, 100, 100, 0.1);
      border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);
      transform: translateZ(0);
    }
    [dir=ltr] .vs__spinner[data-v-086bceda] {
      border-right: 0.9em solid rgba(100, 100, 100, 0.1);
      border-left: 0.9em solid rgba(60, 60, 60, 0.45);
      animation:  vSelectSpinner-ltr-data-v-086bceda 1.1s infinite linear;
    }
    [dir=rtl] .vs__spinner[data-v-086bceda] {
      border-left: 0.9em solid rgba(100, 100, 100, 0.1);
      border-right: 0.9em solid rgba(60, 60, 60, 0.45);
      animation:  vSelectSpinner-rtl-data-v-086bceda 1.1s infinite linear;
    }
    .vs__spinner[data-v-086bceda],
    .vs__spinner[data-v-086bceda]:after {
      width: 5em;
      height: 5em;
    }
     .vs__spinner[data-v-086bceda],  .vs__spinner[data-v-086bceda]:after {
      border-radius: 50%;
    }
    
    /* Loading Spinner States */
    .vs--loading .vs__spinner[data-v-086bceda] {
      opacity: 1;
    }
    .vs__open-indicator[data-v-086bceda] {
      fill: none;
    }
     .vs__open-indicator[data-v-086bceda] {
      margin-top: 0.15rem;
    }
    .vs__dropdown-toggle[data-v-086bceda] {
      transition: all 0.25s ease-in-out;
    }
     .vs__dropdown-toggle[data-v-086bceda] {
      padding: 0.59px 0 2px 0;
    }
    [dir=ltr] .vs--single .vs__dropdown-toggle[data-v-086bceda] {
      padding-left: 6px;
    }
    [dir=rtl] .vs--single .vs__dropdown-toggle[data-v-086bceda] {
      padding-right: 6px;
    }
    .vs__dropdown-option--disabled[data-v-086bceda] {
      opacity: 0.5;
    }
     .vs__dropdown-option--disabled.vs__dropdown-option--selected[data-v-086bceda] {
      background: #114A9F !important;
    }
    .vs__dropdown-option[data-v-086bceda] {
      color: #424244;
    }
     .vs__dropdown-option[data-v-086bceda],  .vs__no-options[data-v-086bceda] {
      padding: 7px 20px;
    }
    .vs__dropdown-option--selected[data-v-086bceda] {
      background-color: #114A9F;
      color: #fff;
      position: relative;
    }
    .vs__dropdown-option--selected[data-v-086bceda]::after {
      content: "";
      height: 1.1rem;
      width: 1.1rem;
      display: inline-block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 1.1rem;
    }
    [dir=rtl] .vs__dropdown-option--selected[data-v-086bceda]::after {
      left: 20px;
      right: unset;
    }
    .vs__dropdown-option--selected.vs__dropdown-option--highlight[data-v-086bceda] {
      color: #fff !important;
      background-color: #114A9F !important;
    }
    .vs__clear svg[data-v-086bceda] {
      color: #424244;
    }
    .vs__selected[data-v-086bceda] {
      color: #fff;
    }
    .v-select.vs--single .vs__selected[data-v-086bceda] {
      color: #424244;
      transition: transform 0.2s ease;
    }
     .v-select.vs--single .vs__selected[data-v-086bceda] {
      margin-top: 5px;
    }
    [dir=ltr] .v-select.vs--single .vs__selected input[data-v-086bceda] {
      padding-left: 0;
    }
    [dir=rtl] .v-select.vs--single .vs__selected input[data-v-086bceda] {
      padding-right: 0;
    }
    [dir=ltr] .vs--single.vs--open .vs__selected[data-v-086bceda] {
      transform: translateX(5px);
    }
    [dir=rtl] .vs--single.vs--open .vs__selected[data-v-086bceda] {
      transform: translateX(-5px);
    }
    .vs__selected .vs__deselect[data-v-086bceda] {
      color: inherit;
    }
    .v-select:not(.vs--single) .vs__selected[data-v-086bceda] {
      font-size: 0.9rem;
    }
     .v-select:not(.vs--single) .vs__selected[data-v-086bceda] {
      border-radius: 3px;
      padding: 0 0.6em;
    }
    [dir=ltr] .v-select:not(.vs--single) .vs__selected[data-v-086bceda] {
      margin: 5px 2px 2px 5px;
    }
    [dir=rtl] .v-select:not(.vs--single) .vs__selected[data-v-086bceda] {
      margin: 5px 5px 2px 2px;
    }
    .v-select:not(.vs--single) .vs__deselect svg[data-v-086bceda] {
      vertical-align: text-top;
    }
     .v-select:not(.vs--single) .vs__deselect svg[data-v-086bceda] {
      transform: scale(0.8);
    }
    .vs__dropdown-menu[data-v-086bceda] {
      top: calc(100% + 0.5rem);
    }
     .vs__dropdown-menu[data-v-086bceda] {
      border: none;
      border-radius: 6px;
      padding: 0;
    }
     .vs--open .vs__dropdown-toggle[data-v-086bceda] {
      border-color: #114A9F;
      border-bottom-color: #114A9F;
      box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    }
    [dir=ltr] .vs--open .vs__dropdown-toggle[data-v-086bceda] {
      border-bottom-left-radius: 0.357rem;
      border-bottom-right-radius: 0.357rem;
    }
    [dir=rtl] .vs--open .vs__dropdown-toggle[data-v-086bceda] {
      border-bottom-right-radius: 0.357rem;
      border-bottom-left-radius: 0.357rem;
    }
    .select-size-lg .vs__selected[data-v-086bceda] {
      font-size: 1rem !important;
    }
     .select-size-lg.vs--single.vs--open .vs__selected[data-v-086bceda] {
      margin-top: 6px;
    }
    .select-size-lg .vs__dropdown-toggle[data-v-086bceda],
    .select-size-lg .vs__selected[data-v-086bceda] {
      font-size: 1.25rem;
    }
     .select-size-lg .vs__dropdown-toggle[data-v-086bceda] {
      padding: 5px;
    }
     .select-size-lg .vs__dropdown-toggle input[data-v-086bceda] {
      margin-top: 0;
    }
    .select-size-lg .vs__deselect svg[data-v-086bceda] {
      vertical-align: middle !important;
    }
     .select-size-lg .vs__deselect svg[data-v-086bceda] {
      transform: scale(1) !important;
    }
     .select-size-sm .vs__dropdown-toggle[data-v-086bceda] {
      padding-bottom: 0;
      padding: 1px;
    }
     .select-size-sm.vs--single .vs__dropdown-toggle[data-v-086bceda] {
      padding: 2px;
    }
    .select-size-sm .vs__dropdown-toggle[data-v-086bceda],
    .select-size-sm .vs__selected[data-v-086bceda] {
      font-size: 0.9rem;
    }
     .select-size-sm .vs__actions[data-v-086bceda] {
      padding-top: 2px;
      padding-bottom: 2px;
    }
    .select-size-sm .vs__deselect svg[data-v-086bceda] {
      vertical-align: middle !important;
    }
     .select-size-sm .vs__search[data-v-086bceda] {
      margin-top: 0;
    }
    .select-size-sm.v-select .vs__selected[data-v-086bceda] {
      font-size: 0.75rem;
    }
     .select-size-sm.v-select .vs__selected[data-v-086bceda] {
      padding: 0 0.3rem;
    }
     .select-size-sm.v-select:not(.vs--single) .vs__selected[data-v-086bceda] {
      margin: 4px 5px;
    }
     .select-size-sm.v-select.vs--single .vs__selected[data-v-086bceda] {
      margin-top: 1px;
    }
     .select-size-sm.vs--single.vs--open .vs__selected[data-v-086bceda] {
      margin-top: 4px;
    }
    .dark-layout .vs__dropdown-toggle[data-v-086bceda] {
      color: #b4b7bd;
    }
     .dark-layout .vs__dropdown-toggle[data-v-086bceda] {
      background: #283046;
      border-color: #404656;
    }
    .dark-layout .vs__selected-options input[data-v-086bceda] {
      color: #b4b7bd;
    }
    .dark-layout .vs__selected-options input[data-v-086bceda]::placeholder {
      color: #676d7d;
    }
    .dark-layout .vs__actions svg[data-v-086bceda] {
      fill: #404656;
    }
     .dark-layout .vs__dropdown-menu[data-v-086bceda] {
      background: #283046;
    }
    .dark-layout .vs__dropdown-menu li[data-v-086bceda] {
      color: #b4b7bd;
    }
    .dark-layout .v-select:not(.vs--single) .vs__selected[data-v-086bceda] {
      color: #114A9F;
    }
     .dark-layout .v-select:not(.vs--single) .vs__selected[data-v-086bceda] {
      background-color: rgba(17, 74, 159, 0.12);
    }
    .dark-layout .v-select.vs--single .vs__selected[data-v-086bceda] {
      color: #b4b7bd !important;
    }
    .dark-layout .vs--disabled .vs__dropdown-toggle[data-v-086bceda],
    .dark-layout .vs--disabled .vs__clear[data-v-086bceda],
    .dark-layout .vs--disabled .vs__search[data-v-086bceda],
    .dark-layout .vs--disabled .vs__selected[data-v-086bceda],
    .dark-layout .vs--disabled .vs__open-indicator[data-v-086bceda] {
      opacity: 0.5;
      color: inherit !important;
    }
     .dark-layout .vs--disabled .vs__dropdown-toggle[data-v-086bceda],  .dark-layout .vs--disabled .vs__clear[data-v-086bceda],  .dark-layout .vs--disabled .vs__search[data-v-086bceda],  .dark-layout .vs--disabled .vs__selected[data-v-086bceda],  .dark-layout .vs--disabled .vs__open-indicator[data-v-086bceda] {
      background-color: #283046;
    }
    .vs--disabled .vs__selected[data-v-086bceda] {
      color: inherit !important;
    }
    .vs--disabled .vs__selected button[data-v-086bceda] {
      display: none;
    }
    #d-table-add-booking .b-table-sticky-header[data-v-086bceda] {
      max-height: calc(95vh - 211px) !important;
    }
    #d-table-add-booking .b-table-sticky-column[data-v-086bceda] {
      z-index: 99;
    }
     #d-table-add-booking .b-table-sticky-column[data-v-086bceda] {
      background: #fff;
    }
    .d-th[data-v-086bceda] {
      min-width: 200px;
    }
    .d-th[data-v-086bceda]:first-child {
      min-width: 100px !important;
      position: sticky;
      z-index: 999 !important;
    }
    [dir=ltr] .d-th[data-v-086bceda]:first-child {
      left: 0;
    }
    [dir=rtl] .d-th[data-v-086bceda]:first-child {
      right: 0;
    }
    .hover-me[data-v-086bceda] {
      width: 100%;
      position: relative;
      height: 36px;
    }
     .hover-me[data-v-086bceda] {
      text-align: center;
    }
    .hover-me .d-select-remaning[data-v-086bceda] {
      position: absolute;
      top: 9px;
      bottom: 0;
    }
    [dir=ltr] .hover-me .d-select-remaning[data-v-086bceda] {
      right: 0;
      left: 0;
    }
    [dir=rtl] .hover-me .d-select-remaning[data-v-086bceda] {
      left: 0;
      right: 0;
    }
    .hover-me .d-select-tee[data-v-086bceda] {
      opacity: 0;
      position: absolute;
      top: 9px;
      bottom: 0;
    }
    [dir=ltr] .hover-me .d-select-tee[data-v-086bceda] {
      right: 0;
      left: 0;
    }
    [dir=rtl] .hover-me .d-select-tee[data-v-086bceda] {
      left: 0;
      right: 0;
    }
    .hover-me:hover .d-select-remaning[data-v-086bceda] {
      opacity: 0;
    }
    .hover-me:hover .d-select-tee[data-v-086bceda] {
      opacity: 1;
    }
    .select-time[data-v-086bceda]  .b-sidebar {
      width: 350px;
    }
    .select-time[data-v-086bceda]  .vs__selected-options {
      max-width: 100%;
      overflow: hidden;
    }
    .select-time[data-v-086bceda]  .vs__selected-options .vs__selected {
      overflow: hidden;
      max-width: 100%;
      white-space: nowrap;
    }
    .select-wrapper[data-v-086bceda] {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    [dir=ltr] .select-wrapper .select-block[data-v-086bceda] {
      margin-right: 12px;
    }
    [dir=rtl] .select-wrapper .select-block[data-v-086bceda] {
      margin-left: 12px;
    }
    .color-danger[data-v-086bceda] {
      color: #EA5455;
    }
    .table-max-height[data-v-086bceda] {
      height: calc(100%);
    }
     .margin-bottom-12[data-v-086bceda] {
      margin-bottom: 12px;
    }
     .select-section[data-v-086bceda] {
      background-color: white;
      padding: 18px;
    }
     .bg-step-block[data-v-086bceda] {
      background-color: white;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
    .bg-step-block .text-block[data-v-086bceda] {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
     .bg-step-block .text-block[data-v-086bceda] {
      padding: 18px 1rem;
    }
     .blocked-background-color[data-v-086bceda] {
      background-color: rgba(193, 193, 193, 0.12);
    }
     .banned-background-color[data-v-086bceda] {
      background-color: rgba(234, 84, 85, 0.12);
    }
     .selected-background-color[data-v-086bceda] {
      background-color: rgba(17, 74, 159, 0.04);
    }
    .header-table[data-v-086bceda] {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 1px;
      text-transform: uppercase;
      white-space: nowrap;
    }
     .header-table[data-v-086bceda] {
      text-align: center;
    }
    [data-v-086bceda] .b-sidebar {
      width: 350px;
    }
    [data-v-086bceda] .vs__selected-options {
      max-width: 100%;
      overflow: hidden;
    }
    [data-v-086bceda] .vs__selected-options .vs__selected {
      overflow: hidden;
      max-width: 100%;
      white-space: nowrap;
    }
    [data-v-086bceda] .b-table-sticky-header {
      overflow-y: auto;
      max-height: 100%;
    }
    [data-v-086bceda] .input-group {
      flex-wrap: nowrap;
    }
    [data-v-086bceda] .btn-group > .btn {
      flex: unset;
      width: 100%;
    }
    .text-success[data-v-086bceda] {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      color: #29B869;
    }
    #sidebar-add-booking {
      width: 980px !important;
    }
    #sidebar-add-booking .custom-body-sidebar .booking-content {
      display: flex;
    }
     #sidebar-add-booking .custom-body-sidebar .booking-content {
      margin: 0 -9px;
    }
    #sidebar-add-booking .custom-body-sidebar .booking-content .col-left {
      flex-basis: 550px;
      min-width: 550px;
      max-width: 550px;
    }
     #sidebar-add-booking .custom-body-sidebar .booking-content .col-left {
      margin: 0 9px;
      background: #FFFFFF;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
    }
     #sidebar-add-booking .custom-body-sidebar .booking-content .col-left .search-form {
      padding: 18px;
    }
    #sidebar-add-booking .custom-body-sidebar .booking-content .col-left .b-table-sticky-header {
      max-height: calc(100vh - 285px) !important;
    }
    #sidebar-add-booking .custom-body-sidebar .booking-content .col-right {
      flex-grow: 1;
      min-width: 376px;
    }
     #sidebar-add-booking .custom-body-sidebar .booking-content .col-right {
      background: #FFFFFF;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      margin: 0 9px;
    }
    #sidebar-add-booking .custom-body-sidebar .booking-content .col-right table thead .header-table-custom th {
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
     #sidebar-add-booking .custom-body-sidebar .booking-content .col-right table thead .header-table-custom th {
      background: #F2F3F7;
      border-bottom: unset;
      padding: 10px;
    }
    [dir=ltr] #sidebar-add-booking .custom-body-sidebar .booking-content .col-right table thead .header-table-custom th:first-child {
      border-top-left-radius: 6px;
    }
    [dir=rtl] #sidebar-add-booking .custom-body-sidebar .booking-content .col-right table thead .header-table-custom th:first-child {
      border-top-right-radius: 6px;
    }
    [dir=ltr] #sidebar-add-booking .custom-body-sidebar .booking-content .col-right table thead .header-table-custom th:last-child {
      border-top-right-radius: 6px;
    }
    [dir=rtl] #sidebar-add-booking .custom-body-sidebar .booking-content .col-right table thead .header-table-custom th:last-child {
      border-top-left-radius: 6px;
    }
    #sidebar-add-booking .custom-body-sidebar .booking-content .col-right table tbody .header-table-body-custom span {
      text-transform: uppercase;
    }
    #sidebar-add-booking .custom-body-sidebar .booking-content .col-right .into-money {
      font-weight: 500;
      font-size: 15px;
      color: #5D5F65;
    }
     #sidebar-add-booking .custom-body-sidebar .booking-content .col-right .into-money {
      border-top: 1px solid #E9EBF1;
      padding: 16px 28px;
    }
    [dir=ltr] #sidebar-add-booking .custom-body-sidebar .booking-content .col-right .into-money {
      text-align: right;
    }
    [dir=rtl] #sidebar-add-booking .custom-body-sidebar .booking-content .col-right .into-money {
      text-align: left;
    }
    #sidebar-checkout .content-wrapper {
      display: flex;
    } #sidebar-checkout .content-wrapper {
      background: #F8F8F8;
    }
    #sidebar-checkout .content-wrapper .col-left {
      min-width: 756px;
      width: 756px;
    }
     #sidebar-checkout .content-wrapper .col-left {
      padding: 18px;
    }
    [dir=ltr] #sidebar-checkout .content-wrapper .col-left {
      border-right: 1px solid #ebebeb;
    }
    [dir=rtl] #sidebar-checkout .content-wrapper .col-left {
      border-left: 1px solid #ebebeb;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-header .loading-btn {
      font-size: 12px;
      color: #9c9ea4;
      user-select: none;
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-header .loading-btn {
      border: 1px solid #9c9ea4;
      border-radius: 4px;
      padding: 0 10px;
      cursor: pointer;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-header .loading-btn svg {
      width: 14px;
      height: 14px;
    }
    [dir=ltr] #sidebar-checkout .content-wrapper .col-left .left-side-header .loading-btn svg {
      margin-right: 8px;
    }
    [dir=rtl] #sidebar-checkout .content-wrapper .col-left .left-side-header .loading-btn svg {
      margin-left: 8px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-header .loading-btn.checkout {
      color: #885bea;
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-header .loading-btn.checkout {
      border-color: #885bea;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .vertival-column {
      position: absolute;
      width: 4px;
      height: 17px;
    }
    [dir=ltr] #sidebar-checkout .content-wrapper .col-left .left-side-body .vertival-column {
      left: 0px;
      border-radius: 0px 2px 2px 0px;
    }
    [dir=rtl] #sidebar-checkout .content-wrapper .col-left .left-side-body .vertival-column {
      right: 0px;
      border-radius: 2px 0px 0px 2px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-nav {
      height: 40px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-nav .nav-item:not(:first-child) {
      font-size: 12px;
      font-weight: 500;
      color: #5D5F65;
    }
    [dir=ltr] #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-nav .nav-item:not(:first-child) {
      margin-left: 4em;
    }
    [dir=rtl] #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-nav .nav-item:not(:first-child) {
      margin-right: 4em;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-nav .nav-item:first-child {
      font-size: 12px;
      font-weight: 500;
      color: #114A9F;
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-nav .nav-item:first-child {
      border: 1px solid #114A9F;
      padding: 4px 16px;
      border-radius: 4px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks {
      height: calc(100vh - 170px);
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks {
      margin-top: 8px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item {
      height: 320px;
      width: 350px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item {
      background: #fff;
      border-radius: 6px;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
      margin-bottom: 18px;
    }
    [dir=ltr] #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item {
      float: left;
    }
    [dir=rtl] #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item {
      float: right;
    }
    [dir=ltr] #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item:nth-child(2n) {
      margin-left: 18px;
    }
    [dir=rtl] #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item:nth-child(2n) {
      margin-right: 18px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 54px;
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header {
      padding: 0 10px;
      border-bottom: 1px solid #e8eaee;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .name {
      font-size: 12px;
      font-weight: 400;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .name .code {
      color: #FDB913;
      font-size: 12px;
      font-weight: 400;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .status {
      font-size: 12px;
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .status {
      margin-top: 2px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .status svg {
      height: 12px;
    }
    [dir=ltr] #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .status svg {
      margin-right: 6px;
    }
    [dir=rtl] #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .status svg {
      margin-left: 6px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .status .dot {
      height: 10px;
      width: 10px;
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .status .dot {
      border-radius: 50%;
    }
    [dir=ltr] #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .status .dot {
      margin-right: 6px;
    }
    [dir=rtl] #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .status .dot {
      margin-left: 6px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .done-btn {
      color: #FD87E3;
      font-size: 12px;
      font-weight: 500;
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__header .done-btn {
      background: rgba(253, 135, 227, 0.12);
      border-radius: 4px;
      padding: 3px 6px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__body {
      flex: 1;
      height: 232px;
      overflow: hidden;
      user-select: none;
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__body {
      padding: 0 10px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__body .sub span {
      color: #5D5F65;
      font-size: 12px;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__body:hover {
      overflow: scroll;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      font-weight: 500;
      height: 34px;
    }
     #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks .block-item__footer {
      padding: 0 10px;
      border-top: 1px solid #e8eaee;
    }
    #sidebar-checkout .content-wrapper .col-left .left-side-body .left-side-blocks:hover {
      overflow: scroll;
      overflow-x: hidden;
    }
    #sidebar-checkout .content-wrapper .col-right {
      flex-grow: 1;
    }
     #sidebar-checkout .content-wrapper .col-right .top-right-side {
      background: #fff;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .header {
      height: 36px;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      align-items: center;
    }
     #sidebar-checkout .content-wrapper .col-right .top-right-side .header {
      background: #F2F3F7;
      padding: 0 12px;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .header .service {
      width: 40%;
      display: flex;
      align-items: center;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .header .amount {
      width: 20%;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .header .total {
      width: 40%;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .categories-wrapper {
      height: calc(30vh - 70px);
      overflow: hidden;
    }
     #sidebar-checkout .content-wrapper .col-right .top-right-side .categories-wrapper {
      border-bottom: 1px solid #ebebeb;
    }
     #sidebar-checkout .content-wrapper .col-right .top-right-side .categories-wrapper .category {
      padding: 0 12px;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .categories-wrapper .category .item-service {
      display: flex;
      align-items: center;
    }
     #sidebar-checkout .content-wrapper .col-right .top-right-side .categories-wrapper .category .item-service {
      margin-top: 12px;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .categories-wrapper .category .item-service .service {
      width: 40%;
      display: flex;
      align-items: center;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .categories-wrapper .category .item-service .amount {
      width: 20%;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .categories-wrapper .category .item-service .total {
      width: 40%;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .payment {
      display: flex;
      font-weight: 500;
    }
     #sidebar-checkout .content-wrapper .col-right .top-right-side .payment {
      margin-top: 5px;
      padding: 0 12px;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .payment .service {
      width: 40%;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .payment .amount {
      width: 20%;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .payment .total {
      width: 40%;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .payment-done {
      display: flex;
      font-weight: 500;
    }
     #sidebar-checkout .content-wrapper .col-right .top-right-side .payment-done {
      margin-top: 5px;
      padding: 0 12px;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .payment-done .service {
      width: 40%;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .payment-done .amount {
      width: 20%;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .payment-done .total {
      width: 40%;
    }
     #sidebar-checkout .content-wrapper .col-right .top-right-side .payment-must {
      padding: 0 12px;
    }
     #sidebar-checkout .content-wrapper .col-right .top-right-side .payment-person {
      padding: 0 12px;
    }
    #sidebar-checkout .content-wrapper .col-right .top-right-side .payment-person svg {
      color: #114A9F;
      width: 14px;
      height: 14px;
    }
     #sidebar-checkout .content-wrapper .col-right .top-right-side .payment-person .input-group-merge {
      margin-top: 6px;
    }
     #sidebar-checkout .content-wrapper .col-right .bottom-right-side {
      background: #fff;
      margin-top: 12px;
      padding: 12px;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .heading {
      font-size: 14px;
      font-weight: 500;
      color: #424242;
    }
     #sidebar-checkout .content-wrapper .col-right .bottom-right-side .heading {
      margin-bottom: 8px;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header,
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail {
      height: 36px;
      display: flex;
      align-items: center;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header.deleted,
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail.deleted {
      text-decoration: line-through;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header .person,
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail .person {
      width: 40%;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header .total,
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail .total {
      width: 20%;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header .arest,
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail .arest {
      width: 30%;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header .arest strong,
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail .arest strong {
      display: none;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header .action,
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail .action {
      width: 10%;
    }
     #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header .action button,  #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail .action button {
      padding: 0 !important;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header .action button::after,
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail .action button::after {
      display: none !important;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header:not(.deleted):hover .arest strong,
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail:not(.deleted):hover .arest strong {
      display: block;
    }
     #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header:not(.deleted):hover .arest strong,  #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail:not(.deleted):hover .arest strong {
      cursor: pointer;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header:not(.deleted):hover .arest span,
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .item-detail:not(.deleted):hover .arest span {
      display: none;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .header {
      height: 25px;
    }
    #sidebar-checkout .content-wrapper .col-right .bottom-right-side .list-invoice .list-item {
      height: calc(100vh - 490px);
    }
     .custom-control.custom-checkbox {
      margin-top: -4px;
    }
    [dir=ltr] .custom-control.custom-checkbox {
      margin-right: 8px;
    }
    [dir=rtl] .custom-control.custom-checkbox {
      margin-left: 8px;
    }
    ._button-no-bg {
      color: #114A9F;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
    }
     ._button-no-bg {
      border-radius: 5px;
      border: 1px solid #114A9F;
      padding: 5px 10px;
      cursor: pointer;
      background: #fff;
    }
     ::v-deep .vs__dropdown-toggle {
      background: #fff;
    }
    ::v-deep ::-webkit-input-placeholder {
      color: #969393;
    }
     ::v-deep th {
      border: 20px;
      background-color: red !important;
    }
     ::v-deep table th {
      padding: 0 !important;
    }
    #modal-payment-for-distribution .list-paid {
      height: calc( 100vh - 515px);
    }
    #modal-payment-for-distribution .list-paid .item-detail {
      line-height: 18px;
    }
     #modal-payment-for-distribution .list-paid .item-detail {
      padding: 8px 1.5rem;
    }
     #modal-payment-for-distribution .list-paid .item-detail:hover {
      background: rgba(193, 193, 193, 0.12);
    }
    #modal-payment-for-distribution .list-paid .item-detail .payment-method {
      display: flex;
      justify-content: space-between;
      font-weight: 500;
    }
    #modal-payment-for-distribution .list-paid .item-detail .note {
      display: flex;
      justify-content: space-between;
    }
    #modal-payment-for-distribution .header {
      display: flex;
      justify-content: space-between;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
     #modal-payment-for-distribution .header {
      padding-bottom: 1rem;
    }
    #modal-payment-for-distribution .header .header-amount {
      color: #114A9F;
    }
    #modal-payment-for-distribution .footer {
      display: flex;
      justify-content: space-between;
    }
     #modal-payment-for-distribution .footer {
      padding: 1.5rem;
      border-top: 1px solid #D6D9E1;
    }
    #modal-payment-for-distribution .footer .footer-left {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
    #modal-payment-for-distribution .footer .footer-right {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #EA5455;
    }
     #modal-payment-for-distribution .paymentType {
      padding: 10px 20px;
    }
    #modal-payment-for-distribution .paymentType-header {
      display: flex;
      font-weight: bold;
    }
     #modal-payment-for-distribution .paymentType-header-item {
      padding: 5px 0;
    }
     #modal-payment-for-distribution .paymentType-select-item {
      padding: 5px 0;
      cursor: pointer;
    }
    #modal-payment-for-distribution .paymentType-select-method:hover {
      color: #114a9f;
    }
     #modal-payment-for-distribution .paymentType-select-method:hover {
      background-color: #e2e9f3;
      cursor: pointer;
    }
    #modal-payment-for-distribution .input-payment-method {
      white-space: nowrap;
      display: flex;
      flex-direction: column;
      vertical-align: middle;
    }
     #modal-payment-for-distribution .input-payment-method {
      cursor: pointer;
    }
    #modal-payment-for-distribution .dropdown-payment-method {
      display: block;
      width: auto;
      min-width: 520px;
      z-index: 15;
      list-style: none;
      position: absolute;
      top: 49px;
    }
     #modal-payment-for-distribution .dropdown-payment-method {
      border: 1px solid #efefef;
      background: white;
      margin: 0;
      padding: 10px 0px;
      border-radius: 0px 0px 3px 3px;
      box-shadow: rgba(0, 0, 0, 0.18) 0px 6px 12px 0px;
    }
    [dir=ltr] #modal-payment-for-distribution .dropdown-payment-method {
      left: calc(50% + 142px);
      transform: translateX(-50%);
    }
    [dir=rtl] #modal-payment-for-distribution .dropdown-payment-method {
      right: calc(50% + 142px);
      transform: translateX(50%);
    }
    #modal-payment-for-distribution .money-exchange {
      color: #114A9F;
    }
    #modal-payment-for-distribution .input-debit-account {
      vertical-align: middle;
    }
    #modal-payment-for-distribution .show-debit-account, #modal-payment-for-distribution .note-payment-display {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
     #modal-payment-for-distribution .ezGolf-icon-external-link {
      cursor: pointer;
    }
    .table-distribution {
      max-height: 300px;
    }
    #tee-sheet .quick-action {
      background-color: #FFFFFF;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border-radius: 6px 6px 0 0;
      padding: 24px;
    }
    #tee-sheet .quick-action .select-wrapper {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    [dir=ltr] #tee-sheet .quick-action .select-wrapper .select-block {
      margin-right: 12px;
    }
    [dir=rtl] #tee-sheet .quick-action .select-wrapper .select-block {
      margin-left: 12px;
    }
    #tee-sheet .quick-action .select-wrapper .select-block .input-search {
      min-width: 250px;
    }
    #tee-sheet .quick-action .info-wrapper {
      align-self: center;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    #tee-sheet .quick-action .info-wrapper .info-block {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    [dir=ltr] #tee-sheet .quick-action .info-wrapper .info-block {
      margin-right: 26px;
    }
    [dir=rtl] #tee-sheet .quick-action .info-wrapper .info-block {
      margin-left: 26px;
    }
    #tee-sheet .quick-action .info-wrapper .info-block .value {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
    }
    [dir=ltr] #tee-sheet .quick-action .info-wrapper .info-block .value {
      margin-right: 8px;
    }
    [dir=rtl] #tee-sheet .quick-action .info-wrapper .info-block .value {
      margin-left: 8px;
    }
    #tee-sheet .quick-action .info-wrapper .info-block .block-number {
      color: white;
    }
     #tee-sheet .quick-action .info-wrapper .info-block .block-number {
      padding: 1px 7px;
      border-radius: 4px;
    }
     #tee-sheet .quick-action .info-wrapper .info-block .btn-custom {
      padding: 7px;
    }
    #tee-sheet .tee-sheet-list {
      height: calc( 100vh - 200px);
    }
     #tee-sheet .tee-sheet-list {
      background-color: #fff;
    }
     #tee-sheet .tee-sheet-list table td {
      padding: 0;
    }
     #tee-sheet .tee-sheet-list table tr.fix-hour {
      background: rgba(193, 193, 193, 0.12);
      box-shadow: inset 0px 1px 0px #DADCD9;
    }
    #tee-sheet .tee-sheet-list table tr td.tee-name {
      text-transform: capitalize;
    }
     #tee-sheet .tee-sheet-list table tr td.tee-name {
      text-align: center;
      padding: 0 10px;
    }
    #tee-sheet .tee-sheet-list table tr td.hover-tee-block {
      opacity: 0;
      min-width: 300px;
    }
     #tee-sheet .tee-sheet-list table tr td.hover-tee-block {
      text-align: center;
      padding: 10px;
      cursor: pointer;
    }
    #tee-sheet .tee-sheet-list table tr td.hover-tee-block:hover {
      opacity: 1;
    }
     #tee-sheet .tee-sheet-list table tr td.hover-tee-block:hover {
      background: rgba(156, 158, 164, 0.12);
    }
    #tee-sheet .tee-sheet-list table tr td.hover-tee-block.blocked {
      opacity: 1;
    }
     #tee-sheet .tee-sheet-list table tr td.hover-tee-block.blocked {
      background: rgba(156, 158, 164, 0.12);
    }
     #tee-sheet .tee-sheet-list table tr td.hover-tee-block.blocked:hover {
      cursor: not-allowed;
    }
    #tee-sheet .tee-sheet-list table tr td.user-info-section {
      position: relative;
    }
     #tee-sheet .tee-sheet-list table tr td.user-info-section .media {
      padding: 8px;
      cursor: pointer;
    }
     #tee-sheet .tee-sheet-list table tr td.user-info-section .media.BOOKED {
      background: rgba(0, 207, 232, 0.12);
    }
     #tee-sheet .tee-sheet-list table tr td.user-info-section .media.CHECK_IN {
      background: rgba(234, 84, 85, 0.12);
    }
     #tee-sheet .tee-sheet-list table tr td.user-info-section .media.CANCEL {
      background: rgba(136, 91, 234, 0.12);
    }
     #tee-sheet .tee-sheet-list table tr td.user-info-section .media.CHECK_OUT {
      background: rgba(136, 91, 234, 0.12);
    }
     #tee-sheet .tee-sheet-list table tr td.user-info-section .media.CANCELLED {
      background: rgba(161, 164, 156, 0.12);
    }
     #tee-sheet .tee-sheet-list table tr td.user-info-section .media.NO_SHOW {
      background: rgba(161, 164, 156, 0.12);
    }
    #tee-sheet .tee-sheet-list table tr td.user-info-section .media .meta {
      display: flex;
      justify-content: space-between;
    }
    #tee-sheet .tee-sheet-list table tr td.user-info-section .media .meta .group-name {
      position: absolute;
      top: 0;
      color: #fff;
      max-width: 100px;
    }
     #tee-sheet .tee-sheet-list table tr td.user-info-section .media .meta .group-name {
      background-color: #9C9EA4;
      padding: 2px 8px;
    }
   #tee-sheet .tee-sheet-list table tr td.user-info-section .media .meta .group-name {
      right: 0;
      border-radius: 0 0 0 6px;
    }
    #tee-sheet .tee-sheet-list table tr td.user-info-section .media .meta .group-name {
      left: 0;
      border-radius: 0 0 6px 0;
    }
    #tee-sheet .tee-sheet-list table tr td.user-info-section .media .meta .bdc {
      color: #FDB913;
      font-weight: 500;
    }
     #tee-sheet .tee-sheet-list table th .tee-time {
      text-align: center;
    }
    .table-caddy tbody td {
      border-right: 1px solid #E9EBF1;
    }
    .table-caddy tbody td {
        padding: 7px 20px 7px 20px;
        border-top: 1px solid #E9EBF1;
    }
    .table-caddy thead td:nth-child(1) {
      width: 100px;
    }
    .table-caddy thead td {
        border-right: 1px solid #E9EBF1;
    }
    .table-caddy thead td {
        padding: 7px 20px 7px 20px;
        border-top: 1px solid #E9EBF1;
    }
    #caddy-carlendar .icon-date-position {
      position: absolute;
      top: 9px;
      right: 22px;
   }
    #caddy-carlendar td.active.in-range.start-date.end-date {
      background: #114a9f !important;
      border-radius: 50%;
   }
    .add-new-group {
      display: flex;
      padding: 0 12px 0 20px;
      justify-content: space-between;
      align-items: center;
   }
    .add-new-group fieldset {
      width: 135px;
      margin-bottom: 0;
   }
    .add-new-group .btn {
      padding: 9px 8px;
   }
    .d-total-info {
      align-items: center;
      font-weight: bold;
   }
    .d-total-info .s-active-serve {
      border: 2px solid #f8afaf;
      color: #f8afaf !important;
      padding: 5px 10px;
      border-radius: 8px;
   }
    .d-total-info .s-active-all {
      border: 2px solid #114a9f;
      color: #114a9f !important;
      padding: 5px 10px;
      border-radius: 8px;
   }
    .d-total-info .s-active-using {
      border: 2px solid #00cfe8;
      color: #00cfe8 !important;
      padding: 5px 10px;
      border-radius: 8px;
   }
    .d-total-info .s-active-ready {
      border: 2px solid #29b869;
      color: #29b869 !important;
      padding: 5px 10px;
      border-radius: 8px;
   }
    .d-total-info .d-status-filter-all:hover {
      border: 2px solid #114a9f;
      color: #114a9f !important;
      padding: 5px 10px;
      border-radius: 8px;
      cursor: pointer;
   }
    .d-total-info .d-status-filter-ready:hover {
      border: 2px solid #29b869;
      color: #29b869 !important;
      padding: 5px 10px;
      border-radius: 8px;
      cursor: pointer;
   }
    .d-total-info .d-status-filter-using:hover {
      border: 2px solid #00cfe8;
      color: #00cfe8 !important;
      padding: 5px 10px;
      border-radius: 8px;
      cursor: pointer;
   }
    .d-total-info .d-status-filter-serve:hover {
      border: 2px solid #f8afaf;
      color: #f8afaf !important;
      padding: 5px 10px;
      border-radius: 8px;
      cursor: pointer;
   }
    .d-total-info .badge {
      border-radius: 4px;
      padding: 4px 7px;
      color: #fff;
      margin-left: 10px;
   }
    .d-total-info .ml-26 {
      margin-left: 26px;
   }
    .d-total-info .all {
      color: #114a9f;
   }
    .d-total-info .ready {
      color: #29b869;
   }
    .d-total-info .using {
      color: #00cfe8;
   }
    .d-total-info .serve {
      color: #f8afaf;
   }
    .table-caddy .dropdown-toggle::after {
      display: none;
   }
    .table-caddy .badge {
      border-radius: 4px;
      padding: 4px 7px;
      margin-right: 10px;
   }
    .table-caddy .ml-26 {
      margin-left: 26px;
   }
    .table-caddy .all {
      background: #114a9f;
   }
    .table-caddy .status-A {
      background: rgba(41, 184, 105, 0.12);
      color: #29b869;
   }
    .table-caddy .status-B {
      background: rgba(0, 207, 232, 0.12);
      color: #00cfe8;
   }
    .table-caddy .status-W {
      background: rgba(248, 175, 175, 0.12);
      color: #f8afaf;
   }
    .table-caddy tr:hover {
      color: #212529;
      background-color: rgba(0, 0, 0, .075);
   }
    .table-caddy tr:hover .td-date {
      background-color: transparent !important;
   }
    .table-caddy thead {
      background: #f2f3f7;
      text-transform: uppercase;
      font-weight: 500;
   }
    .table-caddy thead td {
      padding: 7px 20px 7px 20px;
      border-right: 1px solid #e9ebf1;
      border-top: 1px solid #e9ebf1;
   }
    .table-caddy thead td:last-child {
      border-right: 0;
   }
    .table-caddy thead td:nth-child(1) {
      width: 100px;
   }
    .table-caddy thead td:nth-child(2) {
      width: 130px;
   }
    .table-caddy thead td:nth-child(3) {
      width: 170px;
   }
    .table-caddy thead td:nth-child(5) {
      width: 50px;
   }
    .table-caddy tbody td {
      padding: 7px 20px 7px 20px;
      border-right: 1px solid #e9ebf1;
      border-top: 1px solid #e9ebf1;
   }
    .table-caddy tbody td:last-child {
      border-right: 0;
   }
    .table-caddy tbody tr:last-child {
      border-bottom: 1px solid #e9ebf1;
   }
    .table-caddy .d-disabled {
      background: rgba(193, 193, 193, 0.12);
   }
    .status-color-A {
      color: #29b869;
   }
    .status-color-B {
      color: #00cfe8;
   }
    .status-color-W {
      color: #f8afaf;
   }
    .scroll-caddy {
      height: calc(100vh - 265px);
      overflow: auto;
   }
    .scroll-caddy::-webkit-scrollbar {
      width: 4px;
      border: 1px solid #d5d5d5;
   }
    .scroll-caddy::-webkit-scrollbar-track {
      border-radius: 0;
      background: #eee;
   }
    .scroll-caddy::-webkit-scrollbar-thumb {
      border-radius: 0;
      background: #b0b0b0;
   }
   .d-break-page{
      display: block !important;
      width: 100%;
      page-break-after: auto;
      page-break-inside: avoid;
      page-break-before: avoid;
   }`
}